import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
};

export type ActivateAdvertisinBoInput = {
  /** advertising id */
  advertisingId: Scalars['String'];
};

export type AddConnectFilesInput = {
  connectFileIds: Array<Scalars['String']>;
};

/** 유저 광고 활동 로그 */
export type AdsActivityLogInput = {
  /** ads impression id */
  adsImpressionId: Scalars['String'];
  /** 아이피 */
  ip: Scalars['String'];
  /** url */
  url: Scalars['String'];
  /** 이메일 */
  email?: InputMaybe<Scalars['String']>;
  /** 캐파 서비스 타입 */
  service?: InputMaybe<CapaServiceType>;
  /** 활동 타입 */
  activityType: CapaActivityType;
};

/** input for allow partner to download rfq files */
export type AllowRfqDrawingFileDownloadInput = {
  /** rfq id */
  rfqId: Scalars['String'];
  /** partner id */
  quotationPartnerId: Scalars['String'];
  /** status for file download */
  status?: InputMaybe<CapaQuotationRfqAllowOpenFileStatus>;
};

/** BO 엠버서더 사업자등록증 */
export type AmbassadorFileUploadInput = {
  /** fk 캐파 파일 아이디 */
  fileId: Scalars['String'];
  fileName: Scalars['String'];
};

export type AnnotationComment = {
  __typename?: 'AnnotationComment';
  id?: Maybe<Scalars['String']>;
  isParent?: Maybe<Scalars['Boolean']>;
  comment?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  status?: Maybe<CapaQuotationSharedFileAnnotationStatus>;
  createdAt?: Maybe<Scalars['String']>;
};

export type AnnotationCommentBo = {
  __typename?: 'AnnotationCommentBO';
  id?: Maybe<Scalars['String']>;
  isParent?: Maybe<Scalars['Boolean']>;
  comment?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  edited?: Maybe<Scalars['Boolean']>;
  status?: Maybe<CapaQuotationSharedFileAnnotationStatus>;
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

/** ITP event reward */
export type ApproveItpEventInput = {
  /** ITP event id */
  itpEventId: Scalars['String'];
};

/** 파트너 이메일로 승인 */
export type ApprovedQuotationPartnerByEmailInput = {
  /** 이메일 */
  email: Scalars['String'];
};

export type Authentication = {
  __typename?: 'Authentication';
  /** JWT */
  accessToken: Scalars['String'];
  tokenType: Scalars['String'];
  expiresIn: Scalars['Float'];
  /** JWT */
  refreshToken: Scalars['String'];
  redirectUrl?: Maybe<Scalars['String']>;
};

/** 캐파 로그인 */
export type AuthenticationInput = {
  /** 이메일 */
  email: Scalars['String'];
  /** 비밀번호 */
  password: Scalars['String'];
  /** 캐파 서비스 타입 */
  service: CapaServiceType;
  /** device token */
  deviceToken?: InputMaybe<Scalars['String']>;
  /** user language */
  userLanguage?: InputMaybe<Language>;
};

export type AuthenticationOutput = {
  __typename?: 'AuthenticationOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Authentication>;
};

export enum BackOfficeAccess {
  AccountManagement = 'ACCOUNT_MANAGEMENT',
  DashboardRead = 'DASHBOARD_READ',
  RfqRead = 'RFQ_READ',
  RfqStop = 'RFQ_STOP',
  RfqComment = 'RFQ_COMMENT',
  PartnerRead = 'PARTNER_READ',
  PartnerModify = 'PARTNER_MODIFY',
  PartnerAdd = 'PARTNER_ADD',
  PartnerRemove = 'PARTNER_REMOVE',
  PartnerApprove = 'PARTNER_APPROVE',
  PartnerComment = 'PARTNER_COMMENT',
  ServiceRatingRead = 'SERVICE_RATING_READ',
  PartnerRatingRead = 'PARTNER_RATING_READ',
  StampEventRead = 'STAMP_EVENT_READ',
  StampEventApprove = 'STAMP_EVENT_APPROVE',
  StampEventDownload = 'STAMP_EVENT_DOWNLOAD',
  StampEventComment = 'STAMP_EVENT_COMMENT',
  ClientRead = 'CLIENT_READ',
  ClientComment = 'CLIENT_COMMENT'
}

export enum BackOfficeAdminRole {
  Admin = 'ADMIN',
  Xaccount = 'XACCOUNT',
  Noedit = 'NOEDIT',
  Vietnam = 'VIETNAM'
}

export enum BackOfficeUserDeptType {
  Dev = 'DEV',
  Pd = 'PD',
  Crm = 'CRM',
  Rnd = 'RND'
}

export enum BackOfficeUserStatus {
  /** 가입 */
  Registered = 'REGISTERED',
  /** 탈퇴 */
  Withdraw = 'WITHDRAW'
}

export type BankBookFile = {
  __typename?: 'BankBookFile';
  fileId: Scalars['String'];
  fileName: Scalars['String'];
  fileExtension: Scalars['String'];
};

export type BatchShutDownQuotationPartnerChatRoomsInput = {
  serviceType: CapaQuotationServiceType;
};

export type Capa3DPos = {
  __typename?: 'CAPA3DPos';
  x: Scalars['Float'];
  y: Scalars['Float'];
  z: Scalars['Float'];
};

export type Capa3DPosInput = {
  x: Scalars['Float'];
  y: Scalars['Float'];
  z: Scalars['Float'];
};

/** 액티비티 타입 */
export enum CapaActivityType {
  PageVisit = 'PAGE_VISIT',
  ButtonClick = 'BUTTON_CLICK',
  LinkClick = 'LINK_CLICK',
  ActionInput = 'ACTION_INPUT'
}

/** 광고 노출 정보 */
export type CapaAdsActivityLog = {
  __typename?: 'CAPAAdsActivityLog';
  /** 광고 노출 정보 id */
  count: Scalars['Float'];
  /** 광고 타입 (상단 배너, 카드 등등) */
  service: CapaServiceType;
  /** 광고 타입 (상단 배너, 카드 등등) */
  activityType: CapaActivityType;
};

export type CapaAdsActivityLogsOutput = {
  __typename?: 'CAPAAdsActivityLogsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaAdsActivityLog>>;
};

/** 광고 노출 정보 */
export type CapaAdsImpressionBo = {
  __typename?: 'CAPAAdsImpressionBO';
  /** 광고 노출 정보 id */
  id: Scalars['ID'];
  /** 광고 정보 id */
  advertismentId: Scalars['ID'];
  /** 광고 이미지 id */
  fileId: Scalars['ID'];
  /** 광고 이미지 백그라운드 컬러 */
  backgroundColor?: Maybe<Scalars['String']>;
  /** 광고 타입 (상단 배너, 카드 등등) */
  type: CapaAdvertisementType;
  /** 광고 타이틀 */
  title: Scalars['String'];
  /** 광고 내용 */
  contents: Scalars['String'];
  /** 광고 링크 */
  linkUrl: Scalars['String'];
  /** 광고 종료일 */
  expiredAt?: Maybe<Scalars['String']>;
  /** create at */
  createdAt: Scalars['String'];
  /** update at */
  updatedAt: Scalars['String'];
};

export type CapaAdsImpressionsBoOutput = {
  __typename?: 'CAPAAdsImpressionsBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaAdsImpressionBo>>;
};

/** 광고 정보 */
export type CapaAdvertisementBo = {
  __typename?: 'CAPAAdvertisementBO';
  /** 광고 정보 id */
  id: Scalars['ID'];
  /** 회사명 */
  organizationName: Scalars['String'];
  /** 담당자명 */
  managerName: Scalars['String'];
  /** 전화번호 */
  contact: Scalars['String'];
  /** 이메일 */
  email: Scalars['String'];
  /** 현재 광고 상태 */
  status: CapaAdvertisementStatus;
  /** create at */
  createdAt: Scalars['String'];
  /** update at */
  updatedAt: Scalars['String'];
  /** 광고 노출 정보 */
  adsImpressions?: Maybe<Array<CapaAdsImpressionBo>>;
};

export enum CapaAdvertisementStatus {
  /** 등록 */
  Registered = 'REGISTERED',
  /** 승인 */
  Approved = 'APPROVED',
  /** 만료 */
  Expired = 'EXPIRED',
  /** 삭제 */
  Deleted = 'DELETED'
}

/** 광고 노출 타입 */
export enum CapaAdvertisementType {
  /** 상단 배너 */
  TopBanner = 'TOP_BANNER',
  /** 채팅방 카드 */
  ChatRoomCard = 'CHAT_ROOM_CARD'
}

export type CapaAdvertisementsBoOutput = {
  __typename?: 'CAPAAdvertisementsBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaAdvertisementBo>>;
};

export type CapaAdvertising = {
  __typename?: 'CAPAAdvertising';
  /** advertising id */
  id: Scalars['String'];
  /** ads Impression list */
  adsImpressions: Array<CapaAdvertisingAdsImpression>;
  /** 광고 타입 (배너, 카드) */
  type: CapaAdvertisementType;
  /** 호스팅할 서비스 타입 (배너, 카드) */
  serviceType: CapaServiceType;
};

export type CapaAdvertisingAdsImpression = {
  __typename?: 'CAPAAdvertisingAdsImpression';
  /** ads impression id */
  id: Scalars['String'];
  /** ads impression id */
  advertismentId: Scalars['String'];
  /** file id */
  fildId: Scalars['String'];
  /** backgroundColor */
  backgroundColor: Scalars['String'];
  /** title */
  title: Scalars['String'];
  /** contents */
  contents: Scalars['String'];
  /** linkUrl */
  linkUrl: Scalars['String'];
  /** expiredAt */
  expiredAt?: Maybe<Scalars['String']>;
};

export type CapaAdvertisingBo = {
  __typename?: 'CAPAAdvertisingBO';
  /** advertising id */
  id: Scalars['String'];
  /** ads Impression list */
  adsImpressionIds: Array<Scalars['String']>;
  /** 광고 타입 (배너, 카드) */
  type: CapaAdvertisementType;
  /** 호스팅할 서비스 타입 (배너, 카드) */
  serviceType: CapaServiceType;
};

export type CapaAdvertisingsBoOutput = {
  __typename?: 'CAPAAdvertisingsBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaAdvertisingBo>>;
};

export type CapaAdvertisingsOutput = {
  __typename?: 'CAPAAdvertisingsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaAdvertising>>;
};

/** 엠베서더 목록 */
export type CapaAmbassadorList = {
  __typename?: 'CAPAAmbassadorList';
  /** ambassador id */
  id?: Maybe<Scalars['ID']>;
  /** 협회명 */
  organizationName?: Maybe<Scalars['String']>;
};

export type CapaAvailableReview = {
  __typename?: 'CAPAAvailableReview';
  chatRoomId: Scalars['String'];
  quotationPartnerId: Scalars['String'];
  profileId?: Maybe<Scalars['String']>;
  /** 파트너 회사명 */
  organizationName?: Maybe<Scalars['String']>;
  isComplete: Scalars['Boolean'];
  /** 발주 발행일 */
  purchaseOrderCreatedAt?: Maybe<Scalars['String']>;
};

export enum CapaboBypassSearchUserType {
  Client = 'CLIENT',
  Partner = 'PARTNER'
}

/** 결제 취소 및 환불 정보 */
export type CapaboCancelPaymentList = {
  __typename?: 'CAPABOCancelPaymentList';
  /** 취소 및 환불 사유 */
  cancelReason?: Maybe<Scalars['String']>;
  /** 취소 및 환불 금액 */
  cancelAmount?: Maybe<Scalars['Float']>;
  /** 취소 및 환불 요청일 */
  cancelRequestedAt?: Maybe<Scalars['String']>;
  /** 취소 및 환불 승인일 */
  cancelConfirmedAt?: Maybe<Scalars['String']>;
  /** 취소 및 횐불 승인자 */
  cancelApprover?: Maybe<CapaServiceType>;
  /** 취소승인한 BO ID */
  approverbackOfficeId?: Maybe<Scalars['String']>;
  /** 취소승인한 BO 담당자 이름 */
  approverbackOfficeName?: Maybe<Scalars['String']>;
  /** 가상계좌 미입금 취소 여부 */
  isNotPaidCanceled?: Maybe<Scalars['Boolean']>;
};

/** BO 결제 정보 조회 */
export type CapaboFetchTransactionHistoryInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  keyword?: InputMaybe<Scalars['String']>;
  searchType?: InputMaybe<PaymentHistorySearchTypeBo>;
  searchDateType?: InputMaybe<PaymentHistorySearchDateTypeBo>;
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  /** 테스트 포함 여부 */
  includeTest?: InputMaybe<Scalars['Boolean']>;
  searchPaymentStatus?: InputMaybe<PaymentHistorySearchStatusTypeBo>;
  searchRfqServiceType?: InputMaybe<CapaQuotationNewServiceType>;
};

/** 파트너 가입 히스토리 */
export type CapaboPartnerHistoryModel = {
  __typename?: 'CAPABOPartnerHistoryModel';
  id: Scalars['String'];
  quotationPartnerId: Scalars['String'];
  /** 유저 id */
  resultType: CapaQuotationPartnerStatus;
  rejectReason?: Maybe<Scalars['String']>;
  rejectType?: Maybe<CapaQuotationPartnerRejectType>;
  manager?: Maybe<Scalars['String']>;
  managerBOId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  /** 파트너 인증 히스토리 타입 */
  historyType?: Maybe<CapaBackOfficeQuotationPartnerHistoryType>;
};

export type CapaboProcessingDetailItem = {
  __typename?: 'CAPABOProcessingDetailItem';
  /** 이벤트 생성일 */
  eventCreatedAt: Scalars['String'];
  /** CAPAPurchaseOrderStatus */
  status: CapaPurchaseOrderStatus;
};

export type CapaboProcessingItem = {
  __typename?: 'CAPABOProcessingItem';
  /** purchaseOrderId */
  purchaseOrderId: Scalars['String'];
  /** BO 제조시작 탭 전용 purchaseorder status */
  status?: Maybe<CapaboProcessingPurchaseOrderStatus>;
  /** 결제수단 */
  paymentMethod: CapaPaymentMethodType;
  /** 결제금액 */
  paidAmount: Scalars['Float'];
  purchaseOrderStatus: CapaPurchaseOrderStatus;
  /** 발주서 작성일 */
  purchaseOrderCreatedAt: Scalars['String'];
  /** 결제 취소 및 환불 정보 */
  capaBOCancelPaymentList?: Maybe<Array<CapaboCancelPaymentList>>;
  /** 배송방식 */
  shippingMethod?: Maybe<CapaShippingMethodType>;
  /** 기타 배송 방식 */
  etcShippingMethod?: Maybe<Scalars['String']>;
  /** 배송 정보 입력일 */
  shippingCreatedAt?: Maybe<Scalars['String']>;
  /** 자동 지급 승인일 */
  confirmPurchaseExpectedDate?: Maybe<Scalars['String']>;
  /** 자동 지급 승인 연장일 */
  delayedConfirmPurchaseExpectedDate?: Maybe<Scalars['String']>;
  /** 정산일 (실제 파트너에게 정산 = 지급일) */
  payoutedAt?: Maybe<Scalars['String']>;
  /** 정산금액 (실제 파트너에게 정산 = 지급 대행 요청 금액 */
  payoutedAmount?: Maybe<Scalars['Float']>;
  /** 결제 실패시 결제 시도 금액 */
  paymentFailedAmount?: Maybe<Scalars['Float']>;
  /** 결제 성공 시간 */
  paidAt?: Maybe<Scalars['String']>;
  /** 발주/결제 상태 변경 시점 정보 , 승인자 정보 */
  processingDetailItems: Array<CapaboProcessingDetailItem>;
};

export type CapaboProcessingOutput = {
  __typename?: 'CAPABOProcessingOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaboProcessingProjects>;
};

/** BO 제조 시작 목록 */
export type CapaboProcessingProject = {
  __typename?: 'CAPABOProcessingProject';
  /** rfqId */
  rfqId: Scalars['String'];
  /** quotationId */
  quotationId: Scalars['String'];
  /** chatRoomId */
  chatRoomId: Scalars['String'];
  /** partnerId */
  partnerId: Scalars['String'];
  /** 주문 요청일 */
  rfqCreatedAt: Scalars['String'];
  /** 견적서들의 작성일 */
  quotationCreatedDates: Array<Scalars['String']>;
  /** 프로젝트명 */
  projectName: Scalars['String'];
  /** capa service type */
  serviceType?: Maybe<CapaQuotationServiceType>;
  /** 고객명 */
  clientName: Scalars['String'];
  /** 고객 전화 */
  clientContact: Scalars['String'];
  /** 파트너명 */
  partnerName: Scalars['String'];
  /** 파트너 전화 */
  partnerContact: Scalars['String'];
  processingList?: Maybe<Array<CapaboProcessingItem>>;
  /** transactionId */
  paymentTransactionId: Scalars['String'];
  /** 테스트 RFQ */
  isTest?: Maybe<Scalars['Boolean']>;
};

/** BO 제조 시작 목록 및 프로젝트 수 */
export type CapaboProcessingProjects = {
  __typename?: 'CAPABOProcessingProjects';
  data?: Maybe<Array<CapaboProcessingProject>>;
  totalCount?: Maybe<Scalars['Float']>;
  cancelRequestedCount?: Maybe<Scalars['Float']>;
};

/** bo 제조목록탭 전용 purchaseorder status */
export enum CapaboProcessingPurchaseOrderStatus {
  /** 발주/결제중 */
  ReadyOrPaid = 'READY_OR_PAID',
  /** 결제취소요청 */
  CancelRequested = 'CANCEL_REQUESTED',
  /** 결제취소완료 */
  CancelConfirmed = 'CANCEL_CONFIRMED',
  /** 제조중 */
  Processing = 'PROCESSING',
  /** 환불요청 */
  RefundRequested = 'REFUND_REQUESTED',
  /** 환불완료 */
  RefundConfirmed = 'REFUND_CONFIRMED',
  /** 배송중 */
  Shipping = 'SHIPPING',
  /** 배송중(연장) */
  ShippingExtended = 'SHIPPING_EXTENDED',
  /** 제조완료 */
  PurchaseConfirmed = 'PURCHASE_CONFIRMED',
  /** 결제실패 */
  Failed = 'FAILED'
}

export type CapaBackOffice = {
  __typename?: 'CAPABackOffice';
  /** capa backoffice user id */
  id: Scalars['ID'];
  email: Scalars['String'];
  role: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  nickName?: Maybe<Scalars['String']>;
  dept: Scalars['String'];
  task?: Maybe<Scalars['String']>;
  accessList?: Maybe<Array<BackOfficeAccess>>;
  status?: Maybe<BackOfficeUserStatus>;
};

/** BackOffice 커넥트 그룹 필터타입 */
export enum CapaBackOfficeConnectGroupsFilterType {
  /** 전체 */
  Default = 'DEFAULT',
  /** 실사용 그룹 */
  Activate = 'ACTIVATE',
  /** 테스트 그룹 */
  Test = 'TEST'
}

/** BO 제조 시작 목록 요청 타입 */
export enum CapaBackOfficeFetchProcessingReqType {
  /** 전체 목록 출력 */
  Default = 'DEFAULT',
  /** 필터 탭 (취소 및 환불 요청 관리, ...) */
  Filter = 'FILTER'
}

/** 파트너 목록 필터 */
export enum CapaBackOfficeQuotationPartnerFilterType {
  /** 가입 승인 대기 */
  JoinRegister = 'JOIN_REGISTER',
  /** 가입 승인 거절 */
  JoinRejected = 'JOIN_REJECTED',
  /** 가입 승인 완료 */
  JoinApproved = 'JOIN_APPROVED',
  /** 계좌 승인 대기 */
  AccountRegister = 'ACCOUNT_REGISTER',
  /** 계좌 승인 거절 */
  AccountRejected = 'ACCOUNT_REJECTED',
  /** 가입/계좌 승인 완료 */
  JoinAndAccountApproved = 'JOIN_AND_ACCOUNT_APPROVED',
  /** 탈퇴 */
  Deleted = 'DELETED'
}

export enum CapaBackOfficeQuotationPartnerHistoryType {
  /** 가입 */
  Join = 'JOIN',
  /** 계좌 */
  Submall = 'SUBMALL'
}

export type CapaBackOfficeRole = {
  __typename?: 'CAPABackOfficeRole';
  role: Scalars['String'];
  accessList?: Maybe<Array<BackOfficeAccess>>;
};

/** 관리자 권한 발주서 상태 변경 요청 타입 */
export enum CapaBackOfficeUpdatePurchaseOrderStatusReqType {
  /** 취소 및 환불 승인 */
  Confirm = 'CONFIRM',
  /** 계속 진행 통보 */
  Progress = 'PROGRESS'
}

export type CapaBackOfficeUserOutput = {
  __typename?: 'CAPABackOfficeUserOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaBackOffice>;
};

/** BackOffice 유저 필터타입 */
export enum CapaBackOfficeUsersFilterType {
  /** 전체 */
  Default = 'DEFAULT',
  /** 실사용자 계정 */
  Activate = 'ACTIVATE',
  /** 테스트 계정 */
  Test = 'TEST'
}

export type CapaBackOfficeUsersOutput = {
  __typename?: 'CAPABackOfficeUsersOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaBackOffice>>;
};

/** 은행 코드 */
export enum CapaBankCode {
  /** KB국민은행 */
  KbBank = 'KB_BANK',
  /** SC제일은행 */
  ScBank = 'SC_BANK',
  /** 경남은행 */
  KyongnamBank = 'KYONGNAM_BANK',
  /** 광주은행 */
  KwangjuBank = 'KWANGJU_BANK',
  /** 기업은행 */
  Ibk = 'IBK',
  /** 농협 */
  NhBank = 'NH_BANK',
  /** 대구은행 */
  DaeguBank = 'DAEGU_BANK',
  /** 부산은행 */
  BusanBank = 'BUSAN_BANK',
  /** 산업은행 */
  Kdb = 'KDB',
  /** 새마을금고 */
  Kfcc = 'KFCC',
  /** 수협 */
  ShBank = 'SH_BANK',
  /** 신한은행 */
  ShinhanBank = 'SHINHAN_BANK',
  /** 신협 */
  CreditUnionBank = 'CREDIT_UNION_BANK',
  /** 외환은행 */
  Keb = 'KEB',
  /** 우리은행 */
  WooriBank = 'WOORI_BANK',
  /** 우체국 */
  PostBank = 'POST_BANK',
  /** 전북 */
  JeonbukBank = 'JEONBUK_BANK',
  /** 카카오뱅크 */
  KakaoBank = 'KAKAO_BANK',
  /** 케이뱅크 */
  KBank = 'K_BANK',
  /** 토스뱅크 */
  TossBank = 'TOSS_BANK',
  /** 하나은행_서울은행 */
  HanaSeoulBank = 'HANA_SEOUL_BANK',
  /** 한국씨티은행_한미은행 */
  CityHanmiBank = 'CITY_HANMI_BANK'
}

/** 엠베서더 */
export type CapaBoAmbassador = {
  __typename?: 'CAPABoAmbassador';
  /** ambassador id */
  id?: Maybe<Scalars['ID']>;
  /** 엠베서더 회사명 */
  organizationName?: Maybe<Scalars['String']>;
  /** 담당자명 */
  managerName?: Maybe<Scalars['String']>;
  /** 담당자 이메일 */
  email?: Maybe<Scalars['String']>;
  /** 담당자 휴대폰 번호 */
  cellphoneNumber?: Maybe<Scalars['String']>;
  /** 사업자 등록 번호 */
  companyRegistrationNumber?: Maybe<Scalars['String']>;
  /** 엠베서더 등록일 */
  createdAt?: Maybe<Scalars['String']>;
  /** 전체 초대 수 */
  cntTotal?: Maybe<Scalars['Float']>;
  /** 초대 고객 수 */
  cntClient?: Maybe<Scalars['Float']>;
  /** 초대 파트너 수 */
  cntPartner?: Maybe<Scalars['Float']>;
  /** 최근 초대일 */
  lastInvitedAt?: Maybe<Scalars['String']>;
};

export type CapaBoAmbassadorApprovedPartnerUser = {
  __typename?: 'CAPABoAmbassadorApprovedPartnerUser';
  /** quotation partner id */
  quotationPartnerId?: Maybe<Scalars['ID']>;
  /** 파트너명 */
  organizationName?: Maybe<Scalars['String']>;
  /** 담당자명 */
  managerName?: Maybe<Scalars['String']>;
  /** 휴대폰 번호 */
  cellphoneNumber?: Maybe<Scalars['String']>;
  /** 가입일 */
  createdAt?: Maybe<Scalars['String']>;
  /** 승인일 */
  approvedAt?: Maybe<Scalars['String']>;
  /** 제안수 */
  suggestionCnt?: Maybe<Scalars['Float']>;
  /** 채팅수 */
  chatCnt?: Maybe<Scalars['Float']>;
  /** 수주수 */
  purchaseOrderCnt?: Maybe<Scalars['Float']>;
  /** 유입경로 */
  route?: Maybe<Array<CapaInflowRoute>>;
  /** status */
  status: CapaQuotationPartnerStatus;
  /** status */
  referralCompany: Scalars['String'];
};

export type CapaBoAmbassadorApprovedPartnerUsers = {
  __typename?: 'CAPABoAmbassadorApprovedPartnerUsers';
  /** 초대 파트너 수 */
  cntApprovedPartner?: Maybe<Scalars['Float']>;
  /** 초대 파트너 */
  approvedPartnerUsers?: Maybe<Array<CapaBoAmbassadorApprovedPartnerUser>>;
};

export type CapaBoAmbassadorClientUser = {
  __typename?: 'CAPABoAmbassadorClientUser';
  /** quotation user id */
  quotationUserId?: Maybe<Scalars['ID']>;
  /** 고객명 */
  organizationName?: Maybe<Scalars['String']>;
  /** 담당자명 */
  managerName?: Maybe<Scalars['String']>;
  /** 휴대폰 번호 */
  cellphoneNumber?: Maybe<Scalars['String']>;
  /** 가입일 */
  createdAt?: Maybe<Scalars['String']>;
  /** 견적요청수 */
  rfqCnt?: Maybe<Scalars['Float']>;
  /** 발주수 */
  purchaseOrderCnt?: Maybe<Scalars['Float']>;
  /** 채팅수 */
  chatCnt?: Maybe<Scalars['Float']>;
  /** 유입경로 */
  route?: Maybe<Array<CapaInflowRoute>>;
  /** status */
  status: CapaQuotationUserStatus;
  /** status */
  referralCompany: Scalars['String'];
};

export type CapaBoAmbassadorClientUsers = {
  __typename?: 'CAPABoAmbassadorClientUsers';
  /** 초대 고객 수 */
  cntClient?: Maybe<Scalars['Float']>;
  /** 초대 고객 */
  clientUsers?: Maybe<Array<CapaBoAmbassadorClientUser>>;
};

export type CapaBoAmbassadorIncompleteUser = {
  __typename?: 'CAPABoAmbassadorIncompleteUser';
  /** user id */
  userId: Scalars['ID'];
  /** 담당자명 */
  email: Scalars['String'];
  /** 가입일 */
  createdAt: Scalars['String'];
  /** status */
  status: CapaUserStatus;
  /** 유입경로 */
  route: Array<CapaInflowRoute>;
};

export type CapaBoAmbassadorIncompleteUsers = {
  __typename?: 'CAPABoAmbassadorIncompleteUsers';
  /** 필수 정보 미입력 고객 수 */
  cntIncompleteUser?: Maybe<Scalars['Float']>;
  /** 필수 정보 미입력 고객 */
  incompleteUsers?: Maybe<Array<CapaBoAmbassadorIncompleteUser>>;
};

/** 엠베서더 초대 현황 */
export type CapaBoAmbassadorInvitationStatus = {
  __typename?: 'CAPABoAmbassadorInvitationStatus';
  /** ambassador id */
  ambassadorId?: Maybe<Scalars['ID']>;
  /** 회사명 */
  organizationName?: Maybe<Scalars['String']>;
  /** 담당자명 */
  managerName?: Maybe<Scalars['String']>;
  /** 담당자 이메일 */
  email?: Maybe<Scalars['String']>;
  /** 담당자 휴대폰 번호 */
  cellphoneNumber?: Maybe<Scalars['String']>;
  /** 사업자 등록 번호 */
  companyRegistrationNumber?: Maybe<Scalars['String']>;
  /** 사업자등록증 */
  registration?: Maybe<CapaBoAmbassadorRegistration>;
  /** 엠베서더 등록일 */
  createdAt?: Maybe<Scalars['String']>;
  /** 최근 초대일 */
  lastInvitedAt?: Maybe<Scalars['String']>;
  /** 초대 고객 수 */
  invitedClientCount?: Maybe<Scalars['Float']>;
  /** 초대 파트너 수 */
  invitedPartnerCount?: Maybe<Scalars['Float']>;
  /** 전체 초대 수 */
  invitedTotalCount?: Maybe<Scalars['Float']>;
  /** 고객 누적 방문 수 */
  clientViewCount?: Maybe<Scalars['Float']>;
  /** 파트너 누적 방문 수 */
  partnerViewCount?: Maybe<Scalars['Float']>;
  /** 초대 고객 수 및 목록 */
  clientUsersAndCount?: Maybe<CapaBoAmbassadorClientUsers>;
  /** 승인 파트너 수 및 목록 */
  approvedPartnerUsersAndCount?: Maybe<CapaBoAmbassadorApprovedPartnerUsers>;
  /** 승인 대기 파트너 수 및 목록 */
  notApprovedPartnerUsersAndCount?: Maybe<
    CapaBoAmbassadorNotApprovedPartnerUsers
  >;
  /** 고객 필수정보 미입력 상태 고객 수 및 목록 */
  incompleteUsersAndCount?: Maybe<CapaBoAmbassadorIncompleteUsers>;
};

export type CapaBoAmbassadorInvitationStatusOutput = {
  __typename?: 'CAPABoAmbassadorInvitationStatusOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaBoAmbassadorInvitationStatus>;
};

export type CapaBoAmbassadorNotApprovedPartnerUser = {
  __typename?: 'CAPABoAmbassadorNotApprovedPartnerUser';
  /** quotation partner id */
  quotationPartnerId?: Maybe<Scalars['ID']>;
  /** 파트너명 */
  organizationName?: Maybe<Scalars['String']>;
  /** 담당자명 */
  managerName?: Maybe<Scalars['String']>;
  /** 휴대폰 번호 */
  cellphoneNumber?: Maybe<Scalars['String']>;
  /** 가입일 */
  createdAt?: Maybe<Scalars['String']>;
  /** status */
  status: CapaQuotationPartnerStatus;
  /** 유입경로 */
  route?: Maybe<Array<CapaInflowRoute>>;
};

export type CapaBoAmbassadorNotApprovedPartnerUsers = {
  __typename?: 'CAPABoAmbassadorNotApprovedPartnerUsers';
  /** 승인 대기 파트너 수 */
  cntNotApprovedPartner?: Maybe<Scalars['Float']>;
  /** 승인 대기 파트너 */
  notApprovedPartnerUsers?: Maybe<
    Array<CapaBoAmbassadorNotApprovedPartnerUser>
  >;
};

export type CapaBoAmbassadorRegistration = {
  __typename?: 'CAPABoAmbassadorRegistration';
  /** 사업자등록증 file id */
  fileId?: Maybe<Scalars['String']>;
  /** 사업자등록증 file name */
  fileName?: Maybe<Scalars['String']>;
};

export type CapaBoAmbassadorsOutput = {
  __typename?: 'CAPABoAmbassadorsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaBoAmbassador>>;
};

/** 코멘트 */
export type CapaBoComment = {
  __typename?: 'CAPABoComment';
  /** bo user name */
  name?: Maybe<Scalars['String']>;
  /** bo user nickName */
  nickName?: Maybe<Scalars['String']>;
  /** comment */
  comment?: Maybe<Scalars['String']>;
  /** 코멘트 생성일 */
  createdAt?: Maybe<Scalars['String']>;
};

export type CapaBoCommentQuotationUsers = {
  __typename?: 'CAPABoCommentQuotationUsers';
  /** quotation user id */
  quotationUserId?: Maybe<Scalars['ID']>;
  /** 유저별 comments */
  comments?: Maybe<Array<CapaBoComment>>;
};

export type CapaBoCommentsOutput = {
  __typename?: 'CAPABoCommentsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaBoCommentQuotationUsers>;
};

/** 캐파 BO 메모 정보 */
export type CapaBoMemo = {
  __typename?: 'CAPABoMemo';
  id: Scalars['ID'];
  back_office_id: Scalars['ID'];
  /** 유저 id */
  user_id: Scalars['ID'];
  /** name */
  name: Scalars['String'];
  /** nick_name */
  nick_name: Scalars['String'];
  /** memo */
  memo: Scalars['String'];
  /** role */
  role: Scalars['String'];
  /** 메모 생성일 */
  created_at: Scalars['String'];
};

export type CapaBoMemosOutput = {
  __typename?: 'CAPABoMemosOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaBoMemo>>;
};

export type CapaBypassComplaintInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  /** 유저 타입 */
  complaintUserType: Array<CapaboBypassSearchUserType>;
  /** 불편사항 타입 */
  complaintType: Array<CapaBypassComplaintType>;
};

export enum CapaBypassComplaintType {
  /** 통화필요 */
  RequiredCallNumber = 'REQUIRED_CALL_NUMBER',
  /** 캐파 채팅 불편사항 */
  ChatComplaint = 'CHAT_COMPLAINT',
  /** 연락처 교환 x */
  NotExchangeCallNumber = 'NOT_EXCHANGE_CALL_NUMBER',
  /** 어떤 설정도 하지 않음. */
  NoAction = 'NO_ACTION'
}

export type CapacxManagementRequiredRfq = {
  __typename?: 'CAPACXManagementRequiredRfq';
  /** rfq id */
  rfqId?: Maybe<Scalars['String']>;
  /** 견적요청일 */
  createdAt?: Maybe<Scalars['String']>;
  /** 서비스타입 */
  serviceType?: Maybe<CapaQuotationServiceType>;
  /** 프로젝트명 */
  projectName?: Maybe<Scalars['String']>;
  /** 총 수량 */
  totalQuantity?: Maybe<Scalars['Float']>;
  /** RFQ 상태 */
  status?: Maybe<CapaRfqStatus>;
  /** 조회수 */
  viewCount?: Maybe<Scalars['Float']>;
  /** 조회파트너수 */
  viewPartnerCount?: Maybe<Scalars['Float']>;
};

export type CapacxManagementRequiredUserBo = {
  __typename?: 'CAPACXManagementRequiredUserBO';
  quotationUserId: Scalars['String'];
  /** 고객명 */
  managerName?: Maybe<Scalars['String']>;
  /** 회사명 */
  organizationName?: Maybe<Scalars['String']>;
  /** 고객유형 */
  bizType?: Maybe<CapaQuotationUserBizType>;
  /** 이메일 */
  email?: Maybe<Scalars['String']>;
  /** 휴대전화 */
  cellphoneNumber?: Maybe<Scalars['String']>;
  /** CX 관리 대상 rfq 목록 */
  requiredManagementRfqs?: Maybe<Array<CapacxManagementRequiredRfq>>;
  /** 코멘트 수 */
  commentCount?: Maybe<Scalars['Float']>;
};

export type CapacxManagementRequiredUsersBo = {
  __typename?: 'CAPACXManagementRequiredUsersBO';
  requiredManagementUsers?: Maybe<Array<CapacxManagementRequiredUserBo>>;
  count?: Maybe<Scalars['Float']>;
  unReadCount?: Maybe<Scalars['Float']>;
};

export type CapacxManagementRequiredUsersBoOutput = {
  __typename?: 'CAPACXManagementRequiredUsersBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapacxManagementRequiredUsersBo>;
};

export type CapaCanEditRefundAccountOutput = {
  __typename?: 'CAPACanEditRefundAccountOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CanEditRefundAccountModel>;
};

/** 캐파 견적 서비스 타입 */
export enum CapaCapabilitiesStatusType {
  /** 활성 */
  Active = 'ACTIVE',
  /** 비활성 */
  Inactive = 'INACTIVE',
  /** 보류중 */
  Pending = 'PENDING'
}

/** 챗 첨부 파일 */
export type CapaChatFile = {
  __typename?: 'CAPAChatFile';
  fileId?: Maybe<Scalars['ID']>;
  /** 파일 이름 */
  fileName?: Maybe<Scalars['String']>;
};

export type CapaChatMessageRead = {
  __typename?: 'CAPAChatMessageRead';
  lastChatMessageId?: Maybe<Scalars['ID']>;
};

export type CapaChatMessagesReadOutput = {
  __typename?: 'CAPAChatMessagesReadOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaChatMessageRead>;
};

export type CapaChatRoom = {
  __typename?: 'CAPAChatRoom';
  id: Scalars['ID'];
};

export type CapaChatRoomUser = {
  __typename?: 'CAPAChatRoomUser';
  id: Scalars['ID'];
  /** 유저 타입 */
  userType: CapaChatRoomUserType;
};

export enum CapaChatRoomUserType {
  /** 주인 */
  Owner = 'OWNER',
  /** 멤버 */
  Member = 'MEMBER',
  /** 손님 */
  Guest = 'GUEST'
}

/** 캐파 클러우드 유저 정보 */
export type CapaCloudUser = {
  __typename?: 'CAPACloudUser';
  /** capa cloud user id */
  id: Scalars['ID'];
  /** capa user email */
  email: Scalars['String'];
  /** 사용중인 드라이브 용량 (단위: byte) */
  usedSize: Scalars['Float'];
  /** 사용가능한 드라이브 용량 (단위: byte) */
  availSize: Scalars['Float'];
  /** 전체 드라이브 용량 (단위: byte) */
  driveSize: Scalars['Float'];
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgreed?: Maybe<Scalars['Boolean']>;
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgreed?: Maybe<Scalars['Boolean']>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgreed?: Maybe<Scalars['Boolean']>;
};

/** 캐파 BO 클러우드 유저 정보 */
export type CapaCloudUserBo = {
  __typename?: 'CAPACloudUserBO';
  /** capa user email */
  email: Scalars['String'];
  /** 사용중인 드라이브 용량 (단위: byte) */
  usedSize: Scalars['Float'];
  /** 전체 드라이브 용량 (단위: byte) */
  driveSize: Scalars['Float'];
  /** 클라우드 유저 생성일 */
  createdAt: Scalars['String'];
};

export type CapaCloudUserOutput = {
  __typename?: 'CAPACloudUserOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaCloudUser>;
};

export type CapaCloudUsersBoOutput = {
  __typename?: 'CAPACloudUsersBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaCloudUserBo>>;
};

export type CapaComplaintQuotationChatMessageModel = {
  __typename?: 'CAPAComplaintQuotationChatMessageModel';
  receiveComplaintQuotationChatMessageModels: Array<
    CapaReceiveComplaintQuotationChatMessageModel
  >;
  totalCnt?: Maybe<Scalars['Float']>;
};

export type CapaComplaintRfqInfoModel = {
  __typename?: 'CAPAComplaintRfqInfoModel';
  rfqId: Scalars['String'];
  projectName?: Maybe<Scalars['String']>;
};

export type CapaComplaintUserInfoModel = {
  __typename?: 'CAPAComplaintUserInfoModel';
  userId: Scalars['String'];
  /** 유저 타입 */
  complaintUserType?: Maybe<CapaboBypassSearchUserType>;
  userName?: Maybe<Scalars['String']>;
};

export type CapaConnectAnnotation = {
  __typename?: 'CAPAConnectAnnotation';
  id?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  chatRoomId?: Maybe<Scalars['String']>;
  groupUserId?: Maybe<Scalars['String']>;
  connectFileId?: Maybe<Scalars['String']>;
  connectFileName?: Maybe<Scalars['String']>;
  drawingFile?: Maybe<Scalars['String']>;
  anchorPos?: Maybe<Capa3DPos>;
  handlePos?: Maybe<Capa3DPos>;
  nodeId?: Maybe<Scalars['Float']>;
  comments?: Maybe<Array<CapaConnectAnnotationComment>>;
  hasNew?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type CapaConnectAnnotationBo = {
  __typename?: 'CAPAConnectAnnotationBO';
  id?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  chatRoomId?: Maybe<Scalars['String']>;
  groupUserId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  connectFileId?: Maybe<Scalars['String']>;
  connectFileName?: Maybe<Scalars['String']>;
  drawingFile?: Maybe<Scalars['String']>;
  anchorPos?: Maybe<Capa3DPos>;
  handlePos?: Maybe<Capa3DPos>;
  nodeId?: Maybe<Scalars['Float']>;
  comments?: Maybe<Array<CapaConnectAnnotationCommentBo>>;
  hasNew?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type CapaConnectAnnotationComment = {
  __typename?: 'CAPAConnectAnnotationComment';
  id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  edited?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type CapaConnectAnnotationCommentBo = {
  __typename?: 'CAPAConnectAnnotationCommentBO';
  id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  edited?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type CapaConnectAnnotationOutput = {
  __typename?: 'CAPAConnectAnnotationOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaConnectAnnotation>;
};

export type CapaConnectAnnotationsOutput = {
  __typename?: 'CAPAConnectAnnotationsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaConnectAnnotation>>;
};

export type CapaConnectChatFile = {
  __typename?: 'CAPAConnectChatFile';
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  /** 파일크기 byte */
  fileSize?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  linkStatus?: Maybe<ConnectUserFileLinkStatus>;
  filePermission?: Maybe<ConnectUserFileStatus>;
  thumbnailUri?: Maybe<Scalars['String']>;
  /** original ext */
  originalFileExt?: Maybe<Scalars['String']>;
  permission?: Maybe<CapaQuotationRfqAllowOpenFileStatus>;
};

export type CapaConnectChatMessage = {
  __typename?: 'CAPAConnectChatMessage';
  id?: Maybe<Scalars['ID']>;
  chatRoomId?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  senderId?: Maybe<Scalars['String']>;
  senderName?: Maybe<Scalars['String']>;
  fileOwnerName?: Maybe<Scalars['String']>;
  fileOwnerEmail?: Maybe<Scalars['String']>;
  senderEmail?: Maybe<Scalars['String']>;
  message?: Maybe<CapaConnectChatMessageUnion>;
  /** 안읽은수 */
  unReadCount?: Maybe<Scalars['Float']>;
  chatFiles?: Maybe<Array<CapaConnectChatFile>>;
  /** 생성일 */
  createdAt?: Maybe<Scalars['String']>;
};

export type CapaConnectChatMessageAnnotation = {
  __typename?: 'CAPAConnectChatMessageAnnotation';
  messageType: CapaConnectChatMessageType;
  annotationId?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type CapaConnectChatMessageFileShared = {
  __typename?: 'CAPAConnectChatMessageFileShared';
  messageType: CapaConnectChatMessageType;
  userName?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
};

export type CapaConnectChatMessageInvited = {
  __typename?: 'CAPAConnectChatMessageInvited';
  messageType: CapaConnectChatMessageType;
  userName?: Maybe<Scalars['String']>;
};

export type CapaConnectChatMessageLeave = {
  __typename?: 'CAPAConnectChatMessageLeave';
  messageType: CapaConnectChatMessageType;
  userName?: Maybe<Scalars['String']>;
};

export type CapaConnectChatMessageMessage = {
  __typename?: 'CAPAConnectChatMessageMessage';
  messageType: CapaConnectChatMessageType;
  message?: Maybe<Scalars['String']>;
  fileCount?: Maybe<Scalars['Float']>;
};

export type CapaConnectChatMessageRemoved = {
  __typename?: 'CAPAConnectChatMessageRemoved';
  messageType: CapaConnectChatMessageType;
  userName?: Maybe<Scalars['String']>;
};

export enum CapaConnectChatMessageType {
  System = 'SYSTEM',
  Message = 'MESSAGE',
  Annotation = 'ANNOTATION',
  Invite = 'INVITE',
  Leave = 'LEAVE',
  RemoveFromGroup = 'REMOVE_FROM_GROUP',
  FileShared = 'FILE_SHARED',
  Tutorial = 'TUTORIAL'
}

export type CapaConnectChatMessageUnion =
  | CapaConnectChatMessageMessage
  | CapaConnectChatMessageInvited
  | CapaConnectChatMessageRemoved
  | CapaConnectChatMessageFileShared
  | CapaConnectChatMessageLeave
  | CapaConnectChatMessageAnnotation
  | CapaConnectChatTutorialMessage;

export type CapaConnectChatMessagesOutput = {
  __typename?: 'CAPAConnectChatMessagesOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaConnectChatMessage>>;
};

export type CapaConnectChatRoom = {
  __typename?: 'CAPAConnectChatRoom';
  chatRoomId?: Maybe<Scalars['String']>;
  chatRoomStatus?: Maybe<CapaConnectChatRoomStatus>;
  chatMessages?: Maybe<Array<CapaConnectChatMessage>>;
  /** 생성일 */
  createdAt?: Maybe<Scalars['String']>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
};

/** 챗룸 상태 */
export enum CapaConnectChatRoomStatus {
  Opened = 'OPENED',
  Closed = 'CLOSED'
}

export type CapaConnectChatTutorialMessage = {
  __typename?: 'CAPAConnectChatTutorialMessage';
  messageType: CapaConnectChatMessageType;
  message?: Maybe<Scalars['String']>;
  uiType?: Maybe<Scalars['String']>;
  fileCount?: Maybe<Scalars['Float']>;
};

/** 캐파 커넥트 유저 정보 */
export type CapaConnectContactUser = {
  __typename?: 'CAPAConnectContactUser';
  /** capa cloud user id */
  id: Scalars['ID'];
  /** capa user email */
  email: Scalars['String'];
  /** nick name */
  nickName?: Maybe<Scalars['String']>;
  /** memo */
  memo?: Maybe<Scalars['String']>;
  /** isCapaUser */
  isCapaUser?: Maybe<Scalars['Boolean']>;
};

export type CapaConnectContactUsersOutput = {
  __typename?: 'CAPAConnectContactUsersOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaConnectContactUser>>;
};

export type CapaConnectFeedback = {
  __typename?: 'CAPAConnectFeedback';
  /** 피드백 ID */
  id?: Maybe<Scalars['ID']>;
  connectUserId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  /** 피드백 관련 파일 */
  files?: Maybe<Array<CapaFile>>;
  rating?: Maybe<Scalars['Float']>;
  feedback?: Maybe<Scalars['String']>;
  /** 생성일 */
  createdAt?: Maybe<Scalars['String']>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
  /** 테스트 유무 */
  isTest: Scalars['Boolean'];
};

export type CapaConnectFeedbacksBoOutput = {
  __typename?: 'CAPAConnectFeedbacksBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaConnectFeedback>>;
};

export type CapaConnectFileDetail = {
  __typename?: 'CAPAConnectFileDetail';
  /** 커넥트파일아이디 */
  id: Scalars['String'];
  /** 파일네임 */
  fileName: Scalars['String'];
  /** 파일패스 */
  filePath: Scalars['String'];
  /** thumbnail */
  thumbnail?: Maybe<Scalars['String']>;
  /** isFile */
  isFile?: Maybe<Scalars['Boolean']>;
  linkStatus?: Maybe<ConnectUserFileLinkStatus>;
  filePermission?: Maybe<ConnectUserFileStatus>;
  /** original ext */
  originalFileExt?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<CapaConnectGroup>>;
};

export type CapaConnectFileDetailOutput = {
  __typename?: 'CAPAConnectFileDetailOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaConnectFileDetail>;
};

export type CapaConnectFilePermission = {
  __typename?: 'CAPAConnectFilePermission';
  fileId: Scalars['String'];
  fileName: Scalars['String'];
  email: Scalars['String'];
  connectUserId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  isCapaUser?: Maybe<Scalars['Boolean']>;
  accessLevel?: Maybe<Scalars['String']>;
  groupUserId?: Maybe<Scalars['String']>;
  permission?: Maybe<CapaQuotationRfqAllowOpenFileStatus>;
};

export type CapaConnectFilePermissionOutput = {
  __typename?: 'CAPAConnectFilePermissionOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaConnectFilePermission>>;
};

/** 내드리이브 */
export type CapaConnectFolder = {
  __typename?: 'CAPAConnectFolder';
  /** 커넥트 파일 ID */
  id?: Maybe<Scalars['ID']>;
  /** 파일명 */
  folderName: Scalars['String'];
};

export type CapaConnectGroup = {
  __typename?: 'CAPAConnectGroup';
  /** 그룹 ID */
  id?: Maybe<Scalars['ID']>;
  /** 파일명 */
  groupName?: Maybe<Scalars['String']>;
  /** 파일명 */
  chatRoomId?: Maybe<Scalars['String']>;
  /** 커넥트유저네임 */
  accessLevel: CapaConnectGroupAccessLevel;
  /** 그룹멤버 */
  users?: Maybe<Array<CapaConnectGroupUser>>;
  /** 그룹공유파일들 */
  files?: Maybe<Array<CapaConnectSharedFile>>;
  message?: Maybe<CapaQuotationChatMessageUnion>;
  unReadCount?: Maybe<Scalars['Float']>;
  /** 생성일 (업로드 일시) */
  createdAt?: Maybe<Scalars['String']>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
};

export enum CapaConnectGroupAccessLevel {
  Owner = 'OWNER',
  Manager = 'MANAGER',
  Member = 'MEMBER'
}

export type CapaConnectGroupBo = {
  __typename?: 'CAPAConnectGroupBO';
  /** 그룹 ID */
  id?: Maybe<Scalars['ID']>;
  /** 파일명 */
  groupName?: Maybe<Scalars['String']>;
  chatRoomId?: Maybe<Scalars['String']>;
  /** 그룹멤버 */
  users?: Maybe<Array<CapaConnectGroupUserBo>>;
  /** 가입 구성원 수 */
  registeredUsers?: Maybe<Scalars['Float']>;
  /** 그룹공유파일들 */
  files?: Maybe<Array<CapaConnectGroupFileBo>>;
  /** 채팅 개수 */
  totalChats?: Maybe<Scalars['Float']>;
  /** 마지막 채팅시간 */
  lastMessageAt?: Maybe<Scalars['String']>;
  /** 그룹 상태 */
  status?: Maybe<CapaConnectGroupStatus>;
  /** 그룹 주석 */
  annotations?: Maybe<Array<CapaConnectAnnotationBo>>;
  /** 생성일 (업로드 일시) */
  createdAt?: Maybe<Scalars['String']>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
  /** 테스트 그룹 유무 */
  isTest: Scalars['Boolean'];
};

export type CapaConnectGroupBoOutput = {
  __typename?: 'CAPAConnectGroupBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaConnectGroupBo>;
};

export type CapaConnectGroupChatRoom = {
  __typename?: 'CAPAConnectGroupChatRoom';
  /** 그룹 ID */
  groupId?: Maybe<Scalars['ID']>;
  /** 그룹 이름 */
  groupName: Scalars['String'];
  /** 챗룸 아이디 */
  chatRoomId: Scalars['String'];
  /** 썸네일 */
  thumbnail?: Maybe<Scalars['String']>;
  originalFileExt?: Maybe<Scalars['String']>;
  lastMessage?: Maybe<CapaConnectChatMessageUnion>;
  senderEmail?: Maybe<Scalars['String']>;
  senderName?: Maybe<Scalars['String']>;
  totalMembers?: Maybe<Scalars['Float']>;
  unReadCount?: Maybe<Scalars['Float']>;
  accessLevel?: Maybe<CapaConnectGroupAccessLevel>;
  /** 그룹멤버 */
  users?: Maybe<Array<CapaConnectGroupUser>>;
  /** 생성일 (업로드 일시) */
  createdAt?: Maybe<Scalars['String']>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
};

export type CapaConnectGroupChatRoomOutput = {
  __typename?: 'CAPAConnectGroupChatRoomOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaConnectGroupChatRoom>;
};

export type CapaConnectGroupChatRoomsOutput = {
  __typename?: 'CAPAConnectGroupChatRoomsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaConnectGroupChatRoom>>;
};

export type CapaConnectGroupFileBo = {
  __typename?: 'CAPAConnectGroupFileBO';
  /** 커넥트파일아이디 */
  id: Scalars['String'];
  /** 주인 user ID */
  userId?: Maybe<Scalars['ID']>;
  /** 파일 주인 이메일 */
  email: Scalars['String'];
  /** 파일 주인 유저네임 */
  connectUserName?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['String']>;
  /** 파일 주인 유저네임 */
  fileName?: Maybe<Scalars['String']>;
  fileExtension?: Maybe<Scalars['String']>;
  /** 파일 용량 in bytes */
  fileSize?: Maybe<Scalars['Float']>;
  isFile?: Maybe<Scalars['Boolean']>;
  /** 공유 시간 (업로드 일시) */
  createdAt?: Maybe<Scalars['String']>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
};

export type CapaConnectGroupOutput = {
  __typename?: 'CAPAConnectGroupOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaConnectGroup>;
};

export enum CapaConnectGroupStatus {
  Registered = 'REGISTERED',
  Deleted = 'DELETED'
}

export type CapaConnectGroupUser = {
  __typename?: 'CAPAConnectGroupUser';
  /** 그룹 유저 ID */
  id?: Maybe<Scalars['ID']>;
  userId?: Maybe<Scalars['ID']>;
  /** 그룹 ID */
  groupId?: Maybe<Scalars['ID']>;
  /** 이메일 */
  email: Scalars['String'];
  /** 커넥트유저네임 */
  connectUserName?: Maybe<Scalars['String']>;
  /** 캐파유저냐 */
  isCapaUser?: Maybe<Scalars['Boolean']>;
  /** 커넥트유저네임 */
  accessLevel: CapaConnectGroupAccessLevel;
  /** 생성일 (업로드 일시) */
  createdAt?: Maybe<Scalars['String']>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
};

export enum CapaConnectGroupUserAction {
  Update = 'UPDATE',
  Remove = 'REMOVE'
}

export type CapaConnectGroupUserBo = {
  __typename?: 'CAPAConnectGroupUserBO';
  /** 그룹 유저 ID */
  id?: Maybe<Scalars['ID']>;
  userId?: Maybe<Scalars['ID']>;
  /** 그룹 ID */
  groupId?: Maybe<Scalars['ID']>;
  /** 이메일 */
  email: Scalars['String'];
  /** 커넥트유저네임 */
  connectUserName?: Maybe<Scalars['String']>;
  /** 캐파유저냐 */
  isCapaUser?: Maybe<Scalars['Boolean']>;
  /** 커넥트 그룹 권한 */
  accessLevel: CapaConnectGroupAccessLevel;
  /** 생성일 (그룹 초대 시점) */
  createdAt?: Maybe<Scalars['String']>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
  /** 커넥트유저상태 */
  status?: Maybe<CapaConnectUserStatus>;
  /** 테스트 계정 유무 */
  isTest: Scalars['Boolean'];
};

export type CapaConnectGroupsBoOutput = {
  __typename?: 'CAPAConnectGroupsBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaConnectGroupBo>>;
};

export type CapaConnectGroupsOutput = {
  __typename?: 'CAPAConnectGroupsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaConnectGroup>>;
};

export type CapaConnectIssue = {
  __typename?: 'CAPAConnectIssue';
  /** 이슈 ID */
  id?: Maybe<Scalars['ID']>;
  connectUserId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  /** 이슈 관련 파일 */
  files?: Maybe<Array<CapaFile>>;
  issue?: Maybe<Scalars['String']>;
  /** 생성일 */
  createdAt?: Maybe<Scalars['String']>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
  /** 테스트 유무 */
  isTest: Scalars['Boolean'];
};

export type CapaConnectIssuesBoOutput = {
  __typename?: 'CAPAConnectIssuesBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaConnectIssue>>;
};

export type CapaConnectMyDrive = {
  __typename?: 'CAPAConnectMyDrive';
  files?: Maybe<Array<CapaConnectMyFile>>;
  path?: Maybe<Array<CapaConnectFolder>>;
};

/** 내드리이브 */
export type CapaConnectMyDrivesOutput = {
  __typename?: 'CAPAConnectMyDrivesOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaConnectMyDrive>;
};

/** 내파일들 */
export type CapaConnectMyFile = {
  __typename?: 'CAPAConnectMyFile';
  /** 커넥트 파일 ID */
  id?: Maybe<Scalars['ID']>;
  /** 파일경로 */
  filePath: Scalars['String'];
  /** 파일명 */
  fileName: Scalars['String'];
  /** 파일확장자 */
  fileExtension?: Maybe<Scalars['String']>;
  /** file owner username */
  fileOwnerUsername?: Maybe<Scalars['String']>;
  /** file owner email */
  fileOwnerEmail?: Maybe<Scalars['String']>;
  /** 파일이냐 아니냐 */
  isFile: Scalars['Boolean'];
  /** 공유이냐 아니냐 */
  isShared: Scalars['Boolean'];
  /** 파일크기 byte */
  fileSize?: Maybe<Scalars['Float']>;
  linkStatus?: Maybe<ConnectUserFileLinkStatus>;
  filePermission?: Maybe<ConnectUserFileStatus>;
  /** original ext */
  originalFileExt?: Maybe<Scalars['String']>;
  /** 파일 변환 상태 */
  status?: Maybe<CapaFileConvertStatus>;
  /** 실제 파일 ID */
  fileId?: Maybe<Scalars['String']>;
  /** 썸네일 */
  thumbnail?: Maybe<Scalars['String']>;
  /** 썸네일 */
  thumbnailUri?: Maybe<Scalars['String']>;
  /** 도면 파일 뷰어 URL */
  drawingFile?: Maybe<Scalars['String']>;
  /** 생성일 (업로드 일시) */
  createdAt?: Maybe<Scalars['String']>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
};

export type CapaConnectOnlineUser = {
  __typename?: 'CAPAConnectOnlineUser';
  email?: Maybe<Scalars['String']>;
};

export type CapaConnectOnlineUsersOutput = {
  __typename?: 'CAPAConnectOnlineUsersOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaConnectOnlineUser>>;
};

/** 캐파 커넥트 유저 정보 */
export type CapaConnectSearchUser = {
  __typename?: 'CAPAConnectSearchUser';
  /** capa user email */
  email: Scalars['String'];
  /** capa cloud user id */
  userId?: Maybe<Scalars['String']>;
  /** capa cloud user id */
  connectUserId?: Maybe<Scalars['String']>;
  /** name */
  userName?: Maybe<Scalars['String']>;
};

export type CapaConnectSearchUsersOutput = {
  __typename?: 'CAPAConnectSearchUsersOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaConnectSearchUser>>;
};

export type CapaConnectSharedFile = {
  __typename?: 'CAPAConnectSharedFile';
  /** 커넥트 파일 ID */
  id?: Maybe<Scalars['ID']>;
  /** 파일경로 */
  filePath: Scalars['String'];
  /** 파일명 */
  fileName: Scalars['String'];
  /** 파일확장자 */
  fileExtension?: Maybe<Scalars['String']>;
  /** file owner username */
  fileOwnerUsername?: Maybe<Scalars['String']>;
  /** file owner email */
  fileOwnerEmail?: Maybe<Scalars['String']>;
  /** 파일이냐 아니냐 */
  isFile: Scalars['Boolean'];
  /** 공유이냐 아니냐 */
  isShared: Scalars['Boolean'];
  /** 파일크기 byte */
  fileSize?: Maybe<Scalars['Float']>;
  linkStatus?: Maybe<ConnectUserFileLinkStatus>;
  filePermission?: Maybe<ConnectUserFileStatus>;
  /** original ext */
  originalFileExt?: Maybe<Scalars['String']>;
  /** 파일 변환 상태 */
  status?: Maybe<CapaFileConvertStatus>;
  /** 실제 파일 ID */
  fileId?: Maybe<Scalars['String']>;
  /** 썸네일 */
  thumbnail?: Maybe<Scalars['String']>;
  /** 썸네일 */
  thumbnailUri?: Maybe<Scalars['String']>;
  /** 도면 파일 뷰어 URL */
  drawingFile?: Maybe<Scalars['String']>;
  /** 생성일 (업로드 일시) */
  createdAt?: Maybe<Scalars['String']>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
  /** 그룹 ID */
  groupId?: Maybe<Scalars['ID']>;
  /** 이메일 */
  email: Scalars['String'];
  /** 커넥트유저네임 */
  connectUserName?: Maybe<Scalars['String']>;
  permission?: Maybe<CapaQuotationRfqAllowOpenFileStatus>;
  hasCommentThread?: Maybe<ConnectSharedFileCommentThread>;
  isFirstShared?: Maybe<Scalars['Boolean']>;
};

export enum CapaConnectSharedFileType {
  All = 'ALL',
  Cad = 'CAD',
  Video = 'VIDEO',
  Photo = 'PHOTO',
  Document = 'DOCUMENT',
  Other = 'OTHER'
}

export type CapaConnectSharedFilesOutput = {
  __typename?: 'CAPAConnectSharedFilesOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaConnectSharedFile>>;
};

export type CapaConnectTutorial = {
  __typename?: 'CAPAConnectTutorial';
  message: Scalars['String'];
  fileId: Scalars['String'];
};

export type CapaConnectUpdate = {
  __typename?: 'CAPAConnectUpdate';
  email?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['Float']>;
  anchorPos?: Maybe<Capa3DPos>;
  handlePos?: Maybe<Capa3DPos>;
  annotationId?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['String']>;
  authorId?: Maybe<Scalars['String']>;
  authorName?: Maybe<Scalars['String']>;
  authorEmail?: Maybe<Scalars['String']>;
  edited?: Maybe<Scalars['Boolean']>;
  timestamp?: Maybe<Scalars['String']>;
  /** 업데이트 타입 */
  type?: Maybe<CapaConnectUpdateType>;
};

export type CapaConnectUpdateOutput = {
  __typename?: 'CAPAConnectUpdateOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaConnectUpdate>;
};

export enum CapaConnectUpdateType {
  ChatUpdate = 'CHAT_UPDATE',
  GroupUpdate = 'GROUP_UPDATE',
  MemberUpdate = 'MEMBER_UPDATE',
  FileUpdate = 'FILE_UPDATE',
  AnnotationAdd = 'ANNOTATION_ADD',
  AnnotationUpdate = 'ANNOTATION_UPDATE',
  AnnotationDelete = 'ANNOTATION_DELETE',
  AnnotationOpen = 'ANNOTATION_OPEN',
  AnnotationCommentAdd = 'ANNOTATION_COMMENT_ADD',
  AnnotationCommentUpdate = 'ANNOTATION_COMMENT_UPDATE',
  AnnotationCommentDelete = 'ANNOTATION_COMMENT_DELETE'
}

/** 캐파 커넥트 유저 정보 */
export type CapaConnectUser = {
  __typename?: 'CAPAConnectUser';
  /** capa cloud user id */
  id: Scalars['ID'];
  /** capa user email */
  email: Scalars['String'];
  /** name */
  userName?: Maybe<Scalars['String']>;
  /** userId */
  userId?: Maybe<Scalars['String']>;
  chatRoomUserId?: Maybe<Scalars['String']>;
  notificationFilter: CapaConnectUserNotificationFilter;
  /** 사용중인 드라이브 용량 (단위: byte) */
  usedSize: Scalars['Float'];
  /** 사용가능한 드라이브 용량 (단위: byte) */
  availSize: Scalars['Float'];
  /** 전체 드라이브 용량 (단위: byte) */
  driveSize: Scalars['Float'];
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgreed?: Maybe<Scalars['Boolean']>;
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgreed?: Maybe<Scalars['Boolean']>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgreed?: Maybe<Scalars['Boolean']>;
};

/** 캐파 BO 커넥트 유저 정보 */
export type CapaConnectUserBo = {
  __typename?: 'CAPAConnectUserBO';
  /** capa backoffice connect user id */
  id: Scalars['ID'];
  /** capa backoffice user id */
  userId: Scalars['ID'];
  /** capa connect user email */
  email: Scalars['String'];
  /** capa connect user name */
  userName?: Maybe<Scalars['String']>;
  /** 상태 CAPAConnectUserStatus */
  status: CapaConnectUserStatus;
  /** 가입 경로 */
  route?: Maybe<Array<CapaInflowRoute>>;
  /** 사용중인 드라이브 용량 (단위: byte) */
  usedSize: Scalars['Float'];
  /** 전체 드라이브 용량 (단위: byte) */
  driveSize: Scalars['Float'];
  /** 커넥트 유저 생성일 */
  createdAt: Scalars['String'];
  /** 커넥트 유저 마지막 로그인 */
  lastLoginAt?: Maybe<Scalars['String']>;
  /** 커넥트 업로드 파일 개수 */
  totalFiles?: Maybe<Scalars['Float']>;
  /** 커넥트 공유한 파일 개수 */
  totalSharedFiles?: Maybe<Scalars['Float']>;
  files?: Maybe<Array<CapaConnectMyFile>>;
  /** 커넥트 그룹 개수 */
  totalGroups?: Maybe<Scalars['Float']>;
  /** 커넥트 생성한 그룹 개수 */
  totalOwnerGroups?: Maybe<Scalars['Float']>;
  /** 커넥트 참여 그룹 개수 */
  totalMemberGroups?: Maybe<Scalars['Float']>;
  /** 커넥트 그룹 */
  groups?: Maybe<Array<CapaConnectUserGroupBo>>;
  /** 테스트 계정 유무 */
  isTest: Scalars['Boolean'];
};

export type CapaConnectUserBoOutput = {
  __typename?: 'CAPAConnectUserBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaConnectUserBo>;
};

export type CapaConnectUserFile = {
  __typename?: 'CAPAConnectUserFile';
  id?: Maybe<Scalars['ID']>;
  linkStatus?: Maybe<ConnectUserFileLinkStatus>;
  filePermission?: Maybe<ConnectUserFileStatus>;
};

/** 내파일들 */
export type CapaConnectUserFileBo = {
  __typename?: 'CAPAConnectUserFileBO';
  /** 커넥트 파일 ID */
  id?: Maybe<Scalars['ID']>;
  /** 파일명 */
  fileName: Scalars['String'];
  /** 파일확장자 */
  fileExtension?: Maybe<Scalars['String']>;
  /** file owner username */
  fileOwnerUsername?: Maybe<Scalars['String']>;
  /** file owner email */
  fileOwnerEmail?: Maybe<Scalars['String']>;
  /** 파일이냐 아니냐 */
  isFile: Scalars['Boolean'];
  /** 파일크기 byte */
  fileSize?: Maybe<Scalars['Float']>;
  linkStatus?: Maybe<ConnectUserFileLinkStatus>;
  filePermission?: Maybe<ConnectUserFileStatus>;
  /** 파일 변환 상태 */
  status?: Maybe<CapaFileConvertStatus>;
  /** 실제 파일 ID */
  fileId?: Maybe<Scalars['String']>;
  /** Test 계정 유무 */
  isTest: Scalars['Boolean'];
  /** 방문자 수 */
  visitorsCount?: Maybe<Scalars['Float']>;
  /** 생성일 (업로드 일시) */
  createdAt?: Maybe<Scalars['String']>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
};

export type CapaConnectUserFileLinksBo = {
  __typename?: 'CAPAConnectUserFileLinksBO';
  totalCount?: Maybe<Scalars['Float']>;
  files?: Maybe<Array<CapaConnectUserFileBo>>;
  activeFilesCount?: Maybe<Scalars['Float']>;
};

export type CapaConnectUserFileOutput = {
  __typename?: 'CAPAConnectUserFileOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaConnectUserFile>;
};

export type CapaConnectUserGroupBo = {
  __typename?: 'CAPAConnectUserGroupBO';
  /** capa backoffice connect group id */
  id: Scalars['ID'];
  groupName?: Maybe<Scalars['String']>;
  /** 주석 개수 */
  totalGroupAnnotations?: Maybe<Scalars['Float']>;
  /** 주석 댓글 개수 */
  totalGroupAnnotationComments?: Maybe<Scalars['Float']>;
  /** 커넥트유저네임 */
  accessLevel: CapaConnectGroupAccessLevel;
  status?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
};

/** notification filter */
export type CapaConnectUserNotificationFilter = {
  __typename?: 'CAPAConnectUserNotificationFilter';
  chatPush?: Maybe<Scalars['Boolean']>;
  groupPush?: Maybe<Scalars['Boolean']>;
  groupEmail?: Maybe<Scalars['Boolean']>;
  commentThreadPush?: Maybe<Scalars['Boolean']>;
  commentThreadEmail?: Maybe<Scalars['Boolean']>;
  filePush?: Maybe<Scalars['Boolean']>;
  fileEmail?: Maybe<Scalars['Boolean']>;
};

export type CapaConnectUserOutput = {
  __typename?: 'CAPAConnectUserOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaConnectUser>;
};

export enum CapaConnectUserStatus {
  /** 가입 */
  Registered = 'REGISTERED',
  /** 탈퇴 */
  Deleted = 'DELETED'
}

export type CapaConnectUsersBoOutput = {
  __typename?: 'CAPAConnectUsersBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaConnectUserBo>>;
};

/** 캐파 RFQ 상담 시작 방식 */
export enum CapaConsultingStartMethod {
  /** old rfq - 견적서 없이 상담 가능 */
  OldConsulting = 'OLD_CONSULTING',
  /** 견적서 있어야만 상담 가능 */
  QuotationRequired = 'QUOTATION_REQUIRED',
  /** 견적서 없이 회사소개서만으로도 상담 가능 */
  PartnerIntroductionAvailable = 'PARTNER_INTRODUCTION_AVAILABLE'
}

export type CapaDataCount = {
  __typename?: 'CAPADataCount';
  count: Scalars['Float'];
};

export type CapaDesignDetail = {
  __typename?: 'CAPADesignDetail';
  /** 요청 작업 */
  services?: Maybe<Array<CapaDesignService>>;
};

export type CapaDesignService = {
  __typename?: 'CAPADesignService';
  serviceType?: Maybe<CapaDesignServiceType>;
};

/** design service type */
export enum CapaDesignServiceType {
  /** 제품 디자인 */
  MechanicalDesign = 'MECHANICAL_DESIGN',
  /** 기구 설계  */
  ProductDesign = 'PRODUCT_DESIGN'
}

/** 방해금지 기간 설정 */
export type CapaDoNotDisturbFilter = {
  __typename?: 'CAPADoNotDisturbFilter';
  isActive?: Maybe<Scalars['Boolean']>;
  /** 시작 시간 */
  from?: Maybe<Scalars['Float']>;
  /** 끝나는 시간 */
  to?: Maybe<Scalars['Float']>;
};

/** 방해금지 기간 설정 */
export type CapaDoNotDisturbFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** 시작 시간 */
  from?: InputMaybe<Scalars['Float']>;
  /** 끝나는 시간 */
  to?: InputMaybe<Scalars['Float']>;
};

/** 에러코드 */
export enum CapaErrorCode {
  /** 성공 */
  Success = 'SUCCESS',
  /** 통합 유저를 찾을 수 없습니다. */
  UserNotFound = 'USER_NOT_FOUND',
  /** 비밀번호가 일치하지 않습니다. */
  PasswordIncorrect = 'PASSWORD_INCORRECT',
  /** 중복된 이메일 입니다. */
  DuplicateEmail = 'DUPLICATE_EMAIL',
  /** 검증 코드가 일치하지 않습니다. */
  CodeMismatch = 'CODE_MISMATCH',
  /** 토큰이 일치하지 않습니다. */
  TokenMismatch = 'TOKEN_MISMATCH',
  EmailCodeMismatch = 'EMAIL_CODE_MISMATCH',
  CellPhoneCodeMismatch = 'CELL_PHONE_CODE_MISMATCH',
  /** 유효하지 않은 추천인 ID 입니다. */
  InvalidReferralId = 'INVALID_REFERRAL_ID',
  /** 동의가 필요합니다. */
  NotAgreed = 'NOT_AGREED',
  /** 토큰이 만료되었습니다. */
  TokenExpired = 'TOKEN_EXPIRED',
  /** 유효하지 않은 토큰 입니다. */
  InvalidToken = 'INVALID_TOKEN',
  /** SQL문에서 에러가 발생하였습니다. */
  QueryError = 'QUERY_ERROR',
  /** 허가 되지 않은 접근입니다. */
  Unauthorized = 'UNAUTHORIZED',
  /** 잘못된 요청입니다. */
  BadRequest = 'BAD_REQUEST',
  /** 유효하지 않은 파라미터 입니다. */
  ParmeterValidationError = 'PARMETER_VALIDATION_ERROR',
  /** 채팅 유저가 존재하지 않습니다. */
  ChatUserNotFound = 'CHAT_USER_NOT_FOUND',
  /** 클라우드 사용자가 이미 존재 합니다. */
  CloudUserExists = 'CLOUD_USER_EXISTS',
  /** 클라우드 사용자를 찾을 수 없습니다. */
  CloudUserNotFound = 'CLOUD_USER_NOT_FOUND',
  /** 커넥트 사용자가 이미 존재 합니다. */
  ConnectUserExists = 'CONNECT_USER_EXISTS',
  /** 커넥트 사용자를 찾을 수 없습니다. */
  ConnectUserNotFound = 'CONNECT_USER_NOT_FOUND',
  /** 고객이 이미 존재 합니다. */
  QuotationUserExists = 'QUOTATION_USER_EXISTS',
  /** 고객을 찾을 수 없습니다. */
  QuotationUserNotFound = 'QUOTATION_USER_NOT_FOUND',
  QuotationUserRegistrationFailed = 'QUOTATION_USER_REGISTRATION_FAILED',
  /** 파트너를 찾을 수 없습니다. */
  QuotationPartnerNotFound = 'QUOTATION_PARTNER_NOT_FOUND',
  /** 파트너의 유저를 찾을 수 없습니다. */
  QuotationPartnerUserNotFound = 'QUOTATION_PARTNER_USER_NOT_FOUND',
  /** 이미 파트너가 존재합니다. */
  QuotationPartnerExists = 'QUOTATION_PARTNER_EXISTS',
  /** 권한이 없습니다. */
  NotAllowedUser = 'NOT_ALLOWED_USER',
  /** 중복된 사업자 등록 번호 입니다. */
  DuplicateCompanyRegistrationNo = 'DUPLICATE_COMPANY_REGISTRATION_NO',
  ValidCompanyRegistrationNo = 'VALID_COMPANY_REGISTRATION_NO',
  /** 유효하지 않은 사업자 등록 번호 입니다. */
  InavlidCompanyRegistrationNo = 'INAVLID_COMPANY_REGISTRATION_NO',
  /** 사업자 등록증을 입력해야 합니다. */
  NoCompanyRegistrationFile = 'NO_COMPANY_REGISTRATION_FILE',
  NoPortfolioImage = 'NO_PORTFOLIO_IMAGE',
  NoMatchPortfolioImageLength = 'NO_MATCH_PORTFOLIO_IMAGE_LENGTH',
  /** 파일을 찾을 수 없습니다. */
  FileNotFound = 'FILE_NOT_FOUND',
  NotExistPdfFile = 'NOT_EXIST_PDF_FILE',
  NotExistImagePortfolio = 'NOT_EXIST_IMAGE_PORTFOLIO',
  FileExists = 'FILE_EXISTS',
  /** 도면 파일 변환에 실패 하였습니다. */
  FileConversionFailed = 'FILE_CONVERSION_FAILED',
  /** 클라우드 용량이 부족합니다. */
  NotEnoughCloudStorage = 'NOT_ENOUGH_CLOUD_STORAGE',
  /** 커넥트 용량이 부족합니다. */
  NotEnoughConnectStorage = 'NOT_ENOUGH_CONNECT_STORAGE',
  /** 에러 */
  Error = 'ERROR',
  /** ITP_EVENT_EXIST */
  ItpEventExist = 'ITP_EVENT_EXIST',
  /** ITP_EVENT_NOT_FOUND */
  ItpEventNotFound = 'ITP_EVENT_NOT_FOUND',
  JsbEventExist = 'JSB_EVENT_EXIST',
  JsbEventNotFound = 'JSB_EVENT_NOT_FOUND',
  /** ALREADY_APPROVED */
  AlreadyApproved = 'ALREADY_APPROVED',
  /** BACKOFFICE_NOT_FOUND */
  BackofficeNotFound = 'BACKOFFICE_NOT_FOUND',
  /** CHATROOM_NOT_FOUND */
  ChatroomNotFound = 'CHATROOM_NOT_FOUND',
  QuotationChatroomNotFound = 'QUOTATION_CHATROOM_NOT_FOUND',
  /** CHATROOM_NOT_OPENED */
  ChatroomNotOpened = 'CHATROOM_NOT_OPENED',
  ChatroomAlreadyOpened = 'CHATROOM_ALREADY_OPENED',
  /** NO_CHAT_USERS */
  NoChatUsers = 'NO_CHAT_USERS',
  /** CHATROOM_EXISTS */
  ChatroomExists = 'CHATROOM_EXISTS',
  /** RFQ_NOT_FOUND */
  RfqNotFound = 'RFQ_NOT_FOUND',
  /** RFQ_QUOTATION_OR_QUOTATION_PARTNER_INTRODUCTION_NOT_FOUND */
  RfqQuotationOrQuotationPartnerIntroductionNotFound = 'RFQ_QUOTATION_OR_QUOTATION_PARTNER_INTRODUCTION_NOT_FOUND',
  /** RFQ_QUOTATION_AND_QUOTATION_PARTNER_INTRODUCTION_NOT_FOUND */
  RfqQuotationAndQuotationPartnerIntroductionNotFound = 'RFQ_QUOTATION_AND_QUOTATION_PARTNER_INTRODUCTION_NOT_FOUND',
  /** RFQ_QUOTATION_NOT_FOUND_PARTNER_INTRODUCTION_FOUND */
  RfqQuotationNotFoundPartnerIntroductionFound = 'RFQ_QUOTATION_NOT_FOUND_PARTNER_INTRODUCTION_FOUND',
  /** RFQ_QUOTATION_NOT_FOUND */
  RfqQuotationNotFound = 'RFQ_QUOTATION_NOT_FOUND',
  RfqNotQuotationUser = 'RFQ_NOT_QUOTATION_USER',
  /** RFQ_QUOTATION_ALREADY_REGISTERED */
  RfqQuotationAlreadyRegistered = 'RFQ_QUOTATION_ALREADY_REGISTERED',
  /** RFQ_QUOTATION_ALREADY_CONFIRMED */
  RfqQuotationAlreadyConfirmed = 'RFQ_QUOTATION_ALREADY_CONFIRMED',
  /** RFQ_QUOTATION_NOT_CONFIRMED */
  RfqQuotationNotConfirmed = 'RFQ_QUOTATION_NOT_CONFIRMED',
  /** RFQ_QUOTATION_PARTNER_INTRODUCTION_NOT_FOUND */
  RfqQuotationPartnerIntroductionNotFound = 'RFQ_QUOTATION_PARTNER_INTRODUCTION_NOT_FOUND',
  /** RFQ_FILTER_NOT_PROVIDE_SERVICE_TYPE */
  RfqFilterNotProvideServiceType = 'RFQ_FILTER_NOT_PROVIDE_SERVICE_TYPE',
  /** RFQ_PURCHASE_ORDER_NOT_FOUND */
  RfqPurchaseOrderNotFound = 'RFQ_PURCHASE_ORDER_NOT_FOUND',
  /** RFQ_PURCHASE_ORDER_ALREADY_CONFIRMED */
  RfqPurchaseOrderAlreadyConfirmed = 'RFQ_PURCHASE_ORDER_ALREADY_CONFIRMED',
  /** RFQ_PURCHASE_ORDER_ALREADY_REGISTERED */
  RfqPurchaseOrderAlreadyRegistered = 'RFQ_PURCHASE_ORDER_ALREADY_REGISTERED',
  /** INVALID_RFQ_STATUS */
  InvalidRfqStatus = 'INVALID_RFQ_STATUS',
  /** SEND_MESSAGE_FAILED */
  SendMessageFailed = 'SEND_MESSAGE_FAILED',
  /** READ_MESSAGE_FAILED */
  ReadMessageFailed = 'READ_MESSAGE_FAILED',
  /** FETCH_MESSAGES_FAILED */
  FetchMessagesFailed = 'FETCH_MESSAGES_FAILED',
  /** CANNOT_CREATE_CHATROOM */
  CannotCreateChatroom = 'CANNOT_CREATE_CHATROOM',
  /** INVALID_NOTIFICATION_SEQ */
  InvalidNotificationSeq = 'INVALID_NOTIFICATION_SEQ',
  /** DUPLICATE_RFQ_ID */
  DuplicateRfqId = 'DUPLICATE_RFQ_ID',
  /** RFQ_ALREADY_CONFIRMED */
  RfqAlreadyConfirmed = 'RFQ_ALREADY_CONFIRMED',
  /** RFQ_ALREADY_STOPPED */
  RfqAlreadyStopped = 'RFQ_ALREADY_STOPPED',
  RfqAlreadyComplete = 'RFQ_ALREADY_COMPLETE',
  /** 결제 프로세스 진행중입니다. */
  RfqPaymentInProgress = 'RFQ_PAYMENT_IN_PROGRESS',
  RfqNotConfirmed = 'RFQ_NOT_CONFIRMED',
  /** CANNOT_CHANGE_RFQ_FILE_OPEN_STATUS */
  CannotChangeRfqFileOpenStatus = 'CANNOT_CHANGE_RFQ_FILE_OPEN_STATUS',
  AlreadyEvaluated = 'ALREADY_EVALUATED',
  AlreadyRated = 'ALREADY_RATED',
  RfqNotComplete = 'RFQ_NOT_COMPLETE',
  PassedReviewPeriod = 'PASSED_REVIEW_PERIOD',
  NotReviewReplyPeriod = 'NOT_REVIEW_REPLY_PERIOD',
  AlreadyReplied = 'ALREADY_REPLIED',
  NoMessage = 'NO_MESSAGE',
  NotReviewed = 'NOT_REVIEWED',
  InvalidPath = 'INVALID_PATH',
  GroupNotExists = 'GROUP_NOT_EXISTS',
  GroupAlreadyExists = 'GROUP_ALREADY_EXISTS',
  CannotInviteSelf = 'CANNOT_INVITE_SELF',
  DestinationNotFound = 'DESTINATION_NOT_FOUND',
  DestinationIsFile = 'DESTINATION_IS_FILE',
  InvalidDestination = 'INVALID_DESTINATION',
  SameDestination = 'SAME_DESTINATION',
  NotSendPartnerMessage = 'NOT_SEND_PARTNER_MESSAGE',
  DuplicateGroupName = 'DUPLICATE_GROUP_NAME',
  ConnectUserNotInGroup = 'CONNECT_USER_NOT_IN_GROUP',
  InvalidAccessLevel = 'INVALID_ACCESS_LEVEL',
  NotFoundPartnerChatRoom = 'NOT_FOUND_PARTNER_CHAT_ROOM',
  RfqUpdateNotComplete = 'RFQ_UPDATE_NOT_COMPLETE',
  IsNotExistPurchaseOrder = 'IS_NOT_EXIST_PURCHASE_ORDER',
  IsNotExistRfqQuotation = 'IS_NOT_EXIST_RFQ_QUOTATION',
  IsExistSignature = 'IS_EXIST_SIGNATURE',
  IsExistCompanyRegistration = 'IS_EXIST_COMPANY_REGISTRATION',
  InvalidAnnotation = 'INVALID_ANNOTATION',
  InvalidComment = 'INVALID_COMMENT',
  InvalidGroupUser = 'INVALID_GROUP_USER',
  InvalidFileOwner = 'INVALID_FILE_OWNER',
  /** MAKE_PDF_ERROR */
  MakePdfError = 'MAKE_PDF_ERROR',
  RfqTransactionNotFound = 'RFQ_TRANSACTION_NOT_FOUND',
  /** 허브스팟 사용자가 이미 존재합니다. */
  HubspotUserExists = 'HUBSPOT_USER_EXISTS',
  /** 이미 구독중입니다. */
  AlreadySubscribed = 'ALREADY_SUBSCRIBED',
  NotRegisterQuotationUser = 'NOT_REGISTER_QUOTATION_USER',
  NotUpdateQuotationUser = 'NOT_UPDATE_QUOTATION_USER',
  NotRegisterQuotationPartner = 'NOT_REGISTER_QUOTATION_PARTNER',
  NotUpdateQuotationPartner = 'NOT_UPDATE_QUOTATION_PARTNER',
  NotSaveRfqFilter = 'NOT_SAVE_RFQ_FILTER',
  NotRegisterRfqrfq = 'NOT_REGISTER_RFQRFQ',
  NotRequestAdjustRfqQuotation = 'NOT_REQUEST_ADJUST_RFQ_QUOTATION',
  NotConfirmRfqQuotation = 'NOT_CONFIRM_RFQ_QUOTATION',
  NotRegisterRequestRfqPurchaseorder = 'NOT_REGISTER_REQUEST_RFQ_PURCHASEORDER',
  NotRequestAdjustRfqPurchaseOrder = 'NOT_REQUEST_ADJUST_RFQ_PURCHASE_ORDER',
  NotRequestConfirmRfqTransaction = 'NOT_REQUEST_CONFIRM_RFQ_TRANSACTION',
  NotConfirmRfqTransaction = 'NOT_CONFIRM_RFQ_TRANSACTION',
  NotRequestCompleteRfqTransaction = 'NOT_REQUEST_COMPLETE_RFQ_TRANSACTION',
  NotCompleteRfqTransaction = 'NOT_COMPLETE_RFQ_TRANSACTION',
  NotReadRfqQuotation = 'NOT_READ_RFQ_QUOTATION',
  NotReadRfqPurchaseOrder = 'NOT_READ_RFQ_PURCHASE_ORDER',
  NotExpireRfq = 'NOT_EXPIRE_RFQ',
  NotEvaluateRfqPartners = 'NOT_EVALUATE_RFQ_PARTNERS',
  NotCreateSimpleQuotation = 'NOT_CREATE_SIMPLE_QUOTATION',
  NotCreateDetailedQuotation = 'NOT_CREATE_DETAILED_QUOTATION',
  NotCreatePurchaseOrder = 'NOT_CREATE_PURCHASE_ORDER',
  NotCreatePurchaseOrderWithItem = 'NOT_CREATE_PURCHASE_ORDER_WITH_ITEM',
  NotRegisterRequestRfqPurchaseOrderWithItem = 'NOT_REGISTER_REQUEST_RFQ_PURCHASE_ORDER_WITH_ITEM',
  NotRegisterRequestRfqQuotation = 'NOT_REGISTER_REQUEST_RFQ_QUOTATION',
  NotRequestAdjustRfqPurchaseOrderWithItem = 'NOT_REQUEST_ADJUST_RFQ_PURCHASE_ORDER_WITH_ITEM',
  NotConfirmRfqPurchaseOrderWithItem = 'NOT_CONFIRM_RFQ_PURCHASE_ORDER_WITH_ITEM',
  RequestRfqDrawingFileDownload = 'REQUEST_RFQ_DRAWING_FILE_DOWNLOAD',
  NotRallowRfqDrawingFileDownload = 'NOT_RALLOW_RFQ_DRAWING_FILE_DOWNLOAD',
  NotToggleFavorite = 'NOT_TOGGLE_FAVORITE',
  NotReviewRfq = 'NOT_REVIEW_RFQ',
  NotReplyRfqReview = 'NOT_REPLY_RFQ_REVIEW',
  NotReadAllManagement = 'NOT_READ_ALL_MANAGEMENT',
  NotUpdateRfqStatus = 'NOT_UPDATE_RFQ_STATUS',
  NotCreateQuotationChatRoom = 'NOT_CREATE_QUOTATION_CHAT_ROOM',
  NotSendQuotationChatMessage = 'NOT_SEND_QUOTATION_CHAT_MESSAGE',
  NotFetchQuotationChatRoom = 'NOT_FETCH_QUOTATION_CHAT_ROOM',
  NotQuitQuotationChatRoom = 'NOT_QUIT_QUOTATION_CHAT_ROOM',
  NotReadQuotationChatMessage = 'NOT_READ_QUOTATION_CHAT_MESSAGE',
  NotVerifyCompanyRegistrationNumber = 'NOT_VERIFY_COMPANY_REGISTRATION_NUMBER',
  NotSuggestService = 'NOT_SUGGEST_SERVICE',
  NotRateQuotationService = 'NOT_RATE_QUOTATION_SERVICE',
  NotFetchQuotationServiceRating = 'NOT_FETCH_QUOTATION_SERVICE_RATING',
  AlreadyHaveFileInDrive = 'ALREADY_HAVE_FILE_IN_DRIVE',
  ClossingBusiness = 'CLOSSING_BUSINESS',
  IsNotExistCompanyInfo = 'IS_NOT_EXIST_COMPANY_INFO',
  NiceDnbCompanyOverViewError = 'NICE_DNB_COMPANY_OVER_VIEW_ERROR',
  NiceDnbIsClosedBusinessError = 'NICE_DNB_IS_CLOSED_BUSINESS_ERROR',
  NiceDnbAccssTokenError = 'NICE_DNB_ACCSS_TOKEN_ERROR',
  SharpImageResizeError = 'SHARP_IMAGE_RESIZE_ERROR',
  /** 이미 존재하는 PCB 요청서입니다. */
  DuplicatePcbRfq = 'DUPLICATE_PCB_RFQ',
  DuplicateDesignRfq = 'DUPLICATE_DESIGN_RFQ',
  PcbPdfError = 'PCB_PDF_ERROR',
  ConnectContactUserAlreadyExists = 'CONNECT_CONTACT_USER_ALREADY_EXISTS',
  /** GROUP_USER_ALREADY_EXISTS */
  GroupUserAlreadyExists = 'GROUP_USER_ALREADY_EXISTS',
  /** CANNOT_ADD_THEMSELF_TO_CONTACT_LIST */
  CannotAddThemselfToContactList = 'CANNOT_ADD_THEMSELF_TO_CONTACT_LIST',
  /** CANNOT_INVITE_CAPA_OFFICIAL */
  CannotInviteCapaOfficial = 'CANNOT_INVITE_CAPA_OFFICIAL',
  /** CONNECT_FILE_CAN_NOT_BE_DOWNLOADED */
  ConnectFileCanNotBeDownloaded = 'CONNECT_FILE_CAN_NOT_BE_DOWNLOADED',
  /** 현재 서버 배포중 입니다. */
  DeployingServer = 'DEPLOYING_SERVER',
  NotExistQuotationServiceType = 'NOT_EXIST_QUOTATION_SERVICE_TYPE',
  NotMatchUser = 'NOT_MATCH_USER',
  NotMatchPartnerUserType = 'NOT_MATCH_PARTNER_USER_TYPE',
  NotMatchFileType = 'NOT_MATCH_FILE_TYPE',
  NotCloseAllChatRooms = 'NOT_CLOSE_ALL_CHAT_ROOMS',
  NotAllServiceTypesIncluded = 'NOT_ALL_SERVICE_TYPES_INCLUDED',
  NotServiceTypeIncluded = 'NOT_SERVICE_TYPE_INCLUDED',
  /** 활성화 되지 않은 서비스 타입입니다. */
  NotActiveServiceType = 'NOT_ACTIVE_SERVICE_TYPE',
  /** 가공 방식이 포함되지 않았습니다. */
  NotIncludedDetailedService = 'NOT_INCLUDED_DETAILED_SERVICE',
  InActiveServiceIncluded = 'IN_ACTIVE_SERVICE_INCLUDED',
  OverFileSize = 'OVER_FILE_SIZE',
  MigrationAlreadyCompleted = 'MIGRATION_ALREADY_COMPLETED',
  NotIncludePortfolioFile = 'NOT_INCLUDE_PORTFOLIO_FILE',
  /** FILE_OWNER_NOT_FOUND */
  FileOwnerNotFound = 'FILE_OWNER_NOT_FOUND',
  /** 이미 소개서를 보냈습니다 */
  AlreadySendIntroduction = 'ALREADY_SEND_INTRODUCTION',
  /** 광고 정보를 찾지 못함 */
  AdvertisementNotFound = 'ADVERTISEMENT_NOT_FOUND',
  /** 광고 정보를 찾지 못함 */
  AdvertisingNotFound = 'ADVERTISING_NOT_FOUND',
  NotFoundQuotationAnnotationSharedFileId = 'NOT_FOUND_QUOTATION_ANNOTATION_SHARED_FILE_ID',
  NotFoundQuotationFile = 'NOT_FOUND_QUOTATION_FILE',
  ProvideOnlyOneFileId = 'PROVIDE_ONLY_ONE_FILE_ID',
  NotFoundAnnotation = 'NOT_FOUND_ANNOTATION',
  NotFoundAnnotationParentComment = 'NOT_FOUND_ANNOTATION_PARENT_COMMENT',
  NotFoundAnnotationComment = 'NOT_FOUND_ANNOTATION_COMMENT',
  NotMatchDrawingFile = 'NOT_MATCH_DRAWING_FILE',
  NotMatchChatRoomMessageFile = 'NOT_MATCH_CHAT_ROOM_MESSAGE_FILE',
  NotFoundChatRoom = 'NOT_FOUND_CHAT_ROOM',
  /** 바이패스 관련 고객 불만 정보가 존재하지 않습니다. */
  BypassComplaintNotExists = 'BYPASS_COMPLAINT_NOT_EXISTS',
  NotFountChatRoomUser = 'NOT_FOUNT_CHAT_ROOM_USER',
  NotFoundChatRoomMessageFile = 'NOT_FOUND_CHAT_ROOM_MESSAGE_FILE',
  /** 어노테이션 부모 댓글은 삭제할 수 없습니다. */
  ParentCommentCannotDelete = 'PARENT_COMMENT_CANNOT_DELETE',
  /** 한개 이상의 파라미터 값이 필요합니다. */
  MoreThanOneParameterValueRequired = 'MORE_THAN_ONE_PARAMETER_VALUE_REQUIRED',
  /** 어노테이션이 일치하지 않습니다. */
  NotMatchAnnotation = 'NOT_MATCH_ANNOTATION',
  FetchAnnotationNotFound = 'FETCH_ANNOTATION_NOT_FOUND',
  RequiredDetailedRequest = 'REQUIRED_DETAILED_REQUEST',
  /** 상담리뷰가 존재하지 않습니다. */
  ConsultingReviewNotFound = 'CONSULTING_REVIEW_NOT_FOUND',
  /** 상담리뷰가 이미 존재합니다. */
  ConsultingReviewAlreadyExists = 'CONSULTING_REVIEW_ALREADY_EXISTS',
  /** 거래리뷰가 존재하지 않습니다. */
  TransactionReviewNotFound = 'TRANSACTION_REVIEW_NOT_FOUND',
  /** 거래리뷰가 이미 존재합니다. */
  TransactionReviewAlreadyExists = 'TRANSACTION_REVIEW_ALREADY_EXISTS',
  /** 상담리뷰 작성할 수 있는 시간을 초과하였습니다. */
  ConsultingReviewTimeExceed = 'CONSULTING_REVIEW_TIME_EXCEED',
  /** 거래리뷰 작성할 수 있는 시간을 초과하였습니다. */
  TransactionReviewTimeExceed = 'TRANSACTION_REVIEW_TIME_EXCEED',
  /** ICX (industrial complex) 정보가 없습니다. */
  IcxNotExist = 'ICX_NOT_EXIST',
  /** 거부된 발주서입니다. */
  PurchaseOrderRejected = 'PURCHASE_ORDER_REJECTED',
  /** can't configure firebase admin */
  FirebaseConfigurationError = 'FIREBASE_CONFIGURATION_ERROR',
  /** 거래리뷰 요청을 이미 전송했습니다. */
  AlreadyRequestRegisterTransactionReview = 'ALREADY_REQUEST_REGISTER_TRANSACTION_REVIEW',
  /** BO 유저를 찾을 수 없습니다. */
  BoUserNotFound = 'BO_USER_NOT_FOUND',
  /** 이미 탈퇴한 BO 회원입니다. */
  AlreadyWithdrawnBoUser = 'ALREADY_WITHDRAWN_BO_USER',
  /** 거절됀 사용자 */
  UserRejected = 'USER_REJECTED',
  /** 동일 정보의 엠베서더가 이미 존재합니다. */
  AmbassadorAlreadyExists = 'AMBASSADOR_ALREADY_EXISTS',
  /** 엠베서더를 찾을 수 없습니다. */
  AmbassadorNotFound = 'AMBASSADOR_NOT_FOUND',
  /** 유효하지 않은 엠베서더 ID 입니다. */
  InvalidAmbassadorId = 'INVALID_AMBASSADOR_ID',
  IamportGetTokenError = 'IAMPORT_GET_TOKEN_ERROR',
  IamportGetPaymentDataError = 'IAMPORT_GET_PAYMENT_DATA_ERROR',
  EscrowError = 'ESCROW_ERROR',
  EscrowTokenError = 'ESCROW_TOKEN_ERROR',
  EscrowShippingError = 'ESCROW_SHIPPING_ERROR',
  /** 배송정보를 찾을 수 없습니다. */
  ShippingNotFound = 'SHIPPING_NOT_FOUND',
  /** 이미 예상 배송정보가 등록되었습니다. */
  ShippingAlreadyRegisted = 'SHIPPING_ALREADY_REGISTED',
  /** 해당 MERCHATN_UID에 해당되는 거래건이 없습니다 */
  NoPaymentOfMerchantUid = 'NO_PAYMENT_OF_MERCHANT_UID',
  /** 거래 금액이 일치하지 않습니다. */
  DismatchPaymentAmount = 'DISMATCH_PAYMENT_AMOUNT',
  /** 에스크로 및 결제 input에 null인 값이 있습니다. */
  PaymentInputNonNullable = 'PAYMENT_INPUT_NON_NULLABLE',
  /** 에스크로 및 결제 input에 invalid값이 있습니다.  */
  PaymentInvalidInput = 'PAYMENT_INVALID_INPUT',
  /** 서브몰 미등록 파트너 */
  SubmallNotFound = 'SUBMALL_NOT_FOUND',
  /** 배송등록 불가능 - 가능한 스텝이 아님 */
  RegisterShippingDisableForStep = 'REGISTER_SHIPPING_DISABLE_FOR_STEP',
  /** 제조 시작이 불가능합니다. */
  CannotStartProcessing = 'CANNOT_START_PROCESSING',
  /** 아직 결제되지 않았습니다. */
  BeforePayment = 'BEFORE_PAYMENT',
  /** 사업자등록번호가 일치하지 않습니다. */
  CompanyRegistrationNumberMismatch = 'COMPANY_REGISTRATION_NUMBER_MISMATCH',
  /** 이미 등록된 서브몰이 있습니다. */
  AlreadySubmallExists = 'ALREADY_SUBMALL_EXISTS',
  /** 나이스페이 api not success */
  PaymentApiResultNotSuccess = 'PAYMENT_API_RESULT_NOT_SUCCESS',
  /** 나이스페이 api success */
  PaymentApiResultSuccess = 'PAYMENT_API_RESULT_SUCCESS',
  /** puchase order 상태 값으로 변경이 불가능 합니다 */
  InvalidStatusToUpdatePurchaseOrder = 'INVALID_STATUS_TO_UPDATE_PURCHASE_ORDER',
  /** cancel payment가 존재하지 않습니다 */
  CancelPaymentNotFound = 'CANCEL_PAYMENT_NOT_FOUND',
  /** PG사 정보와 CAPA DB가 매칭이 되지 않습니다. */
  DismatchPaymentInfo = 'DISMATCH_PAYMENT_INFO',
  /** 결제 정보를 찾을 수 없습니다. */
  PaymentNotFound = 'PAYMENT_NOT_FOUND',
  /** 이미 환불되었습니다. */
  AlreadyRefunded = 'ALREADY_REFUNDED',
  /** 환불 요청이 불가능합니다. */
  CannotRequestRefund = 'CANNOT_REQUEST_REFUND',
  /** 환불 계좌가 존재하지 않습니다 */
  RefundBankNotFound = 'REFUND_BANK_NOT_FOUND',
  /** 잘 못된 은행 코드입니다 */
  InvalidBankCode = 'INVALID_BANK_CODE',
  /** 잘 못된 pg 코드입니다 */
  InvalidPgProvider = 'INVALID_PG_PROVIDER',
  /** 파트너가 배송지 입력을 하지 않았습니다.  */
  ShippingNotRegistered = 'SHIPPING_NOT_REGISTERED',
  /** 이미 구매확정을 연기했습니다.  */
  AlreadyExtendedConfirmPurchase = 'ALREADY_EXTENDED_CONFIRM_PURCHASE',
  /** 아임포트 혹은 나이스페이 api 호출 실패 */
  PaymenyApiCallFail = 'PAYMENY_API_CALL_FAIL',
  /** 잘못된 결제 상태 */
  InvalidPaymentStatus = 'INVALID_PAYMENT_STATUS',
  /** 본인인증이 되지 않은 유저 */
  UnverifiedUser = 'UNVERIFIED_USER',
  /** 유효하지 않는 계좌 */
  InvalidAccount = 'INVALID_ACCOUNT',
  /** 예금주가 일치하지 않습니다. */
  AccountHolderMismatch = 'ACCOUNT_HOLDER_MISMATCH',
  /** 환불계좌 정보를 찾을수 없습니다. */
  NotFoundRefundAccount = 'NOT_FOUND_REFUND_ACCOUNT',
  /** 이미 거절된 서브몰입니다. */
  AlreadySubmallRejected = 'ALREADY_SUBMALL_REJECTED',
  /** 사업자 등록증이 존재하지 않습니다. */
  QuotationPartnerRegistrationNotFound = 'QUOTATION_PARTNER_REGISTRATION_NOT_FOUND',
  /** 통장 사본이 존재하지 않습니다. */
  QuotationPartnerBankbookNotFound = 'QUOTATION_PARTNER_BANKBOOK_NOT_FOUND',
  /** 이미 테이블에 등록된 결제 건 입니다. */
  AlreadyRegisteredPayment = 'ALREADY_REGISTERED_PAYMENT',
  CannotCancelPayment = 'CANNOT_CANCEL_PAYMENT',
  FailedIamportCancelRequest = 'FAILED_IAMPORT_CANCEL_REQUEST',
  InvalidQuotationCost = 'INVALID_QUOTATION_COST',
  /** 잘 못된 quotation */
  InvalidQuotation = 'INVALID_QUOTATION',
  /** deetailed quotation not found */
  DetailedQuotationNotFound = 'DETAILED_QUOTATION_NOT_FOUND',
  /** 이미 마감된 견적서입니다. */
  QuotationAlreadyClosed = 'QUOTATION_ALREADY_CLOSED',
  /** 타 업체에 발주됐습니다. */
  QuotationOtherCompanyOrder = 'QUOTATION_OTHER_COMPANY_ORDER',
  /** 최소 결제비용 충족을 못했습니다. 개발은 1,000 운영은 2,000 */
  NotMeetingMinimumCost = 'NOT_MEETING_MINIMUM_COST',
  /** 약관 동의가 필요합니다. */
  TermsNotAgreed = 'TERMS_NOT_AGREED',
  /** 최근 견적서로만 발주 가능합니다. */
  NotLatestQuotation = 'NOT_LATEST_QUOTATION',
  /** 마감된 견적 요청서입니다. */
  RfqExpired = 'RFQ_EXPIRED',
  /** 환불계좌정보가 이미 존재 합니다. */
  RefundBankInfoExists = 'REFUND_BANK_INFO_EXISTS'
}

export type CapaFetchAvailableFilterRfq = {
  __typename?: 'CAPAFetchAvailableFilterRfq';
  id: Scalars['String'];
  isFavorite?: Maybe<Scalars['Boolean']>;
  thumbnailId?: Maybe<Scalars['String']>;
  projectName: Scalars['String'];
  organizationName?: Maybe<Scalars['String']>;
  managerName?: Maybe<Scalars['String']>;
  shortAddress?: Maybe<Scalars['String']>;
  serviceType: CapaQuotationServiceType;
  quantity?: Maybe<Scalars['Float']>;
  uniqueViews?: Maybe<Scalars['Float']>;
  chatRooms?: Maybe<Scalars['Float']>;
  isNew: Scalars['Boolean'];
  isSendQuotation: Scalars['Boolean'];
  isSendIntroduction: Scalars['Boolean'];
  createdAt: Scalars['String'];
  rfqStatus: CapaRfqStatus;
  detailedServiceType?: Maybe<CapaQuotationDetailedServiceType>;
  pageViews?: Maybe<Scalars['Float']>;
  eventType?: Maybe<CapaQuotationRfqEventType>;
  isTest: Scalars['Boolean'];
  currentSituation?: Maybe<QuotationPartnerRfqCurrentSituationType>;
  rfqPurchaseOrderId?: Maybe<Scalars['String']>;
  rfqPurchaseOrderQuotationPartnerId?: Maybe<Scalars['String']>;
  rfqPurchaseOrderQuotationId?: Maybe<Scalars['String']>;
  purchaseOrderStatus?: Maybe<CapaPurchaseOrderStatus>;
  /** rfq 작성한 유저의 프로필 이미지 */
  userProfileId?: Maybe<Scalars['String']>;
};

export type CapaFetchAvailableFilterRfqs = {
  __typename?: 'CAPAFetchAvailableFilterRfqs';
  count: Scalars['Float'];
  rfqs?: Maybe<Array<CapaFetchAvailableFilterRfq>>;
};

export type CapaFetchAvailableFilterRfqsOutput = {
  __typename?: 'CAPAFetchAvailableFilterRfqsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaFetchAvailableFilterRfqs>;
};

/** CAPAFetchQuotationPartnerProjectManagementDetail */
export type CapaFetchQuotationPartnerProjectManagementDetail = {
  __typename?: 'CAPAFetchQuotationPartnerProjectManagementDetail';
  /** 도면 관리 */
  drawingFile?: Maybe<CapaRfqPartnerManagementElement>;
  /** 견적서 */
  quotation?: Maybe<CapaRfqPartnerManagementElement>;
  /** 발주서 */
  purchaseOrder?: Maybe<CapaRfqPartnerManagementElement>;
};

/** CAPAFetchQuotationPartnerProjectManagementDetailOuput */
export type CapaFetchQuotationPartnerProjectManagementDetailOutput = {
  __typename?: 'CAPAFetchQuotationPartnerProjectManagementDetailOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaFetchQuotationPartnerProjectManagementDetail>;
};

export type CapaFetchQuotationPartnerProjectManagementRfqs = {
  __typename?: 'CAPAFetchQuotationPartnerProjectManagementRfqs';
  count: Scalars['Float'];
  managements: Array<CapaQuotationPartnerProjectManagement>;
};

/** CAPAFetchQuotationPartnerProjectManagementRfqsOutput */
export type CapaFetchQuotationPartnerProjectManagementRfqsOutput = {
  __typename?: 'CAPAFetchQuotationPartnerProjectManagementRfqsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaFetchQuotationPartnerProjectManagementRfqs>;
};

/** CAPAFetchQuotationUserProjectManagementDetail */
export type CapaFetchQuotationUserProjectManagementDetail = {
  __typename?: 'CAPAFetchQuotationUserProjectManagementDetail';
  /** 도면 관리 */
  drawingFile?: Maybe<CapaRfqManagementElement>;
  /** 견적서 */
  quotation?: Maybe<CapaRfqManagementElement>;
  /** 발주서 */
  purchaseOrder?: Maybe<CapaRfqManagementElement>;
};

/** CAPARfqProjectManagementOutput */
export type CapaFetchQuotationUserProjectManagementDetailOuput = {
  __typename?: 'CAPAFetchQuotationUserProjectManagementDetailOuput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaFetchQuotationUserProjectManagementDetail>;
};

export type CapaFetchQuotationUserProjectManagementRfqs = {
  __typename?: 'CAPAFetchQuotationUserProjectManagementRfqs';
  count: Scalars['Float'];
  managements: Array<CapaQuotationUserProjectManagement>;
};

/** CAPAFetchQuotationUserProjectManagementListOutput */
export type CapaFetchQuotationUserProjectManagementRfqsOutput = {
  __typename?: 'CAPAFetchQuotationUserProjectManagementRfqsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaFetchQuotationUserProjectManagementRfqs>;
};

export type CapaFetchRfqStatus = {
  __typename?: 'CAPAFetchRfqStatus';
  /** rfq 상태값 */
  rfqStatus: CapaRfqStatus;
};

export type CapaFile = {
  __typename?: 'CAPAFile';
  fileId: Scalars['ID'];
  fileName?: Maybe<Scalars['String']>;
  fileExtension?: Maybe<Scalars['String']>;
  fileMimetype?: Maybe<Scalars['String']>;
  /** 파일 용량 in bytes */
  fileSize?: Maybe<Scalars['Float']>;
  /** 파일 변환 상태 */
  status?: Maybe<CapaFileConvertStatus>;
  /** old File System id */
  oldFileId?: Maybe<Scalars['String']>;
};

/** 도면 파일 변환 처리 상태 */
export enum CapaFileConvertStatus {
  /** 변환요청 */
  Processing = 'PROCESSING',
  /** 큐등록 */
  Queued = 'QUEUED',
  /** 변환중 */
  Converting = 'CONVERTING',
  /** 변환완료 */
  Converted = 'CONVERTED',
  /** 변환실패 */
  Failed = 'FAILED'
}

export type CapaFileStatus = {
  __typename?: 'CAPAFileStatus';
  fileId: Scalars['ID'];
  /** 파일 변환 상태 */
  status?: Maybe<CapaFileConvertStatus>;
};

export type CapaFileStatusOutput = {
  __typename?: 'CAPAFileStatusOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaFileStatus>;
};

/** CAPAFilterableServiceType */
export type CapaFilterableServiceType = {
  cnc?: InputMaybe<CapaServiceTypeDetailFilter>;
  printing?: InputMaybe<CapaServiceTypeDetailFilter>;
  sheetMetal?: InputMaybe<CapaServiceTypeDetailFilter>;
  inj?: InputMaybe<CapaServiceTypeDetailFilter>;
  casting?: InputMaybe<CapaServiceTypeDetailFilter>;
  mechanicalDesign?: InputMaybe<CapaServiceTypeDetailFilter>;
  productDesign?: InputMaybe<CapaServiceTypeDetailFilter>;
  design?: InputMaybe<CapaServiceTypeDetailFilter>;
  pcb?: InputMaybe<CapaServiceTypeDetailFilter>;
};

/** 캐파 견적 파트너가 보는 채팅방룸 */
export type CapaInProgressQuotationPartnerChatRoom = {
  __typename?: 'CAPAInProgressQuotationPartnerChatRoom';
  organizationName?: Maybe<Scalars['String']>;
  quotationUserStatus: CapaQuotationUserStatus;
  managerName?: Maybe<Scalars['String']>;
  projectName: Scalars['String'];
  rfqId: Scalars['String'];
  chatRoomId: Scalars['String'];
  quotaionUserId: Scalars['String'];
  chatRoomStatus: CapaQuotationChatRoomStatus;
  createdAt?: Maybe<Scalars['String']>;
  serviceType: CapaQuotationServiceType;
  /** 수량 */
  quantity?: Maybe<Scalars['Float']>;
  /** detailedServiceType */
  detailedServiceType?: Maybe<Array<CapaQuotationDetailedServiceType>>;
  thumbnailId?: Maybe<Scalars['String']>;
  status: CapaRfqConsultingChatStatusType;
};

export type CapaInProgressQuotationPartnerChatRooms = {
  __typename?: 'CAPAInProgressQuotationPartnerChatRooms';
  count: Scalars['Float'];
  chatRooms?: Maybe<Array<CapaInProgressQuotationPartnerChatRoom>>;
};

/** 캐파 견적 파트너가 보는 채팅방 chatRooms Output */
export type CapaInProgressQuotationPartnerChatRoomsOutput = {
  __typename?: 'CAPAInProgressQuotationPartnerChatRoomsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaInProgressQuotationPartnerChatRooms>;
};

/** 유입경로 */
export enum CapaInflowRoute {
  /** SNS 광고(인스타, 페이스북 등) */
  Sns = 'SNS',
  /** 인터넷 검색 */
  Internet = 'INTERNET',
  /** 크리에이터블 홈페이지 및 블로그 */
  Creatable = 'CREATABLE',
  /** 지인 및 기관 추천 */
  Recommendation = 'RECOMMENDATION',
  /** 홍보 기사 */
  Article = 'ARTICLE',
  /** 이메일 광고 */
  Email = 'EMAIL',
  /** 전화 광고 */
  Phone = 'PHONE',
  /** 문자 광고 */
  Sms = 'SMS',
  /** 카페 등 커뮤니티 */
  Community = 'COMMUNITY',
  /** 오프라인 영업 */
  Offline = 'OFFLINE',
  /** 지면 광고 (우편, 브로셔 등) */
  Paper = 'PAPER',
  /** 서비스설명회 (온라인포함) */
  Presentation = 'PRESENTATION',
  /** 인터넷 광고(구글/네이버 등/0 */
  InternetAdd = 'INTERNET_ADD',
  /** 카파 블로그 */
  CapaBlog = 'CAPA_BLOG',
  /** 언론 보도 */
  MediaReport = 'MEDIA_REPORT',
  /** 우편물 */
  Dm = 'DM',
  /** 홍보 현수막 */
  Placard = 'PLACARD',
  /** 기타 */
  Etc = 'ETC'
}

/** ITP 이벤트 신청 목록 BO */
export type CapaItpEventBo = {
  __typename?: 'CAPAItpEventBO';
  /** ITP 이벤트 아이디 */
  id?: Maybe<Scalars['ID']>;
  /** ITP RFQ 프로젝트 이름 */
  projectName?: Maybe<Scalars['String']>;
  /** ITP RFQ QUOTATION USER 아이디 */
  quotationUserId?: Maybe<Scalars['String']>;
  /** ITP RFQ QUOTATION USER 고객 이름 */
  quotationUserName?: Maybe<Scalars['String']>;
  /** ITP RFQ 매칭 파트너 이름 */
  quotationPartnerOrganizationName?: Maybe<Scalars['String']>;
  /** ITP RFQ 거래 완료 금액 */
  completeCost?: Maybe<Scalars['String']>;
  /** ITP 이벤트 증빙자료 */
  files?: Maybe<Array<CapaFile>>;
  /** ITP RFQ 고객 이메일 */
  email?: Maybe<Scalars['String']>;
  /** ITP RFQ 고객 전화번호 */
  cellphoneNumber?: Maybe<Scalars['String']>;
  /** ITP 이벤트 신청 승인 날짜 */
  approvedAt?: Maybe<Scalars['String']>;
  /** ITP 이벤트 신청 승인 BO 아이디 */
  approvedById?: Maybe<Scalars['String']>;
  /** ITP 이벤트 신청 승인 BO 이름 */
  approvedByName?: Maybe<Scalars['String']>;
  /** ITP 이벤트 officecon에 보낸 날짜 */
  sentAt?: Maybe<Scalars['String']>;
  /** ITP 이벤트 신청 승인 BO 아이디 */
  sentById?: Maybe<Scalars['String']>;
  /** ITP 이벤트 신청 승인 BO 이름 */
  sentByName?: Maybe<Scalars['String']>;
};

/** ITP 이벤트 증빙용 파일 */
export type CapaItpEventFile = {
  __typename?: 'CAPAItpEventFile';
  /** ITP 이벤트 증빙 파일 아이디 */
  fileId?: Maybe<Scalars['ID']>;
  /** 파일 이름 */
  fileName?: Maybe<Scalars['String']>;
};

/** ITP 이벤트 목록 표출 종류 */
export enum CapaItpEventListTypeEnum {
  /** 전체 목록 표출 */
  All = 'ALL',
  /** 확인전 목록 표출 */
  Ready = 'READY',
  /** 승인 ITP 이벤트 신청 목록 표출 */
  Approved = 'APPROVED',
  /** 거절 ITP 이벤트 신청 목록 표출 */
  Reject = 'REJECT',
  /** 전송완료 ITP 이벤트 신청 목록 표출 */
  Sent = 'SENT'
}

/** ITP 이벤트 신청 목록 BO */
export type CapaItpEventXlsxDownload = {
  __typename?: 'CAPAItpEventXlsxDownload';
  /** ITP 이벤트 아이디 */
  id?: Maybe<Scalars['ID']>;
  /** ITP RFQ 고객 이메일 */
  email?: Maybe<Scalars['String']>;
  /** ITP RFQ 고객 전화번호 */
  cellphoneNumber?: Maybe<Scalars['String']>;
};

export type CapaItpEventsBoOutput = {
  __typename?: 'CAPAItpEventsBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaItpEventBo>>;
};

/** Jsb 이벤트 신청 목록 BO */
export type CapaJsbEventBo = {
  __typename?: 'CAPAJsbEventBO';
  /** Jsb 이벤트 아이디 */
  id?: Maybe<Scalars['ID']>;
  /** Jsb RFQ 프로젝트 이름 */
  projectName?: Maybe<Scalars['String']>;
  /** Jsb RFQ QUOTATION USER 아이디 */
  quotationUserId?: Maybe<Scalars['String']>;
  /** Jsb RFQ QUOTATION USER 고객 이름 */
  quotationUserName?: Maybe<Scalars['String']>;
  /** Jsb RFQ 매칭 파트너 이름 */
  quotationPartnerOrganizationName?: Maybe<Scalars['String']>;
  /** Jsb RFQ 거래 완료 금액 */
  completeCost?: Maybe<Scalars['String']>;
  /** Jsb 은행 */
  bank?: Maybe<Scalars['String']>;
  /** Jsb 계좌 */
  account?: Maybe<Scalars['String']>;
  /** Jsb 이벤트 증빙자료 */
  files?: Maybe<Array<CapaFile>>;
  /** Jsb RFQ 고객 이메일 */
  email?: Maybe<Scalars['String']>;
  /** Jsb RFQ 고객 전화번호 */
  cellphoneNumber?: Maybe<Scalars['String']>;
  /** Jsb 이벤트 신청 승인 날짜 */
  approvedAt?: Maybe<Scalars['String']>;
  /** Jsb 이벤트 신청 승인 BO 아이디 */
  approvedById?: Maybe<Scalars['String']>;
  /** Jsb 이벤트 신청 승인 BO 이름 */
  approvedByName?: Maybe<Scalars['String']>;
};

/** JSB 이벤트 증빙용 파일 */
export type CapaJsbEventFile = {
  __typename?: 'CAPAJsbEventFile';
  /** JSB 이벤트 증빙 파일 아이디 */
  fileId?: Maybe<Scalars['ID']>;
  /** 파일 이름 */
  fileName?: Maybe<Scalars['String']>;
};

/** JSB 이벤트 목록 표출 종류 */
export enum CapaJsbEventListTypeEnum {
  /** 전체 목록 표출 */
  All = 'ALL',
  /** 확인전 목록 표출 */
  Ready = 'READY',
  /** 승인 JSB 이벤트 신청 목록 표출 */
  Approved = 'APPROVED',
  /** 거절 JSB 이벤트 신청 목록 표출 */
  Reject = 'REJECT'
}

/** JSB 이벤트 신청 목록 BO */
export type CapaJsbEventXlsxDownload = {
  __typename?: 'CAPAJsbEventXlsxDownload';
  /** JSB 이벤트 아이디 */
  id?: Maybe<Scalars['ID']>;
  /** JSB RFQ 고객 이메일 */
  email?: Maybe<Scalars['String']>;
  /** JSB RFQ 고객 전화번호 */
  cellphoneNumber?: Maybe<Scalars['String']>;
  /** JSB RFQ 고객 은행 */
  bank?: Maybe<Scalars['String']>;
  /** JSB RFQ 고객 계좌 */
  account?: Maybe<Scalars['String']>;
};

export type CapaJsbEventsBoOutput = {
  __typename?: 'CAPAJsbEventsBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaJsbEventBo>>;
};

/** 내드리이브 */
export type CapaMyDrive = {
  __typename?: 'CAPAMyDrive';
  /** 파일 ID */
  fileId: Scalars['ID'];
  /** 파일명 */
  fileName: Scalars['String'];
  /** 파일크기 byte */
  fileSize: Scalars['Float'];
  /** 파일 변환 상태 */
  status?: Maybe<CapaFileConvertStatus>;
  /** 썸네일 */
  thumbnails?: Maybe<Scalars['String']>;
  /** 도면 파일 뷰어 URL */
  viewerUrl?: Maybe<Scalars['String']>;
  /**
   * Legacy 파일 ID
   * @deprecated Legacy
   */
  oldFileId?: Maybe<Scalars['String']>;
  /** 생성일 (업로드 일시) */
  createdAt: Scalars['String'];
  /** 수정일 */
  updatedAt: Scalars['String'];
};

/** 내드리이브 */
export type CapaMyDrivesOutput = {
  __typename?: 'CAPAMyDrivesOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaMyDrive>>;
};

export type CapaNewChatMessage = {
  __typename?: 'CAPANewChatMessage';
  id?: Maybe<Scalars['ID']>;
};

export type CapaNotification = {
  __typename?: 'CAPANotification';
  seq: Scalars['Float'];
  serviceType: CapaServiceType;
  data?: Maybe<CapaNotificationUnion>;
  read?: Maybe<Scalars['Boolean']>;
  /** 생성일 (업로드 일시) */
  createdAt: Scalars['String'];
};

export type CapaNotificationConnect = {
  __typename?: 'CAPANotificationConnect';
  notificationType: CapaNotificationType;
  groupId?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  chatRoomId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  groupUserId?: Maybe<Scalars['String']>;
  accessLevel?: Maybe<CapaConnectGroupAccessLevel>;
  fileName?: Maybe<Scalars['String']>;
  connectFileId?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  oldGroupName?: Maybe<Scalars['String']>;
  annotationId?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['String']>;
  toBeShown?: Maybe<Scalars['String']>;
};

export type CapaNotificationDefault = {
  __typename?: 'CAPANotificationDefault';
  notificationType: CapaNotificationType;
  chatRoomId?: Maybe<Scalars['String']>;
};

export type CapaNotificationRfq = {
  __typename?: 'CAPANotificationRfq';
  notificationType: CapaNotificationType;
  serviceType?: Maybe<CapaQuotationServiceType>;
  rfqId?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  adjustRequest?: Maybe<Scalars['String']>;
  totalAmount?: Maybe<Scalars['String']>;
  managerName?: Maybe<Scalars['String']>;
  chatRoomId?: Maybe<Scalars['String']>;
  /** 환불 금액 */
  refundAmt?: Maybe<Scalars['Float']>;
  /** 정산 완료 금액 */
  depositAmt?: Maybe<Scalars['Float']>;
  /** 예상 지급승인(구매확정)날짜  */
  expectedConfirmPurchaseDate?: Maybe<Scalars['DateTime']>;
};

export enum CapaNotificationType {
  AllowRequest = 'ALLOW_REQUEST',
  AllowResponse = 'ALLOW_RESPONSE',
  Announcement = 'ANNOUNCEMENT',
  EventInvitation = 'EVENT_INVITATION',
  EventRfqConfirm = 'EVENT_RFQ_CONFIRM',
  ItpEventRequestAvailable = 'ITP_EVENT_REQUEST_AVAILABLE',
  RfqComplete = 'RFQ_COMPLETE',
  RfqCompleteRequest = 'RFQ_COMPLETE_REQUEST',
  RfqConfirm = 'RFQ_CONFIRM',
  RfqConfirmRequest = 'RFQ_CONFIRM_REQUEST',
  RfqExpiration = 'RFQ_EXPIRATION',
  RfqExpirationConfirm = 'RFQ_EXPIRATION_CONFIRM',
  RfqExpirationClient = 'RFQ_EXPIRATION_CLIENT',
  RfqExpirationWarning = 'RFQ_EXPIRATION_WARNING',
  RfqRegistered = 'RFQ_REGISTERED',
  RfqReviewDone = 'RFQ_REVIEW_DONE',
  RfqReviewReplyDone = 'RFQ_REVIEW_REPLY_DONE',
  RfqDownloadAccess = 'RFQ_DOWNLOAD_ACCESS',
  RfqDownloadGranted = 'RFQ_DOWNLOAD_GRANTED',
  RfqAdjustQuotation = 'RFQ_ADJUST_QUOTATION',
  RfqPurchaseOrder = 'RFQ_PURCHASE_ORDER',
  RfqRequestQuotation = 'RFQ_REQUEST_QUOTATION',
  QuotationChatRoomStatusOpen = 'QUOTATION_CHAT_ROOM_STATUS_OPEN',
  QuotationChatMessage = 'QUOTATION_CHAT_MESSAGE',
  StampEvent = 'STAMP_EVENT',
  StampInvitationEvent = 'STAMP_INVITATION_EVENT',
  StampWelcomeEvent = 'STAMP_WELCOME_EVENT',
  ConnectInviteUser = 'CONNECT_INVITE_USER',
  ConnectLeaveGroup = 'CONNECT_LEAVE_GROUP',
  ConnectChangeGroupName = 'CONNECT_CHANGE_GROUP_NAME',
  ConnectAccessChange = 'CONNECT_ACCESS_CHANGE',
  ConnectRemoveFromGroup = 'CONNECT_REMOVE_FROM_GROUP',
  ConnectDeleteGroup = 'CONNECT_DELETE_GROUP',
  ConnectDownloadAccess = 'CONNECT_DOWNLOAD_ACCESS',
  ConnectDownloadGranted = 'CONNECT_DOWNLOAD_GRANTED',
  ConnectFileShared = 'CONNECT_FILE_SHARED',
  ConnectAnnotationComment = 'CONNECT_ANNOTATION_COMMENT',
  ConnectNewChat = 'CONNECT_NEW_CHAT',
  PurchaseOrderRegisterRequest = 'PURCHASE_ORDER_REGISTER_REQUEST',
  AwaitingPayment = 'AWAITING_PAYMENT',
  NotPaidCanceled = 'NOT_PAID_CANCELED',
  RejectRfqPurchaseOrderVirtualAccount = 'REJECT_RFQ_PURCHASE_ORDER_VIRTUAL_ACCOUNT',
  RejectRfqPurchaseOrderCreditCard = 'REJECT_RFQ_PURCHASE_ORDER_CREDIT_CARD',
  CancelConfirmedVirtualAccount = 'CANCEL_CONFIRMED_VIRTUAL_ACCOUNT',
  CancelConfirmedCreditCard = 'CANCEL_CONFIRMED_CREDIT_CARD',
  RefundConfirmedVirtualAccount = 'REFUND_CONFIRMED_VIRTUAL_ACCOUNT',
  RefundConfirmedCreditCard = 'REFUND_CONFIRMED_CREDIT_CARD',
  InduceConfirmPurchase = 'INDUCE_CONFIRM_PURCHASE',
  ApprovedPayment = 'APPROVED_PAYMENT',
  CancelRequested = 'CANCEL_REQUESTED',
  CancelConfirmed = 'CANCEL_CONFIRMED',
  RefundRequested = 'REFUND_REQUESTED',
  RefundConfirmed = 'REFUND_CONFIRMED',
  DelayedConfirmPurchase = 'DELAYED_CONFIRM_PURCHASE',
  StartProcessing = 'START_PROCESSING',
  StartShipping = 'START_SHIPPING',
  PurchaseConfirmed = 'PURCHASE_CONFIRMED'
}

export type CapaNotificationUnion =
  | CapaNotificationDefault
  | CapaNotificationRfq
  | CapaNotificationConnect;

export type CapaNotifications = {
  __typename?: 'CAPANotifications';
  count: Scalars['Float'];
  notifications: Array<CapaNotification>;
};

export type CapaNotificationsOutput = {
  __typename?: 'CAPANotificationsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaNotifications>;
};

/** Payment PG providers */
export enum CapapgProviders {
  Nicepay = 'NICEPAY',
  TestMock = 'TEST_MOCK'
}

export type CapaPartnerBo = {
  __typename?: 'CAPAPartnerBO';
  id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  capabilities?: Maybe<CapaQuotationPartnerCapability>;
  managerName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  contact?: Maybe<Scalars['String']>;
  registrationFileId?: Maybe<Scalars['String']>;
  consultingCount?: Maybe<Scalars['Float']>;
  /** 견적서로 제안 수 */
  quotationSuggestionCount?: Maybe<Scalars['Float']>;
  /** 소개서로 제안 수 */
  introductionSuggestionCount?: Maybe<Scalars['Float']>;
  /** 견적 수 = 상담 시작 방식 및 상담 진행 여부 상관 없이 견적서 1회 이상 발송한 프로젝트 수 */
  rfqReceivedQuotationCount?: Maybe<Scalars['Float']>;
  /** 안전 결제 수 */
  paymentCount?: Maybe<Scalars['Float']>;
  lastLoginAt?: Maybe<Scalars['String']>;
  quotationPartnerStatus?: Maybe<CapaQuotationPartnerStatus>;
  submallStatus?: Maybe<CapaSubmallStatus>;
  route?: Maybe<Array<CapaInflowRoute>>;
  /** 추천 기관명/회사명 */
  referralCompany?: Maybe<Scalars['String']>;
};

export type CapaPartnersAndCount = {
  __typename?: 'CAPAPartnersAndCount';
  partners?: Maybe<Array<CapaPartnerBo>>;
  count?: Maybe<Scalars['Float']>;
};

export type CapaPartnersBoOutput = {
  __typename?: 'CAPAPartnersBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaPartnersAndCount>;
  count?: Maybe<Scalars['Float']>;
};

export type CapaPaymentAccountHolderModel = {
  __typename?: 'CAPAPaymentAccountHolderModel';
  /** 예금주 */
  accountHolder?: Maybe<Scalars['String']>;
};

/** 결제 취소 status */
export enum CapaPaymentCancelStatus {
  /** 가상계좌 미입금 취소 */
  NotPaidCanceled = 'NOT_PAID_CANCELED',
  /** 결제 취소 요청 */
  CancelRequested = 'CANCEL_REQUESTED',
  /** 결제 취소 완료 */
  CancelConfirmed = 'CANCEL_CONFIRMED',
  /** 발주서 거부로 인한 결제 취소 */
  RejectOrderByPartner = 'REJECT_ORDER_BY_PARTNER',
  /** 환불 요청 (파트너 승인 전) */
  RefundRequested = 'REFUND_REQUESTED',
  /** 환불 승인 (파트너 승인은 완료되었지만, 실제로 고객에게 아직 환불 이루어지지 않은 경우) */
  RefundConfirmed = 'REFUND_CONFIRMED',
  /** BO 취소 승인 통보 */
  CancelConfirmedBo = 'CANCEL_CONFIRMED_BO',
  /** BO 환불 승인 통보 */
  RefundConfirmedBo = 'REFUND_CONFIRMED_BO',
  /** BO 계속 진행 통보 */
  NotifyProgressBo = 'NOTIFY_PROGRESS_BO',
  /** 결제 취소 실패 */
  Failed = 'FAILED'
}

export type CapaPaymentCardInfo = {
  __typename?: 'CAPAPaymentCardInfo';
  /** 카드사 코드번호(금융결제원 표준코드번호) */
  cardCode: Scalars['String'];
  /** 카드사 명칭 - (신용카드 결제 건의 경우) */
  cardName: Scalars['String'];
  /** 할부개월 수(0이면 일시불) */
  cardQuota: Scalars['Float'];
  /** 결제에 사용된 마스킹된 카드번호. 7~12번째 자리를 마스킹하는 것이 일반적이지만, PG사의 정책/설정에 따라 다소 차이가 있을 수 있음 */
  cardNumber?: Maybe<Scalars['String']>;
  /** 카드유형 */
  cardType: Scalars['Float'];
};

export type CapaPaymentFetchDepositModel = {
  __typename?: 'CAPAPaymentFetchDepositModel';
  transactionIds: Array<Scalars['String']>;
};

export enum CapaPaymentMethodType {
  /** 신용카드 */
  CreditCard = 'CREDIT_CARD',
  /** 가상계좌 */
  VirtualAccount = 'VIRTUAL_ACCOUNT',
  /** 포인트 */
  Point = 'POINT'
}

/** Payment status */
export enum CapaPaymentStatus {
  /** 결제 대기(가상계좌 발급 후 입금 대기, 소액결제) */
  Ready = 'READY',
  /** 결제완료(신용계좌 결제 완료, 가상계좌 입금 완료) */
  Paid = 'PAID',
  /** 배송지 등록 완료 - 실제 api */
  Delivered = 'DELIVERED',
  PurchaseConfirmed = 'PURCHASE_CONFIRMED',
  /** 정산 완료 */
  Settled = 'SETTLED',
  /** 나이스페이 콘솔에서 취소 */
  Cancelled = 'CANCELLED',
  /** 뭔가 좋지 않을 일... ex) 가상계좌를 발급했지만, 입금을 하지 않아 실패 처리되는 경우 */
  Failed = 'FAILED',
  /** 취소 실패 (파트너의 승인아래 환불하고자 했는데, 실패하는 경우) */
  CancelFailed = 'CANCEL_FAILED',
  /** 환불 성공 */
  Refunded = 'REFUNDED',
  /** 지급 대기중  */
  PayoutPending = 'PAYOUT_PENDING',
  /** 지급 대행 완료 */
  PayoutCompleted = 'PAYOUT_COMPLETED',
  /** 고객에게 포인트 지급 완료 */
  PayoutPointCompleted = 'PAYOUT_POINT_COMPLETED'
}

export type CapaPcbDetail = {
  __typename?: 'CAPAPcbDetail';
  /** 요청 작업 */
  services?: Maybe<Array<CapaPcbService>>;
  /** 제작 파일 */
  fabricationFiles?: Maybe<Array<CapaQuotationRfqFabricationFile>>;
  /** 조립 파일 */
  assemblyFiles?: Maybe<Array<CapaQuotationRfqAssemblyFile>>;
  /** 제작 수량 */
  fabricationQuantity?: Maybe<Scalars['Float']>;
  /** 조립 수량 */
  assemblyQuantity?: Maybe<Scalars['Float']>;
  /** 조립 방식 */
  assemblyMethod?: Maybe<Array<CapaRfqPcbassemblyMethod>>;
  /** 메탈마스크 제공 여부 */
  metalMaskAvailablity?: Maybe<Scalars['Boolean']>;
  /** 자재 방법 */
  materialSupplyMethod?: Maybe<CapaRfqPcbMaterialSupplyMethodType>;
};

export type CapaPcbService = {
  __typename?: 'CAPAPcbService';
  serviceType?: Maybe<CapaPcbServiceType>;
};

/** pcb service type */
export enum CapaPcbServiceType {
  /** 설계 */
  CircuitDesign = 'CIRCUIT_DESIGN',
  /** 제작 */
  CircuitFabrication = 'CIRCUIT_FABRICATION',
  /** 조립 */
  CircuitAssembly = 'CIRCUIT_ASSEMBLY'
}

export type CapaProjectManagementReceivedQuotation = {
  __typename?: 'CAPAProjectManagementReceivedQuotation';
  rfqId?: Maybe<Scalars['String']>;
  quotationId?: Maybe<Scalars['String']>;
  quotationType?: Maybe<CapaRfqQuotationType>;
  partnerId?: Maybe<Scalars['String']>;
  quotationPartnerStatus: CapaQuotationPartnerStatus;
  chatRoomId?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  confirmCount?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  deliveryCost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
  isAdjusted?: Maybe<Scalars['Boolean']>;
};

export type CapaProjectManagementReceivedQuotationOutput = {
  __typename?: 'CAPAProjectManagementReceivedQuotationOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaProjectManagementReceivedQuotation>>;
};

/** equipmentRfqfilter 정보 입력 */
export type CapaPromotionLinkInput = {
  capaBlogLink: Scalars['String'];
};

export type CapaPromotionModel = {
  __typename?: 'CAPAPromotionModel';
  id?: Maybe<Scalars['String']>;
  quotationPartnerId: Scalars['String'];
  capaBlogLink: Scalars['String'];
  status: CapaPromotionStatus;
};

export enum CapaPromotionStatus {
  Registered = 'REGISTERED',
  Deleted = 'DELETED'
}

/** CAPAPurchaseOrderModel */
export type CapaPurchaseOrderModel = {
  __typename?: 'CAPAPurchaseOrderModel';
  purchaseOrderId?: Maybe<Scalars['String']>;
  purchaseOrderStatus: CapaPurchaseOrderStatus;
  partnerOrganizationName?: Maybe<Scalars['String']>;
  partnerManagerName?: Maybe<Scalars['String']>;
  partnerFullAddress?: Maybe<Scalars['String']>;
  partnerLogoFileId?: Maybe<Scalars['String']>;
  clientOrganizationName?: Maybe<Scalars['String']>;
  clientFullAddress?: Maybe<Scalars['String']>;
  clientLogoFileId?: Maybe<Scalars['String']>;
  clientManagerName?: Maybe<Scalars['String']>;
  /** 기획에서 해당 enum과 같이 요청하는 태그 표현 */
  projectPurchaseOrderManageStatusType?: Maybe<
    ProjectPurchaseOrderManageStatusType
  >;
  paymentManageModelList?: Maybe<Array<CapaQuotationPaymentManageModel>>;
  /** rfq 생성일 */
  rfqCreatedAt?: Maybe<Scalars['String']>;
  /** rfq 서비스 */
  serviceType: CapaQuotationServiceType;
  /** rfq 프로젝트 이름 */
  projectName?: Maybe<Scalars['String']>;
  /** 제조 수량 */
  quantity?: Maybe<Scalars['Float']>;
};

/** CAPA PURCHASE ORDER STATUS */
export enum CapaPurchaseOrderStatus {
  /** 결제 도입 전 발주서 */
  Created = 'CREATED',
  /** 결제대기(가상계좌 발급 후 입금 대기, 소액결제) */
  ProcessPayment = 'PROCESS_PAYMENT',
  /** 결제완료(신용계좌 결제 완료, 가상계좌 입금 완료) */
  Paid = 'PAID',
  /** 가상계좌 미입금 취소 */
  NotPaidCanceled = 'NOT_PAID_CANCELED',
  /** 제조중 */
  Processing = 'PROCESSING',
  /** 배송중, capa에서 취급하는 배송중 */
  Shipping = 'SHIPPING',
  /** 구매확정 */
  PurchaseConfirmed = 'PURCHASE_CONFIRMED',
  /** 취소 요청 (제조시작 전) */
  CancelRequested = 'CANCEL_REQUESTED',
  /** 취소 확정 (제조시작 전) */
  CancelConfirmed = 'CANCEL_CONFIRMED',
  /** 환불요청 (제조시작 후) */
  RefundRequested = 'REFUND_REQUESTED',
  /** 파트너와 고객 양방 승인하에 환불확정 (제조시작 후) */
  RefundConfirmed = 'REFUND_CONFIRMED',
  /** 파트너 일방 환불 (제조시작 전) */
  RejectOrderByPartner = 'REJECT_ORDER_BY_PARTNER',
  /** 관리자 콘솔에서 취소 */
  CancelledByAdmin = 'CANCELLED_BY_ADMIN',
  /** 발주서가 처음에 생성되었을때 가지는 기본값.백엔드 내부에서 사용되는 상태값으로, 유저에게는 해당 상태를 가진 발주서가 노출되지 않습니다. */
  PaymentFailed = 'PAYMENT_FAILED'
}

export type CapaQuotatationAnnotation = {
  __typename?: 'CAPAQuotatationAnnotation';
  id?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  chatRoomId?: Maybe<Scalars['String']>;
  quotationSharedFileId?: Maybe<Scalars['String']>;
  anchorPos?: Maybe<Capa3DPos>;
  handlePos?: Maybe<Capa3DPos>;
  nodeId?: Maybe<Scalars['Float']>;
  comments?: Maybe<Array<CapaQuotationAnnotationComment>>;
  isNew?: Maybe<Scalars['Boolean']>;
  status?: Maybe<CapaQuotationSharedFileAnnotationStatus>;
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type CapaQuotationActivity = {
  __typename?: 'CAPAQuotationActivity';
  confirmed?: Maybe<Scalars['Float']>;
  complete?: Maybe<Scalars['Float']>;
  reviewed?: Maybe<Scalars['Float']>;
};

export type CapaQuotationActivityOutput = {
  __typename?: 'CAPAQuotationActivityOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationActivity>;
};

export type CapaQuotationAnnotationComment = {
  __typename?: 'CAPAQuotationAnnotationComment';
  /** commentId */
  id?: Maybe<Scalars['String']>;
  /** annotationId */
  annotationId?: Maybe<Scalars['String']>;
  /** capaFileId */
  fileId?: Maybe<Scalars['String']>;
  edited?: Maybe<Scalars['Boolean']>;
  status?: Maybe<CapaQuotationSharedFileAnnotationStatus>;
  userId?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  isParent?: Maybe<Scalars['Boolean']>;
  userName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type CapaQuotationAnnotationCommentMessage = {
  __typename?: 'CAPAQuotationAnnotationCommentMessage';
  messageType: CapaQuotationChatMessageType;
  annotation?: Maybe<CapaQuotationAnnotationComment>;
};

export type CapaQuotationAnnotationOutput = {
  __typename?: 'CAPAQuotationAnnotationOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotatationAnnotation>;
};

export type CapaQuotationBypassMessage = {
  __typename?: 'CAPAQuotationBypassMessage';
  messageType: CapaQuotationChatMessageType;
  bypass?: Maybe<CapaQuotationBypassSendMessageTemplateModel>;
};

export type CapaQuotationBypassMessageDeleteMessage = {
  __typename?: 'CAPAQuotationBypassMessageDeleteMessage';
  messageType: CapaQuotationChatMessageType;
  /** chat room message id */
  id?: Maybe<Scalars['String']>;
};

export type CapaQuotationBypassSendMessageTemplateModel = {
  __typename?: 'CAPAQuotationBypassSendMessageTemplateModel';
  /** chat room message id */
  id?: Maybe<Scalars['String']>;
};

/** Capability 정보 입력 */
export type CapaQuotationCapabilityInput = {
  /** 캐파 견적 서비스 정보 입력 */
  services?: InputMaybe<Array<CapaQuotationServiceInput>>;
};

/** capability notification filter */
export type CapaQuotationCapabilityNotificationFilter = {
  __typename?: 'CAPAQuotationCapabilityNotificationFilter';
  email?: Maybe<Scalars['Boolean']>;
  sms?: Maybe<Scalars['Boolean']>;
  push?: Maybe<Scalars['Boolean']>;
  service?: Maybe<CapaQuotationServiceType>;
  detailedServices?: Maybe<Array<CapaQuotationDetailedServiceType>>;
  optionalServices?: Maybe<Array<CapaQuotationServiceType>>;
};

/** rfq notification for selected capability */
export type CapaQuotationCapabilityNotificationFilterInput = {
  /** 이메일 수신 여부 */
  email?: InputMaybe<Scalars['Boolean']>;
  /** 카카오 (실패시 SMS) 수신 여부 */
  sms?: InputMaybe<Scalars['Boolean']>;
  /** Push Notification 수신 여부 */
  push?: InputMaybe<Scalars['Boolean']>;
  service?: InputMaybe<CapaQuotationServiceType>;
  detailedServices?: InputMaybe<Array<CapaQuotationDetailedServiceType>>;
  optionalServices?: InputMaybe<Array<CapaQuotationServiceType>>;
};

export type CapaQuotationChatFile = {
  __typename?: 'CAPAQuotationChatFile';
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileSize?: Maybe<Scalars['Float']>;
};

export type CapaQuotationChatMessage = {
  __typename?: 'CAPAQuotationChatMessage';
  id?: Maybe<Scalars['ID']>;
  senderId?: Maybe<Scalars['String']>;
  senderUserType?: Maybe<CapaQuotationUserType>;
  organizationName?: Maybe<Scalars['String']>;
  managerName?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
  message?: Maybe<CapaQuotationChatMessageUnion>;
  /** 안읽은수 */
  unReadCount?: Maybe<Scalars['Float']>;
  chatFiles?: Maybe<Array<CapaQuotationChatFile>>;
  /** 생성일 */
  createdAt?: Maybe<Scalars['String']>;
  /** 상태값 */
  status?: Maybe<Scalars['String']>;
};

export type CapaQuotationChatMessageDetailedQuotation = {
  __typename?: 'CAPAQuotationChatMessageDetailedQuotation';
  messageType: CapaQuotationChatMessageType;
  quotation?: Maybe<CapaQuotationDetailedQuotation>;
};

export type CapaQuotationChatMessageMessage = {
  __typename?: 'CAPAQuotationChatMessageMessage';
  messageType: CapaQuotationChatMessageType;
  message?: Maybe<Scalars['String']>;
};

export type CapaQuotationChatMessageRfq = {
  __typename?: 'CAPAQuotationChatMessageRfq';
  messageType: CapaQuotationChatMessageType;
  rfq?: Maybe<CapaQuotationChatRfq>;
};

export type CapaQuotationChatMessageSimpleQuotation = {
  __typename?: 'CAPAQuotationChatMessageSimpleQuotation';
  messageType: CapaQuotationChatMessageType;
  quotation?: Maybe<CapaQuotationSimpleQuotation>;
};

export enum CapaQuotationChatMessageType {
  AllowRequest = 'ALLOW_REQUEST',
  AllowResponse = 'ALLOW_RESPONSE',
  CompleteRequest = 'COMPLETE_REQUEST',
  ConfirmRequest = 'CONFIRM_REQUEST',
  DateDivider = 'DATE_DIVIDER',
  SimpleQuotation = 'SIMPLE_QUOTATION',
  DetailedQuotation = 'DETAILED_QUOTATION',
  RfqComplete = 'RFQ_COMPLETE',
  RfqStopped = 'RFQ_STOPPED',
  RfqConfirm = 'RFQ_CONFIRM',
  RfqExpirationConfirm = 'RFQ_EXPIRATION_CONFIRM',
  QuitChatroomPartner = 'QUIT_CHATROOM_PARTNER',
  QuitChatroomClient = 'QUIT_CHATROOM_CLIENT',
  ChatStart = 'CHAT_START',
  System = 'SYSTEM',
  Message = 'MESSAGE',
  QuotationConsultingStart = 'QUOTATION_CONSULTING_START',
  IntroductionConsultingStart = 'INTRODUCTION_CONSULTING_START',
  QuotationCreated = 'QUOTATION_CREATED',
  QuotationAdjustRequest = 'QUOTATION_ADJUST_REQUEST',
  AdjustedQuotation = 'ADJUSTED_QUOTATION',
  QuotationAgreement = 'QUOTATION_AGREEMENT',
  PurchaseOrderConsultingStart = 'PURCHASE_ORDER_CONSULTING_START',
  PurchaseOrderCreated = 'PURCHASE_ORDER_CREATED',
  PurchaseOrderAdjustRequest = 'PURCHASE_ORDER_ADJUST_REQUEST',
  AdjustedPurchaseOrder = 'ADJUSTED_PURCHASE_ORDER',
  PurchaseOrderAgreement = 'PURCHASE_ORDER_AGREEMENT',
  RfqQuotationRegisterRequest = 'RFQ_QUOTATION_REGISTER_REQUEST',
  PurchaseOrderRegisterRequest = 'PURCHASE_ORDER_REGISTER_REQUEST',
  Withdraw = 'WITHDRAW',
  InduceQuotationRequest = 'INDUCE_QUOTATION_REQUEST',
  InducePurchaseOrderIssue = 'INDUCE_PURCHASE_ORDER_ISSUE',
  RejectRfqPurchaseOrder = 'REJECT_RFQ_PURCHASE_ORDER',
  QuotationAnnotationComment = 'QUOTATION_ANNOTATION_COMMENT',
  QuotationAnnotationReComment = 'QUOTATION_ANNOTATION_RE_COMMENT',
  BypassPrevention = 'BYPASS_PREVENTION',
  Deleted = 'DELETED',
  BypassDeleted = 'BYPASS_DELETED',
  InduceRegisterTransactionReview = 'INDUCE_REGISTER_TRANSACTION_REVIEW',
  RequestRegisterTransactionReview = 'REQUEST_REGISTER_TRANSACTION_REVIEW',
  InduceRequestRegisterTransactionReview = 'INDUCE_REQUEST_REGISTER_TRANSACTION_REVIEW',
  AwaitingPayment = 'AWAITING_PAYMENT',
  ApprovedPayment = 'APPROVED_PAYMENT',
  FailedPayment = 'FAILED_PAYMENT',
  CancelRequested = 'CANCEL_REQUESTED',
  CancelConfirmed = 'CANCEL_CONFIRMED',
  RejectedPurchaseOrder = 'REJECTED_PURCHASE_ORDER',
  RefundRequested = 'REFUND_REQUESTED',
  RefundConfirmed = 'REFUND_CONFIRMED',
  StartProcessing = 'START_PROCESSING',
  StartShipping = 'START_SHIPPING',
  InduceConfirmPurchase = 'INDUCE_CONFIRM_PURCHASE',
  DelayedConfirmPurchase = 'DELAYED_CONFIRM_PURCHASE',
  PurchaseConfirmed = 'PURCHASE_CONFIRMED',
  SubmallRegistrationRequest = 'SUBMALL_REGISTRATION_REQUEST'
}

export type CapaQuotationChatMessageUnion =
  | CapaQuotationChatMessageMessage
  | CapaQuotationChatMessageSimpleQuotation
  | CapaQuotationChatMessageDetailedQuotation
  | CapaQuotationChatMessageRfq
  | CapaQuotationAnnotationCommentMessage
  | CapaQuotationBypassMessage
  | CapaQuotationBypassMessageDeleteMessage;

export type CapaQuotationChatMessagesOutput = {
  __typename?: 'CAPAQuotationChatMessagesOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaQuotationChatMessage>>;
};

export type CapaQuotationChatRfq = {
  __typename?: 'CAPAQuotationChatRfq';
  rfqId?: Maybe<Scalars['String']>;
  userOrganizationName?: Maybe<Scalars['String']>;
  userManagerName?: Maybe<Scalars['String']>;
  partnerOrganizationName?: Maybe<Scalars['String']>;
  partnerManagerName?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  quotationId?: Maybe<Scalars['String']>;
  purchaseOrderId?: Maybe<Scalars['String']>;
  adjustRequest?: Maybe<Scalars['String']>;
  event?: Maybe<CapaQuotationRfqEventType>;
  rejectedReason?: Maybe<Scalars['String']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  isSendRequest?: Maybe<Scalars['Boolean']>;
  /** 결제 대금 */
  purchaseAmount?: Maybe<Scalars['Float']>;
  /** 지급 승인 (구매확정) 예정일 */
  expectedConfirmPurchaseDate?: Maybe<Scalars['String']>;
};

export type CapaQuotationChatRoom = {
  __typename?: 'CAPAQuotationChatRoom';
  chatRoomId?: Maybe<Scalars['String']>;
  chatRoomStatus?: Maybe<CapaQuotationChatRoomStatus>;
  partnerStatus?: Maybe<CapaQuotationPartnerUserStatus>;
  clientStatus?: Maybe<CapaQuotationUserStatus>;
  /** Legacy */
  chatMessages?: Maybe<Array<CapaQuotationChatMessage>>;
  /** Legacy */
  chatMessagesCount?: Maybe<Scalars['Float']>;
  rfqId?: Maybe<Scalars['String']>;
  rfqStatus?: Maybe<CapaRfqStatus>;
  /** old rfq 여부 */
  isOld?: Maybe<Scalars['Boolean']>;
  /** 견적서 발행 여부 */
  hasQuotation?: Maybe<Scalars['Boolean']>;
  /** 견적서 확정 여부 */
  isQuotationConfirmed?: Maybe<Scalars['Boolean']>;
  /** 발주서 발행 여부 */
  hasPurchaseOrder?: Maybe<Scalars['Boolean']>;
  /** 발주서 확정 여부 */
  isPurchaseOrderConfirmed?: Maybe<Scalars['Boolean']>;
  quotationPartnerId?: Maybe<Scalars['String']>;
  chatFiles?: Maybe<Array<CapaQuotationChatFile>>;
  /** 고객이 가장 최근 메세지 읽은 시간 */
  clientLastSeenAt?: Maybe<Scalars['String']>;
  /** 가장 최근 메세지 읽은 시간 */
  partnerLastSeenAt?: Maybe<Scalars['String']>;
  /** 리뷰 작성 여부 */
  hasReview?: Maybe<Scalars['Boolean']>;
  /** 진행중인 결제 건이 있는지, 있다면, 견적서 재발행 불가 */
  hasProgressingPayment?: Maybe<Scalars['Boolean']>;
  /** 생성일 */
  createdAt?: Maybe<Scalars['String']>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
};

export type CapaQuotationChatRoomAnnotationComment = {
  __typename?: 'CAPAQuotationChatRoomAnnotationComment';
  isNew?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
  status?: Maybe<CapaQuotationSharedFileAnnotationStatus>;
  commentUsers?: Maybe<Array<CommentUser>>;
  fileName?: Maybe<Scalars['String']>;
  quotationSharedFileId?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['String']>;
  annotationId?: Maybe<Scalars['String']>;
  comments?: Maybe<Array<AnnotationComment>>;
  userName?: Maybe<Scalars['String']>;
  lastComment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type CapaQuotationChatRoomAnnotationCommentBo = {
  __typename?: 'CAPAQuotationChatRoomAnnotationCommentBO';
  userId?: Maybe<Scalars['String']>;
  status?: Maybe<CapaQuotationSharedFileAnnotationStatus>;
  commentUsers?: Maybe<Array<CommentUserBo>>;
  comments?: Maybe<Array<AnnotationCommentBo>>;
  annotationId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['String']>;
  quotationSharedFileId?: Maybe<Scalars['String']>;
  lastComment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type CapaQuotationChatRoomAnnotationCommentsOutput = {
  __typename?: 'CAPAQuotationChatRoomAnnotationCommentsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaQuotationChatRoomAnnotationComment>>;
};

export type CapaQuotationChatRoomOutput = {
  __typename?: 'CAPAQuotationChatRoomOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationChatRoom>;
};

export type CapaQuotationChatRoomSharedFiles = {
  __typename?: 'CAPAQuotationChatRoomSharedFiles';
  fileName?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['String']>;
  quotationSharedFileId?: Maybe<Scalars['String']>;
  quotationSharedFileSize?: Maybe<Scalars['Float']>;
  quotationSharedFileType?: Maybe<CapaQuotationChatRoomSharedFileType>;
  annotationStatus?: Maybe<CapaQuotationChatRoomSharedFileAnnotationStatus>;
};

export type CapaQuotationChatRoomSharedFilesOutput = {
  __typename?: 'CAPAQuotationChatRoomSharedFilesOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaQuotationChatRoomSharedFiles>>;
};

/** 챗룸 상태 */
export enum CapaQuotationChatRoomStatus {
  /** 채팅방 오픈 상태 */
  Opened = 'OPENED',
  /** 채팅방에 파트너만 들어와있는 상태 */
  OpenedPartner = 'OPENED_PARTNER',
  /** 채팅방 종료 상태 */
  Stopped = 'STOPPED',
  ClosedConfirm = 'CLOSED_CONFIRM',
  ClosedClient = 'CLOSED_CLIENT',
  ClosedPartner = 'CLOSED_PARTNER',
  /** 고객이 채팅하기 시작 전에 파트너가 서비스 타입을 OFF하면서 채팅방을 모두 종료한 경우 */
  ClosedBeforeConsulting = 'CLOSED_BEFORE_CONSULTING'
}

/** 채팅방 필터링 타입 */
export enum CapaQuotationChatRoomsFilterType {
  /** 기본 채팅방 */
  Default = 'DEFAULT',
  /** 견적 상담 상태 채팅방 */
  Consulting = 'CONSULTING',
  /** 발주 상담 상태 채팅방 */
  Confirmed = 'CONFIRMED'
}

export type CapaQuotationChatRoomsTotalCount = {
  __typename?: 'CAPAQuotationChatRoomsTotalCount';
  /** 캐파 서비스 */
  capaService?: Maybe<CapaServiceType>;
  /** 채팅방의 개수 */
  totalCount: Scalars['Float'];
};

export type CapaQuotationCreatePurchaseOrder = {
  __typename?: 'CAPAQuotationCreatePurchaseOrder';
  purchaseOrderId: Scalars['String'];
};

export type CapaQuotationCreatePurchaseOrderOutput = {
  __typename?: 'CAPAQuotationCreatePurchaseOrderOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationCreatePurchaseOrder>;
};

export type CapaQuotationDetailedMaterial = {
  __typename?: 'CAPAQuotationDetailedMaterial';
  material?: Maybe<CapaQuotationMaterial>;
  detailedMaterials?: Maybe<Array<CapaQuotationDetailedMaterialType>>;
};

/** 세부 재료 */
export enum CapaQuotationDetailedMaterialType {
  /** ABS */
  Abs = 'ABS',
  /** 아크릴 (Acrylic) */
  Acryl = 'ACRYL',
  /** MC Nylon */
  McNylon = 'MC_NYLON',
  /** MC Nylon 66 */
  McNylon_66 = 'MC_NYLON_66',
  /** 폴리카보네이트 (PC) */
  Pc = 'PC',
  /** 폴리에틸렌 (PE) */
  Pe = 'PE',
  /** 폴리프로필렌 (PP) */
  Pp = 'PP',
  /** 아세탈 (POM) */
  AcetalPom = 'ACETAL_POM',
  /** PEEK */
  Peek = 'PEEK',
  /** 베이클라이트(Bakelite) */
  Bakelite = 'BAKELITE',
  /** 테플론 (PTFE) */
  Teflon = 'TEFLON',
  /** 2024-T3 */
  Aluminum_2024T3 = 'ALUMINUM_2024_T3',
  /** 6061-T6 */
  Aluminum_6061T6 = 'ALUMINUM_6061_T6',
  /** 6063 */
  Aluminum_6063 = 'ALUMINUM_6063',
  /** 7050 */
  Aluminum_7050 = 'ALUMINUM_7050',
  /** 7075-T6 */
  Aluminum_7075T6 = 'ALUMINUM_7075_T6',
  /** 7075-T7351 */
  Aluminum_7075T7351 = 'ALUMINUM_7075_T7351',
  /** MIC-6 */
  AluminumMic_6 = 'ALUMINUM_MIC_6',
  /** SS 15-5 */
  Ss15_5 = 'SS15_5',
  /** SS 17-4 */
  Ss17_4 = 'SS17_4',
  /** SS 18-8 */
  Ss18_8 = 'SS18_8',
  /** SS 303 */
  Ss303 = 'SS303',
  /** SS 304 */
  Ss304 = 'SS304',
  /** SS 316/316L */
  Ss316Ss316L = 'SS316_SS316L',
  /** SS 416 */
  Ss416 = 'SS416',
  /** SS 420 */
  Ss420 = 'SS420',
  /** SS 235(SS 330) */
  Ss235Ss330 = 'SS235_SS330',
  /** SS 275(SS 400) */
  Ss275Ss400 = 'SS275_SS400',
  /** SS 315(SS 490) */
  Ss315Ss490 = 'SS315_SS490',
  /** SS 410(SS 540) */
  Ss410Ss540 = 'SS410_SS540',
  /** SS 450(SS 590) */
  Ss450Ss590 = 'SS450_SS590',
  /** SS 550 */
  Ss550 = 'SS550',
  /** Copper 101 */
  Copper_101 = 'COPPER_101',
  /** Copper 260(Brass) */
  Copper_260Brass = 'COPPER_260_BRASS',
  /** Copper C110 */
  CopperC110 = 'COPPER_C110',
  /** Copper C360(Brass) */
  CopperC360Brass = 'COPPER_C360_BRASS',
  /** Copper C932(Bronze) */
  CopperC932Bronze = 'COPPER_C932_BRONZE',
  /** S10C(SM10C) */
  S10CSm10C = 'S10C_SM10C',
  /** S15C(SM15C) */
  S15CSm15C = 'S15C_SM15C',
  /** S20C(SM20C) */
  S20CSm20C = 'S20C_SM20C',
  /** S25C(SM25C) */
  S25CSm25C = 'S25C_SM25C',
  /** S30C(SM30C) */
  S30CSm30C = 'S30C_SM30C',
  /** S35C(SM35C) */
  S35CSm35C = 'S35C_SM35C',
  /** S40C(SM40C) */
  S40CSm40C = 'S40C_SM40C',
  /** S45C(SM45C) */
  S45CSm45C = 'S45C_SM45C',
  /** S50C(SM50C) */
  S50CSm50C = 'S50C_SM50C',
  /** S55C(SM55C) */
  S55CSm55C = 'S55C_SM55C',
  /** 일반 황동 */
  GeneralBrass = 'GENERAL_BRASS',
  /** 일반 청동 */
  GeneralBronze = 'GENERAL_BRONZE',
  /** SCM415 */
  Scm_415 = 'SCM_415',
  /** SCM420 */
  Scm_420 = 'SCM_420',
  /** SCM440 */
  Scm_440 = 'SCM_440',
  /** ASA */
  Asa = 'ASA',
  /** HDPE */
  Hdpe = 'HDPE',
  /** LDPE */
  Ldpe = 'LDPE',
  /** Nylon(PA 나일론) */
  NylonPa = 'NYLON_PA',
  /** PBT */
  Pbt = 'PBT',
  /** 트라이탄 (PCT) */
  Pct = 'PCT',
  /** PEI */
  Pei = 'PEI',
  /** PET */
  Pet = 'PET',
  /** PMMA */
  Pmma = 'PMMA',
  /** 폴리스티렌(PS) */
  Ps = 'PS',
  /** PVC */
  Pvc = 'PVC',
  /** TPE */
  Tpe = 'TPE',
  /** TPU */
  Tpu = 'TPU',
  /** 알루미늄 합금 */
  AluminumAlloy = 'ALUMINUM_ALLOY',
  /** 아연 합금 */
  ZincAlloy = 'ZINC_ALLOY',
  /** 마그네슘 합금 */
  MagnesiumAlloy = 'MAGNESIUM_ALLOY',
  /** 파트너 추천이 필요합니다 */
  Recommend = 'RECOMMEND',
  /** 기타(직접입력) */
  Etc = 'ETC'
}

export type CapaQuotationDetailedPcbAssemblyItem = {
  __typename?: 'CAPAQuotationDetailedPcbAssemblyItem';
  /** fileId */
  fileId?: Maybe<Scalars['String']>;
  /** BOM FILE 이름 */
  fileName?: Maybe<Scalars['String']>;
  /** 수량 */
  quantity: Scalars['Float'];
  /** 총액 */
  cost: Scalars['Float'];
  /** 기타 */
  etc?: Maybe<Scalars['String']>;
};

export type CapaQuotationDetailedPcbFabricationItem = {
  __typename?: 'CAPAQuotationDetailedPcbFabricationItem';
  /** fileId */
  fileId?: Maybe<Scalars['String']>;
  /** GERBER FILE 이름 */
  fileName?: Maybe<Scalars['String']>;
  /** 수량 */
  quantity: Scalars['Float'];
  /** 두께 */
  thickness?: Maybe<Scalars['Float']>;
  /** 총액 */
  cost: Scalars['Float'];
  /** 기타 */
  etc?: Maybe<Scalars['String']>;
};

export type CapaQuotationDetailedQuotation = {
  __typename?: 'CAPAQuotationDetailedQuotation';
  /** rfq quotation id */
  id: Scalars['String'];
  rfqId: Scalars['String'];
  chatRoomId?: Maybe<Scalars['String']>;
  type: CapaRfqQuotationType;
  projectName?: Maybe<Scalars['String']>;
  serviceType?: Maybe<CapaQuotationServiceType>;
  detailServiceType?: Maybe<CapaQuotationDetailedServiceType>;
  optionalServices?: Maybe<Array<CapaQuotationRfqQuotationOptionalService>>;
  /** 발행 정보 */
  publish?: Maybe<CapaQuotationDetailedQuotationPublish>;
  /** 공급자 정보 */
  supply?: Maybe<CapaQuotationDetailedQuotationSupply>;
  /** 납품 가능일 */
  dueDate?: Maybe<Scalars['String']>;
  /** 견적서 유효기간 */
  expiration?: Maybe<Scalars['String']>;
  items?: Maybe<Array<CapaQuotationDetailedQuotationItem>>;
  pcbFabricationItems?: Maybe<Array<CapaQuotationDetailedPcbFabricationItem>>;
  pcbAssemblyItems?: Maybe<Array<CapaQuotationDetailedPcbAssemblyItem>>;
  /** 공급가액 */
  quotation?: Maybe<Scalars['Float']>;
  /** 배송비 */
  deliveryCost?: Maybe<Scalars['Float']>;
  /** 배송비 포함여부 */
  excludeDeliveryFee?: Maybe<Scalars['Boolean']>;
  pcb?: Maybe<CapaPcbDetail>;
  design?: Maybe<CapaDesignDetail>;
  /** 최대 시안 수정 횟수 */
  maxDraftModificationCount?: Maybe<Scalars['Float']>;
  /** 수정 범위 및 추가 과금 기준 */
  draftModificationTerms?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
  /** 견적서 확정 */
  isConfirmed?: Maybe<Scalars['Boolean']>;
  /** 견적 설명 */
  etc?: Maybe<Scalars['String']>;
  /** 수정 요청서 읽음 및 내용 */
  adjustRequest?: Maybe<CapaRfqAdjustRequestObject>;
  createdAt?: Maybe<Scalars['String']>;
  /** 가장 최신 여부 */
  latest?: Maybe<Scalars['Boolean']>;
  /** 가견적 여부 */
  isBeforeConsulting?: Maybe<Scalars['Boolean']>;
};

export type CapaQuotationDetailedQuotationItem = {
  __typename?: 'CAPAQuotationDetailedQuotationItem';
  fileId?: Maybe<Scalars['String']>;
  /** 재료 이름 */
  fileName?: Maybe<Scalars['String']>;
  /** 수량 */
  quantity: Scalars['Float'];
  material?: Maybe<Scalars['String']>;
  /** 총액 */
  cost: Scalars['Float'];
  /** 견적 설명 */
  etc?: Maybe<Scalars['String']>;
};

export type CapaQuotationDetailedQuotationItemInput = {
  fileId?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Float'];
  material?: InputMaybe<Scalars['String']>;
  /** 총액 */
  cost: Scalars['Float'];
  etc?: InputMaybe<Scalars['String']>;
};

export type CapaQuotationDetailedQuotationOutput = {
  __typename?: 'CAPAQuotationDetailedQuotationOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationDetailedQuotation>;
};

/** 조립 견적 정보 */
export type CapaQuotationDetailedQuotationPcbAssemblyItemInput = {
  fileId?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Float'];
  /** 총액 */
  cost: Scalars['Float'];
  etc?: InputMaybe<Scalars['String']>;
};

/** 제작 견정 정보 Item */
export type CapaQuotationDetailedQuotationPcbFabricationItemInput = {
  fileId?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Float'];
  /** 두께 */
  thickness?: InputMaybe<Scalars['Float']>;
  /** 총액 */
  cost: Scalars['Float'];
  etc?: InputMaybe<Scalars['String']>;
};

export type CapaQuotationDetailedQuotationPublish = {
  __typename?: 'CAPAQuotationDetailedQuotationPublish';
  /** 고객 상태 */
  quotationUserStatus?: Maybe<CapaQuotationUserStatus>;
  /** 고객 회사명 */
  organizationName?: Maybe<Scalars['String']>;
  /** 고객 담당자명 */
  managerName?: Maybe<Scalars['String']>;
};

export type CapaQuotationDetailedQuotationSupply = {
  __typename?: 'CAPAQuotationDetailedQuotationSupply';
  quotationPartnerId: Scalars['String'];
  quotationPartnerStatus?: Maybe<CapaQuotationPartnerStatus>;
  /** 파트너 회사명 */
  organizationName?: Maybe<Scalars['String']>;
  companyRegistrationNumber?: Maybe<Scalars['Float']>;
  /** 담당자명 */
  managerName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
};

export type CapaQuotationDetailedQuotationsOutput = {
  __typename?: 'CAPAQuotationDetailedQuotationsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaQuotationDetailedQuotation>>;
};

export type CapaQuotationDetailedService = {
  __typename?: 'CAPAQuotationDetailedService';
  type?: Maybe<CapaQuotationDetailedServiceType>;
  materials?: Maybe<Array<CapaQuotationDetailedMaterial>>;
};

/** 캐파 견적 상세 서비스 정보 입력 */
export type CapaQuotationDetailedServiceInput = {
  /** 캐파 견적 상세 서비스 타입 */
  type?: InputMaybe<CapaQuotationDetailedServiceType>;
  /** 재료 정보 입력 */
  materials?: InputMaybe<Array<CapaQuotationMaterialInput>>;
};

/** 캐파 견적 상세 서비스 타입 */
export enum CapaQuotationDetailedServiceType {
  /** 밀링 (Milling) */
  Milling = 'MILLING',
  /** 선반 (Turning) */
  Turning = 'TURNING',
  /** 머시닝 센터 (Machining Center) */
  MachiningCenter = 'MACHINING_CENTER',
  /** 드릴링 (Drilling) */
  Drilling = 'DRILLING',
  /** SLA */
  Sla = 'SLA',
  /** FDM */
  Fdm = 'FDM',
  /** Polyjet */
  Polyjet = 'POLYJET',
  /** MJF */
  Mjf = 'MJF',
  /** SLS */
  Sls = 'SLS',
  /** SLM/DMLS */
  SlmDmls = 'SLM_DMLS',
  /** 일반 사출 (Injection Molding) */
  InjectionMolding = 'INJECTION_MOLDING',
  /** 이중 사출 (Double-Shot Injection Molding) */
  DoubleShotInjectionMolding = 'DOUBLE_SHOT_INJECTION_MOLDING',
  /** 블로우 사출 (Blow Injection Molding) */
  BlowInjectionMolding = 'BLOW_INJECTION_MOLDING',
  /** 인서트 사출 (Insert Injection Molding) */
  InsertInjectionMolding = 'INSERT_INJECTION_MOLDING',
  /** 프레스 (Press) */
  Press = 'PRESS',
  /** 레이저 컷팅 (Laser Cutting) */
  LaserCutting = 'LASER_CUTTING',
  /** 워터젯 컷팅 (Waterjet Cutting) */
  WaterjetCutting = 'WATERJET_CUTTING',
  /** 사형 주조 (Sand Casting) */
  SandCasting = 'SAND_CASTING',
  /** 쉘 주조 (Shell Moulding) */
  ShellCasting = 'SHELL_CASTING',
  /** 인베스트먼트 주조 (Investment Casting) */
  InvestmentCasting = 'INVESTMENT_CASTING',
  /** 다이캐스팅(Die Casting) */
  DieCasting = 'DIE_CASTING',
  /** 원심 주조(Centrifugal Casting) */
  CentrifugalCasting = 'CENTRIFUGAL_CASTING',
  Recommend = 'RECOMMEND',
  CircuitDesign = 'CIRCUIT_DESIGN',
  CircuitFabrication = 'CIRCUIT_FABRICATION',
  CircuitAssembly = 'CIRCUIT_ASSEMBLY',
  MechanicalDesign = 'MECHANICAL_DESIGN',
  ProductDesign = 'PRODUCT_DESIGN',
  Prototyping = 'PROTOTYPING',
  Etc = 'ETC'
}

/** 재료 */
export enum CapaQuotationMaterial {
  /** 플라스틱 (Plastic) */
  Plastic = 'PLASTIC',
  /** 알루미늄 (Aluminum */
  Aluminum = 'ALUMINUM',
  /** 스테인리스 강(Stainless Steel) */
  StainlessSteel = 'STAINLESS_STEEL',
  /** 강철 (Steel) */
  Steel = 'STEEL',
  /** 구리 (Copper) */
  Copper = 'COPPER',
  /** 탄소강 (Carbon Steel) */
  CarbonSteel = 'CARBON_STEEL',
  /** 황동 (Brass) */
  Brass = 'BRASS',
  /** 청동 (Bronze) */
  Bronze = 'BRONZE',
  /** 합금강 (Steel Alloy) */
  SteelAlloy = 'STEEL_ALLOY',
  /** 레진 (흰색) */
  ResinWhite = 'RESIN_WHITE',
  /** 레진 (투명) */
  ResinTransparent = 'RESIN_TRANSPARENT',
  /** 레진 (반투명) */
  ResinTranslucent = 'RESIN_TRANSLUCENT',
  /** PLA */
  Pla = 'PLA',
  /** ABS(산업용) */
  AbsIndustrial = 'ABS_INDUSTRIAL',
  /** Vero (멀티 컬러) */
  Vero = 'VERO',
  /** 고무 유사 */
  RubberLike = 'RUBBER_LIKE',
  /** PA12 */
  Pa12 = 'PA12',
  /** 금속 (Metal) */
  MetalInj = 'METAL_INJ',
  /** 아연 강 (Galvanized Steel)) */
  GalvanizedSteel = 'GALVANIZED_STEEL',
  /** 주철 (Iron) */
  Iron = 'IRON',
  /** 주강 (Steel) */
  SteelCasting = 'STEEL_CASTING',
  /** 알루미늄 합금 (Aluminum Alloy) */
  AluminumAlloy = 'ALUMINUM_ALLOY',
  /** 아연 합금 (Zinc Alloy) */
  ZincAlloy = 'ZINC_ALLOY',
  /** 마그네슘 합금 (Magnesium Alloy) */
  MagnesiumAlloy = 'MAGNESIUM_ALLOY',
  /** 동 합금 (Copper Alloy) */
  CopperAlloy = 'COPPER_ALLOY',
  /** 파트너 추천이 필요합니다 */
  Recommend = 'RECOMMEND',
  /** 기타(직접입력) */
  Etc = 'ETC'
}

/** 재료 정보 입력 */
export type CapaQuotationMaterialInput = {
  /** 재료 */
  material?: InputMaybe<CapaQuotationMaterial>;
  /** 세부 재료 */
  detailedMaterials?: InputMaybe<Array<CapaQuotationDetailedMaterialType>>;
};

export type CapaQuotationMessaegeSearch = {
  __typename?: 'CAPAQuotationMessaegeSearch';
  rfqId?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
  managerName?: Maybe<Scalars['String']>;
  message?: Maybe<CapaQuotationChatMessageUnion>;
  createdAt?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  eventType?: Maybe<CapaQuotationRfqEventType>;
};

export type CapaQuotationMyReceivedQuotation = {
  __typename?: 'CAPAQuotationMyReceivedQuotation';
  rfqId?: Maybe<Scalars['String']>;
  quotationId?: Maybe<Scalars['String']>;
  quotationType?: Maybe<CapaRfqQuotationType>;
  partnerId?: Maybe<Scalars['String']>;
  chatRoomId?: Maybe<Scalars['String']>;
  chatRoomStatus?: Maybe<CapaQuotationChatRoomStatus>;
  chatRoomCreatedAt?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  confirmCount?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  deliveryCost?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
  /** 수정된 견적서 여부 */
  isAdjusted?: Maybe<Scalars['Boolean']>;
  /** 발주서(업체 확정) 발행 여부 */
  isTransaction?: Maybe<Scalars['Boolean']>;
  /** 견적서를 보낸 파트너의 상태 */
  quotationPartnerStatus?: Maybe<CapaQuotationPartnerStatus>;
  /** 특정 rfq가 파트너로부터 수령한 것 */
  rfqReceivedType?: Maybe<CapaRfqReceivedType>;
  /** 발주서 상태 */
  purchaseOrderStatus?: Maybe<CapaPurchaseOrderStatus>;
  satisfactioPoint?: Maybe<Scalars['Float']>;
  reviewCnt?: Maybe<Scalars['Float']>;
};

export type CapaQuotationMyReceivedQuotationsOutput = {
  __typename?: 'CAPAQuotationMyReceivedQuotationsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaQuotationMyReceivedQuotation>>;
};

export type CapaQuotationMyRfqReview = {
  __typename?: 'CAPAQuotationMyRfqReview';
  rfqId: Scalars['String'];
  thumbnailId?: Maybe<Scalars['String']>;
  serviceType?: Maybe<CapaQuotationServiceType>;
  projectName?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  publicComment?: Maybe<Scalars['String']>;
  privateComment?: Maybe<Scalars['String']>;
  replyComment?: Maybe<Scalars['String']>;
  repliedAt?: Maybe<Scalars['String']>;
  quality?: Maybe<Scalars['Float']>;
  dueDate?: Maybe<Scalars['Float']>;
};

export type CapaQuotationMyRfqReviewOutput = {
  __typename?: 'CAPAQuotationMyRfqReviewOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaQuotationMyRfqReview>>;
};

/** 캐파 실제 사용 서비스 타입 */
export enum CapaQuotationNewServiceType {
  All = 'ALL',
  /** CNC */
  Cnc = 'CNC',
  /** 3D 프린터 */
  Printing = 'PRINTING',
  /** 금형사출 */
  Inj = 'INJ',
  /** 판금가공 */
  SheetMetal = 'SHEET_METAL',
  /** 주조 */
  Casting = 'CASTING',
  /** 디자인/설계 */
  Design = 'DESIGN',
  /** 전자회로 */
  Pcb = 'PCB'
}

export type CapaQuotationOptionalService = {
  __typename?: 'CAPAQuotationOptionalService';
  serviceType?: Maybe<CapaQuotationServiceType>;
  quantity?: Maybe<Scalars['Float']>;
};

export type CapaQuotationPartner = {
  __typename?: 'CAPAQuotationPartner';
  id: Scalars['ID'];
  email: Scalars['String'];
  status: CapaQuotationPartnerStatus;
  capabilities: CapaQuotationPartnerCapability;
  organizationName: Scalars['String'];
  fullAddress: Scalars['String'];
  shortAddress: Scalars['String'];
  companyRegistrationNumber: Scalars['String'];
  companyIntroduction?: Maybe<Scalars['String']>;
  foundedIn?: Maybe<Scalars['String']>;
  numberEmployees?: Maybe<Scalars['String']>;
  equipment?: Maybe<Scalars['String']>;
  serviceHours?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  managerName: Scalars['String'];
  department?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  contact: Scalars['String'];
  notificationFilter: CapaQuotationPartnerNotificationFilter;
  rfqFilter?: Maybe<Scalars['String']>;
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgreed?: Maybe<Scalars['Boolean']>;
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgreed?: Maybe<Scalars['Boolean']>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgreed?: Maybe<Scalars['Boolean']>;
  /** 추천인 ID */
  referralUserId?: Maybe<Scalars['String']>;
  /** ITP 대상 여부 */
  isItp: Scalars['Boolean'];
  /** 생성일 */
  createdAt: Scalars['String'];
  /** 수정일 */
  updatedAt: Scalars['String'];
  /** 파트너 업로드 파일 */
  files?: Maybe<Array<CapaQuotationPartnerFile>>;
};

export type CapaQuotationPartnerAvailableRequestReview = {
  __typename?: 'CAPAQuotationPartnerAvailableRequestReview';
  rfqId: Scalars['String'];
  /** 파트너 유저 아이디 */
  quotationPartnerUserId: Scalars['String'];
  chatRoomId: Scalars['String'];
  projectName: Scalars['String'];
  managerName: Scalars['String'];
  organizationName: Scalars['String'];
  purchaseOrderValue: Scalars['Float'];
  serviceType?: Maybe<CapaQuotationServiceType>;
  /** 발주 완료일 */
  purchaseOrderCreatedAt?: Maybe<Scalars['String']>;
  thumbnailId?: Maybe<Scalars['String']>;
  isSendRequest?: Maybe<Scalars['Boolean']>;
};

/** 파트너가 리뷰요청 가능한 목록 */
export type CapaQuotationPartnerAvailableRequestReviewsOutput = {
  __typename?: 'CAPAQuotationPartnerAvailableRequestReviewsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaQuotationPartnerAvailableRequestReview>>;
};

export type CapaQuotationPartnerBo = {
  __typename?: 'CAPAQuotationPartnerBO';
  id: Scalars['ID'];
  email: Scalars['String'];
  status: CapaQuotationPartnerStatus;
  capabilities: CapaQuotationPartnerCapability;
  organizationName: Scalars['String'];
  fullAddress: Scalars['String'];
  shortAddress: Scalars['String'];
  companyRegistrationNumber: Scalars['String'];
  companyIntroduction?: Maybe<Scalars['String']>;
  foundedIn?: Maybe<Scalars['String']>;
  numberEmployees?: Maybe<Scalars['String']>;
  equipment?: Maybe<Scalars['String']>;
  serviceHours?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  managerName: Scalars['String'];
  department?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  contact: Scalars['String'];
  notificationFilter: CapaQuotationPartnerNotificationFilter;
  rfqFilter?: Maybe<Scalars['String']>;
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgreed?: Maybe<Scalars['Boolean']>;
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgreed?: Maybe<Scalars['Boolean']>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgreed?: Maybe<Scalars['Boolean']>;
  /** 추천인 ID */
  referralUserId?: Maybe<Scalars['String']>;
  /** ITP 대상 여부 */
  isItp: Scalars['Boolean'];
  /** CAPA 서비스를 어떻게 알게 되셨나요? (복수 선택 가능) */
  inflowRoute?: Maybe<Array<CapaInflowRoute>>;
  /** 생성일 */
  createdAt: Scalars['String'];
  /** 수정일 */
  updatedAt: Scalars['String'];
  /** 탈퇴 사유 */
  withdrawnReason?: Maybe<CapaWithdrawnQuotationPartnerReason>;
  /** 파트너 업로드 파일 */
  files?: Maybe<Array<CapaQuotationPartnerFile>>;
};

export type CapaQuotationPartnerCapability = {
  __typename?: 'CAPAQuotationPartnerCapability';
  services?: Maybe<Array<CapaQuotationService>>;
};

/** 캐파 견적 파트너가 보는 채팅방룸 */
export type CapaQuotationPartnerChatRoom = {
  __typename?: 'CAPAQuotationPartnerChatRoom';
  profileId?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  quotationUserStatus: CapaQuotationUserStatus;
  managerName?: Maybe<Scalars['String']>;
  projectName: Scalars['String'];
  rfqId: Scalars['String'];
  chatRoomId: Scalars['String'];
  quotaionUserId: Scalars['String'];
  chatRoomStatus: CapaQuotationChatRoomStatus;
  /** 안읽은수 */
  unReadCount?: Maybe<Scalars['Float']>;
  lastMessage?: Maybe<CapaQuotationChatMessageUnion>;
  /** 마지막 메세지 전송시간, */
  lastMessageCreatedAt?: Maybe<Scalars['String']>;
  serviceType: CapaQuotationServiceType;
  detailedServiceType?: Maybe<CapaQuotationDetailedServiceType>;
  thumbnailId?: Maybe<Scalars['String']>;
  rfqStatus: CapaRfqStatus;
  shortAddress?: Maybe<Scalars['String']>;
  rfqCreatedAt?: Maybe<Scalars['String']>;
  purchaseOrderStatus?: Maybe<CapaPurchaseOrderStatus>;
  /** 기획에서 요구하는 상태 를 지정해서 반환. */
  searchProjectStatusTypeEnum?: Maybe<ProjectStatusType>;
  quantity?: Maybe<Scalars['String']>;
  currentChatroomsCount?: Maybe<Scalars['String']>;
};

export type CapaQuotationPartnerChatRooms = {
  __typename?: 'CAPAQuotationPartnerChatRooms';
  totalChatRoomsCount: Scalars['Float'];
  currentChatRoomCount?: Maybe<Scalars['Float']>;
  chatRooms?: Maybe<Array<CapaQuotationPartnerChatRoom>>;
  /** 읽지 않은 메세지 수 */
  totalUnReadMessagesCount?: Maybe<
    Array<CapaQuotationPartnerUnReadMessagesCount>
  >;
};

/** 캐파 견적 파트너가 보는 채팅방 chatRooms Output */
export type CapaQuotationPartnerChatRoomsOutput = {
  __typename?: 'CAPAQuotationPartnerChatRoomsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationPartnerChatRooms>;
};

/** CAPAQuotationPartnerEquipment */
export type CapaQuotationPartnerEquipment = {
  __typename?: 'CAPAQuotationPartnerEquipment';
  /** id */
  id: Scalars['String'];
  /** 장비명 */
  equipmentName: Scalars['String'];
  /** 수량 */
  quantity: Scalars['Float'];
  /** 상세 정보 */
  description?: Maybe<Scalars['String']>;
  /** 파트너 파일 업로드 정보 입력 */
  file?: Maybe<CapaQuotationPartnerStrategyFile>;
  /** 생성 날짜 */
  createdAt?: Maybe<Scalars['String']>;
};

export type CapaQuotationPartnerFile = {
  __typename?: 'CAPAQuotationPartnerFile';
  fileId?: Maybe<Scalars['ID']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<CapaQuotationPartnerFileType>;
};

/** 파트너 파일 타입 */
export enum CapaQuotationPartnerFileType {
  /** 회사 로고 */
  Logo = 'LOGO',
  /** 사업자 등록증 */
  Registration = 'REGISTRATION',
  /** 포트폴리오 이미지 */
  PortfolioImage = 'PORTFOLIO_IMAGE',
  /** 포트폴리오 파일 */
  PortfolioFile = 'PORTFOLIO_FILE',
  /** 파트너 파일 및 동영상 */
  PartnerFile = 'PARTNER_FILE',
  /** 커버 이미지 */
  ImageCover = 'IMAGE_COVER'
}

/** CAPAQuotationPartnerGNB */
export type CapaQuotationPartnerGnb = {
  __typename?: 'CAPAQuotationPartnerGNB';
  /** 새로 들어온 rfq개수 */
  newRfqCount: Scalars['Float'];
  /** 모든 채팅방 unread chat count */
  newChatCount: Scalars['Float'];
  /** 견적 상태 채팅방 unread chat count */
  newConsultingChatCount: Scalars['Float'];
  /** 발주 상태 채팅방 unread chat count */
  newConfirmedChatCount: Scalars['Float'];
  newProjectManagementCount: Scalars['Float'];
  newPaymentManagementCount?: Maybe<Scalars['Float']>;
};

/** CAPAQuotationPartnerGNBOutput */
export type CapaQuotationPartnerGnbOutput = {
  __typename?: 'CAPAQuotationPartnerGNBOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationPartnerGnb>;
};

/** 캐파 파트너 이미지 포토폴리오 타입 */
export enum CapaQuotationPartnerImagePortfolioProduceStepType {
  /** 시제품 제작 */
  Prototyping = 'PROTOTYPING',
  /** 소량 생산 */
  SmallProduction = 'SMALL_PRODUCTION',
  /** 대량 생산 */
  MassProduction = 'MASS_PRODUCTION'
}

/** notification filter */
export type CapaQuotationPartnerNotificationFilter = {
  __typename?: 'CAPAQuotationPartnerNotificationFilter';
  chatEmail?: Maybe<Scalars['Boolean']>;
  chatSMS?: Maybe<Scalars['Boolean']>;
  chatPush?: Maybe<Scalars['Boolean']>;
  rfqEmail?: Maybe<Scalars['Boolean']>;
  rfqSMS?: Maybe<Scalars['Boolean']>;
  rfqPush?: Maybe<Scalars['Boolean']>;
  capabilityFilters?: Maybe<Array<CapaQuotationCapabilityNotificationFilter>>;
  /** 방해금지 시간 */
  doNotDisturb?: Maybe<CapaDoNotDisturbFilter>;
  /** 프로젝트 이메일 알림 */
  projectEmail?: Maybe<Scalars['Boolean']>;
  /** 프로젝트 카카오 (실패시 SMS) 알림 */
  projectSMS?: Maybe<Scalars['Boolean']>;
  /** 프로젝트 (Push) 알림 */
  projectPush?: Maybe<Scalars['Boolean']>;
  /** 프로젝트 알림 설정 */
  projectFilters?: Maybe<Array<CapaRfqProjectFilter>>;
  /** 캐파 소식 및 혜택 이메일 알림 */
  newsEmail?: Maybe<Scalars['Boolean']>;
  /** 캐파 소식 및 혜택 카카오 (실패시 SMS) 알림 */
  newsSMS?: Maybe<Scalars['Boolean']>;
};

/** notification filter */
export type CapaQuotationPartnerNotificationFilterInput = {
  /** email yes/no for new chat messages */
  chatEmail?: InputMaybe<Scalars['Boolean']>;
  /** sms yes/no for new chat messages */
  chatSMS?: InputMaybe<Scalars['Boolean']>;
  /** push notification yes/no for new chat messages */
  chatPush?: InputMaybe<Scalars['Boolean']>;
  /** email yes/no for rfq registration for all capabilities */
  rfqEmail?: InputMaybe<Scalars['Boolean']>;
  /** sms yes/no for rfq registration for all capabilities */
  rfqSMS?: InputMaybe<Scalars['Boolean']>;
  /** push notification yes/no for rfq registration for all capabilities */
  rfqPush?: InputMaybe<Scalars['Boolean']>;
  capabilityFilters?: InputMaybe<
    Array<CapaQuotationCapabilityNotificationFilterInput>
  >;
  /** 방해금지 시간 */
  doNotDisturb?: InputMaybe<CapaDoNotDisturbFilterInput>;
  /** 프로젝트 이메일 알림 */
  projectEmail?: InputMaybe<Scalars['Boolean']>;
  /** 프로젝트 카카오 (실패시 SMS) 알림 */
  projectSMS?: InputMaybe<Scalars['Boolean']>;
  /** 프로젝트 Push 알림 */
  projectPush?: InputMaybe<Scalars['Boolean']>;
  /** 프로젝트 알림 설정 */
  projectFilters?: InputMaybe<Array<CapaRfqProjectFilterInput>>;
  /** 캐파 소식 및 혜택 이메일 알림 */
  newsEmail?: InputMaybe<Scalars['Boolean']>;
  /** 캐파 소식 및 혜택 카카오 (실패시 SMS) 알림 */
  newsSMS?: InputMaybe<Scalars['Boolean']>;
};

export type CapaQuotationPartnerOutput = {
  __typename?: 'CAPAQuotationPartnerOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationPartner>;
};

export type CapaQuotationPartnerPageViewCountModel = {
  __typename?: 'CAPAQuotationPartnerPageViewCountModel';
  pageView: Scalars['String'];
};

/** CAPAQuotationPartnerPortfolio */
export type CapaQuotationPartnerPortfolio = {
  __typename?: 'CAPAQuotationPartnerPortfolio';
  id: Scalars['String'];
  /** 프로젝트 명 */
  projectName: Scalars['String'];
  /** 고객 */
  client?: Maybe<Scalars['String']>;
  /** 상세 정보 */
  description?: Maybe<Scalars['String']>;
  /** 파트너 캐파빌리티 jsonb array of { service_type, process_method, material, detailed_material, etc } */
  capabilities?: Maybe<Array<CapaQuotationPartnerPortfolioService>>;
  /** 제품 용도 */
  projectPurpose?: Maybe<Array<CapaQuotationProductPurpose>>;
  /** 제품 종류 */
  productType?: Maybe<Scalars['String']>;
  /** 수량 */
  quantity?: Maybe<Scalars['Float']>;
  /** 제조 단계 */
  produceStep?: Maybe<CapaQuotationPartnerImagePortfolioProduceStepType>;
  /** 파트너 파일 업로드 정보 입력 */
  files: Array<CapaQuotationPartnerStrategyFile>;
};

/** 캐파 견적 서비스 정보 입력 */
export type CapaQuotationPartnerPortfolioService = {
  __typename?: 'CAPAQuotationPartnerPortfolioService';
  /** 캐파 견적 서비스 타입 */
  service?: Maybe<CapaQuotationServiceType>;
  /** 캐파 견적 상세 서비스 정보 입력 */
  detailedServices?: Maybe<Array<CapaQuotationDetailedServiceType>>;
};

/** CAPAQuotationPartnerProjectManagement */
export type CapaQuotationPartnerProjectManagement = {
  __typename?: 'CAPAQuotationPartnerProjectManagement';
  rfqId: Scalars['String'];
  serviceType: CapaQuotationServiceType;
  projectName: Scalars['String'];
  quotationUserStatus?: Maybe<CapaQuotationUserStatus>;
  organizationName?: Maybe<Scalars['String']>;
  managerName?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  type?: Maybe<CapaRfqProjectManagementType>;
  isNew: Scalars['Boolean'];
  isConfirmedAnotherCompany: Scalars['Boolean'];
  chatRoomId: Scalars['String'];
  createdAt: Scalars['String'];
};

export type CapaQuotationPartnerProjectParticipationStatusBo = {
  __typename?: 'CAPAQuotationPartnerProjectParticipationStatusBO';
  id?: Maybe<Scalars['String']>;
  rfqId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  serviceType?: Maybe<CapaQuotationServiceType>;
  projectName?: Maybe<Scalars['String']>;
  quotation?: Maybe<Scalars['Float']>;
  quotationCreatedDates?: Maybe<Array<Scalars['String']>>;
  chatRoomStatus?: Maybe<CapaQuotationChatRoomStatus>;
  lastMessageAt?: Maybe<Scalars['String']>;
  hasPurchaseOrder?: Maybe<Scalars['Boolean']>;
};

export enum CapaQuotationPartnerRejectType {
  /** 고객이 잘못 가입함 */
  JoinMistake = 'JOIN_MISTAKE',
  /** 파트너 요건 불충 */
  Insufficient = 'INSUFFICIENT',
  /** 연락이 되지 않음 */
  CantInTouch = 'CANT_IN_TOUCH',
  /** ETC */
  Etc = 'ETC'
}

/** 파트너가 받은 리뷰 목록 */
export type CapaQuotationPartnerRfqReviewOutput = {
  __typename?: 'CAPAQuotationPartnerRfqReviewOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationPartnerRfqReviewResult>;
};

export type CapaQuotationPartnerRfqReviewResult = {
  __typename?: 'CAPAQuotationPartnerRfqReviewResult';
  reviewAveragePoint?: Maybe<Scalars['Float']>;
  reviewCount?: Maybe<Scalars['Int']>;
  /** 별점 5점 개수 */
  reviewPointRatio?: Maybe<CapaReviewPointRatio>;
  reviews?: Maybe<Array<CapaRfqReview>>;
};

export enum CapaQuotationPartnerStatus {
  /** 승인 */
  Approved = 'APPROVED',
  /** 등록 */
  Registered = 'REGISTERED',
  /** 삭제 */
  Deleted = 'DELETED',
  /** 거절 */
  Rejected = 'REJECTED'
}

/** CAPAQuotationPartnerStrategy */
export type CapaQuotationPartnerStrategy = {
  __typename?: 'CAPAQuotationPartnerStrategy';
  id: Scalars['ID'];
  email: Scalars['String'];
  status: CapaQuotationPartnerStatus;
  capabilities?: Maybe<CapaQuotationPartnerCapability>;
  organizationName?: Maybe<Scalars['String']>;
  fullAddress?: Maybe<Scalars['String']>;
  shortAddress?: Maybe<Scalars['String']>;
  detailAddress?: Maybe<Scalars['String']>;
  companyRegistrationNumber: Scalars['String'];
  companyIntroduction?: Maybe<Scalars['String']>;
  foundedIn?: Maybe<Scalars['String']>;
  numberEmployees?: Maybe<Scalars['String']>;
  serviceHours?: Maybe<Scalars['String']>;
  managerName: Scalars['String'];
  department?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
  notificationFilter: CapaQuotationPartnerNotificationFilter;
  rfqFilter?: Maybe<Scalars['String']>;
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgreed?: Maybe<Scalars['Boolean']>;
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgreed?: Maybe<Scalars['Boolean']>;
  /** [필수] 결제 서비스 이용약관 동의 */
  paymentAgreed?: Maybe<Scalars['Boolean']>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgreed?: Maybe<Scalars['Boolean']>;
  /** 추천인 ID */
  referralUserId?: Maybe<Scalars['String']>;
  /** ITP 대상 여부 */
  isItp: Scalars['Boolean'];
  /** 생성일 */
  createdAt: Scalars['String'];
  /** 수정일 */
  updatedAt: Scalars['String'];
  /** 파트너 로고 파일 */
  logo?: Maybe<CapaQuotationPartnerStrategyFile>;
  /** 파트너 커버 파일 */
  cover?: Maybe<CapaQuotationPartnerStrategyFile>;
  /** 파트너 업로드 파일 ex) 사진 및 동영상 관련 */
  partnerFiles?: Maybe<Array<CapaQuotationPartnerStrategyFile>>;
  portfolios?: Maybe<Array<CapaQuotationPartnerPortfolio>>;
  equipments?: Maybe<Array<CapaQuotationPartnerEquipment>>;
  /** 인증 관련 정보 */
  certifications?: Maybe<Array<CapaQuotationPartnerTechnologyModel>>;
  /** 특허 관련 정보 */
  patents?: Maybe<Array<CapaQuotationPartnerTechnologyModel>>;
  /** 공장 주소 */
  factoryAddress?: Maybe<Scalars['String']>;
  /** 공장 주소 */
  factoryDetailAddress?: Maybe<Scalars['String']>;
  /** 평균 응답 시간 */
  averageResponseTime?: Maybe<Scalars['String']>;
  /** 완료 거래 수 */
  transactionCount?: Maybe<Scalars['Float']>;
  /** 캐파 블로그 및 홍보 관련 */
  promotionModels?: Maybe<Array<CapaPromotionModel>>;
  /** 파트너 페이지 조회수 */
  partnerPageViewCount?: Maybe<Scalars['Float']>;
  /** 사업자 등록증 자료 */
  registrations: Array<CapaQuotationPartnerStrategyFile>;
  /** 리뷰 */
  reviews?: Maybe<CapaQuotationPartnerRfqReviewResult>;
  /** 서브몰 등록 여부 */
  haveSubmall: Scalars['Boolean'];
};

export type CapaQuotationPartnerStrategyBo = {
  __typename?: 'CAPAQuotationPartnerStrategyBO';
  id: Scalars['ID'];
  email: Scalars['String'];
  status: CapaQuotationPartnerStatus;
  capabilities?: Maybe<CapaQuotationPartnerCapability>;
  organizationName?: Maybe<Scalars['String']>;
  fullAddress?: Maybe<Scalars['String']>;
  shortAddress?: Maybe<Scalars['String']>;
  detailAddress?: Maybe<Scalars['String']>;
  companyRegistrationNumber: Scalars['String'];
  companyIntroduction?: Maybe<Scalars['String']>;
  foundedIn?: Maybe<Scalars['String']>;
  numberEmployees?: Maybe<Scalars['String']>;
  equipment?: Maybe<Scalars['String']>;
  serviceHours?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  managerName: Scalars['String'];
  department?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
  notificationFilter: CapaQuotationPartnerNotificationFilter;
  rfqFilter?: Maybe<Scalars['String']>;
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgreed?: Maybe<Scalars['Boolean']>;
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgreed?: Maybe<Scalars['Boolean']>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgreed?: Maybe<Scalars['Boolean']>;
  /** 추천인 ID */
  referralUserId?: Maybe<Scalars['String']>;
  /** ITP 대상 여부 */
  isItp: Scalars['Boolean'];
  /** CAPA 서비스를 어떻게 알게 되셨나요? (복수 선택 가능) */
  inflowRoute?: Maybe<Array<CapaInflowRoute>>;
  /** 추천 회사명/기관명 */
  referralCompany?: Maybe<Scalars['String']>;
  /** 생성일 */
  createdAt: Scalars['String'];
  /** 수정일 */
  updatedAt: Scalars['String'];
  /** 탈퇴 사유 */
  withdrawnReason?: Maybe<CapaWithdrawnQuotationPartnerReason>;
  /** 파트너 로고 파일 */
  logo?: Maybe<CapaQuotationPartnerStrategyFile>;
  /** 파트너 커버 파일 */
  cover?: Maybe<CapaQuotationPartnerStrategyFile>;
  /** 파트너 업로드 파일 ex) 사진 및 동영상 관련 */
  partnerFiles?: Maybe<Array<CapaQuotationPartnerStrategyFile>>;
  portfolios?: Maybe<Array<CapaQuotationPartnerPortfolio>>;
  equipments?: Maybe<Array<CapaQuotationPartnerEquipment>>;
  /** 인증 관련 정보 */
  certifications?: Maybe<Array<CapaQuotationPartnerTechnologyModel>>;
  /** 특허 관련 정보 */
  patents?: Maybe<Array<CapaQuotationPartnerTechnologyModel>>;
  /** 공장 주소 */
  factoryAddress?: Maybe<Scalars['String']>;
  factoryDetailAddress?: Maybe<Scalars['String']>;
  /** 평균 응답 시간 */
  averageResponseTime?: Maybe<Scalars['String']>;
  /** 완료 거래 수 */
  transactionCount?: Maybe<Scalars['Float']>;
  /** 캐파 블로그 및 홍보 관련 */
  promotionModels?: Maybe<Array<CapaPromotionModel>>;
  /** 파트너 페이지 조회수 */
  partnerPageViewCount?: Maybe<Scalars['Float']>;
  /** 파트너 승인 날짜 */
  approvedAt?: Maybe<Scalars['String']>;
  /** 파트너 승인 담당자 이름 */
  approver?: Maybe<Scalars['String']>;
  /** 파트너 승인 담당자 BO id */
  approverBOId?: Maybe<Scalars['ID']>;
  /** 사업자 등록증 자료 */
  registrations: Array<CapaQuotationPartnerStrategyFile>;
  partnerHistoryModels?: Maybe<Array<CapaboPartnerHistoryModel>>;
  /** 통장 사본 */
  bankbooks?: Maybe<Array<CapaQuotationPartnerStrategyFile>>;
  /** 정산 은행 코드 */
  bankCode?: Maybe<CapaBankCode>;
  /** 정산 계좌번호(`-`제외) */
  accountNumber?: Maybe<Scalars['String']>;
  /** 예금주명 */
  accountHolder?: Maybe<Scalars['String']>;
  /** submallStatus */
  submallStatus?: Maybe<CapaSubmallStatus>;
  /** 상호명 */
  submallName?: Maybe<Scalars['String']>;
};

export type CapaQuotationPartnerStrategyBoOutput = {
  __typename?: 'CAPAQuotationPartnerStrategyBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationPartnerStrategyBo>;
};

export type CapaQuotationPartnerStrategyFile = {
  __typename?: 'CAPAQuotationPartnerStrategyFile';
  /** strategy file id */
  id: Scalars['ID'];
  /** fileId */
  fileId?: Maybe<Scalars['ID']>;
  /** videoThumbnailFileId */
  videoThumbnailFileId?: Maybe<Scalars['ID']>;
  /** fileName */
  fileName?: Maybe<Scalars['String']>;
  /** fileType */
  fileType?: Maybe<CapaQuotationPartnerStrategyFileType>;
  /** mimeType */
  fileMimetype?: Maybe<Scalars['String']>;
  /** fileSize */
  fileSize?: Maybe<Scalars['String']>;
  /** fileExtension */
  fileExtension?: Maybe<Scalars['String']>;
  /** youtubeURL */
  youtubeURL?: Maybe<Scalars['String']>;
};

/** 파트너 기술 관련 파일 상태 */
export enum CapaQuotationPartnerStrategyFileType {
  /** 인증 관련 파일 */
  CertificationFile = 'CERTIFICATION_FILE',
  /** 특허 관련 파일 */
  PatentFile = 'PATENT_FILE',
  /** 이미지 포토폴리오 관련 파일 */
  PortfolioFile = 'PORTFOLIO_FILE',
  /** 장비 관련 파일 */
  EquipmentFile = 'EQUIPMENT_FILE',
  /** 로고 파일 */
  Logo = 'LOGO',
  /** 사업자등록증 파일 */
  Registration = 'REGISTRATION',
  /** 파트너 파일(사진 및 동영상 파일) */
  PartnerFile = 'PARTNER_FILE',
  /** 유튜브 URL */
  YoutubeUrl = 'YOUTUBE_URL',
  /** 커버이미지 */
  ImageCover = 'IMAGE_COVER',
  /** 통장 사본 */
  Bankbook = 'BANKBOOK'
}

/** 파트너 파일 정보 입력 */
export type CapaQuotationPartnerStrategyFileUploadInput = {
  /** fk 캐파 파일 아이디 */
  fileId?: InputMaybe<Scalars['String']>;
  /** videoThumbnailFileId  아이디 */
  videoThumbnailFileId?: InputMaybe<Scalars['String']>;
  /** youtube url */
  youtubeURL?: InputMaybe<Scalars['String']>;
};

/** CAPAQuotationPartnerStrategyOutput */
export type CapaQuotationPartnerStrategyOutput = {
  __typename?: 'CAPAQuotationPartnerStrategyOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationPartnerStrategy>;
};

/** 파트너 파일 정보 입력 */
export type CapaQuotationPartnerStrategyRegistrationFileUploadInput = {
  /** fk 캐파 파일 아이디 */
  fileId?: InputMaybe<Scalars['String']>;
};

export type CapaQuotationPartnerTechnologyInput = {
  /** fk 캐파 파일 아이디 */
  fileId: Scalars['String'];
  /** 인증 /특허 명 */
  technicalName: Scalars['String'];
  /** 발급 기관 */
  certificationAuthority: Scalars['String'];
  /** 유효 기간 시작일 */
  expirationPeriodStart?: InputMaybe<Scalars['String']>;
  /** 유효 기간 종료일 */
  expirationPeriodEnd?: InputMaybe<Scalars['String']>;
  /** 설명 */
  description?: InputMaybe<Scalars['String']>;
};

export type CapaQuotationPartnerTechnologyModel = {
  __typename?: 'CAPAQuotationPartnerTechnologyModel';
  /** capa_quotation_partner_technology 테이블 id */
  id: Scalars['ID'];
  /** fk CAPAQuotationPartnerEntity#id */
  quotationPartnerId: Scalars['ID'];
  /** fk CAPAQuotationPartnerStrategyFileEntity#id */
  strategyFileId?: Maybe<Scalars['ID']>;
  /** file */
  file?: Maybe<CapaQuotationPartnerStrategyFile>;
  /** 인증 /특허 명 */
  technicalName?: Maybe<Scalars['String']>;
  /** 발급 기관 */
  certificationAuthority?: Maybe<Scalars['String']>;
  /** 유효 기간 시작일 */
  expirationPeriodStart?: Maybe<Scalars['String']>;
  /** 유효 기간 종료일 */
  expirationPeriodEnd?: Maybe<Scalars['String']>;
  /** 설명 */
  description?: Maybe<Scalars['String']>;
  /** 파일 종류 ex) 인증 / 특허 */
  technologyType: CapaQuotationPartnerTechnologyType;
};

/** 파트너 기술 관련 파일 상태 */
export enum CapaQuotationPartnerTechnologyType {
  /** 인증 */
  Certification = 'CERTIFICATION',
  /** 특허 */
  Patent = 'PATENT'
}

/** 파트너가 읽지 않은 메세지들의 수 (채팅방의 진척도에 따라 구분) */
export type CapaQuotationPartnerUnReadMessagesCount = {
  __typename?: 'CAPAQuotationPartnerUnReadMessagesCount';
  /** 해당 채팅방의 진척도 */
  chatRoomFilter?: Maybe<CapaQuotationChatRoomsFilterType>;
  /** 읽지 않은 메세지들의 총 수  */
  total?: Maybe<Scalars['Float']>;
};

export enum CapaQuotationPartnerUserStatus {
  /** 승인 */
  Approved = 'APPROVED',
  /** 맴버가입됨 */
  Applied = 'APPLIED',
  /** 삭제 */
  Deleted = 'DELETED',
  /** 거절 */
  Rejected = 'REJECTED'
}

export type CapaQuotationPartnersProjectParticipationStatusBo = {
  __typename?: 'CAPAQuotationPartnersProjectParticipationStatusBO';
  projectParticipationStatus?: Maybe<
    Array<CapaQuotationPartnerProjectParticipationStatusBo>
  >;
  quotationSuggestionCount?: Maybe<Scalars['Float']>;
  introductionSuggestionCount?: Maybe<Scalars['Float']>;
  rfqReceivedQuotationCount?: Maybe<Scalars['Float']>;
  openedChatroomCount?: Maybe<Scalars['Float']>;
  closedChatroomCount?: Maybe<Scalars['Float']>;
  purchaseOrderCount?: Maybe<Scalars['Float']>;
  rejectedPurchaseOrderCount?: Maybe<Scalars['Float']>;
  paymentCount?: Maybe<Scalars['Float']>;
};

export type CapaQuotationPartnersProjectParticipationStatusBoOutput = {
  __typename?: 'CAPAQuotationPartnersProjectParticipationStatusBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationPartnersProjectParticipationStatusBo>;
};

export type CapaQuotationPaymentManage = {
  __typename?: 'CAPAQuotationPaymentManage';
  purchaseOrderInfoList?: Maybe<Array<CapaPurchaseOrderModel>>;
  estimatedAmount?: Maybe<Scalars['Float']>;
  completionAmount?: Maybe<Scalars['Float']>;
  totalCount?: Maybe<Scalars['Float']>;
  point?: Maybe<Scalars['Float']>;
};

/** CAPAQuotationPaymentManageModel */
export type CapaQuotationPaymentManageModel = {
  __typename?: 'CAPAQuotationPaymentManageModel';
  id: Scalars['String'];
  quotationId: Scalars['String'];
  /** quotation user id */
  quotationUserId: Scalars['String'];
  /** quotation partner user id */
  quotationPartnerUserId: Scalars['String'];
  /** quotation partner id */
  quotationPartnerId: Scalars['String'];
  /** rfq id */
  rfqId: Scalars['String'];
  /** purchase order id */
  purchaseOrderId?: Maybe<Scalars['String']>;
  /** total amount */
  totalAmount: Scalars['Float'];
  /** commission */
  commission?: Maybe<Scalars['Float']>;
  paymentMethod: CapaPaymentMethodType;
  status: CapaPaymentStatus;
  isRead: Scalars['Boolean'];
  virtualAccountId?: Maybe<Scalars['String']>;
  /** 결제 승인 날짜 */
  paidAt?: Maybe<Scalars['String']>;
  /** 지급승인(구매확정) 날짜 */
  confirmedAt?: Maybe<Scalars['String']>;
  /**
   * 결제망 이용료
   *     - VAT 포함 3.63% 만큼 수수료를 받는데..
   *     가상의 1000원을 카드결제시  1000 ->   1.1 % 인 11원 (나이스페이에 지불) → pgUsageFee
   *                           1000 →    2.53% 인 25원 (캐파에게 지불) → capaUsageFee
   *     -  가상계좌시 무조건 결제망 수수료를 1100원으로 잡고
   *     330원 차감→  pgUsageFee  ( 300원 (가상계좌생성비용 )+ 30 (부가세) 차감)
   *     770원 → capaUsageFee ( 1100 - 330 )
   *
   */
  capaUsageFee?: Maybe<Scalars['Float']>;
  /**
   * 결제망 이용료
   *     - VAT 포함 3.63% 만큼 수수료를 받는데..
   *     가상의 1000원을 카드결제시  1000 ->   1.1 % 인 11원 (나이스페이에 지불) → pgUsageFee
   *                           1000 →    2.53% 인 25원 (캐파에게 지불) → capaUsageFee
   *     -  가상계좌시 무조건 결제망 수수료를 1100원으로 잡고
   *     330원 차감→  pgUsageFee  ( 300원 (가상계좌생성비용 )+ 30 (부가세) 차감)
   *     770원 → capaUsageFee ( 1100 - 330 )
   *
   */
  pgUsageFee?: Maybe<Scalars['Float']>;
  /** 파트너에게 지급되는 돈 payOut = totalAmount - commission - capaUsageFee - pgUsageFee  */
  payOut?: Maybe<Scalars['Float']>;
  cancelId?: Maybe<Scalars['String']>;
  cancelStatus?: Maybe<CapaPaymentCancelStatus>;
  cancelAmount?: Maybe<Scalars['Float']>;
  cancelReason?: Maybe<Scalars['String']>;
  /** 결제 취소확정일 */
  cancelConfirmedAt?: Maybe<Scalars['String']>;
  /** 생성일 */
  createdAt?: Maybe<Scalars['String']>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']>;
  thumbnailId?: Maybe<Scalars['String']>;
  chatRoomId?: Maybe<Scalars['String']>;
  virtualBankCode?: Maybe<CapaBankCode>;
  virtualAccountNumber?: Maybe<Scalars['String']>;
  /** 해당 발주건에 대한 리뷰 존재 유무 */
  hasReview: Scalars['Boolean'];
  /** 배송 지연 이유 */
  extendReason?: Maybe<Scalars['String']>;
  /** 자동 구매확정 예정일 */
  registerExpectedDate?: Maybe<Scalars['String']>;
  /** 카드번호 */
  cardNumber?: Maybe<Scalars['String']>;
  /** 카드이름 */
  cardName?: Maybe<Scalars['String']>;
  /** 구매확정일 연장 14일 후 */
  extendedPurchaseConfirmDate?: Maybe<Scalars['String']>;
};

export type CapaQuotationPaymentManageModelOutput = {
  __typename?: 'CAPAQuotationPaymentManageModelOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationPaymentManage>;
};

/** Product Purpose */
export enum CapaQuotationProductPurpose {
  AutomobileTransportation = 'AUTOMOBILE_TRANSPORTATION',
  ManufacturinEquipmentIndustrialMachineAndParts = 'MANUFACTURIN_EQUIPMENT_INDUSTRIAL_MACHINE_AND_PARTS',
  RoboticsDroneIotSmartDevice = 'ROBOTICS_DRONE_IOT_SMART_DEVICE',
  MedicalHealthcare = 'MEDICAL_HEALTHCARE',
  SemiconductorElectronicBoards = 'SEMICONDUCTOR_ELECTRONIC_BOARDS',
  OpticsMaterials = 'OPTICS_MATERIALS',
  HouseholdAppliance = 'HOUSEHOLD_APPLIANCE',
  ExperimentInspectionDiagnosisMeasuring = 'EXPERIMENT_INSPECTION_DIAGNOSIS_MEASURING',
  EnergyBatteries = 'ENERGY_BATTERIES',
  BroadcastCommunicationMultimedia = 'BROADCAST_COMMUNICATION_MULTIMEDIA',
  ResearchAndDevelopment = 'RESEARCH_AND_DEVELOPMENT',
  Aerospace = 'AEROSPACE',
  MilitarySafety = 'MILITARY_SAFETY',
  OceanIndustryShipbuilding = 'OCEAN_INDUSTRY_SHIPBUILDING',
  AgricultureFarming = 'AGRICULTURE_FARMING',
  GadgetsPartsComponents = 'GADGETS_PARTS_COMPONENTS',
  KitchenFood = 'KITCHEN_FOOD',
  EducationToys = 'EDUCATION_TOYS',
  SportsOutdoors = 'SPORTS_OUTDOORS',
  FashionBeauty = 'FASHION_BEAUTY',
  InteriorLiving = 'INTERIOR_LIVING',
  Furniture = 'FURNITURE',
  Pets = 'PETS',
  PropsOfficeSupplies = 'PROPS_OFFICE_SUPPLIES',
  ArtsExhibition = 'ARTS_EXHIBITION',
  ArchitectureConstruction = 'ARCHITECTURE_CONSTRUCTION',
  PersonalHobby = 'PERSONAL_HOBBY',
  Etc = 'ETC'
}

/** 캐파 견적 서비스 타입 */
export enum CapaQuotationRecommendation {
  /** 강도가 중요해요 */
  Strength = 'STRENGTH',
  /** 열 변형이 적어야해요 */
  ThermalStrain = 'THERMAL_STRAIN',
  /** 내부식성이 중요해요 */
  CorrosionResistant = 'CORROSION_RESISTANT',
  /** 가벼워야해요 */
  Light = 'LIGHT',
  /** 상담 후 결정할게요 */
  DecideAfterConsulting = 'DECIDE_AFTER_CONSULTING',
  /** 기타(직접입력) */
  Etc = 'ETC',
  /** 표면품질이 중요해요 */
  SurfaceQuality = 'SURFACE_QUALITY',
  /** 유연성이 중요해요 */
  Flexibility = 'FLEXIBILITY',
  /** 공차가 중요해요 */
  Allowance = 'ALLOWANCE',
  /** 내충격성이 중요해요 */
  ShockResistance = 'SHOCK_RESISTANCE',
  /** 탄성이 높아야해요 */
  Elasticity = 'ELASTICITY'
}

/** CAPA RFQ Allow Open FILE Status */
export enum CapaQuotationRfqAllowOpenFileStatus {
  /** allowed */
  Allow = 'ALLOW',
  /** denied */
  Denied = 'DENIED',
  /** request */
  Request = 'REQUEST'
}

/** CAPAQuotationRfqAssemblyFile */
export type CapaQuotationRfqAssemblyFile = {
  __typename?: 'CAPAQuotationRfqAssemblyFile';
  fileId: Scalars['String'];
  fileName: Scalars['String'];
  quantity: Scalars['Float'];
  fileSize?: Maybe<Scalars['Float']>;
};

export type CapaQuotationRfqAvailableRfq = {
  __typename?: 'CAPAQuotationRfqAvailableRfq';
  id: Scalars['String'];
  isFavorite?: Maybe<Scalars['Boolean']>;
  thumbnailId?: Maybe<Scalars['String']>;
  projectName: Scalars['String'];
  organizationName?: Maybe<Scalars['String']>;
  managerName?: Maybe<Scalars['String']>;
  shortAddress?: Maybe<Scalars['String']>;
  serviceType: CapaQuotationServiceType;
  quantity?: Maybe<Scalars['Float']>;
  uniqueViews?: Maybe<Scalars['Float']>;
  chatRooms?: Maybe<Scalars['Float']>;
  isNew: Scalars['Boolean'];
  createdAt: Scalars['String'];
  status: CapaRfqStatus;
  detailedServiceType?: Maybe<CapaQuotationDetailedServiceType>;
  pageViews?: Maybe<Scalars['Float']>;
  eventType?: Maybe<CapaQuotationRfqEventType>;
};

export type CapaQuotationRfqAvailableRfqs = {
  __typename?: 'CAPAQuotationRfqAvailableRfqs';
  count: Scalars['Float'];
  rfqs?: Maybe<Array<CapaQuotationRfqAvailableRfq>>;
};

export type CapaQuotationRfqAvailableRfqsOutput = {
  __typename?: 'CAPAQuotationRfqAvailableRfqsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationRfqAvailableRfqs>;
};

export type CapaQuotationRfqDetail = {
  __typename?: 'CAPAQuotationRfqDetail';
  id: Scalars['String'];
  status?: Maybe<CapaRfqStatus>;
  isOldRfq?: Maybe<Scalars['Boolean']>;
  projectName?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['String']>;
  detailedRequest?: Maybe<Scalars['String']>;
  serviceType?: Maybe<CapaQuotationServiceType>;
  detailedServiceType?: Maybe<CapaQuotationDetailedServiceType>;
  optionalServices?: Maybe<Array<CapaQuotationOptionalService>>;
  dueNegotiable?: Maybe<Scalars['Boolean']>;
  maxEstimatedBudget?: Maybe<Scalars['Float']>;
  minEstimatedBudget?: Maybe<Scalars['Float']>;
  budgetOpen?: Maybe<Scalars['Boolean']>;
  projectPurpose?: Maybe<CapaQuotationProductPurpose>;
  projectPurposeDetail?: Maybe<Scalars['String']>;
  publicOpen?: Maybe<Scalars['Boolean']>;
  eventType?: Maybe<CapaQuotationRfqEventType>;
  manufacturingStage?: Maybe<CapaRfqManufacturingStage>;
  drawingFiles?: Maybe<Array<CapaQuotationRfqDrawingFile>>;
  referenceFiles?: Maybe<Array<CapaQuotationRfqReferenceFile>>;
  pcb?: Maybe<CapaPcbDetail>;
  design?: Maybe<CapaDesignDetail>;
  createdAt: Scalars['String'];
  consultingStartMethod?: Maybe<CapaConsultingStartMethod>;
  transaction?: Maybe<CapaQuotationRfqTransaction>;
  owner?: Maybe<CapaQuotationUser>;
  quotation?: Maybe<CapaQuotationRfqQuotation>;
  chatRoom?: Maybe<CapaQuotationChatRoom>;
  canDownload?: Maybe<Scalars['Boolean']>;
  favorite?: Maybe<Scalars['Boolean']>;
  isSendQuotation?: Maybe<Scalars['Boolean']>;
  isSendIntroduction?: Maybe<Scalars['Boolean']>;
};

export type CapaQuotationRfqDetailOutput = {
  __typename?: 'CAPAQuotationRfqDetailOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationRfqDetail>;
};

export type CapaQuotationRfqDrawingFile = {
  __typename?: 'CAPAQuotationRfqDrawingFile';
  fileId: Scalars['String'];
  fileName?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  material?: Maybe<CapaQuotationMaterial>;
  detailedMaterial?: Maybe<CapaQuotationDetailedMaterialType>;
  etc?: Maybe<Scalars['String']>;
  recommendation?: Maybe<Array<CapaQuotationRecommendation>>;
  fileSize?: Maybe<Scalars['Float']>;
};

/** CAPA RFQ EVENT TYPE */
export enum CapaQuotationRfqEventType {
  /** 일반적인 rfq */
  General = 'GENERAL',
  /** ITP 이벤트 타입 */
  Itp = 'ITP',
  /** 졸사빠 이벤트 타입 */
  Jsb = 'JSB',
  /** ITPX졸사빠 이벤트 타입 */
  Itpjsb = 'ITPJSB'
}

/** CAPAQuotationRfqFabricationFile */
export type CapaQuotationRfqFabricationFile = {
  __typename?: 'CAPAQuotationRfqFabricationFile';
  fileId: Scalars['String'];
  fileName: Scalars['String'];
  quantity: Scalars['Float'];
  thickness: Scalars['Float'];
  fileSize?: Maybe<Scalars['Float']>;
};

/** RfqFilter 정보 입력 */
export type CapaQuotationRfqFilterInput = {
  /** 캐파 견적 서비스 정보 입력 */
  services?: InputMaybe<Array<CapaRfqFilterQuotationServiceInput>>;
};

export type CapaQuotationRfqMyCompleteRfq = {
  __typename?: 'CAPAQuotationRfqMyCompleteRfq';
  id: Scalars['String'];
  projectName: Scalars['String'];
  organizationName: Scalars['String'];
  managerName: Scalars['String'];
  serviceType: CapaQuotationServiceType;
  thumbnailId?: Maybe<Scalars['String']>;
  confirmedAt: Scalars['String'];
  transactionComplete?: Maybe<Scalars['Boolean']>;
  completeAt?: Maybe<Scalars['String']>;
  reviewed: Scalars['Boolean'];
};

export type CapaQuotationRfqMyCompleteRfqOutput = {
  __typename?: 'CAPAQuotationRfqMyCompleteRfqOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaQuotationRfqMyCompleteRfq>>;
};

export type CapaQuotationRfqMyRfq = {
  __typename?: 'CAPAQuotationRfqMyRfq';
  id: Scalars['String'];
  projectName: Scalars['String'];
  organizationName?: Maybe<Scalars['String']>;
  shortAddress?: Maybe<Scalars['String']>;
  serviceType: CapaQuotationServiceType;
  detailedServiceType?: Maybe<CapaQuotationDetailedServiceType>;
  createdAt?: Maybe<Scalars['String']>;
  status: CapaRfqStatus;
  thumbnailId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  chatRoomStatus?: Maybe<CapaQuotationChatRoomStatus>;
  message?: Maybe<CapaQuotationChatMessageUnion>;
  unReadCount?: Maybe<Scalars['Float']>;
  eventType?: Maybe<CapaQuotationRfqEventType>;
};

export type CapaQuotationRfqMyRfqs = {
  __typename?: 'CAPAQuotationRfqMyRfqs';
  count: Scalars['Float'];
  rfqs?: Maybe<Array<CapaQuotationRfqMyRfq>>;
};

export type CapaQuotationRfqMyRfqsOutput = {
  __typename?: 'CAPAQuotationRfqMyRfqsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationRfqMyRfqs>;
};

export type CapaQuotationRfqPartner = {
  __typename?: 'CAPAQuotationRfqPartner';
  chatRoomId: Scalars['String'];
  quotationPartnerId: Scalars['String'];
  organizationName?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
  hasEvaluated?: Maybe<Scalars['Boolean']>;
  isNew?: Maybe<Scalars['Boolean']>;
  permission?: Maybe<CapaQuotationRfqAllowOpenFileStatus>;
  downloaded?: Maybe<Scalars['Boolean']>;
};

export type CapaQuotationRfqPartnerEvaluation = {
  __typename?: 'CAPAQuotationRfqPartnerEvaluation';
  kind?: Maybe<Scalars['Float']>;
  quick?: Maybe<Scalars['Float']>;
  detailed?: Maybe<Scalars['Float']>;
  helpful?: Maybe<Scalars['Float']>;
};

export type CapaQuotationRfqPartnerEvaluationOutput = {
  __typename?: 'CAPAQuotationRfqPartnerEvaluationOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationRfqPartnerEvaluation>;
};

export type CapaQuotationRfqPartnersOutput = {
  __typename?: 'CAPAQuotationRfqPartnersOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaQuotationRfqPartner>>;
};

export type CapaQuotationRfqPurchaseOrder = {
  __typename?: 'CAPAQuotationRfqPurchaseOrder';
  id: Scalars['String'];
  rfqId: Scalars['String'];
  chatRoomId?: Maybe<Scalars['String']>;
  /** 수주처 정보 */
  receiver?: Maybe<CapaQuotationRfqPurchaseOrderReceiver>;
  /** 발주처 정보 */
  publish?: Maybe<CapaQuotationRfqPurchaseOrderPublish>;
  pcb?: Maybe<CapaPcbDetail>;
  /** (견적서) */
  items?: Maybe<Array<CapaQuotationDetailedQuotationItem>>;
  /** pcb -제작 */
  pcbFabricationItems?: Maybe<Array<CapaQuotationDetailedPcbFabricationItem>>;
  /** pcb - 조립 */
  pcbAssemblyItems?: Maybe<Array<CapaQuotationDetailedPcbAssemblyItem>>;
  /** 공급가액(견적서) */
  quotation?: Maybe<Scalars['Float']>;
  /** 배송비(견적서) */
  deliveryCost?: Maybe<Scalars['Float']>;
  /** 최대 시안 수정 횟수(견적서) */
  maxDraftModificationCount?: Maybe<Scalars['Float']>;
  /** 수정 범위 및 추가 과금 기준(견적서) */
  draftModificationTerms?: Maybe<Scalars['String']>;
  /** 검수 기간 */
  inspectionPeriod?: Maybe<Scalars['Float']>;
  /** 검수 항목 */
  inspections?: Maybe<Array<CapaQuotationRfqPurchaseOrderInspection>>;
  /** 납품일 */
  shipDate?: Maybe<Scalars['String']>;
  /** 납품주소 */
  shipAddress?: Maybe<Scalars['String']>;
  /** 납품상세주소 */
  shipDetailAddress?: Maybe<Scalars['String']>;
  /** 이관 정보 */
  transfer?: Maybe<CapaRfqPurchaseOrderTransfer>;
  /** 결제 정보 */
  payments?: Maybe<Array<CapaQuotationRfqPurchaseOrderProvision>>;
  read?: Maybe<Scalars['Boolean']>;
  /** 발주서 확정 */
  isConfirmed?: Maybe<Scalars['Boolean']>;
  /** 수정 요청서 읽음 및 내용 */
  adjustRequest?: Maybe<CapaRfqAdjustRequestObject>;
  isRejected?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  quotationCreatedAt?: Maybe<Scalars['String']>;
  /** 최신 발주서 */
  latest?: Maybe<Scalars['Boolean']>;
  /** 발주서 상태 */
  status: CapaPurchaseOrderStatus;
  /** 결제 대금 */
  paymentAmount?: Maybe<Scalars['Float']>;
  /** 취소,환불,거절 정보 */
  paymentCancelData?: Maybe<FetchPurchaseOrderPaymentCancelData>;
  /** 결제 정보 */
  paymentDataList?: Maybe<Array<FetchPurchaseOrderPaymentData>>;
  /** 배송 정보 */
  shippingDataList?: Maybe<Array<ShippingDataModel>>;
};

export type CapaQuotationRfqPurchaseOrderInspection = {
  __typename?: 'CAPAQuotationRfqPurchaseOrderInspection';
  /** 검수 조건 */
  inspectionType?: Maybe<CapaRfqPurchaseOrderInspectionType>;
  /** 검수 요청 사항 */
  inspectionRequest?: Maybe<Scalars['String']>;
};

export type CapaQuotationRfqPurchaseOrderOutput = {
  __typename?: 'CAPAQuotationRfqPurchaseOrderOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationRfqPurchaseOrder>;
};

export type CapaQuotationRfqPurchaseOrderProvision = {
  __typename?: 'CAPAQuotationRfqPurchaseOrderProvision';
  /** 지급 날짜 */
  provisionDate?: Maybe<Scalars['String']>;
  /** 지급 비율 */
  provisionPercent?: Maybe<Scalars['Float']>;
  /** 지급 금액 */
  provisionCost?: Maybe<Scalars['Float']>;
  /** 지급 타입 */
  provisionType?: Maybe<CapaRfqPurchaseOrderPaymentProvisionType>;
  /** 기타(직접입력) */
  provisionEtc?: Maybe<Scalars['String']>;
};

export type CapaQuotationRfqPurchaseOrderPublish = {
  __typename?: 'CAPAQuotationRfqPurchaseOrderPublish';
  /** 고객 상태 */
  quotationUserStatus?: Maybe<CapaQuotationUserStatus>;
  /** 고객 회사명 */
  organizationName?: Maybe<Scalars['String']>;
  /** 담당자명 */
  managerName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  /** 사업자등록번호 */
  companyRegistrationNumber?: Maybe<Scalars['String']>;
};

export type CapaQuotationRfqPurchaseOrderReceiver = {
  __typename?: 'CAPAQuotationRfqPurchaseOrderReceiver';
  /** 파트너 id */
  quotationPartnerId: Scalars['String'];
  /** 파트너 상태 */
  quotationPartnerStatus: CapaQuotationPartnerStatus;
  /** 파트너 회사명 */
  organizationName?: Maybe<Scalars['String']>;
  /** 파트너 주소 */
  address?: Maybe<Scalars['String']>;
  /** 담당자명 */
  managerName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  /** 사업자등록번호 */
  companyRegistrationNumber?: Maybe<Scalars['String']>;
};

export type CapaQuotationRfqPurchaseOrdersOutput = {
  __typename?: 'CAPAQuotationRfqPurchaseOrdersOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaQuotationRfqPurchaseOrder>>;
};

export type CapaQuotationRfqQuotation = {
  __typename?: 'CAPAQuotationRfqQuotation';
  id: Scalars['ID'];
  rfqId?: Maybe<Scalars['String']>;
  messageId?: Maybe<Scalars['String']>;
  quotationPartnerId?: Maybe<Scalars['String']>;
  /** 견적가 */
  quotation: Scalars['Float'];
  excludeDeliveryFee?: Maybe<Scalars['Boolean']>;
};

export type CapaQuotationRfqQuotationOptionalService = {
  __typename?: 'CAPAQuotationRfqQuotationOptionalService';
  serviceType?: Maybe<CapaQuotationServiceType>;
};

export type CapaQuotationRfqReferenceFile = {
  __typename?: 'CAPAQuotationRfqReferenceFile';
  fileId: Scalars['String'];
  fileName: Scalars['String'];
  fileSize?: Maybe<Scalars['Float']>;
};

export type CapaQuotationRfqReview = {
  __typename?: 'CAPAQuotationRfqReview';
  dueDate?: Maybe<Scalars['Float']>;
  quality?: Maybe<Scalars['Float']>;
  publicComment?: Maybe<Scalars['String']>;
  privateComment?: Maybe<Scalars['String']>;
  replyComment?: Maybe<Scalars['String']>;
  repliedAt?: Maybe<Scalars['String']>;
};

export type CapaQuotationRfqSearch = {
  __typename?: 'CAPAQuotationRfqSearch';
  rfqId?: Maybe<Scalars['String']>;
  thumbnailId?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  shortAddress?: Maybe<Scalars['String']>;
  serviceType?: Maybe<CapaQuotationServiceType>;
  detailedServiceType?: Maybe<CapaQuotationDetailedServiceType>;
  detailedRequest?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  chatRooms?: Maybe<Scalars['Float']>;
  eventType?: Maybe<CapaQuotationRfqEventType>;
};

export type CapaQuotationRfqTransaction = {
  __typename?: 'CAPAQuotationRfqTransaction';
  rfqId: Scalars['String'];
  quotationPartnerId: Scalars['String'];
  organizationName?: Maybe<Scalars['String']>;
  isItp?: Maybe<Scalars['Boolean']>;
  transactionComplete?: Maybe<Scalars['Boolean']>;
  completeCost?: Maybe<Scalars['Float']>;
  completeAt?: Maybe<Scalars['String']>;
};

export type CapaQuotationSearch = {
  __typename?: 'CAPAQuotationSearch';
  rfqs: Array<CapaQuotationRfqSearch>;
  messages: Array<CapaQuotationMessaegeSearch>;
};

export type CapaQuotationSearchOutput = {
  __typename?: 'CAPAQuotationSearchOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationSearch>;
};

export type CapaQuotationService = {
  __typename?: 'CAPAQuotationService';
  service?: Maybe<CapaQuotationServiceType>;
  status: CapaCapabilitiesStatusType;
  detailedServices?: Maybe<Array<CapaQuotationDetailedService>>;
  optionalServices?: Maybe<Array<CapaQuotationServiceType>>;
};

/** 캐파 견적 서비스 정보 입력 */
export type CapaQuotationServiceInput = {
  /** 캐파 견적 서비스 타입 */
  service?: InputMaybe<CapaQuotationServiceType>;
  /** 해당 serviceType의 상태값 */
  status: CapaCapabilitiesStatusType;
  /** 캐파 견적 상세 서비스 정보 입력 */
  detailedServices?: InputMaybe<Array<CapaQuotationDetailedServiceInput>>;
  /** 추가 서비스 타입 (벤딩, 용접, 시제품, 제품디자인 */
  optionalServices?: InputMaybe<Array<CapaQuotationServiceType>>;
};

export type CapaQuotationServiceRating = {
  __typename?: 'CAPAQuotationServiceRating';
  rated: Scalars['Boolean'];
  rating?: Maybe<Scalars['Float']>;
  comment?: Maybe<Scalars['String']>;
};

export type CapaQuotationServiceRatingOutput = {
  __typename?: 'CAPAQuotationServiceRatingOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationServiceRating>;
};

/** 캐파 견적 서비스 타입 */
export enum CapaQuotationServiceType {
  /** CNC */
  Cnc = 'CNC',
  /** 3D 프린터 */
  Printing = 'PRINTING',
  /** 금형사출 */
  Inj = 'INJ',
  /** 판금가공 */
  SheetMetal = 'SHEET_METAL',
  /** 기구설계 */
  MechanicalDesign = 'MECHANICAL_DESIGN',
  /** 주조 */
  Casting = 'CASTING',
  /** 용접 판금 가공 */
  Weilding = 'WEILDING',
  /** 벤딩 판금 가공 */
  Bending = 'BENDING',
  /** 제품 디자인 설계 */
  ProductDesign = 'PRODUCT_DESIGN',
  /** 시제품 제작 설계 */
  Prototyping = 'PROTOTYPING',
  /** 전자회로 */
  Pcb = 'PCB',
  /** 디자인/설계 */
  Design = 'DESIGN'
}

/** CAPAQuotationSharedFileAnnotationStatus */
export enum CapaQuotationSharedFileAnnotationStatus {
  /** REGISTERED */
  Registered = 'REGISTERED',
  /** DELETED */
  Deleted = 'DELETED'
}

export type CapaQuotationSimpleQuotation = {
  __typename?: 'CAPAQuotationSimpleQuotation';
  quotation?: Maybe<Scalars['Float']>;
  excludeDeliveryFee?: Maybe<Scalars['Boolean']>;
  etc?: Maybe<Scalars['String']>;
};

export type CapaQuotationSpecificAnnotationComment = {
  __typename?: 'CAPAQuotationSpecificAnnotationComment';
  id?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  isParent?: Maybe<Scalars['Boolean']>;
  comment?: Maybe<Scalars['String']>;
  status?: Maybe<CapaQuotationSharedFileAnnotationStatus>;
  edited?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type CapaQuotationUpdate = {
  __typename?: 'CAPAQuotationUpdate';
  email?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  chatRoomId?: Maybe<Scalars['String']>;
  quotationSharedFileId?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  nodeId?: Maybe<Scalars['Float']>;
  anchorPos?: Maybe<Capa3DPos>;
  handlePos?: Maybe<Capa3DPos>;
  annotationId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['String']>;
  annotationCreatedAt?: Maybe<Scalars['String']>;
  annotationUpdatedAt?: Maybe<Scalars['String']>;
  commentCreatedAt?: Maybe<Scalars['String']>;
  commentUpdatedAt?: Maybe<Scalars['String']>;
  status?: Maybe<CapaQuotationSharedFileAnnotationStatus>;
  /** 업데이트 타입 */
  type?: Maybe<CapaQuotationUpdateType>;
};

export type CapaQuotationUpdateOutput = {
  __typename?: 'CAPAQuotationUpdateOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationUpdate>;
};

export enum CapaQuotationUpdateType {
  AnnotationAdd = 'ANNOTATION_ADD',
  AnnotationUpdate = 'ANNOTATION_UPDATE',
  AnnotationDelete = 'ANNOTATION_DELETE',
  AnnotationOpen = 'ANNOTATION_OPEN',
  AnnotationCommentAdd = 'ANNOTATION_COMMENT_ADD',
  AnnotationCommentUpdate = 'ANNOTATION_COMMENT_UPDATE',
  AnnotationCommentDelete = 'ANNOTATION_COMMENT_DELETE'
}

export type CapaQuotationUser = {
  __typename?: 'CAPAQuotationUser';
  id: Scalars['ID'];
  email: Scalars['String'];
  /** 상태 CAPAQuotationUserStatus */
  status: CapaQuotationUserStatus;
  /** 이름 (담당자명) */
  managerName?: Maybe<Scalars['String']>;
  /** 휴대폰 번호 */
  cellphoneNumber?: Maybe<Scalars['String']>;
  /** 주소 */
  fullAddress?: Maybe<Scalars['String']>;
  /** 짧은 주소 */
  shortAddress?: Maybe<Scalars['String']>;
  /** 사업자등록번호 */
  companyRegistrationNumber?: Maybe<Scalars['String']>;
  /** 사업자 여부 */
  bizType?: Maybe<CapaQuotationUserBizType>;
  notificationFilter?: Maybe<CapaQuotationUserNotificationFilter>;
  /** 회사 / 단체명 */
  organizationName?: Maybe<Scalars['String']>;
  /** 회사소개 */
  companyIntroduction?: Maybe<Scalars['String']>;
  /** 웹사이트 */
  website?: Maybe<Scalars['String']>;
  /** 부서 */
  department?: Maybe<Scalars['String']>;
  /** 직함 */
  position?: Maybe<Scalars['String']>;
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgreed?: Maybe<Scalars['Boolean']>;
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgreed?: Maybe<Scalars['Boolean']>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgreed?: Maybe<Scalars['Boolean']>;
  /** [필수] 결제 서비스 이용 약관 동의 */
  paymentAgreed?: Maybe<Scalars['Boolean']>;
  /** 추천인 ID */
  referralUserId?: Maybe<Scalars['String']>;
  /** 생성일 */
  createdAt: Scalars['String'];
  /** 수정일 */
  updatedAt: Scalars['String'];
  files?: Maybe<Array<CapaQuotationUserFile>>;
  /** 본인인증 상태 */
  verificationType?: Maybe<CapaQuotationUserVerificationType>;
  /** 본인인증 이름 */
  verificationName?: Maybe<Scalars['String']>;
  /** 본인인증 생년월일 */
  verificationBirthDate?: Maybe<Scalars['String']>;
  /** 본인의 환불계좌 정보 */
  myRefundAccount?: Maybe<FetchMyAccountModel>;
};

export type CapaQuotationUserBo = {
  __typename?: 'CAPAQuotationUserBO';
  id: Scalars['ID'];
  email: Scalars['String'];
  /** 상태 CAPAQuotationUserStatus */
  status: CapaQuotationUserStatus;
  /** 이름 (담당자명) */
  managerName?: Maybe<Scalars['String']>;
  /** 휴대폰 번호 */
  cellphoneNumber?: Maybe<Scalars['String']>;
  /** 주소 */
  fullAddress?: Maybe<Scalars['String']>;
  /** 짧은 주소 */
  shortAddress?: Maybe<Scalars['String']>;
  /** 사업자등록번호 */
  companyRegistrationNumber?: Maybe<Scalars['String']>;
  /** 사업자 여부 */
  bizType?: Maybe<CapaQuotationUserBizType>;
  /** 회사 / 단체명 */
  organizationName?: Maybe<Scalars['String']>;
  /** 회사소개 */
  companyIntroduction?: Maybe<Scalars['String']>;
  /** 웹사이트 */
  website?: Maybe<Scalars['String']>;
  /** 부서 */
  department?: Maybe<Scalars['String']>;
  /** 직함 */
  position?: Maybe<Scalars['String']>;
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgreed?: Maybe<Scalars['Boolean']>;
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgreed?: Maybe<Scalars['Boolean']>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgreed?: Maybe<Scalars['Boolean']>;
  /** 추천인 ID */
  referralUserId?: Maybe<Scalars['String']>;
  /** CAPA 서비스를 어떻게 알게 되셨나요? (복수 선택 가능) */
  inflowRoute?: Maybe<Array<CapaInflowRoute>>;
  /** 추천 회사명/기관명 */
  referralCompany?: Maybe<Scalars['String']>;
  /** 생성일 */
  createdAt: Scalars['String'];
  /** 수정일 */
  updatedAt: Scalars['String'];
  /** 탈퇴이유 */
  withdrawnReason?: Maybe<CapaWithdrawnQuotationUserReason>;
  files?: Maybe<Array<CapaQuotationUserFile>>;
  refundAccounts?: Maybe<Array<CapaQuotationUserRefundBankAccountModel>>;
};

export type CapaQuotationUserBoOutput = {
  __typename?: 'CAPAQuotationUserBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationUserBo>;
};

/** 사업자 여부 */
export enum CapaQuotationUserBizType {
  /** 사업자등록번호가 있음 */
  Biz = 'BIZ',
  /** 법인사업자 */
  Corporate = 'CORPORATE',
  /** 개인사업자 */
  SelfEmployed = 'SELF_EMPLOYED',
  /** 사업자등록번호가 없음 [단체] */
  Organization = 'ORGANIZATION',
  /** 사업자등록번호가 없음 [개인] */
  Individual = 'INDIVIDUAL'
}

export type CapaQuotationUserCertificationModel = {
  __typename?: 'CAPAQuotationUserCertificationModel';
  /** 아임포트 SMS본인인증처리 고유번호 */
  impUid: Scalars['String'];
  /** 가맹점 주문번호 */
  merchantUid?: Maybe<Scalars['String']>;
  /** PG사 SMS본인인증결과 고유번호 */
  pgTid?: Maybe<Scalars['String']>;
  /** SMS본인인증 제공 PG사 명칭. danal(다날) , */
  pgProvider: Scalars['String'];
  /** 인증결과-실명 */
  name?: Maybe<Scalars['String']>;
  /** 인증결과-성별. male:남성, female:여성 , */
  gender?: Maybe<Scalars['String']>;
  /** birthday 를 사용해주세요. 관련공지내용 인증결과-생년월일 UNIX timestamp. 연, 월, 일만 의미있고 시,분,초는 의미없음 , */
  birth?: Maybe<Scalars['String']>;
  /** 인증결과-생년월일 ISO8601 형식의 문자열. YYYY-MM-DD 10자리 문자열 , */
  birthday?: Maybe<Scalars['String']>;
  /** 인증결과-외국인여부. true:외국인, false:내국인. 다날 본인인증서비스 계약시 외국인 구분기능 추가 요청을 해주셔야 사용이 가능합니다. */
  foreigner: Scalars['String'];
  /** 인증결과-사용된 휴대폰번호(신용카드 본인인증의 경우 해당사항없음). 특수기호없이 숫자로만 구성된 휴대폰번호가 전달됨. 통신사 사전승인이 이뤄지지 않으면 phone 속성은 존재하지 않습니다. 통신사 사전승인이 필요하므로 cs@iamport.kr 로 다날 CPID 와 함께 사용승인 요청주시면 안내도와드리겠습니다. */
  phone?: Maybe<Scalars['String']>;
  /** 아임포트 SMS본인인증처리 고유번호 */
  carrier?: Maybe<Scalars['String']>;
  /** 인증성공여부 */
  certified?: Maybe<Scalars['String']>;
  /** 인증처리시각 UNIX timestamp */
  certifiedAt?: Maybe<Scalars['String']>;
  /** 개인 고유구분 식별키(다날 매뉴얼 기준 CI) */
  uniqueKey?: Maybe<Scalars['String']>;
  /** 가맹점 내 개인 고유구분 식별키(다날 매뉴얼 기준 DI). 본인인증 PG MID별로 할당되는 개인 식별키 */
  uniqueInSite?: Maybe<Scalars['String']>;
  /** 본인인증 프로세스가 진행된 웹 페이지의 URL */
  origin?: Maybe<Scalars['String']>;
  /** true:외국인, false:내국인. 다날 본인인증서비스 계약시 외국인 구분기능 추가 요청을 해주셔야 사용이 가능합니다. */
  foreignerV2?: Maybe<Scalars['String']>;
};

export type CapaQuotationUserChatRoom = {
  __typename?: 'CAPAQuotationUserChatRoom';
  chatRoomId?: Maybe<Scalars['ID']>;
  chatRoomStatus?: Maybe<CapaQuotationChatRoomStatus>;
  rfqId?: Maybe<Scalars['ID']>;
  isOldRfq?: Maybe<Scalars['Boolean']>;
  profileId?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  serviceType?: Maybe<CapaQuotationServiceType>;
  thumbnailId?: Maybe<Scalars['String']>;
  quotationPartnerId?: Maybe<Scalars['String']>;
  quotationPartnerStatus?: Maybe<Scalars['String']>;
  unReadCount?: Maybe<Scalars['Float']>;
  lastMessage?: Maybe<CapaQuotationChatMessageUnion>;
  lastMessageCreatedAt?: Maybe<Scalars['String']>;
  rfqStatus?: Maybe<CapaRfqStatus>;
  rfqCreatedAt?: Maybe<Scalars['String']>;
  managerName?: Maybe<Scalars['String']>;
  shortAddress?: Maybe<Scalars['String']>;
  purchaseOrderStatus?: Maybe<CapaPurchaseOrderStatus>;
  /** 기획에서 요구하는 상태 를 지정해서 반환. */
  searchProjectStatusTypeEnum?: Maybe<ProjectStatusType>;
  quantity?: Maybe<Scalars['String']>;
};

export type CapaQuotationUserChatRooms = {
  __typename?: 'CAPAQuotationUserChatRooms';
  totalChatRoomsCount?: Maybe<Scalars['Float']>;
  currentChatRoomCount?: Maybe<Scalars['Float']>;
  chatRooms?: Maybe<Array<CapaQuotationUserChatRoom>>;
  /** 읽지 않은 메세지 수 */
  totalUnReadMessagesCount?: Maybe<Array<CapaQuotationUserUnReadMessagesCount>>;
};

export type CapaQuotationUserChatRoomsOutput = {
  __typename?: 'CAPAQuotationUserChatRoomsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationUserChatRooms>;
};

export type CapaQuotationUserFile = {
  __typename?: 'CAPAQuotationUserFile';
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<CapaQuotationUserFileType>;
};

/** 캐파 견적 유저 파일 종류 */
export enum CapaQuotationUserFileType {
  /** 프로필 */
  Profile = 'PROFILE'
}

export type CapaQuotationUserGnb = {
  __typename?: 'CAPAQuotationUserGNB';
  /** 읽지 않은 견적서 및 회사소개서 수 */
  newQuotationAndIntroductionCount: Scalars['Float'];
  /** 모든 채팅방 unread chat count */
  newChatCount: Scalars['Float'];
  /** 견적 상태 채팅방 unread chat count */
  newConsultingChatCount: Scalars['Float'];
  /** 발주 상태 채팅방 unread chat count */
  newConfirmedChatCount: Scalars['Float'];
  newProjectManagementCount: Scalars['Float'];
  newPaymentManagementCount?: Maybe<Scalars['Float']>;
};

export type CapaQuotationUserGnbOutput = {
  __typename?: 'CAPAQuotationUserGNBOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationUserGnb>;
};

/** notification filter */
export type CapaQuotationUserNotificationFilter = {
  __typename?: 'CAPAQuotationUserNotificationFilter';
  /** 방해금지 시간 */
  doNotDisturb?: Maybe<CapaDoNotDisturbFilter>;
  /** 프로젝트 이메일 알림 */
  projectEmail?: Maybe<Scalars['Boolean']>;
  /** 프로젝트 카카오 (실패시 SMS) 알림 */
  projectSMS?: Maybe<Scalars['Boolean']>;
  /** 프로젝트 알림 설정 */
  projectFilters?: Maybe<Array<CapaRfqProjectFilter>>;
  chatEmail?: Maybe<Scalars['Boolean']>;
  chatSMS?: Maybe<Scalars['Boolean']>;
  chatPush?: Maybe<Scalars['Boolean']>;
  /** 캐파 소식 및 혜택 이메일 알림 */
  newsEmail?: Maybe<Scalars['Boolean']>;
  /** 캐파 소식 및 혜택 카카오 (실패시 SMS) 알림 */
  newsSMS?: Maybe<Scalars['Boolean']>;
};

/** notification filter */
export type CapaQuotationUserNotificationFilterInput = {
  /** 방해금지 시간 */
  doNotDisturb?: InputMaybe<CapaDoNotDisturbFilterInput>;
  /** 프로젝트 이메일 알림 */
  projectEmail?: InputMaybe<Scalars['Boolean']>;
  /** 프로젝트 카카오 (실패시 SMS) 알림 */
  projectSMS?: InputMaybe<Scalars['Boolean']>;
  /** 프로젝트 알림 설정 */
  projectFilters?: InputMaybe<Array<CapaRfqProjectFilterInput>>;
  /** email yes/no for new chat messages */
  chatEmail?: InputMaybe<Scalars['Boolean']>;
  /** sms yes/no for new chat messages */
  chatSMS?: InputMaybe<Scalars['Boolean']>;
  /** push notification yes/no for new chat messages */
  chatPush?: InputMaybe<Scalars['Boolean']>;
  /** 캐파 소식 및 혜택 이메일 알림 */
  newsEmail?: InputMaybe<Scalars['Boolean']>;
  /** 캐파 소식 및 혜택 카카오 (실패시 SMS) 알림 */
  newsSMS?: InputMaybe<Scalars['Boolean']>;
};

export type CapaQuotationUserOutput = {
  __typename?: 'CAPAQuotationUserOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationUser>;
};

/** CAPAQuotationUserProjectManagementList */
export type CapaQuotationUserProjectManagement = {
  __typename?: 'CAPAQuotationUserProjectManagement';
  rfqId: Scalars['String'];
  serviceType: CapaQuotationServiceType;
  projectName: Scalars['String'];
  thumbnail?: Maybe<Scalars['String']>;
  type?: Maybe<CapaRfqProjectManagementType>;
  isNew: Scalars['Boolean'];
  partnerId: Scalars['String'];
  chatRoomId: Scalars['String'];
  createdAt: Scalars['String'];
};

export type CapaQuotationUserRefundBankAccountModel = {
  __typename?: 'CAPAQuotationUserRefundBankAccountModel';
  id: Scalars['String'];
  quotationUserId: Scalars['String'];
  seq: Scalars['Float'];
  bankCode: CapaBankCode;
  account: Scalars['String'];
  holderName: Scalars['String'];
  holderPhone: Scalars['String'];
  createdAt: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type CapaQuotationUserRefundBankAccountModelsOutput = {
  __typename?: 'CAPAQuotationUserRefundBankAccountModelsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaQuotationUserRefundBankAccountModel>>;
};

export type CapaQuotationUserRfq = {
  __typename?: 'CAPAQuotationUserRfq';
  rfqId?: Maybe<Scalars['String']>;
  rfqStatus?: Maybe<CapaRfqStatus>;
  projectName?: Maybe<Scalars['String']>;
  serviceType?: Maybe<CapaQuotationServiceType>;
  createdAt?: Maybe<Scalars['String']>;
  thumbnailId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  protoQuantity?: Maybe<Scalars['Float']>;
  uniqueViews?: Maybe<Scalars['Float']>;
  receivedQuotationCount?: Maybe<Scalars['Float']>;
  newQuotationCount?: Maybe<Scalars['Float']>;
  newIntroductionCount?: Maybe<Scalars['Float']>;
  eventType?: Maybe<CapaQuotationRfqEventType>;
  itpEventRegistered?: Maybe<Scalars['Boolean']>;
  itpEventSent?: Maybe<Scalars['Boolean']>;
  isItpPartner?: Maybe<Scalars['Boolean']>;
  jsbEventRegistered?: Maybe<Scalars['Boolean']>;
  jsbEventSent?: Maybe<Scalars['Boolean']>;
  /** 발주서(업체 확정) 발행 여부 */
  isTransaction?: Maybe<Scalars['Boolean']>;
  /** 상담 시작 방식 */
  consultingStartMethod?: Maybe<CapaConsultingStartMethod>;
  purchaseOrderId?: Maybe<Scalars['String']>;
  /** 발주서 상태 */
  purchaseOrderStatus?: Maybe<CapaPurchaseOrderStatus>;
  /** 기획에서 요구하는 상태 를 지정해서 반환. */
  searchProjectStatusTypeEnum?: Maybe<ProjectStatusType>;
  /** 파트너 로고  */
  profileId?: Maybe<Scalars['String']>;
};

/** 고객이 리뷰 가능한 목록 */
export type CapaQuotationUserRfqAvailableReviewOutput = {
  __typename?: 'CAPAQuotationUserRfqAvailableReviewOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationUserRfqAvailableReviewsResult>;
};

export type CapaQuotationUserRfqAvailableReviewsResult = {
  __typename?: 'CAPAQuotationUserRfqAvailableReviewsResult';
  rfqs: Array<CapaRfqAvailableReviews>;
  availableReviewCount: Scalars['Float'];
};

export type CapaQuotationUserRfqBo = {
  __typename?: 'CAPAQuotationUserRfqBO';
  id?: Maybe<Scalars['String']>;
  rfqId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  serviceType?: Maybe<CapaQuotationServiceType>;
  dueDate?: Maybe<Scalars['String']>;
  status?: Maybe<CapaRfqStatus>;
  openedChatRooms?: Maybe<Scalars['Float']>;
  closedChatRooms?: Maybe<Scalars['Float']>;
  partnersSentQuotation?: Maybe<Scalars['Float']>;
  hasPurchaseOrder?: Maybe<Scalars['Boolean']>;
  isConfirmed?: Maybe<Scalars['Boolean']>;
  isComplete?: Maybe<Scalars['Boolean']>;
  intoductionSuggestionCount?: Maybe<Scalars['Float']>;
  quotationSuggestionCount?: Maybe<Scalars['Float']>;
  totalSuggetionCount?: Maybe<Scalars['Float']>;
};

export type CapaQuotationUserRfqDetail = {
  __typename?: 'CAPAQuotationUserRfqDetail';
  id: Scalars['String'];
  status?: Maybe<CapaRfqStatus>;
  isOldRfq?: Maybe<Scalars['Boolean']>;
  projectName?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['String']>;
  detailedRequest?: Maybe<Scalars['String']>;
  serviceType?: Maybe<CapaQuotationServiceType>;
  detailedServiceType?: Maybe<CapaQuotationDetailedServiceType>;
  optionalServices?: Maybe<Array<CapaQuotationOptionalService>>;
  dueNegotiable?: Maybe<Scalars['Boolean']>;
  maxEstimatedBudget?: Maybe<Scalars['Float']>;
  minEstimatedBudget?: Maybe<Scalars['Float']>;
  budgetOpen?: Maybe<Scalars['Boolean']>;
  projectPurpose?: Maybe<CapaQuotationProductPurpose>;
  projectPurposeDetail?: Maybe<Scalars['String']>;
  publicOpen?: Maybe<Scalars['Boolean']>;
  eventType?: Maybe<CapaQuotationRfqEventType>;
  manufacturingStage?: Maybe<CapaRfqManufacturingStage>;
  drawingFiles?: Maybe<Array<CapaQuotationRfqDrawingFile>>;
  referenceFiles?: Maybe<Array<CapaQuotationRfqReferenceFile>>;
  pcb?: Maybe<CapaPcbDetail>;
  design?: Maybe<CapaDesignDetail>;
  createdAt: Scalars['String'];
  consultingStartMethod?: Maybe<CapaConsultingStartMethod>;
  transaction?: Maybe<CapaQuotationRfqTransaction>;
  chatRoom?: Maybe<Array<CapaQuotationChatRoom>>;
  review?: Maybe<CapaQuotationRfqReview>;
  itpEvent?: Maybe<CapaItpEventBo>;
  jsbEvent?: Maybe<CapaJsbEventBo>;
};

export type CapaQuotationUserRfqDetailOutput = {
  __typename?: 'CAPAQuotationUserRfqDetailOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationUserRfqDetail>;
};

/** 고객이 작성한 리뷰 목록 */
export type CapaQuotationUserRfqReviewsOutput = {
  __typename?: 'CAPAQuotationUserRfqReviewsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaRfqReview>>;
};

export type CapaQuotationUserRfqs = {
  __typename?: 'CAPAQuotationUserRfqs';
  count?: Maybe<Scalars['Float']>;
  rfqs?: Maybe<Array<CapaQuotationUserRfq>>;
};

export type CapaQuotationUserRfqsBoOutput = {
  __typename?: 'CAPAQuotationUserRfqsBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaQuotationUserRfqBo>>;
};

export type CapaQuotationUserRfqsOutput = {
  __typename?: 'CAPAQuotationUserRfqsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationUserRfqs>;
};

export enum CapaQuotationUserStatus {
  Registered = 'REGISTERED',
  Deleted = 'DELETED'
}

export enum CapaQuotationUserType {
  Client = 'CLIENT',
  Partner = 'PARTNER'
}

/** 파트너가 읽지 않은 메세지들의 수 (채팅방의 진척도에 따라 구분) */
export type CapaQuotationUserUnReadMessagesCount = {
  __typename?: 'CAPAQuotationUserUnReadMessagesCount';
  /** 해당 채팅방의 진척도 */
  chatRoomFilter?: Maybe<CapaQuotationChatRoomsFilterType>;
  /** 읽지 않은 메세지들의 총 수  */
  total?: Maybe<Scalars['Float']>;
};

export enum CapaQuotationUserVerificationType {
  /** 본인 인증 완료 상태 */
  Verified = 'VERIFIED',
  /** 본인 미인증 상태 */
  Unverified = 'UNVERIFIED'
}

/** 서비스 평가 목록 및 총 개수 */
export type CapaRatingsAndCount = {
  __typename?: 'CAPARatingsAndCount';
  ratings?: Maybe<Array<CapaServiceRatingBo>>;
  count?: Maybe<Scalars['Float']>;
};

export type CapaReceiveComplaintQuotationChatMessageModel = {
  __typename?: 'CAPAReceiveComplaintQuotationChatMessageModel';
  rfqInfo: CapaComplaintRfqInfoModel;
  userInfo: CapaComplaintUserInfoModel;
  message?: Maybe<Scalars['String']>;
  /** 생성일 */
  createdAt: Scalars['String'];
  complaintType: CapaBypassComplaintType;
  complaint?: Maybe<Scalars['String']>;
  chatRoomId: Scalars['String'];
};

export type CapaReceiveComplaintQuotationChatMessageOutput = {
  __typename?: 'CAPAReceiveComplaintQuotationChatMessageOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaComplaintQuotationChatMessageModel>;
};

/** 추천인 코드 정보 */
export type CapaReferral = {
  __typename?: 'CAPAReferral';
  /** 추천인 코드 */
  referralId: Scalars['ID'];
};

/** 추천인 코드 정보 */
export type CapaReferralOut = {
  __typename?: 'CAPAReferralOut';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaReferral>;
};

/** 리뷰 평점 비율 */
export type CapaReviewPointRatio = {
  __typename?: 'CAPAReviewPointRatio';
  one: Scalars['Float'];
  two: Scalars['Float'];
  three: Scalars['Float'];
  four: Scalars['Float'];
  five: Scalars['Float'];
};

export type CapaReviewableRfq = {
  __typename?: 'CAPAReviewableRfq';
  id: Scalars['String'];
  projectName: Scalars['String'];
  organizationName?: Maybe<Scalars['String']>;
  completeAt?: Maybe<Scalars['String']>;
  thumbnailId?: Maybe<Scalars['String']>;
};

export type CapaReviewableRfqsOutput = {
  __typename?: 'CAPAReviewableRfqsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaReviewableRfq>>;
};

export type CapaRfqAdjustRequestObject = {
  __typename?: 'CAPARfqAdjustRequestObject';
  read?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
};

export enum CapaRfqAdjustRequestType {
  /** QUOTATION */
  Quotation = 'QUOTATION',
  /** PURCHASE_ORDER */
  PurchaseOrder = 'PURCHASE_ORDER'
}

export type CapaRfqAvailableReviews = {
  __typename?: 'CAPARfqAvailableReviews';
  rfqId: Scalars['String'];
  serviceType?: Maybe<CapaQuotationServiceType>;
  projectName: Scalars['String'];
  /** rfq 생성일 */
  rfqCreatedAt?: Maybe<Scalars['String']>;
  thumbnailId?: Maybe<Scalars['String']>;
  reviews: Array<CapaAvailableReview>;
};

export type CapaRfqBo = {
  __typename?: 'CAPARfqBO';
  rfqId: Scalars['ID'];
  createdAt: Scalars['String'];
  serviceType?: Maybe<CapaQuotationServiceType>;
  projectPurpose?: Maybe<CapaQuotationProductPurpose>;
  projectName?: Maybe<Scalars['String']>;
  managerName?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  /** 총 수량 */
  totalCount?: Maybe<Scalars['Float']>;
  status: CapaRfqStatus;
  viewCount?: Maybe<Scalars['Float']>;
  chatRoomCount?: Maybe<Scalars['Float']>;
  /** 견적 수 */
  quotationCount?: Maybe<Scalars['Float']>;
  /** 견적서로 상담 제안한 수 */
  quotationSuggestionCount?: Maybe<Scalars['Float']>;
  /** 소개서로 상담 제안한 수 */
  introductionSuggestionCount?: Maybe<Scalars['Float']>;
  /** 전체(견적 + 상담) 상담 제안한 수 */
  totalSuggestionCount?: Maybe<Scalars['Float']>;
  /** 발주 유무 */
  hasPurchaseOrder?: Maybe<Scalars['Boolean']>;
};

export type CapaRfqChatRoomsBo = {
  __typename?: 'CAPARfqChatRoomsBO';
  id?: Maybe<Scalars['String']>;
  rfqId?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  managerName?: Maybe<Scalars['String']>;
  quotationPartnerId?: Maybe<Scalars['String']>;
  quotationCreatedDates?: Maybe<Array<Scalars['String']>>;
  purchaseOrderCreatedDates?: Maybe<Array<Scalars['String']>>;
  quotation?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['String']>;
  isConfirmed?: Maybe<Scalars['Boolean']>;
  isComplete?: Maybe<Scalars['Boolean']>;
  annotationsCommentCount?: Maybe<Scalars['Float']>;
  annotations?: Maybe<Array<CapaQuotationChatRoomAnnotationCommentBo>>;
  chatRoomStatus?: Maybe<CapaQuotationChatRoomStatus>;
  hasPurchaseOrder?: Maybe<Scalars['Boolean']>;
  /** 발주 거부 사유 */
  purchaseOrderRejectedReason?: Maybe<Scalars['String']>;
};

/** 발주서 상태 */
export enum CapaRfqConsultingChatStatusType {
  /** 상담전 */
  BeforeConsulting = 'BEFORE_CONSULTING',
  /** 상담중 */
  Consulting = 'CONSULTING',
  /** 견적서 확정 */
  QuotationConfirmed = 'QUOTATION_CONFIRMED',
  /** 발주서 발행 */
  PurchaseOrderIssued = 'PURCHASE_ORDER_ISSUED'
}

export type CapaRfqDetailBo = {
  __typename?: 'CAPARfqDetailBO';
  id: Scalars['ID'];
  projectName?: Maybe<Scalars['String']>;
  status: CapaRfqStatus;
  quotationUserId?: Maybe<Scalars['String']>;
  managerName?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['String']>;
  dueNegotiable?: Maybe<Scalars['Boolean']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  chatRooms?: Maybe<Array<CapaRfqChatRoomsBo>>;
  projectPurpose?: Maybe<CapaQuotationProductPurpose>;
  projectPurposeDetail?: Maybe<Scalars['String']>;
  maxBudget?: Maybe<Scalars['Float']>;
  minBudget?: Maybe<Scalars['Float']>;
  budgetOpen?: Maybe<Scalars['Boolean']>;
  serviceType?: Maybe<CapaQuotationServiceType>;
  detailedServiceType?: Maybe<CapaQuotationDetailedServiceType>;
  optionalServices?: Maybe<Array<CapaQuotationOptionalService>>;
  drawingFiles?: Maybe<Array<CapaQuotationRfqDrawingFile>>;
  pcb?: Maybe<CapaPcbDetail>;
  design?: Maybe<CapaDesignDetail>;
  detailedRequest?: Maybe<Scalars['String']>;
  referenceFiles?: Maybe<Array<CapaQuotationRfqReferenceFile>>;
  /** 상담시작 유형 */
  consultingStartMethod?: Maybe<CapaConsultingStartMethod>;
};

export type CapaRfqDetailBoOutput = {
  __typename?: 'CAPARfqDetailBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaRfqDetailBo>;
};

/** 캐파 견적 상세 서비스 정보 입력 */
export type CapaRfqFilterQuotationDetailedServiceInput = {
  /** 캐파 견적 상세 서비스 타입 */
  type?: InputMaybe<CapaQuotationDetailedServiceType>;
  /** 재료 정보 입력 */
  materials?: InputMaybe<Array<CapaRfqFilterQuotationMaterialInput>>;
};

/** 재료 정보 입력 */
export type CapaRfqFilterQuotationMaterialInput = {
  /** 재료 */
  material?: InputMaybe<CapaQuotationMaterial>;
  /** 세부 재료 */
  detailedMaterials?: InputMaybe<Array<CapaQuotationDetailedMaterialType>>;
};

/** 캐파 견적 서비스 정보 입력 */
export type CapaRfqFilterQuotationServiceInput = {
  /** 캐파 견적 서비스 타입 */
  service?: InputMaybe<CapaQuotationServiceType>;
  /** 캐파 견적 상세 서비스 정보 입력 */
  detailedServices?: InputMaybe<
    Array<CapaRfqFilterQuotationDetailedServiceInput>
  >;
  /** 추가 서비스 타입 (벤딩, 용접, 시제품, 제품디자인 */
  optionalServices?: InputMaybe<Array<CapaQuotationServiceType>>;
};

/** CAPARfqManagementElement */
export type CapaRfqManagementElement = {
  __typename?: 'CAPARfqManagementElement';
  type?: Maybe<CapaRfqProjectManagementType>;
  isNew?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
};

/** 제작단계 Manufacturing Stage */
export enum CapaRfqManufacturingStage {
  /** 시험 생산(Pilot Production) */
  StagePilotProduction = 'STAGE_PILOT_PRODUCTION',
  /** 제품 생산(Production) */
  StageProduction = 'STAGE_PRODUCTION',
  /** 시제품 제작(Prototype) */
  StagePrototype = 'STAGE_PROTOTYPE'
}

/** CAPARfqPartnerManagementElement */
export type CapaRfqPartnerManagementElement = {
  __typename?: 'CAPARfqPartnerManagementElement';
  type?: Maybe<CapaRfqProjectManagementType>;
  isNew?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
};

/** pcb 조립 방식 */
export enum CapaRfqPcbAssemblyMethodType {
  /** Surface Mounted Technology - 표면실장기술 */
  Smt = 'SMT',
  /** 수땜 - 손 납땜 */
  Soldering = 'SOLDERING'
}

/** pcb 자제 방법 */
export enum CapaRfqPcbMaterialSupplyMethodType {
  /** 시급 */
  CustomerSupply = 'CUSTOMER_SUPPLY',
  /** 도급 */
  SelfSupply = 'SELF_SUPPLY',
  /** 부분도급 */
  PartialSelfSupply = 'PARTIAL_SELF_SUPPLY'
}

export type CapaRfqPcbassemblyMethod = {
  __typename?: 'CAPARfqPcbassemblyMethod';
  methodType?: Maybe<CapaRfqPcbAssemblyMethodType>;
};

/** 프로젝트 알림 설정 */
export type CapaRfqProjectFilter = {
  __typename?: 'CAPARfqProjectFilter';
  /** 이메일 수신 여부 */
  email?: Maybe<Scalars['Boolean']>;
  /** 카카오 (실패시 SMS) 수신 여부 */
  sms?: Maybe<Scalars['Boolean']>;
  /** 견적서 도착, 견적서 수정요청, 회사소개서 도착, 발주서 도착, 발주거절 */
  service?: Maybe<CapaRfqProjectManagementType>;
};

/** 프로젝트 알림 설정 */
export type CapaRfqProjectFilterInput = {
  /** 이메일 수신 여부 */
  email?: InputMaybe<Scalars['Boolean']>;
  /** 카카오 (실패시 SMS) 수신 여부 */
  sms?: InputMaybe<Scalars['Boolean']>;
  /** 발주서 도착 or 견적서 수정요청 도착 */
  service?: InputMaybe<CapaRfqProjectManagementType>;
};

/** CAPA Rfq Purchase Order Inspection Type(발주서 검수 타입) */
export enum CapaRfqPurchaseOrderInspectionType {
  /** 치수 검사 */
  Dimension = 'DIMENSION',
  /** 기능 검사 */
  Functionalty = 'FUNCTIONALTY',
  /** 외관 검사 */
  Surface = 'SURFACE',
  /** 기타 */
  Etc = 'ETC'
}

/** CAPA Rfq Purchase Order Payment Provision Type(발주서 결제 지급 정보 타입) */
export enum CapaRfqPurchaseOrderPaymentProvisionType {
  /** 계약체결 시 */
  AtContract = 'AT_CONTRACT',
  /** 납품 직후 */
  AfterShip = 'AFTER_SHIP',
  /** 납품 및 검수 직후 */
  AfterShipInspection = 'AFTER_SHIP_INSPECTION',
  /** 계약 종료 시 */
  AtContractTermination = 'AT_CONTRACT_TERMINATION',
  /** 기타 */
  Etc = 'ETC'
}

export type CapaRfqPurchaseOrderTransfer = {
  __typename?: 'CAPARfqPurchaseOrderTransfer';
  /** 이관 조건 */
  transferTerms?: Maybe<CapaRfqPurchaseOrderTransferTermsType>;
  /** 이관 보관 기간(N개월) */
  transferStorage?: Maybe<Scalars['Float']>;
};

/** CAPA Rfq Purchase Order TransferTerms Type(발주서 이관 조건 타입) */
export enum CapaRfqPurchaseOrderTransferTermsType {
  /** 납품 시 이관 */
  TransferAtShip = 'TRANSFER_AT_SHIP',
  /** 납품 후 일정 기간 보관 */
  StorageAfterShip = 'STORAGE_AFTER_SHIP'
}

export type CapaRfqQuotationPartnerSendIntroduction = {
  __typename?: 'CAPARfqQuotationPartnerSendIntroduction';
  /** id */
  id: Scalars['String'];
  /** seq */
  seq: Scalars['Float'];
  /** rfqId */
  rfqId: Scalars['String'];
  /** issuerId */
  issuerId: Scalars['String'];
  /** isSendQuotation */
  isSendQuotation?: Maybe<Scalars['String']>;
  /** read */
  read: Scalars['Boolean'];
  /** createdAt */
  createdAt: Scalars['DateTime'];
  /** updatedAt */
  updatedAt: Scalars['DateTime'];
  /** projectName */
  projectName: Scalars['String'];
  /** userId */
  userId: Scalars['String'];
  /** organizationName */
  organizationName: Scalars['String'];
};

/** CAPA Rfq Quotation Type (견적서 타입) */
export enum CapaRfqQuotationType {
  /** SIMPLE */
  Simple = 'SIMPLE',
  /** DETAIL */
  Detail = 'DETAIL'
}

/** 특정 rfq가 파트너로부터 수령한 것 */
export enum CapaRfqReceivedType {
  /** 견적서만 수령 */
  OnlyQuotation = 'ONLY_QUOTATION',
  /** 회사 소개서만 수령 */
  OnlyIntroduction = 'ONLY_INTRODUCTION',
  /** 견적서와 회사 소개서 수령 */
  QuotationAndIntroduction = 'QUOTATION_AND_INTRODUCTION'
}

export type CapaRfqReview = {
  __typename?: 'CAPARfqReview';
  /** review id */
  id: Scalars['String'];
  projectName: Scalars['String'];
  organizationName?: Maybe<Scalars['String']>;
  managerName?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
  reviewComment: Scalars['String'];
  reviewPoint: Scalars['Float'];
  serviceType: CapaQuotationServiceType;
  reviewFiles?: Maybe<Array<CapaRfqReviewFile>>;
  reviewFileCount?: Maybe<Scalars['Float']>;
  indueDate: Scalars['Boolean'];
  reviewedAt?: Maybe<Scalars['String']>;
  /** 발주액 */
  purchaseOrderValue: Scalars['Float'];
  isEditable: Scalars['Boolean'];
};

/** 리뷰들과 리뷰 총 개수 */
export type CapaRfqReviewAndCount = {
  __typename?: 'CAPARfqReviewAndCount';
  reviews?: Maybe<Array<CapaRfqReviewBo>>;
  count?: Maybe<Scalars['Float']>;
  reviewAveragePoint?: Maybe<Scalars['Float']>;
};

export type CapaRfqReviewBo = {
  __typename?: 'CAPARfqReviewBO';
  reviewerName: Scalars['String'];
  reviewerCompanyName: Scalars['String'];
  reviewerEmail?: Maybe<Scalars['String']>;
  reviewerPhoneNumber?: Maybe<Scalars['String']>;
  partnerCompanyName?: Maybe<Scalars['String']>;
  projectName: Scalars['String'];
  reviewId: Scalars['ID'];
  reviewComment: Scalars['String'];
  reviewPoint: Scalars['Float'];
  inDueDate: Scalars['Boolean'];
  reviewFiles?: Maybe<Array<CapaRfqReviewFile>>;
};

export type CapaRfqReviewChip = {
  __typename?: 'CAPARfqReviewChip';
  chipId: Scalars['ID'];
};

/** 리뷰 파일 */
export type CapaRfqReviewFile = {
  __typename?: 'CAPARfqReviewFile';
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
};

/** 리뷰 종류 */
export enum CapaRfqReviewType {
  /** 상담 리뷰 */
  OnlyConsulting = 'ONLY_CONSULTING',
  /** 거래 리뷰 */
  OnlyTransaction = 'ONLY_TRANSACTION',
  /** 상담 + 거래 리뷰 */
  ConsultingAndTransaction = 'CONSULTING_AND_TRANSACTION'
}

export type CapaRfqReviewsBoOutput = {
  __typename?: 'CAPARfqReviewsBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaRfqReviewAndCount>;
};

/** CAPA RFQ STATUS */
export enum CapaRfqStatus {
  /** 유효 rfq  */
  Available = 'AVAILABLE',
  /** 거래완료 --> 견적요청목록(fetchRfqsBO input) 에서 사용 X */
  Complete = 'COMPLETE',
  /** 발주 - 특정파트너와 연결이된 상태 --> 견적요청목록(fetchRfqsBO input) 에서는 사용 X */
  Confirmed = 'CONFIRMED',
  /** 90일이 지나 만료된 견적(원래 EXPIRED) + EXPIRED_BY_CLIENT + EXPIRED_BY_REWRITE + CONFIRMED + COMPLETE */
  Expired = 'EXPIRED',
  /** 클라이언트가 만료처리 --> 견적요청목록(fetchRfqsBO input) 에서는 사용 X */
  ExpiredByClient = 'EXPIRED_BY_CLIENT',
  /** Cient가 아직 not verified */
  NotVerified = 'NOT_VERIFIED',
  /** CRM의 판단에 따라 중지됨 */
  Stopped = 'STOPPED',
  /** 재작성으로 인해 마감됨 --> 견적요청목록(fetchRfqsBO input) 에서는 사용 X */
  ExpiredByRewrite = 'EXPIRED_BY_REWRITE',
  /** TEST_RFQ */
  TestRfq = 'TEST_RFQ'
}

/** 검색한 rfg 결과 및 개수 */
export type CapaRfqsAndCount = {
  __typename?: 'CAPARfqsAndCount';
  rfqs?: Maybe<Array<CapaRfqBo>>;
  count?: Maybe<Scalars['Float']>;
};

export type CapaRfqsBoOutput = {
  __typename?: 'CAPARfqsBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaRfqsAndCount>;
};

/** 파트너 목록에서 특정 파트너 찾기 위한 필드 값 */
export enum CapaSearchPartnersBoFieldType {
  /** 회사명 */
  OrganizationName = 'ORGANIZATION_NAME',
  /** 담당자명 */
  ManagerName = 'MANAGER_NAME',
  /** 담당자 이메일 */
  Email = 'EMAIL',
  /** 담당자 휴대폰 번호 */
  Contact = 'CONTACT'
}

/** 검색 필드 */
export enum CapaSearchQuotationUsersBoFieldType {
  /** 회사명 */
  CompanyName = 'COMPANY_NAME',
  /** 고객명 */
  ClientName = 'CLIENT_NAME',
  /** 고객 이메일 */
  ClientEmail = 'CLIENT_EMAIL',
  /** 휴대폰번호 */
  Contact = 'CONTACT'
}

/** 검색 필드 */
export enum CapaSearchRfqsBoFieldType {
  /** 프로젝트명 */
  ProjectName = 'PROJECT_NAME',
  /** 고객명 */
  ClientName = 'CLIENT_NAME',
  /** 고객이메일 */
  ClientEmail = 'CLIENT_EMAIL',
  /** 회사명 */
  CompanyName = 'COMPANY_NAME'
}

export type CapaSearchUsersBo = {
  __typename?: 'CAPASearchUsersBo';
  users?: Maybe<Array<CapaUserBo>>;
  count?: Maybe<Scalars['Float']>;
};

export type CapaServiceRatingBo = {
  __typename?: 'CAPAServiceRatingBO';
  /** 구분 */
  userType?: Maybe<CapaQuotationUserType>;
  userId?: Maybe<Scalars['String']>;
  /** 피드백 시간 */
  createdAt?: Maybe<Scalars['String']>;
  managerName?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  /** 평가 지수 */
  rating?: Maybe<Scalars['Float']>;
  /** 기타 의견 */
  comment?: Maybe<Scalars['String']>;
};

export type CapaServiceRatingBoOutput = {
  __typename?: 'CAPAServiceRatingBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaRatingsAndCount>;
};

export type CapaServiceSuggestionBo = {
  __typename?: 'CAPAServiceSuggestionBO';
  /** 구분 */
  userType?: Maybe<CapaQuotationUserType>;
  /** 피드백 시간 */
  createdAt?: Maybe<Scalars['String']>;
  managerName?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  /** 희망 서비스 */
  suggestion?: Maybe<Scalars['String']>;
};

export type CapaServiceSuggestionBoOutput = {
  __typename?: 'CAPAServiceSuggestionBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaSuggestionsAndCount>;
};

/** 캐파 서비스 타입 */
export enum CapaServiceType {
  /** 클라우드 서비스 */
  Cloud = 'CLOUD',
  /** 캐파 고객 (견적) 서비스 */
  Quotation = 'QUOTATION',
  /** 캐파 파트너 (견적) 서비스 */
  QuotationPartner = 'QUOTATION_PARTNER',
  /** 캐파 커넥트 서비스 */
  Connect = 'CONNECT',
  /** 캐파 백오피스 */
  Backoffice = 'BACKOFFICE',
  Super = 'SUPER'
}

export type CapaServiceTypeStatistics = {
  __typename?: 'CAPAServiceTypeStatistics';
  /** 요청 수량 */
  quantity: Scalars['Float'];
  /** 거래 금액 */
  amount?: Maybe<Scalars['Float']>;
};

export type CapaServiceTypeStatisticsOutput = {
  __typename?: 'CAPAServiceTypeStatisticsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaServiceTypeStatistics>;
};

export enum CapaShippingMethodType {
  /** 택배 */
  Package = 'PACKAGE',
  /** 퀵서비스 */
  QuickService = 'QUICK_SERVICE',
  /** 직접 배달 */
  SelfPackage = 'SELF_PACKAGE',
  /** 고객 직접수령 */
  PickUp = 'PICK_UP',
  /** 배송없음 */
  NoPackage = 'NO_PACKAGE',
  /** 기타 */
  Etc = 'ETC'
}

/** 파트너목록 정렬 필드 */
export enum CapaSortPartnersBoFieldType {
  /** 마지막 로그인 */
  LastLoginAt = 'LAST_LOGIN_AT',
  /** 가입일 */
  CreatedAt = 'CREATED_AT',
  /** 전체 제안 프로젝트 수 (견적서 제안 + 소개서 제안) */
  TotalSuggestionCount = 'TOTAL_SUGGESTION_COUNT',
  /** 견적서로 제안한 프로젝트 수 */
  QuotationSuggestionCount = 'QUOTATION_SUGGESTION_COUNT',
  /** 소개서로 제안한 프로젝트 수 */
  IntroductionSuggestionCount = 'INTRODUCTION_SUGGESTION_COUNT',
  /** 견적 수 = 상담 시작 방식 및 상담 진행 여부 상관 없이 견적서 1회 이상 발송한 프로젝트 수 */
  RfqReceivedQuotationCount = 'RFQ_RECEIVED_QUOTATION_COUNT',
  /** 안전결제 수 */
  PaymentCount = 'PAYMENT_COUNT'
}

/** 견적요청목록 정렬 필드 */
export enum CapaSortRfqsBoFieldType {
  /** 주문 요청 일 */
  CreatedAt = 'CREATED_AT',
  /** 총수량 */
  TotalCount = 'TOTAL_COUNT',
  /** 조회수 */
  ViewCount = 'VIEW_COUNT',
  /** 전체(견적 + 소개서) 제안 파트너 수 */
  TotalSuggestionCount = 'TOTAL_SUGGESTION_COUNT',
  /** 연결된 상담 수 */
  ChatroomCount = 'CHATROOM_COUNT'
}

/** 견적요청목록 정렬 필드 */
export enum CapaSortType {
  /** 오름차순 */
  Asc = 'ASC',
  /** 내림차순 */
  Desc = 'DESC'
}

/** 유저목록 정렬 필드 */
export enum CapaSortUsersBoFieldType {
  /** 회원가입일 */
  CreatedAt = 'CREATED_AT',
  /** 견적요청개수 */
  RfqCount = 'RFQ_COUNT'
}

export enum CapaSubmallRejectType {
  /** 고객이 잘못 가입함 */
  JoinMistake = 'JOIN_MISTAKE',
  /** 파트너 요건 불충 */
  Insufficient = 'INSUFFICIENT',
  /** 연락이 되지 않음 */
  CantInTouch = 'CANT_IN_TOUCH',
  /** ETC */
  Etc = 'ETC'
}

export type CapaSubmallRejectedReason = {
  __typename?: 'CAPASubmallRejectedReason';
  /** reject type */
  rejectType: CapaSubmallRejectType;
  /** 취소 상세 사유 */
  reason?: Maybe<Scalars['String']>;
};

/** CAPASubmallStatus */
export enum CapaSubmallStatus {
  /** 계좌 승인 대기 */
  Registered = 'REGISTERED',
  /** 계좌 승인 완료 */
  Approved = 'APPROVED',
  /** 계좌 승인 거절 */
  Rejected = 'REJECTED'
}

export type CapaSubscribeNotifications = {
  __typename?: 'CAPASubscribeNotifications';
  count: Scalars['Float'];
};

export type CapaSubscribeNotificationsOutput = {
  __typename?: 'CAPASubscribeNotificationsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaSubscribeNotifications>;
};

/** 서비스 제안 목록 및 총 개수 */
export type CapaSuggestionsAndCount = {
  __typename?: 'CAPASuggestionsAndCount';
  suggestions?: Maybe<Array<CapaServiceSuggestionBo>>;
  count?: Maybe<Scalars['Float']>;
};

export type CapaTransactionHistoryBo = {
  __typename?: 'CAPATransactionHistoryBO';
  paymentId: Scalars['String'];
  paidAt?: Maybe<Scalars['String']>;
  status: CapaPaymentStatus;
  /** 지급승인(구매확정) 날짜 */
  confirmedAt?: Maybe<Scalars['String']>;
  /** 지급대행 지시일(실제 파트너에게 정산 = 지급일) */
  payoutedAt?: Maybe<Scalars['String']>;
  /** total amount */
  totalAmount: Scalars['Float'];
  /** 캐파 결제망 이용료 수익 (VAT포함) */
  capaUsageFee?: Maybe<Scalars['Float']>;
  /** pg 결제망 이용료 (PG수수료 (VAT포함) */
  pgUsageFee?: Maybe<Scalars['Float']>;
  /** 결제관리 수수료수익 (VAT포함) */
  commission?: Maybe<Scalars['Float']>;
  /** 파트너에게 정산해주는 금액 */
  payoutAmount?: Maybe<Scalars['Float']>;
  paymentMethod: CapaPaymentMethodType;
  quotationUserManagerName: Scalars['String'];
  quotationPartnerOrganizationName: Scalars['String'];
  rfqId: Scalars['String'];
  projectName: Scalars['String'];
  companyRegistrationNumber: Scalars['String'];
  /** capa_payment_cancel ConfirmedAt */
  cancelConfirmedAt?: Maybe<Scalars['String']>;
  cancelStatus?: Maybe<CapaPaymentCancelStatus>;
  /** 포인트 */
  point?: Maybe<Scalars['Float']>;
  serviceType?: Maybe<CapaQuotationServiceType>;
};

export type CapaTransactionHistoryCountBo = {
  __typename?: 'CAPATransactionHistoryCountBO';
  /** 총 결제 건수    */
  transactionCount?: Maybe<Scalars['Float']>;
  /** 총 결제금액  */
  totalAmout?: Maybe<Scalars['Float']>;
  /** PG+캐파 결제망이용료 (VAT 포함)  */
  usageFee?: Maybe<Scalars['Float']>;
  /** 캐파 결제망이용료수익(VAT 포함)  */
  capaUsageFee?: Maybe<Scalars['Float']>;
  /** 결제관리수수료수익(VAT 포함)  */
  commission?: Maybe<Scalars['Float']>;
  /** 결제취소/환불 건수  */
  cancelCount?: Maybe<Scalars['Float']>;
  /** 결제취소/환불금액 */
  totalCancelAmout?: Maybe<Scalars['Float']>;
  /** 총 수익 합계(결제금액-결제취소/환불금액) */
  profit?: Maybe<Scalars['Float']>;
  /** 포인트 합계 */
  point?: Maybe<Scalars['Float']>;
};

export type CapaTransactionHistoryModelBo = {
  __typename?: 'CAPATransactionHistoryModelBO';
  transactionCount: CapaTransactionHistoryCountBo;
  transactionList?: Maybe<Array<CapaTransactionHistoryBo>>;
};

export type CapaTransactionHistoryModelBoOutput = {
  __typename?: 'CAPATransactionHistoryModelBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaTransactionHistoryModelBo>;
};

export type Capauuid = {
  __typename?: 'CAPAUUID';
  uuid: Scalars['String'];
};

export type CapauuidOutput = {
  __typename?: 'CAPAUUIDOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Capauuid>;
};

export type CapaUser = {
  __typename?: 'CAPAUser';
  id: Scalars['ID'];
  email: Scalars['String'];
  status: CapaUserStatus;
  lastLoginAt?: Maybe<Scalars['String']>;
  lastLogoutAt?: Maybe<Scalars['String']>;
  /** 생성일 */
  createdAt: Scalars['String'];
  /** 수정일 */
  updatedAt: Scalars['String'];
};

export type CapaUserBo = {
  __typename?: 'CAPAUserBO';
  id: Scalars['String'];
  managerName?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  bizType?: Maybe<CapaQuotationUserBizType>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rfqCount?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['String']>;
  companyRegistrationNumber?: Maybe<Scalars['Boolean']>;
  status?: Maybe<CapaQuotationUserStatus>;
  route?: Maybe<Array<CapaInflowRoute>>;
  /** 추천 기관명/회사명 */
  referralCompany?: Maybe<Scalars['String']>;
};

/** 유저 현황 */
export enum CapaUserStatus {
  /** 등록 */
  Registered = 'REGISTERED',
  /** 탈퇴 */
  Deleted = 'DELETED'
}

export type CapaUsersBoOutput = {
  __typename?: 'CAPAUsersBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaSearchUsersBo>;
};

export type CapaUsersOutput = {
  __typename?: 'CAPAUsersOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaUser>>;
};

export type CapaVerificationModel = {
  __typename?: 'CAPAVerificationModel';
  /** string 타입의 아임포트 SMS본인인증처리 고유번호 */
  impUid: Scalars['String'];
  /** string 타입의 가맹점 주문번호 */
  merchantUid?: Maybe<Scalars['String']>;
  /** PG사 SMS본인인증결과 고유번호 */
  pgTid?: Maybe<Scalars['String']>;
  /** SMS본인인증 제공 PG사 명칭. danal(다날) */
  pgProvider: Scalars['String'];
  /** 인증결과-실명 */
  name?: Maybe<Scalars['String']>;
  /** 인증결과-성별. male:남성, female:여성  */
  gender?: Maybe<Scalars['String']>;
  /** (deprecated) birthday 를 사용해주세요. 관련공지내용 인증결과-생년월일 UNIX timestamp. 연, 월, 일만 의미있고 시,분,초는 의미없음 */
  birth?: Maybe<Scalars['String']>;
  /** 인증결과-생년월일 ISO8601 형식의 문자열. YYYY-MM-DD 10자리 문자열 */
  birthday?: Maybe<Scalars['String']>;
  /** 인증결과-외국인여부. true:외국인, false:내국인. 다날 본인인증서비스 계약시 외국인 구분기능 추가 요청을 해주셔야 사용이 가능합니다. */
  foreigner: Scalars['Boolean'];
  /** 인증결과-사용된 휴대폰번호(신용카드 본인인증의 경우 해당사항없음). 특수기호없이 숫자로만 구성된 휴대폰번호가 전달됨. 통신사 사전승인이 이뤄지지 않으면 phone 속성은 존재하지 않습니다. 통신사 사전승인이 필요하므로 cs@iamport.kr 로 다날 CPID 와 함께 사용승인 요청주시면 안내도와드리겠습니다. */
  phone?: Maybe<Scalars['String']>;
  /** 인증결과-사용된 휴대폰번호의 통신사(신용카드 본인인증의 경우 해당사항없음). 통신사 사전승인이 이뤄지지 않으면 carrier 속성은 존재하지 않습니다. 통신사 사전승인이 필요하므로 cs@iamport.kr 로 다날 CPID 와 함께 사용승인 요청주시면 안내도와드리겠습니다. = [SKT, KT, LGT, SKT_MVNO, KT_MVNO, LGT_MVNO] */
  carrier?: Maybe<Scalars['String']>;
  /** 인증성공여부 */
  certified?: Maybe<Scalars['Boolean']>;
  /** 인증처리시각 UNIX timestamp */
  certifiedAt?: Maybe<Scalars['Float']>;
  /** 개인 고유구분 식별키(다날 매뉴얼 기준 CI) */
  uniqueKey?: Maybe<Scalars['String']>;
  /** 가맹점 내 개인 고유구분 식별키(다날 매뉴얼 기준 DI). 본인인증 PG MID별로 할당되는 개인 식별키 */
  uniqueInSite?: Maybe<Scalars['String']>;
  /** 본인인증 프로세스가 진행된 웹 페이지의 URL */
  origin?: Maybe<Scalars['String']>;
  /** nullable한 인증결과-외국인여부. true:외국인, false:내국인. 다날 본인인증서비스 계약시 외국인 구분기능 추가 요청을 해주셔야 사용이 가능합니다. */
  foreignerV2?: Maybe<Scalars['Boolean']>;
};

/** 고객 탈퇴 사유 */
export enum CapaWithdrawClientReasonType {
  /** 원하는 파트너를 찾지 못해서 */
  NoMatchedPartner = 'NO_MATCHED_PARTNER',
  /** 더 이상 제조 파트너 찾기에 대한 수요가 없어서 */
  NoNeedToSearchPartner = 'NO_NEED_TO_SEARCH_PARTNER',
  /** 불필요한 알람이 많이 와서 */
  UselessAlarm = 'USELESS_ALARM',
  /** 개인정보 유출 불안 */
  PersonalInformationLeakage = 'PERSONAL_INFORMATION_LEAKAGE',
  /** 이직, 퇴사, 폐업 등 개인적인 사유 */
  PrivacyIssue = 'PRIVACY_ISSUE',
  /** 파트너 품질이 불안 */
  ConcernedAboutQuality = 'CONCERNED_ABOUT_QUALITY',
  /** 에이팀벤처스 서비스 응대가 불만 */
  AteamServiceProblem = 'ATEAM_SERVICE_PROBLEM',
  /** 기타 */
  Etc = 'ETC'
}

export type CapaWithdrawOutput = {
  __typename?: 'CAPAWithdrawOutput';
  consultingChatRooms?: Maybe<CapaWithdrawnChatRoomsUnion>;
  consultingChatRoomsCount: Array<CapaQuotationChatRoomsTotalCount>;
};

/** 고객 탈퇴 사유 */
export enum CapaWithdrawPartnerReasonType {
  /** 원하는 전문 서비스가 없어서 */
  NoMatchedService = 'NO_MATCHED_SERVICE',
  /** 원하는 고객을 만나지 못해서 */
  NoMatchedClient = 'NO_MATCHED_CLIENT',
  /** 불필요한 알람이 많이 와서 */
  UselessAlarm = 'USELESS_ALARM',
  /** 제조 고객 찾기에 대한 수요가 없어져서 */
  NoNeedToSearchClient = 'NO_NEED_TO_SEARCH_CLIENT',
  /** 이직, 퇴사, 폐업 등 개인적인 사유 */
  PrivacyIssue = 'PRIVACY_ISSUE',
  /** 기타 */
  Etc = 'ETC'
}

/** BO에서 보여주기 위한 탈퇴 사유 */
export enum CapaWithdrawReasonType {
  /** 원하는 파트너를 찾지 못해서 */
  NoMatchedPartner = 'NO_MATCHED_PARTNER',
  /** 더 이상 제조 파트너 찾기에 대한 수요가 없어서 */
  NoNeedToSearchPartner = 'NO_NEED_TO_SEARCH_PARTNER',
  /** 불필요한 알람이 많이 와서 */
  UselessAlarm = 'USELESS_ALARM',
  /** 개인정보 유출 불안 */
  PersonalInformationLeakage = 'PERSONAL_INFORMATION_LEAKAGE',
  /** 이직, 퇴사, 폐업 등 개인적인 사유 */
  PrivacyIssue = 'PRIVACY_ISSUE',
  /** 파트너 품질이 불안 */
  ConcernedAboutQuality = 'CONCERNED_ABOUT_QUALITY',
  /** 에이팀벤처스 서비스 응대가 불만 */
  AteamServiceProblem = 'ATEAM_SERVICE_PROBLEM',
  /** 기타 */
  Etc = 'ETC',
  /** 원하는 전문 서비스가 없어서 */
  NoMatchedService = 'NO_MATCHED_SERVICE',
  /** 원하는 고객을 만나지 못해서 */
  NoMatchedClient = 'NO_MATCHED_CLIENT',
  /** 제조 고객 찾기에 대한 수요가 없어져서 */
  NoNeedToSearchClient = 'NO_NEED_TO_SEARCH_CLIENT'
}

export type CapaWithdrawnChatRoomsOutput = {
  __typename?: 'CAPAWithdrawnChatRoomsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaWithdrawOutput>;
};

export type CapaWithdrawnChatRoomsUnion =
  | CapaWithdrawnUserChatRooms
  | CapaWithdrawnPartnerChatRooms
  | CapaWithdrawnConnectGroupChatRooms;

/** 캐파 커넥트 그룹 채팅방 */
export type CapaWithdrawnConnectGroupChatRoom = {
  __typename?: 'CAPAWithdrawnConnectGroupChatRoom';
  /** 그룹 ID */
  groupId: Scalars['ID'];
  /** 그룹 이름 */
  groupName: Scalars['String'];
  /** 챗룸 아이디 */
  chatRoomId: Scalars['ID'];
  /** 썸네일 */
  thumbnail?: Maybe<Scalars['ID']>;
  /** 그룹멤버 */
  users?: Maybe<Array<CapaWithdrawnConnectGroupUser>>;
};

export type CapaWithdrawnConnectGroupChatRooms = {
  __typename?: 'CAPAWithdrawnConnectGroupChatRooms';
  capaServiceType: CapaServiceType;
  chatRooms?: Maybe<Array<CapaWithdrawnConnectGroupChatRoom>>;
};

/** 탈퇴하고자 하는 유저의 커넥트 그룹 */
export type CapaWithdrawnConnectGroupUser = {
  __typename?: 'CAPAWithdrawnConnectGroupUser';
  /** 그룹 유저 ID */
  id?: Maybe<Scalars['ID']>;
  /** 커넥트 유저 아이디 */
  userId?: Maybe<Scalars['ID']>;
  /** 그룹 ID */
  groupId?: Maybe<Scalars['ID']>;
  /** 이메일 */
  email: Scalars['String'];
  /** 커넥트유저네임 */
  connectUserName?: Maybe<Scalars['String']>;
  /** 캐파유저냐 */
  isCapaUser?: Maybe<Scalars['Boolean']>;
};

/** 캐파 파트너스의 채팅방 */
export type CapaWithdrawnPartnerChatRoom = {
  __typename?: 'CAPAWithdrawnPartnerChatRoom';
  organizationName?: Maybe<Scalars['String']>;
  managerName?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  chatRoomId: Scalars['ID'];
  thumbnailId?: Maybe<Scalars['ID']>;
  rfqId?: Maybe<Scalars['String']>;
};

export type CapaWithdrawnPartnerChatRooms = {
  __typename?: 'CAPAWithdrawnPartnerChatRooms';
  capaServiceType: CapaServiceType;
  chatRooms?: Maybe<Array<CapaWithdrawnPartnerChatRoom>>;
};

/** 탈퇴 이유 */
export type CapaWithdrawnQuotationPartnerReason = {
  __typename?: 'CAPAWithdrawnQuotationPartnerReason';
  /** 커파 서비스 중 어디서 탈퇴를 진행했는지 */
  serviceType: CapaServiceType;
  /** 탈퇴 사유 */
  reason?: Maybe<CapaWithdrawReasonType>;
  /** 탈퇴 상세 사유 */
  detailedReason?: Maybe<Scalars['String']>;
  /** 기타 탈퇴 사유 */
  etcReason?: Maybe<Scalars['String']>;
  /** 탈퇴 일시 */
  withdrawnAt: Scalars['String'];
  /** 탈퇴 BO 담당자 성함 */
  withdrawerName?: Maybe<Scalars['String']>;
};

/** 탈퇴 이유 */
export type CapaWithdrawnQuotationUserReason = {
  __typename?: 'CAPAWithdrawnQuotationUserReason';
  /** 커파 서비스 중 어디서 탈퇴를 진행했는지 */
  serviceType: CapaServiceType;
  /** 탈퇴 사유 */
  reason?: Maybe<CapaWithdrawReasonType>;
  /** 탈퇴 상세 사유 */
  detailedReason?: Maybe<Scalars['String']>;
  /** 기타 탈퇴 사유 */
  etcReason?: Maybe<Scalars['String']>;
  /** 탈퇴 일시 */
  withdrawnAt: Scalars['String'];
  /** 탈퇴 BO 담당자 성함 */
  withdrawerName?: Maybe<Scalars['String']>;
};

/** 캐파 클라이언트 채팅방 */
export type CapaWithdrawnUserChatRoom = {
  __typename?: 'CAPAWithdrawnUserChatRoom';
  chatRoomId: Scalars['ID'];
  isOldRfq?: Maybe<Scalars['Boolean']>;
  profileId?: Maybe<Scalars['ID']>;
  projectName?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  thumbnailId?: Maybe<Scalars['ID']>;
  rfqId?: Maybe<Scalars['String']>;
};

export type CapaWithdrawnUserChatRooms = {
  __typename?: 'CAPAWithdrawnUserChatRooms';
  capaServiceType: CapaServiceType;
  chatRooms?: Maybe<Array<CapaWithdrawnUserChatRoom>>;
};

export type CanEditRefundAccountModel = {
  __typename?: 'CanEditRefundAccountModel';
  canEditRefundAccount: Scalars['Boolean'];
};

export type CancelRequestPaymentAgentInput = {
  mid: Scalars['String'];
  settlmntDt: Scalars['String'];
  subId: Scalars['String'];
  seq: Scalars['String'];
};

export enum CapaQuotationChatRoomSharedFileAnnotationStatus {
  /** ON */
  On = 'ON',
  /** OFF */
  Off = 'OFF',
  /** NONE */
  None = 'NONE'
}

export enum CapaQuotationChatRoomSharedFileType {
  /** QUOTATION_FILE */
  QuotationFile = 'QUOTATION_FILE',
  /** CHAT_MESSAGE_FILE */
  ChatMessageFile = 'CHAT_MESSAGE_FILE'
}

export enum CapaQuotationChatRoomSharedFilesFilterType {
  /** ALL_FILE */
  AllFile = 'ALL_FILE',
  /** QUOTATION_FILE */
  QuotationFile = 'QUOTATION_FILE',
  /** CHAT_MESSAGE_FILE */
  ChatMessageFile = 'CHAT_MESSAGE_FILE'
}

export type CapaQuotationChatRoomSpecificAnnotation = {
  __typename?: 'CapaQuotationChatRoomSpecificAnnotation';
  isNew?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
  status?: Maybe<CapaQuotationSharedFileAnnotationStatus>;
  anchorPos?: Maybe<Capa3DPos>;
  handlePos?: Maybe<Capa3DPos>;
  nodeId?: Maybe<Scalars['Float']>;
  commentUsers?: Maybe<Array<CommentUser>>;
  comments?: Maybe<Array<CapaQuotationSpecificAnnotationComment>>;
  createdAt?: Maybe<Scalars['String']>;
  annotationId?: Maybe<Scalars['String']>;
};

export type CapaQuotationChatRoomSpecificAnnotationsOutput = {
  __typename?: 'CapaQuotationChatRoomSpecificAnnotationsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<CapaQuotationChatRoomSpecificAnnotation>>;
};

/** Capa Rfq Project Management Type */
export enum CapaRfqProjectManagementType {
  /** 도면 권한 요청 */
  AllowDrawingFileRequest = 'ALLOW_DRAWING_FILE_REQUEST',
  /** 파트너가 견적서를 보냈을떄 */
  NewRfqQuotation = 'NEW_RFQ_QUOTATION',
  NewQuotationPartnerIntroduction = 'NEW_QUOTATION_PARTNER_INTRODUCTION',
  /** 파트너가 수정 견적서를 보냈을때 */
  AdjustedQuotation = 'ADJUSTED_QUOTATION',
  RefusedPurchaseOrder = 'REFUSED_PURCHASE_ORDER',
  /** 파트너가 발주서 수정 요청 */
  PurchaseOrderAdjustRequest = 'PURCHASE_ORDER_ADJUST_REQUEST',
  /** 파트너가 발주서를 확정했을때 */
  PurchaseOrderConfirmed = 'PURCHASE_ORDER_CONFIRMED',
  /** 고객이 도면 다운로드 허용시 */
  AllowDrawingFileResponse = 'ALLOW_DRAWING_FILE_RESPONSE',
  /** 고객이 도면 다운로드 제한시 */
  AllowDrawingFileDenied = 'ALLOW_DRAWING_FILE_DENIED',
  /** 고객이 견적서 수정 요청 */
  QuotationAdjustRequest = 'QUOTATION_ADJUST_REQUEST',
  /** 고객이 발주서 발행했을때 */
  NewRfqPurchaseOrder = 'NEW_RFQ_PURCHASE_ORDER',
  /** 고객이 발주서를 수정 발행 했을때 */
  AdjustedPurchaseOrder = 'ADJUSTED_PURCHASE_ORDER',
  /** 고객이 견적서를 보고 채팅하기를 클릭했을때 */
  QuotationConsultingStart = 'QUOTATION_CONSULTING_START'
}

/** CapaServiceTypeDetailFilter */
export type CapaServiceTypeDetailFilter = {
  /** detailedServiceTypes */
  detailedServiceTypes?: InputMaybe<Array<CapaQuotationDetailedServiceType>>;
  /** materials */
  materials?: InputMaybe<Array<CapaQuotationMaterial>>;
  /** detailedMaterials */
  detailedMaterials?: InputMaybe<Array<CapaQuotationDetailedMaterialType>>;
  /** optionalServices */
  optionalServices?: InputMaybe<Array<CapaQuotationServiceType>>;
};

export type ChangeChatMessageInvisibleInput = {
  chatRoomId?: InputMaybe<Scalars['String']>;
  senderId?: InputMaybe<Scalars['String']>;
  messageType?: InputMaybe<CapaQuotationChatMessageType>;
  fieldToChange?: InputMaybe<Scalars['String']>;
  valueToChange?: InputMaybe<Scalars['String']>;
};

export type ChangeChatRoomStatusInput = {
  chatRoomId?: InputMaybe<Scalars['String']>;
  quotationId?: InputMaybe<Scalars['String']>;
};

/** 이메일 갱신 */
export type ChangeEmailInput = {
  /** 이메일 */
  newEmail: Scalars['String'];
  /** 인증번호 */
  code: Scalars['String'];
};

/** 비밀번호 변경하기 */
export type ChangePasswordInput = {
  /** 비밀번호 */
  password: Scalars['String'];
  /** 새 비밀번호 */
  newPassword: Scalars['String'];
  /** 새 비밀번호 확인 */
  newPasswordConfirm: Scalars['String'];
  service?: InputMaybe<CapaServiceType>;
};

export type ChatFileUploadInput = {
  fileId: Scalars['String'];
  fileName?: InputMaybe<Scalars['String']>;
};

export type CheckBalanceInput = {
  /** 상점 ID */
  mid: Scalars['String'];
};

export type CheckConnectDuplicateGroupNameInput = {
  groupName: Scalars['String'];
};

export type CloudUser = {
  __typename?: 'CloudUser';
  id: Scalars['ID'];
};

export type CommentUser = {
  __typename?: 'CommentUser';
  userName?: Maybe<Scalars['String']>;
};

export type CommentUserBo = {
  __typename?: 'CommentUserBO';
  userName?: Maybe<Scalars['String']>;
};

export type CompleteRfqTransactionInput = {
  quotationPartnerId: Scalars['String'];
  rfqId: Scalars['String'];
  completeCost: Scalars['Float'];
};

export type ConfirmEscrowPurchaseInput = {
  /** payment table pk ID */
  paymentId: Scalars['String'];
  /** 나이스페이 모달에서 결제할때 입력하는 인증번호 (휴대폰번호 or 사업자번호) -> BuyerAuthNum */
  escrowVerifiedPW: Scalars['String'];
};

export type ConfirmRfqPurchaseOrderInput = {
  rfqId: Scalars['String'];
  purchaseOrderId: Scalars['String'];
};

export type ConfirmRfqQuotationInput = {
  rfqId: Scalars['String'];
  quotationPartnerId: Scalars['String'];
  quotationId?: InputMaybe<Scalars['String']>;
};

export type ConfirmRfqTransactionInput = {
  quotationPartnerId: Scalars['String'];
  rfqId: Scalars['String'];
};

export enum ConnectFileSortType {
  Latest = 'LATEST',
  Oldest = 'OLDEST'
}

export enum ConnectNotificationType {
  ChatPush = 'CHAT_PUSH',
  GroupPush = 'GROUP_PUSH',
  CommentThreadPush = 'COMMENT_THREAD_PUSH',
  FilePush = 'FILE_PUSH',
  GroupEmail = 'GROUP_EMAIL',
  CommentThreadEmail = 'COMMENT_THREAD_EMAIL',
  FileEmail = 'FILE_EMAIL'
}

/** ConnectSharedFileCommentThread */
export enum ConnectSharedFileCommentThread {
  /** yes */
  Yes = 'YES',
  /** no */
  No = 'NO'
}

export type ConnectUser = {
  __typename?: 'ConnectUser';
  id: Scalars['ID'];
  userName?: Maybe<Scalars['String']>;
};

/** Connect activete link status */
export enum ConnectUserFileLinkStatus {
  /** active */
  Active = 'ACTIVE',
  /** deactive */
  Deactive = 'DEACTIVE'
}

/** ConnectUserFileStatus status */
export enum ConnectUserFileStatus {
  /** viewable */
  Viewable = 'VIEWABLE',
  /** downloadable */
  Downloadable = 'DOWNLOADABLE'
}

export type CreateAdsImpressionBoInput = {
  /** advertisement id */
  advertisementId: Scalars['String'];
  /** image file id */
  fileId: Scalars['String'];
  /** image background color */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /** 광고 타이틀 */
  title: Scalars['String'];
  /** 광고 내용 */
  contents: Scalars['String'];
  /** 광고 타입 (배너, 카드) */
  advertisementType: CapaAdvertisementType;
  /** 광고 링크 주소 */
  linkUrl: Scalars['String'];
  /** 광고 종료 날짜 */
  expiredAt?: InputMaybe<Scalars['String']>;
};

export type CreateAdvertisementBoInput = {
  /** 회사명 */
  organizationName: Scalars['String'];
  /** 담당자명 */
  managerName: Scalars['String'];
  /** 연락처 */
  contact: Scalars['String'];
  /** 이메일 */
  email: Scalars['String'];
};

export type CreateAdvertisingBoInput = {
  /** 노출 광고 id 리스트 */
  adsImpressionIds: Array<Scalars['String']>;
  /** 광고 타입 (배너, 카드) */
  advertisementType: CapaAdvertisementType;
  /** 호스팅할 서비스 타입 (배너, 카드) */
  serviceType: CapaServiceType;
};

export type CreateConnectAnnotationCommentInput = {
  groupId: Scalars['String'];
  connectSharedFileId: Scalars['String'];
  annotationId: Scalars['String'];
  comment: Scalars['String'];
};

export type CreateConnectAnnotationInput = {
  groupId: Scalars['String'];
  connectSharedFileId: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
  anchorPos?: InputMaybe<Capa3DPosInput>;
  handlePos?: InputMaybe<Capa3DPosInput>;
  nodeId?: InputMaybe<Scalars['Float']>;
};

export type CreateConnectContactUserInput = {
  contactUserEmail: Scalars['String'];
  nickName?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
};

export type CreateConnectFeedbackInput = {
  /** 1 ~ 5 */
  rating: Scalars['Float'];
  /** feedBack message */
  feedBack?: InputMaybe<Scalars['String']>;
  fileIds?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateConnectGroup = {
  __typename?: 'CreateConnectGroup';
  id: Scalars['String'];
  chatRoomId: Scalars['String'];
};

export type CreateConnectGroupInput = {
  groupName?: InputMaybe<Scalars['String']>;
};

export type CreateConnectGroupOutput = {
  __typename?: 'CreateConnectGroupOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CreateConnectGroup>;
};

export type CreateConnectIssueInput = {
  /** issue message */
  issue: Scalars['String'];
  fileIds?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateDetailedQuotationInput = {
  rfqId: Scalars['String'];
  partnerId: Scalars['String'];
  optionalServices?: InputMaybe<Array<RfqQuotationOptionalServiceInput>>;
  /** 공급가액 */
  quotation?: InputMaybe<Scalars['Float']>;
  /** 배송비 */
  deliveryCost?: InputMaybe<Scalars['Float']>;
  /** false : include delevery fee, true : exclude delevery fee */
  excludeDeliveryFee?: InputMaybe<Scalars['Boolean']>;
  /** 최대 시안 수정 횟수 */
  maxDraftModificationCount?: InputMaybe<Scalars['Float']>;
  /** 수정 범위 및 추가 과금 기준 */
  draftModificationTerms?: InputMaybe<Scalars['String']>;
  /** 견적 설명 */
  etc?: InputMaybe<Scalars['String']>;
  /** 납품 가능일 */
  dueDate?: InputMaybe<Scalars['String']>;
  /** 견적서 유효기간 */
  expiration?: InputMaybe<Scalars['String']>;
  /** 공급자 담당자명 */
  managerName?: InputMaybe<Scalars['String']>;
  /** 공급자 연락처 */
  phone?: InputMaybe<Scalars['String']>;
  /** 공급자 이메일 */
  quotationEmail: Scalars['String'];
  address?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<CapaQuotationDetailedQuotationItemInput>>;
  pcbFabricationItems?: InputMaybe<
    Array<CapaQuotationDetailedQuotationPcbFabricationItemInput>
  >;
  pcbAssemblyItems?: InputMaybe<
    Array<CapaQuotationDetailedQuotationPcbAssemblyItemInput>
  >;
};

/** 고객 환불계좌 BO 등록 */
export type CreateMyRefundAccountBoInput = {
  /** 환불계좌 등록할 고객의 이메일 */
  targetEmail: Scalars['String'];
  bankCode: CapaBankCode;
  /** 계좌 번호 (- 제외) */
  account: Scalars['String'];
  /** 계좌 예금주명과 법인 본인인증자 이름이 다를때 강제 환불계좌 등록 */
  isForce?: InputMaybe<Scalars['Boolean']>;
};

/** 고객 환불계좌 등록 */
export type CreateMyRefundAccountInput = {
  bankCode: CapaBankCode;
  /** 계좌 번호 (- 제외) */
  account: Scalars['String'];
  /** 계좌 예금주명과 법인 본인인증자 이름이 다를때 강제 환불계좌 등록 */
  isForce?: InputMaybe<Scalars['Boolean']>;
};

export type CreateNoticeScheduleInput = {
  /** 점검 시작 시간 */
  startTime: Scalars['String'];
  /** 점검 종료 시간 */
  endTime: Scalars['String'];
  /** 사전점검 시작 시간 */
  previewStartTime?: InputMaybe<Scalars['String']>;
  /** 사전점검 종료 시간 */
  previewEndTime?: InputMaybe<Scalars['String']>;
  /** client partner connect 인지 */
  pageType: NoticeScheduleNoticePageType;
  /** 긴급점검 / 사전점검 등 */
  noticeType: NoticeScheduleNoticeType;
};

export type CreatePaymentInput = {
  purchaseOrderId: Scalars['String'];
  /** quotation partner id */
  partnerId: Scalars['String'];
  rfqId: Scalars['String'];
  pgProvider: CapapgProviders;
  /** CreatePaymentInput에서는 impUid를 transactionId로 받고 있음 */
  transactionId: Scalars['String'];
  refundAccountId?: InputMaybe<Scalars['String']>;
  /** 채팅방 상태 */
  chatRoomStatus?: InputMaybe<CapaQuotationChatRoomStatus>;
};

export type CreatePurchaseOrderInput = {
  quotationId: Scalars['String'];
  /** 발주처 담당자명 */
  managerName: Scalars['String'];
  /** 이관 조건 */
  transferTerms?: InputMaybe<CapaRfqPurchaseOrderTransferTermsType>;
  /** 이관 보관 기간(N개월) */
  transferStorage?: InputMaybe<Scalars['Float']>;
  /** 납품일 */
  shipDate: Scalars['String'];
  /** 납품주소 */
  shipAddress: Scalars['String'];
  /** 납품상세주소 */
  shipDetailAddress?: InputMaybe<Scalars['String']>;
};

export type CreateQuotationAnnotationCommentInput = {
  annotationId: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
};

export type CreateQuotationAnnotationInput = {
  chatRoomId: Scalars['String'];
  quotationSharedFileId: Scalars['String'];
  filterType: CapaQuotationChatRoomSharedFileType;
  comment?: InputMaybe<Scalars['String']>;
  anchorPos?: InputMaybe<Capa3DPosInput>;
  handlePos?: InputMaybe<Capa3DPosInput>;
  nodeId?: InputMaybe<Scalars['Float']>;
};

export type CreateQuotationChatRoomInput = {
  rfqId?: InputMaybe<Scalars['String']>;
};

export type CreateSimpleQuotationInput = {
  rfqId: Scalars['String'];
  partnerId: Scalars['String'];
  quotation?: InputMaybe<Scalars['Float']>;
  /** false : include delevery fee, true : exclude delevery fee */
  excludeDeliveryFee?: InputMaybe<Scalars['Boolean']>;
  etc?: InputMaybe<Scalars['String']>;
};

/** 구매확정(지급승인) 지연 */
export type DelayConfirmEscrowPurchaseInput = {
  /** 발주서 id */
  purchaseOrderId: Scalars['String'];
  /** 지급일 연장 사유 */
  extendReason?: InputMaybe<Scalars['String']>;
};

/** 고객 환불계좌 삭제 */
export type DeleteMyRefundAccountInput = {
  /** 수정할 환불계좌 id */
  refundBankAccountId?: InputMaybe<Scalars['String']>;
};

export type DeleteQuotationChatMessageInput = {
  deleteTargetMsgId: Scalars['String'];
};

export type DesignServiceInput = {
  serviceType: CapaDesignServiceType;
};

export enum EscrowPaymentRequestType {
  /** 구매확정 */
  ConfirmPurchase = 'CONFIRM_PURCHASE',
  /** 구매확정 거절 */
  RefusePurchase = 'REFUSE_PURCHASE',
  /** 배송등록 */
  RegisterShipping = 'REGISTER_SHIPPING'
}

export type EvaluateRfqPartnerInput = {
  quotationPartnerId: Scalars['String'];
  kind?: InputMaybe<Scalars['Boolean']>;
  quick?: InputMaybe<Scalars['Boolean']>;
  detailed?: InputMaybe<Scalars['Boolean']>;
  helpful?: InputMaybe<Scalars['Boolean']>;
  etc?: InputMaybe<Scalars['String']>;
};

export type EvaluateRfqPartnersInput = {
  rfqId: Scalars['String'];
  partners: Array<EvaluateRfqPartnerInput>;
};

export type ExpireRfqInput = {
  rfqId: Scalars['String'];
};

export type FactoronBizFetchIcxInput = {
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  factoronBizSearchType?: InputMaybe<FactoronBizSearchType>;
};

/** FactoronBizSearchType */
export enum FactoronBizSearchType {
  /** 회사명 */
  CompanyName = 'COMPANY_NAME',
  /** 공장대표주소 (도로명) */
  FactoryAddressRoadnam = 'FACTORY_ADDRESS_ROADNAM',
  /** 업종명 */
  IndustryName = 'INDUSTRY_NAME',
  /** 관할조직명 */
  JurisdictionOrganizationName = 'JURISDICTION_ORGANIZATION_NAME',
  /** 생산품 */
  Product = 'PRODUCT',
  /** 공장크기 */
  FactorySize = 'FACTORY_SIZE'
}

export type FavoriteRfqInput = {
  rfqId: Scalars['String'];
};

export type FetchActiveAdvertisingBoInput = {
  /** 광고 타입 (배너, 카드) */
  advertisementTypes: Array<CapaAdvertisementType>;
  /** 호스팅할 서비스 타입 (배너, 카드) */
  serviceType: CapaServiceType;
};

export type FetchActiveAdvertisingInput = {
  /** 광고 타입 (배너, 카드) */
  advertisementTypes: Array<CapaAdvertisementType>;
  /** 호스팅할 서비스 타입 (배너, 카드) */
  serviceType: CapaServiceType;
};

export type FetchAdsActivityLogsInput = {
  /** asd impression id */
  adsImpressionId: Scalars['String'];
};

export type FetchAdsImpressionsBoInput = {
  /** adsImpression ids */
  adsImpressionIds: Array<Scalars['String']>;
};

export type FetchAdvertisementAdsImpressionsBoInput = {
  /** advertisement id */
  advertisementId: Scalars['String'];
};

export type FetchAdvertisementsBoInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchAdvertisingsBoInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchAllIcxInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  icxRegion: Array<IcxRegion>;
  industrialComplexList: Array<IndustrialComplexName>;
  industryCategory: Array<IndustrialSectorsCategory>;
  sectors: Array<IndustrialSectorsName>;
  companyScale: Array<IndustrialCompanyScale>;
  searchKeyword?: InputMaybe<Scalars['String']>;
  employeesCountSortType?: InputMaybe<CapaSortType>;
  industrialBizSearchType?: InputMaybe<IndustrialBizSearchType>;
};

/** FetchAvailableFilterRfqsInput */
export type FetchAvailableFilterRfqsInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  serviceType?: InputMaybe<CapaFilterableServiceType>;
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  productPurposes?: InputMaybe<Array<CapaQuotationProductPurpose>>;
  /** 내가 견적서 작성한 RFQ중에서 검색할 키워드 */
  myKeyword?: InputMaybe<Scalars['String']>;
  /** 내가 견적서 작성한 RFQ 목록 확인 여부 */
  isMyRFQQuotation?: InputMaybe<Scalars['Boolean']>;
  /** 검색할 상태 타입 */
  searchStatus?: InputMaybe<QuotationPartnerRfqCurrentSituationType>;
};

export type FetchBoAmbassadorInvitationStatusInput = {
  ambassadorId: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchBoAmbassadorsInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchBoTestUsersInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchBoUsersInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchBoMemosInput = {
  /** 유저 id */
  userId: Scalars['String'];
  /** 유저 타입 */
  userType: CapaServiceType;
};

export type FetchCxManagementRequiredUsersBoInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchCapaConnectSharedFileInput = {
  groupId: Scalars['String'];
  sortFileType?: InputMaybe<ConnectFileSortType>;
  fileType?: InputMaybe<CapaConnectSharedFileType>;
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchCapabilityInput = {
  /** 캐파 견적 서비스 타입 */
  serviceType?: InputMaybe<Array<CapaQuotationServiceType>>;
};

export type FetchCommentsBoInput = {
  /** quotation user id */
  quotationUserId: Scalars['String'];
};

export type FetchConfirmDetailedQuotationInput = {
  rfqId: Scalars['String'];
  quotationPartnerId: Scalars['String'];
};

export type FetchConfirmPurchaseOrderInput = {
  rfqId: Scalars['String'];
  quotationPartnerId: Scalars['String'];
};

export type FetchConnectAnnotationsInput = {
  groupId: Scalars['String'];
  connectSharedFileId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectChatRoomInput = {
  chatRoomId: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectFeedbacksBoInput = {
  filter?: InputMaybe<CapaBackOfficeUsersFilterType>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectFileDetailInput = {
  fileId: Scalars['String'];
};

export type FetchConnectGroupChatRoomInput = {
  id: Scalars['String'];
};

export type FetchConnectGroupChatRoomsInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectGroupFeedbacksBoInput = {
  groupId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectGroupFilePermissionInput = {
  groupId: Scalars['String'];
  connectFileId: Scalars['String'];
};

export type FetchConnectGroupInput = {
  groupId: Scalars['String'];
  sortFileType?: InputMaybe<ConnectFileSortType>;
  fileType?: InputMaybe<CapaConnectSharedFileType>;
  keyword?: InputMaybe<Scalars['String']>;
};

export type FetchConnectGroupIssuesBoInput = {
  groupId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectGroupsBoInput = {
  filter?: InputMaybe<CapaBackOfficeConnectGroupsFilterType>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectGroupsInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectIssuesBoInput = {
  filter?: InputMaybe<CapaBackOfficeUsersFilterType>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectMyDriveInput = {
  isLatest?: InputMaybe<Scalars['Boolean']>;
  pathId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectUserContactListInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  contactUserEmail?: InputMaybe<Scalars['String']>;
};

export type FetchConnectUserFeedbacksBoInput = {
  connectUserId: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectUserFileLinkBoOutput = {
  __typename?: 'FetchConnectUserFileLinkBOOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaConnectUserFileLinksBo>;
};

export type FetchConnectUserFileLinksBoInput = {
  filter?: InputMaybe<CapaBackOfficeUsersFilterType>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectUserIssuesBoInput = {
  connectUserId: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchConnectUserLinkFile = {
  __typename?: 'FetchConnectUserLinkFile';
  files?: Maybe<Array<CapaConnectMyFile>>;
};

/** 내 정보 */
export type FetchConnectUserLinkFileInput = {
  /** if status logged in */
  email?: InputMaybe<Scalars['String']>;
  /** shareLink */
  shareLink: Array<Scalars['String']>;
  /** 아이피 */
  ip: Scalars['String'];
};

export type FetchConnectUserLinkFileOutput = {
  __typename?: 'FetchConnectUserLinkFileOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<FetchConnectUserLinkFile>;
};

export type FetchConnectUsersBoInput = {
  filter?: InputMaybe<CapaBackOfficeUsersFilterType>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchDetailedQuotationInput = {
  rfqId: Scalars['String'];
  quotationId: Scalars['String'];
};

export type FetchFileConversionStatusInput = {
  fileId: Scalars['String'];
};

/** fetchInProgressQuotationPartnerChatRoomsInput */
export type FetchInProgressQuotationPartnerChatRoomsInput = {
  serviceType: CapaQuotationServiceType;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

/** itp 이벤트 목록 표출 BO */
export type FetchItpEventsBoInput = {
  /** itp 이벤트 목록 타입 */
  listType?: InputMaybe<CapaItpEventListTypeEnum>;
  /** 고객 아이디 Filter */
  quotationUserId?: InputMaybe<Scalars['String']>;
};

/** jsb 이벤트 목록 표출 BO */
export type FetchJsbEventsBoInput = {
  /** jsb 이벤트 목록 타입 */
  listType?: InputMaybe<CapaJsbEventListTypeEnum>;
  /** 고객 아이디 Filter */
  quotationUserId?: InputMaybe<Scalars['String']>;
};

export type FetchMyAccountModel = {
  __typename?: 'FetchMyAccountModel';
  id: Scalars['String'];
  bankCode: CapaBankCode;
  account: Scalars['String'];
  holderName: Scalars['String'];
};

export type FetchMyCompleteRfqsInput = {
  complete: Scalars['Boolean'];
};

/** 캐파 클라우드 회원가입 */
export type FetchMyDriveInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchMyReceivedQuotationsInput = {
  rfqId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchMyRfqQuotationsInput = {
  rfqId: Scalars['String'];
  quotationPartnerId: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchMySubmallInput = {
  partnerId: Scalars['String'];
};

export type FetchNotificationInput = {
  /** 캐파 서비스 타입 */
  service: CapaServiceType;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  lastSeq?: InputMaybe<Scalars['Float']>;
};

export type FetchOneIcxInput = {
  id: Scalars['String'];
};

export type FetchPartnerRfqReviewsInput = {
  quotationPartnerId: Scalars['String'];
};

export type FetchPartnersInput = {
  status?: InputMaybe<CapaBackOfficeQuotationPartnerFilterType>;
  serviceType?: InputMaybe<CapaQuotationServiceType>;
  companyRegistration?: InputMaybe<Scalars['Boolean']>;
  isItp?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  searchField?: InputMaybe<CapaSearchPartnersBoFieldType>;
  searchItem?: InputMaybe<Scalars['String']>;
  /** 정렬필드 */
  sortField?: InputMaybe<CapaSortPartnersBoFieldType>;
  /** 정렬 차순 - asc,desc */
  sortType?: InputMaybe<CapaSortType>;
  includeTest?: InputMaybe<Scalars['Boolean']>;
};

export type FetchPaymentAgentResultInput = {
  mid?: InputMaybe<Scalars['String']>;
  /** 원하는 날짜 조회 YYYYMMDD 형식 */
  settlmntDt?: InputMaybe<Scalars['String']>;
  subId?: InputMaybe<Scalars['String']>;
};

export type FetchPaymentManageByPartnerIdInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  /** 프로젝트이름,고객닉네임,회사명,제조카테고리,주소 검색어 */
  searchKeyword?: InputMaybe<Scalars['String']>;
  /** 발주상태 타입 */
  searchType?: InputMaybe<ProjectPurchaseOrderManageStatusType>;
};

export type FetchPaymentManageByQuotationUserIdInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  /** 프로젝트이름,파트너 이름,제조카테고리 검색어 */
  searchKeyword?: InputMaybe<Scalars['String']>;
  /** 발주상태 타입 */
  searchType?: InputMaybe<ProjectPurchaseOrderManageStatusType>;
};

/** BO 제조 시작 목록 */
export type FetchProcessingBoInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  /** BO 제조 시작 목록 요청 타입 */
  reqType?: InputMaybe<CapaBackOfficeFetchProcessingReqType>;
  /** 목록 탭 필터 */
  filterStatus?: InputMaybe<Array<CapaPurchaseOrderStatus>>;
  /** 발주서 생성날짜 (ex ISOString 형태로 받음 ), 프로젝트명, 고객명, 고객전화, 파트너명 */
  searchKeyword?: InputMaybe<Scalars['String']>;
  /** 제조목록 검색 타입 */
  searchType?: InputMaybe<FetchProcessingBoSearchType>;
  /** 제조목록 검색 타입 */
  isLongLivedCancelRequest?: InputMaybe<Scalars['Boolean']>;
  /** 테스트 포함 여부 */
  includeTest?: InputMaybe<Scalars['Boolean']>;
};

/** 제조목록 검색 타입 */
export enum FetchProcessingBoSearchType {
  /** 발주서 생성날짜 */
  PurchaseOrderCreationDate = 'PURCHASE_ORDER_CREATION_DATE',
  /** 프로젝트명 */
  ProjectName = 'PROJECT_NAME',
  /** 고객 회사명 */
  UserOrganizationName = 'USER_ORGANIZATION_NAME',
  /** 고객명 */
  UserManagerName = 'USER_MANAGER_NAME',
  /** 고객전화 */
  UserPhone = 'USER_PHONE',
  /** 파트너명 */
  PartnerOrganizationName = 'PARTNER_ORGANIZATION_NAME'
}

/** FetchProjectManagementReceivedQuotationsInput */
export type FetchProjectManagementReceivedQuotationsInput = {
  rfqId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchPurchaseOrderInput = {
  purchaseOrderId: Scalars['String'];
};

export type FetchPurchaseOrderPaymentCancelData = {
  __typename?: 'FetchPurchaseOrderPaymentCancelData';
  /** 취소 사유 */
  reason?: Maybe<Scalars['String']>;
  /** 취소 금액 */
  amount: Scalars['Float'];
};

export type FetchPurchaseOrderPaymentData = {
  __typename?: 'FetchPurchaseOrderPaymentData';
  quotationId: Scalars['String'];
  /** quotation user id */
  quotationUserId: Scalars['String'];
  /** quotation partner user id */
  quotationPartnerUserId: Scalars['String'];
  /** quotation partner id */
  quotationPartnerId: Scalars['String'];
  /** rfq id */
  rfqId: Scalars['String'];
  /** purchase order id */
  purchaseOrderId?: Maybe<Scalars['String']>;
  /** total amount */
  totalAmount: Scalars['Float'];
  pgProvider: CapapgProviders;
  paymentMethod: CapaPaymentMethodType;
  createdAt: Scalars['String'];
  /** 결제 승인 날짜 */
  paidAt?: Maybe<Scalars['String']>;
  /** 지급승인(구매확정) 날짜 */
  confirmedAt?: Maybe<Scalars['String']>;
  virtualAccount?: Maybe<VirtualAccountInfo>;
  cardInfo?: Maybe<CapaPaymentCardInfo>;
};

export type FetchPurchaseOrdersBoInput = {
  rfqId: Scalars['String'];
  quotationPartnerId: Scalars['String'];
  purchaseOrderCreatedAt?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchPurchaseOrdersInput = {
  rfqId: Scalars['String'];
  quotationPartnerId: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

/** QuotationChatRoomSharedFilesInput */
export type FetchQuotationChatRoomAnnotationCommentInput = {
  chatRoomId: Scalars['String'];
};

export type FetchQuotationChatRoomInput = {
  chatRoomId: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  lastMessageId?: InputMaybe<Scalars['String']>;
};

/** QuotationChatRoomSharedFilesInput */
export type FetchQuotationChatRoomSharedFilesInput = {
  chatRoomId: Scalars['String'];
  filterType: CapaQuotationChatRoomSharedFilesFilterType;
};

/** fetchQuotationChatRoomSpecificAnnotationInput */
export type FetchQuotationChatRoomSpecificAnnotationBoInput = {
  userId: Scalars['String'];
  chatRoomId: Scalars['String'];
  quotationSharedFileId: Scalars['String'];
  filterType: CapaQuotationChatRoomSharedFileType;
};

/** fetchQuotationChatRoomSpecificAnnotationInput */
export type FetchQuotationChatRoomSpecificAnnotationInput = {
  chatRoomId: Scalars['String'];
  quotationSharedFileId: Scalars['String'];
  filterType: CapaQuotationChatRoomSharedFileType;
};

export type FetchQuotationPartnerActivityInput = {
  quotationPartnerId?: InputMaybe<Scalars['String']>;
};

export type FetchQuotationPartnerChatRoomsInput = {
  /**   CONSULTING,CONFIRMED 사용 안할예정 */
  chatRoomsFilter?: InputMaybe<CapaQuotationChatRoomsFilterType>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  /** 상대방 이름 (닉네임/회사명), 프로젝트 이름, 제조 카테고리 */
  searchKeyword?: InputMaybe<Scalars['String']>;
  /** rfq상태 , 발주 상태 제조상태 검색 위한 Enum */
  searchStatusType?: InputMaybe<ProjectStatusType>;
};

/** FetchQuotationPartnerManagementRfqsInput */
export type FetchQuotationPartnerManagementRfqsInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

/** FetchQuotationPartnerProjectManagementDetailInput */
export type FetchQuotationPartnerProjectManagementDetailInput = {
  rfqId: Scalars['String'];
};

export type FetchQuotationPartnerRfqReviewInput = {
  quotationPartnerId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchQuotationPartnerStrategyBoInput = {
  quotationPartnerId: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchQuotationUserBoInput = {
  quotationUserId: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchQuotationUserChatRoomsInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  /** 상대방 이름 (닉네임/회사명), 프로젝트 이름, 제조 카테고리 */
  searchKeyword?: InputMaybe<Scalars['String']>;
  /** rfq상태 , 발주 상태 제조상태 검색 위한 Enum */
  searchStatusType?: InputMaybe<ProjectStatusType>;
};

/** FetchQuotationUserProjectManagementDetailInput */
export type FetchQuotationUserProjectManagementDetailInput = {
  rfqId: Scalars['String'];
};

/** FetchQuotationUserProjectManagementRfqsInput */
export type FetchQuotationUserProjectManagementRfqsInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchQuotationUserRfqReviewsInput = {
  quotationUserId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchQuotationUserRfqsBoInput = {
  quotationUserId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchQuotationUserRfqsInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  /** 프로젝트이름,고객닉네임,회사명,제조카테고리,주소 검색어 */
  searchKeyword?: InputMaybe<Scalars['String']>;
  /** 채팅목록/고객rfq상태 , 발주 상태 제조상태 검색 위한 Enum */
  searchType?: InputMaybe<ProjectStatusType>;
};

/** 캐파 커넥트 유저 정보 */
export type FetchRecommendedContactList = {
  __typename?: 'FetchRecommendedContactList';
  /** capa user email */
  email: Scalars['String'];
  /** nick name */
  nickName?: Maybe<Scalars['String']>;
  isCapaUser?: Maybe<Scalars['Boolean']>;
};

export type FetchRecommendedContactListsOutput = {
  __typename?: 'FetchRecommendedContactListsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<FetchRecommendedContactList>>;
};

export type FetchRecommendedContactUserListInput = {
  chatRoomUserId: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchRfqInput = {
  rfqId: Scalars['String'];
};

export type FetchRfqPartnerEvaluationInput = {
  quotationPartnerId?: InputMaybe<Scalars['String']>;
};

export type FetchRfqQuotationsBoInput = {
  rfqId: Scalars['String'];
  quotationPartnerId: Scalars['String'];
  quotationCreatedAt?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchRfqReviewBoInput = {
  quotationPartnerId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  includeTest?: InputMaybe<Scalars['Boolean']>;
};

export type FetchRfqsInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  serviceType?: InputMaybe<CapaQuotationServiceType>;
  detailedServiceTypes?: InputMaybe<Array<CapaQuotationDetailedServiceType>>;
  materials?: InputMaybe<Array<CapaQuotationMaterial>>;
  detailedMaterials?: InputMaybe<Array<CapaQuotationDetailedMaterialType>>;
  productPurposes?: InputMaybe<Array<CapaQuotationProductPurpose>>;
  eventType?: InputMaybe<CapaQuotationRfqEventType>;
  optionalServices?: InputMaybe<Array<CapaQuotationServiceType>>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  inludeTest?: InputMaybe<Scalars['Boolean']>;
  /** rfq 상태 */
  status?: InputMaybe<CapaRfqStatus>;
  /** 검색필드 */
  searchField?: InputMaybe<CapaSearchRfqsBoFieldType>;
  /** 검색아이템 */
  searchItem?: InputMaybe<Scalars['String']>;
  /** 정렬필드 */
  sortField?: InputMaybe<CapaSortRfqsBoFieldType>;
  /** 정렬 차순 - asc,desc */
  sortType?: InputMaybe<CapaSortType>;
};

export type FetchServiceRatingBoInput = {
  userType?: InputMaybe<CapaQuotationUserType>;
  ratingOffset?: InputMaybe<Scalars['Float']>;
  ratingLimit?: InputMaybe<Scalars['Float']>;
  includeTest?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchServiceSuggestionBoInput = {
  userType?: InputMaybe<CapaQuotationUserType>;
  includeTest?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type FetchServiceTypeStatisticsInput = {
  serviceType: CapaQuotationServiceType;
};

export type FetchUsersInput = {
  companyRegistrationNumber?: InputMaybe<Scalars['Boolean']>;
  includeTest?: InputMaybe<Scalars['Boolean']>;
  bizType?: InputMaybe<CapaQuotationUserBizType>;
  status?: InputMaybe<CapaQuotationUserStatus>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  /** 검색필드 */
  searchField?: InputMaybe<CapaSearchQuotationUsersBoFieldType>;
  /** 검색아이템 */
  searchItem?: InputMaybe<Scalars['String']>;
  /** 정렬필드 */
  sortField?: InputMaybe<CapaSortUsersBoFieldType>;
  /** 정렬 차순 - asc,desc */
  sortType?: InputMaybe<CapaSortType>;
};

export type FetchWithdrawnChatRoomsInput = {
  chatRoomsFilter?: InputMaybe<CapaQuotationChatRoomsFilterType>;
  /** 캐파 서비스 */
  serviceType?: InputMaybe<CapaServiceType>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type IcxAuthentication = {
  __typename?: 'IcxAuthentication';
  /** JWT */
  accessToken: Scalars['String'];
  tokenType: Scalars['String'];
  expiresIn: Scalars['Float'];
  /** JWT */
  refreshToken: Scalars['String'];
  redirectUrl?: Maybe<Scalars['String']>;
};

/** icx 로그인 */
export type IcxAuthenticationInput = {
  /** Ateam에서 지정해준 비밀번호 */
  password: Scalars['String'];
  /** device token */
  deviceToken?: InputMaybe<Scalars['String']>;
};

export type IcxAuthenticationOutput = {
  __typename?: 'IcxAuthenticationOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<IcxAuthentication>;
};

export type IcxDetatilModel = {
  __typename?: 'IcxDetatilModel';
  id?: Maybe<Scalars['String']>;
  basicResearchId?: Maybe<Scalars['String']>;
  basicListStandard?: Maybe<Scalars['String']>;
  basicNote?: Maybe<Scalars['String']>;
  basicCity?: Maybe<Scalars['String']>;
  basicCounty?: Maybe<Scalars['String']>;
  basicFactoryManagementNumber?: Maybe<Scalars['String']>;
  basicListId?: Maybe<Scalars['String']>;
  basicComplexId?: Maybe<Scalars['String']>;
  basicMapNumber?: Maybe<Scalars['String']>;
  basicAreaNumber?: Maybe<Scalars['String']>;
  basicSerialNumber?: Maybe<Scalars['String']>;
  basicCompanyName?: Maybe<Scalars['String']>;
  basicComplexName?: Maybe<Scalars['String']>;
  basicKnowledgeIndustryCenter?: Maybe<Scalars['String']>;
  basicComplexAbbreviatedName?: Maybe<Scalars['String']>;
  basicHeadquarters?: Maybe<Scalars['String']>;
  basicComplexDivision?: Maybe<Scalars['String']>;
  basicCompanyScale?: Maybe<Scalars['String']>;
  basicIndustryCode?: Maybe<Scalars['String']>;
  basicIndustryMiddleCategory?: Maybe<Scalars['String']>;
  basicIndustrial?: Maybe<Scalars['String']>;
  basicIndustryCategory?: Maybe<Scalars['String']>;
  keyresultsProduce_2020?: Maybe<Scalars['String']>;
  keyresultsProduce_2019?: Maybe<Scalars['String']>;
  keyresultsExport_2020?: Maybe<Scalars['String']>;
  keyresultsExport_2019?: Maybe<Scalars['String']>;
  keyresultsEmploy_2020?: Maybe<Scalars['String']>;
  keyresultsEmploy_2019?: Maybe<Scalars['String']>;
  fullinvestigationCompanyName?: Maybe<Scalars['String']>;
  fullinvestigationName_1?: Maybe<Scalars['String']>;
  fullinvestigationGender_1?: Maybe<Scalars['String']>;
  fullinvestigationName_2?: Maybe<Scalars['String']>;
  fullinvestigationGender_2?: Maybe<Scalars['String']>;
  fullinvestigationStreetAddress?: Maybe<Scalars['String']>;
  fullinvestigationNumberAddress?: Maybe<Scalars['String']>;
  fullinvestigationDivision?: Maybe<Scalars['String']>;
  fullinvestigationCorporationNumber?: Maybe<Scalars['String']>;
  fullinvestigationYear?: Maybe<Scalars['String']>;
  fullinvestigationMonth?: Maybe<Scalars['String']>;
  fullinvestigationRegistrationNumber?: Maybe<Scalars['String']>;
  fullinvestigationWhether?: Maybe<Scalars['String']>;
  fullinvestigationAddress?: Maybe<Scalars['String']>;
  fullinvestigationCompanyScale?: Maybe<Scalars['String']>;
  fullinvestigationStockMarket?: Maybe<Scalars['String']>;
  fullinvestigationStockKosdaq?: Maybe<Scalars['String']>;
  fullinvestigationOutwardAppearance?: Maybe<Scalars['String']>;
  fullinvestigationNormal?: Maybe<Scalars['String']>;
  fullinvestigationCall?: Maybe<Scalars['String']>;
  fullinvestigationFax?: Maybe<Scalars['String']>;
  fullinvestigationEmail?: Maybe<Scalars['String']>;
  workplaceWhetherMine?: Maybe<Scalars['String']>;
  workplaceWhetherRent?: Maybe<Scalars['String']>;
  workplaceRentCompanyName?: Maybe<Scalars['String']>;
  workplaceYear?: Maybe<Scalars['String']>;
  workplaceMonth?: Maybe<Scalars['String']>;
  workplaceRegistrationStatus?: Maybe<Scalars['String']>;
  workplaceStartYear?: Maybe<Scalars['String']>;
  workplaceStartMonth?: Maybe<Scalars['String']>;
  workplaceOnlyOneCompany?: Maybe<Scalars['String']>;
  workplaceOverseasCompany?: Maybe<Scalars['String']>;
  workplaceManyCompany?: Maybe<Scalars['String']>;
  workplaceCountryName_1?: Maybe<Scalars['String']>;
  workplaceCountryName_2?: Maybe<Scalars['String']>;
  workplaceCountryName_3?: Maybe<Scalars['String']>;
  workplaceCountryName_4?: Maybe<Scalars['String']>;
  workplaceCountryName_5?: Maybe<Scalars['String']>;
  workplaceUsa?: Maybe<Scalars['String']>;
  workplaceChina?: Maybe<Scalars['String']>;
  workplaceJapan?: Maybe<Scalars['String']>;
  workplaceSoutheastAsia?: Maybe<Scalars['String']>;
  workplaceEurope?: Maybe<Scalars['String']>;
  workplaceMiddleEast?: Maybe<Scalars['String']>;
  workplaceLatinAmerica?: Maybe<Scalars['String']>;
  workplaceEtc?: Maybe<Scalars['String']>;
  workplaceNone?: Maybe<Scalars['String']>;
  workplaceEmployeesNumber?: Maybe<Scalars['String']>;
  workplaceAllCompanyName?: Maybe<Scalars['String']>;
  workplaceCurrnetBusiness?: Maybe<Scalars['String']>;
  workplaceCity?: Maybe<Scalars['String']>;
  workplaceCounty?: Maybe<Scalars['String']>;
  workplaceBusinessStatus?: Maybe<Scalars['String']>;
  workplaceIndustrialComplexBusinessCount?: Maybe<Scalars['String']>;
  activitiesProductName_1?: Maybe<Scalars['String']>;
  activitiesProductType_1?: Maybe<Scalars['String']>;
  activitiesIndustryClassification_1?: Maybe<Scalars['String']>;
  activitiesSectors_1?: Maybe<Scalars['String']>;
  activitiesProductName_2?: Maybe<Scalars['String']>;
  activitiesProductType_2?: Maybe<Scalars['String']>;
  activitiesIndustryClassification_2?: Maybe<Scalars['String']>;
  activitiesSectors_2?: Maybe<Scalars['String']>;
  activitiesProductName_3?: Maybe<Scalars['String']>;
  activitiesProductType_3?: Maybe<Scalars['String']>;
  activitiesIndustryClassification_3?: Maybe<Scalars['String']>;
  activitiesSectors_3?: Maybe<Scalars['String']>;
  activityCharacteristics_1?: Maybe<Scalars['String']>;
  activityCharacteristics_2?: Maybe<Scalars['String']>;
  activityCharacteristics_3?: Maybe<Scalars['String']>;
  activityCharacteristics_4?: Maybe<Scalars['String']>;
  activityCharacteristics_5?: Maybe<Scalars['String']>;
  activityCharacteristics_6?: Maybe<Scalars['String']>;
  activityCharacteristics_7?: Maybe<Scalars['String']>;
  purchasesLargeBusiness?: Maybe<Scalars['String']>;
  purchasesSmallBusiness?: Maybe<Scalars['String']>;
  purchasesGovernment?: Maybe<Scalars['String']>;
  purchasesUniversity?: Maybe<Scalars['String']>;
  purchasesHeadquarters?: Maybe<Scalars['String']>;
  purchasesOversearImport?: Maybe<Scalars['String']>;
  purchasesIndividualUnspecifiedMajority?: Maybe<Scalars['String']>;
  purchasesOthers?: Maybe<Scalars['String']>;
  purchasesBeforePurchase?: Maybe<Scalars['String']>;
  purchasesNote?: Maybe<Scalars['String']>;
  purchasesSeoul?: Maybe<Scalars['String']>;
  purchasesBusan?: Maybe<Scalars['String']>;
  purchasesTegu?: Maybe<Scalars['String']>;
  purchasesIncheon?: Maybe<Scalars['String']>;
  purchasesGwangju?: Maybe<Scalars['String']>;
  purchasesDaejon?: Maybe<Scalars['String']>;
  purchasesUlsan?: Maybe<Scalars['String']>;
  purchasesSejong?: Maybe<Scalars['String']>;
  purchasesKyonggi?: Maybe<Scalars['String']>;
  purchasesKangwon?: Maybe<Scalars['String']>;
  purchasesChungbuk?: Maybe<Scalars['String']>;
  purchasesChungnam?: Maybe<Scalars['String']>;
  purchasesJeonbuk?: Maybe<Scalars['String']>;
  purchasesChonnam?: Maybe<Scalars['String']>;
  purchasesKyongbok?: Maybe<Scalars['String']>;
  purchasesKyongnam?: Maybe<Scalars['String']>;
  purchasesJeju?: Maybe<Scalars['String']>;
  purchasesIndustrialComplex1?: Maybe<Scalars['String']>;
  purchasesIndustrialComplex2?: Maybe<Scalars['String']>;
  purchasesIndustrialComplex3?: Maybe<Scalars['String']>;
  purchasesOthers2?: Maybe<Scalars['String']>;
  vendorLargeBusiness?: Maybe<Scalars['String']>;
  vendorSmallBusiness?: Maybe<Scalars['String']>;
  vendorGovernment?: Maybe<Scalars['String']>;
  vendorUniversity?: Maybe<Scalars['String']>;
  vendorHeadquarters?: Maybe<Scalars['String']>;
  vendorOversearDirectExport?: Maybe<Scalars['String']>;
  vendorInvidualUnspecifiedMajority?: Maybe<Scalars['String']>;
  vendorOthers?: Maybe<Scalars['String']>;
  vendorBeforePurchase?: Maybe<Scalars['String']>;
  vendorNote?: Maybe<Scalars['String']>;
  vendorSeoul?: Maybe<Scalars['String']>;
  vendorBusan?: Maybe<Scalars['String']>;
  vendorTegu?: Maybe<Scalars['String']>;
  vendorIncheon?: Maybe<Scalars['String']>;
  vendorGwangju?: Maybe<Scalars['String']>;
  vendorDaejon?: Maybe<Scalars['String']>;
  vendorUlsan?: Maybe<Scalars['String']>;
  vendorSejong?: Maybe<Scalars['String']>;
  vendorKyonggi?: Maybe<Scalars['String']>;
  vendorKangwon?: Maybe<Scalars['String']>;
  vendorChungbuk?: Maybe<Scalars['String']>;
  vendorChungnam?: Maybe<Scalars['String']>;
  vendorJeonbuk?: Maybe<Scalars['String']>;
  vendorChonnam?: Maybe<Scalars['String']>;
  vendorKyongbok?: Maybe<Scalars['String']>;
  vendorKyongnam?: Maybe<Scalars['String']>;
  vendorJeju?: Maybe<Scalars['String']>;
  vendorIndustrialComplex1?: Maybe<Scalars['String']>;
  vendorIndustrialComplex2?: Maybe<Scalars['String']>;
  vendorIndustrialComplex3?: Maybe<Scalars['String']>;
  vendorOthers2?: Maybe<Scalars['String']>;
  rndWhether?: Maybe<Scalars['String']>;
  rndInvestment_2020?: Maybe<Scalars['String']>;
  rndPatentApplication_2020?: Maybe<Scalars['String']>;
  rndPatentRegistration_2020?: Maybe<Scalars['String']>;
  rndInvestment_2019?: Maybe<Scalars['String']>;
  rndPatentApplication_2019?: Maybe<Scalars['String']>;
  rndPatentRegistration_2019?: Maybe<Scalars['String']>;
  solarInstalledOrNot?: Maybe<Scalars['String']>;
  solarInstalledCapacity?: Maybe<Scalars['String']>;
  safetyManagerPresence?: Maybe<Scalars['String']>;
  safetyManagerName?: Maybe<Scalars['String']>;
  safetyManagerPosition?: Maybe<Scalars['String']>;
  safetyManagerPhoneNumber?: Maybe<Scalars['String']>;
  safetyIndustrialRiskAres?: Maybe<Scalars['String']>;
  safetyFirstPlace?: Maybe<Scalars['String']>;
  safetySecondPlace?: Maybe<Scalars['String']>;
  employees2020FullTimeTotal?: Maybe<Scalars['String']>;
  employees2020FullTimeRnd?: Maybe<Scalars['String']>;
  employees2020FullTimeSkilledLocals?: Maybe<Scalars['String']>;
  employees2020FullTimeSkilledForeigner?: Maybe<Scalars['String']>;
  employees2020FullTimeOthers?: Maybe<Scalars['String']>;
  employees2020FullTimeWomanTotal?: Maybe<Scalars['String']>;
  employees2020FullTimeWomanRnd?: Maybe<Scalars['String']>;
  employees2020FullTimeLocalWoman?: Maybe<Scalars['String']>;
  employees2020FullTimeForeignerWoman?: Maybe<Scalars['String']>;
  employees2020FullTimeWomanOthers?: Maybe<Scalars['String']>;
  employees2020_15_19Total?: Maybe<Scalars['String']>;
  employees2020_15_19Rnd?: Maybe<Scalars['String']>;
  employees2020_15_19SkilledLocals?: Maybe<Scalars['String']>;
  employees2020_15_19SkilledForeigner?: Maybe<Scalars['String']>;
  employees2020_15_19Others?: Maybe<Scalars['String']>;
  employees2020_20_29Total?: Maybe<Scalars['String']>;
  employees2020_20_29Rnd?: Maybe<Scalars['String']>;
  employees2020_20_29SkilledLocals?: Maybe<Scalars['String']>;
  employees2020_20_29SkilledForeigners?: Maybe<Scalars['String']>;
  employees2020_20_29Others?: Maybe<Scalars['String']>;
  employees2020_30_34Total?: Maybe<Scalars['String']>;
  employees2020_30_34Rnd?: Maybe<Scalars['String']>;
  employees2020_30_34SkilledLocals?: Maybe<Scalars['String']>;
  employees2020_30_34SkilledForeigners?: Maybe<Scalars['String']>;
  employees2020_30_34Others?: Maybe<Scalars['String']>;
  employees2020_35_39Total?: Maybe<Scalars['String']>;
  employees2020_35_39Rnd?: Maybe<Scalars['String']>;
  employees2020_35_39SkilledLocals?: Maybe<Scalars['String']>;
  employees2020_35_39SkilledForeigners?: Maybe<Scalars['String']>;
  employees2020_35_39Others?: Maybe<Scalars['String']>;
  employees2020_40_49Total?: Maybe<Scalars['String']>;
  employees2020_40_49Rnd?: Maybe<Scalars['String']>;
  employees2020_40_49SkilledLocals?: Maybe<Scalars['String']>;
  employees2020_40_49SkilledForeigners?: Maybe<Scalars['String']>;
  employees2020_40_49Others?: Maybe<Scalars['String']>;
  employees2020_50_59Total?: Maybe<Scalars['String']>;
  employees2020_50_59Rnd?: Maybe<Scalars['String']>;
  employees2020_50_59SkilledLocals?: Maybe<Scalars['String']>;
  employees2020_50_59SkilledForeigners?: Maybe<Scalars['String']>;
  employees2020_50_59Others?: Maybe<Scalars['String']>;
  employees2020Above_60Total?: Maybe<Scalars['String']>;
  employees2020Above_60Rnd?: Maybe<Scalars['String']>;
  employees2020Above_60SkilledLocals?: Maybe<Scalars['String']>;
  employees2020Above_60SkilledForeigner?: Maybe<Scalars['String']>;
  employees2020Above_60Others?: Maybe<Scalars['String']>;
  thirdPartyEmployees2020DispatchedTotal?: Maybe<Scalars['String']>;
  thirdPartyEmployees2020DispatchedRnd?: Maybe<Scalars['String']>;
  thirdPartyEmployees2020DispatchedSkilledLocal?: Maybe<Scalars['String']>;
  thirdPartyEmployees2020DispatchedSkilledForeigner?: Maybe<Scalars['String']>;
  thirdPartyEmployees2020DispatchedOthers?: Maybe<Scalars['String']>;
  thirdPartyEmployees2020DispatchedWomenTotal?: Maybe<Scalars['String']>;
  thirdPartyEmployees2020DispatchedWomenRnd?: Maybe<Scalars['String']>;
  thirdPartyEmployees2020DispatchedLocalWomenProduction?: Maybe<
    Scalars['String']
  >;
  thirdPartyEmployees2020DispatchedForeignerWomenProduction?: Maybe<
    Scalars['String']
  >;
  thirdPartyEmployees2020DispatchedWomenOthers?: Maybe<Scalars['String']>;
  employees2019FullTimeTotal?: Maybe<Scalars['String']>;
  employees2019FullTimeRnd?: Maybe<Scalars['String']>;
  employees2019FullTimeSkilledLocals?: Maybe<Scalars['String']>;
  employees2019FullTimeSkilledForeigner?: Maybe<Scalars['String']>;
  employees2019FullTimeOthers?: Maybe<Scalars['String']>;
  employees2019FullTimeWomanTotal?: Maybe<Scalars['String']>;
  employees2019FullTimeWomanRnd?: Maybe<Scalars['String']>;
  employees2019FullTimeLocalWoman?: Maybe<Scalars['String']>;
  employees2019FullTimeForeignerWoman?: Maybe<Scalars['String']>;
  employees2019FullTimeWomanOthers?: Maybe<Scalars['String']>;
  employees2019_15_19Total?: Maybe<Scalars['String']>;
  employees2019_15_19Rnd?: Maybe<Scalars['String']>;
  employees2019_15_19SkilledLocals?: Maybe<Scalars['String']>;
  employees2019_15_19SkilledForeigner?: Maybe<Scalars['String']>;
  employees2019_15_19Others?: Maybe<Scalars['String']>;
  employees2019_20_29Total?: Maybe<Scalars['String']>;
  employees2019_20_29Rnd?: Maybe<Scalars['String']>;
  employees2019_20_29SkilledLocals?: Maybe<Scalars['String']>;
  employees2019_20_29SkilledForeigners?: Maybe<Scalars['String']>;
  employees2019_20_29Others?: Maybe<Scalars['String']>;
  employees2019_30_34Total?: Maybe<Scalars['String']>;
  employees2019_30_34Rnd?: Maybe<Scalars['String']>;
  employees2019_30_34SkilledLocals?: Maybe<Scalars['String']>;
  employees2019_30_34SkilledForeigners?: Maybe<Scalars['String']>;
  employees2019_30_34Others?: Maybe<Scalars['String']>;
  employees2019_35_39Total?: Maybe<Scalars['String']>;
  employees2019_35_39Rnd?: Maybe<Scalars['String']>;
  employees2019_35_39SkilledLocals?: Maybe<Scalars['String']>;
  employees2019_35_39SkilledForeigners?: Maybe<Scalars['String']>;
  employees2019_35_39Others?: Maybe<Scalars['String']>;
  employees2019_40_49Total?: Maybe<Scalars['String']>;
  employees2019_40_49Rnd?: Maybe<Scalars['String']>;
  employees2019_40_49SkilledLocals?: Maybe<Scalars['String']>;
  employees2019_40_49SkilledForeigners?: Maybe<Scalars['String']>;
  employees2019_40_49Others?: Maybe<Scalars['String']>;
  employees2019_50_59Others?: Maybe<Scalars['String']>;
  employees2019_50_59Rnd?: Maybe<Scalars['String']>;
  employees2019_50_59SkilledLocals?: Maybe<Scalars['String']>;
  employees2019_50_59SkilledForeigners?: Maybe<Scalars['String']>;
  employees2019_50_59Others2?: Maybe<Scalars['String']>;
  employees2019Above_60Total?: Maybe<Scalars['String']>;
  employees2019Above_60Rnd?: Maybe<Scalars['String']>;
  employees2019Above_60SkilledLocals?: Maybe<Scalars['String']>;
  employees2019Above_60SkilledForeigner?: Maybe<Scalars['String']>;
  employees2019Above_60Others?: Maybe<Scalars['String']>;
  thirdPartyEmployees2019DispatchedTotal?: Maybe<Scalars['String']>;
  thirdPartyEmployees2019DispatchedRnd?: Maybe<Scalars['String']>;
  thirdPartyEmployees2019DispatchedSkilledLocal?: Maybe<Scalars['String']>;
  thirdPartyEmployees2019DispatchedSkilledForeigner?: Maybe<Scalars['String']>;
  thirdPartyEmployees2019DispatchedOthers?: Maybe<Scalars['String']>;
  thirdPartyEmployees2019DispatchedWomenTotal?: Maybe<Scalars['String']>;
  thirdPartyEmployees2019DispatchedWomenRnd?: Maybe<Scalars['String']>;
  thirdPartyEmployees2019DispatchedLocalWomenProduction?: Maybe<
    Scalars['String']
  >;
  thirdPartyEmployees2019DispatchedForeignerWomenProduction?: Maybe<
    Scalars['String']
  >;
  thirdPartyEmployees2019DispatchedWomenOthers?: Maybe<Scalars['String']>;
  productionPerformanceResponseCriteria_1?: Maybe<Scalars['String']>;
  productionPerformanceResponseCriteria_2?: Maybe<Scalars['String']>;
  productionPerformanceIndustrialComplexBusinessCount?: Maybe<
    Scalars['String']
  >;
  productionPerformance_2020Cost?: Maybe<Scalars['String']>;
  productionPerformance_2019Cost?: Maybe<Scalars['String']>;
  exportStatusExportPerformanceIn_19_20?: Maybe<Scalars['String']>;
  exportStatusNoExport?: Maybe<Scalars['String']>;
  exportStatusNotExported?: Maybe<Scalars['String']>;
  exportStatusOthers?: Maybe<Scalars['String']>;
  exportStatusOtherBusiness?: Maybe<Scalars['String']>;
  exportPerformance2020Absence?: Maybe<Scalars['String']>;
  exportPerformance2020ExportCost?: Maybe<Scalars['String']>;
  exportPerformance2019Absence?: Maybe<Scalars['String']>;
  exportPerformance2019ExportCost?: Maybe<Scalars['String']>;
  exportCountryUsa?: Maybe<Scalars['String']>;
  exportCountryChina?: Maybe<Scalars['String']>;
  exportCountryJapan?: Maybe<Scalars['String']>;
  exportCountrySoutheastAsia?: Maybe<Scalars['String']>;
  exportCountryEurope?: Maybe<Scalars['String']>;
  exportCountryMiddleEast?: Maybe<Scalars['String']>;
  exportCountryLatinAmerica?: Maybe<Scalars['String']>;
  exportCountryOthers?: Maybe<Scalars['String']>;
  exportCountryNote?: Maybe<Scalars['String']>;
  respondantRespondantName?: Maybe<Scalars['String']>;
  respondantDepartment?: Maybe<Scalars['String']>;
  respondantRole?: Maybe<Scalars['String']>;
  respondantPhoneNumber?: Maybe<Scalars['String']>;
  respondantFaxNumber?: Maybe<Scalars['String']>;
  respondantEmail?: Maybe<Scalars['String']>;
  respondantAgreeTerms?: Maybe<Scalars['String']>;
  respondantMonth?: Maybe<Scalars['String']>;
  respondantDate?: Maybe<Scalars['String']>;
  respondantRespondant?: Maybe<Scalars['String']>;
  respondantUserSignature?: Maybe<Scalars['String']>;
};

export type IcxFactoron = {
  __typename?: 'IcxFactoron';
  icxModelList?: Maybe<Array<IcxFactoronModel>>;
  count?: Maybe<Scalars['Float']>;
};

export type IcxFactoronModel = {
  __typename?: 'IcxFactoronModel';
  id: Scalars['String'];
  no?: Maybe<Scalars['String']>;
  industrialComplex?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  representativeName?: Maybe<Scalars['String']>;
  birthOrRegistrationNumber?: Maybe<Scalars['String']>;
  industrialCenterName?: Maybe<Scalars['String']>;
  factoryControlNumber?: Maybe<Scalars['String']>;
  factoryAddressRoadName?: Maybe<Scalars['String']>;
  factoryAddressNo?: Maybe<Scalars['String']>;
  companyRegistrationNumber?: Maybe<Scalars['String']>;
  representativeIndustryCode?: Maybe<Scalars['String']>;
  representativeIndustryNumber?: Maybe<Scalars['String']>;
  sectors?: Maybe<Scalars['String']>;
  industryName?: Maybe<Scalars['String']>;
  jurisdictionOrganizationName?: Maybe<Scalars['String']>;
  jurisdictionOrganizationCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  establishment?: Maybe<Scalars['String']>;
  moveInType?: Maybe<Scalars['String']>;
  classificationOfHoldings?: Maybe<Scalars['String']>;
  applicationDate?: Maybe<Scalars['String']>;
  firstApprovalDate?: Maybe<Scalars['String']>;
  approvalClassification?: Maybe<Scalars['String']>;
  approvalDate?: Maybe<Scalars['String']>;
  firstRegistrationDate?: Maybe<Scalars['String']>;
  registrationCategory?: Maybe<Scalars['String']>;
  registrationDate?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  changeReportDate?: Maybe<Scalars['String']>;
  businessType?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
  faxNumber?: Maybe<Scalars['String']>;
  maleEmployeeCount?: Maybe<Scalars['String']>;
  femaleEmployeeCount?: Maybe<Scalars['String']>;
  maleForeigner?: Maybe<Scalars['String']>;
  femaleForeigner?: Maybe<Scalars['String']>;
  employeesCount?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  mainMaterial?: Maybe<Scalars['String']>;
  businessStartDate?: Maybe<Scalars['String']>;
  factoryCompletionDate?: Maybe<Scalars['String']>;
  estimatedConstructionStartDate?: Maybe<Scalars['String']>;
  estimatedConstructionCompletionDate?: Maybe<Scalars['String']>;
  factorySize?: Maybe<Scalars['String']>;
  useArea?: Maybe<Scalars['String']>;
  landCategory?: Maybe<Scalars['String']>;
  landArea?: Maybe<Scalars['String']>;
  manufacturingFacilityArea?: Maybe<Scalars['String']>;
  ancillaryFacilityArea?: Maybe<Scalars['String']>;
  officeArea?: Maybe<Scalars['String']>;
  warehouseArea?: Maybe<Scalars['String']>;
  horizontalProjectionArea?: Maybe<Scalars['String']>;
  buildingArea?: Maybe<Scalars['String']>;
  airQuality?: Maybe<Scalars['String']>;
  waterQuality?: Maybe<Scalars['String']>;
  isNoiseVibration?: Maybe<Scalars['String']>;
  livingWater?: Maybe<Scalars['String']>;
  industrialWater?: Maybe<Scalars['String']>;
  power?: Maybe<Scalars['String']>;
  oil?: Maybe<Scalars['String']>;
  gas?: Maybe<Scalars['String']>;
  etcOil?: Maybe<Scalars['String']>;
  equityMillion?: Maybe<Scalars['String']>;
  debtCapitalMillion?: Maybe<Scalars['String']>;
  foreignInvestmentRatio?: Maybe<Scalars['String']>;
  foreignInvestment?: Maybe<Scalars['String']>;
  cancellationDate?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<Scalars['String']>;
  representativeEmail?: Maybe<Scalars['String']>;
  representativePhoneNumber?: Maybe<Scalars['String']>;
  factoryWebsite?: Maybe<Scalars['String']>;
  factoryZipCode?: Maybe<Scalars['String']>;
  representativeZipCode?: Maybe<Scalars['String']>;
  representativeAddress?: Maybe<Scalars['String']>;
  reasonChange?: Maybe<Scalars['String']>;
  factoryManagementNumberOld?: Maybe<Scalars['String']>;
  expirationPeriod?: Maybe<Scalars['String']>;
  factoryCondition?: Maybe<Scalars['String']>;
  freeEconomicZone?: Maybe<Scalars['String']>;
};

export type IcxFactoronModelOutput = {
  __typename?: 'IcxFactoronModelOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<IcxFactoron>;
};

export type IcxInnoBiz = {
  __typename?: 'IcxInnoBiz';
  icxModelList?: Maybe<Array<IcxInnoBizModel>>;
  count?: Maybe<Scalars['Float']>;
};

export type IcxInnoBizModel = {
  __typename?: 'IcxInnoBizModel';
  id: Scalars['String'];
  no?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  representativeName?: Maybe<Scalars['String']>;
  representativeEmai?: Maybe<Scalars['String']>;
  representativeContact?: Maybe<Scalars['String']>;
  employeesCount?: Maybe<Scalars['String']>;
  relatedIndustry?: Maybe<Scalars['String']>;
  industryCode?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  companyContact?: Maybe<Scalars['String']>;
};

export type IcxInnoBizModelOutput = {
  __typename?: 'IcxInnoBizModelOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<IcxInnoBiz>;
};

export type IcxMainBiz = {
  __typename?: 'IcxMainBiz';
  icxModelList?: Maybe<Array<IcxMainBizModel>>;
  count?: Maybe<Scalars['Float']>;
};

export type IcxMainBizModel = {
  __typename?: 'IcxMainBizModel';
  id: Scalars['String'];
  no?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  representativeName?: Maybe<Scalars['String']>;
  industryCode?: Maybe<Scalars['String']>;
  industryName?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  certificationExpirationDate?: Maybe<Scalars['String']>;
};

export type IcxMainBizModelOutput = {
  __typename?: 'IcxMainBizModelOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<IcxMainBiz>;
};

export type IcxMiniCluster = {
  __typename?: 'IcxMiniCluster';
  icxModelList?: Maybe<Array<IcxMiniClusterModel>>;
  count?: Maybe<Scalars['Float']>;
};

export type IcxMiniClusterFetchIcxInput = {
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  miniClusterSearchType?: InputMaybe<MiniClusterSearchType>;
};

export type IcxMiniClusterModel = {
  __typename?: 'IcxMiniClusterModel';
  id?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  base?: Maybe<Scalars['String']>;
  miniClusterName?: Maybe<Scalars['String']>;
  enterpriseType?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  businessRegistrationNumber?: Maybe<Scalars['String']>;
  industryUniversityInstituteCollaboration?: Maybe<Scalars['String']>;
  companyRegistrationDate?: Maybe<Scalars['String']>;
  memberName?: Maybe<Scalars['String']>;
  mailAddress?: Maybe<Scalars['String']>;
  registrationDate?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
};

export type IcxMiniClusterModelOutput = {
  __typename?: 'IcxMiniClusterModelOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<IcxMiniCluster>;
};

export type IcxModel = {
  __typename?: 'IcxModel';
  icxDetatilModelList?: Maybe<Array<IcxDetatilModel>>;
  icxDetatilModelCount?: Maybe<Scalars['Float']>;
};

export type IcxModelOutput = {
  __typename?: 'IcxModelOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<IcxDetatilModel>;
};

export type IcxModelsOutput = {
  __typename?: 'IcxModelsOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<IcxModel>;
};

/** 시 도 */
export enum IcxRegion {
  Seoul = 'Seoul',
  Busan = 'Busan',
  Incheon = 'Incheon',
  Daegu = 'Daegu',
  GwangJu = 'GwangJu',
  DaeJeon = 'DaeJeon',
  Ulsan = 'Ulsan',
  Gyeonggi = 'Gyeonggi',
  Gangwon = 'Gangwon',
  Chungbuk = 'Chungbuk',
  Chungnam = 'Chungnam',
  Jeonbuk = 'Jeonbuk',
  Jeonnam = 'Jeonnam',
  Geyongnam = 'Geyongnam',
  Geyongbuk = 'Geyongbuk',
  Jeju = 'Jeju',
  /** NULL */
  Null = 'NULL'
}

/** 토큰 갱신 */
export type IcxTokenRefreshInput = {
  /** refresh 토큰 */
  refreshToken: Scalars['String'];
};

export type IcxVentureBiz = {
  __typename?: 'IcxVentureBiz';
  icxModelList?: Maybe<Array<IcxVentureBizModel>>;
  count?: Maybe<Scalars['Float']>;
};

export type IcxVentureBizModel = {
  __typename?: 'IcxVentureBizModel';
  id: Scalars['String'];
  no?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
  relatedIndustry?: Maybe<Scalars['String']>;
  industryName?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
};

export type IcxVentureBizModelOutput = {
  __typename?: 'IcxVentureBizModelOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<IcxVentureBiz>;
};

/** IndustrialBizSearchType */
export enum IndustrialBizSearchType {
  /** 업체명 */
  BasicCompanyName = 'BASIC_COMPANY_NAME',
  /** 지역 */
  BasicCity = 'BASIC_CITY',
  /** 단지 */
  BasicComplexName = 'BASIC_COMPLEX_NAME',
  /** 제조업 */
  BasicIndustryCategory = 'BASIC_INDUSTRY_CATEGORY',
  /** 업종 */
  BasicIndustrial = 'BASIC_INDUSTRIAL',
  /** 회사 규모 */
  FullinvestigationCompanyScale = 'FULLINVESTIGATION_COMPANY_SCALE',
  /** 직원수 */
  Employees_2020FullTimeTotal = 'EMPLOYEES_2020_FULL_TIME_TOTAL'
}

/** 기업 규모 */
export enum IndustrialCompanyScale {
  MajorCompany = 'MAJOR_COMPANY',
  MidSizedCompany = 'MID_SIZED_COMPANY',
  SmallCompany = 'SMALL_COMPANY',
  /** NULL */
  Null = 'NULL'
}

/** 단지명 */
export enum IndustrialComplexName {
  /** 남동국가산업단지 */
  IndustrialComplex_1 = 'INDUSTRIAL_COMPLEX_1',
  /** 광양국가산업단지 */
  IndustrialComplex_2 = 'INDUSTRIAL_COMPLEX_2',
  /** 광주월전중소협력단지형외국인투자지역 */
  IndustrialComplex_3 = 'INDUSTRIAL_COMPLEX_3',
  /** 광주첨단과학국가산업단지 */
  IndustrialComplex_4 = 'INDUSTRIAL_COMPLEX_4',
  /** 구미국가산업단지 */
  IndustrialComplex_5 = 'INDUSTRIAL_COMPLEX_5',
  /** 구미외국인투자지역 */
  IndustrialComplex_6 = 'INDUSTRIAL_COMPLEX_6',
  /** 국가식품클러스터국가산업단지 */
  IndustrialComplex_7 = 'INDUSTRIAL_COMPLEX_7',
  /** 국가식품클러스터식품산업단지중소협력단지형외국인투자지역 */
  IndustrialComplex_8 = 'INDUSTRIAL_COMPLEX_8',
  /** 군산2국가산업단지 */
  IndustrialComplex_9 = 'INDUSTRIAL_COMPLEX_9',
  /** 군산국가산업단지 */
  IndustrialComplex_10 = 'INDUSTRIAL_COMPLEX_10',
  /** 김해GoldenRoot일반산업단지 */
  IndustrialComplex_11 = 'INDUSTRIAL_COMPLEX_11',
  /** 달성2차외국인투자지역 */
  IndustrialComplex_12 = 'INDUSTRIAL_COMPLEX_12',
  /** 달성2차일반산업단지 */
  IndustrialComplex_13 = 'INDUSTRIAL_COMPLEX_13',
  /** 대구국가산업단지 */
  IndustrialComplex_14 = 'INDUSTRIAL_COMPLEX_14',
  /** 대불국가산업단지 */
  IndustrialComplex_15 = 'INDUSTRIAL_COMPLEX_15',
  /** 대불외국인투자지역 */
  IndustrialComplex_16 = 'INDUSTRIAL_COMPLEX_16',
  /** 명지녹산국가산업단지 */
  IndustrialComplex_17 = 'INDUSTRIAL_COMPLEX_17',
  /** 문막중소협력단지형외국인투자지역 */
  IndustrialComplex_18 = 'INDUSTRIAL_COMPLEX_18',
  /** 반월국가산업단지 */
  IndustrialComplex_19 = 'INDUSTRIAL_COMPLEX_19',
  /** 부산신평장림일반산업단지(협업단지) */
  IndustrialComplex_20 = 'INDUSTRIAL_COMPLEX_20',
  /** 북평국가산업단지 */
  IndustrialComplex_21 = 'INDUSTRIAL_COMPLEX_21',
  /** 빛그린국가산업단지 */
  IndustrialComplex_22 = 'INDUSTRIAL_COMPLEX_22',
  /** 서울디지털국가산업단지 */
  IndustrialComplex_23 = 'INDUSTRIAL_COMPLEX_23',
  /** 시화국가산업단지 */
  IndustrialComplex_24 = 'INDUSTRIAL_COMPLEX_24',
  /** 시화멀티테크노밸리 */
  IndustrialComplex_25 = 'INDUSTRIAL_COMPLEX_25',
  /** 아산국가산업단지(포승지구) */
  IndustrialComplex_26 = 'INDUSTRIAL_COMPLEX_26',
  /** 여수국가산업단지 */
  IndustrialComplex_27 = 'INDUSTRIAL_COMPLEX_27',
  /** 오송생명과학단지 */
  IndustrialComplex_28 = 'INDUSTRIAL_COMPLEX_28',
  /** 온산국가산업단지 */
  IndustrialComplex_29 = 'INDUSTRIAL_COMPLEX_29',
  /** 울산미포국가산업단지 */
  IndustrialComplex_30 = 'INDUSTRIAL_COMPLEX_30',
  /** 익산국가산업단지 */
  IndustrialComplex_31 = 'INDUSTRIAL_COMPLEX_31',
  /** 장성동화농공단지 */
  IndustrialComplex_32 = 'INDUSTRIAL_COMPLEX_32',
  /** 장성삼계농공단지 */
  IndustrialComplex_33 = 'INDUSTRIAL_COMPLEX_33',
  /** 창원국가산업단지 */
  IndustrialComplex_34 = 'INDUSTRIAL_COMPLEX_34',
  /** 청주오송제2생명과학일반산업단지(충북경제자유구역 오송바이오폴리스지구) */
  IndustrialComplex_35 = 'INDUSTRIAL_COMPLEX_35',
  /** 한국수출산업(부평)국가산업단지 */
  IndustrialComplex_36 = 'INDUSTRIAL_COMPLEX_36',
  /** 한국수출산업(주안)국가산업단지 */
  IndustrialComplex_37 = 'INDUSTRIAL_COMPLEX_37',
  /** 석문국가산업단지 */
  IndustrialComplex_38 = 'INDUSTRIAL_COMPLEX_38',
  /** 아산국가산업단지(고대부곡지구) */
  IndustrialComplex_39 = 'INDUSTRIAL_COMPLEX_39',
  /** 충주외국인투자지역 */
  IndustrialComplex_40 = 'INDUSTRIAL_COMPLEX_40',
  /** 파주탄현중소기업전용국가산업단지 */
  IndustrialComplex_41 = 'INDUSTRIAL_COMPLEX_41',
  /** 원주문막반계일반산업단지 */
  IndustrialComplex_42 = 'INDUSTRIAL_COMPLEX_42',
  /** 북평일반산업단지 */
  IndustrialComplex_43 = 'INDUSTRIAL_COMPLEX_43',
  /** 양주홍죽일반산업단지 */
  IndustrialComplex_44 = 'INDUSTRIAL_COMPLEX_44',
  /** 송산2외국인투자지역 */
  IndustrialComplex_45 = 'INDUSTRIAL_COMPLEX_45',
  /** 사천제2일반산업단지 */
  IndustrialComplex_46 = 'INDUSTRIAL_COMPLEX_46',
  /** 송산2-1외국인투자지역 */
  IndustrialComplex_47 = 'INDUSTRIAL_COMPLEX_47',
  /** 사천제1일반산업단지 */
  IndustrialComplex_48 = 'INDUSTRIAL_COMPLEX_48',
  /** 사천외국인투자지역 */
  IndustrialComplex_49 = 'INDUSTRIAL_COMPLEX_49',
  /** 아산제2테크노밸리일반산업단지 */
  IndustrialComplex_50 = 'INDUSTRIAL_COMPLEX_50',
  /** 이천장호원일반산업단지 */
  IndustrialComplex_51 = 'INDUSTRIAL_COMPLEX_51',
  /** 천안외국인투자지역 */
  IndustrialComplex_52 = 'INDUSTRIAL_COMPLEX_52',
  /** 사천임대전용산업단지 */
  IndustrialComplex_53 = 'INDUSTRIAL_COMPLEX_53',
  /** 천안5산단외국인투자지역 */
  IndustrialComplex_54 = 'INDUSTRIAL_COMPLEX_54',
  /** 진해국가산업단지 */
  IndustrialComplex_55 = 'INDUSTRIAL_COMPLEX_55',
  /** 진천산수외국인투자지역 */
  IndustrialComplex_56 = 'INDUSTRIAL_COMPLEX_56',
  /** 이천대월일반산업단지 */
  IndustrialComplex_57 = 'INDUSTRIAL_COMPLEX_57',
  /** 인주외국인투자지역 */
  IndustrialComplex_58 = 'INDUSTRIAL_COMPLEX_58',
  /** 포항국가산업단지 */
  IndustrialComplex_59 = 'INDUSTRIAL_COMPLEX_59',
  /** 장항국가생태산업단지 */
  IndustrialComplex_60 = 'INDUSTRIAL_COMPLEX_60',
  /** 오창외국인투자지역 */
  IndustrialComplex_61 = 'INDUSTRIAL_COMPLEX_61',
  /** 포항블루밸리국가산업단지 */
  IndustrialComplex_62 = 'INDUSTRIAL_COMPLEX_62',
  /** 안정국가산업단지 */
  IndustrialComplex_63 = 'INDUSTRIAL_COMPLEX_63',
  /** 송산2-2외국인투자지역 */
  IndustrialComplex_64 = 'INDUSTRIAL_COMPLEX_64',
  /** NULL */
  Null = 'NULL'
}

/** 업종_대분류 */
export enum IndustrialSectorsCategory {
  Produce = 'PRODUCE',
  NonManufacturing = 'NON_MANUFACTURING',
  /** NULL */
  Null = 'NULL'
}

/** 업종 */
export enum IndustrialSectorsName {
  /** 01. 음식료 */
  SectorName_1 = 'SECTOR_NAME_1',
  /** 02. 섬유의복 */
  SectorName_2 = 'SECTOR_NAME_2',
  /** 03. 목재종이 */
  SectorName_3 = 'SECTOR_NAME_3',
  /** 04. 석유화학 */
  SectorName_4 = 'SECTOR_NAME_4',
  /** 05. 비금속 */
  SectorName_5 = 'SECTOR_NAME_5',
  /** 06. 철강 */
  SectorName_6 = 'SECTOR_NAME_6',
  /** 07. 기계 */
  SectorName_7 = 'SECTOR_NAME_7',
  /** 08. 전기전자 */
  SectorName_8 = 'SECTOR_NAME_8',
  /** 09. 운송장비 */
  SectorName_9 = 'SECTOR_NAME_9',
  /** 10. (제조)기타 */
  SectorName_10 = 'SECTOR_NAME_10',
  /** 11. 정보통신업 */
  SectorName_11 = 'SECTOR_NAME_11',
  /** 12. */
  SectorName_12 = 'SECTOR_NAME_12',
  /** 13. 출판업 */
  SectorName_13 = 'SECTOR_NAME_13',
  /** 14. (비제조)기타 */
  SectorName_14 = 'SECTOR_NAME_14',
  /** NULL */
  Null = 'NULL'
}

export type InnoBizFetchIcxInput = {
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  innoBizSearchType?: InputMaybe<InnoBizSearchType>;
  employeesCountSortType?: InputMaybe<CapaSortType>;
};

/** InnoBizSearchType */
export enum InnoBizSearchType {
  /** 업체명 */
  CompanyName = 'COMPANY_NAME',
  /** 주소 */
  Address = 'ADDRESS',
  /** 종업원수 */
  EmployeesCount = 'EMPLOYEES_COUNT',
  /** 업종 */
  RelatedIndustry = 'RELATED_INDUSTRY',
  /** 업종코드 */
  IndustryCode = 'INDUSTRY_CODE',
  /** 주생산품 */
  RepresentativeName = 'REPRESENTATIVE_NAME',
  /** 연락처 */
  CompanyContact = 'COMPANY_CONTACT'
}

export type InsertCommentBoInput = {
  /** quotation user id */
  quotationUserId: Scalars['String'];
  /** back office user id */
  backOfficeId: Scalars['String'];
  /** comment */
  comment: Scalars['String'];
};

export type InsertMemoBoInput = {
  /** user id */
  id: Scalars['String'];
  /** back office user id */
  back_office_id: Scalars['String'];
  /** memo */
  memo: Scalars['String'];
  /** type */
  type: Scalars['String'];
};

export type InviteConnectGroupUserInput = {
  email: Scalars['String'];
  accessLevel: CapaConnectGroupAccessLevel;
};

export type InviteConnectGroupUsersInput = {
  groupId: Scalars['String'];
  inviteUsers: Array<InviteConnectGroupUserInput>;
};

export type IsUsedPayment = {
  __typename?: 'IsUsedPayment';
  isUsedPayment: Scalars['Boolean'];
};

/** ITP 이벤트 증빙 파일 */
export type ItpEventFileUploadInput = {
  /** fk ITP 이벤트 증빙 파일 아이디 */
  fileId: Scalars['String'];
};

/** JSB 이벤트 증빙 파일 */
export type JsbEventFileUploadInput = {
  /** fk JSB 이벤트 증빙 파일 아이디 */
  fileId: Scalars['String'];
};

export enum Language {
  Korean = 'KOREAN',
  English = 'ENGLISH',
  Chinese = 'CHINESE',
  Vietnam = 'VIETNAM'
}

export type LeaveConnectGroupInput = {
  groupId: Scalars['String'];
};

export type MainBizFetchIcxInput = {
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  mainBizSearchType?: InputMaybe<MainBizSearchType>;
};

/** MainBizSearchType */
export enum MainBizSearchType {
  /** 사업자명 */
  CompanyName = 'COMPANY_NAME',
  /** 대표자명 */
  RepresentativeName = 'REPRESENTATIVE_NAME',
  /** 업종코드 */
  IndustryCode = 'INDUSTRY_CODE',
  /** 업종명 */
  IndustryName = 'INDUSTRY_NAME',
  /** 지역 */
  Region = 'REGION',
  /** 소재지 */
  Location = 'LOCATION'
}

export type ManageConnectGroupUserInput = {
  groupId: Scalars['String'];
  userEmail: Scalars['String'];
  action: CapaConnectGroupUserAction;
  accessLevel?: InputMaybe<CapaConnectGroupAccessLevel>;
};

export type ManageDownloadPermissionInput = {
  /** 그룹ID */
  groupId: Scalars['String'];
  groupUserId?: InputMaybe<Scalars['String']>;
  connectFileId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CapaQuotationRfqAllowOpenFileStatus>;
};

export type ManageQuotationPartnerAccountBoInput = {
  /** 서브몰 계좌 등록할 고객의 이메일 */
  targetEmail: Scalars['String'];
  /** quotation partner id */
  partnerId: Scalars['String'];
  /** 서브몰 이름 (상호명) */
  submallName: Scalars['String'];
  /** 대표자명 */
  managerName: Scalars['String'];
  /** 통장 사본 fileId */
  bankbookFileId: Scalars['String'];
  /** 정산 은행 코드 */
  bankCode: CapaBankCode;
  /** 정산 계좌번호(`-`제외) */
  accountNumber: Scalars['String'];
  /** 예금주명 */
  accountHolder: Scalars['String'];
};

export type ManageQuotationPartnerAccountInput = {
  /** quotation partner id */
  partnerId: Scalars['String'];
  /** 서브몰 이름 (상호명) */
  submallName: Scalars['String'];
  /** 대표자명 */
  managerName: Scalars['String'];
  /** 통장 사본 fileId */
  bankbookFileId: Scalars['String'];
  /** 정산 은행 코드 */
  bankCode: CapaBankCode;
  /** 정산 계좌번호(`-`제외) */
  accountNumber: Scalars['String'];
  /** 예금주명 */
  accountHolder: Scalars['String'];
};

/** MiniClusterSearchType */
export enum MiniClusterSearchType {
  /** 지역 */
  Region = 'REGION',
  /** 거점 */
  Base = 'BASE',
  /** 미니클러스터 명 */
  MiniClusterName = 'MINI_CLUSTER_NAME',
  /** 기업 유형 */
  EnterPriseType = 'ENTER_PRISE_TYPE',
  /** 기업명 */
  CompanyName = 'COMPANY_NAME',
  /** 산학 연구분 */
  IndustryUniversityInstituteCollaboration = 'INDUSTRY_UNIVERSITY_INSTITUTE_COLLABORATION'
}

export type MoveConnectFileInput = {
  fileId: Scalars['String'];
  destId?: InputMaybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * 캐파 유저 통합 회원 가입
   * @deprecated change name @see {registerUser, RegisterCapaUserInput}
   */
  register: AuthenticationOutput;
  /** 캐파 유저 통합 회원 가입 */
  registerUser: AuthenticationOutput;
  /** capa_user & capa_quotation_user 통합 회원가입 */
  registerIntegratedUser: AuthenticationOutput;
  /** 약관 동의하지 않은 유저를 위한 약관 동의 api */
  updateTerms: Output;
  /** Authorization: Bearer 토큰 갱신 */
  refresh: AuthenticationOutput;
  /** 이메일 인증 요청 */
  requestEmailVerificationCode: Output;
  /** 비밀번호 찾기/재설정 */
  requestResetPassword: Output;
  /** 비밀번호 변경하기 */
  changePassword: Output;
  /** 이메일 수정 */
  changeEmail: Output;
  /** 추천 아이디 코드 발급 */
  requestReferralId: CapaReferralOut;
  /** 핸드폰 인증 요청 */
  requestCellPhoneVerificationCode: Output;
  /** 핸드폰 인증 요청 */
  verifyCellPhoneVerificationCode: Output;
  /** 고객 회원 탈퇴 */
  withdrawQuotationUser: Output;
  /** 파트너 회원 탈퇴 */
  withdrawQuotationPartner: Output;
  /** 엠베서더 주도 신규 회원 가입 페이지 조회수 증가 */
  updateAmbassadorSignUpPageViewCountByIp: Output;
  registerQuotationUserBO: Output;
  updateQuotationUserBO: Output;
  withdrawQuotationUserBO: Output;
  registerQuotationPartnerBO: CapaQuotationPartnerOutput;
  updateQuotationPartnerBO: Output;
  withdrawQuotationPartnerBO: Output;
  insertBOMemo: Output;
  deleteBOMemo: Output;
  approvedQuotationPartnerByEmail: Output;
  updateBOTestUser: Output;
  createNoticeScheduleBO: NoticeScheduleOutput;
  updateNoticeScheduleBO: NoticeScheduleOutput;
  insertCommentBO: Output;
  registerBackOfficeUser: Output;
  updateBackOfficeUser: Output;
  withdrawBackOfficeUser: Output;
  updateRfqStatusBO: Output;
  updateQuotationPartnerStatusBO: Output;
  registerAmbassadorBO: Output;
  updateAmbassadorBO: Output;
  migration: Output;
  updateSubmallStatusBO: Output;
  updatePurchaseOrderStatusBO: Output;
  createRefundAccountBO: Output;
  manageQuotationPartnerAccountBO: Output;
  updateBOTestConnectGroup: Output;
  createAdvertisementBO: Output;
  createAdsImpressionBO: Output;
  createAdvertisingBO: Output;
  activateAdvertisingBO: Output;
  registerQuotationUser: AuthenticationOutput;
  registerQuotationPartner: AuthenticationOutput;
  suggestService: Output;
  sendQuotationChatMessage: CapaQuotationChatRoomOutput;
  quitQuotationChatRoom: Output;
  readQuotationChatMessage: Output;
  subscribeCAPANews: Output;
  updateBypassChatComplaint: Output;
  deleteQuotationChatMessage: Output;
  createQuotationAnnotation: CapaQuotationAnnotationOutput;
  createQuotationAnnotationComment: CapaQuotationAnnotationOutput;
  removeQuotationAnnotation: Output;
  removeQuotationAnnotationComment: Output;
  updateQuotationAnnotation: Output;
  readQuotationAnnotationComment: Output;
  updateQuotationAnnotationComment: Output;
  updatePurchaseOrderStatus: Output;
  sendSystemChatMessage: Output;
  updateQuotationPartner: UpdateCapaQuotationPartnerStrategyOutput;
  createQuotationChatRoom: CapaQuotationChatRoomOutput;
  rateQuotationServicePartner: Output;
  batchShutDownQuotationPartnerChatRooms: Output;
  saveCapabilities: Output;
  saveRfqFilter: Output;
  rejectRfqPurchaseOrder: Output;
  manageQuotationPartnerAccount: Output;
  updateQuotationUser: CapaQuotationUserOutput;
  rateQuotationServiceUser: Output;
  changeChatRoomStatusOpen: Output;
  changeQuotationMessageInvisible: Output;
  delayConfirmEscrowPurchase: Output;
  createMyRefundAccountByQuotationUser: Output;
  deleteMyRefundAccountByQuotationUser: Output;
  updateIdentityVerification: Output;
  /** 캐파 클라우드 회원가입 */
  registerCloudUser: AuthenticationOutput;
  /**
   * 캐파 클라우드 파일 삭제
   * rest api 와 동일 기능
   * [Delete <URL>/cloud/:fileId]
   */
  removeCloudFile: Output;
  registerConnectUser: AuthenticationOutput;
  updateConnectUser: CapaConnectUserOutput;
  removeConnectUser: Output;
  createConnectFolder: Output;
  removeConnectFile: Output;
  renameConnectFile: Output;
  requestDownloadPermission: Output;
  manageDownloadPermission: Output;
  moveConnectFile: Output;
  addConnectFiles: Output;
  createGroup: CreateConnectGroupOutput;
  createGroupWithCapa: CreateConnectGroupOutput;
  inviteGroupMembers: Output;
  manageGroupMember: Output;
  removeGroup: Output;
  renameGroupName: Output;
  exitGroup: Output;
  shareFilesToGroup: Output;
  unshareFileFromGroup: Output;
  checkDuplicateGroupName: Output;
  leaveGroup: Output;
  createConnectAnnotation: CapaConnectAnnotationOutput;
  createConnectAnnotationComment: CapaConnectAnnotationOutput;
  updateConnectAnnotation: CapaConnectAnnotationOutput;
  updateConnectAnnotationComment: CapaConnectAnnotationOutput;
  removeConnectAnnotation: Output;
  removeConnectAnnotationComment: CapaConnectAnnotationOutput;
  sendAnnotationCommentToChat: Output;
  readConnectAnnotationComment: Output;
  sendConnectChatMessage: Output;
  sendConnectChatMessageToCapa: Output;
  readConnectChatMessage: CapaChatMessagesReadOutput;
  createConnectContactUser: Output;
  updateConnectContactUser: Output;
  removeConnectContactUser: Output;
  updateConnectUserFilePermission: Output;
  updateConnectUserFileLinkStatus: UpdateConnectUserFileLinkOutput;
  addConnectLinkFiles: Output;
  createConnectFeedback: Output;
  createConnectIssue: Output;
  registerItpEvent: Output;
  approveItpEvent: Output;
  registerJsbEvent: Output;
  registerRFQ: Output;
  requestAdjustRfqQuotation: Output;
  confirmRfqQuotation: Output;
  confirmRfqTransaction: Output;
  completeRfqTransaction: Output;
  readRfqQuotation: Output;
  createPurchaseOrder: CapaQuotationCreatePurchaseOrderOutput;
  expireRfq: Output;
  evaluateRfqPartners: Output;
  allowRfqDrawingFileDownload: Output;
  reviewRfq: Output;
  readAllManagement: Output;
  readManagement: Output;
  registerRequestRfqQuotation: Output;
  registerRfqReview: Output;
  updateRfqReview: Output;
  requestRegisterTransactionReview: Output;
  createPaymentAfterCreatePurchaseOrder: Output;
  expireRfqTest: Output;
  registerRequestRfqPurchaseOrder: Output;
  requestAdjustRfqPurchaseOrder: Output;
  confirmRfqPurchaseOrder: Output;
  requestAdjustRfqPurchaseOrderWithItem: Output;
  confirmRfqPurchaseOrderWithItem: Output;
  requestConfirmRfqTransaction: Output;
  requestCompleteRfqTransaction: Output;
  readRfqPurchaseOrder: Output;
  createSimpleQuotation: CapaQuotationChatRoomOutput;
  createDetailedQuotation: CapaQuotationChatRoomOutput;
  requestRfqDrawingFileDownload: Output;
  toggleFavorite: Output;
  replyRfqReview: Output;
  sendQuotationPartnerIntroduction: Output;
  readRfqAdjustRequest: Output;
  /** 사용자 활동 로그 입력 완료 */
  writeUserActivityLog: Output;
  /** 광고 활동 로그 입력 */
  writeAdsActivityLog: Output;
  readNotification: Output;
  clearNewNotification: Output;
  /** Authorization: Bearer 토큰 갱신 */
  icxRefreshAccessToken: IcxAuthenticationOutput;
};

export type MutationRegisterArgs = {
  input: RegistrationInput;
};

export type MutationRegisterUserArgs = {
  input: RegisterCapaUserInput;
};

export type MutationRegisterIntegratedUserArgs = {
  input: RegisterIntegratedUserInput;
};

export type MutationUpdateTermsArgs = {
  input: UpdateCapaUserTermsInput;
};

export type MutationRefreshArgs = {
  input: TokenRefreshInput;
};

export type MutationRequestEmailVerificationCodeArgs = {
  input: RequestEmailVerificationCodeInput;
};

export type MutationRequestResetPasswordArgs = {
  input: RequestResetPasswordInput;
};

export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};

export type MutationChangeEmailArgs = {
  input: ChangeEmailInput;
};

export type MutationRequestReferralIdArgs = {
  input: RequestReferralInput;
};

export type MutationRequestCellPhoneVerificationCodeArgs = {
  input: RequestCellPhoneVerificationCodeInput;
};

export type MutationVerifyCellPhoneVerificationCodeArgs = {
  input: VerifyCellPhoneVerificationCodeInput;
};

export type MutationWithdrawQuotationUserArgs = {
  input: WithdrawQuotationUserInput;
};

export type MutationWithdrawQuotationPartnerArgs = {
  input: WithdrawQuotationPartnerInput;
};

export type MutationUpdateAmbassadorSignUpPageViewCountByIpArgs = {
  input: UpdateAmbassadorSignUpPageViewCountByIpInput;
};

export type MutationRegisterQuotationUserBoArgs = {
  input: UpdateQuotationUserBoInput;
};

export type MutationUpdateQuotationUserBoArgs = {
  input: UpdateQuotationUserBoInput;
};

export type MutationWithdrawQuotationUserBoArgs = {
  input: WithdrawQuotationUserBoInput;
};

export type MutationRegisterQuotationPartnerBoArgs = {
  input: RegisterQuotationPartnerBoInput;
};

export type MutationUpdateQuotationPartnerBoArgs = {
  input: UpdateQuotationPartnerBoStrategyInput;
};

export type MutationWithdrawQuotationPartnerBoArgs = {
  input: WithdrawQuotationPartnerBoInput;
};

export type MutationInsertBoMemoArgs = {
  input: InsertMemoBoInput;
};

export type MutationDeleteBoMemoArgs = {
  input: InsertMemoBoInput;
};

export type MutationApprovedQuotationPartnerByEmailArgs = {
  input: ApprovedQuotationPartnerByEmailInput;
};

export type MutationUpdateBoTestUserArgs = {
  input: UpdateBoTestUserInput;
};

export type MutationCreateNoticeScheduleBoArgs = {
  input: CreateNoticeScheduleInput;
};

export type MutationUpdateNoticeScheduleBoArgs = {
  input: UpdateNoticeScheduleInput;
};

export type MutationInsertCommentBoArgs = {
  input: InsertCommentBoInput;
};

export type MutationRegisterBackOfficeUserArgs = {
  input: RegisterBackOfficeUserInput;
};

export type MutationUpdateBackOfficeUserArgs = {
  input: UpdateBackOfficeUserInput;
};

export type MutationWithdrawBackOfficeUserArgs = {
  input: WithdrawBackOfficeUserInput;
};

export type MutationUpdateRfqStatusBoArgs = {
  input: UpdateRfqStatusInput;
};

export type MutationUpdateQuotationPartnerStatusBoArgs = {
  input: UpdateQuotationPartnerStatusInput;
};

export type MutationRegisterAmbassadorBoArgs = {
  input: RegisterAmbassadorBoInput;
};

export type MutationUpdateAmbassadorBoArgs = {
  input: UpdateAmbassadorBoInput;
};

export type MutationUpdateSubmallStatusBoArgs = {
  input: UpdateSubmallStatusBoInput;
};

export type MutationUpdatePurchaseOrderStatusBoArgs = {
  input: UpdatePurchaseOrderStatusBoInput;
};

export type MutationCreateRefundAccountBoArgs = {
  input: CreateMyRefundAccountBoInput;
};

export type MutationManageQuotationPartnerAccountBoArgs = {
  input: ManageQuotationPartnerAccountBoInput;
};

export type MutationUpdateBoTestConnectGroupArgs = {
  input: UpdateBoTestConnectGroupInput;
};

export type MutationCreateAdvertisementBoArgs = {
  input: CreateAdvertisementBoInput;
};

export type MutationCreateAdsImpressionBoArgs = {
  input: CreateAdsImpressionBoInput;
};

export type MutationCreateAdvertisingBoArgs = {
  input: CreateAdvertisingBoInput;
};

export type MutationActivateAdvertisingBoArgs = {
  input: ActivateAdvertisinBoInput;
};

export type MutationRegisterQuotationUserArgs = {
  input: RegisterQuotationUserInput;
};

export type MutationRegisterQuotationPartnerArgs = {
  input: RegisterQuotationPartnerInput;
};

export type MutationSuggestServiceArgs = {
  input: SuggestServiceInput;
};

export type MutationSendQuotationChatMessageArgs = {
  input: SendQuotationChatMessageInput;
};

export type MutationQuitQuotationChatRoomArgs = {
  input: QuitQuotationChatRoomInput;
};

export type MutationReadQuotationChatMessageArgs = {
  input: ReadQuotationChatRoomMessageInput;
};

export type MutationSubscribeCapaNewsArgs = {
  input: SubscribeCapaNewsInput;
};

export type MutationUpdateBypassChatComplaintArgs = {
  input: UpdateReceiveComplaintQuotationChatMessageInput;
};

export type MutationDeleteQuotationChatMessageArgs = {
  input: DeleteQuotationChatMessageInput;
};

export type MutationCreateQuotationAnnotationArgs = {
  input: CreateQuotationAnnotationInput;
};

export type MutationCreateQuotationAnnotationCommentArgs = {
  input: CreateQuotationAnnotationCommentInput;
};

export type MutationRemoveQuotationAnnotationArgs = {
  input: RemoveQuotationAnnotationInput;
};

export type MutationRemoveQuotationAnnotationCommentArgs = {
  input: RemoveQuotationAnnotationCommentInput;
};

export type MutationUpdateQuotationAnnotationArgs = {
  input: UpdateQuotationAnnotationInput;
};

export type MutationReadQuotationAnnotationCommentArgs = {
  input: ReadQuotationAnnotationCommentInput;
};

export type MutationUpdateQuotationAnnotationCommentArgs = {
  input: UpdateQuotationAnnotationCommentInput;
};

export type MutationUpdatePurchaseOrderStatusArgs = {
  input: UpdatePurchaseOrderStatusInput;
};

export type MutationSendSystemChatMessageArgs = {
  input: SendSystemChatMessageInput;
};

export type MutationUpdateQuotationPartnerArgs = {
  input: UpdateQuotationPartnerStrategyInput;
};

export type MutationCreateQuotationChatRoomArgs = {
  input: CreateQuotationChatRoomInput;
};

export type MutationRateQuotationServicePartnerArgs = {
  input: QuotationServiceRatingInput;
};

export type MutationBatchShutDownQuotationPartnerChatRoomsArgs = {
  input: BatchShutDownQuotationPartnerChatRoomsInput;
};

export type MutationSaveCapabilitiesArgs = {
  input: SaveRfqCapabilitiesInput;
};

export type MutationSaveRfqFilterArgs = {
  input: SaveRfqFilterInput;
};

export type MutationRejectRfqPurchaseOrderArgs = {
  input: RejectRfqPurchaseOrderInput;
};

export type MutationManageQuotationPartnerAccountArgs = {
  input: ManageQuotationPartnerAccountInput;
};

export type MutationUpdateQuotationUserArgs = {
  input: UpdateQuotationUserInput;
};

export type MutationRateQuotationServiceUserArgs = {
  input: QuotationServiceRatingInput;
};

export type MutationChangeChatRoomStatusOpenArgs = {
  input: ChangeChatRoomStatusInput;
};

export type MutationChangeQuotationMessageInvisibleArgs = {
  input: ChangeChatMessageInvisibleInput;
};

export type MutationDelayConfirmEscrowPurchaseArgs = {
  input: DelayConfirmEscrowPurchaseInput;
};

export type MutationCreateMyRefundAccountByQuotationUserArgs = {
  input: CreateMyRefundAccountInput;
};

export type MutationDeleteMyRefundAccountByQuotationUserArgs = {
  input: DeleteMyRefundAccountInput;
};

export type MutationUpdateIdentityVerificationArgs = {
  input: UpdateIdentityVerificationInput;
};

export type MutationRemoveCloudFileArgs = {
  input: RequestFileInput;
};

export type MutationRegisterConnectUserArgs = {
  input: RegisterConnectUserInput;
};

export type MutationUpdateConnectUserArgs = {
  input: UpdateConnectUserInput;
};

export type MutationRemoveConnectUserArgs = {
  input: RemoveConnectUserInput;
};

export type MutationCreateConnectFolderArgs = {
  input: RegisterConnectUserFolderInput;
};

export type MutationRemoveConnectFileArgs = {
  input: RemoveConnectFileInput;
};

export type MutationRenameConnectFileArgs = {
  input: RenameConnectFileInput;
};

export type MutationRequestDownloadPermissionArgs = {
  input: RequestDownloadPermissionInput;
};

export type MutationManageDownloadPermissionArgs = {
  input: ManageDownloadPermissionInput;
};

export type MutationMoveConnectFileArgs = {
  input: MoveConnectFileInput;
};

export type MutationAddConnectFilesArgs = {
  input: AddConnectFilesInput;
};

export type MutationCreateGroupArgs = {
  input: CreateConnectGroupInput;
};

export type MutationInviteGroupMembersArgs = {
  input: InviteConnectGroupUsersInput;
};

export type MutationManageGroupMemberArgs = {
  input: ManageConnectGroupUserInput;
};

export type MutationRemoveGroupArgs = {
  input: RemoveConnectGroupInput;
};

export type MutationRenameGroupNameArgs = {
  input: RenameConnectGroupInput;
};

export type MutationExitGroupArgs = {
  input: FetchConnectGroupInput;
};

export type MutationShareFilesToGroupArgs = {
  input: ShareConnectFilesInput;
};

export type MutationUnshareFileFromGroupArgs = {
  input: UnshareConnectFilesInput;
};

export type MutationCheckDuplicateGroupNameArgs = {
  input: CheckConnectDuplicateGroupNameInput;
};

export type MutationLeaveGroupArgs = {
  input: LeaveConnectGroupInput;
};

export type MutationCreateConnectAnnotationArgs = {
  input: CreateConnectAnnotationInput;
};

export type MutationCreateConnectAnnotationCommentArgs = {
  input: CreateConnectAnnotationCommentInput;
};

export type MutationUpdateConnectAnnotationArgs = {
  input: UpdateConnectAnnotationInput;
};

export type MutationUpdateConnectAnnotationCommentArgs = {
  input: UpdateConnectAnnotationCommentInput;
};

export type MutationRemoveConnectAnnotationArgs = {
  input: RemoveConnectAnnotationInput;
};

export type MutationRemoveConnectAnnotationCommentArgs = {
  input: RemoveConnectAnnotationCommentInput;
};

export type MutationSendAnnotationCommentToChatArgs = {
  input: SendAnnotationCommentToChatInput;
};

export type MutationReadConnectAnnotationCommentArgs = {
  input: ReadConnectAnnotationCommentInput;
};

export type MutationSendConnectChatMessageArgs = {
  input: SendConnectChatMessageInput;
};

export type MutationSendConnectChatMessageToCapaArgs = {
  input: SendConnectChatMessageToCapaInput;
};

export type MutationReadConnectChatMessageArgs = {
  input: ReadConnectChatRoomMessageInput;
};

export type MutationCreateConnectContactUserArgs = {
  input: CreateConnectContactUserInput;
};

export type MutationUpdateConnectContactUserArgs = {
  input: CreateConnectContactUserInput;
};

export type MutationRemoveConnectContactUserArgs = {
  input: RemoveConnectContactUserInput;
};

export type MutationUpdateConnectUserFilePermissionArgs = {
  input: UpdateConnectUserFilePermissionInput;
};

export type MutationUpdateConnectUserFileLinkStatusArgs = {
  input: UpdateConnectUserFileLinkInput;
};

export type MutationAddConnectLinkFilesArgs = {
  input: AddConnectFilesInput;
};

export type MutationCreateConnectFeedbackArgs = {
  input: CreateConnectFeedbackInput;
};

export type MutationCreateConnectIssueArgs = {
  input: CreateConnectIssueInput;
};

export type MutationRegisterItpEventArgs = {
  input: RegisterItpEventInput;
};

export type MutationApproveItpEventArgs = {
  input: ApproveItpEventInput;
};

export type MutationRegisterJsbEventArgs = {
  input: RegisterJsbEventInput;
};

export type MutationRegisterRfqArgs = {
  input: RegisterRfqInput;
};

export type MutationRequestAdjustRfqQuotationArgs = {
  input: RequestAdjustRfqQuotationInput;
};

export type MutationConfirmRfqQuotationArgs = {
  input: ConfirmRfqQuotationInput;
};

export type MutationConfirmRfqTransactionArgs = {
  input: ConfirmRfqTransactionInput;
};

export type MutationCompleteRfqTransactionArgs = {
  input: CompleteRfqTransactionInput;
};

export type MutationReadRfqQuotationArgs = {
  input: ReadRfqQuotationInput;
};

export type MutationCreatePurchaseOrderArgs = {
  input: CreatePurchaseOrderInput;
};

export type MutationExpireRfqArgs = {
  input: ExpireRfqInput;
};

export type MutationEvaluateRfqPartnersArgs = {
  input: EvaluateRfqPartnersInput;
};

export type MutationAllowRfqDrawingFileDownloadArgs = {
  input: AllowRfqDrawingFileDownloadInput;
};

export type MutationReviewRfqArgs = {
  input: ReviewRfqInput;
};

export type MutationReadAllManagementArgs = {
  input: ReadAllManagementInput;
};

export type MutationReadManagementArgs = {
  input: ReadManagementInput;
};

export type MutationRegisterRequestRfqQuotationArgs = {
  input: RegisterRequestRfqQuotationInput;
};

export type MutationRegisterRfqReviewArgs = {
  input: RegisterRfqReviewInput;
};

export type MutationUpdateRfqReviewArgs = {
  input: UpdateRfqReviewInput;
};

export type MutationRequestRegisterTransactionReviewArgs = {
  input: RequestRegisterTransactionReviewInput;
};

export type MutationCreatePaymentAfterCreatePurchaseOrderArgs = {
  input: CreatePaymentInput;
};

export type MutationExpireRfqTestArgs = {
  input: ExpireRfqInput;
};

export type MutationRegisterRequestRfqPurchaseOrderArgs = {
  input: RegisterRequestRfqPurchaseOrderInput;
};

export type MutationRequestAdjustRfqPurchaseOrderArgs = {
  input: RequestAdjustRfqPurchaseOrderInput;
};

export type MutationConfirmRfqPurchaseOrderArgs = {
  input: ConfirmRfqPurchaseOrderInput;
};

export type MutationRequestAdjustRfqPurchaseOrderWithItemArgs = {
  input: RequestAdjustRfqPurchaseOrderInput;
};

export type MutationConfirmRfqPurchaseOrderWithItemArgs = {
  input: ConfirmRfqPurchaseOrderInput;
};

export type MutationRequestConfirmRfqTransactionArgs = {
  input: RequestConfirmRfqTransactionInput;
};

export type MutationRequestCompleteRfqTransactionArgs = {
  input: RequestConfirmRfqTransactionInput;
};

export type MutationReadRfqPurchaseOrderArgs = {
  input: ReadRfqPurchaseOrderInput;
};

export type MutationCreateSimpleQuotationArgs = {
  input: CreateSimpleQuotationInput;
};

export type MutationCreateDetailedQuotationArgs = {
  input: CreateDetailedQuotationInput;
};

export type MutationRequestRfqDrawingFileDownloadArgs = {
  input: RequestRfqDrawingFileDownloadInput;
};

export type MutationToggleFavoriteArgs = {
  input: FavoriteRfqInput;
};

export type MutationReplyRfqReviewArgs = {
  input: ReplyRfqReviewInput;
};

export type MutationSendQuotationPartnerIntroductionArgs = {
  input: SendQuotationPartnerIntroductionInput;
};

export type MutationReadRfqAdjustRequestArgs = {
  input: ReadRfqAdjustRequestInput;
};

export type MutationWriteUserActivityLogArgs = {
  input: UserActivityLogInput;
};

export type MutationWriteAdsActivityLogArgs = {
  input: AdsActivityLogInput;
};

export type MutationReadNotificationArgs = {
  input: ReadNotificationInput;
};

export type MutationClearNewNotificationArgs = {
  input: ReadNotificationInput;
};

export type MutationIcxRefreshAccessTokenArgs = {
  input: IcxTokenRefreshInput;
};

/** NiceDnbAccssToken */
export type NiceDnbAccssToken = {
  __typename?: 'NiceDnbAccssToken';
  /** JWT */
  accessToken: Scalars['String'];
  tokenType: Scalars['String'];
  /** expiresIn */
  expiresIn: Scalars['Float'];
  /** scope */
  scope: Scalars['String'];
};

/** NiceDnbCompanyInformation */
export type NiceDnbCompanyInformation = {
  __typename?: 'NiceDnbCompanyInformation';
  /** 기업 이름 */
  cmpNm?: Maybe<Scalars['String']>;
  /** 기업 규모 */
  cmpSclNm?: Maybe<Scalars['String']>;
  /** 비즈니스 타입 */
  bzTypNm?: Maybe<Scalars['String']>;
  /** 비즈니스 컨텐츠 이름 */
  bzcndNm?: Maybe<Scalars['String']>;
  /** 대표자 이름 */
  ceoNm?: Maybe<Scalars['String']>;
  /** 설립 일자 */
  estbDate?: Maybe<Scalars['String']>;
  /** homepageUrl */
  homepageUrl?: Maybe<Scalars['String']>;
  /** 직원수 */
  empCnt?: Maybe<Scalars['String']>;
  /** 주소 */
  adr?: Maybe<Scalars['String']>;
  /** 상세 주소 */
  dtlAdr?: Maybe<Scalars['String']>;
  /** 우편 번호 */
  zip?: Maybe<Scalars['String']>;
  /** 사업자 번호 */
  bizNo?: Maybe<Scalars['String']>;
  /** 폐업일 */
  statOcrDate?: Maybe<Scalars['String']>;
  /** 휴폐업구분 */
  clsbzNm?: Maybe<Scalars['String']>;
};

/** NiceDnbCompanyInformationInput */
export type NiceDnbCompanyInformationInput = {
  /** 기업 이름 */
  cmpNm?: InputMaybe<Scalars['String']>;
  /** 기업 규모 */
  cmpSclNm?: InputMaybe<Scalars['String']>;
  /** 비즈니스 타입 */
  bzTypNm?: InputMaybe<Scalars['String']>;
  /** 비즈니스 컨텐츠 이름 */
  bzcndNm?: InputMaybe<Scalars['String']>;
  /** 대표자 이름 */
  ceoNm?: InputMaybe<Scalars['String']>;
  /** 설립 일자 */
  estbDate?: InputMaybe<Scalars['String']>;
  /** homepageUrl */
  homepageUrl?: InputMaybe<Scalars['String']>;
  /** 직원수 */
  empCnt?: InputMaybe<Scalars['String']>;
  /** 주소 */
  adr?: InputMaybe<Scalars['String']>;
  /** 상세 주소 */
  dtlAdr?: InputMaybe<Scalars['String']>;
  /** 우편 번호 */
  zip?: InputMaybe<Scalars['String']>;
  /** 사업자등록번호 */
  bizNo?: InputMaybe<Scalars['String']>;
  /** 폐업일 */
  statOcrDate?: InputMaybe<Scalars['String']>;
  /** 휴폐업구분 */
  clsbzNm?: InputMaybe<Scalars['String']>;
};

/** NiceDnbCompanyOverView */
export type NiceDnbCompanyOverView = {
  __typename?: 'NiceDnbCompanyOverView';
  /** 기업 이름 */
  cmpNm: Scalars['String'];
  /** 기업 규모 */
  cmpSclNm: Scalars['String'];
  /** 비즈니스 타입 */
  bzTypNm: Scalars['String'];
  /** 비즈니스 컨텐츠 이름 */
  bzcndNm: Scalars['String'];
  /** 대표자 이름 */
  ceoNm: Scalars['String'];
  /** 설립 일자 */
  estbDate: Scalars['String'];
  /** homepageUrl */
  homepageUrl: Scalars['String'];
  /** 직원수 */
  empCnt: Scalars['String'];
  /** 주소 */
  adr: Scalars['String'];
  /** 상세 주소 */
  dtlAdr: Scalars['String'];
  /** 우편 번호 */
  zip: Scalars['String'];
  /** 사업자 번호 */
  bizNo: Scalars['String'];
};

/** NiceDnbIsClosedBusiness */
export type NiceDnbIsClosedBusiness = {
  __typename?: 'NiceDnbIsClosedBusiness';
  /** 폐업일 */
  statOcrDate: Scalars['String'];
  /** 휴폐업구분 */
  clsbzNm: Scalars['String'];
};

export type NoticeSchedule = {
  __typename?: 'NoticeSchedule';
  id: Scalars['String'];
  /** 점검 시작 시간 */
  startTime: Scalars['String'];
  /** 점검 종료 시간 */
  endTime: Scalars['String'];
  /** 사전점검 시작 시간 */
  previewStartTime?: Maybe<Scalars['String']>;
  /** 사전점검 종료 시간 */
  previewEndTime?: Maybe<Scalars['String']>;
  /** client partner connect 인지 */
  pageType: NoticeScheduleNoticePageType;
  /** 긴급점검 / 사전점검 */
  noticeType: NoticeScheduleNoticeType;
  /** 시작예정 / 시작중 / 종료 */
  status: NoticeScheduleNoticeStatus;
};

export enum NoticeScheduleNoticePageType {
  Capa = 'CAPA',
  Connect = 'CONNECT'
}

export enum NoticeScheduleNoticeStatus {
  NotYetStart = 'NOT_YET_START',
  Starting = 'STARTING',
  End = 'END'
}

export enum NoticeScheduleNoticeType {
  EmergencyNotice = 'EMERGENCY_NOTICE',
  PreviewNotice = 'PREVIEW_NOTICE'
}

export type NoticeScheduleOutput = {
  __typename?: 'NoticeScheduleOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<NoticeSchedule>;
};

/** Default Output */
export type Output = {
  __typename?: 'Output';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
};

export type PartnerCapabilityOutput = {
  __typename?: 'PartnerCapabilityOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<CapaQuotationPartnerCapability>;
};

export type PaymentData = {
  __typename?: 'PaymentData';
  amount: Scalars['Float'];
  impUid?: Maybe<Scalars['String']>;
  pgProvider: Scalars['String'];
  merchantId?: Maybe<Scalars['String']>;
  transactionId: Scalars['String'];
  paymentMethod: CapaPaymentMethodType;
  virtualAccount?: Maybe<VirtualAccountInfo>;
  cardInfo?: Maybe<CapaPaymentCardInfo>;
  payoutSeq?: Maybe<Scalars['Float']>;
  status: CapaPaymentStatus;
  paidAt?: Maybe<Scalars['String']>;
};

/** PaymentHistorySearchDateTypeBO */
export enum PaymentHistorySearchDateTypeBo {
  /** 전체 */
  All = 'ALL',
  /** 일별 */
  Day = 'DAY',
  /** 주별 */
  Week = 'WEEK',
  /** 월별 */
  Month = 'MONTH',
  /** 연도별 */
  Year = 'YEAR'
}

/** PaymentHistorySearchStatusTypeBO */
export enum PaymentHistorySearchStatusTypeBo {
  /** 전체 */
  All = 'ALL',
  /** 취소 확정 */
  CancelConfirmed = 'CANCEL_CONFIRMED',
  /** 환불 확정 */
  RefundConfirmed = 'REFUND_CONFIRMED',
  /** 발주서 거절 */
  RejectOrderByPartner = 'REJECT_ORDER_BY_PARTNER',
  /** 구매 확정 */
  PurchaseConfirmed = 'PURCHASE_CONFIRMED'
}

/** PaymentHistorySearchTypeBO */
export enum PaymentHistorySearchTypeBo {
  /** 고객명 */
  QuotationUserName = 'QUOTATION_USER_NAME',
  /** 프로젝트명 */
  ProjectName = 'PROJECT_NAME',
  /** 파트너명 */
  QuotationPartnerName = 'QUOTATION_PARTNER_NAME',
  /** 사업자번호 */
  RegistrationNumber = 'REGISTRATION_NUMBER'
}

export type PcbAssemblyMethodInput = {
  methodType: CapaRfqPcbAssemblyMethodType;
};

export type PcbServiceInput = {
  serviceType: CapaPcbServiceType;
};

export enum ProjectPurchaseOrderManageStatusType {
  /** 전체 목록 표출 */
  All = 'ALL',
  /** 결제_발주중 */
  OrderInprogress = 'ORDER_INPROGRESS',
  /** 결제_발주중단 */
  OrderSuspended = 'ORDER_SUSPENDED',
  /** 제조중 */
  Processing = 'PROCESSING',
  /** 제조중단 */
  ProcessInterruption = 'PROCESS_INTERRUPTION',
  /** 배송중 */
  Shipping = 'SHIPPING',
  /** 거래완료 */
  ConfirmPurchaseOrder = 'CONFIRM_PURCHASE_ORDER'
}

export enum ProjectStatusType {
  /** 전체 목록 표출 */
  All = 'ALL',
  /** 견적비교중 */
  QuotationComparison = 'QUOTATION_COMPARISON',
  /** 견적비교마감 */
  QuotationComparisonClosing = 'QUOTATION_COMPARISON_CLOSING',
  /** 결제_발주중 */
  OrderInprogress = 'ORDER_INPROGRESS',
  /** 결제_발주중단 */
  OrderSuspended = 'ORDER_SUSPENDED',
  /** 제조중 */
  Processing = 'PROCESSING',
  /** 제조중단 */
  ProcessInterruption = 'PROCESS_INTERRUPTION',
  /** 배송중 */
  Shipping = 'SHIPPING',
  /** 거래완료 */
  ConfirmPurchaseOrder = 'CONFIRM_PURCHASE_ORDER'
}

export type Query = {
  __typename?: 'Query';
  /** 캐파 유저 통합 로그인 */
  authenticate: AuthenticationOutput;
  /** 캐파서비스 확인 checkRegisteredCapaService */
  checkRegisteredCapaService: RegisteredCapaServicesOutput;
  /** 이메일 인증 확인 */
  verifyEmailVerificationCode: Output;
  /** 디바이스 토큰 삭제 */
  removeDeviceToken: Output;
  authenticateBO: AuthenticationOutput;
  fetchMyBackOfficeUser: CapaBackOfficeUserOutput;
  fetchItpEventsBO: CapaItpEventsBoOutput;
  fetchJsbEventsBO: CapaJsbEventsBoOutput;
  fetchCloudUsersBO: CapaCloudUsersBoOutput;
  fetchBoMemo: CapaBoMemosOutput;
  fetchPartnersBO: CapaPartnersBoOutput;
  fetchUsersBO: CapaUsersBoOutput;
  fetchRfqsBO: CapaRfqsBoOutput;
  fetchRfqDetailBO: CapaRfqDetailBoOutput;
  fetchQuotationUserRfqsBO: CapaQuotationUserRfqsBoOutput;
  fetchQuotationChatMessagesBO: CapaQuotationChatRoomOutput;
  fetchQuotationPartnerProjectParticipationStatusBO: CapaQuotationPartnersProjectParticipationStatusBoOutput;
  fetchQuotationUserBO: CapaQuotationUserBoOutput;
  fetchQuotationPartnerBO: CapaQuotationPartnerStrategyBoOutput;
  fetchRfqQuotationsBO: CapaQuotationDetailedQuotationsOutput;
  fetchPurchaseOrdesBO: CapaQuotationRfqPurchaseOrdersOutput;
  fetchServiceSuggestionBO: CapaServiceSuggestionBoOutput;
  fetchServiceRatingBO: CapaServiceRatingBoOutput;
  fetchCXManagementRequiredUsersBO: CapacxManagementRequiredUsersBoOutput;
  fetchBOTestUsers: CapaUsersOutput;
  getNoticeScheduleBO: NoticeScheduleOutput;
  fetchCommentBO: CapaBoCommentsOutput;
  fetchBypassComplaintBO: CapaReceiveComplaintQuotationChatMessageOutput;
  fetchQuotationChatRoomSpecificAnnotationsBO: CapaQuotationChatRoomSpecificAnnotationsOutput;
  fetchRfqReviewBO: CapaRfqReviewsBoOutput;
  fetchBOUsers: CapaBackOfficeUsersOutput;
  fetchBOAmbassadors: CapaBoAmbassadorsOutput;
  fetchBOAmbassadorInvitationStatus: CapaBoAmbassadorInvitationStatusOutput;
  fetchProcessingBO: CapaboProcessingOutput;
  fetchTransactionHistoryBO: CapaTransactionHistoryModelBoOutput;
  fetchConnectFileBO: CapaConnectFileDetailOutput;
  fetchConnectUsersBO: CapaConnectUsersBoOutput;
  fetchConnectUserBO: CapaConnectUserBoOutput;
  fetchConnectGroupsBO: CapaConnectGroupsBoOutput;
  fetchConnectGroupBO: CapaConnectGroupBoOutput;
  fetchConnectChatMessagesBO: CapaConnectChatMessagesOutput;
  fetchConnectFeedbacksBO: CapaConnectFeedbacksBoOutput;
  fetchConnectUserFeedbacksBO: CapaConnectFeedbacksBoOutput;
  fetchConnectGroupFeedbacksBO: CapaConnectFeedbacksBoOutput;
  fetchConnectIssuesBO: CapaConnectIssuesBoOutput;
  fetchConnectUserIssuesBO: CapaConnectIssuesBoOutput;
  fetchConnectGroupIssuesBO: CapaConnectIssuesBoOutput;
  fetchConnectUserFileLinksBO: FetchConnectUserFileLinkBoOutput;
  fetchAdvertisementsBO: CapaAdvertisementsBoOutput;
  fetchAdsImpressionsBO: CapaAdsImpressionsBoOutput;
  fetchAdvertisementAdsImpressionsBO: CapaAdsImpressionsBoOutput;
  fetchActiveAdvertisingBO: CapaAdvertisingsOutput;
  fetchAdvertisingsBO: CapaAdvertisingsBoOutput;
  fetchAdsActivityLogs: CapaAdsActivityLogsOutput;
  fetchCapability: PartnerCapabilityOutput;
  verifyCompanyRegistrationNumber: Output;
  fetchQuotationUser: CapaQuotationUserOutput;
  fetchMyQuotationPartner: CapaQuotationPartnerStrategyOutput;
  fetchQuotationPartner: CapaQuotationPartnerStrategyOutput;
  fetchWithdrawnQuotationPartner: CapaQuotationPartnerStrategyOutput;
  fetchQuotationChatMessages: CapaQuotationChatMessagesOutput;
  fetchQuotationChatRoom: CapaQuotationChatRoomOutput;
  fetchQuotationPartnerActivity: CapaQuotationActivityOutput;
  fetchRfqQuotationPdf: CapaQuotationDetailedQuotationOutput;
  fetchWithdrawnChatRooms: CapaWithdrawnChatRoomsOutput;
  fetchQuotationChatRoomSharedFiles: CapaQuotationChatRoomSharedFilesOutput;
  fetchQuotationChatRoomAnnotationComments: CapaQuotationChatRoomAnnotationCommentsOutput;
  fetchQuotationChatRoomSpecificAnnotations: CapaQuotationChatRoomSpecificAnnotationsOutput;
  fetchQuotationServicePartnerRating: CapaQuotationServiceRatingOutput;
  fetchQuotationPartnerChatRooms: CapaQuotationPartnerChatRoomsOutput;
  fetchInProgressQuotationPartnerChatRooms: CapaInProgressQuotationPartnerChatRoomsOutput;
  fetchMySubmall: SubmallDataModelOutput;
  fetchMyQuotationUser: CapaQuotationUserOutput;
  fetchQuotationUserChatRooms: CapaQuotationUserChatRoomsOutput;
  fetchQuotationServiceUserRating: CapaQuotationServiceRatingOutput;
  fetchServiceTypeStatistics: CapaServiceTypeStatisticsOutput;
  fetchMyRefundBankAccounts: CapaQuotationUserRefundBankAccountModelsOutput;
  canEditRefundAccount: CapaCanEditRefundAccountOutput;
  fetchMyPaymentDataByPartner: CapaQuotationPaymentManageModelOutput;
  fetchMyPaymentDataByQuotationUser: CapaQuotationPaymentManageModelOutput;
  fetchCloudUser: CapaCloudUserOutput;
  fetchMyDrive: CapaMyDrivesOutput;
  fetchFileConversionStatus: CapaFileStatusOutput;
  fetchConnectUser: CapaConnectUserOutput;
  searchUser: CapaConnectSearchUsersOutput;
  fetchConnectMyDrive: CapaConnectMyDrivesOutput;
  fetchConnectFileDetail: CapaConnectFileDetailOutput;
  fetchFilePermission: CapaConnectFilePermissionOutput;
  searchFile: CapaConnectMyDrivesOutput;
  fetchCapaConnectSharedFile: CapaConnectSharedFilesOutput;
  fetchGroups: CapaConnectGroupsOutput;
  fetchGroup: CapaConnectGroupOutput;
  searchGroups: CapaConnectGroupChatRoomsOutput;
  fetchConnectAnnotations: CapaConnectAnnotationsOutput;
  fetchConnectChatMessages: CapaConnectChatMessagesOutput;
  fetchConnectGroupChatRooms: CapaConnectGroupChatRoomsOutput;
  fetchConnectGroupChatRoom: CapaConnectGroupChatRoomOutput;
  fetchConnectUserContactList: CapaConnectContactUsersOutput;
  fetchRecommendedContactUsersList: FetchRecommendedContactListsOutput;
  fetchConnectUserLinkFiles: FetchConnectUserLinkFileOutput;
  requestRfqId: CapauuidOutput;
  fetchQuotationUserRfqs: CapaQuotationUserRfqsOutput;
  fetchMyReceivedQuotations: CapaQuotationMyReceivedQuotationsOutput;
  fetchProjectManagementReceivedQuotations: CapaProjectManagementReceivedQuotationOutput;
  fetchQuotationUserGNB: CapaQuotationUserGnbOutput;
  fetchQuotationUserRfqDetail: CapaQuotationUserRfqDetailOutput;
  fetchRfqPartners: CapaQuotationRfqPartnersOutput;
  fetchPartnerRfqReviews: CapaQuotationMyRfqReviewOutput;
  fetchRfqReviews: CapaQuotationMyRfqReviewOutput;
  fetchMyReviewableRfqs: CapaReviewableRfqsOutput;
  /** 고객의 프로젝트 관리 Viewer */
  fetchQuotationUserProjectManagementDetail: CapaFetchQuotationUserProjectManagementDetailOuput;
  fetchQuotationUserProjectManagementRfqs: CapaFetchQuotationUserProjectManagementRfqsOutput;
  fetchQuotationUserRfqAvailableReviews: CapaQuotationUserRfqAvailableReviewOutput;
  fetchQuotationUserRfqReviews: CapaQuotationUserRfqReviewsOutput;
  fetchAvailableRfqs: CapaQuotationRfqAvailableRfqsOutput;
  fetchAvailableFilterRfqs: CapaFetchAvailableFilterRfqsOutput;
  fetchQuotationPartnerProjectManagementRfqs: CapaFetchQuotationPartnerProjectManagementRfqsOutput;
  fetchQuotationPartnerProjectManagementDetail: CapaFetchQuotationPartnerProjectManagementDetailOutput;
  fetchMyConsultingRfqs: CapaQuotationRfqMyRfqsOutput;
  fetchMyConfirmedRfqs: CapaQuotationRfqMyRfqsOutput;
  fetchQuotationPartnerGNB: CapaQuotationPartnerGnbOutput;
  fetchRfqDetail: CapaQuotationRfqDetailOutput;
  fetchMyRfqReviews: CapaQuotationMyRfqReviewOutput;
  searchRfq: CapaQuotationSearchOutput;
  fetchMyCompleteRfqs: CapaQuotationRfqMyCompleteRfqOutput;
  fetchQuotationPartnerRfqReview: CapaQuotationPartnerRfqReviewOutput;
  fetchQuotationPartnerAvailableRequestReviews: CapaQuotationPartnerAvailableRequestReviewsOutput;
  fetchRfqPartnerEvaluation: CapaQuotationRfqPartnerEvaluationOutput;
  fetchDetailedQuotation: CapaQuotationDetailedQuotationOutput;
  fetchMyRfqQuotations: CapaQuotationDetailedQuotationsOutput;
  fetchConfirmDetailedQuotation: CapaQuotationDetailedQuotationOutput;
  fetchPurchaseOrder: CapaQuotationRfqPurchaseOrderOutput;
  fetchPurchaseOrders: CapaQuotationRfqPurchaseOrdersOutput;
  fetchConfirmPurchaseOrder: CapaQuotationRfqPurchaseOrderOutput;
  /** 광고 활동 로그 입력 */
  fetchActiveAdvertising: CapaAdvertisingsOutput;
  fetchCAPANotification: CapaNotificationsOutput;
  fetchAllIcxInfo: IcxModelsOutput;
  fetchOneIcxInfo: IcxModelOutput;
  icxAuthenticate: IcxAuthenticationOutput;
  fetchMainBiz: IcxMainBizModelOutput;
  fetchFactoron: IcxFactoronModelOutput;
  fetchInnoBiz: IcxInnoBizModelOutput;
  fetchVentureBiz: IcxVentureBizModelOutput;
  fetchMiniCluster: IcxMiniClusterModelOutput;
  /** 에스크로 - 배송 등록 */
  registerShippingEscrow: Output;
  /** 지급대행 - 잔액 조회 */
  checkBalance: Output;
  /** 에스크로 - 구매확정 */
  confirmEscrowPurchase: Output;
  /** 에스크로 - 구매거절 */
  refuseEscrowPurchase: Output;
  /** 지급대행 - 서브몰 등록 */
  registerSubmall: Output;
  /** 지급대행 - 지급대행 요청 */
  requestPaymentAgent: Output;
  cancelRequestPaymentAgent: Output;
  fetchPaymentAgentResult: Output;
};

export type QueryAuthenticateArgs = {
  input: AuthenticationInput;
};

export type QueryCheckRegisteredCapaServiceArgs = {
  emails: Array<Scalars['String']>;
};

export type QueryVerifyEmailVerificationCodeArgs = {
  input: VerifyEmailVerificationCodeInput;
};

export type QueryRemoveDeviceTokenArgs = {
  input: RemoveDeviceTokenInput;
};

export type QueryAuthenticateBoArgs = {
  input: AuthenticationInput;
};

export type QueryFetchItpEventsBoArgs = {
  input: FetchItpEventsBoInput;
};

export type QueryFetchJsbEventsBoArgs = {
  input: FetchJsbEventsBoInput;
};

export type QueryFetchBoMemoArgs = {
  input: FetchBoMemosInput;
};

export type QueryFetchPartnersBoArgs = {
  input: FetchPartnersInput;
};

export type QueryFetchUsersBoArgs = {
  input: FetchUsersInput;
};

export type QueryFetchRfqsBoArgs = {
  input: FetchRfqsInput;
};

export type QueryFetchRfqDetailBoArgs = {
  input: FetchRfqInput;
};

export type QueryFetchQuotationUserRfqsBoArgs = {
  input: FetchQuotationUserRfqsBoInput;
};

export type QueryFetchQuotationChatMessagesBoArgs = {
  input: FetchQuotationChatRoomInput;
};

export type QueryFetchQuotationPartnerProjectParticipationStatusBoArgs = {
  input: FetchQuotationPartnerProjectParticipationStatusBoInput;
};

export type QueryFetchQuotationUserBoArgs = {
  input: FetchQuotationUserBoInput;
};

export type QueryFetchQuotationPartnerBoArgs = {
  input: FetchQuotationPartnerStrategyBoInput;
};

export type QueryFetchRfqQuotationsBoArgs = {
  input: FetchRfqQuotationsBoInput;
};

export type QueryFetchPurchaseOrdesBoArgs = {
  input: FetchPurchaseOrdersBoInput;
};

export type QueryFetchServiceSuggestionBoArgs = {
  input: FetchServiceSuggestionBoInput;
};

export type QueryFetchServiceRatingBoArgs = {
  input: FetchServiceRatingBoInput;
};

export type QueryFetchCxManagementRequiredUsersBoArgs = {
  input: FetchCxManagementRequiredUsersBoInput;
};

export type QueryFetchBoTestUsersArgs = {
  input: FetchBoTestUsersInput;
};

export type QueryFetchCommentBoArgs = {
  input: FetchCommentsBoInput;
};

export type QueryFetchBypassComplaintBoArgs = {
  input: CapaBypassComplaintInput;
};

export type QueryFetchQuotationChatRoomSpecificAnnotationsBoArgs = {
  input: FetchQuotationChatRoomSpecificAnnotationBoInput;
};

export type QueryFetchRfqReviewBoArgs = {
  input: FetchRfqReviewBoInput;
};

export type QueryFetchBoUsersArgs = {
  input: FetchBoUsersInput;
};

export type QueryFetchBoAmbassadorsArgs = {
  input: FetchBoAmbassadorsInput;
};

export type QueryFetchBoAmbassadorInvitationStatusArgs = {
  input: FetchBoAmbassadorInvitationStatusInput;
};

export type QueryFetchProcessingBoArgs = {
  input: FetchProcessingBoInput;
};

export type QueryFetchTransactionHistoryBoArgs = {
  input: CapaboFetchTransactionHistoryInput;
};

export type QueryFetchConnectFileBoArgs = {
  connectFileId: Scalars['String'];
};

export type QueryFetchConnectUsersBoArgs = {
  input: FetchConnectUsersBoInput;
};

export type QueryFetchConnectUserBoArgs = {
  connectUserId: Scalars['String'];
};

export type QueryFetchConnectGroupsBoArgs = {
  input: FetchConnectGroupsBoInput;
};

export type QueryFetchConnectGroupBoArgs = {
  groupId: Scalars['String'];
};

export type QueryFetchConnectChatMessagesBoArgs = {
  input: FetchConnectChatRoomInput;
};

export type QueryFetchConnectFeedbacksBoArgs = {
  input: FetchConnectFeedbacksBoInput;
};

export type QueryFetchConnectUserFeedbacksBoArgs = {
  input: FetchConnectUserFeedbacksBoInput;
};

export type QueryFetchConnectGroupFeedbacksBoArgs = {
  input: FetchConnectGroupFeedbacksBoInput;
};

export type QueryFetchConnectIssuesBoArgs = {
  input: FetchConnectIssuesBoInput;
};

export type QueryFetchConnectUserIssuesBoArgs = {
  input: FetchConnectUserIssuesBoInput;
};

export type QueryFetchConnectGroupIssuesBoArgs = {
  input: FetchConnectGroupIssuesBoInput;
};

export type QueryFetchConnectUserFileLinksBoArgs = {
  input: FetchConnectUserFileLinksBoInput;
};

export type QueryFetchAdvertisementsBoArgs = {
  input: FetchAdvertisementsBoInput;
};

export type QueryFetchAdsImpressionsBoArgs = {
  input: FetchAdsImpressionsBoInput;
};

export type QueryFetchAdvertisementAdsImpressionsBoArgs = {
  input: FetchAdvertisementAdsImpressionsBoInput;
};

export type QueryFetchActiveAdvertisingBoArgs = {
  input: FetchActiveAdvertisingBoInput;
};

export type QueryFetchAdvertisingsBoArgs = {
  input: FetchAdvertisingsBoInput;
};

export type QueryFetchAdsActivityLogsArgs = {
  input: FetchAdsActivityLogsInput;
};

export type QueryFetchCapabilityArgs = {
  input: FetchCapabilityInput;
};

export type QueryVerifyCompanyRegistrationNumberArgs = {
  input: VerifyCompanyRegistrationNumberInput;
};

export type QueryFetchQuotationUserArgs = {
  quotationUserId: Scalars['String'];
};

export type QueryFetchQuotationPartnerArgs = {
  quotationPartnerId: Scalars['String'];
};

export type QueryFetchWithdrawnQuotationPartnerArgs = {
  quotationPartnerId: Scalars['String'];
};

export type QueryFetchQuotationChatMessagesArgs = {
  input: FetchQuotationChatRoomInput;
};

export type QueryFetchQuotationChatRoomArgs = {
  input: FetchQuotationChatRoomInput;
};

export type QueryFetchQuotationPartnerActivityArgs = {
  input?: InputMaybe<FetchQuotationPartnerActivityInput>;
};

export type QueryFetchRfqQuotationPdfArgs = {
  input?: InputMaybe<RequestRfqQuotationPdfInput>;
};

export type QueryFetchWithdrawnChatRoomsArgs = {
  input: FetchWithdrawnChatRoomsInput;
};

export type QueryFetchQuotationChatRoomSharedFilesArgs = {
  input: FetchQuotationChatRoomSharedFilesInput;
};

export type QueryFetchQuotationChatRoomAnnotationCommentsArgs = {
  input: FetchQuotationChatRoomAnnotationCommentInput;
};

export type QueryFetchQuotationChatRoomSpecificAnnotationsArgs = {
  input: FetchQuotationChatRoomSpecificAnnotationInput;
};

export type QueryFetchQuotationPartnerChatRoomsArgs = {
  input: FetchQuotationPartnerChatRoomsInput;
};

export type QueryFetchInProgressQuotationPartnerChatRoomsArgs = {
  input: FetchInProgressQuotationPartnerChatRoomsInput;
};

export type QueryFetchMySubmallArgs = {
  input: FetchMySubmallInput;
};

export type QueryFetchQuotationUserChatRoomsArgs = {
  input?: InputMaybe<FetchQuotationUserChatRoomsInput>;
};

export type QueryFetchServiceTypeStatisticsArgs = {
  input: FetchServiceTypeStatisticsInput;
};

export type QueryFetchMyPaymentDataByPartnerArgs = {
  input: FetchPaymentManageByPartnerIdInput;
};

export type QueryFetchMyPaymentDataByQuotationUserArgs = {
  input: FetchPaymentManageByQuotationUserIdInput;
};

export type QueryFetchMyDriveArgs = {
  input: FetchMyDriveInput;
};

export type QueryFetchFileConversionStatusArgs = {
  input: FetchFileConversionStatusInput;
};

export type QuerySearchUserArgs = {
  input: SearchConnectUsersInput;
};

export type QueryFetchConnectMyDriveArgs = {
  input: FetchConnectMyDriveInput;
};

export type QueryFetchConnectFileDetailArgs = {
  input: FetchConnectFileDetailInput;
};

export type QueryFetchFilePermissionArgs = {
  input: FetchConnectGroupFilePermissionInput;
};

export type QuerySearchFileArgs = {
  input: SearchConnectFileInput;
};

export type QueryFetchCapaConnectSharedFileArgs = {
  input: FetchCapaConnectSharedFileInput;
};

export type QueryFetchGroupsArgs = {
  input: FetchConnectGroupsInput;
};

export type QueryFetchGroupArgs = {
  input: FetchConnectGroupInput;
};

export type QuerySearchGroupsArgs = {
  input: SearchConnectGroupsInput;
};

export type QueryFetchConnectAnnotationsArgs = {
  input: FetchConnectAnnotationsInput;
};

export type QueryFetchConnectChatMessagesArgs = {
  input: FetchConnectChatRoomInput;
};

export type QueryFetchConnectGroupChatRoomsArgs = {
  input: FetchConnectGroupChatRoomsInput;
};

export type QueryFetchConnectGroupChatRoomArgs = {
  input: FetchConnectGroupChatRoomInput;
};

export type QueryFetchConnectUserContactListArgs = {
  input: FetchConnectUserContactListInput;
};

export type QueryFetchRecommendedContactUsersListArgs = {
  input: FetchRecommendedContactUserListInput;
};

export type QueryFetchConnectUserLinkFilesArgs = {
  input: FetchConnectUserLinkFileInput;
};

export type QueryFetchQuotationUserRfqsArgs = {
  input: FetchQuotationUserRfqsInput;
};

export type QueryFetchMyReceivedQuotationsArgs = {
  input: FetchMyReceivedQuotationsInput;
};

export type QueryFetchProjectManagementReceivedQuotationsArgs = {
  input: FetchProjectManagementReceivedQuotationsInput;
};

export type QueryFetchQuotationUserRfqDetailArgs = {
  input: FetchRfqInput;
};

export type QueryFetchRfqPartnersArgs = {
  input: FetchRfqInput;
};

export type QueryFetchPartnerRfqReviewsArgs = {
  input: FetchPartnerRfqReviewsInput;
};

export type QueryFetchQuotationUserProjectManagementDetailArgs = {
  input: FetchQuotationUserProjectManagementDetailInput;
};

export type QueryFetchQuotationUserProjectManagementRfqsArgs = {
  input: FetchQuotationUserProjectManagementRfqsInput;
};

export type QueryFetchQuotationUserRfqAvailableReviewsArgs = {
  input: FetchQuotationUserRfqReviewsInput;
};

export type QueryFetchQuotationUserRfqReviewsArgs = {
  input: FetchQuotationUserRfqReviewsInput;
};

export type QueryFetchAvailableRfqsArgs = {
  input: FetchRfqsInput;
};

export type QueryFetchAvailableFilterRfqsArgs = {
  input: FetchAvailableFilterRfqsInput;
};

export type QueryFetchQuotationPartnerProjectManagementRfqsArgs = {
  input: FetchQuotationPartnerManagementRfqsInput;
};

export type QueryFetchQuotationPartnerProjectManagementDetailArgs = {
  input: FetchQuotationPartnerProjectManagementDetailInput;
};

export type QueryFetchMyConsultingRfqsArgs = {
  input: FetchRfqsInput;
};

export type QueryFetchMyConfirmedRfqsArgs = {
  input: FetchRfqsInput;
};

export type QueryFetchQuotationPartnerGnbArgs = {
  input: FetchRfqsInput;
};

export type QueryFetchRfqDetailArgs = {
  input: FetchRfqInput;
};

export type QuerySearchRfqArgs = {
  input: QuotationKeywordSearchInput;
};

export type QueryFetchMyCompleteRfqsArgs = {
  input: FetchMyCompleteRfqsInput;
};

export type QueryFetchQuotationPartnerRfqReviewArgs = {
  input: FetchQuotationPartnerRfqReviewInput;
};

export type QueryFetchQuotationPartnerAvailableRequestReviewsArgs = {
  input: FetchQuotationPartnerRfqReviewInput;
};

export type QueryFetchRfqPartnerEvaluationArgs = {
  input?: InputMaybe<FetchRfqPartnerEvaluationInput>;
};

export type QueryFetchDetailedQuotationArgs = {
  input: FetchDetailedQuotationInput;
};

export type QueryFetchMyRfqQuotationsArgs = {
  input: FetchMyRfqQuotationsInput;
};

export type QueryFetchConfirmDetailedQuotationArgs = {
  input: FetchConfirmDetailedQuotationInput;
};

export type QueryFetchPurchaseOrderArgs = {
  input: FetchPurchaseOrderInput;
};

export type QueryFetchPurchaseOrdersArgs = {
  input: FetchPurchaseOrdersInput;
};

export type QueryFetchConfirmPurchaseOrderArgs = {
  input: FetchConfirmPurchaseOrderInput;
};

export type QueryFetchActiveAdvertisingArgs = {
  input: FetchActiveAdvertisingInput;
};

export type QueryFetchCapaNotificationArgs = {
  input: FetchNotificationInput;
};

export type QueryFetchAllIcxInfoArgs = {
  input: FetchAllIcxInput;
};

export type QueryFetchOneIcxInfoArgs = {
  input: FetchOneIcxInput;
};

export type QueryIcxAuthenticateArgs = {
  input: IcxAuthenticationInput;
};

export type QueryFetchMainBizArgs = {
  input: MainBizFetchIcxInput;
};

export type QueryFetchFactoronArgs = {
  input: FactoronBizFetchIcxInput;
};

export type QueryFetchInnoBizArgs = {
  input: InnoBizFetchIcxInput;
};

export type QueryFetchVentureBizArgs = {
  input: VentureBizFetchIcxInput;
};

export type QueryFetchMiniClusterArgs = {
  input: IcxMiniClusterFetchIcxInput;
};

export type QueryRegisterShippingEscrowArgs = {
  input: RegisterExpectedDeliveryDateInput;
};

export type QueryCheckBalanceArgs = {
  input: CheckBalanceInput;
};

export type QueryConfirmEscrowPurchaseArgs = {
  input: ConfirmEscrowPurchaseInput;
};

export type QueryRefuseEscrowPurchaseArgs = {
  input: RefuseEscrowPurchaseInput;
};

export type QueryRegisterSubmallArgs = {
  input: RegisterSubmallInput;
};

export type QueryRequestPaymentAgentArgs = {
  input: RequestPaymentAgentInput;
};

export type QueryCancelRequestPaymentAgentArgs = {
  input: CancelRequestPaymentAgentInput;
};

export type QueryFetchPaymentAgentResultArgs = {
  input: FetchPaymentAgentResultInput;
};

export type QuitQuotationChatRoomInput = {
  chatRoomId: Scalars['String'];
};

export type QuotationKeywordSearchInput = {
  keyword: Scalars['String'];
  confirmed: Scalars['Boolean'];
  eventType?: InputMaybe<CapaQuotationRfqEventType>;
};

export type QuotationPartner = {
  __typename?: 'QuotationPartner';
  id: Scalars['ID'];
};

/** 파트너 파일 정보 입력 */
export type QuotationPartnerFileUploadInput = {
  /** fk 캐파 클라우드 파일 아이디 */
  fileId: Scalars['String'];
  /** 타입 CAPAQuotationPartnerFileType */
  fileType: CapaQuotationPartnerFileType;
};

/** 파트너가 고객찾기에서 rfq상태 , 발주 상태 제조상태 검색 위한 Enum */
export enum QuotationPartnerRfqCurrentSituationType {
  /** 전체 목록 표출 */
  All = 'ALL',
  /** 나와 상담중  */
  ConsultingWithMe = 'CONSULTING_WITH_ME',
  /** 타업체발주  */
  OtherCompanyOrder = 'OTHER_COMPANY_ORDER',
  /** 타업체상담중  */
  ConsultingWithOtherCompany = 'CONSULTING_WITH_OTHER_COMPANY',
  /** 견적비교 마감  */
  RequestFinish = 'REQUEST_FINISH',
  /** 회사소개서보냄  */
  SendCompanyIntroduction = 'SEND_COMPANY_INTRODUCTION',
  /** 견적서 발행함 */
  SendQuotation = 'SEND_QUOTATION',
  /** 결제/발주중 */
  OrderInprogress = 'ORDER_INPROGRESS',
  /** 결제/발주중단 */
  OrderSuspended = 'ORDER_SUSPENDED',
  /** 제조중 */
  Processing = 'PROCESSING',
  /** 제조중단 */
  ProcessInterruption = 'PROCESS_INTERRUPTION',
  /** 배송중 */
  Shipping = 'SHIPPING',
  /** 거래완료 */
  ConfirmPurchaseOrder = 'CONFIRM_PURCHASE_ORDER'
}

export type QuotationServiceRatingInput = {
  /** 점수 */
  rating: Scalars['Float'];
  /** 커멘트 */
  comment?: InputMaybe<Scalars['String']>;
};

export type QuotationUser = {
  __typename?: 'QuotationUser';
  id: Scalars['ID'];
};

/** 고객 파일 정보 입력 */
export type QuotationUserFileUploadInput = {
  /** fk 파일 아이디 */
  fileId: Scalars['String'];
  /** 타입 CAPAQuotationUserFileType */
  fileType: CapaQuotationUserFileType;
};

/** ReadAllManagementInput */
export type ReadAllManagementInput = {
  rfqId: Scalars['String'];
  type: CapaRfqProjectManagementType;
};

export type ReadConnectAnnotationCommentInput = {
  annotationId: Scalars['String'];
};

export type ReadConnectChatRoomMessageInput = {
  chatRoomId: Scalars['String'];
};

/** ReadManagementInput */
export type ReadManagementInput = {
  rfqId: Scalars['String'];
  type: CapaRfqProjectManagementType;
  partnerId?: InputMaybe<Scalars['String']>;
};

export type ReadNotificationInput = {
  /** 캐파 서비스 타입 */
  service: CapaServiceType;
  seq?: InputMaybe<Scalars['Float']>;
};

export type ReadQuotationAnnotationCommentInput = {
  annotationId: Scalars['String'];
};

export type ReadQuotationChatRoomMessageInput = {
  chatRoomId: Scalars['String'];
};

export type ReadRfqPurchaseOrderInput = {
  rfqId: Scalars['String'];
  quotationPartnerId: Scalars['String'];
};

export type ReadRfqQuotationInput = {
  rfqId: Scalars['String'];
  partnerId: Scalars['String'];
};

export type RefuseEscrowPurchaseInput = {
  TID?: InputMaybe<Scalars['String']>;
  MID?: InputMaybe<Scalars['String']>;
  ReqType?: InputMaybe<EscrowPaymentRequestType>;
  EdiDate?: InputMaybe<Scalars['String']>;
  MallIp?: InputMaybe<Scalars['String']>;
  CharSet?: InputMaybe<Scalars['String']>;
  EdiType?: InputMaybe<Scalars['String']>;
  BuyerAuthNum?: InputMaybe<Scalars['String']>;
  RejectReason?: InputMaybe<Scalars['String']>;
  RefundAccount?: InputMaybe<Scalars['String']>;
  RefundBankCode?: InputMaybe<Scalars['String']>;
  RefundName?: InputMaybe<Scalars['String']>;
};

export type RegistTbUtmInput = {
  utmSource?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmTerm?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
};

/** BO 엠버서더 등록 */
export type RegisterAmbassadorBoInput = {
  /** 엠베서더 회사명 */
  organizationName: Scalars['String'];
  /** 비밀번호 */
  password: Scalars['String'];
  /** 담당자명 */
  managerName: Scalars['String'];
  /** 담당자 이메일 */
  email: Scalars['String'];
  /** 담당자 휴대폰 번호 */
  cellphoneNumber: Scalars['String'];
  /** 사업자 등록번호 */
  companyRegistrationNumber: Scalars['String'];
  /** 사업자 등록증 파일 */
  registration?: InputMaybe<AmbassadorFileUploadInput>;
  /** 엠베서더 등록일 */
  createdAt?: InputMaybe<Scalars['String']>;
};

/** BO 회원가입 */
export type RegisterBackOfficeUserInput = {
  /** 이메일 */
  email: Scalars['String'];
  /** 비밀번호 */
  password: Scalars['String'];
  /** 역할 */
  role: BackOfficeAdminRole;
  /** 이름 */
  name: Scalars['String'];
  /** 영어닉네임 */
  nickName: Scalars['String'];
  /** 부서 */
  dept: BackOfficeUserDeptType;
  /** 직무 */
  task: Scalars['String'];
  /** 상태 */
  status?: InputMaybe<BackOfficeUserStatus>;
};

/** 캐파 회원가입 */
export type RegisterCapaUserInput = {
  /** 이메일 */
  email: Scalars['String'];
  /** 인증번호 */
  code: Scalars['String'];
  /** 비밀번호 */
  password: Scalars['String'];
  /** 비밀번호 확인 */
  passwordConfirm: Scalars['String'];
  /** CAPA 서비스를 어떻게 알게 되셨나요? (복수 선택 가능) */
  inflowRoute: Array<CapaInflowRoute>;
  /** 추천 회사명/기관명 */
  referralCompany?: InputMaybe<Scalars['String']>;
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgree: Scalars['Boolean'];
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgree: Scalars['Boolean'];
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgree?: InputMaybe<Scalars['Boolean']>;
  /** [필수] 결제 서비스 약관 동의 */
  paymentAgree?: InputMaybe<Scalars['Boolean']>;
  /** 캐파 서비스 타입 */
  service: CapaServiceType;
  /** 추천인 ID */
  referralUserId?: InputMaybe<Scalars['String']>;
  /** 엠버서더 ID */
  ambassadorId?: InputMaybe<Scalars['String']>;
  /** utm 정보 */
  registTbUtmInfo?: InputMaybe<RegistTbUtmInput>;
};

export type RegisterConnectUserFolderInput = {
  pathId?: InputMaybe<Scalars['String']>;
  folderName: Scalars['String'];
};

export type RegisterConnectUserInput = {
  userName: Scalars['String'];
  userLanguage: Language;
};

export type RegisterExpectedDeliveryDateInput = {
  quotationPartnerId: Scalars['String'];
  purchaseOrderId: Scalars['String'];
  /** 상점IP 서버주소 */
  MallIp?: InputMaybe<Scalars['String']>;
  /**
   *
   *       배송업체명.
   *       배송지 등록을 위해 반드시 필요한 정보지만 나이스페이측 택배사 리스트 업데이트 이슈로 인해 optional.
   *       이 데이터는 배송정보db에 저장,
   *       registerShippingEscrow(에스크로 배송 등록)시 db에 저장된 값이 null 이라면
   *       백엔드단에서 NicepayShippingCompany enum중 실제 존재하는 데이터를 임의로 설정 해주어야한다.
   *
   */
  shippingCompany?: InputMaybe<Scalars['String']>;
  /** 배송지 주소 */
  shippingAddress: Scalars['String'];
  /** 송장번호, '-' 특수문자 없이 입력 */
  invoiceNumber?: InputMaybe<Scalars['String']>;
  /** 등록자이름 */
  registerName: Scalars['String'];
  /** 배송 방식 */
  shippingMethod: CapaShippingMethodType;
  /** 기타 배송방식 */
  etcShippingMethod?: InputMaybe<Scalars['String']>;
};

/** 카파 User 통합 회원가입 */
export type RegisterIntegratedUserInput = {
  /** 이메일 */
  email: Scalars['String'];
  /** 이메일 인증번호 */
  emailCode: Scalars['String'];
  /** 휴대폰 인증번호 */
  cellphoneCode: Scalars['String'];
  /** 비밀번호 */
  password: Scalars['String'];
  /** 비밀번호 확인 */
  passwordConfirm: Scalars['String'];
  /** 사업자 기업 정보 관련 */
  companyInfo?: InputMaybe<NiceDnbCompanyInformationInput>;
  /** 회사 / 단체명 */
  organizationName?: InputMaybe<Scalars['String']>;
  /** 이름 (담당자명) */
  managerName: Scalars['String'];
  /** 휴대폰 번호 */
  cellphoneNumber: Scalars['String'];
  /** CAPA 서비스를 어떻게 알게 되셨나요? (복수 선택 가능) */
  inflowRoute?: InputMaybe<Array<CapaInflowRoute>>;
  /** [필수] 카파 서비스 이용약관 동의 */
  serviceAgree: Scalars['Boolean'];
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgree: Scalars['Boolean'];
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgree?: InputMaybe<Scalars['Boolean']>;
  /** 카파 서비스 타입 */
  service: CapaServiceType;
  /** 주소 */
  fullAddress?: InputMaybe<Scalars['String']>;
  /** 짧은 주소 */
  shortAddress?: InputMaybe<Scalars['String']>;
  /** 사업자 여부 */
  bizType: CapaQuotationUserBizType;
  /** 회사소개 */
  companyIntroduction?: InputMaybe<Scalars['String']>;
  /** 웹사이트 */
  website?: InputMaybe<Scalars['String']>;
  /** 부서 */
  department?: InputMaybe<Scalars['String']>;
  /** 직함 */
  position?: InputMaybe<Scalars['String']>;
  /** 견적 유저 파일 업로드 정보 입력 */
  files?: InputMaybe<Array<QuotationUserFileUploadInput>>;
  /** 추천인 ID */
  referralUserId?: InputMaybe<Scalars['String']>;
};

/** ITP 이벤트 RFQ 거래완료 보상 신청 */
export type RegisterItpEventInput = {
  /** rfq 아이디 */
  rfqId: Scalars['String'];
  /** 연락처 */
  cellphoneNumber: Scalars['String'];
  /** ITP 이벤트 거래완료 증빙 자료 */
  files: Array<ItpEventFileUploadInput>;
  /** OFFICECON 정보제공 동의여부 */
  officeconAgreed: Scalars['Boolean'];
  /** 거래완료 금액 */
  completeCost: Scalars['Float'];
  /** rfq 프로젝트 이름 */
  projectName: Scalars['String'];
  /** Quotation 파트너 id */
  quotationPartnerId: Scalars['String'];
};

/** ITP 이벤트 RFQ 거래완료 보상 신청 */
export type RegisterJsbEventInput = {
  /** rfq 아이디 */
  rfqId: Scalars['String'];
  /** 연락처 */
  cellphoneNumber: Scalars['String'];
  /** ITP 이벤트 거래완료 증빙 자료 */
  files: Array<JsbEventFileUploadInput>;
  /** 거래완료 금액 */
  completeCost: Scalars['Float'];
  /** 은행 */
  bank: Scalars['String'];
  /** 계좍 */
  account: Scalars['String'];
  /** rfq 프로젝트 이름 */
  projectName: Scalars['String'];
  /** Quotation 파트너 id */
  quotationPartnerId: Scalars['String'];
};

export type RegisterQuotationPartnerBoInput = {
  /** 이메일 */
  email: Scalars['String'];
  /** 비밀번호 */
  password: Scalars['String'];
  /** CAPA 서비스를 어떻게 알게 되셨나요? (복수 선택 가능) */
  inflowRoute: Array<CapaInflowRoute>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgree?: InputMaybe<Scalars['Boolean']>;
  /** 파트너 캐파빌리티 jsonb array of { service_type, process_method, material, detailed_material, etc } */
  capabilities: CapaQuotationCapabilityInput;
  /** 회사명 */
  organizationName: Scalars['String'];
  /** 주소 */
  fullAddress: Scalars['String'];
  /** 구 까지만 보여주는 주소 */
  shortAddress: Scalars['String'];
  /** 사업자 등록번호 */
  companyRegistrationNumber: Scalars['String'];
  /** 회사소개 */
  companyIntroduction?: InputMaybe<Scalars['String']>;
  /** 설립년도 */
  foundedIn?: InputMaybe<Scalars['String']>;
  /** 규모 (직원수) */
  numberEmployees?: InputMaybe<Scalars['String']>;
  /** 장비 */
  equipment?: InputMaybe<Scalars['String']>;
  /** 대응 시간 */
  serviceHours?: InputMaybe<Scalars['String']>;
  /** 웹사이트 */
  website?: InputMaybe<Scalars['String']>;
  /** 담당자명 */
  managerName: Scalars['String'];
  /** 부서 */
  department: Scalars['String'];
  /** 직위 */
  position: Scalars['String'];
  /** 연락처 */
  contact: Scalars['String'];
  /** 파트너 파일 업로드 정보 입력 */
  files?: InputMaybe<Array<QuotationPartnerFileUploadInput>>;
  /** 파트너 기술관련 파일 업로드 정보 입력 */
  strategyFiles?: InputMaybe<
    Array<CapaQuotationPartnerStrategyFileUploadInput>
  >;
  /** 공장 주소 */
  factoryAddress?: InputMaybe<Scalars['String']>;
};

/** 파트너 정보 입력 */
export type RegisterQuotationPartnerEquipmentInput = {
  /** fk 캐파 파일 아이디 */
  fileId?: InputMaybe<Scalars['String']>;
  /** 장비 명 */
  equipmentName: Scalars['String'];
  /** 설명 */
  description?: InputMaybe<Scalars['String']>;
  /** 수량 */
  quantity: Scalars['Float'];
};

/** 파트너 정보 입력 */
export type RegisterQuotationPartnerInput = {
  /** 파트너 캐파빌리티 jsonb array of { service_type, process_method, material, detailed_material, etc } */
  capabilities: CapaQuotationCapabilityInput;
  /** 회사명 */
  organizationName: Scalars['String'];
  /** 주소 */
  fullAddress: Scalars['String'];
  /** 구 까지만 보여주는 주소 */
  shortAddress: Scalars['String'];
  /** detail address */
  detailAddress?: InputMaybe<Scalars['String']>;
  /** 사업자 등록번호 */
  companyRegistrationNumber: Scalars['String'];
  /** 회사소개 */
  companyIntroduction?: InputMaybe<Scalars['String']>;
  /** 설립년도 */
  foundedIn?: InputMaybe<Scalars['String']>;
  /** 규모 (직원수) */
  numberEmployees?: InputMaybe<Scalars['String']>;
  /** 장비 */
  equipment?: InputMaybe<Scalars['String']>;
  /** 대응 시간 */
  serviceHours?: InputMaybe<Scalars['String']>;
  /** 웹사이트 */
  website?: InputMaybe<Scalars['String']>;
  /** 담당자명 */
  managerName: Scalars['String'];
  /** 부서 */
  department: Scalars['String'];
  /** 직위 */
  position: Scalars['String'];
  /** 연락처 */
  contact: Scalars['String'];
  /** 사업자 등록증 파일 */
  registrations: Array<CapaQuotationPartnerStrategyFileUploadInput>;
  /** 공장 주소 */
  factoryAddress?: InputMaybe<Scalars['String']>;
  /** factory detail address */
  factoryDetailAddress?: InputMaybe<Scalars['String']>;
};

/** RegisterQuotationPartnerPortfolioCapabilitiesInput */
export type RegisterQuotationPartnerPortfolioCapabilitiesInput = {
  service?: InputMaybe<CapaQuotationServiceType>;
  detailedServices?: InputMaybe<Array<CapaQuotationDetailedServiceType>>;
};

/** 파트너 정보 입력 */
export type RegisterQuotationPartnerPortfolioInput = {
  /** 파트너 파일 업로드 정보 입력 */
  files: Array<CapaQuotationPartnerStrategyFileUploadInput>;
  /** 프로젝트 명 */
  projectName: Scalars['String'];
  /** 고객 */
  client?: InputMaybe<Scalars['String']>;
  /** 상세 정보 */
  description?: InputMaybe<Scalars['String']>;
  /** 제품 용도 */
  projectPurpose?: InputMaybe<Array<CapaQuotationProductPurpose>>;
  /** 제품 용도 */
  capabilities?: InputMaybe<
    Array<RegisterQuotationPartnerPortfolioCapabilitiesInput>
  >;
  /** 제품 종류 */
  productType?: InputMaybe<Scalars['String']>;
  /** 수량 */
  quantity?: InputMaybe<Scalars['Float']>;
  /** 제조 단계 */
  produceStep?: InputMaybe<CapaQuotationPartnerImagePortfolioProduceStepType>;
};

/** 매칭 필수정보 입력 / 기본 정보 */
export type RegisterQuotationUserInput = {
  /** 이름 (담당자명) */
  managerName: Scalars['String'];
  /** 휴대폰 번호 */
  cellphoneNumber: Scalars['String'];
  /** 주소 */
  fullAddress?: InputMaybe<Scalars['String']>;
  /** 짧은 주소 */
  shortAddress?: InputMaybe<Scalars['String']>;
  /** 사업자등록번호 */
  companyRegistrationNumber?: InputMaybe<Scalars['String']>;
  /** 사업자 여부 */
  bizType: CapaQuotationUserBizType;
  /** 회사 / 단체명 */
  organizationName?: InputMaybe<Scalars['String']>;
  /** 회사소개 */
  companyIntroduction?: InputMaybe<Scalars['String']>;
  /** 웹사이트 */
  website?: InputMaybe<Scalars['String']>;
  /** 부서 */
  department?: InputMaybe<Scalars['String']>;
  /** 직함 */
  position?: InputMaybe<Scalars['String']>;
  /** 견적 유저 파일 업로드 정보 입력 */
  files?: InputMaybe<Array<QuotationUserFileUploadInput>>;
  /** 추천인 ID */
  referralUserId?: InputMaybe<Scalars['String']>;
};

export type RegisterRequestRfqPurchaseOrderInput = {
  rfqId: Scalars['String'];
};

export type RegisterRequestRfqQuotationInput = {
  rfqId: Scalars['String'];
  partnerId: Scalars['String'];
};

export type RegisterRfqDesignInput = {
  /** design 단계 - 제품 디자인, 기구 설계 */
  services: Array<DesignServiceInput>;
};

export type RegisterRfqInput = {
  rfqId: Scalars['String'];
  serviceType: CapaQuotationServiceType;
  detailedServiceType?: InputMaybe<CapaQuotationDetailedServiceType>;
  /** pcb 서비스 이용 */
  pcb?: InputMaybe<RegisterRfqPcbInput>;
  /** pcb 서비스 이용 */
  design?: InputMaybe<RegisterRfqDesignInput>;
  drawingFiles?: InputMaybe<Array<RfqDrawingFileInput>>;
  /** 상세요청사항 */
  detailedRequest?: InputMaybe<Scalars['String']>;
  referenceFiles?: InputMaybe<Array<RfqReferenceFileInput>>;
  projectName: Scalars['String'];
  dueDate: Scalars['String'];
  dueNegotiable: Scalars['Boolean'];
  maxEstimatedBudget: Scalars['Float'];
  minEstimatedBudget: Scalars['Float'];
  budgetOpen: Scalars['Boolean'];
  projectPurpose: CapaQuotationProductPurpose;
  projectPurposeDetail: Scalars['String'];
  optionalServices?: InputMaybe<Array<RfqOptionalServiceInput>>;
  publicOpen: Scalars['Boolean'];
  eventType?: InputMaybe<CapaQuotationRfqEventType>;
  manufacturingStage?: InputMaybe<CapaRfqManufacturingStage>;
  /** 재작성 베이스 rfqId */
  preRfqId?: InputMaybe<Scalars['String']>;
  /** 상담 시작 방식 */
  consultingStartMethod?: InputMaybe<CapaConsultingStartMethod>;
};

export type RegisterRfqPcbInput = {
  /** pcb 단계 - 설계, 제작, 조립 */
  services: Array<PcbServiceInput>;
  /** 설계시 제작 수량 */
  fabricationQuantity?: InputMaybe<Scalars['Float']>;
  /** 거버파일 - pcb 제작을 위한 파일 */
  fabricationFiles?: InputMaybe<Array<RfqPcbFabricationFileInput>>;
  /** 설계시 조립 수량 */
  assemblyQuantity?: InputMaybe<Scalars['Float']>;
  /** BOM 파일 - pcb 조립을 위한 파일 */
  assemblyFiles?: InputMaybe<Array<RfqPcbAssemblyFileInput>>;
  /** 조립 방식 */
  assemblyMethod?: InputMaybe<Array<PcbAssemblyMethodInput>>;
  /** 메탈마스크 제공 여부 */
  metalMaskAvailablity?: InputMaybe<Scalars['Boolean']>;
  /** 자재 방법 */
  materialSupplyMethod?: InputMaybe<CapaRfqPcbMaterialSupplyMethodType>;
};

export type RegisterRfqReviewInput = {
  /** rfq id */
  rfqId: Scalars['String'];
  /** quotation Partner id */
  quotationPartnerId: Scalars['String'];
  /** 리뷰 타입 */
  rfqReviewType?: InputMaybe<CapaRfqReviewType>;
  /** transaction satisfaction comment */
  transactionSatisfactionPoint?: InputMaybe<Scalars['Float']>;
  /** transaction satisfaction comment */
  transactionSatisfactionComment?: InputMaybe<Scalars['String']>;
  reviewFiles?: InputMaybe<Array<RfqTransactionReviewFileInput>>;
  /** 납기일 준수 여부 */
  inDueDate?: InputMaybe<Scalars['Boolean']>;
};

export type RegisterSubmallInput = {
  quotationPartnerId: Scalars['String'];
  /** 서브몰id(파트너가 원하는) - 영문자,숫자조합 */
  submallId: Scalars['String'];
  /** 서브몰 이름 (상호명) */
  submallName: Scalars['String'];
  /** 정산 은행 코드 */
  bankCode: CapaBankCode;
  /** 정산 계좌번호(`-`제외) */
  bankAccount: Scalars['String'];
  /** 예금주명 */
  accountHolder: Scalars['String'];
  /** 사업자 등록번호 */
  submallRegistrationNumber: Scalars['String'];
  /** 필수값. 요청타입 (0:신규, 1:수정) */
  reqType?: InputMaybe<SubmallRequestType>;
};

export type RegisteredCapaService = {
  __typename?: 'RegisteredCapaService';
  email: Scalars['String'];
  scopes?: Maybe<Array<CapaServiceType>>;
  quotationUser?: Maybe<QuotationUser>;
  quotationParnter?: Maybe<QuotationPartner>;
  connectUser?: Maybe<ConnectUser>;
  cloudUser?: Maybe<CloudUser>;
};

export type RegisteredCapaServicesOutput = {
  __typename?: 'RegisteredCapaServicesOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<Array<RegisteredCapaService>>;
};

/** @deprecated @see {RegisterCapaUserInput} 캐파 회원가입 */
export type RegistrationInput = {
  /** 이메일 */
  email: Scalars['String'];
  /** 인증번호 */
  code: Scalars['String'];
  /** 비밀번호 */
  password: Scalars['String'];
  /** 비밀번호 확인 */
  passwordConfirm: Scalars['String'];
  /** CAPA 서비스를 어떻게 알게 되셨나요? (복수 선택 가능) */
  inflowRoute: Array<CapaInflowRoute>;
  /** 추천 회사명/기관명 */
  referralCompany?: InputMaybe<Scalars['String']>;
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgree: Scalars['Boolean'];
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgree: Scalars['Boolean'];
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgree?: InputMaybe<Scalars['Boolean']>;
  /** [필수] 결제 서비스 약관 동의 */
  paymentAgree?: InputMaybe<Scalars['Boolean']>;
  /** 캐파 서비스 타입 */
  service: CapaServiceType;
  /** 추천인 ID */
  referralUserId?: InputMaybe<Scalars['String']>;
  /** 엠버서더 ID */
  ambassadorId?: InputMaybe<Scalars['String']>;
  /** utm 정보 */
  registTbUtmInfo?: InputMaybe<RegistTbUtmInput>;
};

export type RejectRfqPurchaseOrderInput = {
  /** rfq id */
  rfqId: Scalars['String'];
  /** 발주서 id */
  purchaseOrderId: Scalars['String'];
  /** 거부 이유 */
  rejectReason?: InputMaybe<Scalars['String']>;
};

/** BO 서브몰 승인 거절 */
export type RejectSubmallInput = {
  /** reject type */
  rejectType: CapaSubmallRejectType;
  /** 취소 상세 사유 */
  reason?: InputMaybe<Scalars['String']>;
};

export type RemoveConnectAnnotationCommentInput = {
  groupId: Scalars['String'];
  connectSharedFileId: Scalars['String'];
  annotationId: Scalars['String'];
  commentId: Scalars['String'];
};

export type RemoveConnectAnnotationInput = {
  groupId: Scalars['String'];
  connectSharedFileId: Scalars['String'];
  annotationId: Scalars['String'];
};

export type RemoveConnectContactUserInput = {
  contactUserEmails: Array<Scalars['String']>;
};

export type RemoveConnectFileInput = {
  /** 파일 */
  fileIds: Array<Scalars['String']>;
  /** isFolder or not */
  isFolder?: InputMaybe<Scalars['Boolean']>;
  /** filePath */
  filePath?: InputMaybe<Scalars['String']>;
};

export type RemoveConnectGroupInput = {
  groupId: Scalars['String'];
  archive?: InputMaybe<Scalars['Boolean']>;
};

export type RemoveConnectUserInput = {
  userId: Scalars['String'];
};

/** 디바이스 토큰 삭제 */
export type RemoveDeviceTokenInput = {
  /** 이메일 */
  email: Scalars['String'];
  /** device token */
  deviceToken?: InputMaybe<Scalars['String']>;
};

export type RemoveQuotationAnnotationCommentInput = {
  annotationCommentId: Scalars['String'];
};

export type RemoveQuotationAnnotationInput = {
  annotationId: Scalars['String'];
};

export type RenameConnectFileInput = {
  /** 파일 path */
  fileId?: InputMaybe<Scalars['String']>;
  /** 새 파일 이름 */
  toName: Scalars['String'];
};

export type RenameConnectGroupInput = {
  /** 그룹ID */
  groupId?: InputMaybe<Scalars['String']>;
  /** 새 그룹 이름 */
  toName?: InputMaybe<Scalars['String']>;
};

export type ReplyRfqReviewInput = {
  rfqId: Scalars['String'];
  reply: Scalars['String'];
};

export type RequestAdjustRfqPurchaseOrderInput = {
  rfqId?: InputMaybe<Scalars['String']>;
  /** 수정 요청 내용 */
  adjustRequest?: InputMaybe<Scalars['String']>;
};

export type RequestAdjustRfqQuotationInput = {
  rfqId?: InputMaybe<Scalars['String']>;
  quotationPartnerId?: InputMaybe<Scalars['String']>;
  /** 수정 요청 내용 */
  adjustRequest?: InputMaybe<Scalars['String']>;
};

/** 이메일 인증 코드 */
export type RequestCellPhoneVerificationCodeInput = {
  /** 휴대폰 번호 */
  cellphoneNumber: Scalars['String'];
};

export type RequestConfirmRfqTransactionInput = {
  rfqId?: InputMaybe<Scalars['String']>;
};

export type RequestDownloadPermissionInput = {
  /** 그룹ID */
  groupId: Scalars['String'];
  connectFileId?: InputMaybe<Scalars['String']>;
};

/** 이메일 인증 코드 */
export type RequestEmailVerificationCodeInput = {
  /** 이메일 */
  email: Scalars['String'];
  /** 캐파 서비스 타입 */
  service: CapaServiceType;
};

export type RequestFileInput = {
  /** 파일 id */
  fileId: Scalars['String'];
};

export type RequestPaymentAgent = {
  mid?: InputMaybe<Scalars['String']>;
  settlmntDt?: InputMaybe<Scalars['String']>;
  subId?: InputMaybe<Scalars['String']>;
  settlmntAmt?: InputMaybe<Scalars['Float']>;
  dupChkYn?: InputMaybe<Scalars['String']>;
  accountDesc?: InputMaybe<Scalars['String']>;
  /** transaction id */
  transactionId: Scalars['String'];
};

export type RequestPaymentAgentInput = {
  data?: InputMaybe<Array<RequestPaymentAgent>>;
};

/** 캐파 추천인 코드 발행 */
export type RequestReferralInput = {
  /** 캐파 서비스 타입 */
  service: CapaServiceType;
};

export type RequestRefundInput = {
  /** 환불 사유 */
  reason: Scalars['String'];
  /** 환불 금액 */
  amount?: InputMaybe<Scalars['Float']>;
};

export type RequestRegisterTransactionReviewInput = {
  rfqId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

/** 비밀번호 재설정 */
export type RequestResetPasswordInput = {
  /** 이메일 */
  email: Scalars['String'];
  service?: InputMaybe<CapaServiceType>;
};

export type RequestRfqDrawingFileDownloadInput = {
  rfqId?: InputMaybe<Scalars['String']>;
};

export type RequestRfqQuotationPdfInput = {
  /** 견적서 id */
  quotationId: Scalars['String'];
};

export type ReviewRfqInput = {
  rfqId: Scalars['String'];
  quality: Scalars['Float'];
  dueDate: Scalars['Float'];
  publicComment?: InputMaybe<Scalars['String']>;
  privateComment?: InputMaybe<Scalars['String']>;
};

export type RfqDrawingFileInput = {
  fileId: Scalars['String'];
  fileName: Scalars['String'];
  quantity: Scalars['Float'];
  material: CapaQuotationMaterial;
  detailedMaterial?: InputMaybe<CapaQuotationDetailedMaterialType>;
  etc?: InputMaybe<Scalars['String']>;
  recommendation?: InputMaybe<Array<CapaQuotationRecommendation>>;
};

export type RfqOptionalServiceInput = {
  serviceType: CapaQuotationServiceType;
  quantity?: InputMaybe<Scalars['Float']>;
};

/** pcb 조립을 위한 파일 */
export type RfqPcbAssemblyFileInput = {
  fileId: Scalars['String'];
  fileName: Scalars['String'];
  quantity: Scalars['Float'];
};

/** pcb 제작을 위한 파일 */
export type RfqPcbFabricationFileInput = {
  fileId: Scalars['String'];
  fileName: Scalars['String'];
  quantity: Scalars['Float'];
  thickness: Scalars['Float'];
};

export type RfqQuotationOptionalServiceInput = {
  serviceType: CapaQuotationServiceType;
};

export type RfqReferenceFileInput = {
  fileId: Scalars['String'];
  fileName: Scalars['String'];
};

export type RfqTransactionReviewFileInput = {
  fileId: Scalars['String'];
  fileName: Scalars['String'];
};

export type SavePayment = {
  __typename?: 'SavePayment';
  id: Scalars['String'];
};

export type SaveRfqCapabilitiesInput = {
  serviceType: CapaQuotationServiceType;
  status: CapaCapabilitiesStatusType;
  /** capabilities */
  capabilities: CapaQuotationCapabilityInput;
};

export type SaveRfqFilterInput = {
  filter?: InputMaybe<CapaQuotationRfqFilterInput>;
};

export type SearchConnectFileInput = {
  pathId?: InputMaybe<Scalars['String']>;
  keyword: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type SearchConnectGroupsInput = {
  groupName: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type SearchConnectUsersInput = {
  keyword: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type SendAnnotationCommentToChatInput = {
  commentId: Scalars['String'];
};

export type SendConnectChatMessageInput = {
  chatRoomId?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  /** 파트너 파일 업로드 */
  fileIds?: InputMaybe<Array<Scalars['String']>>;
};

export type SendConnectChatMessageToCapaInput = {
  chatRoomId?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  /** 파트너 파일 업로드 */
  fileIds?: InputMaybe<Array<Scalars['String']>>;
};

export type SendQuotationChatMessageInput = {
  chatRoomId?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  /** 파트너 파일 업로드 정보 입력 */
  files?: InputMaybe<Array<ChatFileUploadInput>>;
  messageType?: InputMaybe<CapaQuotationChatMessageType>;
};

export type SendSystemChatMessageInput = {
  chatRoomId?: InputMaybe<Scalars['String']>;
  messageType?: InputMaybe<CapaQuotationChatMessageType>;
};

export type ShareConnectFilesInput = {
  /** 그룹ID */
  groupId: Scalars['String'];
  /** fileIds */
  connectFileIds: Array<Scalars['String']>;
  permission?: InputMaybe<CapaQuotationRfqAllowOpenFileStatus>;
};

/** 배송 정보 */
export type ShippingDataModel = {
  __typename?: 'ShippingDataModel';
  /** 배송등록 예정 건 */
  id: Scalars['String'];
  /** 배송업체 */
  shippingCompany?: Maybe<Scalars['String']>;
  /** 송장번호 */
  invoiceNumber?: Maybe<Scalars['String']>;
  /** 지급승인 연장 여부 */
  isExtended: Scalars['Boolean'];
  /** 지급일 연장 사유 */
  extendReason?: Maybe<Scalars['String']>;
  /** 배송등록 여부 */
  isRegistered: Scalars['Boolean'];
  /** 배송등록 예정일(YYYYMMDD) 00:00 + 6영업일 고로 자동 구매확정일을 의미 */
  registerExpectedDate: Scalars['String'];
  /** 구매확정일 연장 14일 후 */
  extendedPurchaseConfirmDate: Scalars['String'];
};

export type StibeeCapaUser = {
  __typename?: 'StibeeCAPAUser';
  email: Scalars['String'];
  clientManagerName: Scalars['String'];
  partnerManagerName: Scalars['String'];
  connectManagerName: Scalars['String'];
  clientOrganizationName: Scalars['String'];
  partnerOrganizationName: Scalars['String'];
  connectOrganizationName: Scalars['String'];
};

export type SubmallDataModel = {
  __typename?: 'SubmallDataModel';
  /** id */
  id: Scalars['ID'];
  /** quotation partner id */
  partnerId: Scalars['String'];
  /** 서브몰 id */
  submallId: Scalars['String'];
  /** 서브몰 이름 */
  submallName: Scalars['String'];
  /** 서브몰 사업자 등록 번호, 수정불가 */
  submallRegistrationNumber: Scalars['String'];
  /** 계좌은행코드 */
  bankCode: CapaBankCode;
  /** 계좌번호(`-`제외) */
  accountNumber: Scalars['String'];
  /** 예금주 */
  accountHolder: Scalars['String'];
  status: CapaSubmallStatus;
  managerName: Scalars['String'];
  approvedAt?: Maybe<Scalars['String']>;
  rejectedAt?: Maybe<Scalars['String']>;
  rejectedReason?: Maybe<CapaSubmallRejectedReason>;
  bankBookFile?: Maybe<BankBookFile>;
};

export type SubmallDataModelOutput = {
  __typename?: 'SubmallDataModelOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<SubmallDataModel>;
};

export enum SubmallRequestType {
  /** 기존 서브몰 수정 */
  Update = 'UPDATE',
  /** 신규 서브몰 등록 */
  Create = 'CREATE'
}

export type SubscribeCapaNewsInput = {
  /** 구독 대상 이메일 */
  subscriberEmail: Scalars['String'];
  /** 사용자 이름 */
  userName: Scalars['String'];
};

export type SubscribeConnectChatRoomInput = {
  chatRoomId: Scalars['String'];
};

export type SubscribeConnectUserFileInput = {
  /** fileId */
  fileId: Scalars['String'];
};

export type SubscribeFileConversionStatusInput = {
  fileId: Scalars['String'];
};

export type SubscribeNotificationInput = {
  serviceType: CapaServiceType;
};

export type SubscribeQuotationChatRoomInput = {
  chatRoomId: Scalars['String'];
};

export type Subscription = {
  __typename?: 'Subscription';
  subscribeQuotationChatMessage: CapaQuotationChatMessagesOutput;
  subscribeQuotationChatRoom: CapaQuotationChatRoomOutput;
  subscribeQuotationUpdateData: CapaQuotationUpdateOutput;
  subscribeFileStatusUpdate: CapaFileStatusOutput;
  subscribeFileConversionStatus: CapaFileStatusOutput;
  subscribeConnectChatMessages: CapaConnectChatMessagesOutput;
  subscribeConnectUpdateData: CapaConnectUpdateOutput;
  subscribeConnectOnlineUsersData: CapaConnectOnlineUsersOutput;
  subscribeConnectUserFileStatus: CapaConnectUserFileOutput;
  subscribeCAPANotification: CapaSubscribeNotificationsOutput;
};

export type SubscriptionSubscribeQuotationChatMessageArgs = {
  input: SubscribeQuotationChatRoomInput;
};

export type SubscriptionSubscribeQuotationChatRoomArgs = {
  input: SubscribeQuotationChatRoomInput;
};

export type SubscriptionSubscribeQuotationUpdateDataArgs = {
  input: SubscribeQuotationChatRoomInput;
};

export type SubscriptionSubscribeFileConversionStatusArgs = {
  input: SubscribeFileConversionStatusInput;
};

export type SubscriptionSubscribeConnectChatMessagesArgs = {
  input: SubscribeConnectChatRoomInput;
};

export type SubscriptionSubscribeConnectUserFileStatusArgs = {
  input: SubscribeConnectUserFileInput;
};

export type SubscriptionSubscribeCapaNotificationArgs = {
  input: SubscribeNotificationInput;
};

/** 서비스 제안 */
export type SuggestServiceInput = {
  /** 이메일 */
  email?: InputMaybe<Scalars['String']>;
  /** 제안 */
  suggestion?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Scalars['String']>;
};

/** 토큰 갱신 */
export type TokenRefreshInput = {
  /** refresh 토큰 */
  refreshToken: Scalars['String'];
};

export type UnshareConnectFilesInput = {
  /** 그룹ID */
  groupId: Scalars['String'];
  groupName?: InputMaybe<Scalars['String']>;
  chatRoomId?: InputMaybe<Scalars['String']>;
  /** fileIds */
  connectFileIds?: InputMaybe<Array<Scalars['String']>>;
  /** messageIds */
  messageIds?: InputMaybe<Array<Scalars['String']>>;
  removeAllMyFile?: InputMaybe<Scalars['Boolean']>;
};

/** BO 엠버서더 정보 수정 */
export type UpdateAmbassadorBoInput = {
  /** 수정 대상 엠베서더 id */
  id: Scalars['String'];
  /** 엠베서더 회사명 */
  organizationName?: InputMaybe<Scalars['String']>;
  /** 비밀번호 */
  password?: InputMaybe<Scalars['String']>;
  /** 담당자명 */
  managerName?: InputMaybe<Scalars['String']>;
  /** 담당자 이메일 */
  email?: InputMaybe<Scalars['String']>;
  /** 담당자 휴대폰 번호 */
  cellphoneNumber?: InputMaybe<Scalars['String']>;
  /** 사업자 등록번호 */
  companyRegistrationNumber?: InputMaybe<Scalars['String']>;
  /** 사업자 등록증 파일 */
  registration?: InputMaybe<AmbassadorFileUploadInput>;
};

export type UpdateAmbassadorSignUpPageViewCountByIpInput = {
  ambassadorId: Scalars['String'];
  userType: CapaQuotationUserType;
};

export type UpdateBoTestConnectGroupInput = {
  groupId: Scalars['String'];
  /** 테스트 그룹 True/False */
  isTest: Scalars['Boolean'];
};

export type UpdateBoTestUserInput = {
  /** 이메일 */
  email: Scalars['String'];
  /** 테스트 유저 True/False */
  isTest: Scalars['Boolean'];
};

/** BO 회원정보 수정 */
export type UpdateBackOfficeUserInput = {
  /** 수정 대상 회원 id */
  id: Scalars['String'];
  /** 수정 대상 회원 이메일 */
  email: Scalars['String'];
  /** 역할 */
  role?: InputMaybe<BackOfficeAdminRole>;
  /** 이름 */
  name?: InputMaybe<Scalars['String']>;
  /** 영어닉네임 */
  nickName?: InputMaybe<Scalars['String']>;
  /** 부서 */
  dept?: InputMaybe<BackOfficeUserDeptType>;
  /** 직무 */
  task?: InputMaybe<Scalars['String']>;
};

export type UpdateCapaQuotationPartnerStrategy = {
  __typename?: 'UpdateCAPAQuotationPartnerStrategy';
  id: Scalars['ID'];
  email: Scalars['String'];
  status: CapaQuotationPartnerStatus;
  capabilities?: Maybe<CapaQuotationPartnerCapability>;
  organizationName?: Maybe<Scalars['String']>;
  fullAddress?: Maybe<Scalars['String']>;
  shortAddress?: Maybe<Scalars['String']>;
  detailAddress?: Maybe<Scalars['String']>;
  companyRegistrationNumber: Scalars['String'];
  companyIntroduction?: Maybe<Scalars['String']>;
  foundedIn?: Maybe<Scalars['String']>;
  numberEmployees?: Maybe<Scalars['String']>;
  serviceHours?: Maybe<Scalars['String']>;
  managerName: Scalars['String'];
  department?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
  notificationFilter: CapaQuotationPartnerNotificationFilter;
  rfqFilter?: Maybe<Scalars['String']>;
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgreed?: Maybe<Scalars['Boolean']>;
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgreed?: Maybe<Scalars['Boolean']>;
  /** [필수] 결제 서비스 이용약관 동의 */
  paymentAgreed?: Maybe<Scalars['Boolean']>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgreed?: Maybe<Scalars['Boolean']>;
  /** 추천인 ID */
  referralUserId?: Maybe<Scalars['String']>;
  /** ITP 대상 여부 */
  isItp: Scalars['Boolean'];
  /** 생성일 */
  createdAt: Scalars['String'];
  /** 수정일 */
  updatedAt: Scalars['String'];
  /** 파트너 업로드 파일 ex) 사진 및 동영상 관련 */
  logo?: Maybe<CapaQuotationPartnerStrategyFile>;
  /** 커버 이미지 */
  cover?: Maybe<CapaQuotationPartnerStrategyFile>;
  /** 포트폴리오 */
  portfolios?: Maybe<Array<CapaQuotationPartnerPortfolio>>;
  /** 장비 */
  equipments?: Maybe<Array<CapaQuotationPartnerEquipment>>;
  /** 파트너 업로드 파일 ex) 사진 및 동영상 관련 */
  partnerFiles?: Maybe<Array<CapaQuotationPartnerStrategyFile>>;
  /** 인증 관련 정보 */
  certifications?: Maybe<Array<CapaQuotationPartnerTechnologyModel>>;
  /** 특허 관련 정보 */
  patents?: Maybe<Array<CapaQuotationPartnerTechnologyModel>>;
  /** 공장 주소 */
  factoryAddress?: Maybe<Scalars['String']>;
  factoryDetailAddress?: Maybe<Scalars['String']>;
  partnerPageViewCount: Scalars['Float'];
  transactionCount: Scalars['Float'];
  /** 캐파 블로그 및 홍보 관련 */
  promotionModels?: Maybe<Array<CapaPromotionModel>>;
  /** 평균 응답 시간 */
  averageResponseTime?: Maybe<Scalars['String']>;
  /** 사업자 등록증 자료 */
  registrations: Array<CapaQuotationPartnerStrategyFile>;
};

export type UpdateCapaQuotationPartnerStrategyOutput = {
  __typename?: 'UpdateCAPAQuotationPartnerStrategyOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<UpdateCapaQuotationPartnerStrategy>;
};

/** 약관 동의하지 않은 유저를 위한 약관 동의 api */
export type UpdateCapaUserTermsInput = {
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgree: Scalars['Boolean'];
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgree: Scalars['Boolean'];
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgree?: InputMaybe<Scalars['Boolean']>;
  /** [필수] 결제 서비스 약관 동의 */
  paymentAgree?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateConnectAnnotationCommentInput = {
  groupId: Scalars['String'];
  connectSharedFileId: Scalars['String'];
  annotationId: Scalars['String'];
  commentId: Scalars['String'];
  comment: Scalars['String'];
  edited: Scalars['Boolean'];
};

export type UpdateConnectAnnotationInput = {
  groupId: Scalars['String'];
  connectSharedFileId: Scalars['String'];
  annotationId: Scalars['String'];
  anchorPos?: InputMaybe<Capa3DPosInput>;
  handlePos?: InputMaybe<Capa3DPosInput>;
  nodeId?: InputMaybe<Scalars['Float']>;
};

export type UpdateConnectUserFileLink = {
  __typename?: 'UpdateConnectUserFileLink';
  shareLink: Scalars['String'];
  linkStatus: ConnectUserFileLinkStatus;
  filePermission: ConnectUserFileStatus;
};

/** 내 정보 */
export type UpdateConnectUserFileLinkInput = {
  /** fileIds */
  connectFileIds: Array<Scalars['String']>;
  linkStatus: ConnectUserFileLinkStatus;
};

export type UpdateConnectUserFileLinkOutput = {
  __typename?: 'UpdateConnectUserFileLinkOutput';
  /** CAPA ERROR CODE */
  result: CapaErrorCode;
  /** errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  data?: Maybe<UpdateConnectUserFileLink>;
};

/** 내 정보 */
export type UpdateConnectUserFilePermissionInput = {
  /** fileIds */
  connectFileIds: Array<Scalars['String']>;
  permission: ConnectUserFileStatus;
};

/** 내 정보 */
export type UpdateConnectUserInput = {
  /** 이름 (username) */
  username?: InputMaybe<Scalars['String']>;
  /** language */
  userLanguage?: InputMaybe<Language>;
  /** notification filter */
  notificationFilterType?: InputMaybe<ConnectNotificationType>;
  notificationFilterValue?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateIdentityVerificationInput = {
  impUid: Scalars['String'];
};

export type UpdateNoticeScheduleInput = {
  id: Scalars['String'];
  /** 점검 시작 시간 */
  startTime: Scalars['String'];
  /** 점검 종료 시간 */
  endTime: Scalars['String'];
  /** 사전점검 시작 시간 */
  previewStartTime?: InputMaybe<Scalars['String']>;
  /** 사전점검 종료 시간 */
  previewEndTime?: InputMaybe<Scalars['String']>;
  /** client partner connect 인지 */
  pageType: NoticeScheduleNoticePageType;
  /** 긴급점검 / 임시점검 / 사전점검 등 */
  noticeType: NoticeScheduleNoticeType;
  /** 시작예정 / 시작중 / 종료 */
  status?: InputMaybe<NoticeScheduleNoticeStatus>;
};

/** BO 관리자 권한 발주서 상태 변경 (계속진행통보, 취소/환불 승인 ... */
export type UpdatePurchaseOrderStatusBoInput = {
  purchaseOrderId: Scalars['String'];
  reqType: CapaBackOfficeUpdatePurchaseOrderStatusReqType;
};

export type UpdatePurchaseOrderStatusInput = {
  /** 카파 서비스 타입 */
  service: CapaServiceType;
  /** purchase order id */
  purchaseOrderId: Scalars['String'];
  /** 변경할 발주서 status (to-be) */
  statusToChange: CapaPurchaseOrderStatus;
  /** 배송지 등록 */
  registerExpectedDeliveryDate?: InputMaybe<RegisterExpectedDeliveryDateInput>;
  /** 환불 사유 및 환불 금액 */
  requestRefund?: InputMaybe<RequestRefundInput>;
  /** 나이스페이 모달에서 결제할때 입력하는 인증번호 (휴대폰번호 or 사업자번호) -> BuyerAuthNum */
  escrowVerifiedPW?: InputMaybe<Scalars['String']>;
  /** BO 관리자 여부 */
  isAdmin?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateQuotationAnnotationCommentInput = {
  annotationId: Scalars['String'];
  annotationCommentId: Scalars['String'];
  comment: Scalars['String'];
};

export type UpdateQuotationAnnotationInput = {
  annotationId: Scalars['String'];
  anchorPos?: InputMaybe<Capa3DPosInput>;
  handlePos?: InputMaybe<Capa3DPosInput>;
};

export type UpdateQuotationPartnerBoStrategyInput = {
  /** 이메일 */
  email?: InputMaybe<Scalars['String']>;
  /** 비밀번호 */
  password?: InputMaybe<Scalars['String']>;
  /** 유저 상태 */
  status: CapaUserStatus;
  /** CAPA 서비스를 어떻게 알게 되셨나요? (복수 선택 가능) */
  inflowRoute?: InputMaybe<Array<CapaInflowRoute>>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgree?: InputMaybe<Scalars['Boolean']>;
  /** 파트너 상태 */
  partnerStatus: CapaQuotationPartnerStatus;
  /** 파트너 캐파빌리티 jsonb array of { service_type, process_method, material, detailed_material, etc } */
  capabilities?: InputMaybe<CapaQuotationCapabilityInput>;
  /** 회사명 */
  organizationName?: InputMaybe<Scalars['String']>;
  /** 주소 */
  fullAddress?: InputMaybe<Scalars['String']>;
  /** 구 까지만 보여주는 주소 */
  shortAddress?: InputMaybe<Scalars['String']>;
  /** 사업자 등록번호 */
  companyRegistrationNumber?: InputMaybe<Scalars['String']>;
  /** 회사소개 */
  companyIntroduction?: InputMaybe<Scalars['String']>;
  /** 설립년도 */
  foundedIn?: InputMaybe<Scalars['String']>;
  /** 규모 (직원수) */
  numberEmployees?: InputMaybe<Scalars['String']>;
  /** 장비 */
  equipment?: InputMaybe<Scalars['String']>;
  /** 대응 시간 */
  serviceHours?: InputMaybe<Scalars['String']>;
  /** 웹사이트 */
  website?: InputMaybe<Scalars['String']>;
  /** 담당자명 */
  managerName?: InputMaybe<Scalars['String']>;
  /** 부서 */
  department?: InputMaybe<Scalars['String']>;
  /** 직위 */
  position?: InputMaybe<Scalars['String']>;
  /** 연락처 */
  contact?: InputMaybe<Scalars['String']>;
  /** 연락처 */
  notificationFilter?: InputMaybe<CapaQuotationPartnerNotificationFilterInput>;
  /** 파트너 파일 업로드 정보 입력 */
  files?: InputMaybe<Array<QuotationPartnerFileUploadInput>>;
  /** 파트너 기술관련 파일 업로드 정보 입력 */
  strategyFiles?: InputMaybe<
    Array<CapaQuotationPartnerStrategyFileUploadInput>
  >;
  /** 공장 주소 */
  factoryAddress?: InputMaybe<Scalars['String']>;
  /** 파트너 홍보 관련 유튜브 영상 링크 목록 */
  promotionLinks?: InputMaybe<Array<CapaPromotionLinkInput>>;
};

export type UpdateQuotationPartnerStatusInput = {
  quotationPartnerId: Scalars['String'];
  status: CapaQuotationPartnerStatus;
  rejectType?: InputMaybe<CapaQuotationPartnerRejectType>;
  rejectReason?: InputMaybe<Scalars['String']>;
};

export type UpdateQuotationPartnerStrategyInput = {
  /** 파트너 캐파빌리티 jsonb array of { service_type, process_method, material, detailed_material, etc } */
  capabilities?: InputMaybe<CapaQuotationCapabilityInput>;
  /** 회사명 */
  organizationName?: InputMaybe<Scalars['String']>;
  /** 주소 */
  fullAddress?: InputMaybe<Scalars['String']>;
  /** 구 까지만 보여주는 주소 */
  shortAddress?: InputMaybe<Scalars['String']>;
  /** detail address */
  detailAddress?: InputMaybe<Scalars['String']>;
  /** 사업자 등록번호 */
  companyRegistrationNumber?: InputMaybe<Scalars['String']>;
  /** 회사소개 */
  companyIntroduction?: InputMaybe<Scalars['String']>;
  /** 설립년도 */
  foundedIn?: InputMaybe<Scalars['String']>;
  /** 규모 (직원수) */
  numberEmployees?: InputMaybe<Scalars['String']>;
  /** 대응 시간 */
  serviceHours?: InputMaybe<Scalars['String']>;
  /** 담당자명 */
  managerName?: InputMaybe<Scalars['String']>;
  /** 부서 */
  department?: InputMaybe<Scalars['String']>;
  /** 직위 */
  position?: InputMaybe<Scalars['String']>;
  /** 연락처 */
  contact?: InputMaybe<Scalars['String']>;
  /** rfqFilter */
  rfqFilter?: InputMaybe<CapaQuotationCapabilityInput>;
  /** notificationFilter */
  notificationFilter?: InputMaybe<CapaQuotationPartnerNotificationFilterInput>;
  /** 파트너 로고 파일 */
  logo?: InputMaybe<CapaQuotationPartnerStrategyRegistrationFileUploadInput>;
  /** 포트폴리오 */
  portfolios?: InputMaybe<Array<RegisterQuotationPartnerPortfolioInput>>;
  /** 사진 및 동영상 */
  partnerFiles?: InputMaybe<Array<CapaQuotationPartnerStrategyFileUploadInput>>;
  /** 사업자 등록증 */
  registrations?: InputMaybe<
    Array<CapaQuotationPartnerStrategyFileUploadInput>
  >;
  /** 장비 */
  equipments?: InputMaybe<Array<RegisterQuotationPartnerEquipmentInput>>;
  /** 인증 기술 관련 정보 목록 */
  certificationFiles?: InputMaybe<Array<CapaQuotationPartnerTechnologyInput>>;
  /** 특허 기술 관련 정보 목록 */
  patentFiles?: InputMaybe<Array<CapaQuotationPartnerTechnologyInput>>;
  /** 커버 이미지 */
  coverFile?: InputMaybe<CapaQuotationPartnerStrategyFileUploadInput>;
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgree?: InputMaybe<Scalars['Boolean']>;
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgree?: InputMaybe<Scalars['Boolean']>;
  /** [필수] 결제 서비스 이용약관 */
  paymentAgree?: InputMaybe<Scalars['Boolean']>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgree?: InputMaybe<Scalars['Boolean']>;
  /** 공장 위치 */
  factoryAddress?: InputMaybe<Scalars['String']>;
  /** factory detail address */
  factoryDetailAddress?: InputMaybe<Scalars['String']>;
};

/** 내 정보 */
export type UpdateQuotationUserBoInput = {
  /** 이메일 */
  email?: InputMaybe<Scalars['String']>;
  /** 비밀번호 */
  password?: InputMaybe<Scalars['String']>;
  /** 유저 상태 */
  status: CapaUserStatus;
  /** CAPA 서비스를 어떻게 알게 되셨나요? (복수 선택 가능) */
  inflowRoute?: InputMaybe<Array<CapaInflowRoute>>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgree?: InputMaybe<Scalars['Boolean']>;
  /** 유저 상태 */
  userStatus: CapaQuotationUserStatus;
  /** 이름 (담당자명) */
  managerName?: InputMaybe<Scalars['String']>;
  /** 휴대폰 번호 */
  cellphoneNumber?: InputMaybe<Scalars['String']>;
  /** 주소 */
  fullAddress?: InputMaybe<Scalars['String']>;
  /** 짧은 주소 */
  shortAddress?: InputMaybe<Scalars['String']>;
  /** 사업자등록번호 */
  companyRegistrationNumber?: InputMaybe<Scalars['String']>;
  /** 사업자 여부 */
  bizType?: InputMaybe<CapaQuotationUserBizType>;
  /** 회사 / 단체명 */
  organizationName?: InputMaybe<Scalars['String']>;
  /** 회사소개 */
  companyIntroduction?: InputMaybe<Scalars['String']>;
  /** 웹사이트 */
  website?: InputMaybe<Scalars['String']>;
  /** 부서 */
  department?: InputMaybe<Scalars['String']>;
  /** 직함 */
  position?: InputMaybe<Scalars['String']>;
  /** 프로필 사진 설정 */
  files?: InputMaybe<Array<QuotationUserFileUploadInput>>;
};

/** 내 정보 */
export type UpdateQuotationUserInput = {
  /** 캐파 소식 및 혜택 수신동의 */
  emailreceive?: InputMaybe<Scalars['Boolean']>;
  /** 이름 (담당자명) */
  managerName?: InputMaybe<Scalars['String']>;
  /** 휴대폰 번호 */
  cellphoneNumber?: InputMaybe<Scalars['String']>;
  /** 주소 */
  fullAddress?: InputMaybe<Scalars['String']>;
  /** 짧은 주소 */
  shortAddress?: InputMaybe<Scalars['String']>;
  /** 사업자등록번호 */
  companyRegistrationNumber?: InputMaybe<Scalars['String']>;
  /** 사업자 여부 */
  bizType?: InputMaybe<CapaQuotationUserBizType>;
  /** 회사 / 단체명 */
  organizationName?: InputMaybe<Scalars['String']>;
  /** 회사소개 */
  companyIntroduction?: InputMaybe<Scalars['String']>;
  /** 웹사이트 */
  website?: InputMaybe<Scalars['String']>;
  /** 부서 */
  department?: InputMaybe<Scalars['String']>;
  /** 직함 */
  position?: InputMaybe<Scalars['String']>;
  /** 프로필 사진 설정 */
  files?: InputMaybe<Array<QuotationUserFileUploadInput>>;
  /** [필수] 캐파 서비스 이용약관 동의 */
  serviceAgree?: InputMaybe<Scalars['Boolean']>;
  /** [필수] 개인정보 수집 및 활용 동의 */
  privacyAgree?: InputMaybe<Scalars['Boolean']>;
  /** [필수] 결제 서비스 이용약관 동의 */
  paymentAgree?: InputMaybe<Scalars['Boolean']>;
  /** [선택] 프로모션 정보 수신 동의 */
  promotionAgree?: InputMaybe<Scalars['Boolean']>;
  /** 고객 알림 설정 */
  notificationFilter?: InputMaybe<CapaQuotationUserNotificationFilterInput>;
};

export type UpdateReceiveComplaintQuotationChatMessageInput = {
  /** 바이패스 의심되는 chat message id */
  chatMessageId?: InputMaybe<Scalars['String']>;
  /** 유저 불편 사항 */
  complaint?: InputMaybe<Scalars['String']>;
  /** 유저 불편 사항 타입 */
  complaintType?: InputMaybe<CapaBypassComplaintType>;
};

export type UpdateRfqReviewInput = {
  /** review id */
  reviewId: Scalars['String'];
  /** 리뷰 타입 */
  rfqReviewType?: InputMaybe<CapaRfqReviewType>;
  /** transaction satisfaction comment */
  transactionSatisfactionPoint?: InputMaybe<Scalars['Float']>;
  /** transaction satisfaction comment */
  transactionSatisfactionComment?: InputMaybe<Scalars['String']>;
  reviewFiles?: InputMaybe<Array<RfqTransactionReviewFileInput>>;
  /** 납기일 준수 여부 */
  inDueDate?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateRfqStatusInput = {
  rfqId: Scalars['String'];
  rfqStatus: CapaRfqStatus;
};

/** BO 서브몰 상태 변경 */
export type UpdateSubmallStatusBoInput = {
  /** fk CAPAQuotationPartnerEntity#id */
  quotationPartnerId: Scalars['String'];
  /** 변경할 서브몰 status (to-be) */
  statusToChange: CapaSubmallStatus;
  /** BO 서브몰 승인 거절 */
  rejectSubmall?: InputMaybe<RejectSubmallInput>;
};

/** 유저 활동 로그 */
export type UserActivityLogInput = {
  /** 이메일 */
  email?: InputMaybe<Scalars['String']>;
  /** 활동 타입 */
  activityType?: InputMaybe<CapaActivityType>;
  /** 활동 id */
  activitiId?: InputMaybe<Scalars['String']>;
  /** 아이피 */
  ip?: InputMaybe<Scalars['String']>;
  /** 운영체제 */
  os?: InputMaybe<Scalars['String']>;
  /** 기기 종류 */
  deviceType?: InputMaybe<Scalars['String']>;
  /** 브라우저 종류 */
  browser?: InputMaybe<Scalars['String']>;
  /** 캐파 서비스 타입 */
  service?: InputMaybe<CapaServiceType>;
};

export type VentureBizFetchIcxInput = {
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  ventureBizSearchType?: InputMaybe<VentureBizSearchType>;
};

/** VentureBizSearchType */
export enum VentureBizSearchType {
  /** 기업명 */
  CompanyName = 'COMPANY_NAME',
  /** 전화번호 */
  Contact = 'CONTACT',
  /** 관련업종 */
  RelatedIndustry = 'RELATED_INDUSTRY',
  /** 업종 1 */
  IndustryName = 'INDUSTRY_NAME',
  /** 지역 */
  Region = 'REGION'
}

/** 이메일 인증 */
export type VerifyCellPhoneVerificationCodeInput = {
  /** 휴대폰 번호 */
  cellphoneNumber: Scalars['String'];
  /** 인증번호 */
  code: Scalars['String'];
};

/** 사업자 등록 번호 확인 */
export type VerifyCompanyRegistrationNumberInput = {
  /** 사업자 등록 번호 */
  companyRegistrationNumber: Scalars['String'];
};

/** 이메일 인증 */
export type VerifyEmailVerificationCodeInput = {
  /** 이메일 */
  email: Scalars['String'];
  /** 인증번호 */
  code: Scalars['String'];
};

export type VirtualAccountInfo = {
  __typename?: 'VirtualAccountInfo';
  accountNumber: Scalars['String'];
  bankCode: CapaBankCode;
  bankName: Scalars['String'];
  bankHolder?: Maybe<Scalars['String']>;
  dueDate: Scalars['Float'];
  issuedAt: Scalars['Float'];
};

/** BO 회원 탈퇴 */
export type WithdrawBackOfficeUserInput = {
  /** 탈퇴 대상 회원 id */
  id: Scalars['String'];
  /** 탈퇴 대상 회원 이메일 */
  email: Scalars['String'];
};

/** 고객 탈퇴 사유 */
export type WithdrawClientReasonInput = {
  /** serviceType */
  serviceType: CapaServiceType;
  /** 고객탈퇴사유 */
  reason: CapaWithdrawClientReasonType;
  /** 탈퇴 상세 사유 */
  detailedReason?: InputMaybe<Scalars['String']>;
  /** 기타 탈퇴 사유 */
  etcReason?: InputMaybe<Scalars['String']>;
};

/** 파트너 탈퇴 사유 */
export type WithdrawPartnerReasonInput = {
  /** serviceType */
  serviceType: CapaServiceType;
  /** 파트너 탈퇴 사유 */
  reason: CapaWithdrawPartnerReasonType;
  /** 탈퇴 상세 사유 */
  detailedReason?: InputMaybe<Scalars['String']>;
  /** 기타 탈퇴 사유 */
  etcReason?: InputMaybe<Scalars['String']>;
};

export type WithdrawQuotationPartnerBoInput = {
  /** 이메일 */
  email: Scalars['String'];
  /** 탈퇴 사유 */
  withdrawReason: WithdrawPartnerReasonInput;
};

/** 파트너 회원 탈퇴 */
export type WithdrawQuotationPartnerInput = {
  /** 탈퇴하고자 하는 파트너의 이메일 */
  email: Scalars['String'];
  /** 탈퇴 사유 */
  withdrawReason: WithdrawPartnerReasonInput;
};

/** 강제 탈퇴 */
export type WithdrawQuotationUserBoInput = {
  /** 이메일 */
  email: Scalars['String'];
  /** 탈퇴 사유 */
  withdrawReason: WithdrawClientReasonInput;
};

/** 고객 회원 탈퇴 */
export type WithdrawQuotationUserInput = {
  /** 탈퇴하고자 하는 고객의 이메일 */
  email: Scalars['String'];
  /** 탈퇴 사유 */
  withdrawReason: WithdrawClientReasonInput;
};

export type FetchCapacxManagementRequiredUsersBo = {
  __typename?: 'fetchCAPACXManagementRequiredUsersBO';
  quotationUserId: Scalars['String'];
  /** 고객명 */
  managerName?: Maybe<Scalars['String']>;
  /** 회사명 */
  organizationName?: Maybe<Scalars['String']>;
  /** 고객유형 */
  bizType?: Maybe<CapaQuotationUserBizType>;
  /** 이메일 */
  email?: Maybe<Scalars['String']>;
  /** 휴대전화 */
  cellphoneNumber?: Maybe<Scalars['String']>;
  /** rfq id */
  rfqId?: Maybe<Scalars['String']>;
  /** 견적요청일 */
  createdAt?: Maybe<Scalars['String']>;
  /** 서비스타입 */
  serviceType?: Maybe<CapaQuotationServiceType>;
  /** 프로젝트명 */
  projectName?: Maybe<Scalars['String']>;
  /** 총 수량 */
  totalQuantity?: Maybe<Scalars['Float']>;
  /** RFQ 상태 */
  status?: Maybe<CapaRfqStatus>;
  /** 조회수 */
  viewCount?: Maybe<Scalars['Float']>;
  /** 조회파트너수 */
  viewPartnerCount?: Maybe<Scalars['Float']>;
  /** 코멘트수 */
  commentCount?: Maybe<Scalars['Float']>;
};

export type FetchQuotationPartnerProjectParticipationStatusBoInput = {
  quotationPartnerId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

/** readRfqAdjustRequestInput */
export type ReadRfqAdjustRequestInput = {
  email?: InputMaybe<Scalars['String']>;
  /** 업데이트할 adjustRequest Id */
  id: Scalars['String'];
  type: CapaRfqAdjustRequestType;
};

export type SendQuotationPartnerIntroductionInput = {
  rfqId: Scalars['String'];
  partnerId?: InputMaybe<Scalars['String']>;
};

export type AuthenticateQueryVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  service: CapaServiceType;
}>;

export type AuthenticateQuery = {
  __typename?: 'Query';
  authenticate: {
    __typename?: 'AuthenticationOutput';
    errorMessage?: string | null;
    result: CapaErrorCode;
    data?: {
      __typename?: 'Authentication';
      accessToken: string;
      tokenType: string;
      expiresIn: number;
      refreshToken: string;
      redirectUrl?: string | null;
    } | null;
  };
};

export type FetchMyQuotationPartnerQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FetchMyQuotationPartnerQuery = {
  __typename?: 'Query';
  fetchMyQuotationPartner: {
    __typename?: 'CAPAQuotationPartnerStrategyOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAQuotationPartnerStrategy';
      id: string;
      email: string;
      status: CapaQuotationPartnerStatus;
      organizationName?: string | null;
      fullAddress?: string | null;
      shortAddress?: string | null;
      companyRegistrationNumber: string;
      companyIntroduction?: string | null;
      foundedIn?: string | null;
      numberEmployees?: string | null;
      serviceHours?: string | null;
      managerName: string;
      department?: string | null;
      position?: string | null;
      contact?: string | null;
      rfqFilter?: string | null;
      serviceAgreed?: boolean | null;
      privacyAgreed?: boolean | null;
      promotionAgreed?: boolean | null;
      referralUserId?: string | null;
      isItp: boolean;
      createdAt: string;
      updatedAt: string;
      factoryAddress?: string | null;
      averageResponseTime?: string | null;
      transactionCount?: number | null;
      partnerPageViewCount?: number | null;
      capabilities?: {
        __typename?: 'CAPAQuotationPartnerCapability';
        services?: Array<{
          __typename?: 'CAPAQuotationService';
          service?: CapaQuotationServiceType | null;
          status: CapaCapabilitiesStatusType;
          optionalServices?: Array<CapaQuotationServiceType> | null;
          detailedServices?: Array<{
            __typename?: 'CAPAQuotationDetailedService';
            type?: CapaQuotationDetailedServiceType | null;
            materials?: Array<{
              __typename?: 'CAPAQuotationDetailedMaterial';
              detailedMaterials?: Array<
                CapaQuotationDetailedMaterialType
              > | null;
            }> | null;
          }> | null;
        }> | null;
      } | null;
      notificationFilter: {
        __typename?: 'CAPAQuotationPartnerNotificationFilter';
        chatEmail?: boolean | null;
        chatSMS?: boolean | null;
        chatPush?: boolean | null;
        rfqEmail?: boolean | null;
        rfqSMS?: boolean | null;
        rfqPush?: boolean | null;
        projectEmail?: boolean | null;
        projectSMS?: boolean | null;
        newsEmail?: boolean | null;
        newsSMS?: boolean | null;
        capabilityFilters?: Array<{
          __typename?: 'CAPAQuotationCapabilityNotificationFilter';
          email?: boolean | null;
          sms?: boolean | null;
          push?: boolean | null;
          service?: CapaQuotationServiceType | null;
          detailedServices?: Array<CapaQuotationDetailedServiceType> | null;
          optionalServices?: Array<CapaQuotationServiceType> | null;
        }> | null;
        doNotDisturb?: {
          __typename?: 'CAPADoNotDisturbFilter';
          isActive?: boolean | null;
          to?: number | null;
          from?: number | null;
        } | null;
        projectFilters?: Array<{
          __typename?: 'CAPARfqProjectFilter';
          email?: boolean | null;
          sms?: boolean | null;
          service?: CapaRfqProjectManagementType | null;
        }> | null;
      };
      logo?: {
        __typename?: 'CAPAQuotationPartnerStrategyFile';
        id: string;
        fileId?: string | null;
        fileName?: string | null;
        fileType?: CapaQuotationPartnerStrategyFileType | null;
        fileMimetype?: string | null;
        fileSize?: string | null;
        fileExtension?: string | null;
      } | null;
      partnerFiles?: Array<{
        __typename?: 'CAPAQuotationPartnerStrategyFile';
        id: string;
        fileId?: string | null;
        fileName?: string | null;
        fileType?: CapaQuotationPartnerStrategyFileType | null;
        fileMimetype?: string | null;
        fileSize?: string | null;
        fileExtension?: string | null;
        videoThumbnailFileId?: string | null;
      }> | null;
      portfolios?: Array<{
        __typename?: 'CAPAQuotationPartnerPortfolio';
        id: string;
        projectName: string;
        client?: string | null;
        description?: string | null;
        projectPurpose?: Array<CapaQuotationProductPurpose> | null;
        productType?: string | null;
        quantity?: number | null;
        produceStep?: CapaQuotationPartnerImagePortfolioProduceStepType | null;
        capabilities?: Array<{
          __typename?: 'CAPAQuotationPartnerPortfolioService';
          service?: CapaQuotationServiceType | null;
          detailedServices?: Array<CapaQuotationDetailedServiceType> | null;
        }> | null;
        files: Array<{
          __typename?: 'CAPAQuotationPartnerStrategyFile';
          id: string;
          fileId?: string | null;
          fileName?: string | null;
          fileType?: CapaQuotationPartnerStrategyFileType | null;
          fileMimetype?: string | null;
          fileSize?: string | null;
          fileExtension?: string | null;
        }>;
      }> | null;
      equipments?: Array<{
        __typename?: 'CAPAQuotationPartnerEquipment';
        id: string;
        equipmentName: string;
        quantity: number;
        description?: string | null;
        createdAt?: string | null;
        file?: {
          __typename?: 'CAPAQuotationPartnerStrategyFile';
          id: string;
          fileId?: string | null;
          fileName?: string | null;
          fileType?: CapaQuotationPartnerStrategyFileType | null;
          fileMimetype?: string | null;
          fileSize?: string | null;
          fileExtension?: string | null;
        } | null;
      }> | null;
      certifications?: Array<{
        __typename?: 'CAPAQuotationPartnerTechnologyModel';
        id: string;
        quotationPartnerId: string;
        strategyFileId?: string | null;
        technicalName?: string | null;
        certificationAuthority?: string | null;
        expirationPeriodStart?: string | null;
        expirationPeriodEnd?: string | null;
        description?: string | null;
        technologyType: CapaQuotationPartnerTechnologyType;
        file?: {
          __typename?: 'CAPAQuotationPartnerStrategyFile';
          id: string;
          fileId?: string | null;
          fileName?: string | null;
          fileType?: CapaQuotationPartnerStrategyFileType | null;
          fileMimetype?: string | null;
          fileSize?: string | null;
          fileExtension?: string | null;
        } | null;
      }> | null;
      patents?: Array<{
        __typename?: 'CAPAQuotationPartnerTechnologyModel';
        id: string;
        quotationPartnerId: string;
        strategyFileId?: string | null;
        technicalName?: string | null;
        certificationAuthority?: string | null;
        expirationPeriodStart?: string | null;
        expirationPeriodEnd?: string | null;
        description?: string | null;
        technologyType: CapaQuotationPartnerTechnologyType;
        file?: {
          __typename?: 'CAPAQuotationPartnerStrategyFile';
          id: string;
          fileId?: string | null;
          fileName?: string | null;
          fileType?: CapaQuotationPartnerStrategyFileType | null;
          fileMimetype?: string | null;
          fileSize?: string | null;
          fileExtension?: string | null;
        } | null;
      }> | null;
      promotionModels?: Array<{
        __typename?: 'CAPAPromotionModel';
        id?: string | null;
        quotationPartnerId: string;
        capaBlogLink: string;
        status: CapaPromotionStatus;
      }> | null;
      registrations: Array<{
        __typename?: 'CAPAQuotationPartnerStrategyFile';
        id: string;
        fileId?: string | null;
        videoThumbnailFileId?: string | null;
      }>;
    } | null;
  };
};

export type FetchMyQuotationUserQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FetchMyQuotationUserQuery = {
  __typename?: 'Query';
  fetchMyQuotationUser: {
    __typename?: 'CAPAQuotationUserOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAQuotationUser';
      id: string;
      email: string;
      status: CapaQuotationUserStatus;
      managerName?: string | null;
      cellphoneNumber?: string | null;
      fullAddress?: string | null;
      shortAddress?: string | null;
      companyRegistrationNumber?: string | null;
      bizType?: CapaQuotationUserBizType | null;
      organizationName?: string | null;
      companyIntroduction?: string | null;
      website?: string | null;
      department?: string | null;
      position?: string | null;
      serviceAgreed?: boolean | null;
      privacyAgreed?: boolean | null;
      promotionAgreed?: boolean | null;
      paymentAgreed?: boolean | null;
      referralUserId?: string | null;
      createdAt: string;
      updatedAt: string;
      verificationType?: CapaQuotationUserVerificationType | null;
      verificationName?: string | null;
      verificationBirthDate?: string | null;
      notificationFilter?: {
        __typename?: 'CAPAQuotationUserNotificationFilter';
        projectEmail?: boolean | null;
        projectSMS?: boolean | null;
        chatEmail?: boolean | null;
        chatSMS?: boolean | null;
        chatPush?: boolean | null;
        newsEmail?: boolean | null;
        newsSMS?: boolean | null;
        doNotDisturb?: {
          __typename?: 'CAPADoNotDisturbFilter';
          isActive?: boolean | null;
          from?: number | null;
          to?: number | null;
        } | null;
        projectFilters?: Array<{
          __typename?: 'CAPARfqProjectFilter';
          email?: boolean | null;
          sms?: boolean | null;
          service?: CapaRfqProjectManagementType | null;
        }> | null;
      } | null;
      files?: Array<{
        __typename?: 'CAPAQuotationUserFile';
        fileId?: string | null;
        fileName?: string | null;
        fileType?: CapaQuotationUserFileType | null;
      }> | null;
      myRefundAccount?: {
        __typename?: 'FetchMyAccountModel';
        id: string;
        bankCode: CapaBankCode;
        account: string;
        holderName: string;
      } | null;
    } | null;
  };
};

export type FetchQuotationUserQueryVariables = Exact<{
  quotationUserId: Scalars['String'];
}>;

export type FetchQuotationUserQuery = {
  __typename?: 'Query';
  fetchQuotationUser: {
    __typename?: 'CAPAQuotationUserOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAQuotationUser';
      id: string;
      email: string;
      status: CapaQuotationUserStatus;
      managerName?: string | null;
      cellphoneNumber?: string | null;
      fullAddress?: string | null;
      shortAddress?: string | null;
      companyRegistrationNumber?: string | null;
      bizType?: CapaQuotationUserBizType | null;
      organizationName?: string | null;
      companyIntroduction?: string | null;
      website?: string | null;
      department?: string | null;
      position?: string | null;
      serviceAgreed?: boolean | null;
      privacyAgreed?: boolean | null;
      promotionAgreed?: boolean | null;
      referralUserId?: string | null;
      createdAt: string;
      updatedAt: string;
      files?: Array<{
        __typename?: 'CAPAQuotationUserFile';
        fileId?: string | null;
        fileName?: string | null;
        fileType?: CapaQuotationUserFileType | null;
      }> | null;
    } | null;
  };
};

export type RefreshMutationVariables = Exact<{
  refreshToken: Scalars['String'];
}>;

export type RefreshMutation = {
  __typename?: 'Mutation';
  refresh: {
    __typename?: 'AuthenticationOutput';
    errorMessage?: string | null;
    result: CapaErrorCode;
    data?: {
      __typename?: 'Authentication';
      accessToken: string;
      tokenType: string;
      expiresIn: number;
      refreshToken: string;
      redirectUrl?: string | null;
    } | null;
  };
};

export type RequestReferralIdMutationVariables = Exact<{
  service: CapaServiceType;
}>;

export type RequestReferralIdMutation = {
  __typename?: 'Mutation';
  requestReferralId: {
    __typename?: 'CAPAReferralOut';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: { __typename?: 'CAPAReferral'; referralId: string } | null;
  };
};

export type RequestEmailVerificationCodeMutationVariables = Exact<{
  email: Scalars['String'];
  service: CapaServiceType;
}>;

export type RequestEmailVerificationCodeMutation = {
  __typename?: 'Mutation';
  requestEmailVerificationCode: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type VerifyEmailVerificationCodeQueryVariables = Exact<{
  email: Scalars['String'];
  code: Scalars['String'];
}>;

export type VerifyEmailVerificationCodeQuery = {
  __typename?: 'Query';
  verifyEmailVerificationCode: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type RegisterMutationVariables = Exact<{
  input: RegistrationInput;
}>;

export type RegisterMutation = {
  __typename?: 'Mutation';
  register: {
    __typename?: 'AuthenticationOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'Authentication';
      accessToken: string;
      tokenType: string;
      expiresIn: number;
      refreshToken: string;
      redirectUrl?: string | null;
    } | null;
  };
};

export type VerifyCompanyRegistrationNumberQueryVariables = Exact<{
  input: VerifyCompanyRegistrationNumberInput;
}>;

export type VerifyCompanyRegistrationNumberQuery = {
  __typename?: 'Query';
  verifyCompanyRegistrationNumber: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type RegisterQuotationUserMutationVariables = Exact<{
  input: RegisterQuotationUserInput;
}>;

export type RegisterQuotationUserMutation = {
  __typename?: 'Mutation';
  registerQuotationUser: {
    __typename?: 'AuthenticationOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'Authentication';
      accessToken: string;
      tokenType: string;
      expiresIn: number;
      refreshToken: string;
      redirectUrl?: string | null;
    } | null;
  };
};

export type RequestResetPasswordMutationVariables = Exact<{
  input: RequestResetPasswordInput;
}>;

export type RequestResetPasswordMutation = {
  __typename?: 'Mutation';
  requestResetPassword: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type ChangeEmailMutationVariables = Exact<{
  input: ChangeEmailInput;
}>;

export type ChangeEmailMutation = {
  __typename?: 'Mutation';
  changeEmail: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;

export type ChangePasswordMutation = {
  __typename?: 'Mutation';
  changePassword: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type UpdateQuotationUserMutationVariables = Exact<{
  input: UpdateQuotationUserInput;
}>;

export type UpdateQuotationUserMutation = {
  __typename?: 'Mutation';
  updateQuotationUser: {
    __typename?: 'CAPAQuotationUserOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAQuotationUser';
      id: string;
      email: string;
      status: CapaQuotationUserStatus;
      managerName?: string | null;
      cellphoneNumber?: string | null;
      fullAddress?: string | null;
      shortAddress?: string | null;
      companyRegistrationNumber?: string | null;
      bizType?: CapaQuotationUserBizType | null;
      organizationName?: string | null;
      companyIntroduction?: string | null;
      website?: string | null;
      department?: string | null;
      position?: string | null;
      serviceAgreed?: boolean | null;
      privacyAgreed?: boolean | null;
      promotionAgreed?: boolean | null;
      referralUserId?: string | null;
      createdAt: string;
      updatedAt: string;
      files?: Array<{
        __typename?: 'CAPAQuotationUserFile';
        fileId?: string | null;
        fileName?: string | null;
        fileType?: CapaQuotationUserFileType | null;
      }> | null;
    } | null;
  };
};

export type SubscribeCapaNewsMutationVariables = Exact<{
  subscriberEmail: Scalars['String'];
  userName: Scalars['String'];
}>;

export type SubscribeCapaNewsMutation = {
  __typename?: 'Mutation';
  subscribeCAPANews: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type UpdateAmbassadorSignUpPageViewCountByIpMutationVariables = Exact<{
  input: UpdateAmbassadorSignUpPageViewCountByIpInput;
}>;

export type UpdateAmbassadorSignUpPageViewCountByIpMutation = {
  __typename?: 'Mutation';
  updateAmbassadorSignUpPageViewCountByIp: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type UpdateTermsMutationVariables = Exact<{
  input: UpdateCapaUserTermsInput;
}>;

export type UpdateTermsMutation = {
  __typename?: 'Mutation';
  updateTerms: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type UpdateIdentityVerificationMutationVariables = Exact<{
  input: UpdateIdentityVerificationInput;
}>;

export type UpdateIdentityVerificationMutation = {
  __typename?: 'Mutation';
  updateIdentityVerification: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type SubscribeQuotationUpdateDataSubscriptionVariables = Exact<{
  chatRoomId: Scalars['String'];
}>;

export type SubscribeQuotationUpdateDataSubscription = {
  __typename?: 'Subscription';
  subscribeQuotationUpdateData: {
    __typename?: 'CAPAQuotationUpdateOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAQuotationUpdate';
      quotationSharedFileId?: string | null;
      userName?: string | null;
      chatRoomId?: string | null;
      comment?: string | null;
      nodeId?: number | null;
      annotationId?: string | null;
      userId?: string | null;
      commentId?: string | null;
      annotationCreatedAt?: string | null;
      annotationUpdatedAt?: string | null;
      commentCreatedAt?: string | null;
      commentUpdatedAt?: string | null;
      status?: CapaQuotationSharedFileAnnotationStatus | null;
      type?: CapaQuotationUpdateType | null;
      anchorPos?: {
        __typename?: 'CAPA3DPos';
        x: number;
        y: number;
        z: number;
      } | null;
      handlePos?: {
        __typename?: 'CAPA3DPos';
        x: number;
        y: number;
        z: number;
      } | null;
    } | null;
  };
};

export type FetchQuotationChatRoomAnnotationCommentsQueryVariables = Exact<{
  input: FetchQuotationChatRoomAnnotationCommentInput;
}>;

export type FetchQuotationChatRoomAnnotationCommentsQuery = {
  __typename?: 'Query';
  fetchQuotationChatRoomAnnotationComments: {
    __typename?: 'CAPAQuotationChatRoomAnnotationCommentsOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: Array<{
      __typename?: 'CAPAQuotationChatRoomAnnotationComment';
      userId?: string | null;
      isNew?: boolean | null;
      annotationId?: string | null;
      fileName?: string | null;
      fileId?: string | null;
      lastComment?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      commentUsers?: Array<{
        __typename?: 'CommentUser';
        userName?: string | null;
      }> | null;
      comments?: Array<{
        __typename?: 'AnnotationComment';
        id?: string | null;
        isParent?: boolean | null;
        comment?: string | null;
        userId?: string | null;
        userName?: string | null;
        status?: CapaQuotationSharedFileAnnotationStatus | null;
        createdAt?: string | null;
      }> | null;
    }> | null;
  };
};

export type FetchQuotationChatRoomSpecificAnnotationsQueryVariables = Exact<{
  input: FetchQuotationChatRoomSpecificAnnotationInput;
}>;

export type FetchQuotationChatRoomSpecificAnnotationsQuery = {
  __typename?: 'Query';
  fetchQuotationChatRoomSpecificAnnotations: {
    __typename?: 'CapaQuotationChatRoomSpecificAnnotationsOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: Array<{
      __typename?: 'CapaQuotationChatRoomSpecificAnnotation';
      isNew?: boolean | null;
      userId?: string | null;
      status?: CapaQuotationSharedFileAnnotationStatus | null;
      nodeId?: number | null;
      createdAt?: string | null;
      annotationId?: string | null;
      anchorPos?: {
        __typename?: 'CAPA3DPos';
        x: number;
        y: number;
        z: number;
      } | null;
      handlePos?: {
        __typename?: 'CAPA3DPos';
        x: number;
        y: number;
        z: number;
      } | null;
      commentUsers?: Array<{
        __typename?: 'CommentUser';
        userName?: string | null;
      }> | null;
      comments?: Array<{
        __typename?: 'CAPAQuotationSpecificAnnotationComment';
        id?: string | null;
        userId?: string | null;
        userName?: string | null;
        isParent?: boolean | null;
        comment?: string | null;
        status?: CapaQuotationSharedFileAnnotationStatus | null;
        edited?: boolean | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      }> | null;
    }> | null;
  };
};

export type CreateQuotationAnnotationMutationVariables = Exact<{
  input: CreateQuotationAnnotationInput;
}>;

export type CreateQuotationAnnotationMutation = {
  __typename?: 'Mutation';
  createQuotationAnnotation: {
    __typename?: 'CAPAQuotationAnnotationOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAQuotatationAnnotation';
      id?: string | null;
      userId?: string | null;
      chatRoomId?: string | null;
      nodeId?: number | null;
      isNew?: boolean | null;
      status?: CapaQuotationSharedFileAnnotationStatus | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      anchorPos?: {
        __typename?: 'CAPA3DPos';
        x: number;
        y: number;
        z: number;
      } | null;
      handlePos?: {
        __typename?: 'CAPA3DPos';
        x: number;
        y: number;
        z: number;
      } | null;
      comments?: Array<{
        __typename?: 'CAPAQuotationAnnotationComment';
        id?: string | null;
        userId?: string | null;
        isParent?: boolean | null;
        comment?: string | null;
        userName?: string | null;
        status?: CapaQuotationSharedFileAnnotationStatus | null;
        edited?: boolean | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      }> | null;
    } | null;
  };
};

export type RemoveQuotationAnnotationMutationVariables = Exact<{
  input: RemoveQuotationAnnotationInput;
}>;

export type RemoveQuotationAnnotationMutation = {
  __typename?: 'Mutation';
  removeQuotationAnnotation: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type CreateQuotationAnnotationCommentMutationVariables = Exact<{
  input: CreateQuotationAnnotationCommentInput;
}>;

export type CreateQuotationAnnotationCommentMutation = {
  __typename?: 'Mutation';
  createQuotationAnnotationComment: {
    __typename?: 'CAPAQuotationAnnotationOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAQuotatationAnnotation';
      id?: string | null;
      userId?: string | null;
      chatRoomId?: string | null;
      nodeId?: number | null;
      isNew?: boolean | null;
      status?: CapaQuotationSharedFileAnnotationStatus | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      anchorPos?: {
        __typename?: 'CAPA3DPos';
        x: number;
        y: number;
        z: number;
      } | null;
      handlePos?: {
        __typename?: 'CAPA3DPos';
        x: number;
        y: number;
        z: number;
      } | null;
      comments?: Array<{
        __typename?: 'CAPAQuotationAnnotationComment';
        id?: string | null;
        userId?: string | null;
        isParent?: boolean | null;
        comment?: string | null;
        userName?: string | null;
        status?: CapaQuotationSharedFileAnnotationStatus | null;
        edited?: boolean | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      }> | null;
    } | null;
  };
};

export type RemoveQuotationAnnotationCommentMutationVariables = Exact<{
  input: RemoveQuotationAnnotationCommentInput;
}>;

export type RemoveQuotationAnnotationCommentMutation = {
  __typename?: 'Mutation';
  removeQuotationAnnotationComment: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type UpdateQuotationAnnotationMutationVariables = Exact<{
  input: UpdateQuotationAnnotationInput;
}>;

export type UpdateQuotationAnnotationMutation = {
  __typename?: 'Mutation';
  updateQuotationAnnotation: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type UpdateQuotationAnnotationCommentMutationVariables = Exact<{
  input: UpdateQuotationAnnotationCommentInput;
}>;

export type UpdateQuotationAnnotationCommentMutation = {
  __typename?: 'Mutation';
  updateQuotationAnnotationComment: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type ReadQuotationAnnotationCommentMutationVariables = Exact<{
  annotationId: Scalars['String'];
}>;

export type ReadQuotationAnnotationCommentMutation = {
  __typename?: 'Mutation';
  readQuotationAnnotationComment: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type FetchQuotationChatRoomQueryVariables = Exact<{
  input: FetchQuotationChatRoomInput;
}>;

export type FetchQuotationChatRoomQuery = {
  __typename?: 'Query';
  fetchQuotationChatRoom: {
    __typename?: 'CAPAQuotationChatRoomOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAQuotationChatRoom';
      rfqId?: string | null;
      quotationPartnerId?: string | null;
      chatRoomId?: string | null;
      isOld?: boolean | null;
      rfqStatus?: CapaRfqStatus | null;
      chatRoomStatus?: CapaQuotationChatRoomStatus | null;
      partnerStatus?: CapaQuotationPartnerUserStatus | null;
      clientStatus?: CapaQuotationUserStatus | null;
      hasQuotation?: boolean | null;
      hasReview?: boolean | null;
      isQuotationConfirmed?: boolean | null;
      hasPurchaseOrder?: boolean | null;
      isPurchaseOrderConfirmed?: boolean | null;
      partnerLastSeenAt?: string | null;
      hasProgressingPayment?: boolean | null;
      chatFiles?: Array<{
        __typename?: 'CAPAQuotationChatFile';
        fileName?: string | null;
        fileId?: string | null;
        fileSize?: number | null;
      }> | null;
    } | null;
  };
};

export type SubscribeQuotationChatRoomSubscriptionVariables = Exact<{
  input: SubscribeQuotationChatRoomInput;
}>;

export type SubscribeQuotationChatRoomSubscription = {
  __typename?: 'Subscription';
  subscribeQuotationChatRoom: {
    __typename?: 'CAPAQuotationChatRoomOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAQuotationChatRoom';
      rfqId?: string | null;
      quotationPartnerId?: string | null;
      chatRoomId?: string | null;
      isOld?: boolean | null;
      rfqStatus?: CapaRfqStatus | null;
      chatRoomStatus?: CapaQuotationChatRoomStatus | null;
      partnerStatus?: CapaQuotationPartnerUserStatus | null;
      clientStatus?: CapaQuotationUserStatus | null;
      hasQuotation?: boolean | null;
      isQuotationConfirmed?: boolean | null;
      hasPurchaseOrder?: boolean | null;
      isPurchaseOrderConfirmed?: boolean | null;
      partnerLastSeenAt?: string | null;
      hasReview?: boolean | null;
      hasProgressingPayment?: boolean | null;
      chatFiles?: Array<{
        __typename?: 'CAPAQuotationChatFile';
        fileName?: string | null;
        fileId?: string | null;
        fileSize?: number | null;
      }> | null;
    } | null;
  };
};

export type FetchQuotationChatMessagesQueryVariables = Exact<{
  input: FetchQuotationChatRoomInput;
}>;

export type FetchQuotationChatMessagesQuery = {
  __typename?: 'Query';
  fetchQuotationChatMessages: {
    __typename?: 'CAPAQuotationChatMessagesOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: Array<{
      __typename?: 'CAPAQuotationChatMessage';
      id?: string | null;
      senderId?: string | null;
      senderUserType?: CapaQuotationUserType | null;
      organizationName?: string | null;
      managerName?: string | null;
      profileId?: string | null;
      createdAt?: string | null;
      unReadCount?: number | null;
      message?:
        | {
            __typename?: 'CAPAQuotationChatMessageMessage';
            messageType: CapaQuotationChatMessageType;
            message?: string | null;
          }
        | {
            __typename?: 'CAPAQuotationChatMessageSimpleQuotation';
            messageType: CapaQuotationChatMessageType;
            quotation?: {
              __typename?: 'CAPAQuotationSimpleQuotation';
              quotation?: number | null;
              excludeDeliveryFee?: boolean | null;
              etc?: string | null;
            } | null;
          }
        | {
            __typename?: 'CAPAQuotationChatMessageDetailedQuotation';
            messageType: CapaQuotationChatMessageType;
            quotation?: {
              __typename?: 'CAPAQuotationDetailedQuotation';
              rfqId: string;
              projectName?: string | null;
              serviceType?: CapaQuotationServiceType | null;
              dueDate?: string | null;
              expiration?: string | null;
              quotation?: number | null;
              deliveryCost?: number | null;
              createdAt?: string | null;
              maxDraftModificationCount?: number | null;
              draftModificationTerms?: string | null;
              etc?: string | null;
              optionalServices?: Array<{
                __typename?: 'CAPAQuotationRfqQuotationOptionalService';
                serviceType?: CapaQuotationServiceType | null;
              }> | null;
              publish?: {
                __typename?: 'CAPAQuotationDetailedQuotationPublish';
                organizationName?: string | null;
              } | null;
              supply?: {
                __typename?: 'CAPAQuotationDetailedQuotationSupply';
                quotationPartnerStatus?: CapaQuotationPartnerStatus | null;
                quotationPartnerId: string;
                organizationName?: string | null;
                companyRegistrationNumber?: number | null;
                managerName?: string | null;
                address?: string | null;
              } | null;
              items?: Array<{
                __typename?: 'CAPAQuotationDetailedQuotationItem';
                fileId?: string | null;
                fileName?: string | null;
                quantity: number;
                material?: string | null;
                cost: number;
                etc?: string | null;
              }> | null;
            } | null;
          }
        | {
            __typename?: 'CAPAQuotationChatMessageRfq';
            messageType: CapaQuotationChatMessageType;
            rfq?: {
              __typename?: 'CAPAQuotationChatRfq';
              rfqId?: string | null;
              userOrganizationName?: string | null;
              userManagerName?: string | null;
              partnerOrganizationName?: string | null;
              partnerManagerName?: string | null;
              projectName?: string | null;
              quotationId?: string | null;
              purchaseOrderId?: string | null;
              adjustRequest?: string | null;
              event?: CapaQuotationRfqEventType | null;
              rejectedReason?: string | null;
              isVisible?: boolean | null;
              isSendRequest?: boolean | null;
              purchaseAmount?: number | null;
              expectedConfirmPurchaseDate?: string | null;
            } | null;
          }
        | {
            __typename?: 'CAPAQuotationAnnotationCommentMessage';
            messageType: CapaQuotationChatMessageType;
            annotation?: {
              __typename?: 'CAPAQuotationAnnotationComment';
              id?: string | null;
              annotationId?: string | null;
              fileId?: string | null;
              userId?: string | null;
              isParent?: boolean | null;
              comment?: string | null;
              userName?: string | null;
              status?: CapaQuotationSharedFileAnnotationStatus | null;
              edited?: boolean | null;
              createdAt?: string | null;
              updatedAt?: string | null;
            } | null;
          }
        | {
            __typename?: 'CAPAQuotationBypassMessage';
            messageType: CapaQuotationChatMessageType;
            bypass?: {
              __typename?: 'CAPAQuotationBypassSendMessageTemplateModel';
              id?: string | null;
            } | null;
          }
        | {
            __typename?: 'CAPAQuotationBypassMessageDeleteMessage';
            messageType: CapaQuotationChatMessageType;
            id?: string | null;
          }
        | null;
      chatFiles?: Array<{
        __typename?: 'CAPAQuotationChatFile';
        fileId?: string | null;
        fileName?: string | null;
        fileSize?: number | null;
      }> | null;
    }> | null;
  };
};

export type SubscribeQuotationChatMessageSubscriptionVariables = Exact<{
  input: SubscribeQuotationChatRoomInput;
}>;

export type SubscribeQuotationChatMessageSubscription = {
  __typename?: 'Subscription';
  subscribeQuotationChatMessage: {
    __typename?: 'CAPAQuotationChatMessagesOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: Array<{
      __typename?: 'CAPAQuotationChatMessage';
      id?: string | null;
      senderId?: string | null;
      senderUserType?: CapaQuotationUserType | null;
      organizationName?: string | null;
      managerName?: string | null;
      profileId?: string | null;
      createdAt?: string | null;
      unReadCount?: number | null;
      message?:
        | {
            __typename?: 'CAPAQuotationChatMessageMessage';
            messageType: CapaQuotationChatMessageType;
            message?: string | null;
          }
        | {
            __typename?: 'CAPAQuotationChatMessageSimpleQuotation';
            messageType: CapaQuotationChatMessageType;
            quotation?: {
              __typename?: 'CAPAQuotationSimpleQuotation';
              quotation?: number | null;
              excludeDeliveryFee?: boolean | null;
              etc?: string | null;
            } | null;
          }
        | {
            __typename?: 'CAPAQuotationChatMessageDetailedQuotation';
            messageType: CapaQuotationChatMessageType;
            quotation?: {
              __typename?: 'CAPAQuotationDetailedQuotation';
              rfqId: string;
              projectName?: string | null;
              serviceType?: CapaQuotationServiceType | null;
              dueDate?: string | null;
              expiration?: string | null;
              quotation?: number | null;
              deliveryCost?: number | null;
              createdAt?: string | null;
              maxDraftModificationCount?: number | null;
              draftModificationTerms?: string | null;
              etc?: string | null;
              optionalServices?: Array<{
                __typename?: 'CAPAQuotationRfqQuotationOptionalService';
                serviceType?: CapaQuotationServiceType | null;
              }> | null;
              publish?: {
                __typename?: 'CAPAQuotationDetailedQuotationPublish';
                organizationName?: string | null;
              } | null;
              supply?: {
                __typename?: 'CAPAQuotationDetailedQuotationSupply';
                quotationPartnerStatus?: CapaQuotationPartnerStatus | null;
                quotationPartnerId: string;
                organizationName?: string | null;
                companyRegistrationNumber?: number | null;
                managerName?: string | null;
                address?: string | null;
              } | null;
              items?: Array<{
                __typename?: 'CAPAQuotationDetailedQuotationItem';
                fileId?: string | null;
                fileName?: string | null;
                quantity: number;
                material?: string | null;
                cost: number;
                etc?: string | null;
              }> | null;
            } | null;
          }
        | {
            __typename?: 'CAPAQuotationChatMessageRfq';
            messageType: CapaQuotationChatMessageType;
            rfq?: {
              __typename?: 'CAPAQuotationChatRfq';
              rfqId?: string | null;
              quotationId?: string | null;
              purchaseOrderId?: string | null;
              adjustRequest?: string | null;
              event?: CapaQuotationRfqEventType | null;
              rejectedReason?: string | null;
              isVisible?: boolean | null;
              isSendRequest?: boolean | null;
              purchaseAmount?: number | null;
              expectedConfirmPurchaseDate?: string | null;
            } | null;
          }
        | {
            __typename?: 'CAPAQuotationAnnotationCommentMessage';
            messageType: CapaQuotationChatMessageType;
            annotation?: {
              __typename?: 'CAPAQuotationAnnotationComment';
              id?: string | null;
              annotationId?: string | null;
              fileId?: string | null;
              userId?: string | null;
              isParent?: boolean | null;
              comment?: string | null;
              userName?: string | null;
              status?: CapaQuotationSharedFileAnnotationStatus | null;
              edited?: boolean | null;
              createdAt?: string | null;
              updatedAt?: string | null;
            } | null;
          }
        | {
            __typename?: 'CAPAQuotationBypassMessage';
            messageType: CapaQuotationChatMessageType;
            bypass?: {
              __typename?: 'CAPAQuotationBypassSendMessageTemplateModel';
              id?: string | null;
            } | null;
          }
        | {
            __typename?: 'CAPAQuotationBypassMessageDeleteMessage';
            messageType: CapaQuotationChatMessageType;
            id?: string | null;
          }
        | null;
      chatFiles?: Array<{
        __typename?: 'CAPAQuotationChatFile';
        fileId?: string | null;
        fileName?: string | null;
        fileSize?: number | null;
      }> | null;
    }> | null;
  };
};

export type ReadQuotationChatMessageMutationVariables = Exact<{
  chatRoomId: Scalars['String'];
}>;

export type ReadQuotationChatMessageMutation = {
  __typename?: 'Mutation';
  readQuotationChatMessage: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type SendQuotationChatMessageMutationVariables = Exact<{
  input: SendQuotationChatMessageInput;
}>;

export type SendQuotationChatMessageMutation = {
  __typename?: 'Mutation';
  sendQuotationChatMessage: {
    __typename?: 'CAPAQuotationChatRoomOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAQuotationChatRoom';
      chatRoomId?: string | null;
      chatRoomStatus?: CapaQuotationChatRoomStatus | null;
    } | null;
  };
};

export type QuitQuotationChatRoomMutationVariables = Exact<{
  chatRoomId: Scalars['String'];
}>;

export type QuitQuotationChatRoomMutation = {
  __typename?: 'Mutation';
  quitQuotationChatRoom: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type ChangeChatRoomStatusOpenMutationVariables = Exact<{
  input: ChangeChatRoomStatusInput;
}>;

export type ChangeChatRoomStatusOpenMutation = {
  __typename?: 'Mutation';
  changeChatRoomStatusOpen: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type ChangeQuotationMessageInvisibleMutationVariables = Exact<{
  input: ChangeChatMessageInvisibleInput;
}>;

export type ChangeQuotationMessageInvisibleMutation = {
  __typename?: 'Mutation';
  changeQuotationMessageInvisible: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type FetchQuotationChatRoomSharedFilesQueryVariables = Exact<{
  input: FetchQuotationChatRoomSharedFilesInput;
}>;

export type FetchQuotationChatRoomSharedFilesQuery = {
  __typename?: 'Query';
  fetchQuotationChatRoomSharedFiles: {
    __typename?: 'CAPAQuotationChatRoomSharedFilesOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: Array<{
      __typename?: 'CAPAQuotationChatRoomSharedFiles';
      fileId?: string | null;
      fileName?: string | null;
      quotationSharedFileId?: string | null;
      quotationSharedFileSize?: number | null;
      quotationSharedFileType?: CapaQuotationChatRoomSharedFileType | null;
      annotationStatus?: CapaQuotationChatRoomSharedFileAnnotationStatus | null;
    }> | null;
  };
};

export type DeleteQuotationChatMessageMutationVariables = Exact<{
  input: DeleteQuotationChatMessageInput;
}>;

export type DeleteQuotationChatMessageMutation = {
  __typename?: 'Mutation';
  deleteQuotationChatMessage: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type UpdateBypassChatComplaintMutationVariables = Exact<{
  input: UpdateReceiveComplaintQuotationChatMessageInput;
}>;

export type UpdateBypassChatComplaintMutation = {
  __typename?: 'Mutation';
  updateBypassChatComplaint: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type FetchMyDriveQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
}>;

export type FetchMyDriveQuery = {
  __typename?: 'Query';
  fetchMyDrive: {
    __typename?: 'CAPAMyDrivesOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: Array<{
      __typename?: 'CAPAMyDrive';
      oldFileId?: string | null;
      fileId: string;
      fileName: string;
      fileSize: number;
      status?: CapaFileConvertStatus | null;
      thumbnails?: string | null;
      viewerUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
  };
};

export type RegisterCloudUserMutationVariables = Exact<{
  [key: string]: never;
}>;

export type RegisterCloudUserMutation = {
  __typename?: 'Mutation';
  registerCloudUser: {
    __typename?: 'AuthenticationOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'Authentication';
      accessToken: string;
      refreshToken: string;
      redirectUrl?: string | null;
      tokenType: string;
      expiresIn: number;
    } | null;
  };
};

export type FetchConnectUserQueryVariables = Exact<{ [key: string]: never }>;

export type FetchConnectUserQuery = {
  __typename?: 'Query';
  fetchConnectUser: {
    __typename?: 'CAPAConnectUserOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAConnectUser';
      id: string;
      email: string;
      userName?: string | null;
      usedSize: number;
      availSize: number;
      driveSize: number;
      serviceAgreed?: boolean | null;
      privacyAgreed?: boolean | null;
      promotionAgreed?: boolean | null;
      notificationFilter: {
        __typename?: 'CAPAConnectUserNotificationFilter';
        chatPush?: boolean | null;
        groupPush?: boolean | null;
        groupEmail?: boolean | null;
        commentThreadPush?: boolean | null;
        commentThreadEmail?: boolean | null;
        filePush?: boolean | null;
        fileEmail?: boolean | null;
      };
    } | null;
  };
};

export type FetchConnectMyDriveQueryVariables = Exact<{
  input: FetchConnectMyDriveInput;
}>;

export type FetchConnectMyDriveQuery = {
  __typename?: 'Query';
  fetchConnectMyDrive: {
    __typename?: 'CAPAConnectMyDrivesOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAConnectMyDrive';
      files?: Array<{
        __typename?: 'CAPAConnectMyFile';
        id?: string | null;
        filePath: string;
        fileName: string;
        isFile: boolean;
        isShared: boolean;
        fileSize?: number | null;
        originalFileExt?: string | null;
        status?: CapaFileConvertStatus | null;
        fileId?: string | null;
        thumbnail?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      }> | null;
      path?: Array<{
        __typename?: 'CAPAConnectFolder';
        folderName: string;
      }> | null;
    } | null;
  };
};

export type CheckRegisteredCapaServiceQueryVariables = Exact<{
  emails: Array<Scalars['String']> | Scalars['String'];
}>;

export type CheckRegisteredCapaServiceQuery = {
  __typename?: 'Query';
  checkRegisteredCapaService: {
    __typename?: 'RegisteredCapaServicesOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: Array<{
      __typename?: 'RegisteredCapaService';
      scopes?: Array<CapaServiceType> | null;
    }> | null;
  };
};

export type SearchFileQueryVariables = Exact<{
  input: SearchConnectFileInput;
}>;

export type SearchFileQuery = {
  __typename?: 'Query';
  searchFile: {
    __typename?: 'CAPAConnectMyDrivesOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAConnectMyDrive';
      files?: Array<{
        __typename?: 'CAPAConnectMyFile';
        id?: string | null;
        filePath: string;
        fileName: string;
        isFile: boolean;
        isShared: boolean;
        fileSize?: number | null;
        originalFileExt?: string | null;
        status?: CapaFileConvertStatus | null;
        fileId?: string | null;
        thumbnail?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      }> | null;
      path?: Array<{
        __typename?: 'CAPAConnectFolder';
        folderName: string;
      }> | null;
    } | null;
  };
};

export type RegisterConnectUserMutationVariables = Exact<{
  input: RegisterConnectUserInput;
}>;

export type RegisterConnectUserMutation = {
  __typename?: 'Mutation';
  registerConnectUser: {
    __typename?: 'AuthenticationOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'Authentication';
      accessToken: string;
      tokenType: string;
      expiresIn: number;
      refreshToken: string;
      redirectUrl?: string | null;
    } | null;
  };
};

export type UpdateConnectUserMutationVariables = Exact<{
  input: UpdateConnectUserInput;
}>;

export type UpdateConnectUserMutation = {
  __typename?: 'Mutation';
  updateConnectUser: {
    __typename?: 'CAPAConnectUserOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAConnectUser';
      id: string;
      userName?: string | null;
      usedSize: number;
      availSize: number;
      driveSize: number;
      serviceAgreed?: boolean | null;
      privacyAgreed?: boolean | null;
      promotionAgreed?: boolean | null;
      notificationFilter: {
        __typename?: 'CAPAConnectUserNotificationFilter';
        chatPush?: boolean | null;
        groupPush?: boolean | null;
        groupEmail?: boolean | null;
        commentThreadPush?: boolean | null;
        commentThreadEmail?: boolean | null;
        filePush?: boolean | null;
        fileEmail?: boolean | null;
      };
    } | null;
  };
};

export type FetchQuotationUserRfqsQueryVariables = Exact<{
  input: FetchQuotationUserRfqsInput;
}>;

export type FetchQuotationUserRfqsQuery = {
  __typename?: 'Query';
  fetchQuotationUserRfqs: {
    __typename?: 'CAPAQuotationUserRfqsOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAQuotationUserRfqs';
      count?: number | null;
      rfqs?: Array<{
        __typename?: 'CAPAQuotationUserRfq';
        rfqId?: string | null;
        rfqStatus?: CapaRfqStatus | null;
        projectName?: string | null;
        serviceType?: CapaQuotationServiceType | null;
        createdAt?: string | null;
        thumbnailId?: string | null;
        quantity?: number | null;
        protoQuantity?: number | null;
        uniqueViews?: number | null;
        receivedQuotationCount?: number | null;
        newQuotationCount?: number | null;
        newIntroductionCount?: number | null;
        eventType?: CapaQuotationRfqEventType | null;
        itpEventRegistered?: boolean | null;
        itpEventSent?: boolean | null;
        isItpPartner?: boolean | null;
        isTransaction?: boolean | null;
        searchProjectStatusTypeEnum?: ProjectStatusType | null;
      }> | null;
    } | null;
  };
};

export type FetchMyReceivedQuotationsQueryVariables = Exact<{
  input: FetchMyReceivedQuotationsInput;
}>;

export type FetchMyReceivedQuotationsQuery = {
  __typename?: 'Query';
  fetchMyReceivedQuotations: {
    __typename?: 'CAPAQuotationMyReceivedQuotationsOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: Array<{
      __typename?: 'CAPAQuotationMyReceivedQuotation';
      rfqId?: string | null;
      quotationId?: string | null;
      quotationType?: CapaRfqQuotationType | null;
      partnerId?: string | null;
      chatRoomId?: string | null;
      chatRoomStatus?: CapaQuotationChatRoomStatus | null;
      chatRoomCreatedAt?: string | null;
      profileId?: string | null;
      organizationName?: string | null;
      confirmCount?: number | null;
      cost?: number | null;
      deliveryCost?: number | null;
      createdAt?: string | null;
      read?: boolean | null;
      isAdjusted?: boolean | null;
      isTransaction?: boolean | null;
      quotationPartnerStatus?: CapaQuotationPartnerStatus | null;
      rfqReceivedType?: CapaRfqReceivedType | null;
      purchaseOrderStatus?: CapaPurchaseOrderStatus | null;
      satisfactioPoint?: number | null;
      reviewCnt?: number | null;
    }> | null;
  };
};

export type FetchQuotationUserChatRoomsQueryVariables = Exact<{
  input?: InputMaybe<FetchQuotationUserChatRoomsInput>;
}>;

export type FetchQuotationUserChatRoomsQuery = {
  __typename?: 'Query';
  fetchQuotationUserChatRooms: {
    __typename?: 'CAPAQuotationUserChatRoomsOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAQuotationUserChatRooms';
      totalChatRoomsCount?: number | null;
      currentChatRoomCount?: number | null;
      totalUnReadMessagesCount?: Array<{
        __typename?: 'CAPAQuotationUserUnReadMessagesCount';
        chatRoomFilter?: CapaQuotationChatRoomsFilterType | null;
        total?: number | null;
      }> | null;
      chatRooms?: Array<{
        __typename?: 'CAPAQuotationUserChatRoom';
        chatRoomId?: string | null;
        chatRoomStatus?: CapaQuotationChatRoomStatus | null;
        rfqId?: string | null;
        isOldRfq?: boolean | null;
        profileId?: string | null;
        projectName?: string | null;
        organizationName?: string | null;
        serviceType?: CapaQuotationServiceType | null;
        thumbnailId?: string | null;
        quotationPartnerId?: string | null;
        quotationPartnerStatus?: string | null;
        unReadCount?: number | null;
        lastMessageCreatedAt?: string | null;
        rfqStatus?: CapaRfqStatus | null;
        rfqCreatedAt?: string | null;
        managerName?: string | null;
        shortAddress?: string | null;
        purchaseOrderStatus?: CapaPurchaseOrderStatus | null;
        searchProjectStatusTypeEnum?: ProjectStatusType | null;
        quantity?: string | null;
        lastMessage?:
          | {
              __typename?: 'CAPAQuotationChatMessageMessage';
              messageType: CapaQuotationChatMessageType;
              message?: string | null;
            }
          | {
              __typename?: 'CAPAQuotationChatMessageSimpleQuotation';
              messageType: CapaQuotationChatMessageType;
              quotation?: {
                __typename?: 'CAPAQuotationSimpleQuotation';
                quotation?: number | null;
                excludeDeliveryFee?: boolean | null;
                etc?: string | null;
              } | null;
            }
          | {
              __typename?: 'CAPAQuotationChatMessageDetailedQuotation';
              messageType: CapaQuotationChatMessageType;
              quotation?: {
                __typename?: 'CAPAQuotationDetailedQuotation';
                rfqId: string;
                projectName?: string | null;
                serviceType?: CapaQuotationServiceType | null;
                dueDate?: string | null;
                expiration?: string | null;
                quotation?: number | null;
                deliveryCost?: number | null;
                createdAt?: string | null;
                maxDraftModificationCount?: number | null;
                draftModificationTerms?: string | null;
                etc?: string | null;
                optionalServices?: Array<{
                  __typename?: 'CAPAQuotationRfqQuotationOptionalService';
                  serviceType?: CapaQuotationServiceType | null;
                }> | null;
                publish?: {
                  __typename?: 'CAPAQuotationDetailedQuotationPublish';
                  organizationName?: string | null;
                } | null;
                supply?: {
                  __typename?: 'CAPAQuotationDetailedQuotationSupply';
                  quotationPartnerStatus?: CapaQuotationPartnerStatus | null;
                  quotationPartnerId: string;
                  organizationName?: string | null;
                  companyRegistrationNumber?: number | null;
                  managerName?: string | null;
                  address?: string | null;
                } | null;
                items?: Array<{
                  __typename?: 'CAPAQuotationDetailedQuotationItem';
                  fileId?: string | null;
                  fileName?: string | null;
                  quantity: number;
                  material?: string | null;
                  cost: number;
                  etc?: string | null;
                }> | null;
              } | null;
            }
          | {
              __typename?: 'CAPAQuotationChatMessageRfq';
              messageType: CapaQuotationChatMessageType;
              rfq?: {
                __typename?: 'CAPAQuotationChatRfq';
                rfqId?: string | null;
                quotationId?: string | null;
                purchaseOrderId?: string | null;
                projectName?: string | null;
                userManagerName?: string | null;
                userOrganizationName?: string | null;
                partnerManagerName?: string | null;
                partnerOrganizationName?: string | null;
                adjustRequest?: string | null;
                event?: CapaQuotationRfqEventType | null;
                rejectedReason?: string | null;
                isVisible?: boolean | null;
              } | null;
            }
          | {
              __typename?: 'CAPAQuotationAnnotationCommentMessage';
              messageType: CapaQuotationChatMessageType;
              annotation?: {
                __typename?: 'CAPAQuotationAnnotationComment';
                id?: string | null;
                annotationId?: string | null;
                fileId?: string | null;
                userId?: string | null;
                isParent?: boolean | null;
                comment?: string | null;
                userName?: string | null;
                status?: CapaQuotationSharedFileAnnotationStatus | null;
                edited?: boolean | null;
                createdAt?: string | null;
                updatedAt?: string | null;
              } | null;
            }
          | {
              __typename?: 'CAPAQuotationBypassMessage';
              messageType: CapaQuotationChatMessageType;
              bypass?: {
                __typename?: 'CAPAQuotationBypassSendMessageTemplateModel';
                id?: string | null;
              } | null;
            }
          | {
              __typename?: 'CAPAQuotationBypassMessageDeleteMessage';
              messageType: CapaQuotationChatMessageType;
              id?: string | null;
            }
          | null;
      }> | null;
    } | null;
  };
};

export type RegisterItpEventMutationVariables = Exact<{
  input: RegisterItpEventInput;
}>;

export type RegisterItpEventMutation = {
  __typename?: 'Mutation';
  registerItpEvent: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type RegisterJsbEventMutationVariables = Exact<{
  input: RegisterJsbEventInput;
}>;

export type RegisterJsbEventMutation = {
  __typename?: 'Mutation';
  registerJsbEvent: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type FetchQuotationUserGnbQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FetchQuotationUserGnbQuery = {
  __typename?: 'Query';
  fetchQuotationUserGNB: {
    __typename?: 'CAPAQuotationUserGNBOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAQuotationUserGNB';
      newChatCount: number;
      newQuotationAndIntroductionCount: number;
      newPaymentManagementCount?: number | null;
    } | null;
  };
};

export type WriteUserActivityLogMutationVariables = Exact<{
  input: UserActivityLogInput;
}>;

export type WriteUserActivityLogMutation = {
  __typename?: 'Mutation';
  writeUserActivityLog: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type GetNoticeScheduleBoQueryVariables = Exact<{ [key: string]: never }>;

export type GetNoticeScheduleBoQuery = {
  __typename?: 'Query';
  getNoticeScheduleBO: {
    __typename?: 'NoticeScheduleOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'NoticeSchedule';
      id: string;
      startTime: string;
      endTime: string;
      previewStartTime?: string | null;
      previewEndTime?: string | null;
      pageType: NoticeScheduleNoticePageType;
      noticeType: NoticeScheduleNoticeType;
      status: NoticeScheduleNoticeStatus;
    } | null;
  };
};

export type FetchCapaNotificationQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FetchCapaNotificationQuery = {
  __typename?: 'Query';
  fetchCAPANotification: {
    __typename?: 'CAPANotificationsOutput';
    errorMessage?: string | null;
    result: CapaErrorCode;
    data?: {
      __typename?: 'CAPANotifications';
      count: number;
      notifications: Array<{
        __typename?: 'CAPANotification';
        seq: number;
        serviceType: CapaServiceType;
        read?: boolean | null;
        createdAt: string;
        data?:
          | {
              __typename?: 'CAPANotificationDefault';
              notificationType: CapaNotificationType;
            }
          | {
              __typename?: 'CAPANotificationRfq';
              notificationType: CapaNotificationType;
              serviceType?: CapaQuotationServiceType | null;
              rfqId?: string | null;
              projectName?: string | null;
              organizationName?: string | null;
              adjustRequest?: string | null;
              totalAmount?: string | null;
              managerName?: string | null;
              chatRoomId?: string | null;
              refundAmt?: number | null;
              depositAmt?: number | null;
            }
          | { __typename?: 'CAPANotificationConnect' }
          | null;
      }>;
    } | null;
  };
};

export type SubscribeCapaNotificationSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type SubscribeCapaNotificationSubscription = {
  __typename?: 'Subscription';
  subscribeCAPANotification: {
    __typename?: 'CAPASubscribeNotificationsOutput';
    errorMessage?: string | null;
    result: CapaErrorCode;
    data?: { __typename?: 'CAPASubscribeNotifications'; count: number } | null;
  };
};

export type ReadNotificationMutationVariables = Exact<{
  seq?: InputMaybe<Scalars['Float']>;
}>;

export type ReadNotificationMutation = {
  __typename?: 'Mutation';
  readNotification: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type ClearNewNotificationMutationVariables = Exact<{
  [key: string]: never;
}>;

export type ClearNewNotificationMutation = {
  __typename?: 'Mutation';
  clearNewNotification: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type FetchQuotationPartnerActivityQueryVariables = Exact<{
  quotationPartnerId?: InputMaybe<Scalars['String']>;
}>;

export type FetchQuotationPartnerActivityQuery = {
  __typename?: 'Query';
  fetchQuotationPartnerActivity: {
    __typename?: 'CAPAQuotationActivityOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAQuotationActivity';
      complete?: number | null;
      confirmed?: number | null;
    } | null;
  };
};

export type FetchWithdrawnQuotationPartnerQueryVariables = Exact<{
  quotationPartnerId: Scalars['String'];
}>;

export type FetchWithdrawnQuotationPartnerQuery = {
  __typename?: 'Query';
  fetchWithdrawnQuotationPartner: {
    __typename?: 'CAPAQuotationPartnerStrategyOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAQuotationPartnerStrategy';
      id: string;
      status: CapaQuotationPartnerStatus;
      organizationName?: string | null;
      fullAddress?: string | null;
      shortAddress?: string | null;
      companyRegistrationNumber: string;
      companyIntroduction?: string | null;
      foundedIn?: string | null;
      numberEmployees?: string | null;
      serviceHours?: string | null;
      managerName: string;
      department?: string | null;
      position?: string | null;
      contact?: string | null;
      rfqFilter?: string | null;
      serviceAgreed?: boolean | null;
      privacyAgreed?: boolean | null;
      promotionAgreed?: boolean | null;
      referralUserId?: string | null;
      isItp: boolean;
      createdAt: string;
      updatedAt: string;
      factoryAddress?: string | null;
      averageResponseTime?: string | null;
      transactionCount?: number | null;
      partnerPageViewCount?: number | null;
      haveSubmall: boolean;
      capabilities?: {
        __typename?: 'CAPAQuotationPartnerCapability';
        services?: Array<{
          __typename?: 'CAPAQuotationService';
          service?: CapaQuotationServiceType | null;
          status: CapaCapabilitiesStatusType;
          optionalServices?: Array<CapaQuotationServiceType> | null;
          detailedServices?: Array<{
            __typename?: 'CAPAQuotationDetailedService';
            type?: CapaQuotationDetailedServiceType | null;
            materials?: Array<{
              __typename?: 'CAPAQuotationDetailedMaterial';
              detailedMaterials?: Array<
                CapaQuotationDetailedMaterialType
              > | null;
            }> | null;
          }> | null;
        }> | null;
      } | null;
      notificationFilter: {
        __typename?: 'CAPAQuotationPartnerNotificationFilter';
        chatEmail?: boolean | null;
        chatSMS?: boolean | null;
        chatPush?: boolean | null;
        rfqEmail?: boolean | null;
        rfqSMS?: boolean | null;
        rfqPush?: boolean | null;
        projectEmail?: boolean | null;
        projectSMS?: boolean | null;
        newsEmail?: boolean | null;
        newsSMS?: boolean | null;
        capabilityFilters?: Array<{
          __typename?: 'CAPAQuotationCapabilityNotificationFilter';
          email?: boolean | null;
          sms?: boolean | null;
          push?: boolean | null;
          service?: CapaQuotationServiceType | null;
          detailedServices?: Array<CapaQuotationDetailedServiceType> | null;
          optionalServices?: Array<CapaQuotationServiceType> | null;
        }> | null;
        doNotDisturb?: {
          __typename?: 'CAPADoNotDisturbFilter';
          isActive?: boolean | null;
          to?: number | null;
          from?: number | null;
        } | null;
        projectFilters?: Array<{
          __typename?: 'CAPARfqProjectFilter';
          email?: boolean | null;
          sms?: boolean | null;
          service?: CapaRfqProjectManagementType | null;
        }> | null;
      };
      logo?: {
        __typename?: 'CAPAQuotationPartnerStrategyFile';
        id: string;
        fileId?: string | null;
        fileName?: string | null;
        fileType?: CapaQuotationPartnerStrategyFileType | null;
        fileMimetype?: string | null;
        fileSize?: string | null;
        fileExtension?: string | null;
      } | null;
      cover?: {
        __typename?: 'CAPAQuotationPartnerStrategyFile';
        id: string;
        fileId?: string | null;
        fileName?: string | null;
        fileType?: CapaQuotationPartnerStrategyFileType | null;
        fileMimetype?: string | null;
        fileSize?: string | null;
        fileExtension?: string | null;
      } | null;
      partnerFiles?: Array<{
        __typename?: 'CAPAQuotationPartnerStrategyFile';
        id: string;
        fileId?: string | null;
        fileName?: string | null;
        fileType?: CapaQuotationPartnerStrategyFileType | null;
        fileMimetype?: string | null;
        fileSize?: string | null;
        fileExtension?: string | null;
        videoThumbnailFileId?: string | null;
        youtubeURL?: string | null;
      }> | null;
      portfolios?: Array<{
        __typename?: 'CAPAQuotationPartnerPortfolio';
        id: string;
        projectName: string;
        client?: string | null;
        description?: string | null;
        projectPurpose?: Array<CapaQuotationProductPurpose> | null;
        productType?: string | null;
        quantity?: number | null;
        produceStep?: CapaQuotationPartnerImagePortfolioProduceStepType | null;
        capabilities?: Array<{
          __typename?: 'CAPAQuotationPartnerPortfolioService';
          service?: CapaQuotationServiceType | null;
          detailedServices?: Array<CapaQuotationDetailedServiceType> | null;
        }> | null;
        files: Array<{
          __typename?: 'CAPAQuotationPartnerStrategyFile';
          id: string;
          fileId?: string | null;
          fileName?: string | null;
          fileType?: CapaQuotationPartnerStrategyFileType | null;
          fileMimetype?: string | null;
          fileSize?: string | null;
          fileExtension?: string | null;
        }>;
      }> | null;
      equipments?: Array<{
        __typename?: 'CAPAQuotationPartnerEquipment';
        id: string;
        equipmentName: string;
        quantity: number;
        description?: string | null;
        createdAt?: string | null;
        file?: {
          __typename?: 'CAPAQuotationPartnerStrategyFile';
          id: string;
          fileId?: string | null;
          fileName?: string | null;
          fileType?: CapaQuotationPartnerStrategyFileType | null;
          fileMimetype?: string | null;
          fileSize?: string | null;
          fileExtension?: string | null;
        } | null;
      }> | null;
      certifications?: Array<{
        __typename?: 'CAPAQuotationPartnerTechnologyModel';
        id: string;
        quotationPartnerId: string;
        strategyFileId?: string | null;
        technicalName?: string | null;
        certificationAuthority?: string | null;
        expirationPeriodStart?: string | null;
        expirationPeriodEnd?: string | null;
        description?: string | null;
        technologyType: CapaQuotationPartnerTechnologyType;
        file?: {
          __typename?: 'CAPAQuotationPartnerStrategyFile';
          id: string;
          fileId?: string | null;
          fileName?: string | null;
          fileType?: CapaQuotationPartnerStrategyFileType | null;
          fileMimetype?: string | null;
          fileSize?: string | null;
          fileExtension?: string | null;
        } | null;
      }> | null;
      patents?: Array<{
        __typename?: 'CAPAQuotationPartnerTechnologyModel';
        id: string;
        quotationPartnerId: string;
        strategyFileId?: string | null;
        technicalName?: string | null;
        certificationAuthority?: string | null;
        expirationPeriodStart?: string | null;
        expirationPeriodEnd?: string | null;
        description?: string | null;
        technologyType: CapaQuotationPartnerTechnologyType;
        file?: {
          __typename?: 'CAPAQuotationPartnerStrategyFile';
          id: string;
          fileId?: string | null;
          fileName?: string | null;
          fileType?: CapaQuotationPartnerStrategyFileType | null;
          fileMimetype?: string | null;
          fileSize?: string | null;
          fileExtension?: string | null;
        } | null;
      }> | null;
      promotionModels?: Array<{
        __typename?: 'CAPAPromotionModel';
        id?: string | null;
        quotationPartnerId: string;
        capaBlogLink: string;
        status: CapaPromotionStatus;
      }> | null;
      registrations: Array<{
        __typename?: 'CAPAQuotationPartnerStrategyFile';
        id: string;
        fileId?: string | null;
        videoThumbnailFileId?: string | null;
      }>;
    } | null;
  };
};

export type FetchQuotationPartnerQueryVariables = Exact<{
  quotationPartnerId: Scalars['String'];
}>;

export type FetchQuotationPartnerQuery = {
  __typename?: 'Query';
  fetchQuotationPartner: {
    __typename?: 'CAPAQuotationPartnerStrategyOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAQuotationPartnerStrategy';
      id: string;
      status: CapaQuotationPartnerStatus;
      organizationName?: string | null;
      fullAddress?: string | null;
      shortAddress?: string | null;
      companyRegistrationNumber: string;
      companyIntroduction?: string | null;
      foundedIn?: string | null;
      numberEmployees?: string | null;
      serviceHours?: string | null;
      managerName: string;
      department?: string | null;
      position?: string | null;
      contact?: string | null;
      rfqFilter?: string | null;
      serviceAgreed?: boolean | null;
      privacyAgreed?: boolean | null;
      promotionAgreed?: boolean | null;
      referralUserId?: string | null;
      isItp: boolean;
      createdAt: string;
      updatedAt: string;
      factoryAddress?: string | null;
      averageResponseTime?: string | null;
      transactionCount?: number | null;
      partnerPageViewCount?: number | null;
      haveSubmall: boolean;
      capabilities?: {
        __typename?: 'CAPAQuotationPartnerCapability';
        services?: Array<{
          __typename?: 'CAPAQuotationService';
          service?: CapaQuotationServiceType | null;
          status: CapaCapabilitiesStatusType;
          optionalServices?: Array<CapaQuotationServiceType> | null;
          detailedServices?: Array<{
            __typename?: 'CAPAQuotationDetailedService';
            type?: CapaQuotationDetailedServiceType | null;
            materials?: Array<{
              __typename?: 'CAPAQuotationDetailedMaterial';
              detailedMaterials?: Array<
                CapaQuotationDetailedMaterialType
              > | null;
            }> | null;
          }> | null;
        }> | null;
      } | null;
      notificationFilter: {
        __typename?: 'CAPAQuotationPartnerNotificationFilter';
        chatEmail?: boolean | null;
        chatSMS?: boolean | null;
        chatPush?: boolean | null;
        rfqEmail?: boolean | null;
        rfqSMS?: boolean | null;
        rfqPush?: boolean | null;
        projectEmail?: boolean | null;
        projectSMS?: boolean | null;
        newsEmail?: boolean | null;
        newsSMS?: boolean | null;
        capabilityFilters?: Array<{
          __typename?: 'CAPAQuotationCapabilityNotificationFilter';
          email?: boolean | null;
          sms?: boolean | null;
          push?: boolean | null;
          service?: CapaQuotationServiceType | null;
          detailedServices?: Array<CapaQuotationDetailedServiceType> | null;
          optionalServices?: Array<CapaQuotationServiceType> | null;
        }> | null;
        doNotDisturb?: {
          __typename?: 'CAPADoNotDisturbFilter';
          isActive?: boolean | null;
          to?: number | null;
          from?: number | null;
        } | null;
        projectFilters?: Array<{
          __typename?: 'CAPARfqProjectFilter';
          email?: boolean | null;
          sms?: boolean | null;
          service?: CapaRfqProjectManagementType | null;
        }> | null;
      };
      logo?: {
        __typename?: 'CAPAQuotationPartnerStrategyFile';
        id: string;
        fileId?: string | null;
        fileName?: string | null;
        fileType?: CapaQuotationPartnerStrategyFileType | null;
        fileMimetype?: string | null;
        fileSize?: string | null;
        fileExtension?: string | null;
      } | null;
      cover?: {
        __typename?: 'CAPAQuotationPartnerStrategyFile';
        id: string;
        fileId?: string | null;
        fileName?: string | null;
        fileType?: CapaQuotationPartnerStrategyFileType | null;
        fileMimetype?: string | null;
        fileSize?: string | null;
        fileExtension?: string | null;
      } | null;
      partnerFiles?: Array<{
        __typename?: 'CAPAQuotationPartnerStrategyFile';
        id: string;
        fileId?: string | null;
        fileName?: string | null;
        fileType?: CapaQuotationPartnerStrategyFileType | null;
        fileMimetype?: string | null;
        fileSize?: string | null;
        fileExtension?: string | null;
        videoThumbnailFileId?: string | null;
        youtubeURL?: string | null;
      }> | null;
      portfolios?: Array<{
        __typename?: 'CAPAQuotationPartnerPortfolio';
        id: string;
        projectName: string;
        client?: string | null;
        description?: string | null;
        projectPurpose?: Array<CapaQuotationProductPurpose> | null;
        productType?: string | null;
        quantity?: number | null;
        produceStep?: CapaQuotationPartnerImagePortfolioProduceStepType | null;
        capabilities?: Array<{
          __typename?: 'CAPAQuotationPartnerPortfolioService';
          service?: CapaQuotationServiceType | null;
          detailedServices?: Array<CapaQuotationDetailedServiceType> | null;
        }> | null;
        files: Array<{
          __typename?: 'CAPAQuotationPartnerStrategyFile';
          id: string;
          fileId?: string | null;
          fileName?: string | null;
          fileType?: CapaQuotationPartnerStrategyFileType | null;
          fileMimetype?: string | null;
          fileSize?: string | null;
          fileExtension?: string | null;
        }>;
      }> | null;
      equipments?: Array<{
        __typename?: 'CAPAQuotationPartnerEquipment';
        id: string;
        equipmentName: string;
        quantity: number;
        description?: string | null;
        createdAt?: string | null;
        file?: {
          __typename?: 'CAPAQuotationPartnerStrategyFile';
          id: string;
          fileId?: string | null;
          fileName?: string | null;
          fileType?: CapaQuotationPartnerStrategyFileType | null;
          fileMimetype?: string | null;
          fileSize?: string | null;
          fileExtension?: string | null;
        } | null;
      }> | null;
      certifications?: Array<{
        __typename?: 'CAPAQuotationPartnerTechnologyModel';
        id: string;
        quotationPartnerId: string;
        strategyFileId?: string | null;
        technicalName?: string | null;
        certificationAuthority?: string | null;
        expirationPeriodStart?: string | null;
        expirationPeriodEnd?: string | null;
        description?: string | null;
        technologyType: CapaQuotationPartnerTechnologyType;
        file?: {
          __typename?: 'CAPAQuotationPartnerStrategyFile';
          id: string;
          fileId?: string | null;
          fileName?: string | null;
          fileType?: CapaQuotationPartnerStrategyFileType | null;
          fileMimetype?: string | null;
          fileSize?: string | null;
          fileExtension?: string | null;
        } | null;
      }> | null;
      patents?: Array<{
        __typename?: 'CAPAQuotationPartnerTechnologyModel';
        id: string;
        quotationPartnerId: string;
        strategyFileId?: string | null;
        technicalName?: string | null;
        certificationAuthority?: string | null;
        expirationPeriodStart?: string | null;
        expirationPeriodEnd?: string | null;
        description?: string | null;
        technologyType: CapaQuotationPartnerTechnologyType;
        file?: {
          __typename?: 'CAPAQuotationPartnerStrategyFile';
          id: string;
          fileId?: string | null;
          fileName?: string | null;
          fileType?: CapaQuotationPartnerStrategyFileType | null;
          fileMimetype?: string | null;
          fileSize?: string | null;
          fileExtension?: string | null;
        } | null;
      }> | null;
      promotionModels?: Array<{
        __typename?: 'CAPAPromotionModel';
        id?: string | null;
        quotationPartnerId: string;
        capaBlogLink: string;
        status: CapaPromotionStatus;
      }> | null;
      registrations: Array<{
        __typename?: 'CAPAQuotationPartnerStrategyFile';
        id: string;
        fileId?: string | null;
        videoThumbnailFileId?: string | null;
      }>;
      reviews?: {
        __typename?: 'CAPAQuotationPartnerRfqReviewResult';
        reviewAveragePoint?: number | null;
        reviewCount?: number | null;
        reviewPointRatio?: {
          __typename?: 'CAPAReviewPointRatio';
          one: number;
          two: number;
          three: number;
          four: number;
          five: number;
        } | null;
        reviews?: Array<{
          __typename?: 'CAPARfqReview';
          id: string;
          projectName: string;
          organizationName?: string | null;
          profileId?: string | null;
          managerName?: string | null;
          isEditable: boolean;
          reviewComment: string;
          reviewPoint: number;
          serviceType: CapaQuotationServiceType;
          reviewFileCount?: number | null;
          indueDate: boolean;
          reviewedAt?: string | null;
          purchaseOrderValue: number;
          reviewFiles?: Array<{
            __typename?: 'CAPARfqReviewFile';
            fileId?: string | null;
            fileName?: string | null;
          }> | null;
        }> | null;
      } | null;
    } | null;
  };
};

export type FetchRfqPartnerEvaluationQueryVariables = Exact<{
  quotationPartnerId?: InputMaybe<Scalars['String']>;
}>;

export type FetchRfqPartnerEvaluationQuery = {
  __typename?: 'Query';
  fetchRfqPartnerEvaluation: {
    __typename?: 'CAPAQuotationRfqPartnerEvaluationOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAQuotationRfqPartnerEvaluation';
      kind?: number | null;
      quick?: number | null;
      detailed?: number | null;
      helpful?: number | null;
    } | null;
  };
};

export type SendSystemChatMessageMutationVariables = Exact<{
  input: SendSystemChatMessageInput;
}>;

export type SendSystemChatMessageMutation = {
  __typename?: 'Mutation';
  sendSystemChatMessage: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type DelayConfirmEscrowPurchaseMutationVariables = Exact<{
  input: DelayConfirmEscrowPurchaseInput;
}>;

export type DelayConfirmEscrowPurchaseMutation = {
  __typename?: 'Mutation';
  delayConfirmEscrowPurchase: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type CreatePaymentAfterCreatePurchaseOrderMutationVariables = Exact<{
  input: CreatePaymentInput;
}>;

export type CreatePaymentAfterCreatePurchaseOrderMutation = {
  __typename?: 'Mutation';
  createPaymentAfterCreatePurchaseOrder: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type FetchMyRefundBankAccountsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FetchMyRefundBankAccountsQuery = {
  __typename?: 'Query';
  fetchMyRefundBankAccounts: {
    __typename?: 'CAPAQuotationUserRefundBankAccountModelsOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: Array<{
      __typename?: 'CAPAQuotationUserRefundBankAccountModel';
      id: string;
      quotationUserId: string;
      seq: number;
      bankCode: CapaBankCode;
      account: string;
      holderName: string;
      holderPhone: string;
      createdAt: string;
      updatedAt: string;
    }> | null;
  };
};

export type FetchMyPaymentDataByQuotationUserQueryVariables = Exact<{
  input: FetchPaymentManageByQuotationUserIdInput;
}>;

export type FetchMyPaymentDataByQuotationUserQuery = {
  __typename?: 'Query';
  fetchMyPaymentDataByQuotationUser: {
    __typename?: 'CAPAQuotationPaymentManageModelOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAQuotationPaymentManage';
      estimatedAmount?: number | null;
      completionAmount?: number | null;
      totalCount?: number | null;
      point?: number | null;
      purchaseOrderInfoList?: Array<{
        __typename?: 'CAPAPurchaseOrderModel';
        purchaseOrderId?: string | null;
        purchaseOrderStatus: CapaPurchaseOrderStatus;
        partnerOrganizationName?: string | null;
        partnerManagerName?: string | null;
        partnerFullAddress?: string | null;
        partnerLogoFileId?: string | null;
        clientOrganizationName?: string | null;
        clientFullAddress?: string | null;
        clientLogoFileId?: string | null;
        clientManagerName?: string | null;
        projectPurchaseOrderManageStatusType?: ProjectPurchaseOrderManageStatusType | null;
        rfqCreatedAt?: string | null;
        serviceType: CapaQuotationServiceType;
        projectName?: string | null;
        quantity?: number | null;
        paymentManageModelList?: Array<{
          __typename?: 'CAPAQuotationPaymentManageModel';
          id: string;
          quotationId: string;
          quotationUserId: string;
          quotationPartnerUserId: string;
          quotationPartnerId: string;
          rfqId: string;
          purchaseOrderId?: string | null;
          totalAmount: number;
          commission?: number | null;
          paymentMethod: CapaPaymentMethodType;
          status: CapaPaymentStatus;
          isRead: boolean;
          virtualAccountId?: string | null;
          paidAt?: string | null;
          confirmedAt?: string | null;
          capaUsageFee?: number | null;
          pgUsageFee?: number | null;
          payOut?: number | null;
          cancelId?: string | null;
          cancelStatus?: CapaPaymentCancelStatus | null;
          cancelAmount?: number | null;
          cancelReason?: string | null;
          cancelConfirmedAt?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          thumbnailId?: string | null;
          chatRoomId?: string | null;
          virtualBankCode?: CapaBankCode | null;
          virtualAccountNumber?: string | null;
          hasReview: boolean;
          extendReason?: string | null;
          registerExpectedDate?: string | null;
          extendedPurchaseConfirmDate?: string | null;
          cardNumber?: string | null;
          cardName?: string | null;
        }> | null;
      }> | null;
    } | null;
  };
};

export type CreateMyRefundAccountByQuotationUserMutationVariables = Exact<{
  input: CreateMyRefundAccountInput;
}>;

export type CreateMyRefundAccountByQuotationUserMutation = {
  __typename?: 'Mutation';
  createMyRefundAccountByQuotationUser: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type DeleteMyRefundAccountByQuotationUserMutationVariables = Exact<{
  input: DeleteMyRefundAccountInput;
}>;

export type DeleteMyRefundAccountByQuotationUserMutation = {
  __typename?: 'Mutation';
  deleteMyRefundAccountByQuotationUser: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type CanEditRefundAccountQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CanEditRefundAccountQuery = {
  __typename?: 'Query';
  canEditRefundAccount: {
    __typename?: 'CAPACanEditRefundAccountOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CanEditRefundAccountModel';
      canEditRefundAccount: boolean;
    } | null;
  };
};

export type PurchaseOrderModelFragment = {
  __typename?: 'CAPAPurchaseOrderModel';
  purchaseOrderId?: string | null;
  purchaseOrderStatus: CapaPurchaseOrderStatus;
  partnerOrganizationName?: string | null;
  partnerManagerName?: string | null;
  partnerFullAddress?: string | null;
  partnerLogoFileId?: string | null;
  clientOrganizationName?: string | null;
  clientFullAddress?: string | null;
  clientLogoFileId?: string | null;
  clientManagerName?: string | null;
  projectPurchaseOrderManageStatusType?: ProjectPurchaseOrderManageStatusType | null;
  rfqCreatedAt?: string | null;
  serviceType: CapaQuotationServiceType;
  projectName?: string | null;
  quantity?: number | null;
  paymentManageModelList?: Array<{
    __typename?: 'CAPAQuotationPaymentManageModel';
    id: string;
    quotationId: string;
    quotationUserId: string;
    quotationPartnerUserId: string;
    quotationPartnerId: string;
    rfqId: string;
    purchaseOrderId?: string | null;
    totalAmount: number;
    commission?: number | null;
    paymentMethod: CapaPaymentMethodType;
    status: CapaPaymentStatus;
    isRead: boolean;
    virtualAccountId?: string | null;
    paidAt?: string | null;
    confirmedAt?: string | null;
    capaUsageFee?: number | null;
    pgUsageFee?: number | null;
    payOut?: number | null;
    cancelId?: string | null;
    cancelStatus?: CapaPaymentCancelStatus | null;
    cancelAmount?: number | null;
    cancelReason?: string | null;
    cancelConfirmedAt?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    thumbnailId?: string | null;
    chatRoomId?: string | null;
    virtualBankCode?: CapaBankCode | null;
    virtualAccountNumber?: string | null;
    hasReview: boolean;
    extendReason?: string | null;
    registerExpectedDate?: string | null;
    extendedPurchaseConfirmDate?: string | null;
    cardNumber?: string | null;
    cardName?: string | null;
  }> | null;
};

export type CreatePurchaseOrderMutationVariables = Exact<{
  input: CreatePurchaseOrderInput;
}>;

export type CreatePurchaseOrderMutation = {
  __typename?: 'Mutation';
  createPurchaseOrder: {
    __typename?: 'CAPAQuotationCreatePurchaseOrderOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAQuotationCreatePurchaseOrder';
      purchaseOrderId: string;
    } | null;
  };
};

export type FetchPurchaseOrdersQueryVariables = Exact<{
  input: FetchPurchaseOrdersInput;
}>;

export type FetchPurchaseOrdersQuery = {
  __typename?: 'Query';
  fetchPurchaseOrders: {
    __typename?: 'CAPAQuotationRfqPurchaseOrdersOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: Array<{
      __typename?: 'CAPAQuotationRfqPurchaseOrder';
      id: string;
      rfqId: string;
      chatRoomId?: string | null;
      latest?: boolean | null;
      quotation?: number | null;
      deliveryCost?: number | null;
      maxDraftModificationCount?: number | null;
      draftModificationTerms?: string | null;
      inspectionPeriod?: number | null;
      shipDate?: string | null;
      shipAddress?: string | null;
      shipDetailAddress?: string | null;
      read?: boolean | null;
      isConfirmed?: boolean | null;
      isRejected?: boolean | null;
      createdAt?: string | null;
      quotationCreatedAt?: string | null;
      status: CapaPurchaseOrderStatus;
      paymentAmount?: number | null;
      receiver?: {
        __typename?: 'CAPAQuotationRfqPurchaseOrderReceiver';
        quotationPartnerStatus: CapaQuotationPartnerStatus;
        quotationPartnerId: string;
        organizationName?: string | null;
        managerName?: string | null;
        companyRegistrationNumber?: string | null;
      } | null;
      publish?: {
        __typename?: 'CAPAQuotationRfqPurchaseOrderPublish';
        quotationUserStatus?: CapaQuotationUserStatus | null;
        organizationName?: string | null;
        managerName?: string | null;
        companyRegistrationNumber?: string | null;
      } | null;
      pcb?: {
        __typename?: 'CAPAPcbDetail';
        fabricationQuantity?: number | null;
        assemblyQuantity?: number | null;
        metalMaskAvailablity?: boolean | null;
        materialSupplyMethod?: CapaRfqPcbMaterialSupplyMethodType | null;
        services?: Array<{
          __typename?: 'CAPAPcbService';
          serviceType?: CapaPcbServiceType | null;
        }> | null;
        fabricationFiles?: Array<{
          __typename?: 'CAPAQuotationRfqFabricationFile';
          fileId: string;
          fileName: string;
          quantity: number;
          thickness: number;
          fileSize?: number | null;
        }> | null;
        assemblyFiles?: Array<{
          __typename?: 'CAPAQuotationRfqAssemblyFile';
          fileId: string;
          fileName: string;
          quantity: number;
          fileSize?: number | null;
        }> | null;
        assemblyMethod?: Array<{
          __typename?: 'CAPARfqPcbassemblyMethod';
          methodType?: CapaRfqPcbAssemblyMethodType | null;
        }> | null;
      } | null;
      items?: Array<{
        __typename?: 'CAPAQuotationDetailedQuotationItem';
        fileId?: string | null;
        fileName?: string | null;
        quantity: number;
        material?: string | null;
        cost: number;
        etc?: string | null;
      }> | null;
      pcbFabricationItems?: Array<{
        __typename?: 'CAPAQuotationDetailedPcbFabricationItem';
        fileId?: string | null;
        fileName?: string | null;
        quantity: number;
        thickness?: number | null;
        cost: number;
        etc?: string | null;
      }> | null;
      pcbAssemblyItems?: Array<{
        __typename?: 'CAPAQuotationDetailedPcbAssemblyItem';
        fileId?: string | null;
        fileName?: string | null;
        quantity: number;
        cost: number;
        etc?: string | null;
      }> | null;
      inspections?: Array<{
        __typename?: 'CAPAQuotationRfqPurchaseOrderInspection';
        inspectionType?: CapaRfqPurchaseOrderInspectionType | null;
        inspectionRequest?: string | null;
      }> | null;
      transfer?: {
        __typename?: 'CAPARfqPurchaseOrderTransfer';
        transferTerms?: CapaRfqPurchaseOrderTransferTermsType | null;
        transferStorage?: number | null;
      } | null;
      payments?: Array<{
        __typename?: 'CAPAQuotationRfqPurchaseOrderProvision';
        provisionDate?: string | null;
        provisionCost?: number | null;
        provisionPercent?: number | null;
        provisionType?: CapaRfqPurchaseOrderPaymentProvisionType | null;
        provisionEtc?: string | null;
      }> | null;
      adjustRequest?: {
        __typename?: 'CAPARfqAdjustRequestObject';
        read?: boolean | null;
        message?: string | null;
      } | null;
      paymentCancelData?: {
        __typename?: 'FetchPurchaseOrderPaymentCancelData';
        amount: number;
        reason?: string | null;
      } | null;
      paymentDataList?: Array<{
        __typename?: 'FetchPurchaseOrderPaymentData';
        quotationId: string;
        quotationUserId: string;
        quotationPartnerUserId: string;
        quotationPartnerId: string;
        rfqId: string;
        purchaseOrderId?: string | null;
        totalAmount: number;
        pgProvider: CapapgProviders;
        paymentMethod: CapaPaymentMethodType;
        createdAt: string;
        paidAt?: string | null;
        confirmedAt?: string | null;
        virtualAccount?: {
          __typename?: 'VirtualAccountInfo';
          accountNumber: string;
          bankCode: CapaBankCode;
          bankName: string;
          bankHolder?: string | null;
          dueDate: number;
          issuedAt: number;
        } | null;
        cardInfo?: {
          __typename?: 'CAPAPaymentCardInfo';
          cardCode: string;
          cardName: string;
          cardQuota: number;
          cardNumber?: string | null;
          cardType: number;
        } | null;
      }> | null;
      shippingDataList?: Array<{
        __typename?: 'ShippingDataModel';
        id: string;
        shippingCompany?: string | null;
        invoiceNumber?: string | null;
        isExtended: boolean;
        extendReason?: string | null;
        isRegistered: boolean;
        registerExpectedDate: string;
        extendedPurchaseConfirmDate: string;
      }> | null;
    }> | null;
  };
};

export type UpdatePurchaseOrderStatusMutationVariables = Exact<{
  input: UpdatePurchaseOrderStatusInput;
}>;

export type UpdatePurchaseOrderStatusMutation = {
  __typename?: 'Mutation';
  updatePurchaseOrderStatus: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type ReadRfqQuotationMutationVariables = Exact<{
  input: ReadRfqQuotationInput;
}>;

export type ReadRfqQuotationMutation = {
  __typename?: 'Mutation';
  readRfqQuotation: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type RequestAdjustRfqQuotationMutationVariables = Exact<{
  input: RequestAdjustRfqQuotationInput;
}>;

export type RequestAdjustRfqQuotationMutation = {
  __typename?: 'Mutation';
  requestAdjustRfqQuotation: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type ConfirmRfqQuotationMutationVariables = Exact<{
  input: ConfirmRfqQuotationInput;
}>;

export type ConfirmRfqQuotationMutation = {
  __typename?: 'Mutation';
  confirmRfqQuotation: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type FetchRfqQuotationPdfQueryVariables = Exact<{
  input?: InputMaybe<RequestRfqQuotationPdfInput>;
}>;

export type FetchRfqQuotationPdfQuery = {
  __typename?: 'Query';
  fetchRfqQuotationPdf: {
    __typename?: 'CAPAQuotationDetailedQuotationOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAQuotationDetailedQuotation';
      id: string;
      rfqId: string;
      chatRoomId?: string | null;
      projectName?: string | null;
      serviceType?: CapaQuotationServiceType | null;
      dueDate?: string | null;
      expiration?: string | null;
      quotation?: number | null;
      deliveryCost?: number | null;
      createdAt?: string | null;
      maxDraftModificationCount?: number | null;
      draftModificationTerms?: string | null;
      read?: boolean | null;
      isConfirmed?: boolean | null;
      etc?: string | null;
      optionalServices?: Array<{
        __typename?: 'CAPAQuotationRfqQuotationOptionalService';
        serviceType?: CapaQuotationServiceType | null;
      }> | null;
      publish?: {
        __typename?: 'CAPAQuotationDetailedQuotationPublish';
        organizationName?: string | null;
      } | null;
      supply?: {
        __typename?: 'CAPAQuotationDetailedQuotationSupply';
        quotationPartnerStatus?: CapaQuotationPartnerStatus | null;
        quotationPartnerId: string;
        organizationName?: string | null;
        companyRegistrationNumber?: number | null;
        managerName?: string | null;
        address?: string | null;
      } | null;
      pcbFabricationItems?: Array<{
        __typename?: 'CAPAQuotationDetailedPcbFabricationItem';
        fileId?: string | null;
        fileName?: string | null;
        quantity: number;
        thickness?: number | null;
        cost: number;
        etc?: string | null;
      }> | null;
      pcbAssemblyItems?: Array<{
        __typename?: 'CAPAQuotationDetailedPcbAssemblyItem';
        fileId?: string | null;
        fileName?: string | null;
        quantity: number;
        cost: number;
        etc?: string | null;
      }> | null;
      items?: Array<{
        __typename?: 'CAPAQuotationDetailedQuotationItem';
        fileId?: string | null;
        fileName?: string | null;
        quantity: number;
        material?: string | null;
        cost: number;
        etc?: string | null;
      }> | null;
      adjustRequest?: {
        __typename?: 'CAPARfqAdjustRequestObject';
        read?: boolean | null;
        message?: string | null;
      } | null;
    } | null;
  };
};

export type RegisterRequestRfqQuotationMutationVariables = Exact<{
  input: RegisterRequestRfqQuotationInput;
}>;

export type RegisterRequestRfqQuotationMutation = {
  __typename?: 'Mutation';
  registerRequestRfqQuotation: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type ReadRfqAdjustRequestMutationVariables = Exact<{
  input: ReadRfqAdjustRequestInput;
}>;

export type ReadRfqAdjustRequestMutation = {
  __typename?: 'Mutation';
  readRfqAdjustRequest: {
    __typename?: 'Output';
    errorMessage?: string | null;
    result: CapaErrorCode;
  };
};

export type FetchQuotationServiceUserRatingQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FetchQuotationServiceUserRatingQuery = {
  __typename?: 'Query';
  fetchQuotationServiceUserRating: {
    __typename?: 'CAPAQuotationServiceRatingOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAQuotationServiceRating';
      rated: boolean;
      rating?: number | null;
      comment?: string | null;
    } | null;
  };
};

export type RateQuotationServiceUserMutationVariables = Exact<{
  input: QuotationServiceRatingInput;
}>;

export type RateQuotationServiceUserMutation = {
  __typename?: 'Mutation';
  rateQuotationServiceUser: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type EvaluateRfqPartnersMutationVariables = Exact<{
  input: EvaluateRfqPartnersInput;
}>;

export type EvaluateRfqPartnersMutation = {
  __typename?: 'Mutation';
  evaluateRfqPartners: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type FetchQuotationUserRfqDetailQueryVariables = Exact<{
  rfqId: Scalars['String'];
}>;

export type FetchQuotationUserRfqDetailQuery = {
  __typename?: 'Query';
  fetchQuotationUserRfqDetail: {
    __typename?: 'CAPAQuotationUserRfqDetailOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAQuotationUserRfqDetail';
      id: string;
      status?: CapaRfqStatus | null;
      projectName?: string | null;
      dueDate?: string | null;
      detailedRequest?: string | null;
      serviceType?: CapaQuotationServiceType | null;
      detailedServiceType?: CapaQuotationDetailedServiceType | null;
      dueNegotiable?: boolean | null;
      maxEstimatedBudget?: number | null;
      minEstimatedBudget?: number | null;
      budgetOpen?: boolean | null;
      projectPurpose?: CapaQuotationProductPurpose | null;
      projectPurposeDetail?: string | null;
      publicOpen?: boolean | null;
      eventType?: CapaQuotationRfqEventType | null;
      manufacturingStage?: CapaRfqManufacturingStage | null;
      isOldRfq?: boolean | null;
      createdAt: string;
      consultingStartMethod?: CapaConsultingStartMethod | null;
      chatRoom?: Array<{
        __typename?: 'CAPAQuotationChatRoom';
        chatRoomId?: string | null;
        chatRoomStatus?: CapaQuotationChatRoomStatus | null;
        rfqId?: string | null;
        chatMessagesCount?: number | null;
        quotationPartnerId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      }> | null;
      review?: {
        __typename?: 'CAPAQuotationRfqReview';
        dueDate?: number | null;
        quality?: number | null;
        publicComment?: string | null;
        privateComment?: string | null;
        replyComment?: string | null;
        repliedAt?: string | null;
      } | null;
      pcb?: {
        __typename?: 'CAPAPcbDetail';
        fabricationQuantity?: number | null;
        assemblyQuantity?: number | null;
        metalMaskAvailablity?: boolean | null;
        materialSupplyMethod?: CapaRfqPcbMaterialSupplyMethodType | null;
        services?: Array<{
          __typename?: 'CAPAPcbService';
          serviceType?: CapaPcbServiceType | null;
        }> | null;
        fabricationFiles?: Array<{
          __typename?: 'CAPAQuotationRfqFabricationFile';
          fileSize?: number | null;
          fileId: string;
          fileName: string;
          thickness: number;
          quantity: number;
        }> | null;
        assemblyFiles?: Array<{
          __typename?: 'CAPAQuotationRfqAssemblyFile';
          fileSize?: number | null;
          fileId: string;
          fileName: string;
          quantity: number;
        }> | null;
        assemblyMethod?: Array<{
          __typename?: 'CAPARfqPcbassemblyMethod';
          methodType?: CapaRfqPcbAssemblyMethodType | null;
        }> | null;
      } | null;
      design?: {
        __typename?: 'CAPADesignDetail';
        services?: Array<{
          __typename?: 'CAPADesignService';
          serviceType?: CapaDesignServiceType | null;
        }> | null;
      } | null;
      optionalServices?: Array<{
        __typename?: 'CAPAQuotationOptionalService';
        serviceType?: CapaQuotationServiceType | null;
        quantity?: number | null;
      }> | null;
      drawingFiles?: Array<{
        __typename?: 'CAPAQuotationRfqDrawingFile';
        fileSize?: number | null;
        fileId: string;
        fileName?: string | null;
        quantity?: number | null;
        material?: CapaQuotationMaterial | null;
        detailedMaterial?: CapaQuotationDetailedMaterialType | null;
        etc?: string | null;
        recommendation?: Array<CapaQuotationRecommendation> | null;
      }> | null;
      referenceFiles?: Array<{
        __typename?: 'CAPAQuotationRfqReferenceFile';
        fileSize?: number | null;
        fileId: string;
        fileName: string;
      }> | null;
      itpEvent?: {
        __typename?: 'CAPAItpEventBO';
        id?: string | null;
        projectName?: string | null;
        quotationUserId?: string | null;
        quotationUserName?: string | null;
        quotationPartnerOrganizationName?: string | null;
        completeCost?: string | null;
        approvedAt?: string | null;
        approvedById?: string | null;
        approvedByName?: string | null;
        sentAt?: string | null;
        sentById?: string | null;
        sentByName?: string | null;
        files?: Array<{
          __typename?: 'CAPAFile';
          fileSize?: number | null;
          fileId: string;
          fileName?: string | null;
          fileExtension?: string | null;
          fileMimetype?: string | null;
          status?: CapaFileConvertStatus | null;
          oldFileId?: string | null;
        }> | null;
      } | null;
      jsbEvent?: {
        __typename?: 'CAPAJsbEventBO';
        id?: string | null;
        projectName?: string | null;
        quotationUserId?: string | null;
        quotationUserName?: string | null;
        quotationPartnerOrganizationName?: string | null;
        completeCost?: string | null;
        approvedAt?: string | null;
        approvedById?: string | null;
        approvedByName?: string | null;
        files?: Array<{
          __typename?: 'CAPAFile';
          fileSize?: number | null;
          fileId: string;
          fileName?: string | null;
          fileExtension?: string | null;
          fileMimetype?: string | null;
          status?: CapaFileConvertStatus | null;
          oldFileId?: string | null;
        }> | null;
      } | null;
      transaction?: {
        __typename?: 'CAPAQuotationRfqTransaction';
        rfqId: string;
        quotationPartnerId: string;
        transactionComplete?: boolean | null;
        completeCost?: number | null;
        completeAt?: string | null;
        isItp?: boolean | null;
        organizationName?: string | null;
      } | null;
    } | null;
  };
};

export type FetchRfqDetailQueryVariables = Exact<{
  rfqId: Scalars['String'];
}>;

export type FetchRfqDetailQuery = {
  __typename?: 'Query';
  fetchRfqDetail: {
    __typename?: 'CAPAQuotationRfqDetailOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAQuotationRfqDetail';
      id: string;
      status?: CapaRfqStatus | null;
      projectName?: string | null;
      dueDate?: string | null;
      detailedRequest?: string | null;
      serviceType?: CapaQuotationServiceType | null;
      detailedServiceType?: CapaQuotationDetailedServiceType | null;
      dueNegotiable?: boolean | null;
      maxEstimatedBudget?: number | null;
      minEstimatedBudget?: number | null;
      budgetOpen?: boolean | null;
      projectPurpose?: CapaQuotationProductPurpose | null;
      projectPurposeDetail?: string | null;
      publicOpen?: boolean | null;
      eventType?: CapaQuotationRfqEventType | null;
      manufacturingStage?: CapaRfqManufacturingStage | null;
      favorite?: boolean | null;
      canDownload?: boolean | null;
      createdAt: string;
      isOldRfq?: boolean | null;
      optionalServices?: Array<{
        __typename?: 'CAPAQuotationOptionalService';
        serviceType?: CapaQuotationServiceType | null;
        quantity?: number | null;
      }> | null;
      pcb?: {
        __typename?: 'CAPAPcbDetail';
        fabricationQuantity?: number | null;
        assemblyQuantity?: number | null;
        metalMaskAvailablity?: boolean | null;
        materialSupplyMethod?: CapaRfqPcbMaterialSupplyMethodType | null;
        services?: Array<{
          __typename?: 'CAPAPcbService';
          serviceType?: CapaPcbServiceType | null;
        }> | null;
        fabricationFiles?: Array<{
          __typename?: 'CAPAQuotationRfqFabricationFile';
          fileSize?: number | null;
          fileId: string;
          fileName: string;
          thickness: number;
          quantity: number;
        }> | null;
        assemblyFiles?: Array<{
          __typename?: 'CAPAQuotationRfqAssemblyFile';
          fileSize?: number | null;
          fileId: string;
          fileName: string;
          quantity: number;
        }> | null;
        assemblyMethod?: Array<{
          __typename?: 'CAPARfqPcbassemblyMethod';
          methodType?: CapaRfqPcbAssemblyMethodType | null;
        }> | null;
      } | null;
      drawingFiles?: Array<{
        __typename?: 'CAPAQuotationRfqDrawingFile';
        fileSize?: number | null;
        fileId: string;
        fileName?: string | null;
        quantity?: number | null;
        material?: CapaQuotationMaterial | null;
        detailedMaterial?: CapaQuotationDetailedMaterialType | null;
        etc?: string | null;
        recommendation?: Array<CapaQuotationRecommendation> | null;
      }> | null;
      referenceFiles?: Array<{
        __typename?: 'CAPAQuotationRfqReferenceFile';
        fileSize?: number | null;
        fileId: string;
        fileName: string;
      }> | null;
      transaction?: {
        __typename?: 'CAPAQuotationRfqTransaction';
        rfqId: string;
        quotationPartnerId: string;
        transactionComplete?: boolean | null;
        completeCost?: number | null;
        completeAt?: string | null;
      } | null;
      owner?: {
        __typename?: 'CAPAQuotationUser';
        id: string;
        status: CapaQuotationUserStatus;
        managerName?: string | null;
        shortAddress?: string | null;
        bizType?: CapaQuotationUserBizType | null;
        organizationName?: string | null;
        companyIntroduction?: string | null;
        website?: string | null;
        department?: string | null;
        createdAt: string;
        updatedAt: string;
        files?: Array<{
          __typename?: 'CAPAQuotationUserFile';
          fileId?: string | null;
          fileName?: string | null;
          fileType?: CapaQuotationUserFileType | null;
        }> | null;
      } | null;
      quotation?: {
        __typename?: 'CAPAQuotationRfqQuotation';
        id: string;
        rfqId?: string | null;
        messageId?: string | null;
        quotationPartnerId?: string | null;
        quotation: number;
        excludeDeliveryFee?: boolean | null;
      } | null;
      chatRoom?: {
        __typename?: 'CAPAQuotationChatRoom';
        rfqId?: string | null;
        chatRoomId?: string | null;
        chatRoomStatus?: CapaQuotationChatRoomStatus | null;
        quotationPartnerId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        chatMessages?: Array<{
          __typename?: 'CAPAQuotationChatMessage';
          id?: string | null;
          senderId?: string | null;
          senderUserType?: CapaQuotationUserType | null;
          organizationName?: string | null;
          managerName?: string | null;
          profileId?: string | null;
          unReadCount?: number | null;
          createdAt?: string | null;
          chatFiles?: Array<{
            __typename?: 'CAPAQuotationChatFile';
            fileSize?: number | null;
            fileId?: string | null;
            fileName?: string | null;
          }> | null;
        }> | null;
      } | null;
    } | null;
  };
};

export type FetchRfqPartnersQueryVariables = Exact<{
  rfqId: Scalars['String'];
}>;

export type FetchRfqPartnersQuery = {
  __typename?: 'Query';
  fetchRfqPartners: {
    __typename?: 'CAPAQuotationRfqPartnersOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: Array<{
      __typename?: 'CAPAQuotationRfqPartner';
      quotationPartnerId: string;
      organizationName?: string | null;
      profileId?: string | null;
      hasEvaluated?: boolean | null;
      permission?: CapaQuotationRfqAllowOpenFileStatus | null;
      downloaded?: boolean | null;
      chatRoomId: string;
    }> | null;
  };
};

export type FetchDetailedQuotationQueryVariables = Exact<{
  input: FetchDetailedQuotationInput;
}>;

export type FetchDetailedQuotationQuery = {
  __typename?: 'Query';
  fetchDetailedQuotation: {
    __typename?: 'CAPAQuotationDetailedQuotationOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAQuotationDetailedQuotation';
      id: string;
      rfqId: string;
      type: CapaRfqQuotationType;
      latest?: boolean | null;
      chatRoomId?: string | null;
      projectName?: string | null;
      serviceType?: CapaQuotationServiceType | null;
      dueDate?: string | null;
      expiration?: string | null;
      quotation?: number | null;
      deliveryCost?: number | null;
      createdAt?: string | null;
      maxDraftModificationCount?: number | null;
      draftModificationTerms?: string | null;
      read?: boolean | null;
      isConfirmed?: boolean | null;
      etc?: string | null;
      optionalServices?: Array<{
        __typename?: 'CAPAQuotationRfqQuotationOptionalService';
        serviceType?: CapaQuotationServiceType | null;
      }> | null;
      publish?: {
        __typename?: 'CAPAQuotationDetailedQuotationPublish';
        organizationName?: string | null;
      } | null;
      supply?: {
        __typename?: 'CAPAQuotationDetailedQuotationSupply';
        quotationPartnerStatus?: CapaQuotationPartnerStatus | null;
        quotationPartnerId: string;
        organizationName?: string | null;
        companyRegistrationNumber?: number | null;
        managerName?: string | null;
        address?: string | null;
      } | null;
      items?: Array<{
        __typename?: 'CAPAQuotationDetailedQuotationItem';
        fileId?: string | null;
        fileName?: string | null;
        quantity: number;
        material?: string | null;
        cost: number;
        etc?: string | null;
      }> | null;
      pcbFabricationItems?: Array<{
        __typename?: 'CAPAQuotationDetailedPcbFabricationItem';
        fileId?: string | null;
        fileName?: string | null;
        quantity: number;
        thickness?: number | null;
        cost: number;
        etc?: string | null;
      }> | null;
      pcbAssemblyItems?: Array<{
        __typename?: 'CAPAQuotationDetailedPcbAssemblyItem';
        fileId?: string | null;
        fileName?: string | null;
        quantity: number;
        cost: number;
        etc?: string | null;
      }> | null;
      adjustRequest?: {
        __typename?: 'CAPARfqAdjustRequestObject';
        read?: boolean | null;
        message?: string | null;
      } | null;
    } | null;
  };
};

export type FetchMyRfqQuotationsQueryVariables = Exact<{
  input: FetchMyRfqQuotationsInput;
}>;

export type FetchMyRfqQuotationsQuery = {
  __typename?: 'Query';
  fetchMyRfqQuotations: {
    __typename?: 'CAPAQuotationDetailedQuotationsOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: Array<{
      __typename?: 'CAPAQuotationDetailedQuotation';
      id: string;
      rfqId: string;
      chatRoomId?: string | null;
      type: CapaRfqQuotationType;
      latest?: boolean | null;
      projectName?: string | null;
      serviceType?: CapaQuotationServiceType | null;
      dueDate?: string | null;
      expiration?: string | null;
      quotation?: number | null;
      deliveryCost?: number | null;
      createdAt?: string | null;
      maxDraftModificationCount?: number | null;
      draftModificationTerms?: string | null;
      read?: boolean | null;
      isConfirmed?: boolean | null;
      etc?: string | null;
      isBeforeConsulting?: boolean | null;
      optionalServices?: Array<{
        __typename?: 'CAPAQuotationRfqQuotationOptionalService';
        serviceType?: CapaQuotationServiceType | null;
      }> | null;
      publish?: {
        __typename?: 'CAPAQuotationDetailedQuotationPublish';
        organizationName?: string | null;
      } | null;
      supply?: {
        __typename?: 'CAPAQuotationDetailedQuotationSupply';
        quotationPartnerStatus?: CapaQuotationPartnerStatus | null;
        quotationPartnerId: string;
        organizationName?: string | null;
        companyRegistrationNumber?: number | null;
        managerName?: string | null;
        phone?: string | null;
        address?: string | null;
      } | null;
      items?: Array<{
        __typename?: 'CAPAQuotationDetailedQuotationItem';
        fileId?: string | null;
        fileName?: string | null;
        quantity: number;
        material?: string | null;
        cost: number;
        etc?: string | null;
      }> | null;
      pcbFabricationItems?: Array<{
        __typename?: 'CAPAQuotationDetailedPcbFabricationItem';
        fileId?: string | null;
        fileName?: string | null;
        quantity: number;
        thickness?: number | null;
        cost: number;
        etc?: string | null;
      }> | null;
      pcbAssemblyItems?: Array<{
        __typename?: 'CAPAQuotationDetailedPcbAssemblyItem';
        fileId?: string | null;
        fileName?: string | null;
        quantity: number;
        cost: number;
        etc?: string | null;
      }> | null;
      adjustRequest?: {
        __typename?: 'CAPARfqAdjustRequestObject';
        read?: boolean | null;
        message?: string | null;
      } | null;
    }> | null;
  };
};

export type CompleteRfqTransactionMutationVariables = Exact<{
  input: CompleteRfqTransactionInput;
}>;

export type CompleteRfqTransactionMutation = {
  __typename?: 'Mutation';
  completeRfqTransaction: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type RegisterRfqMutationVariables = Exact<{
  input: RegisterRfqInput;
}>;

export type RegisterRfqMutation = {
  __typename?: 'Mutation';
  registerRFQ: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type ExpireRfqMutationVariables = Exact<{
  rfqId: Scalars['String'];
}>;

export type ExpireRfqMutation = {
  __typename?: 'Mutation';
  expireRfq: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type AllowRfqDrawingFileDownloadMutationVariables = Exact<{
  input: AllowRfqDrawingFileDownloadInput;
}>;

export type AllowRfqDrawingFileDownloadMutation = {
  __typename?: 'Mutation';
  allowRfqDrawingFileDownload: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type SuggestServiceMutationVariables = Exact<{
  input: SuggestServiceInput;
}>;

export type SuggestServiceMutation = {
  __typename?: 'Mutation';
  suggestService: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type RequestRfqIdQueryVariables = Exact<{ [key: string]: never }>;

export type RequestRfqIdQuery = {
  __typename?: 'Query';
  requestRfqId: {
    __typename?: 'CAPAUUIDOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: { __typename?: 'CAPAUUID'; uuid: string } | null;
  };
};

export type ConfirmRfqTransactionMutationVariables = Exact<{
  input: ConfirmRfqTransactionInput;
}>;

export type ConfirmRfqTransactionMutation = {
  __typename?: 'Mutation';
  confirmRfqTransaction: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type ReviewRfqMutationVariables = Exact<{
  input: ReviewRfqInput;
}>;

export type ReviewRfqMutation = {
  __typename?: 'Mutation';
  reviewRfq: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type FetchMyRfqReviewsQueryVariables = Exact<{ [key: string]: never }>;

export type FetchMyRfqReviewsQuery = {
  __typename?: 'Query';
  fetchMyRfqReviews: {
    __typename?: 'CAPAQuotationMyRfqReviewOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: Array<{
      __typename?: 'CAPAQuotationMyRfqReview';
      rfqId: string;
      thumbnailId?: string | null;
      serviceType?: CapaQuotationServiceType | null;
      projectName?: string | null;
      organizationName?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      publicComment?: string | null;
      privateComment?: string | null;
      replyComment?: string | null;
      repliedAt?: string | null;
    }> | null;
  };
};

export type FetchPartnerRfqReviewsQueryVariables = Exact<{
  quotationPartnerId: Scalars['String'];
}>;

export type FetchPartnerRfqReviewsQuery = {
  __typename?: 'Query';
  fetchPartnerRfqReviews: {
    __typename?: 'CAPAQuotationMyRfqReviewOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: Array<{
      __typename?: 'CAPAQuotationMyRfqReview';
      rfqId: string;
      thumbnailId?: string | null;
      serviceType?: CapaQuotationServiceType | null;
      projectName?: string | null;
      organizationName?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      publicComment?: string | null;
      privateComment?: string | null;
      replyComment?: string | null;
      repliedAt?: string | null;
    }> | null;
  };
};

export type FetchMyReviewableRfqsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FetchMyReviewableRfqsQuery = {
  __typename?: 'Query';
  fetchMyReviewableRfqs: {
    __typename?: 'CAPAReviewableRfqsOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: Array<{
      __typename?: 'CAPAReviewableRfq';
      id: string;
      projectName: string;
      organizationName?: string | null;
      completeAt?: string | null;
      thumbnailId?: string | null;
    }> | null;
  };
};

export type FetchRfqReviewsQueryVariables = Exact<{ [key: string]: never }>;

export type FetchRfqReviewsQuery = {
  __typename?: 'Query';
  fetchRfqReviews: {
    __typename?: 'CAPAQuotationMyRfqReviewOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: Array<{
      __typename?: 'CAPAQuotationMyRfqReview';
      rfqId: string;
      thumbnailId?: string | null;
      serviceType?: CapaQuotationServiceType | null;
      projectName?: string | null;
      organizationName?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      publicComment?: string | null;
      privateComment?: string | null;
      replyComment?: string | null;
      repliedAt?: string | null;
      quality?: number | null;
      dueDate?: number | null;
    }> | null;
  };
};

export type FetchQuotationUserRfqReviewsQueryVariables = Exact<{
  input: FetchQuotationUserRfqReviewsInput;
}>;

export type FetchQuotationUserRfqReviewsQuery = {
  __typename?: 'Query';
  fetchQuotationUserRfqReviews: {
    __typename?: 'CAPAQuotationUserRfqReviewsOutput';
    errorMessage?: string | null;
    result: CapaErrorCode;
    data?: Array<{
      __typename?: 'CAPARfqReview';
      id: string;
      isEditable: boolean;
      projectName: string;
      organizationName?: string | null;
      managerName?: string | null;
      reviewComment: string;
      reviewPoint: number;
      serviceType: CapaQuotationServiceType;
      reviewFileCount?: number | null;
      indueDate: boolean;
      reviewedAt?: string | null;
      purchaseOrderValue: number;
      reviewFiles?: Array<{
        __typename?: 'CAPARfqReviewFile';
        fileId?: string | null;
        fileName?: string | null;
      }> | null;
    }> | null;
  };
};

export type FetchQuotationUserRfqAvailableReviewsQueryVariables = Exact<{
  input: FetchQuotationUserRfqReviewsInput;
}>;

export type FetchQuotationUserRfqAvailableReviewsQuery = {
  __typename?: 'Query';
  fetchQuotationUserRfqAvailableReviews: {
    __typename?: 'CAPAQuotationUserRfqAvailableReviewOutput';
    errorMessage?: string | null;
    result: CapaErrorCode;
    data?: {
      __typename?: 'CAPAQuotationUserRfqAvailableReviewsResult';
      availableReviewCount: number;
      rfqs: Array<{
        __typename?: 'CAPARfqAvailableReviews';
        rfqId: string;
        serviceType?: CapaQuotationServiceType | null;
        projectName: string;
        rfqCreatedAt?: string | null;
        thumbnailId?: string | null;
        reviews: Array<{
          __typename?: 'CAPAAvailableReview';
          chatRoomId: string;
          quotationPartnerId: string;
          profileId?: string | null;
          organizationName?: string | null;
          isComplete: boolean;
          purchaseOrderCreatedAt?: string | null;
        }>;
      }>;
    } | null;
  };
};

export type FetchQuotationPartnerRfqReviewQueryVariables = Exact<{
  input: FetchQuotationPartnerRfqReviewInput;
}>;

export type FetchQuotationPartnerRfqReviewQuery = {
  __typename?: 'Query';
  fetchQuotationPartnerRfqReview: {
    __typename?: 'CAPAQuotationPartnerRfqReviewOutput';
    result: CapaErrorCode;
    errorMessage?: string | null;
    data?: {
      __typename?: 'CAPAQuotationPartnerRfqReviewResult';
      reviewAveragePoint?: number | null;
      reviewCount?: number | null;
      reviewPointRatio?: {
        __typename?: 'CAPAReviewPointRatio';
        one: number;
        two: number;
        three: number;
        four: number;
        five: number;
      } | null;
      reviews?: Array<{
        __typename?: 'CAPARfqReview';
        id: string;
        projectName: string;
        organizationName?: string | null;
        profileId?: string | null;
        managerName?: string | null;
        isEditable: boolean;
        reviewComment: string;
        reviewPoint: number;
        serviceType: CapaQuotationServiceType;
        reviewFileCount?: number | null;
        indueDate: boolean;
        reviewedAt?: string | null;
        purchaseOrderValue: number;
        reviewFiles?: Array<{
          __typename?: 'CAPARfqReviewFile';
          fileId?: string | null;
          fileName?: string | null;
        }> | null;
      }> | null;
    } | null;
  };
};

export type RegisterRfqReviewMutationVariables = Exact<{
  input: RegisterRfqReviewInput;
}>;

export type RegisterRfqReviewMutation = {
  __typename?: 'Mutation';
  registerRfqReview: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type UpdateRfqReviewMutationVariables = Exact<{
  input: UpdateRfqReviewInput;
}>;

export type UpdateRfqReviewMutation = {
  __typename?: 'Mutation';
  updateRfqReview: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type FetchWithdrawnChatRoomsQueryVariables = Exact<{
  input: FetchWithdrawnChatRoomsInput;
}>;

export type FetchWithdrawnChatRoomsQuery = {
  __typename?: 'Query';
  fetchWithdrawnChatRooms: {
    __typename?: 'CAPAWithdrawnChatRoomsOutput';
    errorMessage?: string | null;
    result: CapaErrorCode;
    data?: {
      __typename?: 'CAPAWithdrawOutput';
      consultingChatRooms?:
        | {
            __typename?: 'CAPAWithdrawnUserChatRooms';
            capaServiceType: CapaServiceType;
            chatRooms?: Array<{
              __typename?: 'CAPAWithdrawnUserChatRoom';
              chatRoomId: string;
              isOldRfq?: boolean | null;
              profileId?: string | null;
              projectName?: string | null;
              organizationName?: string | null;
              thumbnailId?: string | null;
            }> | null;
          }
        | {
            __typename?: 'CAPAWithdrawnPartnerChatRooms';
            capaServiceType: CapaServiceType;
            chatRooms?: Array<{
              __typename?: 'CAPAWithdrawnPartnerChatRoom';
              rfqId?: string | null;
              organizationName?: string | null;
              managerName?: string | null;
              projectName?: string | null;
              chatRoomId: string;
              thumbnailId?: string | null;
            }> | null;
          }
        | {
            __typename?: 'CAPAWithdrawnConnectGroupChatRooms';
            capaServiceType: CapaServiceType;
            chatRooms?: Array<{
              __typename?: 'CAPAWithdrawnConnectGroupChatRoom';
              groupId: string;
              groupName: string;
              chatRoomId: string;
              thumbnail?: string | null;
              users?: Array<{
                __typename?: 'CAPAWithdrawnConnectGroupUser';
                id?: string | null;
                connectUserName?: string | null;
                isCapaUser?: boolean | null;
              }> | null;
            }> | null;
          }
        | null;
      consultingChatRoomsCount: Array<{
        __typename?: 'CAPAQuotationChatRoomsTotalCount';
        capaService?: CapaServiceType | null;
        totalCount: number;
      }>;
    } | null;
  };
};

export type WithdrawQuotationUserMutationVariables = Exact<{
  input: WithdrawQuotationUserInput;
}>;

export type WithdrawQuotationUserMutation = {
  __typename?: 'Mutation';
  withdrawQuotationUser: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export type WithdrawQuotationPartnerMutationVariables = Exact<{
  input: WithdrawQuotationPartnerInput;
}>;

export type WithdrawQuotationPartnerMutation = {
  __typename?: 'Mutation';
  withdrawQuotationPartner: {
    __typename?: 'Output';
    result: CapaErrorCode;
    errorMessage?: string | null;
  };
};

export const PurchaseOrderModelFragmentDoc = gql`
  fragment PurchaseOrderModel on CAPAPurchaseOrderModel {
    purchaseOrderId
    purchaseOrderStatus
    partnerOrganizationName
    partnerManagerName
    partnerFullAddress
    partnerLogoFileId
    clientOrganizationName
    clientFullAddress
    clientLogoFileId
    clientManagerName
    projectPurchaseOrderManageStatusType
    paymentManageModelList {
      id
      quotationId
      quotationUserId
      quotationPartnerUserId
      quotationPartnerId
      rfqId
      purchaseOrderId
      totalAmount
      commission
      paymentMethod
      status
      isRead
      virtualAccountId
      paidAt
      confirmedAt
      capaUsageFee
      pgUsageFee
      payOut
      cancelId
      cancelStatus
      cancelAmount
      cancelReason
      cancelConfirmedAt
      createdAt
      updatedAt
      thumbnailId
      chatRoomId
      virtualBankCode
      virtualAccountNumber
      hasReview
      extendReason
      registerExpectedDate
      extendedPurchaseConfirmDate
      cardNumber
      cardName
    }
    rfqCreatedAt
    serviceType
    projectName
    quantity
  }
`;
export const AuthenticateDocument = gql`
  query Authenticate(
    $email: String!
    $password: String!
    $service: CAPAServiceType!
  ) {
    authenticate(
      input: { email: $email, password: $password, service: $service }
    ) {
      data {
        accessToken
        tokenType
        expiresIn
        refreshToken
        redirectUrl
      }
      errorMessage
      result
    }
  }
`;

/**
 * __useAuthenticateQuery__
 *
 * To run a query within a React component, call `useAuthenticateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthenticateQuery({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      service: // value for 'service'
 *   },
 * });
 */
export function useAuthenticateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AuthenticateQuery,
    AuthenticateQueryVariables
  >
) {
  return Apollo.useQuery<AuthenticateQuery, AuthenticateQueryVariables>(
    AuthenticateDocument,
    baseOptions
  );
}
export function useAuthenticateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AuthenticateQuery,
    AuthenticateQueryVariables
  >
) {
  return Apollo.useLazyQuery<AuthenticateQuery, AuthenticateQueryVariables>(
    AuthenticateDocument,
    baseOptions
  );
}
export type AuthenticateQueryHookResult = ReturnType<
  typeof useAuthenticateQuery
>;
export type AuthenticateLazyQueryHookResult = ReturnType<
  typeof useAuthenticateLazyQuery
>;
export type AuthenticateQueryResult = Apollo.QueryResult<
  AuthenticateQuery,
  AuthenticateQueryVariables
>;
export const FetchMyQuotationPartnerDocument = gql`
  query fetchMyQuotationPartner {
    fetchMyQuotationPartner {
      result
      errorMessage
      data {
        id
        email
        status
        capabilities {
          services {
            service
            status
            detailedServices {
              materials {
                detailedMaterials
              }
              type
            }
            optionalServices
          }
        }
        organizationName
        fullAddress
        shortAddress
        companyRegistrationNumber
        companyIntroduction
        foundedIn
        numberEmployees
        serviceHours
        managerName
        department
        position
        contact
        notificationFilter {
          chatEmail
          chatSMS
          chatPush
          rfqEmail
          rfqSMS
          rfqPush
          capabilityFilters {
            email
            sms
            push
            service
            detailedServices
            optionalServices
          }
          doNotDisturb {
            isActive
            to
            from
          }
          projectEmail
          projectSMS
          projectFilters {
            email
            sms
            service
          }
          newsEmail
          newsSMS
        }
        rfqFilter
        serviceAgreed
        privacyAgreed
        promotionAgreed
        referralUserId
        isItp
        createdAt
        updatedAt
        logo {
          id
          fileId
          fileName
          fileType
          fileMimetype
          fileSize
          fileExtension
        }
        partnerFiles {
          id
          fileId
          fileName
          fileType
          fileMimetype
          fileSize
          fileExtension
          videoThumbnailFileId
        }
        portfolios {
          id
          projectName
          client
          description
          capabilities {
            service
            detailedServices
          }
          projectPurpose
          productType
          quantity
          produceStep
          files {
            id
            fileId
            fileName
            fileType
            fileMimetype
            fileSize
            fileExtension
          }
        }
        equipments {
          id
          equipmentName
          quantity
          description
          file {
            id
            fileId
            fileName
            fileType
            fileMimetype
            fileSize
            fileExtension
          }
          createdAt
        }
        certifications {
          id
          quotationPartnerId
          strategyFileId
          file {
            id
            fileId
            fileName
            fileType
            fileMimetype
            fileSize
            fileExtension
          }
          technicalName
          certificationAuthority
          expirationPeriodStart
          expirationPeriodEnd
          description
          technologyType
        }
        patents {
          id
          quotationPartnerId
          strategyFileId
          file {
            id
            fileId
            fileName
            fileType
            fileMimetype
            fileSize
            fileExtension
          }
          technicalName
          certificationAuthority
          expirationPeriodStart
          expirationPeriodEnd
          description
          technologyType
        }
        factoryAddress
        averageResponseTime
        transactionCount
        promotionModels {
          id
          quotationPartnerId
          capaBlogLink
          status
        }
        partnerPageViewCount
        registrations {
          id
          fileId
          videoThumbnailFileId
        }
      }
    }
  }
`;

/**
 * __useFetchMyQuotationPartnerQuery__
 *
 * To run a query within a React component, call `useFetchMyQuotationPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMyQuotationPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMyQuotationPartnerQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchMyQuotationPartnerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchMyQuotationPartnerQuery,
    FetchMyQuotationPartnerQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchMyQuotationPartnerQuery,
    FetchMyQuotationPartnerQueryVariables
  >(FetchMyQuotationPartnerDocument, baseOptions);
}
export function useFetchMyQuotationPartnerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchMyQuotationPartnerQuery,
    FetchMyQuotationPartnerQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchMyQuotationPartnerQuery,
    FetchMyQuotationPartnerQueryVariables
  >(FetchMyQuotationPartnerDocument, baseOptions);
}
export type FetchMyQuotationPartnerQueryHookResult = ReturnType<
  typeof useFetchMyQuotationPartnerQuery
>;
export type FetchMyQuotationPartnerLazyQueryHookResult = ReturnType<
  typeof useFetchMyQuotationPartnerLazyQuery
>;
export type FetchMyQuotationPartnerQueryResult = Apollo.QueryResult<
  FetchMyQuotationPartnerQuery,
  FetchMyQuotationPartnerQueryVariables
>;
export const FetchMyQuotationUserDocument = gql`
  query fetchMyQuotationUser {
    fetchMyQuotationUser {
      result
      errorMessage
      data {
        id
        email
        status
        managerName
        cellphoneNumber
        fullAddress
        shortAddress
        companyRegistrationNumber
        bizType
        notificationFilter {
          doNotDisturb {
            isActive
            from
            to
          }
          projectEmail
          projectSMS
          projectFilters {
            email
            sms
            service
          }
          chatEmail
          chatSMS
          chatPush
          newsEmail
          newsSMS
        }
        organizationName
        companyIntroduction
        website
        department
        position
        serviceAgreed
        privacyAgreed
        promotionAgreed
        paymentAgreed
        referralUserId
        createdAt
        updatedAt
        files {
          fileId
          fileName
          fileType
        }
        verificationType
        verificationName
        verificationBirthDate
        myRefundAccount {
          id
          bankCode
          account
          holderName
        }
      }
    }
  }
`;

/**
 * __useFetchMyQuotationUserQuery__
 *
 * To run a query within a React component, call `useFetchMyQuotationUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMyQuotationUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMyQuotationUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchMyQuotationUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchMyQuotationUserQuery,
    FetchMyQuotationUserQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchMyQuotationUserQuery,
    FetchMyQuotationUserQueryVariables
  >(FetchMyQuotationUserDocument, baseOptions);
}
export function useFetchMyQuotationUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchMyQuotationUserQuery,
    FetchMyQuotationUserQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchMyQuotationUserQuery,
    FetchMyQuotationUserQueryVariables
  >(FetchMyQuotationUserDocument, baseOptions);
}
export type FetchMyQuotationUserQueryHookResult = ReturnType<
  typeof useFetchMyQuotationUserQuery
>;
export type FetchMyQuotationUserLazyQueryHookResult = ReturnType<
  typeof useFetchMyQuotationUserLazyQuery
>;
export type FetchMyQuotationUserQueryResult = Apollo.QueryResult<
  FetchMyQuotationUserQuery,
  FetchMyQuotationUserQueryVariables
>;
export const FetchQuotationUserDocument = gql`
  query fetchQuotationUser($quotationUserId: String!) {
    fetchQuotationUser(quotationUserId: $quotationUserId) {
      data {
        id
        email
        status
        managerName
        cellphoneNumber
        fullAddress
        shortAddress
        companyRegistrationNumber
        bizType
        organizationName
        companyIntroduction
        website
        department
        position
        serviceAgreed
        privacyAgreed
        promotionAgreed
        referralUserId
        createdAt
        updatedAt
        files {
          fileId
          fileName
          fileType
        }
      }
      result
      errorMessage
    }
  }
`;

/**
 * __useFetchQuotationUserQuery__
 *
 * To run a query within a React component, call `useFetchQuotationUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchQuotationUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchQuotationUserQuery({
 *   variables: {
 *      quotationUserId: // value for 'quotationUserId'
 *   },
 * });
 */
export function useFetchQuotationUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchQuotationUserQuery,
    FetchQuotationUserQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchQuotationUserQuery,
    FetchQuotationUserQueryVariables
  >(FetchQuotationUserDocument, baseOptions);
}
export function useFetchQuotationUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchQuotationUserQuery,
    FetchQuotationUserQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchQuotationUserQuery,
    FetchQuotationUserQueryVariables
  >(FetchQuotationUserDocument, baseOptions);
}
export type FetchQuotationUserQueryHookResult = ReturnType<
  typeof useFetchQuotationUserQuery
>;
export type FetchQuotationUserLazyQueryHookResult = ReturnType<
  typeof useFetchQuotationUserLazyQuery
>;
export type FetchQuotationUserQueryResult = Apollo.QueryResult<
  FetchQuotationUserQuery,
  FetchQuotationUserQueryVariables
>;
export const RefreshDocument = gql`
  mutation refresh($refreshToken: String!) {
    refresh(input: { refreshToken: $refreshToken }) {
      errorMessage
      result
      data {
        accessToken
        tokenType
        expiresIn
        refreshToken
        redirectUrl
      }
    }
  }
`;
export type RefreshMutationFn = Apollo.MutationFunction<
  RefreshMutation,
  RefreshMutationVariables
>;

/**
 * __useRefreshMutation__
 *
 * To run a mutation, you first call `useRefreshMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshMutation, { data, loading, error }] = useRefreshMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RefreshMutation,
    RefreshMutationVariables
  >
) {
  return Apollo.useMutation<RefreshMutation, RefreshMutationVariables>(
    RefreshDocument,
    baseOptions
  );
}
export type RefreshMutationHookResult = ReturnType<typeof useRefreshMutation>;
export type RefreshMutationResult = Apollo.MutationResult<RefreshMutation>;
export type RefreshMutationOptions = Apollo.BaseMutationOptions<
  RefreshMutation,
  RefreshMutationVariables
>;
export const RequestReferralIdDocument = gql`
  mutation requestReferralId($service: CAPAServiceType!) {
    requestReferralId(input: { service: $service }) {
      result
      errorMessage
      data {
        referralId
      }
    }
  }
`;
export type RequestReferralIdMutationFn = Apollo.MutationFunction<
  RequestReferralIdMutation,
  RequestReferralIdMutationVariables
>;

/**
 * __useRequestReferralIdMutation__
 *
 * To run a mutation, you first call `useRequestReferralIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestReferralIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestReferralIdMutation, { data, loading, error }] = useRequestReferralIdMutation({
 *   variables: {
 *      service: // value for 'service'
 *   },
 * });
 */
export function useRequestReferralIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestReferralIdMutation,
    RequestReferralIdMutationVariables
  >
) {
  return Apollo.useMutation<
    RequestReferralIdMutation,
    RequestReferralIdMutationVariables
  >(RequestReferralIdDocument, baseOptions);
}
export type RequestReferralIdMutationHookResult = ReturnType<
  typeof useRequestReferralIdMutation
>;
export type RequestReferralIdMutationResult = Apollo.MutationResult<
  RequestReferralIdMutation
>;
export type RequestReferralIdMutationOptions = Apollo.BaseMutationOptions<
  RequestReferralIdMutation,
  RequestReferralIdMutationVariables
>;
export const RequestEmailVerificationCodeDocument = gql`
  mutation requestEmailVerificationCode(
    $email: String!
    $service: CAPAServiceType!
  ) {
    requestEmailVerificationCode(input: { email: $email, service: $service }) {
      result
      errorMessage
    }
  }
`;
export type RequestEmailVerificationCodeMutationFn = Apollo.MutationFunction<
  RequestEmailVerificationCodeMutation,
  RequestEmailVerificationCodeMutationVariables
>;

/**
 * __useRequestEmailVerificationCodeMutation__
 *
 * To run a mutation, you first call `useRequestEmailVerificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestEmailVerificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestEmailVerificationCodeMutation, { data, loading, error }] = useRequestEmailVerificationCodeMutation({
 *   variables: {
 *      email: // value for 'email'
 *      service: // value for 'service'
 *   },
 * });
 */
export function useRequestEmailVerificationCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestEmailVerificationCodeMutation,
    RequestEmailVerificationCodeMutationVariables
  >
) {
  return Apollo.useMutation<
    RequestEmailVerificationCodeMutation,
    RequestEmailVerificationCodeMutationVariables
  >(RequestEmailVerificationCodeDocument, baseOptions);
}
export type RequestEmailVerificationCodeMutationHookResult = ReturnType<
  typeof useRequestEmailVerificationCodeMutation
>;
export type RequestEmailVerificationCodeMutationResult = Apollo.MutationResult<
  RequestEmailVerificationCodeMutation
>;
export type RequestEmailVerificationCodeMutationOptions = Apollo.BaseMutationOptions<
  RequestEmailVerificationCodeMutation,
  RequestEmailVerificationCodeMutationVariables
>;
export const VerifyEmailVerificationCodeDocument = gql`
  query verifyEmailVerificationCode($email: String!, $code: String!) {
    verifyEmailVerificationCode(input: { email: $email, code: $code }) {
      result
      errorMessage
    }
  }
`;

/**
 * __useVerifyEmailVerificationCodeQuery__
 *
 * To run a query within a React component, call `useVerifyEmailVerificationCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailVerificationCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyEmailVerificationCodeQuery({
 *   variables: {
 *      email: // value for 'email'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerifyEmailVerificationCodeQuery(
  baseOptions?: Apollo.QueryHookOptions<
    VerifyEmailVerificationCodeQuery,
    VerifyEmailVerificationCodeQueryVariables
  >
) {
  return Apollo.useQuery<
    VerifyEmailVerificationCodeQuery,
    VerifyEmailVerificationCodeQueryVariables
  >(VerifyEmailVerificationCodeDocument, baseOptions);
}
export function useVerifyEmailVerificationCodeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VerifyEmailVerificationCodeQuery,
    VerifyEmailVerificationCodeQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    VerifyEmailVerificationCodeQuery,
    VerifyEmailVerificationCodeQueryVariables
  >(VerifyEmailVerificationCodeDocument, baseOptions);
}
export type VerifyEmailVerificationCodeQueryHookResult = ReturnType<
  typeof useVerifyEmailVerificationCodeQuery
>;
export type VerifyEmailVerificationCodeLazyQueryHookResult = ReturnType<
  typeof useVerifyEmailVerificationCodeLazyQuery
>;
export type VerifyEmailVerificationCodeQueryResult = Apollo.QueryResult<
  VerifyEmailVerificationCodeQuery,
  VerifyEmailVerificationCodeQueryVariables
>;
export const RegisterDocument = gql`
  mutation register($input: RegistrationInput!) {
    register(input: $input) {
      result
      errorMessage
      data {
        accessToken
        tokenType
        expiresIn
        refreshToken
        redirectUrl
      }
    }
  }
`;
export type RegisterMutationFn = Apollo.MutationFunction<
  RegisterMutation,
  RegisterMutationVariables
>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterMutation,
    RegisterMutationVariables
  >
) {
  return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(
    RegisterDocument,
    baseOptions
  );
}
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<
  RegisterMutation,
  RegisterMutationVariables
>;
export const VerifyCompanyRegistrationNumberDocument = gql`
  query verifyCompanyRegistrationNumber(
    $input: VerifyCompanyRegistrationNumberInput!
  ) {
    verifyCompanyRegistrationNumber(input: $input) {
      result
      errorMessage
    }
  }
`;

/**
 * __useVerifyCompanyRegistrationNumberQuery__
 *
 * To run a query within a React component, call `useVerifyCompanyRegistrationNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyCompanyRegistrationNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyCompanyRegistrationNumberQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyCompanyRegistrationNumberQuery(
  baseOptions?: Apollo.QueryHookOptions<
    VerifyCompanyRegistrationNumberQuery,
    VerifyCompanyRegistrationNumberQueryVariables
  >
) {
  return Apollo.useQuery<
    VerifyCompanyRegistrationNumberQuery,
    VerifyCompanyRegistrationNumberQueryVariables
  >(VerifyCompanyRegistrationNumberDocument, baseOptions);
}
export function useVerifyCompanyRegistrationNumberLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VerifyCompanyRegistrationNumberQuery,
    VerifyCompanyRegistrationNumberQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    VerifyCompanyRegistrationNumberQuery,
    VerifyCompanyRegistrationNumberQueryVariables
  >(VerifyCompanyRegistrationNumberDocument, baseOptions);
}
export type VerifyCompanyRegistrationNumberQueryHookResult = ReturnType<
  typeof useVerifyCompanyRegistrationNumberQuery
>;
export type VerifyCompanyRegistrationNumberLazyQueryHookResult = ReturnType<
  typeof useVerifyCompanyRegistrationNumberLazyQuery
>;
export type VerifyCompanyRegistrationNumberQueryResult = Apollo.QueryResult<
  VerifyCompanyRegistrationNumberQuery,
  VerifyCompanyRegistrationNumberQueryVariables
>;
export const RegisterQuotationUserDocument = gql`
  mutation registerQuotationUser($input: RegisterQuotationUserInput!) {
    registerQuotationUser(input: $input) {
      result
      errorMessage
      data {
        accessToken
        tokenType
        expiresIn
        refreshToken
        redirectUrl
      }
    }
  }
`;
export type RegisterQuotationUserMutationFn = Apollo.MutationFunction<
  RegisterQuotationUserMutation,
  RegisterQuotationUserMutationVariables
>;

/**
 * __useRegisterQuotationUserMutation__
 *
 * To run a mutation, you first call `useRegisterQuotationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterQuotationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerQuotationUserMutation, { data, loading, error }] = useRegisterQuotationUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterQuotationUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterQuotationUserMutation,
    RegisterQuotationUserMutationVariables
  >
) {
  return Apollo.useMutation<
    RegisterQuotationUserMutation,
    RegisterQuotationUserMutationVariables
  >(RegisterQuotationUserDocument, baseOptions);
}
export type RegisterQuotationUserMutationHookResult = ReturnType<
  typeof useRegisterQuotationUserMutation
>;
export type RegisterQuotationUserMutationResult = Apollo.MutationResult<
  RegisterQuotationUserMutation
>;
export type RegisterQuotationUserMutationOptions = Apollo.BaseMutationOptions<
  RegisterQuotationUserMutation,
  RegisterQuotationUserMutationVariables
>;
export const RequestResetPasswordDocument = gql`
  mutation RequestResetPassword($input: RequestResetPasswordInput!) {
    requestResetPassword(input: $input) {
      result
      errorMessage
    }
  }
`;
export type RequestResetPasswordMutationFn = Apollo.MutationFunction<
  RequestResetPasswordMutation,
  RequestResetPasswordMutationVariables
>;

/**
 * __useRequestResetPasswordMutation__
 *
 * To run a mutation, you first call `useRequestResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestResetPasswordMutation, { data, loading, error }] = useRequestResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestResetPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestResetPasswordMutation,
    RequestResetPasswordMutationVariables
  >
) {
  return Apollo.useMutation<
    RequestResetPasswordMutation,
    RequestResetPasswordMutationVariables
  >(RequestResetPasswordDocument, baseOptions);
}
export type RequestResetPasswordMutationHookResult = ReturnType<
  typeof useRequestResetPasswordMutation
>;
export type RequestResetPasswordMutationResult = Apollo.MutationResult<
  RequestResetPasswordMutation
>;
export type RequestResetPasswordMutationOptions = Apollo.BaseMutationOptions<
  RequestResetPasswordMutation,
  RequestResetPasswordMutationVariables
>;
export const ChangeEmailDocument = gql`
  mutation ChangeEmail($input: ChangeEmailInput!) {
    changeEmail(input: $input) {
      result
      errorMessage
    }
  }
`;
export type ChangeEmailMutationFn = Apollo.MutationFunction<
  ChangeEmailMutation,
  ChangeEmailMutationVariables
>;

/**
 * __useChangeEmailMutation__
 *
 * To run a mutation, you first call `useChangeEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEmailMutation, { data, loading, error }] = useChangeEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeEmailMutation,
    ChangeEmailMutationVariables
  >
) {
  return Apollo.useMutation<ChangeEmailMutation, ChangeEmailMutationVariables>(
    ChangeEmailDocument,
    baseOptions
  );
}
export type ChangeEmailMutationHookResult = ReturnType<
  typeof useChangeEmailMutation
>;
export type ChangeEmailMutationResult = Apollo.MutationResult<
  ChangeEmailMutation
>;
export type ChangeEmailMutationOptions = Apollo.BaseMutationOptions<
  ChangeEmailMutation,
  ChangeEmailMutationVariables
>;
export const ChangePasswordDocument = gql`
  mutation ChangePassword($input: ChangePasswordInput!) {
    changePassword(input: $input) {
      result
      errorMessage
    }
  }
`;
export type ChangePasswordMutationFn = Apollo.MutationFunction<
  ChangePasswordMutation,
  ChangePasswordMutationVariables
>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangePasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangePasswordMutation,
    ChangePasswordMutationVariables
  >
) {
  return Apollo.useMutation<
    ChangePasswordMutation,
    ChangePasswordMutationVariables
  >(ChangePasswordDocument, baseOptions);
}
export type ChangePasswordMutationHookResult = ReturnType<
  typeof useChangePasswordMutation
>;
export type ChangePasswordMutationResult = Apollo.MutationResult<
  ChangePasswordMutation
>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<
  ChangePasswordMutation,
  ChangePasswordMutationVariables
>;
export const UpdateQuotationUserDocument = gql`
  mutation updateQuotationUser($input: UpdateQuotationUserInput!) {
    updateQuotationUser(input: $input) {
      result
      errorMessage
      data {
        id
        email
        status
        managerName
        cellphoneNumber
        fullAddress
        shortAddress
        companyRegistrationNumber
        bizType
        organizationName
        companyIntroduction
        website
        department
        position
        serviceAgreed
        privacyAgreed
        promotionAgreed
        referralUserId
        createdAt
        updatedAt
        files {
          fileId
          fileName
          fileType
        }
      }
    }
  }
`;
export type UpdateQuotationUserMutationFn = Apollo.MutationFunction<
  UpdateQuotationUserMutation,
  UpdateQuotationUserMutationVariables
>;

/**
 * __useUpdateQuotationUserMutation__
 *
 * To run a mutation, you first call `useUpdateQuotationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuotationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuotationUserMutation, { data, loading, error }] = useUpdateQuotationUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuotationUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateQuotationUserMutation,
    UpdateQuotationUserMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdateQuotationUserMutation,
    UpdateQuotationUserMutationVariables
  >(UpdateQuotationUserDocument, baseOptions);
}
export type UpdateQuotationUserMutationHookResult = ReturnType<
  typeof useUpdateQuotationUserMutation
>;
export type UpdateQuotationUserMutationResult = Apollo.MutationResult<
  UpdateQuotationUserMutation
>;
export type UpdateQuotationUserMutationOptions = Apollo.BaseMutationOptions<
  UpdateQuotationUserMutation,
  UpdateQuotationUserMutationVariables
>;
export const SubscribeCapaNewsDocument = gql`
  mutation subscribeCAPANews($subscriberEmail: String!, $userName: String!) {
    subscribeCAPANews(
      input: { subscriberEmail: $subscriberEmail, userName: $userName }
    ) {
      result
      errorMessage
    }
  }
`;
export type SubscribeCapaNewsMutationFn = Apollo.MutationFunction<
  SubscribeCapaNewsMutation,
  SubscribeCapaNewsMutationVariables
>;

/**
 * __useSubscribeCapaNewsMutation__
 *
 * To run a mutation, you first call `useSubscribeCapaNewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeCapaNewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeCapaNewsMutation, { data, loading, error }] = useSubscribeCapaNewsMutation({
 *   variables: {
 *      subscriberEmail: // value for 'subscriberEmail'
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useSubscribeCapaNewsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubscribeCapaNewsMutation,
    SubscribeCapaNewsMutationVariables
  >
) {
  return Apollo.useMutation<
    SubscribeCapaNewsMutation,
    SubscribeCapaNewsMutationVariables
  >(SubscribeCapaNewsDocument, baseOptions);
}
export type SubscribeCapaNewsMutationHookResult = ReturnType<
  typeof useSubscribeCapaNewsMutation
>;
export type SubscribeCapaNewsMutationResult = Apollo.MutationResult<
  SubscribeCapaNewsMutation
>;
export type SubscribeCapaNewsMutationOptions = Apollo.BaseMutationOptions<
  SubscribeCapaNewsMutation,
  SubscribeCapaNewsMutationVariables
>;
export const UpdateAmbassadorSignUpPageViewCountByIpDocument = gql`
  mutation updateAmbassadorSignUpPageViewCountByIp(
    $input: UpdateAmbassadorSignUpPageViewCountByIpInput!
  ) {
    updateAmbassadorSignUpPageViewCountByIp(input: $input) {
      result
      errorMessage
    }
  }
`;
export type UpdateAmbassadorSignUpPageViewCountByIpMutationFn = Apollo.MutationFunction<
  UpdateAmbassadorSignUpPageViewCountByIpMutation,
  UpdateAmbassadorSignUpPageViewCountByIpMutationVariables
>;

/**
 * __useUpdateAmbassadorSignUpPageViewCountByIpMutation__
 *
 * To run a mutation, you first call `useUpdateAmbassadorSignUpPageViewCountByIpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmbassadorSignUpPageViewCountByIpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmbassadorSignUpPageViewCountByIpMutation, { data, loading, error }] = useUpdateAmbassadorSignUpPageViewCountByIpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAmbassadorSignUpPageViewCountByIpMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAmbassadorSignUpPageViewCountByIpMutation,
    UpdateAmbassadorSignUpPageViewCountByIpMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdateAmbassadorSignUpPageViewCountByIpMutation,
    UpdateAmbassadorSignUpPageViewCountByIpMutationVariables
  >(UpdateAmbassadorSignUpPageViewCountByIpDocument, baseOptions);
}
export type UpdateAmbassadorSignUpPageViewCountByIpMutationHookResult = ReturnType<
  typeof useUpdateAmbassadorSignUpPageViewCountByIpMutation
>;
export type UpdateAmbassadorSignUpPageViewCountByIpMutationResult = Apollo.MutationResult<
  UpdateAmbassadorSignUpPageViewCountByIpMutation
>;
export type UpdateAmbassadorSignUpPageViewCountByIpMutationOptions = Apollo.BaseMutationOptions<
  UpdateAmbassadorSignUpPageViewCountByIpMutation,
  UpdateAmbassadorSignUpPageViewCountByIpMutationVariables
>;
export const UpdateTermsDocument = gql`
  mutation updateTerms($input: UpdateCapaUserTermsInput!) {
    updateTerms(input: $input) {
      result
      errorMessage
    }
  }
`;
export type UpdateTermsMutationFn = Apollo.MutationFunction<
  UpdateTermsMutation,
  UpdateTermsMutationVariables
>;

/**
 * __useUpdateTermsMutation__
 *
 * To run a mutation, you first call `useUpdateTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTermsMutation, { data, loading, error }] = useUpdateTermsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTermsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTermsMutation,
    UpdateTermsMutationVariables
  >
) {
  return Apollo.useMutation<UpdateTermsMutation, UpdateTermsMutationVariables>(
    UpdateTermsDocument,
    baseOptions
  );
}
export type UpdateTermsMutationHookResult = ReturnType<
  typeof useUpdateTermsMutation
>;
export type UpdateTermsMutationResult = Apollo.MutationResult<
  UpdateTermsMutation
>;
export type UpdateTermsMutationOptions = Apollo.BaseMutationOptions<
  UpdateTermsMutation,
  UpdateTermsMutationVariables
>;
export const UpdateIdentityVerificationDocument = gql`
  mutation updateIdentityVerification(
    $input: UpdateIdentityVerificationInput!
  ) {
    updateIdentityVerification(input: $input) {
      result
      errorMessage
    }
  }
`;
export type UpdateIdentityVerificationMutationFn = Apollo.MutationFunction<
  UpdateIdentityVerificationMutation,
  UpdateIdentityVerificationMutationVariables
>;

/**
 * __useUpdateIdentityVerificationMutation__
 *
 * To run a mutation, you first call `useUpdateIdentityVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIdentityVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIdentityVerificationMutation, { data, loading, error }] = useUpdateIdentityVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIdentityVerificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateIdentityVerificationMutation,
    UpdateIdentityVerificationMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdateIdentityVerificationMutation,
    UpdateIdentityVerificationMutationVariables
  >(UpdateIdentityVerificationDocument, baseOptions);
}
export type UpdateIdentityVerificationMutationHookResult = ReturnType<
  typeof useUpdateIdentityVerificationMutation
>;
export type UpdateIdentityVerificationMutationResult = Apollo.MutationResult<
  UpdateIdentityVerificationMutation
>;
export type UpdateIdentityVerificationMutationOptions = Apollo.BaseMutationOptions<
  UpdateIdentityVerificationMutation,
  UpdateIdentityVerificationMutationVariables
>;
export const SubscribeQuotationUpdateDataDocument = gql`
  subscription subscribeQuotationUpdateData($chatRoomId: String!) {
    subscribeQuotationUpdateData(input: { chatRoomId: $chatRoomId }) {
      result
      errorMessage
      data {
        quotationSharedFileId
        userName
        chatRoomId
        comment
        nodeId
        anchorPos {
          x
          y
          z
        }
        handlePos {
          x
          y
          z
        }
        annotationId
        userId
        commentId
        annotationCreatedAt
        annotationUpdatedAt
        commentCreatedAt
        commentUpdatedAt
        status
        type
      }
    }
  }
`;

/**
 * __useSubscribeQuotationUpdateDataSubscription__
 *
 * To run a query within a React component, call `useSubscribeQuotationUpdateDataSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeQuotationUpdateDataSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeQuotationUpdateDataSubscription({
 *   variables: {
 *      chatRoomId: // value for 'chatRoomId'
 *   },
 * });
 */
export function useSubscribeQuotationUpdateDataSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    SubscribeQuotationUpdateDataSubscription,
    SubscribeQuotationUpdateDataSubscriptionVariables
  >
) {
  return Apollo.useSubscription<
    SubscribeQuotationUpdateDataSubscription,
    SubscribeQuotationUpdateDataSubscriptionVariables
  >(SubscribeQuotationUpdateDataDocument, baseOptions);
}
export type SubscribeQuotationUpdateDataSubscriptionHookResult = ReturnType<
  typeof useSubscribeQuotationUpdateDataSubscription
>;
export type SubscribeQuotationUpdateDataSubscriptionResult = Apollo.SubscriptionResult<
  SubscribeQuotationUpdateDataSubscription
>;
export const FetchQuotationChatRoomAnnotationCommentsDocument = gql`
  query fetchQuotationChatRoomAnnotationComments(
    $input: FetchQuotationChatRoomAnnotationCommentInput!
  ) {
    fetchQuotationChatRoomAnnotationComments(input: $input) {
      result
      errorMessage
      data {
        userId
        isNew
        commentUsers {
          userName
        }
        comments {
          id
          isParent
          comment
          userId
          userName
          status
          createdAt
        }
        annotationId
        fileName
        fileId
        lastComment
        createdAt
        updatedAt
      }
    }
  }
`;

/**
 * __useFetchQuotationChatRoomAnnotationCommentsQuery__
 *
 * To run a query within a React component, call `useFetchQuotationChatRoomAnnotationCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchQuotationChatRoomAnnotationCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchQuotationChatRoomAnnotationCommentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchQuotationChatRoomAnnotationCommentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchQuotationChatRoomAnnotationCommentsQuery,
    FetchQuotationChatRoomAnnotationCommentsQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchQuotationChatRoomAnnotationCommentsQuery,
    FetchQuotationChatRoomAnnotationCommentsQueryVariables
  >(FetchQuotationChatRoomAnnotationCommentsDocument, baseOptions);
}
export function useFetchQuotationChatRoomAnnotationCommentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchQuotationChatRoomAnnotationCommentsQuery,
    FetchQuotationChatRoomAnnotationCommentsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchQuotationChatRoomAnnotationCommentsQuery,
    FetchQuotationChatRoomAnnotationCommentsQueryVariables
  >(FetchQuotationChatRoomAnnotationCommentsDocument, baseOptions);
}
export type FetchQuotationChatRoomAnnotationCommentsQueryHookResult = ReturnType<
  typeof useFetchQuotationChatRoomAnnotationCommentsQuery
>;
export type FetchQuotationChatRoomAnnotationCommentsLazyQueryHookResult = ReturnType<
  typeof useFetchQuotationChatRoomAnnotationCommentsLazyQuery
>;
export type FetchQuotationChatRoomAnnotationCommentsQueryResult = Apollo.QueryResult<
  FetchQuotationChatRoomAnnotationCommentsQuery,
  FetchQuotationChatRoomAnnotationCommentsQueryVariables
>;
export const FetchQuotationChatRoomSpecificAnnotationsDocument = gql`
  query fetchQuotationChatRoomSpecificAnnotations(
    $input: FetchQuotationChatRoomSpecificAnnotationInput!
  ) {
    fetchQuotationChatRoomSpecificAnnotations(input: $input) {
      result
      errorMessage
      data {
        isNew
        userId
        status
        anchorPos {
          x
          y
          z
        }
        handlePos {
          x
          y
          z
        }
        nodeId
        commentUsers {
          userName
        }
        createdAt
        comments {
          id
          userId
          userName
          isParent
          comment
          status
          edited
          createdAt
          updatedAt
        }
        annotationId
      }
    }
  }
`;

/**
 * __useFetchQuotationChatRoomSpecificAnnotationsQuery__
 *
 * To run a query within a React component, call `useFetchQuotationChatRoomSpecificAnnotationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchQuotationChatRoomSpecificAnnotationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchQuotationChatRoomSpecificAnnotationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchQuotationChatRoomSpecificAnnotationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchQuotationChatRoomSpecificAnnotationsQuery,
    FetchQuotationChatRoomSpecificAnnotationsQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchQuotationChatRoomSpecificAnnotationsQuery,
    FetchQuotationChatRoomSpecificAnnotationsQueryVariables
  >(FetchQuotationChatRoomSpecificAnnotationsDocument, baseOptions);
}
export function useFetchQuotationChatRoomSpecificAnnotationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchQuotationChatRoomSpecificAnnotationsQuery,
    FetchQuotationChatRoomSpecificAnnotationsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchQuotationChatRoomSpecificAnnotationsQuery,
    FetchQuotationChatRoomSpecificAnnotationsQueryVariables
  >(FetchQuotationChatRoomSpecificAnnotationsDocument, baseOptions);
}
export type FetchQuotationChatRoomSpecificAnnotationsQueryHookResult = ReturnType<
  typeof useFetchQuotationChatRoomSpecificAnnotationsQuery
>;
export type FetchQuotationChatRoomSpecificAnnotationsLazyQueryHookResult = ReturnType<
  typeof useFetchQuotationChatRoomSpecificAnnotationsLazyQuery
>;
export type FetchQuotationChatRoomSpecificAnnotationsQueryResult = Apollo.QueryResult<
  FetchQuotationChatRoomSpecificAnnotationsQuery,
  FetchQuotationChatRoomSpecificAnnotationsQueryVariables
>;
export const CreateQuotationAnnotationDocument = gql`
  mutation createQuotationAnnotation($input: CreateQuotationAnnotationInput!) {
    createQuotationAnnotation(input: $input) {
      result
      errorMessage
      data {
        id
        userId
        chatRoomId
        anchorPos {
          x
          y
          z
        }
        handlePos {
          x
          y
          z
        }
        nodeId
        comments {
          id
          userId
          isParent
          comment
          userName
          status
          edited
          createdAt
          updatedAt
        }
        isNew
        status
        createdAt
        updatedAt
      }
    }
  }
`;
export type CreateQuotationAnnotationMutationFn = Apollo.MutationFunction<
  CreateQuotationAnnotationMutation,
  CreateQuotationAnnotationMutationVariables
>;

/**
 * __useCreateQuotationAnnotationMutation__
 *
 * To run a mutation, you first call `useCreateQuotationAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuotationAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuotationAnnotationMutation, { data, loading, error }] = useCreateQuotationAnnotationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuotationAnnotationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateQuotationAnnotationMutation,
    CreateQuotationAnnotationMutationVariables
  >
) {
  return Apollo.useMutation<
    CreateQuotationAnnotationMutation,
    CreateQuotationAnnotationMutationVariables
  >(CreateQuotationAnnotationDocument, baseOptions);
}
export type CreateQuotationAnnotationMutationHookResult = ReturnType<
  typeof useCreateQuotationAnnotationMutation
>;
export type CreateQuotationAnnotationMutationResult = Apollo.MutationResult<
  CreateQuotationAnnotationMutation
>;
export type CreateQuotationAnnotationMutationOptions = Apollo.BaseMutationOptions<
  CreateQuotationAnnotationMutation,
  CreateQuotationAnnotationMutationVariables
>;
export const RemoveQuotationAnnotationDocument = gql`
  mutation removeQuotationAnnotation($input: RemoveQuotationAnnotationInput!) {
    removeQuotationAnnotation(input: $input) {
      result
      errorMessage
    }
  }
`;
export type RemoveQuotationAnnotationMutationFn = Apollo.MutationFunction<
  RemoveQuotationAnnotationMutation,
  RemoveQuotationAnnotationMutationVariables
>;

/**
 * __useRemoveQuotationAnnotationMutation__
 *
 * To run a mutation, you first call `useRemoveQuotationAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveQuotationAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeQuotationAnnotationMutation, { data, loading, error }] = useRemoveQuotationAnnotationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveQuotationAnnotationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveQuotationAnnotationMutation,
    RemoveQuotationAnnotationMutationVariables
  >
) {
  return Apollo.useMutation<
    RemoveQuotationAnnotationMutation,
    RemoveQuotationAnnotationMutationVariables
  >(RemoveQuotationAnnotationDocument, baseOptions);
}
export type RemoveQuotationAnnotationMutationHookResult = ReturnType<
  typeof useRemoveQuotationAnnotationMutation
>;
export type RemoveQuotationAnnotationMutationResult = Apollo.MutationResult<
  RemoveQuotationAnnotationMutation
>;
export type RemoveQuotationAnnotationMutationOptions = Apollo.BaseMutationOptions<
  RemoveQuotationAnnotationMutation,
  RemoveQuotationAnnotationMutationVariables
>;
export const CreateQuotationAnnotationCommentDocument = gql`
  mutation createQuotationAnnotationComment(
    $input: CreateQuotationAnnotationCommentInput!
  ) {
    createQuotationAnnotationComment(input: $input) {
      result
      errorMessage
      data {
        id
        userId
        chatRoomId
        anchorPos {
          x
          y
          z
        }
        handlePos {
          x
          y
          z
        }
        nodeId
        comments {
          id
          userId
          isParent
          comment
          userName
          status
          edited
          createdAt
          updatedAt
        }
        isNew
        status
        createdAt
        updatedAt
      }
    }
  }
`;
export type CreateQuotationAnnotationCommentMutationFn = Apollo.MutationFunction<
  CreateQuotationAnnotationCommentMutation,
  CreateQuotationAnnotationCommentMutationVariables
>;

/**
 * __useCreateQuotationAnnotationCommentMutation__
 *
 * To run a mutation, you first call `useCreateQuotationAnnotationCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuotationAnnotationCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuotationAnnotationCommentMutation, { data, loading, error }] = useCreateQuotationAnnotationCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuotationAnnotationCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateQuotationAnnotationCommentMutation,
    CreateQuotationAnnotationCommentMutationVariables
  >
) {
  return Apollo.useMutation<
    CreateQuotationAnnotationCommentMutation,
    CreateQuotationAnnotationCommentMutationVariables
  >(CreateQuotationAnnotationCommentDocument, baseOptions);
}
export type CreateQuotationAnnotationCommentMutationHookResult = ReturnType<
  typeof useCreateQuotationAnnotationCommentMutation
>;
export type CreateQuotationAnnotationCommentMutationResult = Apollo.MutationResult<
  CreateQuotationAnnotationCommentMutation
>;
export type CreateQuotationAnnotationCommentMutationOptions = Apollo.BaseMutationOptions<
  CreateQuotationAnnotationCommentMutation,
  CreateQuotationAnnotationCommentMutationVariables
>;
export const RemoveQuotationAnnotationCommentDocument = gql`
  mutation removeQuotationAnnotationComment(
    $input: RemoveQuotationAnnotationCommentInput!
  ) {
    removeQuotationAnnotationComment(input: $input) {
      result
      errorMessage
    }
  }
`;
export type RemoveQuotationAnnotationCommentMutationFn = Apollo.MutationFunction<
  RemoveQuotationAnnotationCommentMutation,
  RemoveQuotationAnnotationCommentMutationVariables
>;

/**
 * __useRemoveQuotationAnnotationCommentMutation__
 *
 * To run a mutation, you first call `useRemoveQuotationAnnotationCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveQuotationAnnotationCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeQuotationAnnotationCommentMutation, { data, loading, error }] = useRemoveQuotationAnnotationCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveQuotationAnnotationCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveQuotationAnnotationCommentMutation,
    RemoveQuotationAnnotationCommentMutationVariables
  >
) {
  return Apollo.useMutation<
    RemoveQuotationAnnotationCommentMutation,
    RemoveQuotationAnnotationCommentMutationVariables
  >(RemoveQuotationAnnotationCommentDocument, baseOptions);
}
export type RemoveQuotationAnnotationCommentMutationHookResult = ReturnType<
  typeof useRemoveQuotationAnnotationCommentMutation
>;
export type RemoveQuotationAnnotationCommentMutationResult = Apollo.MutationResult<
  RemoveQuotationAnnotationCommentMutation
>;
export type RemoveQuotationAnnotationCommentMutationOptions = Apollo.BaseMutationOptions<
  RemoveQuotationAnnotationCommentMutation,
  RemoveQuotationAnnotationCommentMutationVariables
>;
export const UpdateQuotationAnnotationDocument = gql`
  mutation updateQuotationAnnotation($input: UpdateQuotationAnnotationInput!) {
    updateQuotationAnnotation(input: $input) {
      result
      errorMessage
    }
  }
`;
export type UpdateQuotationAnnotationMutationFn = Apollo.MutationFunction<
  UpdateQuotationAnnotationMutation,
  UpdateQuotationAnnotationMutationVariables
>;

/**
 * __useUpdateQuotationAnnotationMutation__
 *
 * To run a mutation, you first call `useUpdateQuotationAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuotationAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuotationAnnotationMutation, { data, loading, error }] = useUpdateQuotationAnnotationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuotationAnnotationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateQuotationAnnotationMutation,
    UpdateQuotationAnnotationMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdateQuotationAnnotationMutation,
    UpdateQuotationAnnotationMutationVariables
  >(UpdateQuotationAnnotationDocument, baseOptions);
}
export type UpdateQuotationAnnotationMutationHookResult = ReturnType<
  typeof useUpdateQuotationAnnotationMutation
>;
export type UpdateQuotationAnnotationMutationResult = Apollo.MutationResult<
  UpdateQuotationAnnotationMutation
>;
export type UpdateQuotationAnnotationMutationOptions = Apollo.BaseMutationOptions<
  UpdateQuotationAnnotationMutation,
  UpdateQuotationAnnotationMutationVariables
>;
export const UpdateQuotationAnnotationCommentDocument = gql`
  mutation updateQuotationAnnotationComment(
    $input: UpdateQuotationAnnotationCommentInput!
  ) {
    updateQuotationAnnotationComment(input: $input) {
      result
      errorMessage
    }
  }
`;
export type UpdateQuotationAnnotationCommentMutationFn = Apollo.MutationFunction<
  UpdateQuotationAnnotationCommentMutation,
  UpdateQuotationAnnotationCommentMutationVariables
>;

/**
 * __useUpdateQuotationAnnotationCommentMutation__
 *
 * To run a mutation, you first call `useUpdateQuotationAnnotationCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuotationAnnotationCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuotationAnnotationCommentMutation, { data, loading, error }] = useUpdateQuotationAnnotationCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuotationAnnotationCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateQuotationAnnotationCommentMutation,
    UpdateQuotationAnnotationCommentMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdateQuotationAnnotationCommentMutation,
    UpdateQuotationAnnotationCommentMutationVariables
  >(UpdateQuotationAnnotationCommentDocument, baseOptions);
}
export type UpdateQuotationAnnotationCommentMutationHookResult = ReturnType<
  typeof useUpdateQuotationAnnotationCommentMutation
>;
export type UpdateQuotationAnnotationCommentMutationResult = Apollo.MutationResult<
  UpdateQuotationAnnotationCommentMutation
>;
export type UpdateQuotationAnnotationCommentMutationOptions = Apollo.BaseMutationOptions<
  UpdateQuotationAnnotationCommentMutation,
  UpdateQuotationAnnotationCommentMutationVariables
>;
export const ReadQuotationAnnotationCommentDocument = gql`
  mutation readQuotationAnnotationComment($annotationId: String!) {
    readQuotationAnnotationComment(input: { annotationId: $annotationId }) {
      result
      errorMessage
    }
  }
`;
export type ReadQuotationAnnotationCommentMutationFn = Apollo.MutationFunction<
  ReadQuotationAnnotationCommentMutation,
  ReadQuotationAnnotationCommentMutationVariables
>;

/**
 * __useReadQuotationAnnotationCommentMutation__
 *
 * To run a mutation, you first call `useReadQuotationAnnotationCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadQuotationAnnotationCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readQuotationAnnotationCommentMutation, { data, loading, error }] = useReadQuotationAnnotationCommentMutation({
 *   variables: {
 *      annotationId: // value for 'annotationId'
 *   },
 * });
 */
export function useReadQuotationAnnotationCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReadQuotationAnnotationCommentMutation,
    ReadQuotationAnnotationCommentMutationVariables
  >
) {
  return Apollo.useMutation<
    ReadQuotationAnnotationCommentMutation,
    ReadQuotationAnnotationCommentMutationVariables
  >(ReadQuotationAnnotationCommentDocument, baseOptions);
}
export type ReadQuotationAnnotationCommentMutationHookResult = ReturnType<
  typeof useReadQuotationAnnotationCommentMutation
>;
export type ReadQuotationAnnotationCommentMutationResult = Apollo.MutationResult<
  ReadQuotationAnnotationCommentMutation
>;
export type ReadQuotationAnnotationCommentMutationOptions = Apollo.BaseMutationOptions<
  ReadQuotationAnnotationCommentMutation,
  ReadQuotationAnnotationCommentMutationVariables
>;
export const FetchQuotationChatRoomDocument = gql`
  query fetchQuotationChatRoom($input: FetchQuotationChatRoomInput!) {
    fetchQuotationChatRoom(input: $input) {
      result
      errorMessage
      data {
        rfqId
        quotationPartnerId
        chatRoomId
        isOld
        rfqStatus
        chatRoomStatus
        partnerStatus
        clientStatus
        hasQuotation
        hasReview
        isQuotationConfirmed
        hasPurchaseOrder
        isPurchaseOrderConfirmed
        partnerLastSeenAt
        chatFiles {
          fileName
          fileId
          fileSize
        }
        hasProgressingPayment
      }
    }
  }
`;

/**
 * __useFetchQuotationChatRoomQuery__
 *
 * To run a query within a React component, call `useFetchQuotationChatRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchQuotationChatRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchQuotationChatRoomQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchQuotationChatRoomQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchQuotationChatRoomQuery,
    FetchQuotationChatRoomQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchQuotationChatRoomQuery,
    FetchQuotationChatRoomQueryVariables
  >(FetchQuotationChatRoomDocument, baseOptions);
}
export function useFetchQuotationChatRoomLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchQuotationChatRoomQuery,
    FetchQuotationChatRoomQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchQuotationChatRoomQuery,
    FetchQuotationChatRoomQueryVariables
  >(FetchQuotationChatRoomDocument, baseOptions);
}
export type FetchQuotationChatRoomQueryHookResult = ReturnType<
  typeof useFetchQuotationChatRoomQuery
>;
export type FetchQuotationChatRoomLazyQueryHookResult = ReturnType<
  typeof useFetchQuotationChatRoomLazyQuery
>;
export type FetchQuotationChatRoomQueryResult = Apollo.QueryResult<
  FetchQuotationChatRoomQuery,
  FetchQuotationChatRoomQueryVariables
>;
export const SubscribeQuotationChatRoomDocument = gql`
  subscription subscribeQuotationChatRoom(
    $input: SubscribeQuotationChatRoomInput!
  ) {
    subscribeQuotationChatRoom(input: $input) {
      result
      errorMessage
      data {
        rfqId
        quotationPartnerId
        chatRoomId
        isOld
        rfqStatus
        chatRoomStatus
        partnerStatus
        clientStatus
        hasQuotation
        isQuotationConfirmed
        hasPurchaseOrder
        isPurchaseOrderConfirmed
        partnerLastSeenAt
        hasReview
        chatFiles {
          fileName
          fileId
          fileSize
        }
        hasProgressingPayment
      }
    }
  }
`;

/**
 * __useSubscribeQuotationChatRoomSubscription__
 *
 * To run a query within a React component, call `useSubscribeQuotationChatRoomSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeQuotationChatRoomSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeQuotationChatRoomSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeQuotationChatRoomSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    SubscribeQuotationChatRoomSubscription,
    SubscribeQuotationChatRoomSubscriptionVariables
  >
) {
  return Apollo.useSubscription<
    SubscribeQuotationChatRoomSubscription,
    SubscribeQuotationChatRoomSubscriptionVariables
  >(SubscribeQuotationChatRoomDocument, baseOptions);
}
export type SubscribeQuotationChatRoomSubscriptionHookResult = ReturnType<
  typeof useSubscribeQuotationChatRoomSubscription
>;
export type SubscribeQuotationChatRoomSubscriptionResult = Apollo.SubscriptionResult<
  SubscribeQuotationChatRoomSubscription
>;
export const FetchQuotationChatMessagesDocument = gql`
  query fetchQuotationChatMessages($input: FetchQuotationChatRoomInput!) {
    fetchQuotationChatMessages(input: $input) {
      result
      errorMessage
      data {
        id
        senderId
        senderUserType
        organizationName
        managerName
        profileId
        message {
          ... on CAPAQuotationChatMessageRfq {
            messageType
            rfq {
              rfqId
              userOrganizationName
              userManagerName
              partnerOrganizationName
              partnerManagerName
              projectName
              quotationId
              purchaseOrderId
              adjustRequest
              event
              rejectedReason
              isVisible
              isSendRequest
              purchaseAmount
              expectedConfirmPurchaseDate
            }
          }
          ... on CAPAQuotationChatMessageMessage {
            messageType
            message
          }
          ... on CAPAQuotationChatMessageSimpleQuotation {
            messageType
            quotation {
              quotation
              excludeDeliveryFee
              etc
            }
          }
          ... on CAPAQuotationChatMessageDetailedQuotation {
            messageType
            quotation {
              rfqId
              projectName
              serviceType
              optionalServices {
                serviceType
              }
              publish {
                organizationName
              }
              supply {
                quotationPartnerStatus
                quotationPartnerId
                organizationName
                companyRegistrationNumber
                managerName
                address
              }
              dueDate
              expiration
              items {
                fileId
                fileName
                quantity
                material
                cost
                etc
              }
              quotation
              deliveryCost
              createdAt
              maxDraftModificationCount
              draftModificationTerms
              etc
            }
          }
          ... on CAPAQuotationAnnotationCommentMessage {
            messageType
            annotation {
              id
              annotationId
              fileId
              userId
              isParent
              comment
              userName
              status
              edited
              createdAt
              updatedAt
            }
          }
          ... on CAPAQuotationBypassMessage {
            messageType
            bypass {
              id
            }
          }
          ... on CAPAQuotationBypassMessageDeleteMessage {
            messageType
            id
          }
        }
        chatFiles {
          fileId
          fileName
          fileSize
        }
        createdAt
        unReadCount
        chatFiles {
          fileName
          fileId
          fileSize
        }
        createdAt
      }
    }
  }
`;

/**
 * __useFetchQuotationChatMessagesQuery__
 *
 * To run a query within a React component, call `useFetchQuotationChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchQuotationChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchQuotationChatMessagesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchQuotationChatMessagesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchQuotationChatMessagesQuery,
    FetchQuotationChatMessagesQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchQuotationChatMessagesQuery,
    FetchQuotationChatMessagesQueryVariables
  >(FetchQuotationChatMessagesDocument, baseOptions);
}
export function useFetchQuotationChatMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchQuotationChatMessagesQuery,
    FetchQuotationChatMessagesQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchQuotationChatMessagesQuery,
    FetchQuotationChatMessagesQueryVariables
  >(FetchQuotationChatMessagesDocument, baseOptions);
}
export type FetchQuotationChatMessagesQueryHookResult = ReturnType<
  typeof useFetchQuotationChatMessagesQuery
>;
export type FetchQuotationChatMessagesLazyQueryHookResult = ReturnType<
  typeof useFetchQuotationChatMessagesLazyQuery
>;
export type FetchQuotationChatMessagesQueryResult = Apollo.QueryResult<
  FetchQuotationChatMessagesQuery,
  FetchQuotationChatMessagesQueryVariables
>;
export const SubscribeQuotationChatMessageDocument = gql`
  subscription subscribeQuotationChatMessage(
    $input: SubscribeQuotationChatRoomInput!
  ) {
    subscribeQuotationChatMessage(input: $input) {
      result
      errorMessage
      data {
        id
        senderId
        senderUserType
        organizationName
        managerName
        profileId
        message {
          ... on CAPAQuotationChatMessageRfq {
            messageType
            rfq {
              rfqId
              quotationId
              purchaseOrderId
              adjustRequest
              event
              rejectedReason
              isVisible
              isSendRequest
              purchaseAmount
              expectedConfirmPurchaseDate
            }
          }
          ... on CAPAQuotationChatMessageMessage {
            messageType
            message
          }
          ... on CAPAQuotationChatMessageSimpleQuotation {
            messageType
            quotation {
              quotation
              excludeDeliveryFee
              etc
            }
          }
          ... on CAPAQuotationChatMessageDetailedQuotation {
            messageType
            quotation {
              rfqId
              projectName
              serviceType
              optionalServices {
                serviceType
              }
              publish {
                organizationName
              }
              supply {
                quotationPartnerStatus
                quotationPartnerId
                organizationName
                companyRegistrationNumber
                managerName
                address
              }
              dueDate
              expiration
              items {
                fileId
                fileName
                quantity
                material
                cost
                etc
              }
              quotation
              deliveryCost
              createdAt
              maxDraftModificationCount
              draftModificationTerms
              etc
            }
          }
          ... on CAPAQuotationAnnotationCommentMessage {
            messageType
            annotation {
              id
              annotationId
              fileId
              userId
              isParent
              comment
              userName
              status
              edited
              createdAt
              updatedAt
            }
          }
          ... on CAPAQuotationBypassMessage {
            messageType
            bypass {
              id
            }
          }
          ... on CAPAQuotationBypassMessageDeleteMessage {
            messageType
            id
          }
        }
        chatFiles {
          fileId
          fileName
          fileSize
        }
        createdAt
        unReadCount
        chatFiles {
          fileName
          fileId
          fileSize
        }
        createdAt
      }
    }
  }
`;

/**
 * __useSubscribeQuotationChatMessageSubscription__
 *
 * To run a query within a React component, call `useSubscribeQuotationChatMessageSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeQuotationChatMessageSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeQuotationChatMessageSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeQuotationChatMessageSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    SubscribeQuotationChatMessageSubscription,
    SubscribeQuotationChatMessageSubscriptionVariables
  >
) {
  return Apollo.useSubscription<
    SubscribeQuotationChatMessageSubscription,
    SubscribeQuotationChatMessageSubscriptionVariables
  >(SubscribeQuotationChatMessageDocument, baseOptions);
}
export type SubscribeQuotationChatMessageSubscriptionHookResult = ReturnType<
  typeof useSubscribeQuotationChatMessageSubscription
>;
export type SubscribeQuotationChatMessageSubscriptionResult = Apollo.SubscriptionResult<
  SubscribeQuotationChatMessageSubscription
>;
export const ReadQuotationChatMessageDocument = gql`
  mutation readQuotationChatMessage($chatRoomId: String!) {
    readQuotationChatMessage(input: { chatRoomId: $chatRoomId }) {
      result
      errorMessage
    }
  }
`;
export type ReadQuotationChatMessageMutationFn = Apollo.MutationFunction<
  ReadQuotationChatMessageMutation,
  ReadQuotationChatMessageMutationVariables
>;

/**
 * __useReadQuotationChatMessageMutation__
 *
 * To run a mutation, you first call `useReadQuotationChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadQuotationChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readQuotationChatMessageMutation, { data, loading, error }] = useReadQuotationChatMessageMutation({
 *   variables: {
 *      chatRoomId: // value for 'chatRoomId'
 *   },
 * });
 */
export function useReadQuotationChatMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReadQuotationChatMessageMutation,
    ReadQuotationChatMessageMutationVariables
  >
) {
  return Apollo.useMutation<
    ReadQuotationChatMessageMutation,
    ReadQuotationChatMessageMutationVariables
  >(ReadQuotationChatMessageDocument, baseOptions);
}
export type ReadQuotationChatMessageMutationHookResult = ReturnType<
  typeof useReadQuotationChatMessageMutation
>;
export type ReadQuotationChatMessageMutationResult = Apollo.MutationResult<
  ReadQuotationChatMessageMutation
>;
export type ReadQuotationChatMessageMutationOptions = Apollo.BaseMutationOptions<
  ReadQuotationChatMessageMutation,
  ReadQuotationChatMessageMutationVariables
>;
export const SendQuotationChatMessageDocument = gql`
  mutation sendQuotationChatMessage($input: SendQuotationChatMessageInput!) {
    sendQuotationChatMessage(input: $input) {
      result
      errorMessage
      data {
        chatRoomId
        chatRoomStatus
      }
    }
  }
`;
export type SendQuotationChatMessageMutationFn = Apollo.MutationFunction<
  SendQuotationChatMessageMutation,
  SendQuotationChatMessageMutationVariables
>;

/**
 * __useSendQuotationChatMessageMutation__
 *
 * To run a mutation, you first call `useSendQuotationChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendQuotationChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendQuotationChatMessageMutation, { data, loading, error }] = useSendQuotationChatMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendQuotationChatMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendQuotationChatMessageMutation,
    SendQuotationChatMessageMutationVariables
  >
) {
  return Apollo.useMutation<
    SendQuotationChatMessageMutation,
    SendQuotationChatMessageMutationVariables
  >(SendQuotationChatMessageDocument, baseOptions);
}
export type SendQuotationChatMessageMutationHookResult = ReturnType<
  typeof useSendQuotationChatMessageMutation
>;
export type SendQuotationChatMessageMutationResult = Apollo.MutationResult<
  SendQuotationChatMessageMutation
>;
export type SendQuotationChatMessageMutationOptions = Apollo.BaseMutationOptions<
  SendQuotationChatMessageMutation,
  SendQuotationChatMessageMutationVariables
>;
export const QuitQuotationChatRoomDocument = gql`
  mutation quitQuotationChatRoom($chatRoomId: String!) {
    quitQuotationChatRoom(input: { chatRoomId: $chatRoomId }) {
      result
      errorMessage
    }
  }
`;
export type QuitQuotationChatRoomMutationFn = Apollo.MutationFunction<
  QuitQuotationChatRoomMutation,
  QuitQuotationChatRoomMutationVariables
>;

/**
 * __useQuitQuotationChatRoomMutation__
 *
 * To run a mutation, you first call `useQuitQuotationChatRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuitQuotationChatRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quitQuotationChatRoomMutation, { data, loading, error }] = useQuitQuotationChatRoomMutation({
 *   variables: {
 *      chatRoomId: // value for 'chatRoomId'
 *   },
 * });
 */
export function useQuitQuotationChatRoomMutation(
  baseOptions?: Apollo.MutationHookOptions<
    QuitQuotationChatRoomMutation,
    QuitQuotationChatRoomMutationVariables
  >
) {
  return Apollo.useMutation<
    QuitQuotationChatRoomMutation,
    QuitQuotationChatRoomMutationVariables
  >(QuitQuotationChatRoomDocument, baseOptions);
}
export type QuitQuotationChatRoomMutationHookResult = ReturnType<
  typeof useQuitQuotationChatRoomMutation
>;
export type QuitQuotationChatRoomMutationResult = Apollo.MutationResult<
  QuitQuotationChatRoomMutation
>;
export type QuitQuotationChatRoomMutationOptions = Apollo.BaseMutationOptions<
  QuitQuotationChatRoomMutation,
  QuitQuotationChatRoomMutationVariables
>;
export const ChangeChatRoomStatusOpenDocument = gql`
  mutation changeChatRoomStatusOpen($input: ChangeChatRoomStatusInput!) {
    changeChatRoomStatusOpen(input: $input) {
      result
      errorMessage
    }
  }
`;
export type ChangeChatRoomStatusOpenMutationFn = Apollo.MutationFunction<
  ChangeChatRoomStatusOpenMutation,
  ChangeChatRoomStatusOpenMutationVariables
>;

/**
 * __useChangeChatRoomStatusOpenMutation__
 *
 * To run a mutation, you first call `useChangeChatRoomStatusOpenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeChatRoomStatusOpenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeChatRoomStatusOpenMutation, { data, loading, error }] = useChangeChatRoomStatusOpenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeChatRoomStatusOpenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeChatRoomStatusOpenMutation,
    ChangeChatRoomStatusOpenMutationVariables
  >
) {
  return Apollo.useMutation<
    ChangeChatRoomStatusOpenMutation,
    ChangeChatRoomStatusOpenMutationVariables
  >(ChangeChatRoomStatusOpenDocument, baseOptions);
}
export type ChangeChatRoomStatusOpenMutationHookResult = ReturnType<
  typeof useChangeChatRoomStatusOpenMutation
>;
export type ChangeChatRoomStatusOpenMutationResult = Apollo.MutationResult<
  ChangeChatRoomStatusOpenMutation
>;
export type ChangeChatRoomStatusOpenMutationOptions = Apollo.BaseMutationOptions<
  ChangeChatRoomStatusOpenMutation,
  ChangeChatRoomStatusOpenMutationVariables
>;
export const ChangeQuotationMessageInvisibleDocument = gql`
  mutation changeQuotationMessageInvisible(
    $input: ChangeChatMessageInvisibleInput!
  ) {
    changeQuotationMessageInvisible(input: $input) {
      result
      errorMessage
    }
  }
`;
export type ChangeQuotationMessageInvisibleMutationFn = Apollo.MutationFunction<
  ChangeQuotationMessageInvisibleMutation,
  ChangeQuotationMessageInvisibleMutationVariables
>;

/**
 * __useChangeQuotationMessageInvisibleMutation__
 *
 * To run a mutation, you first call `useChangeQuotationMessageInvisibleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeQuotationMessageInvisibleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeQuotationMessageInvisibleMutation, { data, loading, error }] = useChangeQuotationMessageInvisibleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeQuotationMessageInvisibleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeQuotationMessageInvisibleMutation,
    ChangeQuotationMessageInvisibleMutationVariables
  >
) {
  return Apollo.useMutation<
    ChangeQuotationMessageInvisibleMutation,
    ChangeQuotationMessageInvisibleMutationVariables
  >(ChangeQuotationMessageInvisibleDocument, baseOptions);
}
export type ChangeQuotationMessageInvisibleMutationHookResult = ReturnType<
  typeof useChangeQuotationMessageInvisibleMutation
>;
export type ChangeQuotationMessageInvisibleMutationResult = Apollo.MutationResult<
  ChangeQuotationMessageInvisibleMutation
>;
export type ChangeQuotationMessageInvisibleMutationOptions = Apollo.BaseMutationOptions<
  ChangeQuotationMessageInvisibleMutation,
  ChangeQuotationMessageInvisibleMutationVariables
>;
export const FetchQuotationChatRoomSharedFilesDocument = gql`
  query fetchQuotationChatRoomSharedFiles(
    $input: FetchQuotationChatRoomSharedFilesInput!
  ) {
    fetchQuotationChatRoomSharedFiles(input: $input) {
      result
      errorMessage
      data {
        fileId
        fileName
        quotationSharedFileId
        quotationSharedFileSize
        quotationSharedFileType
        annotationStatus
      }
    }
  }
`;

/**
 * __useFetchQuotationChatRoomSharedFilesQuery__
 *
 * To run a query within a React component, call `useFetchQuotationChatRoomSharedFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchQuotationChatRoomSharedFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchQuotationChatRoomSharedFilesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchQuotationChatRoomSharedFilesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchQuotationChatRoomSharedFilesQuery,
    FetchQuotationChatRoomSharedFilesQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchQuotationChatRoomSharedFilesQuery,
    FetchQuotationChatRoomSharedFilesQueryVariables
  >(FetchQuotationChatRoomSharedFilesDocument, baseOptions);
}
export function useFetchQuotationChatRoomSharedFilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchQuotationChatRoomSharedFilesQuery,
    FetchQuotationChatRoomSharedFilesQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchQuotationChatRoomSharedFilesQuery,
    FetchQuotationChatRoomSharedFilesQueryVariables
  >(FetchQuotationChatRoomSharedFilesDocument, baseOptions);
}
export type FetchQuotationChatRoomSharedFilesQueryHookResult = ReturnType<
  typeof useFetchQuotationChatRoomSharedFilesQuery
>;
export type FetchQuotationChatRoomSharedFilesLazyQueryHookResult = ReturnType<
  typeof useFetchQuotationChatRoomSharedFilesLazyQuery
>;
export type FetchQuotationChatRoomSharedFilesQueryResult = Apollo.QueryResult<
  FetchQuotationChatRoomSharedFilesQuery,
  FetchQuotationChatRoomSharedFilesQueryVariables
>;
export const DeleteQuotationChatMessageDocument = gql`
  mutation deleteQuotationChatMessage(
    $input: DeleteQuotationChatMessageInput!
  ) {
    deleteQuotationChatMessage(input: $input) {
      result
      errorMessage
    }
  }
`;
export type DeleteQuotationChatMessageMutationFn = Apollo.MutationFunction<
  DeleteQuotationChatMessageMutation,
  DeleteQuotationChatMessageMutationVariables
>;

/**
 * __useDeleteQuotationChatMessageMutation__
 *
 * To run a mutation, you first call `useDeleteQuotationChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuotationChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuotationChatMessageMutation, { data, loading, error }] = useDeleteQuotationChatMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteQuotationChatMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteQuotationChatMessageMutation,
    DeleteQuotationChatMessageMutationVariables
  >
) {
  return Apollo.useMutation<
    DeleteQuotationChatMessageMutation,
    DeleteQuotationChatMessageMutationVariables
  >(DeleteQuotationChatMessageDocument, baseOptions);
}
export type DeleteQuotationChatMessageMutationHookResult = ReturnType<
  typeof useDeleteQuotationChatMessageMutation
>;
export type DeleteQuotationChatMessageMutationResult = Apollo.MutationResult<
  DeleteQuotationChatMessageMutation
>;
export type DeleteQuotationChatMessageMutationOptions = Apollo.BaseMutationOptions<
  DeleteQuotationChatMessageMutation,
  DeleteQuotationChatMessageMutationVariables
>;
export const UpdateBypassChatComplaintDocument = gql`
  mutation updateBypassChatComplaint(
    $input: UpdateReceiveComplaintQuotationChatMessageInput!
  ) {
    updateBypassChatComplaint(input: $input) {
      result
      errorMessage
    }
  }
`;
export type UpdateBypassChatComplaintMutationFn = Apollo.MutationFunction<
  UpdateBypassChatComplaintMutation,
  UpdateBypassChatComplaintMutationVariables
>;

/**
 * __useUpdateBypassChatComplaintMutation__
 *
 * To run a mutation, you first call `useUpdateBypassChatComplaintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBypassChatComplaintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBypassChatComplaintMutation, { data, loading, error }] = useUpdateBypassChatComplaintMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBypassChatComplaintMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateBypassChatComplaintMutation,
    UpdateBypassChatComplaintMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdateBypassChatComplaintMutation,
    UpdateBypassChatComplaintMutationVariables
  >(UpdateBypassChatComplaintDocument, baseOptions);
}
export type UpdateBypassChatComplaintMutationHookResult = ReturnType<
  typeof useUpdateBypassChatComplaintMutation
>;
export type UpdateBypassChatComplaintMutationResult = Apollo.MutationResult<
  UpdateBypassChatComplaintMutation
>;
export type UpdateBypassChatComplaintMutationOptions = Apollo.BaseMutationOptions<
  UpdateBypassChatComplaintMutation,
  UpdateBypassChatComplaintMutationVariables
>;
export const FetchMyDriveDocument = gql`
  query fetchMyDrive($limit: Float, $offset: Float) {
    fetchMyDrive(input: { limit: $limit, offset: $offset }) {
      result
      errorMessage
      data {
        oldFileId
        fileId
        fileName
        fileSize
        status
        thumbnails
        viewerUrl
        createdAt
        updatedAt
      }
    }
  }
`;

/**
 * __useFetchMyDriveQuery__
 *
 * To run a query within a React component, call `useFetchMyDriveQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMyDriveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMyDriveQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFetchMyDriveQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchMyDriveQuery,
    FetchMyDriveQueryVariables
  >
) {
  return Apollo.useQuery<FetchMyDriveQuery, FetchMyDriveQueryVariables>(
    FetchMyDriveDocument,
    baseOptions
  );
}
export function useFetchMyDriveLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchMyDriveQuery,
    FetchMyDriveQueryVariables
  >
) {
  return Apollo.useLazyQuery<FetchMyDriveQuery, FetchMyDriveQueryVariables>(
    FetchMyDriveDocument,
    baseOptions
  );
}
export type FetchMyDriveQueryHookResult = ReturnType<
  typeof useFetchMyDriveQuery
>;
export type FetchMyDriveLazyQueryHookResult = ReturnType<
  typeof useFetchMyDriveLazyQuery
>;
export type FetchMyDriveQueryResult = Apollo.QueryResult<
  FetchMyDriveQuery,
  FetchMyDriveQueryVariables
>;
export const RegisterCloudUserDocument = gql`
  mutation registerCloudUser {
    registerCloudUser {
      result
      errorMessage
      data {
        accessToken
        refreshToken
        redirectUrl
        tokenType
        expiresIn
      }
    }
  }
`;
export type RegisterCloudUserMutationFn = Apollo.MutationFunction<
  RegisterCloudUserMutation,
  RegisterCloudUserMutationVariables
>;

/**
 * __useRegisterCloudUserMutation__
 *
 * To run a mutation, you first call `useRegisterCloudUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterCloudUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerCloudUserMutation, { data, loading, error }] = useRegisterCloudUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useRegisterCloudUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterCloudUserMutation,
    RegisterCloudUserMutationVariables
  >
) {
  return Apollo.useMutation<
    RegisterCloudUserMutation,
    RegisterCloudUserMutationVariables
  >(RegisterCloudUserDocument, baseOptions);
}
export type RegisterCloudUserMutationHookResult = ReturnType<
  typeof useRegisterCloudUserMutation
>;
export type RegisterCloudUserMutationResult = Apollo.MutationResult<
  RegisterCloudUserMutation
>;
export type RegisterCloudUserMutationOptions = Apollo.BaseMutationOptions<
  RegisterCloudUserMutation,
  RegisterCloudUserMutationVariables
>;
export const FetchConnectUserDocument = gql`
  query fetchConnectUser {
    fetchConnectUser {
      result
      errorMessage
      data {
        id
        email
        userName
        notificationFilter {
          chatPush
          groupPush
          groupEmail
          commentThreadPush
          commentThreadEmail
          filePush
          fileEmail
        }
        usedSize
        availSize
        driveSize
        serviceAgreed
        privacyAgreed
        promotionAgreed
      }
    }
  }
`;

/**
 * __useFetchConnectUserQuery__
 *
 * To run a query within a React component, call `useFetchConnectUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchConnectUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchConnectUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchConnectUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchConnectUserQuery,
    FetchConnectUserQueryVariables
  >
) {
  return Apollo.useQuery<FetchConnectUserQuery, FetchConnectUserQueryVariables>(
    FetchConnectUserDocument,
    baseOptions
  );
}
export function useFetchConnectUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchConnectUserQuery,
    FetchConnectUserQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchConnectUserQuery,
    FetchConnectUserQueryVariables
  >(FetchConnectUserDocument, baseOptions);
}
export type FetchConnectUserQueryHookResult = ReturnType<
  typeof useFetchConnectUserQuery
>;
export type FetchConnectUserLazyQueryHookResult = ReturnType<
  typeof useFetchConnectUserLazyQuery
>;
export type FetchConnectUserQueryResult = Apollo.QueryResult<
  FetchConnectUserQuery,
  FetchConnectUserQueryVariables
>;
export const FetchConnectMyDriveDocument = gql`
  query fetchConnectMyDrive($input: FetchConnectMyDriveInput!) {
    fetchConnectMyDrive(input: $input) {
      result
      errorMessage
      data {
        files {
          id
          filePath
          fileName
          isFile
          isShared
          fileSize
          originalFileExt
          status
          fileId
          thumbnail
          createdAt
          updatedAt
        }
        path {
          folderName
        }
      }
    }
  }
`;

/**
 * __useFetchConnectMyDriveQuery__
 *
 * To run a query within a React component, call `useFetchConnectMyDriveQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchConnectMyDriveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchConnectMyDriveQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchConnectMyDriveQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchConnectMyDriveQuery,
    FetchConnectMyDriveQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchConnectMyDriveQuery,
    FetchConnectMyDriveQueryVariables
  >(FetchConnectMyDriveDocument, baseOptions);
}
export function useFetchConnectMyDriveLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchConnectMyDriveQuery,
    FetchConnectMyDriveQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchConnectMyDriveQuery,
    FetchConnectMyDriveQueryVariables
  >(FetchConnectMyDriveDocument, baseOptions);
}
export type FetchConnectMyDriveQueryHookResult = ReturnType<
  typeof useFetchConnectMyDriveQuery
>;
export type FetchConnectMyDriveLazyQueryHookResult = ReturnType<
  typeof useFetchConnectMyDriveLazyQuery
>;
export type FetchConnectMyDriveQueryResult = Apollo.QueryResult<
  FetchConnectMyDriveQuery,
  FetchConnectMyDriveQueryVariables
>;
export const CheckRegisteredCapaServiceDocument = gql`
  query checkRegisteredCapaService($emails: [String!]!) {
    checkRegisteredCapaService(emails: $emails) {
      result
      errorMessage
      data {
        scopes
      }
    }
  }
`;

/**
 * __useCheckRegisteredCapaServiceQuery__
 *
 * To run a query within a React component, call `useCheckRegisteredCapaServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckRegisteredCapaServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckRegisteredCapaServiceQuery({
 *   variables: {
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useCheckRegisteredCapaServiceQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CheckRegisteredCapaServiceQuery,
    CheckRegisteredCapaServiceQueryVariables
  >
) {
  return Apollo.useQuery<
    CheckRegisteredCapaServiceQuery,
    CheckRegisteredCapaServiceQueryVariables
  >(CheckRegisteredCapaServiceDocument, baseOptions);
}
export function useCheckRegisteredCapaServiceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckRegisteredCapaServiceQuery,
    CheckRegisteredCapaServiceQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    CheckRegisteredCapaServiceQuery,
    CheckRegisteredCapaServiceQueryVariables
  >(CheckRegisteredCapaServiceDocument, baseOptions);
}
export type CheckRegisteredCapaServiceQueryHookResult = ReturnType<
  typeof useCheckRegisteredCapaServiceQuery
>;
export type CheckRegisteredCapaServiceLazyQueryHookResult = ReturnType<
  typeof useCheckRegisteredCapaServiceLazyQuery
>;
export type CheckRegisteredCapaServiceQueryResult = Apollo.QueryResult<
  CheckRegisteredCapaServiceQuery,
  CheckRegisteredCapaServiceQueryVariables
>;
export const SearchFileDocument = gql`
  query searchFile($input: SearchConnectFileInput!) {
    searchFile(input: $input) {
      result
      errorMessage
      data {
        files {
          id
          filePath
          fileName
          isFile
          isShared
          fileSize
          originalFileExt
          status
          fileId
          thumbnail
          createdAt
          updatedAt
        }
        path {
          folderName
        }
      }
    }
  }
`;

/**
 * __useSearchFileQuery__
 *
 * To run a query within a React component, call `useSearchFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFileQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchFileQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SearchFileQuery,
    SearchFileQueryVariables
  >
) {
  return Apollo.useQuery<SearchFileQuery, SearchFileQueryVariables>(
    SearchFileDocument,
    baseOptions
  );
}
export function useSearchFileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchFileQuery,
    SearchFileQueryVariables
  >
) {
  return Apollo.useLazyQuery<SearchFileQuery, SearchFileQueryVariables>(
    SearchFileDocument,
    baseOptions
  );
}
export type SearchFileQueryHookResult = ReturnType<typeof useSearchFileQuery>;
export type SearchFileLazyQueryHookResult = ReturnType<
  typeof useSearchFileLazyQuery
>;
export type SearchFileQueryResult = Apollo.QueryResult<
  SearchFileQuery,
  SearchFileQueryVariables
>;
export const RegisterConnectUserDocument = gql`
  mutation registerConnectUser($input: RegisterConnectUserInput!) {
    registerConnectUser(input: $input) {
      result
      errorMessage
      data {
        accessToken
        tokenType
        expiresIn
        refreshToken
        redirectUrl
      }
    }
  }
`;
export type RegisterConnectUserMutationFn = Apollo.MutationFunction<
  RegisterConnectUserMutation,
  RegisterConnectUserMutationVariables
>;

/**
 * __useRegisterConnectUserMutation__
 *
 * To run a mutation, you first call `useRegisterConnectUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterConnectUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerConnectUserMutation, { data, loading, error }] = useRegisterConnectUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterConnectUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterConnectUserMutation,
    RegisterConnectUserMutationVariables
  >
) {
  return Apollo.useMutation<
    RegisterConnectUserMutation,
    RegisterConnectUserMutationVariables
  >(RegisterConnectUserDocument, baseOptions);
}
export type RegisterConnectUserMutationHookResult = ReturnType<
  typeof useRegisterConnectUserMutation
>;
export type RegisterConnectUserMutationResult = Apollo.MutationResult<
  RegisterConnectUserMutation
>;
export type RegisterConnectUserMutationOptions = Apollo.BaseMutationOptions<
  RegisterConnectUserMutation,
  RegisterConnectUserMutationVariables
>;
export const UpdateConnectUserDocument = gql`
  mutation updateConnectUser($input: UpdateConnectUserInput!) {
    updateConnectUser(input: $input) {
      result
      errorMessage
      data {
        id
        userName
        notificationFilter {
          chatPush
          groupPush
          groupEmail
          commentThreadPush
          commentThreadEmail
          filePush
          fileEmail
        }
        usedSize
        availSize
        driveSize
        serviceAgreed
        privacyAgreed
        promotionAgreed
      }
    }
  }
`;
export type UpdateConnectUserMutationFn = Apollo.MutationFunction<
  UpdateConnectUserMutation,
  UpdateConnectUserMutationVariables
>;

/**
 * __useUpdateConnectUserMutation__
 *
 * To run a mutation, you first call `useUpdateConnectUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConnectUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConnectUserMutation, { data, loading, error }] = useUpdateConnectUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConnectUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateConnectUserMutation,
    UpdateConnectUserMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdateConnectUserMutation,
    UpdateConnectUserMutationVariables
  >(UpdateConnectUserDocument, baseOptions);
}
export type UpdateConnectUserMutationHookResult = ReturnType<
  typeof useUpdateConnectUserMutation
>;
export type UpdateConnectUserMutationResult = Apollo.MutationResult<
  UpdateConnectUserMutation
>;
export type UpdateConnectUserMutationOptions = Apollo.BaseMutationOptions<
  UpdateConnectUserMutation,
  UpdateConnectUserMutationVariables
>;
export const FetchQuotationUserRfqsDocument = gql`
  query fetchQuotationUserRfqs($input: FetchQuotationUserRfqsInput!) {
    fetchQuotationUserRfqs(input: $input) {
      result
      errorMessage
      data {
        count
        rfqs {
          rfqId
          rfqStatus
          projectName
          serviceType
          createdAt
          thumbnailId
          quantity
          protoQuantity
          uniqueViews
          receivedQuotationCount
          newQuotationCount
          newIntroductionCount
          eventType
          itpEventRegistered
          itpEventSent
          isItpPartner
          isTransaction
          searchProjectStatusTypeEnum
        }
      }
    }
  }
`;

/**
 * __useFetchQuotationUserRfqsQuery__
 *
 * To run a query within a React component, call `useFetchQuotationUserRfqsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchQuotationUserRfqsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchQuotationUserRfqsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchQuotationUserRfqsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchQuotationUserRfqsQuery,
    FetchQuotationUserRfqsQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchQuotationUserRfqsQuery,
    FetchQuotationUserRfqsQueryVariables
  >(FetchQuotationUserRfqsDocument, baseOptions);
}
export function useFetchQuotationUserRfqsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchQuotationUserRfqsQuery,
    FetchQuotationUserRfqsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchQuotationUserRfqsQuery,
    FetchQuotationUserRfqsQueryVariables
  >(FetchQuotationUserRfqsDocument, baseOptions);
}
export type FetchQuotationUserRfqsQueryHookResult = ReturnType<
  typeof useFetchQuotationUserRfqsQuery
>;
export type FetchQuotationUserRfqsLazyQueryHookResult = ReturnType<
  typeof useFetchQuotationUserRfqsLazyQuery
>;
export type FetchQuotationUserRfqsQueryResult = Apollo.QueryResult<
  FetchQuotationUserRfqsQuery,
  FetchQuotationUserRfqsQueryVariables
>;
export const FetchMyReceivedQuotationsDocument = gql`
  query fetchMyReceivedQuotations($input: FetchMyReceivedQuotationsInput!) {
    fetchMyReceivedQuotations(input: $input) {
      result
      errorMessage
      data {
        rfqId
        quotationId
        quotationType
        partnerId
        chatRoomId
        chatRoomStatus
        chatRoomCreatedAt
        profileId
        organizationName
        confirmCount
        cost
        deliveryCost
        createdAt
        read
        isAdjusted
        isTransaction
        quotationPartnerStatus
        rfqReceivedType
        purchaseOrderStatus
        satisfactioPoint
        reviewCnt
      }
    }
  }
`;

/**
 * __useFetchMyReceivedQuotationsQuery__
 *
 * To run a query within a React component, call `useFetchMyReceivedQuotationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMyReceivedQuotationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMyReceivedQuotationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchMyReceivedQuotationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchMyReceivedQuotationsQuery,
    FetchMyReceivedQuotationsQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchMyReceivedQuotationsQuery,
    FetchMyReceivedQuotationsQueryVariables
  >(FetchMyReceivedQuotationsDocument, baseOptions);
}
export function useFetchMyReceivedQuotationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchMyReceivedQuotationsQuery,
    FetchMyReceivedQuotationsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchMyReceivedQuotationsQuery,
    FetchMyReceivedQuotationsQueryVariables
  >(FetchMyReceivedQuotationsDocument, baseOptions);
}
export type FetchMyReceivedQuotationsQueryHookResult = ReturnType<
  typeof useFetchMyReceivedQuotationsQuery
>;
export type FetchMyReceivedQuotationsLazyQueryHookResult = ReturnType<
  typeof useFetchMyReceivedQuotationsLazyQuery
>;
export type FetchMyReceivedQuotationsQueryResult = Apollo.QueryResult<
  FetchMyReceivedQuotationsQuery,
  FetchMyReceivedQuotationsQueryVariables
>;
export const FetchQuotationUserChatRoomsDocument = gql`
  query fetchQuotationUserChatRooms($input: FetchQuotationUserChatRoomsInput) {
    fetchQuotationUserChatRooms(input: $input) {
      result
      errorMessage
      data {
        totalChatRoomsCount
        currentChatRoomCount
        totalUnReadMessagesCount {
          chatRoomFilter
          total
        }
        chatRooms {
          chatRoomId
          chatRoomStatus
          rfqId
          isOldRfq
          profileId
          projectName
          organizationName
          serviceType
          thumbnailId
          quotationPartnerId
          quotationPartnerStatus
          unReadCount
          lastMessage {
            ... on CAPAQuotationChatMessageRfq {
              messageType
              rfq {
                rfqId
                quotationId
                purchaseOrderId
                projectName
                userManagerName
                userOrganizationName
                partnerManagerName
                partnerOrganizationName
                adjustRequest
                event
                rejectedReason
                isVisible
              }
            }
            ... on CAPAQuotationChatMessageMessage {
              messageType
              message
            }
            ... on CAPAQuotationChatMessageSimpleQuotation {
              messageType
              quotation {
                quotation
                excludeDeliveryFee
                etc
              }
            }
            ... on CAPAQuotationChatMessageDetailedQuotation {
              messageType
              quotation {
                rfqId
                projectName
                serviceType
                optionalServices {
                  serviceType
                }
                publish {
                  organizationName
                }
                supply {
                  quotationPartnerStatus
                  quotationPartnerId
                  organizationName
                  companyRegistrationNumber
                  managerName
                  address
                }
                dueDate
                expiration
                items {
                  fileId
                  fileName
                  quantity
                  material
                  cost
                  etc
                }
                quotation
                deliveryCost
                createdAt
                maxDraftModificationCount
                draftModificationTerms
                etc
              }
            }
            ... on CAPAQuotationAnnotationCommentMessage {
              messageType
              annotation {
                id
                annotationId
                fileId
                userId
                isParent
                comment
                userName
                status
                edited
                createdAt
                updatedAt
              }
            }
            ... on CAPAQuotationBypassMessage {
              messageType
              bypass {
                id
              }
            }
            ... on CAPAQuotationBypassMessageDeleteMessage {
              messageType
              id
            }
          }
          lastMessageCreatedAt
          rfqStatus
          rfqCreatedAt
          managerName
          shortAddress
          purchaseOrderStatus
          searchProjectStatusTypeEnum
          quantity
        }
      }
    }
  }
`;

/**
 * __useFetchQuotationUserChatRoomsQuery__
 *
 * To run a query within a React component, call `useFetchQuotationUserChatRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchQuotationUserChatRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchQuotationUserChatRoomsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchQuotationUserChatRoomsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchQuotationUserChatRoomsQuery,
    FetchQuotationUserChatRoomsQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchQuotationUserChatRoomsQuery,
    FetchQuotationUserChatRoomsQueryVariables
  >(FetchQuotationUserChatRoomsDocument, baseOptions);
}
export function useFetchQuotationUserChatRoomsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchQuotationUserChatRoomsQuery,
    FetchQuotationUserChatRoomsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchQuotationUserChatRoomsQuery,
    FetchQuotationUserChatRoomsQueryVariables
  >(FetchQuotationUserChatRoomsDocument, baseOptions);
}
export type FetchQuotationUserChatRoomsQueryHookResult = ReturnType<
  typeof useFetchQuotationUserChatRoomsQuery
>;
export type FetchQuotationUserChatRoomsLazyQueryHookResult = ReturnType<
  typeof useFetchQuotationUserChatRoomsLazyQuery
>;
export type FetchQuotationUserChatRoomsQueryResult = Apollo.QueryResult<
  FetchQuotationUserChatRoomsQuery,
  FetchQuotationUserChatRoomsQueryVariables
>;
export const RegisterItpEventDocument = gql`
  mutation registerItpEvent($input: RegisterItpEventInput!) {
    registerItpEvent(input: $input) {
      result
      errorMessage
    }
  }
`;
export type RegisterItpEventMutationFn = Apollo.MutationFunction<
  RegisterItpEventMutation,
  RegisterItpEventMutationVariables
>;

/**
 * __useRegisterItpEventMutation__
 *
 * To run a mutation, you first call `useRegisterItpEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterItpEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerItpEventMutation, { data, loading, error }] = useRegisterItpEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterItpEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterItpEventMutation,
    RegisterItpEventMutationVariables
  >
) {
  return Apollo.useMutation<
    RegisterItpEventMutation,
    RegisterItpEventMutationVariables
  >(RegisterItpEventDocument, baseOptions);
}
export type RegisterItpEventMutationHookResult = ReturnType<
  typeof useRegisterItpEventMutation
>;
export type RegisterItpEventMutationResult = Apollo.MutationResult<
  RegisterItpEventMutation
>;
export type RegisterItpEventMutationOptions = Apollo.BaseMutationOptions<
  RegisterItpEventMutation,
  RegisterItpEventMutationVariables
>;
export const RegisterJsbEventDocument = gql`
  mutation registerJsbEvent($input: RegisterJsbEventInput!) {
    registerJsbEvent(input: $input) {
      result
      errorMessage
    }
  }
`;
export type RegisterJsbEventMutationFn = Apollo.MutationFunction<
  RegisterJsbEventMutation,
  RegisterJsbEventMutationVariables
>;

/**
 * __useRegisterJsbEventMutation__
 *
 * To run a mutation, you first call `useRegisterJsbEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterJsbEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerJsbEventMutation, { data, loading, error }] = useRegisterJsbEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterJsbEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterJsbEventMutation,
    RegisterJsbEventMutationVariables
  >
) {
  return Apollo.useMutation<
    RegisterJsbEventMutation,
    RegisterJsbEventMutationVariables
  >(RegisterJsbEventDocument, baseOptions);
}
export type RegisterJsbEventMutationHookResult = ReturnType<
  typeof useRegisterJsbEventMutation
>;
export type RegisterJsbEventMutationResult = Apollo.MutationResult<
  RegisterJsbEventMutation
>;
export type RegisterJsbEventMutationOptions = Apollo.BaseMutationOptions<
  RegisterJsbEventMutation,
  RegisterJsbEventMutationVariables
>;
export const FetchQuotationUserGnbDocument = gql`
  query fetchQuotationUserGNB {
    fetchQuotationUserGNB {
      result
      errorMessage
      data {
        newChatCount
        newQuotationAndIntroductionCount
        newPaymentManagementCount
      }
    }
  }
`;

/**
 * __useFetchQuotationUserGnbQuery__
 *
 * To run a query within a React component, call `useFetchQuotationUserGnbQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchQuotationUserGnbQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchQuotationUserGnbQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchQuotationUserGnbQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchQuotationUserGnbQuery,
    FetchQuotationUserGnbQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchQuotationUserGnbQuery,
    FetchQuotationUserGnbQueryVariables
  >(FetchQuotationUserGnbDocument, baseOptions);
}
export function useFetchQuotationUserGnbLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchQuotationUserGnbQuery,
    FetchQuotationUserGnbQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchQuotationUserGnbQuery,
    FetchQuotationUserGnbQueryVariables
  >(FetchQuotationUserGnbDocument, baseOptions);
}
export type FetchQuotationUserGnbQueryHookResult = ReturnType<
  typeof useFetchQuotationUserGnbQuery
>;
export type FetchQuotationUserGnbLazyQueryHookResult = ReturnType<
  typeof useFetchQuotationUserGnbLazyQuery
>;
export type FetchQuotationUserGnbQueryResult = Apollo.QueryResult<
  FetchQuotationUserGnbQuery,
  FetchQuotationUserGnbQueryVariables
>;
export const WriteUserActivityLogDocument = gql`
  mutation writeUserActivityLog($input: UserActivityLogInput!) {
    writeUserActivityLog(input: $input) {
      result
      errorMessage
    }
  }
`;
export type WriteUserActivityLogMutationFn = Apollo.MutationFunction<
  WriteUserActivityLogMutation,
  WriteUserActivityLogMutationVariables
>;

/**
 * __useWriteUserActivityLogMutation__
 *
 * To run a mutation, you first call `useWriteUserActivityLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWriteUserActivityLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [writeUserActivityLogMutation, { data, loading, error }] = useWriteUserActivityLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWriteUserActivityLogMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WriteUserActivityLogMutation,
    WriteUserActivityLogMutationVariables
  >
) {
  return Apollo.useMutation<
    WriteUserActivityLogMutation,
    WriteUserActivityLogMutationVariables
  >(WriteUserActivityLogDocument, baseOptions);
}
export type WriteUserActivityLogMutationHookResult = ReturnType<
  typeof useWriteUserActivityLogMutation
>;
export type WriteUserActivityLogMutationResult = Apollo.MutationResult<
  WriteUserActivityLogMutation
>;
export type WriteUserActivityLogMutationOptions = Apollo.BaseMutationOptions<
  WriteUserActivityLogMutation,
  WriteUserActivityLogMutationVariables
>;
export const GetNoticeScheduleBoDocument = gql`
  query getNoticeScheduleBO {
    getNoticeScheduleBO {
      result
      errorMessage
      data {
        id
        startTime
        endTime
        previewStartTime
        previewEndTime
        pageType
        noticeType
        status
      }
    }
  }
`;

/**
 * __useGetNoticeScheduleBoQuery__
 *
 * To run a query within a React component, call `useGetNoticeScheduleBoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoticeScheduleBoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoticeScheduleBoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNoticeScheduleBoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetNoticeScheduleBoQuery,
    GetNoticeScheduleBoQueryVariables
  >
) {
  return Apollo.useQuery<
    GetNoticeScheduleBoQuery,
    GetNoticeScheduleBoQueryVariables
  >(GetNoticeScheduleBoDocument, baseOptions);
}
export function useGetNoticeScheduleBoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNoticeScheduleBoQuery,
    GetNoticeScheduleBoQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetNoticeScheduleBoQuery,
    GetNoticeScheduleBoQueryVariables
  >(GetNoticeScheduleBoDocument, baseOptions);
}
export type GetNoticeScheduleBoQueryHookResult = ReturnType<
  typeof useGetNoticeScheduleBoQuery
>;
export type GetNoticeScheduleBoLazyQueryHookResult = ReturnType<
  typeof useGetNoticeScheduleBoLazyQuery
>;
export type GetNoticeScheduleBoQueryResult = Apollo.QueryResult<
  GetNoticeScheduleBoQuery,
  GetNoticeScheduleBoQueryVariables
>;
export const FetchCapaNotificationDocument = gql`
  query fetchCAPANotification {
    fetchCAPANotification(input: { service: QUOTATION }) {
      errorMessage
      result
      data {
        count
        notifications {
          seq
          serviceType
          read
          createdAt
          data {
            ... on CAPANotificationDefault {
              notificationType
            }
            ... on CAPANotificationRfq {
              notificationType
              serviceType
              rfqId
              projectName
              organizationName
              adjustRequest
              totalAmount
              managerName
              chatRoomId
              refundAmt
              depositAmt
            }
          }
        }
      }
    }
  }
`;

/**
 * __useFetchCapaNotificationQuery__
 *
 * To run a query within a React component, call `useFetchCapaNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCapaNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCapaNotificationQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchCapaNotificationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchCapaNotificationQuery,
    FetchCapaNotificationQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchCapaNotificationQuery,
    FetchCapaNotificationQueryVariables
  >(FetchCapaNotificationDocument, baseOptions);
}
export function useFetchCapaNotificationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCapaNotificationQuery,
    FetchCapaNotificationQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchCapaNotificationQuery,
    FetchCapaNotificationQueryVariables
  >(FetchCapaNotificationDocument, baseOptions);
}
export type FetchCapaNotificationQueryHookResult = ReturnType<
  typeof useFetchCapaNotificationQuery
>;
export type FetchCapaNotificationLazyQueryHookResult = ReturnType<
  typeof useFetchCapaNotificationLazyQuery
>;
export type FetchCapaNotificationQueryResult = Apollo.QueryResult<
  FetchCapaNotificationQuery,
  FetchCapaNotificationQueryVariables
>;
export const SubscribeCapaNotificationDocument = gql`
  subscription subscribeCAPANotification {
    subscribeCAPANotification(input: { serviceType: QUOTATION }) {
      errorMessage
      result
      data {
        count
      }
    }
  }
`;

/**
 * __useSubscribeCapaNotificationSubscription__
 *
 * To run a query within a React component, call `useSubscribeCapaNotificationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeCapaNotificationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeCapaNotificationSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSubscribeCapaNotificationSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    SubscribeCapaNotificationSubscription,
    SubscribeCapaNotificationSubscriptionVariables
  >
) {
  return Apollo.useSubscription<
    SubscribeCapaNotificationSubscription,
    SubscribeCapaNotificationSubscriptionVariables
  >(SubscribeCapaNotificationDocument, baseOptions);
}
export type SubscribeCapaNotificationSubscriptionHookResult = ReturnType<
  typeof useSubscribeCapaNotificationSubscription
>;
export type SubscribeCapaNotificationSubscriptionResult = Apollo.SubscriptionResult<
  SubscribeCapaNotificationSubscription
>;
export const ReadNotificationDocument = gql`
  mutation readNotification($seq: Float) {
    readNotification(input: { service: QUOTATION_PARTNER, seq: $seq }) {
      result
      errorMessage
    }
  }
`;
export type ReadNotificationMutationFn = Apollo.MutationFunction<
  ReadNotificationMutation,
  ReadNotificationMutationVariables
>;

/**
 * __useReadNotificationMutation__
 *
 * To run a mutation, you first call `useReadNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readNotificationMutation, { data, loading, error }] = useReadNotificationMutation({
 *   variables: {
 *      seq: // value for 'seq'
 *   },
 * });
 */
export function useReadNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReadNotificationMutation,
    ReadNotificationMutationVariables
  >
) {
  return Apollo.useMutation<
    ReadNotificationMutation,
    ReadNotificationMutationVariables
  >(ReadNotificationDocument, baseOptions);
}
export type ReadNotificationMutationHookResult = ReturnType<
  typeof useReadNotificationMutation
>;
export type ReadNotificationMutationResult = Apollo.MutationResult<
  ReadNotificationMutation
>;
export type ReadNotificationMutationOptions = Apollo.BaseMutationOptions<
  ReadNotificationMutation,
  ReadNotificationMutationVariables
>;
export const ClearNewNotificationDocument = gql`
  mutation clearNewNotification {
    clearNewNotification(input: { service: QUOTATION }) {
      result
      errorMessage
    }
  }
`;
export type ClearNewNotificationMutationFn = Apollo.MutationFunction<
  ClearNewNotificationMutation,
  ClearNewNotificationMutationVariables
>;

/**
 * __useClearNewNotificationMutation__
 *
 * To run a mutation, you first call `useClearNewNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearNewNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearNewNotificationMutation, { data, loading, error }] = useClearNewNotificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useClearNewNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ClearNewNotificationMutation,
    ClearNewNotificationMutationVariables
  >
) {
  return Apollo.useMutation<
    ClearNewNotificationMutation,
    ClearNewNotificationMutationVariables
  >(ClearNewNotificationDocument, baseOptions);
}
export type ClearNewNotificationMutationHookResult = ReturnType<
  typeof useClearNewNotificationMutation
>;
export type ClearNewNotificationMutationResult = Apollo.MutationResult<
  ClearNewNotificationMutation
>;
export type ClearNewNotificationMutationOptions = Apollo.BaseMutationOptions<
  ClearNewNotificationMutation,
  ClearNewNotificationMutationVariables
>;
export const FetchQuotationPartnerActivityDocument = gql`
  query fetchQuotationPartnerActivity($quotationPartnerId: String) {
    fetchQuotationPartnerActivity(
      input: { quotationPartnerId: $quotationPartnerId }
    ) {
      result
      errorMessage
      data {
        complete
        confirmed
      }
    }
  }
`;

/**
 * __useFetchQuotationPartnerActivityQuery__
 *
 * To run a query within a React component, call `useFetchQuotationPartnerActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchQuotationPartnerActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchQuotationPartnerActivityQuery({
 *   variables: {
 *      quotationPartnerId: // value for 'quotationPartnerId'
 *   },
 * });
 */
export function useFetchQuotationPartnerActivityQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchQuotationPartnerActivityQuery,
    FetchQuotationPartnerActivityQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchQuotationPartnerActivityQuery,
    FetchQuotationPartnerActivityQueryVariables
  >(FetchQuotationPartnerActivityDocument, baseOptions);
}
export function useFetchQuotationPartnerActivityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchQuotationPartnerActivityQuery,
    FetchQuotationPartnerActivityQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchQuotationPartnerActivityQuery,
    FetchQuotationPartnerActivityQueryVariables
  >(FetchQuotationPartnerActivityDocument, baseOptions);
}
export type FetchQuotationPartnerActivityQueryHookResult = ReturnType<
  typeof useFetchQuotationPartnerActivityQuery
>;
export type FetchQuotationPartnerActivityLazyQueryHookResult = ReturnType<
  typeof useFetchQuotationPartnerActivityLazyQuery
>;
export type FetchQuotationPartnerActivityQueryResult = Apollo.QueryResult<
  FetchQuotationPartnerActivityQuery,
  FetchQuotationPartnerActivityQueryVariables
>;
export const FetchWithdrawnQuotationPartnerDocument = gql`
  query fetchWithdrawnQuotationPartner($quotationPartnerId: String!) {
    fetchWithdrawnQuotationPartner(quotationPartnerId: $quotationPartnerId) {
      result
      errorMessage
      data {
        id
        status
        capabilities {
          services {
            service
            status
            detailedServices {
              materials {
                detailedMaterials
              }
              type
            }
            optionalServices
          }
        }
        organizationName
        fullAddress
        shortAddress
        companyRegistrationNumber
        companyIntroduction
        foundedIn
        numberEmployees
        serviceHours
        managerName
        department
        position
        contact
        notificationFilter {
          chatEmail
          chatSMS
          chatPush
          rfqEmail
          rfqSMS
          rfqPush
          capabilityFilters {
            email
            sms
            push
            service
            detailedServices
            optionalServices
          }
          doNotDisturb {
            isActive
            to
            from
          }
          projectEmail
          projectSMS
          projectFilters {
            email
            sms
            service
          }
          newsEmail
          newsSMS
        }
        rfqFilter
        serviceAgreed
        privacyAgreed
        promotionAgreed
        referralUserId
        isItp
        createdAt
        updatedAt
        logo {
          id
          fileId
          fileName
          fileType
          fileMimetype
          fileSize
          fileExtension
        }
        cover {
          id
          fileId
          fileName
          fileType
          fileMimetype
          fileSize
          fileExtension
        }
        partnerFiles {
          id
          fileId
          fileName
          fileType
          fileMimetype
          fileSize
          fileExtension
          videoThumbnailFileId
          youtubeURL
        }
        portfolios {
          id
          projectName
          client
          description
          capabilities {
            service
            detailedServices
          }
          projectPurpose
          productType
          quantity
          produceStep
          files {
            id
            fileId
            fileName
            fileType
            fileMimetype
            fileSize
            fileExtension
          }
        }
        equipments {
          id
          equipmentName
          quantity
          description
          file {
            id
            fileId
            fileName
            fileType
            fileMimetype
            fileSize
            fileExtension
          }
          createdAt
        }
        certifications {
          id
          quotationPartnerId
          strategyFileId
          file {
            id
            fileId
            fileName
            fileType
            fileMimetype
            fileSize
            fileExtension
          }
          technicalName
          certificationAuthority
          expirationPeriodStart
          expirationPeriodEnd
          description
          technologyType
        }
        patents {
          id
          quotationPartnerId
          strategyFileId
          file {
            id
            fileId
            fileName
            fileType
            fileMimetype
            fileSize
            fileExtension
          }
          technicalName
          certificationAuthority
          expirationPeriodStart
          expirationPeriodEnd
          description
          technologyType
        }
        factoryAddress
        averageResponseTime
        transactionCount
        promotionModels {
          id
          quotationPartnerId
          capaBlogLink
          status
        }
        partnerPageViewCount
        registrations {
          id
          fileId
          videoThumbnailFileId
        }
        haveSubmall
      }
    }
  }
`;

/**
 * __useFetchWithdrawnQuotationPartnerQuery__
 *
 * To run a query within a React component, call `useFetchWithdrawnQuotationPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchWithdrawnQuotationPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchWithdrawnQuotationPartnerQuery({
 *   variables: {
 *      quotationPartnerId: // value for 'quotationPartnerId'
 *   },
 * });
 */
export function useFetchWithdrawnQuotationPartnerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchWithdrawnQuotationPartnerQuery,
    FetchWithdrawnQuotationPartnerQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchWithdrawnQuotationPartnerQuery,
    FetchWithdrawnQuotationPartnerQueryVariables
  >(FetchWithdrawnQuotationPartnerDocument, baseOptions);
}
export function useFetchWithdrawnQuotationPartnerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchWithdrawnQuotationPartnerQuery,
    FetchWithdrawnQuotationPartnerQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchWithdrawnQuotationPartnerQuery,
    FetchWithdrawnQuotationPartnerQueryVariables
  >(FetchWithdrawnQuotationPartnerDocument, baseOptions);
}
export type FetchWithdrawnQuotationPartnerQueryHookResult = ReturnType<
  typeof useFetchWithdrawnQuotationPartnerQuery
>;
export type FetchWithdrawnQuotationPartnerLazyQueryHookResult = ReturnType<
  typeof useFetchWithdrawnQuotationPartnerLazyQuery
>;
export type FetchWithdrawnQuotationPartnerQueryResult = Apollo.QueryResult<
  FetchWithdrawnQuotationPartnerQuery,
  FetchWithdrawnQuotationPartnerQueryVariables
>;
export const FetchQuotationPartnerDocument = gql`
  query fetchQuotationPartner($quotationPartnerId: String!) {
    fetchQuotationPartner(quotationPartnerId: $quotationPartnerId) {
      result
      errorMessage
      data {
        id
        status
        capabilities {
          services {
            service
            status
            detailedServices {
              materials {
                detailedMaterials
              }
              type
            }
            optionalServices
          }
        }
        organizationName
        fullAddress
        shortAddress
        companyRegistrationNumber
        companyIntroduction
        foundedIn
        numberEmployees
        serviceHours
        managerName
        department
        position
        contact
        notificationFilter {
          chatEmail
          chatSMS
          chatPush
          rfqEmail
          rfqSMS
          rfqPush
          capabilityFilters {
            email
            sms
            push
            service
            detailedServices
            optionalServices
          }
          doNotDisturb {
            isActive
            to
            from
          }
          projectEmail
          projectSMS
          projectFilters {
            email
            sms
            service
          }
          newsEmail
          newsSMS
        }
        rfqFilter
        serviceAgreed
        privacyAgreed
        promotionAgreed
        referralUserId
        isItp
        createdAt
        updatedAt
        logo {
          id
          fileId
          fileName
          fileType
          fileMimetype
          fileSize
          fileExtension
        }
        cover {
          id
          fileId
          fileName
          fileType
          fileMimetype
          fileSize
          fileExtension
        }
        partnerFiles {
          id
          fileId
          fileName
          fileType
          fileMimetype
          fileSize
          fileExtension
          videoThumbnailFileId
          youtubeURL
        }
        portfolios {
          id
          projectName
          client
          description
          capabilities {
            service
            detailedServices
          }
          projectPurpose
          productType
          quantity
          produceStep
          files {
            id
            fileId
            fileName
            fileType
            fileMimetype
            fileSize
            fileExtension
          }
        }
        equipments {
          id
          equipmentName
          quantity
          description
          file {
            id
            fileId
            fileName
            fileType
            fileMimetype
            fileSize
            fileExtension
          }
          createdAt
        }
        certifications {
          id
          quotationPartnerId
          strategyFileId
          file {
            id
            fileId
            fileName
            fileType
            fileMimetype
            fileSize
            fileExtension
          }
          technicalName
          certificationAuthority
          expirationPeriodStart
          expirationPeriodEnd
          description
          technologyType
        }
        patents {
          id
          quotationPartnerId
          strategyFileId
          file {
            id
            fileId
            fileName
            fileType
            fileMimetype
            fileSize
            fileExtension
          }
          technicalName
          certificationAuthority
          expirationPeriodStart
          expirationPeriodEnd
          description
          technologyType
        }
        factoryAddress
        averageResponseTime
        transactionCount
        promotionModels {
          id
          quotationPartnerId
          capaBlogLink
          status
        }
        partnerPageViewCount
        registrations {
          id
          fileId
          videoThumbnailFileId
        }
        reviews {
          reviewAveragePoint
          reviewCount
          reviewPointRatio {
            one
            two
            three
            four
            five
          }
          reviews {
            id
            projectName
            organizationName
            profileId
            managerName
            isEditable
            reviewComment
            reviewPoint
            serviceType
            reviewFiles {
              fileId
              fileName
            }
            reviewFileCount
            indueDate
            reviewedAt
            purchaseOrderValue
          }
        }
        haveSubmall
      }
    }
  }
`;

/**
 * __useFetchQuotationPartnerQuery__
 *
 * To run a query within a React component, call `useFetchQuotationPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchQuotationPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchQuotationPartnerQuery({
 *   variables: {
 *      quotationPartnerId: // value for 'quotationPartnerId'
 *   },
 * });
 */
export function useFetchQuotationPartnerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchQuotationPartnerQuery,
    FetchQuotationPartnerQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchQuotationPartnerQuery,
    FetchQuotationPartnerQueryVariables
  >(FetchQuotationPartnerDocument, baseOptions);
}
export function useFetchQuotationPartnerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchQuotationPartnerQuery,
    FetchQuotationPartnerQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchQuotationPartnerQuery,
    FetchQuotationPartnerQueryVariables
  >(FetchQuotationPartnerDocument, baseOptions);
}
export type FetchQuotationPartnerQueryHookResult = ReturnType<
  typeof useFetchQuotationPartnerQuery
>;
export type FetchQuotationPartnerLazyQueryHookResult = ReturnType<
  typeof useFetchQuotationPartnerLazyQuery
>;
export type FetchQuotationPartnerQueryResult = Apollo.QueryResult<
  FetchQuotationPartnerQuery,
  FetchQuotationPartnerQueryVariables
>;
export const FetchRfqPartnerEvaluationDocument = gql`
  query fetchRfqPartnerEvaluation($quotationPartnerId: String) {
    fetchRfqPartnerEvaluation(
      input: { quotationPartnerId: $quotationPartnerId }
    ) {
      result
      errorMessage
      data {
        kind
        quick
        detailed
        helpful
      }
    }
  }
`;

/**
 * __useFetchRfqPartnerEvaluationQuery__
 *
 * To run a query within a React component, call `useFetchRfqPartnerEvaluationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRfqPartnerEvaluationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRfqPartnerEvaluationQuery({
 *   variables: {
 *      quotationPartnerId: // value for 'quotationPartnerId'
 *   },
 * });
 */
export function useFetchRfqPartnerEvaluationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchRfqPartnerEvaluationQuery,
    FetchRfqPartnerEvaluationQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchRfqPartnerEvaluationQuery,
    FetchRfqPartnerEvaluationQueryVariables
  >(FetchRfqPartnerEvaluationDocument, baseOptions);
}
export function useFetchRfqPartnerEvaluationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchRfqPartnerEvaluationQuery,
    FetchRfqPartnerEvaluationQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchRfqPartnerEvaluationQuery,
    FetchRfqPartnerEvaluationQueryVariables
  >(FetchRfqPartnerEvaluationDocument, baseOptions);
}
export type FetchRfqPartnerEvaluationQueryHookResult = ReturnType<
  typeof useFetchRfqPartnerEvaluationQuery
>;
export type FetchRfqPartnerEvaluationLazyQueryHookResult = ReturnType<
  typeof useFetchRfqPartnerEvaluationLazyQuery
>;
export type FetchRfqPartnerEvaluationQueryResult = Apollo.QueryResult<
  FetchRfqPartnerEvaluationQuery,
  FetchRfqPartnerEvaluationQueryVariables
>;
export const SendSystemChatMessageDocument = gql`
  mutation sendSystemChatMessage($input: SendSystemChatMessageInput!) {
    sendSystemChatMessage(input: $input) {
      result
      errorMessage
    }
  }
`;
export type SendSystemChatMessageMutationFn = Apollo.MutationFunction<
  SendSystemChatMessageMutation,
  SendSystemChatMessageMutationVariables
>;

/**
 * __useSendSystemChatMessageMutation__
 *
 * To run a mutation, you first call `useSendSystemChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSystemChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSystemChatMessageMutation, { data, loading, error }] = useSendSystemChatMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSystemChatMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendSystemChatMessageMutation,
    SendSystemChatMessageMutationVariables
  >
) {
  return Apollo.useMutation<
    SendSystemChatMessageMutation,
    SendSystemChatMessageMutationVariables
  >(SendSystemChatMessageDocument, baseOptions);
}
export type SendSystemChatMessageMutationHookResult = ReturnType<
  typeof useSendSystemChatMessageMutation
>;
export type SendSystemChatMessageMutationResult = Apollo.MutationResult<
  SendSystemChatMessageMutation
>;
export type SendSystemChatMessageMutationOptions = Apollo.BaseMutationOptions<
  SendSystemChatMessageMutation,
  SendSystemChatMessageMutationVariables
>;
export const DelayConfirmEscrowPurchaseDocument = gql`
  mutation delayConfirmEscrowPurchase(
    $input: DelayConfirmEscrowPurchaseInput!
  ) {
    delayConfirmEscrowPurchase(input: $input) {
      result
      errorMessage
    }
  }
`;
export type DelayConfirmEscrowPurchaseMutationFn = Apollo.MutationFunction<
  DelayConfirmEscrowPurchaseMutation,
  DelayConfirmEscrowPurchaseMutationVariables
>;

/**
 * __useDelayConfirmEscrowPurchaseMutation__
 *
 * To run a mutation, you first call `useDelayConfirmEscrowPurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelayConfirmEscrowPurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [delayConfirmEscrowPurchaseMutation, { data, loading, error }] = useDelayConfirmEscrowPurchaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDelayConfirmEscrowPurchaseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DelayConfirmEscrowPurchaseMutation,
    DelayConfirmEscrowPurchaseMutationVariables
  >
) {
  return Apollo.useMutation<
    DelayConfirmEscrowPurchaseMutation,
    DelayConfirmEscrowPurchaseMutationVariables
  >(DelayConfirmEscrowPurchaseDocument, baseOptions);
}
export type DelayConfirmEscrowPurchaseMutationHookResult = ReturnType<
  typeof useDelayConfirmEscrowPurchaseMutation
>;
export type DelayConfirmEscrowPurchaseMutationResult = Apollo.MutationResult<
  DelayConfirmEscrowPurchaseMutation
>;
export type DelayConfirmEscrowPurchaseMutationOptions = Apollo.BaseMutationOptions<
  DelayConfirmEscrowPurchaseMutation,
  DelayConfirmEscrowPurchaseMutationVariables
>;
export const CreatePaymentAfterCreatePurchaseOrderDocument = gql`
  mutation createPaymentAfterCreatePurchaseOrder($input: CreatePaymentInput!) {
    createPaymentAfterCreatePurchaseOrder(input: $input) {
      result
      errorMessage
    }
  }
`;
export type CreatePaymentAfterCreatePurchaseOrderMutationFn = Apollo.MutationFunction<
  CreatePaymentAfterCreatePurchaseOrderMutation,
  CreatePaymentAfterCreatePurchaseOrderMutationVariables
>;

/**
 * __useCreatePaymentAfterCreatePurchaseOrderMutation__
 *
 * To run a mutation, you first call `useCreatePaymentAfterCreatePurchaseOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentAfterCreatePurchaseOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentAfterCreatePurchaseOrderMutation, { data, loading, error }] = useCreatePaymentAfterCreatePurchaseOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaymentAfterCreatePurchaseOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePaymentAfterCreatePurchaseOrderMutation,
    CreatePaymentAfterCreatePurchaseOrderMutationVariables
  >
) {
  return Apollo.useMutation<
    CreatePaymentAfterCreatePurchaseOrderMutation,
    CreatePaymentAfterCreatePurchaseOrderMutationVariables
  >(CreatePaymentAfterCreatePurchaseOrderDocument, baseOptions);
}
export type CreatePaymentAfterCreatePurchaseOrderMutationHookResult = ReturnType<
  typeof useCreatePaymentAfterCreatePurchaseOrderMutation
>;
export type CreatePaymentAfterCreatePurchaseOrderMutationResult = Apollo.MutationResult<
  CreatePaymentAfterCreatePurchaseOrderMutation
>;
export type CreatePaymentAfterCreatePurchaseOrderMutationOptions = Apollo.BaseMutationOptions<
  CreatePaymentAfterCreatePurchaseOrderMutation,
  CreatePaymentAfterCreatePurchaseOrderMutationVariables
>;
export const FetchMyRefundBankAccountsDocument = gql`
  query fetchMyRefundBankAccounts {
    fetchMyRefundBankAccounts {
      result
      errorMessage
      data {
        id
        quotationUserId
        seq
        bankCode
        account
        holderName
        holderPhone
        createdAt
        updatedAt
      }
    }
  }
`;

/**
 * __useFetchMyRefundBankAccountsQuery__
 *
 * To run a query within a React component, call `useFetchMyRefundBankAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMyRefundBankAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMyRefundBankAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchMyRefundBankAccountsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchMyRefundBankAccountsQuery,
    FetchMyRefundBankAccountsQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchMyRefundBankAccountsQuery,
    FetchMyRefundBankAccountsQueryVariables
  >(FetchMyRefundBankAccountsDocument, baseOptions);
}
export function useFetchMyRefundBankAccountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchMyRefundBankAccountsQuery,
    FetchMyRefundBankAccountsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchMyRefundBankAccountsQuery,
    FetchMyRefundBankAccountsQueryVariables
  >(FetchMyRefundBankAccountsDocument, baseOptions);
}
export type FetchMyRefundBankAccountsQueryHookResult = ReturnType<
  typeof useFetchMyRefundBankAccountsQuery
>;
export type FetchMyRefundBankAccountsLazyQueryHookResult = ReturnType<
  typeof useFetchMyRefundBankAccountsLazyQuery
>;
export type FetchMyRefundBankAccountsQueryResult = Apollo.QueryResult<
  FetchMyRefundBankAccountsQuery,
  FetchMyRefundBankAccountsQueryVariables
>;
export const FetchMyPaymentDataByQuotationUserDocument = gql`
  query fetchMyPaymentDataByQuotationUser(
    $input: FetchPaymentManageByQuotationUserIdInput!
  ) {
    fetchMyPaymentDataByQuotationUser(input: $input) {
      result
      errorMessage
      data {
        purchaseOrderInfoList {
          ...PurchaseOrderModel
        }
        estimatedAmount
        completionAmount
        totalCount
        point
      }
    }
  }
  ${PurchaseOrderModelFragmentDoc}
`;

/**
 * __useFetchMyPaymentDataByQuotationUserQuery__
 *
 * To run a query within a React component, call `useFetchMyPaymentDataByQuotationUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMyPaymentDataByQuotationUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMyPaymentDataByQuotationUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchMyPaymentDataByQuotationUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchMyPaymentDataByQuotationUserQuery,
    FetchMyPaymentDataByQuotationUserQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchMyPaymentDataByQuotationUserQuery,
    FetchMyPaymentDataByQuotationUserQueryVariables
  >(FetchMyPaymentDataByQuotationUserDocument, baseOptions);
}
export function useFetchMyPaymentDataByQuotationUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchMyPaymentDataByQuotationUserQuery,
    FetchMyPaymentDataByQuotationUserQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchMyPaymentDataByQuotationUserQuery,
    FetchMyPaymentDataByQuotationUserQueryVariables
  >(FetchMyPaymentDataByQuotationUserDocument, baseOptions);
}
export type FetchMyPaymentDataByQuotationUserQueryHookResult = ReturnType<
  typeof useFetchMyPaymentDataByQuotationUserQuery
>;
export type FetchMyPaymentDataByQuotationUserLazyQueryHookResult = ReturnType<
  typeof useFetchMyPaymentDataByQuotationUserLazyQuery
>;
export type FetchMyPaymentDataByQuotationUserQueryResult = Apollo.QueryResult<
  FetchMyPaymentDataByQuotationUserQuery,
  FetchMyPaymentDataByQuotationUserQueryVariables
>;
export const CreateMyRefundAccountByQuotationUserDocument = gql`
  mutation createMyRefundAccountByQuotationUser(
    $input: CreateMyRefundAccountInput!
  ) {
    createMyRefundAccountByQuotationUser(input: $input) {
      result
      errorMessage
    }
  }
`;
export type CreateMyRefundAccountByQuotationUserMutationFn = Apollo.MutationFunction<
  CreateMyRefundAccountByQuotationUserMutation,
  CreateMyRefundAccountByQuotationUserMutationVariables
>;

/**
 * __useCreateMyRefundAccountByQuotationUserMutation__
 *
 * To run a mutation, you first call `useCreateMyRefundAccountByQuotationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyRefundAccountByQuotationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyRefundAccountByQuotationUserMutation, { data, loading, error }] = useCreateMyRefundAccountByQuotationUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMyRefundAccountByQuotationUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMyRefundAccountByQuotationUserMutation,
    CreateMyRefundAccountByQuotationUserMutationVariables
  >
) {
  return Apollo.useMutation<
    CreateMyRefundAccountByQuotationUserMutation,
    CreateMyRefundAccountByQuotationUserMutationVariables
  >(CreateMyRefundAccountByQuotationUserDocument, baseOptions);
}
export type CreateMyRefundAccountByQuotationUserMutationHookResult = ReturnType<
  typeof useCreateMyRefundAccountByQuotationUserMutation
>;
export type CreateMyRefundAccountByQuotationUserMutationResult = Apollo.MutationResult<
  CreateMyRefundAccountByQuotationUserMutation
>;
export type CreateMyRefundAccountByQuotationUserMutationOptions = Apollo.BaseMutationOptions<
  CreateMyRefundAccountByQuotationUserMutation,
  CreateMyRefundAccountByQuotationUserMutationVariables
>;
export const DeleteMyRefundAccountByQuotationUserDocument = gql`
  mutation deleteMyRefundAccountByQuotationUser(
    $input: DeleteMyRefundAccountInput!
  ) {
    deleteMyRefundAccountByQuotationUser(input: $input) {
      result
      errorMessage
    }
  }
`;
export type DeleteMyRefundAccountByQuotationUserMutationFn = Apollo.MutationFunction<
  DeleteMyRefundAccountByQuotationUserMutation,
  DeleteMyRefundAccountByQuotationUserMutationVariables
>;

/**
 * __useDeleteMyRefundAccountByQuotationUserMutation__
 *
 * To run a mutation, you first call `useDeleteMyRefundAccountByQuotationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMyRefundAccountByQuotationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMyRefundAccountByQuotationUserMutation, { data, loading, error }] = useDeleteMyRefundAccountByQuotationUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMyRefundAccountByQuotationUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteMyRefundAccountByQuotationUserMutation,
    DeleteMyRefundAccountByQuotationUserMutationVariables
  >
) {
  return Apollo.useMutation<
    DeleteMyRefundAccountByQuotationUserMutation,
    DeleteMyRefundAccountByQuotationUserMutationVariables
  >(DeleteMyRefundAccountByQuotationUserDocument, baseOptions);
}
export type DeleteMyRefundAccountByQuotationUserMutationHookResult = ReturnType<
  typeof useDeleteMyRefundAccountByQuotationUserMutation
>;
export type DeleteMyRefundAccountByQuotationUserMutationResult = Apollo.MutationResult<
  DeleteMyRefundAccountByQuotationUserMutation
>;
export type DeleteMyRefundAccountByQuotationUserMutationOptions = Apollo.BaseMutationOptions<
  DeleteMyRefundAccountByQuotationUserMutation,
  DeleteMyRefundAccountByQuotationUserMutationVariables
>;
export const CanEditRefundAccountDocument = gql`
  query canEditRefundAccount {
    canEditRefundAccount {
      result
      errorMessage
      data {
        canEditRefundAccount
      }
    }
  }
`;

/**
 * __useCanEditRefundAccountQuery__
 *
 * To run a query within a React component, call `useCanEditRefundAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanEditRefundAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanEditRefundAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useCanEditRefundAccountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CanEditRefundAccountQuery,
    CanEditRefundAccountQueryVariables
  >
) {
  return Apollo.useQuery<
    CanEditRefundAccountQuery,
    CanEditRefundAccountQueryVariables
  >(CanEditRefundAccountDocument, baseOptions);
}
export function useCanEditRefundAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CanEditRefundAccountQuery,
    CanEditRefundAccountQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    CanEditRefundAccountQuery,
    CanEditRefundAccountQueryVariables
  >(CanEditRefundAccountDocument, baseOptions);
}
export type CanEditRefundAccountQueryHookResult = ReturnType<
  typeof useCanEditRefundAccountQuery
>;
export type CanEditRefundAccountLazyQueryHookResult = ReturnType<
  typeof useCanEditRefundAccountLazyQuery
>;
export type CanEditRefundAccountQueryResult = Apollo.QueryResult<
  CanEditRefundAccountQuery,
  CanEditRefundAccountQueryVariables
>;
export const CreatePurchaseOrderDocument = gql`
  mutation createPurchaseOrder($input: CreatePurchaseOrderInput!) {
    createPurchaseOrder(input: $input) {
      result
      data {
        purchaseOrderId
      }
      errorMessage
    }
  }
`;
export type CreatePurchaseOrderMutationFn = Apollo.MutationFunction<
  CreatePurchaseOrderMutation,
  CreatePurchaseOrderMutationVariables
>;

/**
 * __useCreatePurchaseOrderMutation__
 *
 * To run a mutation, you first call `useCreatePurchaseOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePurchaseOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPurchaseOrderMutation, { data, loading, error }] = useCreatePurchaseOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePurchaseOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePurchaseOrderMutation,
    CreatePurchaseOrderMutationVariables
  >
) {
  return Apollo.useMutation<
    CreatePurchaseOrderMutation,
    CreatePurchaseOrderMutationVariables
  >(CreatePurchaseOrderDocument, baseOptions);
}
export type CreatePurchaseOrderMutationHookResult = ReturnType<
  typeof useCreatePurchaseOrderMutation
>;
export type CreatePurchaseOrderMutationResult = Apollo.MutationResult<
  CreatePurchaseOrderMutation
>;
export type CreatePurchaseOrderMutationOptions = Apollo.BaseMutationOptions<
  CreatePurchaseOrderMutation,
  CreatePurchaseOrderMutationVariables
>;
export const FetchPurchaseOrdersDocument = gql`
  query fetchPurchaseOrders($input: FetchPurchaseOrdersInput!) {
    fetchPurchaseOrders(input: $input) {
      result
      errorMessage
      data {
        id
        rfqId
        chatRoomId
        latest
        receiver {
          quotationPartnerStatus
          quotationPartnerId
          organizationName
          managerName
          quotationPartnerStatus
          companyRegistrationNumber
        }
        publish {
          quotationUserStatus
          organizationName
          managerName
          companyRegistrationNumber
        }
        pcb {
          services {
            serviceType
          }
          fabricationFiles {
            fileId
            fileName
            quantity
            thickness
            fileSize
          }
          assemblyFiles {
            fileId
            fileName
            quantity
            fileSize
          }
          fabricationQuantity
          assemblyQuantity
          assemblyMethod {
            methodType
          }
          metalMaskAvailablity
          materialSupplyMethod
        }
        items {
          fileId
          fileName
          quantity
          material
          cost
          etc
        }
        pcbFabricationItems {
          fileId
          fileName
          quantity
          thickness
          cost
          etc
        }
        pcbAssemblyItems {
          fileId
          fileName
          quantity
          cost
          etc
        }
        quotation
        deliveryCost
        maxDraftModificationCount
        draftModificationTerms
        inspectionPeriod
        inspections {
          inspectionType
          inspectionRequest
        }
        shipDate
        shipAddress
        shipDetailAddress
        transfer {
          transferTerms
          transferStorage
        }
        payments {
          provisionDate
          provisionCost
          provisionPercent
          provisionType
          provisionEtc
        }
        adjustRequest {
          read
          message
        }
        paymentCancelData {
          amount
          reason
        }
        read
        isConfirmed
        isRejected
        createdAt
        quotationCreatedAt
        status
        paymentAmount
        paymentDataList {
          quotationId
          quotationUserId
          quotationPartnerUserId
          quotationPartnerId
          rfqId
          purchaseOrderId
          totalAmount
          pgProvider
          paymentMethod
          createdAt
          paidAt
          confirmedAt
          virtualAccount {
            accountNumber
            bankCode
            bankName
            bankHolder
            dueDate
            issuedAt
          }
          cardInfo {
            cardCode
            cardName
            cardQuota
            cardNumber
            cardType
          }
        }
        shippingDataList {
          id
          shippingCompany
          invoiceNumber
          isExtended
          extendReason
          isRegistered
          registerExpectedDate
          extendedPurchaseConfirmDate
        }
      }
    }
  }
`;

/**
 * __useFetchPurchaseOrdersQuery__
 *
 * To run a query within a React component, call `useFetchPurchaseOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPurchaseOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPurchaseOrdersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchPurchaseOrdersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchPurchaseOrdersQuery,
    FetchPurchaseOrdersQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchPurchaseOrdersQuery,
    FetchPurchaseOrdersQueryVariables
  >(FetchPurchaseOrdersDocument, baseOptions);
}
export function useFetchPurchaseOrdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchPurchaseOrdersQuery,
    FetchPurchaseOrdersQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchPurchaseOrdersQuery,
    FetchPurchaseOrdersQueryVariables
  >(FetchPurchaseOrdersDocument, baseOptions);
}
export type FetchPurchaseOrdersQueryHookResult = ReturnType<
  typeof useFetchPurchaseOrdersQuery
>;
export type FetchPurchaseOrdersLazyQueryHookResult = ReturnType<
  typeof useFetchPurchaseOrdersLazyQuery
>;
export type FetchPurchaseOrdersQueryResult = Apollo.QueryResult<
  FetchPurchaseOrdersQuery,
  FetchPurchaseOrdersQueryVariables
>;
export const UpdatePurchaseOrderStatusDocument = gql`
  mutation updatePurchaseOrderStatus($input: UpdatePurchaseOrderStatusInput!) {
    updatePurchaseOrderStatus(input: $input) {
      result
      errorMessage
    }
  }
`;
export type UpdatePurchaseOrderStatusMutationFn = Apollo.MutationFunction<
  UpdatePurchaseOrderStatusMutation,
  UpdatePurchaseOrderStatusMutationVariables
>;

/**
 * __useUpdatePurchaseOrderStatusMutation__
 *
 * To run a mutation, you first call `useUpdatePurchaseOrderStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePurchaseOrderStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePurchaseOrderStatusMutation, { data, loading, error }] = useUpdatePurchaseOrderStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePurchaseOrderStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePurchaseOrderStatusMutation,
    UpdatePurchaseOrderStatusMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdatePurchaseOrderStatusMutation,
    UpdatePurchaseOrderStatusMutationVariables
  >(UpdatePurchaseOrderStatusDocument, baseOptions);
}
export type UpdatePurchaseOrderStatusMutationHookResult = ReturnType<
  typeof useUpdatePurchaseOrderStatusMutation
>;
export type UpdatePurchaseOrderStatusMutationResult = Apollo.MutationResult<
  UpdatePurchaseOrderStatusMutation
>;
export type UpdatePurchaseOrderStatusMutationOptions = Apollo.BaseMutationOptions<
  UpdatePurchaseOrderStatusMutation,
  UpdatePurchaseOrderStatusMutationVariables
>;
export const ReadRfqQuotationDocument = gql`
  mutation readRfqQuotation($input: ReadRfqQuotationInput!) {
    readRfqQuotation(input: $input) {
      result
      errorMessage
    }
  }
`;
export type ReadRfqQuotationMutationFn = Apollo.MutationFunction<
  ReadRfqQuotationMutation,
  ReadRfqQuotationMutationVariables
>;

/**
 * __useReadRfqQuotationMutation__
 *
 * To run a mutation, you first call `useReadRfqQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadRfqQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readRfqQuotationMutation, { data, loading, error }] = useReadRfqQuotationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReadRfqQuotationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReadRfqQuotationMutation,
    ReadRfqQuotationMutationVariables
  >
) {
  return Apollo.useMutation<
    ReadRfqQuotationMutation,
    ReadRfqQuotationMutationVariables
  >(ReadRfqQuotationDocument, baseOptions);
}
export type ReadRfqQuotationMutationHookResult = ReturnType<
  typeof useReadRfqQuotationMutation
>;
export type ReadRfqQuotationMutationResult = Apollo.MutationResult<
  ReadRfqQuotationMutation
>;
export type ReadRfqQuotationMutationOptions = Apollo.BaseMutationOptions<
  ReadRfqQuotationMutation,
  ReadRfqQuotationMutationVariables
>;
export const RequestAdjustRfqQuotationDocument = gql`
  mutation requestAdjustRfqQuotation($input: RequestAdjustRfqQuotationInput!) {
    requestAdjustRfqQuotation(input: $input) {
      result
      errorMessage
    }
  }
`;
export type RequestAdjustRfqQuotationMutationFn = Apollo.MutationFunction<
  RequestAdjustRfqQuotationMutation,
  RequestAdjustRfqQuotationMutationVariables
>;

/**
 * __useRequestAdjustRfqQuotationMutation__
 *
 * To run a mutation, you first call `useRequestAdjustRfqQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAdjustRfqQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAdjustRfqQuotationMutation, { data, loading, error }] = useRequestAdjustRfqQuotationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestAdjustRfqQuotationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestAdjustRfqQuotationMutation,
    RequestAdjustRfqQuotationMutationVariables
  >
) {
  return Apollo.useMutation<
    RequestAdjustRfqQuotationMutation,
    RequestAdjustRfqQuotationMutationVariables
  >(RequestAdjustRfqQuotationDocument, baseOptions);
}
export type RequestAdjustRfqQuotationMutationHookResult = ReturnType<
  typeof useRequestAdjustRfqQuotationMutation
>;
export type RequestAdjustRfqQuotationMutationResult = Apollo.MutationResult<
  RequestAdjustRfqQuotationMutation
>;
export type RequestAdjustRfqQuotationMutationOptions = Apollo.BaseMutationOptions<
  RequestAdjustRfqQuotationMutation,
  RequestAdjustRfqQuotationMutationVariables
>;
export const ConfirmRfqQuotationDocument = gql`
  mutation confirmRfqQuotation($input: ConfirmRfqQuotationInput!) {
    confirmRfqQuotation(input: $input) {
      result
      errorMessage
    }
  }
`;
export type ConfirmRfqQuotationMutationFn = Apollo.MutationFunction<
  ConfirmRfqQuotationMutation,
  ConfirmRfqQuotationMutationVariables
>;

/**
 * __useConfirmRfqQuotationMutation__
 *
 * To run a mutation, you first call `useConfirmRfqQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmRfqQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmRfqQuotationMutation, { data, loading, error }] = useConfirmRfqQuotationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmRfqQuotationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConfirmRfqQuotationMutation,
    ConfirmRfqQuotationMutationVariables
  >
) {
  return Apollo.useMutation<
    ConfirmRfqQuotationMutation,
    ConfirmRfqQuotationMutationVariables
  >(ConfirmRfqQuotationDocument, baseOptions);
}
export type ConfirmRfqQuotationMutationHookResult = ReturnType<
  typeof useConfirmRfqQuotationMutation
>;
export type ConfirmRfqQuotationMutationResult = Apollo.MutationResult<
  ConfirmRfqQuotationMutation
>;
export type ConfirmRfqQuotationMutationOptions = Apollo.BaseMutationOptions<
  ConfirmRfqQuotationMutation,
  ConfirmRfqQuotationMutationVariables
>;
export const FetchRfqQuotationPdfDocument = gql`
  query fetchRfqQuotationPdf($input: RequestRfqQuotationPdfInput) {
    fetchRfqQuotationPdf(input: $input) {
      result
      errorMessage
      data {
        id
        rfqId
        chatRoomId
        projectName
        serviceType
        optionalServices {
          serviceType
        }
        publish {
          organizationName
        }
        supply {
          quotationPartnerStatus
          quotationPartnerId
          organizationName
          companyRegistrationNumber
          managerName
          address
        }
        pcbFabricationItems {
          fileId
          fileName
          quantity
          thickness
          cost
          etc
        }
        pcbAssemblyItems {
          fileId
          fileName
          quantity
          cost
          etc
        }
        dueDate
        expiration
        items {
          fileId
          fileName
          quantity
          material
          cost
          etc
        }
        quotation
        deliveryCost
        createdAt
        maxDraftModificationCount
        draftModificationTerms
        read
        adjustRequest {
          read
          message
        }
        isConfirmed
        etc
      }
    }
  }
`;

/**
 * __useFetchRfqQuotationPdfQuery__
 *
 * To run a query within a React component, call `useFetchRfqQuotationPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRfqQuotationPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRfqQuotationPdfQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchRfqQuotationPdfQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchRfqQuotationPdfQuery,
    FetchRfqQuotationPdfQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchRfqQuotationPdfQuery,
    FetchRfqQuotationPdfQueryVariables
  >(FetchRfqQuotationPdfDocument, baseOptions);
}
export function useFetchRfqQuotationPdfLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchRfqQuotationPdfQuery,
    FetchRfqQuotationPdfQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchRfqQuotationPdfQuery,
    FetchRfqQuotationPdfQueryVariables
  >(FetchRfqQuotationPdfDocument, baseOptions);
}
export type FetchRfqQuotationPdfQueryHookResult = ReturnType<
  typeof useFetchRfqQuotationPdfQuery
>;
export type FetchRfqQuotationPdfLazyQueryHookResult = ReturnType<
  typeof useFetchRfqQuotationPdfLazyQuery
>;
export type FetchRfqQuotationPdfQueryResult = Apollo.QueryResult<
  FetchRfqQuotationPdfQuery,
  FetchRfqQuotationPdfQueryVariables
>;
export const RegisterRequestRfqQuotationDocument = gql`
  mutation registerRequestRfqQuotation(
    $input: RegisterRequestRfqQuotationInput!
  ) {
    registerRequestRfqQuotation(input: $input) {
      result
      errorMessage
    }
  }
`;
export type RegisterRequestRfqQuotationMutationFn = Apollo.MutationFunction<
  RegisterRequestRfqQuotationMutation,
  RegisterRequestRfqQuotationMutationVariables
>;

/**
 * __useRegisterRequestRfqQuotationMutation__
 *
 * To run a mutation, you first call `useRegisterRequestRfqQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterRequestRfqQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerRequestRfqQuotationMutation, { data, loading, error }] = useRegisterRequestRfqQuotationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterRequestRfqQuotationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterRequestRfqQuotationMutation,
    RegisterRequestRfqQuotationMutationVariables
  >
) {
  return Apollo.useMutation<
    RegisterRequestRfqQuotationMutation,
    RegisterRequestRfqQuotationMutationVariables
  >(RegisterRequestRfqQuotationDocument, baseOptions);
}
export type RegisterRequestRfqQuotationMutationHookResult = ReturnType<
  typeof useRegisterRequestRfqQuotationMutation
>;
export type RegisterRequestRfqQuotationMutationResult = Apollo.MutationResult<
  RegisterRequestRfqQuotationMutation
>;
export type RegisterRequestRfqQuotationMutationOptions = Apollo.BaseMutationOptions<
  RegisterRequestRfqQuotationMutation,
  RegisterRequestRfqQuotationMutationVariables
>;
export const ReadRfqAdjustRequestDocument = gql`
  mutation readRfqAdjustRequest($input: readRfqAdjustRequestInput!) {
    readRfqAdjustRequest(input: $input) {
      errorMessage
      result
    }
  }
`;
export type ReadRfqAdjustRequestMutationFn = Apollo.MutationFunction<
  ReadRfqAdjustRequestMutation,
  ReadRfqAdjustRequestMutationVariables
>;

/**
 * __useReadRfqAdjustRequestMutation__
 *
 * To run a mutation, you first call `useReadRfqAdjustRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadRfqAdjustRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readRfqAdjustRequestMutation, { data, loading, error }] = useReadRfqAdjustRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReadRfqAdjustRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReadRfqAdjustRequestMutation,
    ReadRfqAdjustRequestMutationVariables
  >
) {
  return Apollo.useMutation<
    ReadRfqAdjustRequestMutation,
    ReadRfqAdjustRequestMutationVariables
  >(ReadRfqAdjustRequestDocument, baseOptions);
}
export type ReadRfqAdjustRequestMutationHookResult = ReturnType<
  typeof useReadRfqAdjustRequestMutation
>;
export type ReadRfqAdjustRequestMutationResult = Apollo.MutationResult<
  ReadRfqAdjustRequestMutation
>;
export type ReadRfqAdjustRequestMutationOptions = Apollo.BaseMutationOptions<
  ReadRfqAdjustRequestMutation,
  ReadRfqAdjustRequestMutationVariables
>;
export const FetchQuotationServiceUserRatingDocument = gql`
  query fetchQuotationServiceUserRating {
    fetchQuotationServiceUserRating {
      result
      errorMessage
      data {
        rated
        rating
        comment
      }
    }
  }
`;

/**
 * __useFetchQuotationServiceUserRatingQuery__
 *
 * To run a query within a React component, call `useFetchQuotationServiceUserRatingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchQuotationServiceUserRatingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchQuotationServiceUserRatingQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchQuotationServiceUserRatingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchQuotationServiceUserRatingQuery,
    FetchQuotationServiceUserRatingQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchQuotationServiceUserRatingQuery,
    FetchQuotationServiceUserRatingQueryVariables
  >(FetchQuotationServiceUserRatingDocument, baseOptions);
}
export function useFetchQuotationServiceUserRatingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchQuotationServiceUserRatingQuery,
    FetchQuotationServiceUserRatingQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchQuotationServiceUserRatingQuery,
    FetchQuotationServiceUserRatingQueryVariables
  >(FetchQuotationServiceUserRatingDocument, baseOptions);
}
export type FetchQuotationServiceUserRatingQueryHookResult = ReturnType<
  typeof useFetchQuotationServiceUserRatingQuery
>;
export type FetchQuotationServiceUserRatingLazyQueryHookResult = ReturnType<
  typeof useFetchQuotationServiceUserRatingLazyQuery
>;
export type FetchQuotationServiceUserRatingQueryResult = Apollo.QueryResult<
  FetchQuotationServiceUserRatingQuery,
  FetchQuotationServiceUserRatingQueryVariables
>;
export const RateQuotationServiceUserDocument = gql`
  mutation rateQuotationServiceUser($input: QuotationServiceRatingInput!) {
    rateQuotationServiceUser(input: $input) {
      result
      errorMessage
    }
  }
`;
export type RateQuotationServiceUserMutationFn = Apollo.MutationFunction<
  RateQuotationServiceUserMutation,
  RateQuotationServiceUserMutationVariables
>;

/**
 * __useRateQuotationServiceUserMutation__
 *
 * To run a mutation, you first call `useRateQuotationServiceUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRateQuotationServiceUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rateQuotationServiceUserMutation, { data, loading, error }] = useRateQuotationServiceUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRateQuotationServiceUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RateQuotationServiceUserMutation,
    RateQuotationServiceUserMutationVariables
  >
) {
  return Apollo.useMutation<
    RateQuotationServiceUserMutation,
    RateQuotationServiceUserMutationVariables
  >(RateQuotationServiceUserDocument, baseOptions);
}
export type RateQuotationServiceUserMutationHookResult = ReturnType<
  typeof useRateQuotationServiceUserMutation
>;
export type RateQuotationServiceUserMutationResult = Apollo.MutationResult<
  RateQuotationServiceUserMutation
>;
export type RateQuotationServiceUserMutationOptions = Apollo.BaseMutationOptions<
  RateQuotationServiceUserMutation,
  RateQuotationServiceUserMutationVariables
>;
export const EvaluateRfqPartnersDocument = gql`
  mutation evaluateRfqPartners($input: EvaluateRfqPartnersInput!) {
    evaluateRfqPartners(input: $input) {
      result
      errorMessage
    }
  }
`;
export type EvaluateRfqPartnersMutationFn = Apollo.MutationFunction<
  EvaluateRfqPartnersMutation,
  EvaluateRfqPartnersMutationVariables
>;

/**
 * __useEvaluateRfqPartnersMutation__
 *
 * To run a mutation, you first call `useEvaluateRfqPartnersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEvaluateRfqPartnersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [evaluateRfqPartnersMutation, { data, loading, error }] = useEvaluateRfqPartnersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEvaluateRfqPartnersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EvaluateRfqPartnersMutation,
    EvaluateRfqPartnersMutationVariables
  >
) {
  return Apollo.useMutation<
    EvaluateRfqPartnersMutation,
    EvaluateRfqPartnersMutationVariables
  >(EvaluateRfqPartnersDocument, baseOptions);
}
export type EvaluateRfqPartnersMutationHookResult = ReturnType<
  typeof useEvaluateRfqPartnersMutation
>;
export type EvaluateRfqPartnersMutationResult = Apollo.MutationResult<
  EvaluateRfqPartnersMutation
>;
export type EvaluateRfqPartnersMutationOptions = Apollo.BaseMutationOptions<
  EvaluateRfqPartnersMutation,
  EvaluateRfqPartnersMutationVariables
>;
export const FetchQuotationUserRfqDetailDocument = gql`
  query fetchQuotationUserRfqDetail($rfqId: String!) {
    fetchQuotationUserRfqDetail(input: { rfqId: $rfqId }) {
      result
      errorMessage
      data {
        id
        status
        projectName
        dueDate
        detailedRequest
        serviceType
        detailedServiceType
        chatRoom {
          chatRoomId
          chatRoomStatus
          rfqId
          chatMessagesCount
          quotationPartnerId
          createdAt
          updatedAt
        }
        review {
          dueDate
          quality
          publicComment
          privateComment
          replyComment
          repliedAt
        }
        pcb {
          services {
            serviceType
          }
          fabricationFiles {
            fileSize
            fileId
            fileName
            fileSize
            thickness
            quantity
          }
          assemblyFiles {
            fileSize
            fileId
            fileName
            fileSize
            quantity
          }
          fabricationQuantity
          assemblyQuantity
          assemblyMethod {
            methodType
          }
          metalMaskAvailablity
          materialSupplyMethod
        }
        design {
          services {
            serviceType
          }
        }
        optionalServices {
          serviceType
          quantity
        }
        dueNegotiable
        maxEstimatedBudget
        minEstimatedBudget
        budgetOpen
        projectPurpose
        projectPurposeDetail
        publicOpen
        eventType
        manufacturingStage
        drawingFiles {
          fileSize
          fileId
          fileName
          fileSize
          quantity
          material
          detailedMaterial
          etc
          recommendation
        }
        referenceFiles {
          fileSize
          fileId
          fileName
          fileSize
        }
        itpEvent {
          id
          projectName
          quotationUserId
          quotationUserName
          quotationPartnerOrganizationName
          completeCost
          files {
            fileSize
            fileId
            fileName
            fileExtension
            fileMimetype
            fileSize
            status
            oldFileId
          }
          approvedAt
          approvedById
          approvedByName
          sentAt
          sentById
          sentByName
        }
        jsbEvent {
          id
          projectName
          quotationUserId
          quotationUserName
          quotationPartnerOrganizationName
          completeCost
          files {
            fileSize
            fileId
            fileName
            fileExtension
            fileMimetype
            fileSize
            status
            oldFileId
          }
          approvedAt
          approvedById
          approvedByName
        }
        transaction {
          rfqId
          quotationPartnerId
          transactionComplete
          completeCost
          completeAt
          isItp
          organizationName
        }
        isOldRfq
        createdAt
        consultingStartMethod
      }
    }
  }
`;

/**
 * __useFetchQuotationUserRfqDetailQuery__
 *
 * To run a query within a React component, call `useFetchQuotationUserRfqDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchQuotationUserRfqDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchQuotationUserRfqDetailQuery({
 *   variables: {
 *      rfqId: // value for 'rfqId'
 *   },
 * });
 */
export function useFetchQuotationUserRfqDetailQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchQuotationUserRfqDetailQuery,
    FetchQuotationUserRfqDetailQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchQuotationUserRfqDetailQuery,
    FetchQuotationUserRfqDetailQueryVariables
  >(FetchQuotationUserRfqDetailDocument, baseOptions);
}
export function useFetchQuotationUserRfqDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchQuotationUserRfqDetailQuery,
    FetchQuotationUserRfqDetailQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchQuotationUserRfqDetailQuery,
    FetchQuotationUserRfqDetailQueryVariables
  >(FetchQuotationUserRfqDetailDocument, baseOptions);
}
export type FetchQuotationUserRfqDetailQueryHookResult = ReturnType<
  typeof useFetchQuotationUserRfqDetailQuery
>;
export type FetchQuotationUserRfqDetailLazyQueryHookResult = ReturnType<
  typeof useFetchQuotationUserRfqDetailLazyQuery
>;
export type FetchQuotationUserRfqDetailQueryResult = Apollo.QueryResult<
  FetchQuotationUserRfqDetailQuery,
  FetchQuotationUserRfqDetailQueryVariables
>;
export const FetchRfqDetailDocument = gql`
  query fetchRfqDetail($rfqId: String!) {
    fetchRfqDetail(input: { rfqId: $rfqId }) {
      result
      errorMessage
      data {
        id
        status
        projectName
        dueDate
        detailedRequest
        serviceType
        detailedServiceType
        optionalServices {
          serviceType
          quantity
        }
        pcb {
          services {
            serviceType
          }
          fabricationFiles {
            fileSize
            fileId
            fileName
            fileSize
            thickness
            quantity
          }
          assemblyFiles {
            fileSize
            fileId
            fileName
            fileSize
            quantity
          }
          fabricationQuantity
          assemblyQuantity
          assemblyMethod {
            methodType
          }
          metalMaskAvailablity
          materialSupplyMethod
        }
        dueNegotiable
        maxEstimatedBudget
        minEstimatedBudget
        budgetOpen
        projectPurpose
        projectPurposeDetail
        publicOpen
        eventType
        manufacturingStage
        drawingFiles {
          fileSize
          fileId
          fileName
          fileSize
          quantity
          material
          detailedMaterial
          etc
          recommendation
        }
        referenceFiles {
          fileSize
          fileId
          fileName
          fileSize
        }
        transaction {
          rfqId
          quotationPartnerId
          transactionComplete
          completeCost
          completeAt
        }
        owner {
          id
          status
          managerName
          shortAddress
          bizType
          organizationName
          companyIntroduction
          website
          department
          createdAt
          updatedAt
          files {
            fileId
            fileName
            fileType
          }
        }
        quotation {
          id
          rfqId
          messageId
          quotationPartnerId
          quotation
          excludeDeliveryFee
        }
        chatRoom {
          rfqId
          chatRoomId
          chatRoomStatus
          quotationPartnerId
          chatMessages {
            id
            senderId
            senderUserType
            organizationName
            managerName
            profileId
            unReadCount
            chatFiles {
              fileSize
              fileId
              fileName
              fileSize
            }
            createdAt
          }
          createdAt
          updatedAt
        }
        favorite
        canDownload
        createdAt
        isOldRfq
      }
    }
  }
`;

/**
 * __useFetchRfqDetailQuery__
 *
 * To run a query within a React component, call `useFetchRfqDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRfqDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRfqDetailQuery({
 *   variables: {
 *      rfqId: // value for 'rfqId'
 *   },
 * });
 */
export function useFetchRfqDetailQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchRfqDetailQuery,
    FetchRfqDetailQueryVariables
  >
) {
  return Apollo.useQuery<FetchRfqDetailQuery, FetchRfqDetailQueryVariables>(
    FetchRfqDetailDocument,
    baseOptions
  );
}
export function useFetchRfqDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchRfqDetailQuery,
    FetchRfqDetailQueryVariables
  >
) {
  return Apollo.useLazyQuery<FetchRfqDetailQuery, FetchRfqDetailQueryVariables>(
    FetchRfqDetailDocument,
    baseOptions
  );
}
export type FetchRfqDetailQueryHookResult = ReturnType<
  typeof useFetchRfqDetailQuery
>;
export type FetchRfqDetailLazyQueryHookResult = ReturnType<
  typeof useFetchRfqDetailLazyQuery
>;
export type FetchRfqDetailQueryResult = Apollo.QueryResult<
  FetchRfqDetailQuery,
  FetchRfqDetailQueryVariables
>;
export const FetchRfqPartnersDocument = gql`
  query fetchRfqPartners($rfqId: String!) {
    fetchRfqPartners(input: { rfqId: $rfqId }) {
      result
      errorMessage
      data {
        quotationPartnerId
        organizationName
        profileId
        hasEvaluated
        permission
        downloaded
        chatRoomId
      }
    }
  }
`;

/**
 * __useFetchRfqPartnersQuery__
 *
 * To run a query within a React component, call `useFetchRfqPartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRfqPartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRfqPartnersQuery({
 *   variables: {
 *      rfqId: // value for 'rfqId'
 *   },
 * });
 */
export function useFetchRfqPartnersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchRfqPartnersQuery,
    FetchRfqPartnersQueryVariables
  >
) {
  return Apollo.useQuery<FetchRfqPartnersQuery, FetchRfqPartnersQueryVariables>(
    FetchRfqPartnersDocument,
    baseOptions
  );
}
export function useFetchRfqPartnersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchRfqPartnersQuery,
    FetchRfqPartnersQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchRfqPartnersQuery,
    FetchRfqPartnersQueryVariables
  >(FetchRfqPartnersDocument, baseOptions);
}
export type FetchRfqPartnersQueryHookResult = ReturnType<
  typeof useFetchRfqPartnersQuery
>;
export type FetchRfqPartnersLazyQueryHookResult = ReturnType<
  typeof useFetchRfqPartnersLazyQuery
>;
export type FetchRfqPartnersQueryResult = Apollo.QueryResult<
  FetchRfqPartnersQuery,
  FetchRfqPartnersQueryVariables
>;
export const FetchDetailedQuotationDocument = gql`
  query fetchDetailedQuotation($input: FetchDetailedQuotationInput!) {
    fetchDetailedQuotation(input: $input) {
      result
      errorMessage
      data {
        id
        rfqId
        type
        latest
        chatRoomId
        projectName
        serviceType
        optionalServices {
          serviceType
        }
        publish {
          organizationName
        }
        supply {
          quotationPartnerStatus
          quotationPartnerId
          organizationName
          companyRegistrationNumber
          managerName
          address
        }
        dueDate
        expiration
        items {
          fileId
          fileName
          quantity
          material
          cost
          etc
        }
        pcbFabricationItems {
          fileId
          fileName
          quantity
          thickness
          cost
          etc
        }
        pcbAssemblyItems {
          fileId
          fileName
          quantity
          cost
          etc
        }
        quotation
        deliveryCost
        createdAt
        maxDraftModificationCount
        draftModificationTerms
        read
        adjustRequest {
          read
          message
        }
        isConfirmed
        etc
      }
    }
  }
`;

/**
 * __useFetchDetailedQuotationQuery__
 *
 * To run a query within a React component, call `useFetchDetailedQuotationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDetailedQuotationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDetailedQuotationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchDetailedQuotationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchDetailedQuotationQuery,
    FetchDetailedQuotationQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchDetailedQuotationQuery,
    FetchDetailedQuotationQueryVariables
  >(FetchDetailedQuotationDocument, baseOptions);
}
export function useFetchDetailedQuotationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchDetailedQuotationQuery,
    FetchDetailedQuotationQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchDetailedQuotationQuery,
    FetchDetailedQuotationQueryVariables
  >(FetchDetailedQuotationDocument, baseOptions);
}
export type FetchDetailedQuotationQueryHookResult = ReturnType<
  typeof useFetchDetailedQuotationQuery
>;
export type FetchDetailedQuotationLazyQueryHookResult = ReturnType<
  typeof useFetchDetailedQuotationLazyQuery
>;
export type FetchDetailedQuotationQueryResult = Apollo.QueryResult<
  FetchDetailedQuotationQuery,
  FetchDetailedQuotationQueryVariables
>;
export const FetchMyRfqQuotationsDocument = gql`
  query fetchMyRfqQuotations($input: FetchMyRfqQuotationsInput!) {
    fetchMyRfqQuotations(input: $input) {
      result
      errorMessage
      data {
        id
        rfqId
        chatRoomId
        type
        latest
        projectName
        serviceType
        optionalServices {
          serviceType
        }
        publish {
          organizationName
        }
        supply {
          quotationPartnerStatus
          quotationPartnerId
          organizationName
          companyRegistrationNumber
          managerName
          phone
          address
        }
        dueDate
        expiration
        items {
          fileId
          fileName
          quantity
          material
          cost
          etc
        }
        pcbFabricationItems {
          fileId
          fileName
          quantity
          thickness
          cost
          etc
        }
        pcbAssemblyItems {
          fileId
          fileName
          quantity
          cost
          etc
        }
        quotation
        deliveryCost
        createdAt
        maxDraftModificationCount
        draftModificationTerms
        read
        adjustRequest {
          read
          message
        }
        isConfirmed
        etc
        isBeforeConsulting
      }
    }
  }
`;

/**
 * __useFetchMyRfqQuotationsQuery__
 *
 * To run a query within a React component, call `useFetchMyRfqQuotationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMyRfqQuotationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMyRfqQuotationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchMyRfqQuotationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchMyRfqQuotationsQuery,
    FetchMyRfqQuotationsQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchMyRfqQuotationsQuery,
    FetchMyRfqQuotationsQueryVariables
  >(FetchMyRfqQuotationsDocument, baseOptions);
}
export function useFetchMyRfqQuotationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchMyRfqQuotationsQuery,
    FetchMyRfqQuotationsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchMyRfqQuotationsQuery,
    FetchMyRfqQuotationsQueryVariables
  >(FetchMyRfqQuotationsDocument, baseOptions);
}
export type FetchMyRfqQuotationsQueryHookResult = ReturnType<
  typeof useFetchMyRfqQuotationsQuery
>;
export type FetchMyRfqQuotationsLazyQueryHookResult = ReturnType<
  typeof useFetchMyRfqQuotationsLazyQuery
>;
export type FetchMyRfqQuotationsQueryResult = Apollo.QueryResult<
  FetchMyRfqQuotationsQuery,
  FetchMyRfqQuotationsQueryVariables
>;
export const CompleteRfqTransactionDocument = gql`
  mutation completeRfqTransaction($input: CompleteRfqTransactionInput!) {
    completeRfqTransaction(input: $input) {
      result
      errorMessage
    }
  }
`;
export type CompleteRfqTransactionMutationFn = Apollo.MutationFunction<
  CompleteRfqTransactionMutation,
  CompleteRfqTransactionMutationVariables
>;

/**
 * __useCompleteRfqTransactionMutation__
 *
 * To run a mutation, you first call `useCompleteRfqTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteRfqTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeRfqTransactionMutation, { data, loading, error }] = useCompleteRfqTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteRfqTransactionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteRfqTransactionMutation,
    CompleteRfqTransactionMutationVariables
  >
) {
  return Apollo.useMutation<
    CompleteRfqTransactionMutation,
    CompleteRfqTransactionMutationVariables
  >(CompleteRfqTransactionDocument, baseOptions);
}
export type CompleteRfqTransactionMutationHookResult = ReturnType<
  typeof useCompleteRfqTransactionMutation
>;
export type CompleteRfqTransactionMutationResult = Apollo.MutationResult<
  CompleteRfqTransactionMutation
>;
export type CompleteRfqTransactionMutationOptions = Apollo.BaseMutationOptions<
  CompleteRfqTransactionMutation,
  CompleteRfqTransactionMutationVariables
>;
export const RegisterRfqDocument = gql`
  mutation registerRFQ($input: RegisterRfqInput!) {
    registerRFQ(input: $input) {
      result
      errorMessage
    }
  }
`;
export type RegisterRfqMutationFn = Apollo.MutationFunction<
  RegisterRfqMutation,
  RegisterRfqMutationVariables
>;

/**
 * __useRegisterRfqMutation__
 *
 * To run a mutation, you first call `useRegisterRfqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterRfqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerRfqMutation, { data, loading, error }] = useRegisterRfqMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterRfqMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterRfqMutation,
    RegisterRfqMutationVariables
  >
) {
  return Apollo.useMutation<RegisterRfqMutation, RegisterRfqMutationVariables>(
    RegisterRfqDocument,
    baseOptions
  );
}
export type RegisterRfqMutationHookResult = ReturnType<
  typeof useRegisterRfqMutation
>;
export type RegisterRfqMutationResult = Apollo.MutationResult<
  RegisterRfqMutation
>;
export type RegisterRfqMutationOptions = Apollo.BaseMutationOptions<
  RegisterRfqMutation,
  RegisterRfqMutationVariables
>;
export const ExpireRfqDocument = gql`
  mutation expireRfq($rfqId: String!) {
    expireRfq(input: { rfqId: $rfqId }) {
      result
      errorMessage
    }
  }
`;
export type ExpireRfqMutationFn = Apollo.MutationFunction<
  ExpireRfqMutation,
  ExpireRfqMutationVariables
>;

/**
 * __useExpireRfqMutation__
 *
 * To run a mutation, you first call `useExpireRfqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExpireRfqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [expireRfqMutation, { data, loading, error }] = useExpireRfqMutation({
 *   variables: {
 *      rfqId: // value for 'rfqId'
 *   },
 * });
 */
export function useExpireRfqMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExpireRfqMutation,
    ExpireRfqMutationVariables
  >
) {
  return Apollo.useMutation<ExpireRfqMutation, ExpireRfqMutationVariables>(
    ExpireRfqDocument,
    baseOptions
  );
}
export type ExpireRfqMutationHookResult = ReturnType<
  typeof useExpireRfqMutation
>;
export type ExpireRfqMutationResult = Apollo.MutationResult<ExpireRfqMutation>;
export type ExpireRfqMutationOptions = Apollo.BaseMutationOptions<
  ExpireRfqMutation,
  ExpireRfqMutationVariables
>;
export const AllowRfqDrawingFileDownloadDocument = gql`
  mutation allowRfqDrawingFileDownload(
    $input: AllowRfqDrawingFileDownloadInput!
  ) {
    allowRfqDrawingFileDownload(input: $input) {
      result
      errorMessage
    }
  }
`;
export type AllowRfqDrawingFileDownloadMutationFn = Apollo.MutationFunction<
  AllowRfqDrawingFileDownloadMutation,
  AllowRfqDrawingFileDownloadMutationVariables
>;

/**
 * __useAllowRfqDrawingFileDownloadMutation__
 *
 * To run a mutation, you first call `useAllowRfqDrawingFileDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAllowRfqDrawingFileDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [allowRfqDrawingFileDownloadMutation, { data, loading, error }] = useAllowRfqDrawingFileDownloadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllowRfqDrawingFileDownloadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AllowRfqDrawingFileDownloadMutation,
    AllowRfqDrawingFileDownloadMutationVariables
  >
) {
  return Apollo.useMutation<
    AllowRfqDrawingFileDownloadMutation,
    AllowRfqDrawingFileDownloadMutationVariables
  >(AllowRfqDrawingFileDownloadDocument, baseOptions);
}
export type AllowRfqDrawingFileDownloadMutationHookResult = ReturnType<
  typeof useAllowRfqDrawingFileDownloadMutation
>;
export type AllowRfqDrawingFileDownloadMutationResult = Apollo.MutationResult<
  AllowRfqDrawingFileDownloadMutation
>;
export type AllowRfqDrawingFileDownloadMutationOptions = Apollo.BaseMutationOptions<
  AllowRfqDrawingFileDownloadMutation,
  AllowRfqDrawingFileDownloadMutationVariables
>;
export const SuggestServiceDocument = gql`
  mutation suggestService($input: SuggestServiceInput!) {
    suggestService(input: $input) {
      result
      errorMessage
    }
  }
`;
export type SuggestServiceMutationFn = Apollo.MutationFunction<
  SuggestServiceMutation,
  SuggestServiceMutationVariables
>;

/**
 * __useSuggestServiceMutation__
 *
 * To run a mutation, you first call `useSuggestServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuggestServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suggestServiceMutation, { data, loading, error }] = useSuggestServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuggestServiceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SuggestServiceMutation,
    SuggestServiceMutationVariables
  >
) {
  return Apollo.useMutation<
    SuggestServiceMutation,
    SuggestServiceMutationVariables
  >(SuggestServiceDocument, baseOptions);
}
export type SuggestServiceMutationHookResult = ReturnType<
  typeof useSuggestServiceMutation
>;
export type SuggestServiceMutationResult = Apollo.MutationResult<
  SuggestServiceMutation
>;
export type SuggestServiceMutationOptions = Apollo.BaseMutationOptions<
  SuggestServiceMutation,
  SuggestServiceMutationVariables
>;
export const RequestRfqIdDocument = gql`
  query requestRfqId {
    requestRfqId {
      result
      errorMessage
      data {
        uuid
      }
    }
  }
`;

/**
 * __useRequestRfqIdQuery__
 *
 * To run a query within a React component, call `useRequestRfqIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestRfqIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestRfqIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useRequestRfqIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RequestRfqIdQuery,
    RequestRfqIdQueryVariables
  >
) {
  return Apollo.useQuery<RequestRfqIdQuery, RequestRfqIdQueryVariables>(
    RequestRfqIdDocument,
    baseOptions
  );
}
export function useRequestRfqIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RequestRfqIdQuery,
    RequestRfqIdQueryVariables
  >
) {
  return Apollo.useLazyQuery<RequestRfqIdQuery, RequestRfqIdQueryVariables>(
    RequestRfqIdDocument,
    baseOptions
  );
}
export type RequestRfqIdQueryHookResult = ReturnType<
  typeof useRequestRfqIdQuery
>;
export type RequestRfqIdLazyQueryHookResult = ReturnType<
  typeof useRequestRfqIdLazyQuery
>;
export type RequestRfqIdQueryResult = Apollo.QueryResult<
  RequestRfqIdQuery,
  RequestRfqIdQueryVariables
>;
export const ConfirmRfqTransactionDocument = gql`
  mutation confirmRfqTransaction($input: ConfirmRfqTransactionInput!) {
    confirmRfqTransaction(input: $input) {
      result
      errorMessage
    }
  }
`;
export type ConfirmRfqTransactionMutationFn = Apollo.MutationFunction<
  ConfirmRfqTransactionMutation,
  ConfirmRfqTransactionMutationVariables
>;

/**
 * __useConfirmRfqTransactionMutation__
 *
 * To run a mutation, you first call `useConfirmRfqTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmRfqTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmRfqTransactionMutation, { data, loading, error }] = useConfirmRfqTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmRfqTransactionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConfirmRfqTransactionMutation,
    ConfirmRfqTransactionMutationVariables
  >
) {
  return Apollo.useMutation<
    ConfirmRfqTransactionMutation,
    ConfirmRfqTransactionMutationVariables
  >(ConfirmRfqTransactionDocument, baseOptions);
}
export type ConfirmRfqTransactionMutationHookResult = ReturnType<
  typeof useConfirmRfqTransactionMutation
>;
export type ConfirmRfqTransactionMutationResult = Apollo.MutationResult<
  ConfirmRfqTransactionMutation
>;
export type ConfirmRfqTransactionMutationOptions = Apollo.BaseMutationOptions<
  ConfirmRfqTransactionMutation,
  ConfirmRfqTransactionMutationVariables
>;
export const ReviewRfqDocument = gql`
  mutation reviewRfq($input: ReviewRfqInput!) {
    reviewRfq(input: $input) {
      result
      errorMessage
    }
  }
`;
export type ReviewRfqMutationFn = Apollo.MutationFunction<
  ReviewRfqMutation,
  ReviewRfqMutationVariables
>;

/**
 * __useReviewRfqMutation__
 *
 * To run a mutation, you first call `useReviewRfqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewRfqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewRfqMutation, { data, loading, error }] = useReviewRfqMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewRfqMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReviewRfqMutation,
    ReviewRfqMutationVariables
  >
) {
  return Apollo.useMutation<ReviewRfqMutation, ReviewRfqMutationVariables>(
    ReviewRfqDocument,
    baseOptions
  );
}
export type ReviewRfqMutationHookResult = ReturnType<
  typeof useReviewRfqMutation
>;
export type ReviewRfqMutationResult = Apollo.MutationResult<ReviewRfqMutation>;
export type ReviewRfqMutationOptions = Apollo.BaseMutationOptions<
  ReviewRfqMutation,
  ReviewRfqMutationVariables
>;
export const FetchMyRfqReviewsDocument = gql`
  query fetchMyRfqReviews {
    fetchMyRfqReviews {
      result
      errorMessage
      data {
        rfqId
        thumbnailId
        serviceType
        projectName
        organizationName
        createdAt
        updatedAt
        publicComment
        privateComment
        replyComment
        repliedAt
      }
    }
  }
`;

/**
 * __useFetchMyRfqReviewsQuery__
 *
 * To run a query within a React component, call `useFetchMyRfqReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMyRfqReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMyRfqReviewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchMyRfqReviewsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchMyRfqReviewsQuery,
    FetchMyRfqReviewsQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchMyRfqReviewsQuery,
    FetchMyRfqReviewsQueryVariables
  >(FetchMyRfqReviewsDocument, baseOptions);
}
export function useFetchMyRfqReviewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchMyRfqReviewsQuery,
    FetchMyRfqReviewsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchMyRfqReviewsQuery,
    FetchMyRfqReviewsQueryVariables
  >(FetchMyRfqReviewsDocument, baseOptions);
}
export type FetchMyRfqReviewsQueryHookResult = ReturnType<
  typeof useFetchMyRfqReviewsQuery
>;
export type FetchMyRfqReviewsLazyQueryHookResult = ReturnType<
  typeof useFetchMyRfqReviewsLazyQuery
>;
export type FetchMyRfqReviewsQueryResult = Apollo.QueryResult<
  FetchMyRfqReviewsQuery,
  FetchMyRfqReviewsQueryVariables
>;
export const FetchPartnerRfqReviewsDocument = gql`
  query fetchPartnerRfqReviews($quotationPartnerId: String!) {
    fetchPartnerRfqReviews(input: { quotationPartnerId: $quotationPartnerId }) {
      result
      errorMessage
      data {
        rfqId
        thumbnailId
        serviceType
        projectName
        organizationName
        createdAt
        updatedAt
        publicComment
        privateComment
        replyComment
        repliedAt
      }
    }
  }
`;

/**
 * __useFetchPartnerRfqReviewsQuery__
 *
 * To run a query within a React component, call `useFetchPartnerRfqReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPartnerRfqReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPartnerRfqReviewsQuery({
 *   variables: {
 *      quotationPartnerId: // value for 'quotationPartnerId'
 *   },
 * });
 */
export function useFetchPartnerRfqReviewsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchPartnerRfqReviewsQuery,
    FetchPartnerRfqReviewsQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchPartnerRfqReviewsQuery,
    FetchPartnerRfqReviewsQueryVariables
  >(FetchPartnerRfqReviewsDocument, baseOptions);
}
export function useFetchPartnerRfqReviewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchPartnerRfqReviewsQuery,
    FetchPartnerRfqReviewsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchPartnerRfqReviewsQuery,
    FetchPartnerRfqReviewsQueryVariables
  >(FetchPartnerRfqReviewsDocument, baseOptions);
}
export type FetchPartnerRfqReviewsQueryHookResult = ReturnType<
  typeof useFetchPartnerRfqReviewsQuery
>;
export type FetchPartnerRfqReviewsLazyQueryHookResult = ReturnType<
  typeof useFetchPartnerRfqReviewsLazyQuery
>;
export type FetchPartnerRfqReviewsQueryResult = Apollo.QueryResult<
  FetchPartnerRfqReviewsQuery,
  FetchPartnerRfqReviewsQueryVariables
>;
export const FetchMyReviewableRfqsDocument = gql`
  query fetchMyReviewableRfqs {
    fetchMyReviewableRfqs {
      result
      errorMessage
      data {
        id
        projectName
        organizationName
        completeAt
        thumbnailId
      }
    }
  }
`;

/**
 * __useFetchMyReviewableRfqsQuery__
 *
 * To run a query within a React component, call `useFetchMyReviewableRfqsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMyReviewableRfqsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMyReviewableRfqsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchMyReviewableRfqsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchMyReviewableRfqsQuery,
    FetchMyReviewableRfqsQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchMyReviewableRfqsQuery,
    FetchMyReviewableRfqsQueryVariables
  >(FetchMyReviewableRfqsDocument, baseOptions);
}
export function useFetchMyReviewableRfqsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchMyReviewableRfqsQuery,
    FetchMyReviewableRfqsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchMyReviewableRfqsQuery,
    FetchMyReviewableRfqsQueryVariables
  >(FetchMyReviewableRfqsDocument, baseOptions);
}
export type FetchMyReviewableRfqsQueryHookResult = ReturnType<
  typeof useFetchMyReviewableRfqsQuery
>;
export type FetchMyReviewableRfqsLazyQueryHookResult = ReturnType<
  typeof useFetchMyReviewableRfqsLazyQuery
>;
export type FetchMyReviewableRfqsQueryResult = Apollo.QueryResult<
  FetchMyReviewableRfqsQuery,
  FetchMyReviewableRfqsQueryVariables
>;
export const FetchRfqReviewsDocument = gql`
  query fetchRfqReviews {
    fetchRfqReviews {
      result
      errorMessage
      data {
        rfqId
        thumbnailId
        serviceType
        projectName
        organizationName
        createdAt
        updatedAt
        publicComment
        privateComment
        replyComment
        repliedAt
        quality
        dueDate
      }
    }
  }
`;

/**
 * __useFetchRfqReviewsQuery__
 *
 * To run a query within a React component, call `useFetchRfqReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRfqReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRfqReviewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchRfqReviewsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchRfqReviewsQuery,
    FetchRfqReviewsQueryVariables
  >
) {
  return Apollo.useQuery<FetchRfqReviewsQuery, FetchRfqReviewsQueryVariables>(
    FetchRfqReviewsDocument,
    baseOptions
  );
}
export function useFetchRfqReviewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchRfqReviewsQuery,
    FetchRfqReviewsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchRfqReviewsQuery,
    FetchRfqReviewsQueryVariables
  >(FetchRfqReviewsDocument, baseOptions);
}
export type FetchRfqReviewsQueryHookResult = ReturnType<
  typeof useFetchRfqReviewsQuery
>;
export type FetchRfqReviewsLazyQueryHookResult = ReturnType<
  typeof useFetchRfqReviewsLazyQuery
>;
export type FetchRfqReviewsQueryResult = Apollo.QueryResult<
  FetchRfqReviewsQuery,
  FetchRfqReviewsQueryVariables
>;
export const FetchQuotationUserRfqReviewsDocument = gql`
  query fetchQuotationUserRfqReviews(
    $input: FetchQuotationUserRfqReviewsInput!
  ) {
    fetchQuotationUserRfqReviews(input: $input) {
      errorMessage
      result
      data {
        id
        isEditable
        projectName
        organizationName
        managerName
        reviewComment
        reviewPoint
        serviceType
        reviewFiles {
          fileId
          fileName
        }
        reviewFileCount
        indueDate
        reviewedAt
        purchaseOrderValue
      }
    }
  }
`;

/**
 * __useFetchQuotationUserRfqReviewsQuery__
 *
 * To run a query within a React component, call `useFetchQuotationUserRfqReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchQuotationUserRfqReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchQuotationUserRfqReviewsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchQuotationUserRfqReviewsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchQuotationUserRfqReviewsQuery,
    FetchQuotationUserRfqReviewsQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchQuotationUserRfqReviewsQuery,
    FetchQuotationUserRfqReviewsQueryVariables
  >(FetchQuotationUserRfqReviewsDocument, baseOptions);
}
export function useFetchQuotationUserRfqReviewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchQuotationUserRfqReviewsQuery,
    FetchQuotationUserRfqReviewsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchQuotationUserRfqReviewsQuery,
    FetchQuotationUserRfqReviewsQueryVariables
  >(FetchQuotationUserRfqReviewsDocument, baseOptions);
}
export type FetchQuotationUserRfqReviewsQueryHookResult = ReturnType<
  typeof useFetchQuotationUserRfqReviewsQuery
>;
export type FetchQuotationUserRfqReviewsLazyQueryHookResult = ReturnType<
  typeof useFetchQuotationUserRfqReviewsLazyQuery
>;
export type FetchQuotationUserRfqReviewsQueryResult = Apollo.QueryResult<
  FetchQuotationUserRfqReviewsQuery,
  FetchQuotationUserRfqReviewsQueryVariables
>;
export const FetchQuotationUserRfqAvailableReviewsDocument = gql`
  query fetchQuotationUserRfqAvailableReviews(
    $input: FetchQuotationUserRfqReviewsInput!
  ) {
    fetchQuotationUserRfqAvailableReviews(input: $input) {
      errorMessage
      result
      data {
        availableReviewCount
        rfqs {
          rfqId
          serviceType
          projectName
          rfqCreatedAt
          thumbnailId
          reviews {
            chatRoomId
            quotationPartnerId
            profileId
            quotationPartnerId
            organizationName
            isComplete
            purchaseOrderCreatedAt
          }
        }
      }
    }
  }
`;

/**
 * __useFetchQuotationUserRfqAvailableReviewsQuery__
 *
 * To run a query within a React component, call `useFetchQuotationUserRfqAvailableReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchQuotationUserRfqAvailableReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchQuotationUserRfqAvailableReviewsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchQuotationUserRfqAvailableReviewsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchQuotationUserRfqAvailableReviewsQuery,
    FetchQuotationUserRfqAvailableReviewsQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchQuotationUserRfqAvailableReviewsQuery,
    FetchQuotationUserRfqAvailableReviewsQueryVariables
  >(FetchQuotationUserRfqAvailableReviewsDocument, baseOptions);
}
export function useFetchQuotationUserRfqAvailableReviewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchQuotationUserRfqAvailableReviewsQuery,
    FetchQuotationUserRfqAvailableReviewsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchQuotationUserRfqAvailableReviewsQuery,
    FetchQuotationUserRfqAvailableReviewsQueryVariables
  >(FetchQuotationUserRfqAvailableReviewsDocument, baseOptions);
}
export type FetchQuotationUserRfqAvailableReviewsQueryHookResult = ReturnType<
  typeof useFetchQuotationUserRfqAvailableReviewsQuery
>;
export type FetchQuotationUserRfqAvailableReviewsLazyQueryHookResult = ReturnType<
  typeof useFetchQuotationUserRfqAvailableReviewsLazyQuery
>;
export type FetchQuotationUserRfqAvailableReviewsQueryResult = Apollo.QueryResult<
  FetchQuotationUserRfqAvailableReviewsQuery,
  FetchQuotationUserRfqAvailableReviewsQueryVariables
>;
export const FetchQuotationPartnerRfqReviewDocument = gql`
  query fetchQuotationPartnerRfqReview(
    $input: FetchQuotationPartnerRfqReviewInput!
  ) {
    fetchQuotationPartnerRfqReview(input: $input) {
      result
      errorMessage
      data {
        reviewAveragePoint
        reviewCount
        reviewPointRatio {
          one
          two
          three
          four
          five
        }
        reviews {
          id
          projectName
          organizationName
          profileId
          managerName
          isEditable
          reviewComment
          reviewPoint
          serviceType
          reviewFiles {
            fileId
            fileName
          }
          reviewFileCount
          indueDate
          reviewedAt
          purchaseOrderValue
        }
      }
    }
  }
`;

/**
 * __useFetchQuotationPartnerRfqReviewQuery__
 *
 * To run a query within a React component, call `useFetchQuotationPartnerRfqReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchQuotationPartnerRfqReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchQuotationPartnerRfqReviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchQuotationPartnerRfqReviewQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchQuotationPartnerRfqReviewQuery,
    FetchQuotationPartnerRfqReviewQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchQuotationPartnerRfqReviewQuery,
    FetchQuotationPartnerRfqReviewQueryVariables
  >(FetchQuotationPartnerRfqReviewDocument, baseOptions);
}
export function useFetchQuotationPartnerRfqReviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchQuotationPartnerRfqReviewQuery,
    FetchQuotationPartnerRfqReviewQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchQuotationPartnerRfqReviewQuery,
    FetchQuotationPartnerRfqReviewQueryVariables
  >(FetchQuotationPartnerRfqReviewDocument, baseOptions);
}
export type FetchQuotationPartnerRfqReviewQueryHookResult = ReturnType<
  typeof useFetchQuotationPartnerRfqReviewQuery
>;
export type FetchQuotationPartnerRfqReviewLazyQueryHookResult = ReturnType<
  typeof useFetchQuotationPartnerRfqReviewLazyQuery
>;
export type FetchQuotationPartnerRfqReviewQueryResult = Apollo.QueryResult<
  FetchQuotationPartnerRfqReviewQuery,
  FetchQuotationPartnerRfqReviewQueryVariables
>;
export const RegisterRfqReviewDocument = gql`
  mutation registerRfqReview($input: RegisterRfqReviewInput!) {
    registerRfqReview(input: $input) {
      result
      errorMessage
    }
  }
`;
export type RegisterRfqReviewMutationFn = Apollo.MutationFunction<
  RegisterRfqReviewMutation,
  RegisterRfqReviewMutationVariables
>;

/**
 * __useRegisterRfqReviewMutation__
 *
 * To run a mutation, you first call `useRegisterRfqReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterRfqReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerRfqReviewMutation, { data, loading, error }] = useRegisterRfqReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterRfqReviewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterRfqReviewMutation,
    RegisterRfqReviewMutationVariables
  >
) {
  return Apollo.useMutation<
    RegisterRfqReviewMutation,
    RegisterRfqReviewMutationVariables
  >(RegisterRfqReviewDocument, baseOptions);
}
export type RegisterRfqReviewMutationHookResult = ReturnType<
  typeof useRegisterRfqReviewMutation
>;
export type RegisterRfqReviewMutationResult = Apollo.MutationResult<
  RegisterRfqReviewMutation
>;
export type RegisterRfqReviewMutationOptions = Apollo.BaseMutationOptions<
  RegisterRfqReviewMutation,
  RegisterRfqReviewMutationVariables
>;
export const UpdateRfqReviewDocument = gql`
  mutation updateRfqReview($input: UpdateRfqReviewInput!) {
    updateRfqReview(input: $input) {
      result
      errorMessage
    }
  }
`;
export type UpdateRfqReviewMutationFn = Apollo.MutationFunction<
  UpdateRfqReviewMutation,
  UpdateRfqReviewMutationVariables
>;

/**
 * __useUpdateRfqReviewMutation__
 *
 * To run a mutation, you first call `useUpdateRfqReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRfqReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRfqReviewMutation, { data, loading, error }] = useUpdateRfqReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRfqReviewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateRfqReviewMutation,
    UpdateRfqReviewMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdateRfqReviewMutation,
    UpdateRfqReviewMutationVariables
  >(UpdateRfqReviewDocument, baseOptions);
}
export type UpdateRfqReviewMutationHookResult = ReturnType<
  typeof useUpdateRfqReviewMutation
>;
export type UpdateRfqReviewMutationResult = Apollo.MutationResult<
  UpdateRfqReviewMutation
>;
export type UpdateRfqReviewMutationOptions = Apollo.BaseMutationOptions<
  UpdateRfqReviewMutation,
  UpdateRfqReviewMutationVariables
>;
export const FetchWithdrawnChatRoomsDocument = gql`
  query fetchWithdrawnChatRooms($input: FetchWithdrawnChatRoomsInput!) {
    fetchWithdrawnChatRooms(input: $input) {
      errorMessage
      result
      data {
        consultingChatRooms {
          ... on CAPAWithdrawnUserChatRooms {
            capaServiceType
            chatRooms {
              chatRoomId
              isOldRfq
              profileId
              projectName
              organizationName
              thumbnailId
            }
          }
          ... on CAPAWithdrawnPartnerChatRooms {
            capaServiceType
            chatRooms {
              rfqId
              organizationName
              managerName
              projectName
              chatRoomId
              thumbnailId
            }
          }
          ... on CAPAWithdrawnConnectGroupChatRooms {
            capaServiceType
            chatRooms {
              groupId
              groupName
              chatRoomId
              thumbnail
              users {
                id
                connectUserName
                isCapaUser
              }
            }
          }
        }
        consultingChatRoomsCount {
          capaService
          totalCount
        }
      }
    }
  }
`;

/**
 * __useFetchWithdrawnChatRoomsQuery__
 *
 * To run a query within a React component, call `useFetchWithdrawnChatRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchWithdrawnChatRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchWithdrawnChatRoomsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchWithdrawnChatRoomsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchWithdrawnChatRoomsQuery,
    FetchWithdrawnChatRoomsQueryVariables
  >
) {
  return Apollo.useQuery<
    FetchWithdrawnChatRoomsQuery,
    FetchWithdrawnChatRoomsQueryVariables
  >(FetchWithdrawnChatRoomsDocument, baseOptions);
}
export function useFetchWithdrawnChatRoomsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchWithdrawnChatRoomsQuery,
    FetchWithdrawnChatRoomsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FetchWithdrawnChatRoomsQuery,
    FetchWithdrawnChatRoomsQueryVariables
  >(FetchWithdrawnChatRoomsDocument, baseOptions);
}
export type FetchWithdrawnChatRoomsQueryHookResult = ReturnType<
  typeof useFetchWithdrawnChatRoomsQuery
>;
export type FetchWithdrawnChatRoomsLazyQueryHookResult = ReturnType<
  typeof useFetchWithdrawnChatRoomsLazyQuery
>;
export type FetchWithdrawnChatRoomsQueryResult = Apollo.QueryResult<
  FetchWithdrawnChatRoomsQuery,
  FetchWithdrawnChatRoomsQueryVariables
>;
export const WithdrawQuotationUserDocument = gql`
  mutation withdrawQuotationUser($input: WithdrawQuotationUserInput!) {
    withdrawQuotationUser(input: $input) {
      result
      errorMessage
    }
  }
`;
export type WithdrawQuotationUserMutationFn = Apollo.MutationFunction<
  WithdrawQuotationUserMutation,
  WithdrawQuotationUserMutationVariables
>;

/**
 * __useWithdrawQuotationUserMutation__
 *
 * To run a mutation, you first call `useWithdrawQuotationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawQuotationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawQuotationUserMutation, { data, loading, error }] = useWithdrawQuotationUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWithdrawQuotationUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WithdrawQuotationUserMutation,
    WithdrawQuotationUserMutationVariables
  >
) {
  return Apollo.useMutation<
    WithdrawQuotationUserMutation,
    WithdrawQuotationUserMutationVariables
  >(WithdrawQuotationUserDocument, baseOptions);
}
export type WithdrawQuotationUserMutationHookResult = ReturnType<
  typeof useWithdrawQuotationUserMutation
>;
export type WithdrawQuotationUserMutationResult = Apollo.MutationResult<
  WithdrawQuotationUserMutation
>;
export type WithdrawQuotationUserMutationOptions = Apollo.BaseMutationOptions<
  WithdrawQuotationUserMutation,
  WithdrawQuotationUserMutationVariables
>;
export const WithdrawQuotationPartnerDocument = gql`
  mutation withdrawQuotationPartner($input: WithdrawQuotationPartnerInput!) {
    withdrawQuotationPartner(input: $input) {
      result
      errorMessage
    }
  }
`;
export type WithdrawQuotationPartnerMutationFn = Apollo.MutationFunction<
  WithdrawQuotationPartnerMutation,
  WithdrawQuotationPartnerMutationVariables
>;

/**
 * __useWithdrawQuotationPartnerMutation__
 *
 * To run a mutation, you first call `useWithdrawQuotationPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawQuotationPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawQuotationPartnerMutation, { data, loading, error }] = useWithdrawQuotationPartnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWithdrawQuotationPartnerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WithdrawQuotationPartnerMutation,
    WithdrawQuotationPartnerMutationVariables
  >
) {
  return Apollo.useMutation<
    WithdrawQuotationPartnerMutation,
    WithdrawQuotationPartnerMutationVariables
  >(WithdrawQuotationPartnerDocument, baseOptions);
}
export type WithdrawQuotationPartnerMutationHookResult = ReturnType<
  typeof useWithdrawQuotationPartnerMutation
>;
export type WithdrawQuotationPartnerMutationResult = Apollo.MutationResult<
  WithdrawQuotationPartnerMutation
>;
export type WithdrawQuotationPartnerMutationOptions = Apollo.BaseMutationOptions<
  WithdrawQuotationPartnerMutation,
  WithdrawQuotationPartnerMutationVariables
>;
